import React$1, { useState, useRef, useEffect, useCallback, Fragment as Fragment$1, useMemo } from 'react';
import styled, { withTheme, css } from 'styled-components';
import emojiRegex from 'emoji-regex';
import { Colors, MEDIA } from '@brg/ui';
import { QRCodeSVG } from 'qrcode.react';
import { ErrorBoundary } from 'react-error-boundary';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _taggedTemplateLiteralLoose(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
}

var toUpperCaseString = function toUpperCaseString(_ref) {
  var str = _ref.str,
    sliceId = _ref.sliceId;
  return sliceId ? (str || '').substr(0, sliceId).toUpperCase() : (str || '').toUpperCase();
};

var calcFontSize = function calcFontSize(_ref) {
  var parentWidth = _ref.parentWidth,
    elementWidth = _ref.elementWidth,
    fontSize = _ref.fontSize,
    fontSizeMax = _ref.fontSizeMax,
    fontSizeMin = _ref.fontSizeMin;
  var k = elementWidth / fontSize;
  var newFontSize = parentWidth / k || 0;
  if (fontSizeMax < newFontSize) {
    return fontSizeMax;
  }
  if (fontSizeMin > newFontSize) {
    return fontSizeMin;
  }
  return newFontSize;
};

var AdaptiveText = function AdaptiveText(_ref) {
  var _elementRef$current;
  var text = _ref.text,
    style = _ref.style,
    _ref$fontSizeMax = _ref.fontSizeMax,
    fontSizeMax = _ref$fontSizeMax === void 0 ? 100 : _ref$fontSizeMax,
    _ref$fontSizeMin = _ref.fontSizeMin,
    fontSizeMin = _ref$fontSizeMin === void 0 ? 14 : _ref$fontSizeMin,
    setWidthsAndFontSize = _ref.setWidthsAndFontSize;
  var _useState = useState(fontSizeMax),
    fontSize = _useState[0],
    setFontSize = _useState[1];
  var elementRef = useRef(null);
  useEffect(function () {
    var onPaint = function onPaint() {
      if (elementRef.current) {
        var elementRect = elementRef.current;
        var parentRect = elementRef.current.parentElement;
        var parentWidth = parentRect.clientWidth;
        var elementWidth = elementRect.clientWidth;
        var newFontSize = calcFontSize({
          parentWidth: parentWidth,
          elementWidth: elementWidth,
          fontSize: fontSize,
          fontSizeMax: fontSizeMax,
          fontSizeMin: fontSizeMin,
          setWidthsAndFontSize: setWidthsAndFontSize
        });
        setFontSize(newFontSize);
        setWidthsAndFontSize === null || setWidthsAndFontSize === void 0 ? void 0 : setWidthsAndFontSize({
          parentWidth: parentWidth,
          elementWidth: elementWidth,
          newFontSize: newFontSize
        });
      }
    };
    var id = requestAnimationFrame(onPaint);
    return function () {
      return cancelAnimationFrame(id);
    };
  }, [text, (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.clientWidth, setWidthsAndFontSize]);
  if (typeof text !== 'string') {
    console.warn("AdaptiveText: Prop 'text' is required");
    return null;
  }
  return /*#__PURE__*/React$1.createElement("span", {
    style: _extends({
      fontSize: fontSize,
      textWrap: 'nowrap'
    }, style),
    ref: elementRef
  }, text);
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 148.1mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 148)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 30px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  height: 6.8%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: 400;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 23.8%;\n  width: 72%;\n  padding-bottom: 33px;\n"])));
var TextFirst = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.3px;\n    margin-right: -2.3px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 27px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -18px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -18px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  width: 100%;\n  height: 47px;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  margin: 2px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 1px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -1;
});
var TextThird = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 4.2px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.2px;\n"])));
var WarholCardA5L = function WarholCardA5L(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var _useState = useState(43),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock, null, /*#__PURE__*/React$1.createElement(TextUrl, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock, null, /*#__PURE__*/React$1.createElement(ImageInner, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock, null, /*#__PURE__*/React$1.createElement(TextFirst, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird, null, customSubtitle || url))));
};

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1;
var Wrapper$1 = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.wrapperWidth;
}, function (props) {
  return props.wrapperHeight;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.wrapperWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.wrapperHeight;
}, function (props) {
  return props.wrapperPadding;
});
var MainBlock$1 = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$1 = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    font-style: normal;\n    font-weight: ", ";\n    padding-top: ", "px;\n  }\n"])), function (props) {
  return props.urlHeight;
}, function (props) {
  return props.urlFontSize;
}, function (props) {
  return props.urlLetterSpacing;
}, function (props) {
  return props.urlFontWeight;
}, function (props) {
  return props.urlPaddingTop;
});
var ImageBlock$1 = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$1 = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$1 = styled.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 90%;\n  padding-bottom: ", "px;\n"])), function (props) {
  return props.textBlockPaddingBottom;
});
var TextFirst$1 = styled.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: ", "px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: ", "px;\n    margin-right: -", "px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (props) {
  return props.numberFontSize;
}, function (props) {
  return props.numberLetterSpacing;
}, function (props) {
  return props.numberLetterSpacing;
}, function (props) {
  return props.dashWidth;
}, function (props) {
  return props.dashPosition;
}, function (props) {
  return props.dashPosition;
});
var TextSecond$1 = styled.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteralLoose(["\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  width: 100%;\n  height: ", "px;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  margin-bottom: 5px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  margin: ", ";\n  letter-spacing: ", "px;\n  margin-right: ", "px;\n"])), function (props) {
  return props.textSecondHeight;
}, function (props) {
  return props.textSecondMargin;
}, function (props) {
  return props.textSecondLetterSpacing;
}, function (props) {
  return props !== null && props !== void 0 && props.fullText ? 0 : -props.textSecondLetterSpacing;
});
var TextThird$1 = styled.div(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: ", "px;\n  font-style: normal;\n  font-weight: 400;\n"])), function (props) {
  return props.textThirdFontSize;
});
var WarholStylePortraitTemplate = function WarholStylePortraitTemplate(_ref) {
  var image = _ref.image,
    url = _ref.url,
    customSubtitle = _ref.customSubtitle,
    name = _ref.name,
    number = _ref.number,
    dw = _ref.dw,
    dh = _ref.dh,
    wrapperWidth = _ref.wrapperWidth,
    wrapperHeight = _ref.wrapperHeight,
    wrapperPadding = _ref.wrapperPadding,
    urlHeight = _ref.urlHeight,
    urlFontSize = _ref.urlFontSize,
    urlLetterSpacing = _ref.urlLetterSpacing,
    urlFontWeight = _ref.urlFontWeight,
    urlPaddingTop = _ref.urlPaddingTop,
    textBlockHeight = _ref.textBlockHeight,
    textBlockPaddingBottom = _ref.textBlockPaddingBottom,
    numberFontSize = _ref.numberFontSize,
    numberLetterSpacing = _ref.numberLetterSpacing,
    dashWidth = _ref.dashWidth,
    dashPosition = _ref.dashPosition,
    textSecondHeight = _ref.textSecondHeight,
    textSecondMargin = _ref.textSecondMargin,
    textSecondLetterSpacing = _ref.textSecondLetterSpacing,
    textThirdFontSize = _ref.textThirdFontSize,
    fontSizeMax = _ref.fontSizeMax;
  var initName = toUpperCaseString({
    str: name
  });
  return /*#__PURE__*/React$1.createElement(Wrapper$1, {
    dw: dw,
    dh: dh,
    wrapperWidth: wrapperWidth,
    wrapperHeight: wrapperHeight,
    wrapperPadding: wrapperPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$1, null, /*#__PURE__*/React$1.createElement(TextUrl$1, {
    urlHeight: urlHeight,
    urlFontSize: urlFontSize,
    urlLetterSpacing: urlLetterSpacing,
    urlFontWeight: urlFontWeight,
    urlPaddingTop: urlPaddingTop
  }, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$1, null, /*#__PURE__*/React$1.createElement(ImageInner$1, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$1, {
    textBlockHeight: textBlockHeight,
    textBlockPaddingBottom: textBlockPaddingBottom
  }, /*#__PURE__*/React$1.createElement(TextFirst$1, {
    numberFontSize: numberFontSize,
    numberLetterSpacing: numberLetterSpacing,
    dashWidth: dashWidth,
    dashPosition: dashPosition
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$1, {
    textSecondHeight: textSecondHeight,
    textSecondLetterSpacing: textSecondLetterSpacing,
    textSecondMargin: textSecondMargin
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontSizeMax,
    style: {
      lineHeight: 'normal'
    }
  })), /*#__PURE__*/React$1.createElement(TextThird$1, {
    textThirdFontSize: textThirdFontSize
  }, customSubtitle || url))));
};

var WarholCardA5 = function WarholCardA5(props) {
  return /*#__PURE__*/React$1.createElement(WarholStylePortraitTemplate, _extends({}, props, {
    wrapperWidth: 148,
    wrapperHeight: 210,
    wrapperPadding: 28,
    urlHeight: 5.8,
    urlFontSize: 5.8,
    urlLetterSpacing: 0.2,
    urlFontWeight: "bold",
    textBlockHeight: 17.6,
    textBlockPaddingBottom: 25,
    numberFontSize: 12,
    numberLetterSpacing: 3,
    dashWidth: 32,
    dashPosition: 22,
    textSecondHeight: 59,
    textSecondLetterSpacing: 2.2,
    textThirdFontSize: 5.5,
    fontSizeMax: 54.5
  }));
};

var _templateObject$2, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$2;
var Wrapper$2 = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 40.4px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$2 = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$2 = styled.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 5px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$2 = styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$2 = styled.div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$2 = styled.div(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 23.9%;\n  width: 72%;\n  padding-bottom: 49px;\n"])));
var TextFirst$2 = styled.div(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 3.4px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 38px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -25px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -25px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$2 = styled.div(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 60px;\n  text-align: center;\n  margin: 4.5px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2;
});
var TextThird$2 = styled.div(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 6px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.2px;\n"])));
var WarholCardA4L = function WarholCardA4L(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var _useState = useState(60),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$2, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$2, null, /*#__PURE__*/React$1.createElement(TextUrl$2, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$2, null, /*#__PURE__*/React$1.createElement(ImageInner$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$2, null, /*#__PURE__*/React$1.createElement(TextFirst$2, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$2, {
    fs: fontS,
    id: "text-second",
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$2, null, customSubtitle || url))));
};

var WarholCardA4 = function WarholCardA4(props) {
  return /*#__PURE__*/React$1.createElement(WarholStylePortraitTemplate, _extends({}, props, {
    wrapperWidth: 210,
    wrapperHeight: 297,
    wrapperPadding: 40.4,
    urlHeight: 5.905,
    urlFontSize: 5.4,
    urlLetterSpacing: 0.1,
    urlFontWeight: "400",
    textBlockHeight: 17.6,
    textBlockPaddingBottom: 34,
    numberFontSize: 18,
    numberLetterSpacing: 3.4,
    dashWidth: 46,
    dashPosition: 32,
    textSecondHeight: 80,
    textSecondLetterSpacing: 2,
    textThirdFontSize: 8,
    fontSizeMax: 78.5,
    urlPaddingTop: 5
  }));
};

var _templateObject$3, _templateObject2$3, _templateObject3$3, _templateObject4$3, _templateObject5$3, _templateObject6$3, _templateObject7$3, _templateObject8$3, _templateObject9$3;
var Wrapper$3 = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 297mm;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 59px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$3 = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$3 = styled.div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$3 = styled.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$3 = styled.div(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$3 = styled.div(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 70px;\n"])));
var TextFirst$3 = styled.div(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 4.2px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 53px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -36px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -36px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$3 = styled.div(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 85px;\n  text-align: center;\n  margin: 8px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2.2px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2.2;
});
var TextThird$3 = styled.div(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 8.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.3px;\n"])));
var WarholCardA3L = function WarholCardA3L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(85),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$3, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$3, null, /*#__PURE__*/React$1.createElement(TextUrl$3, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$3, null, /*#__PURE__*/React$1.createElement(ImageInner$3, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$3, null, /*#__PURE__*/React$1.createElement(TextFirst$3, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$3, {
    fs: fontS,
    id: "text-second",
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$3, null, customSubtitle || url))));
};

var WarholCardA3 = function WarholCardA3(props) {
  return /*#__PURE__*/React$1.createElement(WarholStylePortraitTemplate, _extends({}, props, {
    wrapperWidth: 297,
    wrapperHeight: 420,
    wrapperPadding: 57,
    urlHeight: 5.9,
    urlFontSize: 6.7,
    urlLetterSpacing: 0.3,
    urlFontWeight: "bold",
    textBlockPaddingBottom: 50,
    numberFontSize: 26,
    numberLetterSpacing: 3.6,
    dashWidth: 60,
    dashPosition: 35,
    textSecondHeight: 100,
    textSecondLetterSpacing: 3,
    textThirdFontSize: 10.5,
    fontSizeMax: 110
  }));
};

var _templateObject$4, _templateObject2$4, _templateObject3$4, _templateObject4$4, _templateObject5$4, _templateObject6$4, _templateObject7$4, _templateObject8$4, _templateObject9$4;
var Wrapper$4 = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 420mm;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 82px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$4 = styled.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$4 = styled.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.1px;\n    margin-top: 4px;\n  }\n"])));
var ImageBlock$4 = styled.div(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$4 = styled.div(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$4 = styled.div(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24%;\n  width: 72%;\n  padding-bottom: 96.5px;\n"])));
var TextFirst$4 = styled.div(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 30px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 5.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 75px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -48px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -48px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$4 = styled.div(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 105px;\n  text-align: center;\n  margin: 18px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2.5px;\n"])));
var TextThird$4 = styled.div(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.4px;\n"])));
var WarholCardA2L = function WarholCardA2L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(121),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$4, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$4, null, /*#__PURE__*/React$1.createElement(TextUrl$4, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$4, null, /*#__PURE__*/React$1.createElement(ImageInner$4, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$4, null, /*#__PURE__*/React$1.createElement(TextFirst$4, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$4, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$4, null, customSubtitle || url))));
};

var WarholCardA2 = function WarholCardA2(props) {
  return /*#__PURE__*/React$1.createElement(WarholStylePortraitTemplate, _extends({}, props, {
    wrapperWidth: 420,
    wrapperHeight: 594,
    wrapperPadding: 80,
    urlHeight: 5.9,
    urlFontSize: 12,
    urlLetterSpacing: 0.1,
    urlFontWeight: "bold",
    textBlockPaddingBottom: 71,
    numberFontSize: 35,
    numberLetterSpacing: 7.5,
    dashWidth: 93,
    dashPosition: 60,
    textSecondHeight: 160,
    textSecondLetterSpacing: 4.5,
    textThirdFontSize: 15.5,
    fontSizeMax: 155
  }));
};

var _templateObject$5, _templateObject2$5, _templateObject3$5, _templateObject4$5, _templateObject5$5, _templateObject6$5, _templateObject7$5, _templateObject8$5, _templateObject9$5;
var Wrapper$5 = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 594mm;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 118px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$5 = styled.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$5 = styled.div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.6px;\n    margin-right: 2px;\n  }\n"])));
var ImageBlock$5 = styled.div(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$5 = styled.div(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$5 = styled.div(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24%;\n  width: 72%;\n  padding-bottom: 137px;\n"])));
var TextFirst$5 = styled.div(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 8.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 108px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -72px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -72px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$5 = styled.div(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 150px;\n  text-align: center;\n  margin: 24px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 4.5px;\n"])));
var TextThird$5 = styled.div(_templateObject9$5 || (_templateObject9$5 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n"])));
var WarholCardA1L = function WarholCardA1L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(170),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$5, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$5, null, /*#__PURE__*/React$1.createElement(TextUrl$5, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$5, null, /*#__PURE__*/React$1.createElement(ImageInner$5, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$5, null, /*#__PURE__*/React$1.createElement(TextFirst$5, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$5, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$5, null, customSubtitle || url))));
};

var WarholCardA1 = function WarholCardA1(props) {
  return /*#__PURE__*/React$1.createElement(WarholStylePortraitTemplate, _extends({}, props, {
    wrapperWidth: 594,
    wrapperHeight: 841,
    wrapperPadding: 115,
    urlHeight: 5.9,
    urlFontSize: 16,
    urlLetterSpacing: 0.6,
    urlFontWeight: "bold",
    textBlockPaddingBottom: 100,
    numberFontSize: 50,
    numberLetterSpacing: 10.5,
    dashWidth: 132,
    dashPosition: 84,
    textSecondHeight: 200,
    textSecondLetterSpacing: 5.5,
    textThirdFontSize: 22,
    fontSizeMax: 220
  }));
};

var _templateObject$6, _templateObject2$6, _templateObject3$6, _templateObject4$6, _templateObject5$6, _templateObject6$6, _templateObject7$6, _templateObject8$6, _templateObject9$6;
var Wrapper$6 = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n  width: 1189mm;\n  height: 841mm;\n  transform: scale(\n    calc(", " / 1189),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 163px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$6 = styled.div(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$6 = styled.div(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteralLoose(["\n  height: 6.91%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 1px;\n  }\n"])));
var ImageBlock$6 = styled.div(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$6 = styled.div(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$6 = styled.div(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24%;\n  width: 72%;\n  padding-bottom: 195px;\n"])));
var TextFirst$6 = styled.div(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 60px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 10px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 150px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -100px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -100px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$6 = styled.div(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 240px;\n  text-align: center;\n  margin: 24px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 6px;\n"])));
var TextThird$6 = styled.div(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.7px;\n"])));
var WarholCardA0L = function WarholCardA0L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(240),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  return /*#__PURE__*/React$1.createElement(Wrapper$6, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$6, null, /*#__PURE__*/React$1.createElement(TextUrl$6, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$6, null, /*#__PURE__*/React$1.createElement(ImageInner$6, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$6, null, /*#__PURE__*/React$1.createElement(TextFirst$6, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$6, {
    fs: fontS
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$6, null, customSubtitle || url))));
};

var WarholCardA0 = function WarholCardA0(props) {
  return /*#__PURE__*/React$1.createElement(WarholStylePortraitTemplate, _extends({}, props, {
    wrapperWidth: 841,
    wrapperHeight: 1189,
    wrapperPadding: 168,
    urlHeight: 5.9,
    urlFontSize: 24,
    urlFontWeight: "bold",
    textBlockPaddingBottom: 138,
    numberFontSize: 70,
    numberLetterSpacing: 15,
    dashWidth: 184,
    dashPosition: 124,
    textSecondHeight: 300,
    textSecondLetterSpacing: 9,
    textThirdFontSize: 30.5,
    fontSizeMax: 310
  }));
};

var _templateObject$7, _templateObject2$7, _templateObject3$7, _templateObject4$7, _templateObject5$7, _templateObject6$7, _templateObject7$7, _templateObject8$7, _templateObject9$7;
var Wrapper$7 = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 148.1mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 148)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 30px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$7 = styled.div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$7 = styled.div(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteralLoose(["\n  height: 7%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: 400;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$7 = styled.div(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$7 = styled.div(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$7 = styled.div(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 23.6%;\n  width: 72%;\n  padding-bottom: 23px;\n"])));
var TextFirst$7 = styled.div(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.3px;\n    margin-right: -2.3px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 30px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -18px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -18px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$7 = styled.div(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  width: 100%;\n  height: 40px;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  margin: 7px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 1px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -1;
});
var TextThird$7 = styled.div(_templateObject9$7 || (_templateObject9$7 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 5.5px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard2A5L = function WarholCard2A5L(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var _useState = useState(32.9),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$7, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$7, null, /*#__PURE__*/React$1.createElement(TextUrl$7, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$7, null, /*#__PURE__*/React$1.createElement(ImageInner$7, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$7, null, /*#__PURE__*/React$1.createElement(TextFirst$7, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$7, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$7, null, customSubtitle || url))));
};

var _templateObject$8, _templateObject2$8, _templateObject3$8, _templateObject4$8, _templateObject5$8, _templateObject6$8, _templateObject7$8, _templateObject8$8, _templateObject9$8;
var Wrapper$8 = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n  width: 148.1mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 148),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 28.5px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$8 = styled.div(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$8 = styled.div(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 4px;\n    margin: 4px 2px 0 0;\n  }\n"])));
var ImageBlock$8 = styled.div(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$8 = styled.div(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$8 = styled.div(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 88%;\n  padding-bottom: 26px;\n"])));
var TextFirst$8 = styled.div(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.3px;\n    margin-right: -2.3px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 30px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -18px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -18px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$8 = styled.div(_templateObject8$8 || (_templateObject8$8 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  width: 100%;\n  height: 40px;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  margin: 7px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -1.5;
});
var TextThird$8 = styled.div(_templateObject9$8 || (_templateObject9$8 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 5.5px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard2A5 = function WarholCard2A5(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var _useState = useState(32),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  return /*#__PURE__*/React$1.createElement(Wrapper$8, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$8, null, /*#__PURE__*/React$1.createElement(TextUrl$8, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$8, null, /*#__PURE__*/React$1.createElement(ImageInner$8, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$8, null, /*#__PURE__*/React$1.createElement(TextFirst$8, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$8, {
    fs: fontS,
    id: "text-second"
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$8, null, customSubtitle || url))));
};

var _templateObject$9, _templateObject2$9, _templateObject3$9, _templateObject4$9, _templateObject5$9, _templateObject6$9, _templateObject7$9, _templateObject8$9, _templateObject9$9;
var Wrapper$9 = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 41px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$9 = styled.div(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$9 = styled.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 5px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$9 = styled.div(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$9 = styled.div(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$9 = styled.div(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 23.9%;\n  width: 72%;\n  padding-bottom: 34px;\n"])));
var TextFirst$9 = styled.div(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 17px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 3.4px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 43px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -25px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -25px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$9 = styled.div(_templateObject8$9 || (_templateObject8$9 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 50px;\n  text-align: center;\n  margin: 14.5px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2;
});
var TextThird$9 = styled.div(_templateObject9$9 || (_templateObject9$9 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard2A4L = function WarholCard2A4L(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var _useState = useState(45),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$9, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$9, null, /*#__PURE__*/React$1.createElement(TextUrl$9, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$9, null, /*#__PURE__*/React$1.createElement(ImageInner$9, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$9, null, /*#__PURE__*/React$1.createElement(TextFirst$9, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$9, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$9, null, customSubtitle || url))));
};

var _templateObject$a, _templateObject2$a, _templateObject3$a, _templateObject4$a, _templateObject5$a, _templateObject6$a, _templateObject7$a, _templateObject8$a, _templateObject9$a;
var Wrapper$a = styled.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 40.4px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$a = styled.div(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$a = styled.div(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteralLoose(["\n  height: 5.905%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.7px;\n    line-height: 4px;\n    margin: 5px 3px 0 0;\n  }\n"])));
var ImageBlock$a = styled.div(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$a = styled.div(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$a = styled.div(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 87.9%;\n  padding-bottom: 34.5px;\n"])));
var TextFirst$a = styled.div(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.79px;\n    margin-right: -2.79px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 42px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -25px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -25px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$a = styled.div(_templateObject8$a || (_templateObject8$a = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 50px;\n  text-align: center;\n  margin: 13.7px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2;
});
var TextThird$a = styled.div(_templateObject9$a || (_templateObject9$a = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard2A4 = function WarholCard2A4(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var _useState = useState(45),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$a, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$a, null, /*#__PURE__*/React$1.createElement(TextUrl$a, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$a, null, /*#__PURE__*/React$1.createElement(ImageInner$a, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$a, null, /*#__PURE__*/React$1.createElement(TextFirst$a, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$a, {
    fs: fontS,
    id: "text-second",
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$a, null, customSubtitle || url))));
};

var _templateObject$b, _templateObject2$b, _templateObject3$b, _templateObject4$b, _templateObject5$b, _templateObject6$b, _templateObject7$b, _templateObject8$b, _templateObject9$b;
var Wrapper$b = styled.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 297mm;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 59px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$b = styled.div(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$b = styled.div(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 5px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$b = styled.div(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$b = styled.div(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$b = styled.div(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 50px;\n"])));
var TextFirst$b = styled.div(_templateObject7$b || (_templateObject7$b = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 4.7px;\n    margin-right: -4.7px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 60px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -35px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -35px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$b = styled.div(_templateObject8$b || (_templateObject8$b = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 75px;\n  text-align: center;\n  margin: 20px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 1.8px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -1.8;
});
var TextThird$b = styled.div(_templateObject9$b || (_templateObject9$b = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.4px;\n"])));
var WarholCard2A3L = function WarholCard2A3L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(64.7),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$b, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$b, null, /*#__PURE__*/React$1.createElement(TextUrl$b, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$b, null, /*#__PURE__*/React$1.createElement(ImageInner$b, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$b, null, /*#__PURE__*/React$1.createElement(TextFirst$b, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$b, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$b, null, customSubtitle || url))));
};

var _templateObject$c, _templateObject2$c, _templateObject3$c, _templateObject4$c, _templateObject5$c, _templateObject6$c, _templateObject7$c, _templateObject8$c, _templateObject9$c;
var Wrapper$c = styled.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 420mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 57px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$c = styled.div(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$c = styled.div(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 6.7px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 8px;\n  }\n"])));
var ImageBlock$c = styled.div(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$c = styled.div(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$c = styled.div(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 88%;\n  padding-bottom: 51px;\n"])));
var TextFirst$c = styled.div(_templateObject7$c || (_templateObject7$c = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 26px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 3.6px;\n    margin-right: -3.6px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 60px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -35px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -35px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$c = styled.div(_templateObject8$c || (_templateObject8$c = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 75px;\n  text-align: center;\n  margin: 18px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2;
});
var TextThird$c = styled.div(_templateObject9$c || (_templateObject9$c = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 10.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.3px;\n"])));
var WarholCard2A3 = function WarholCard2A3(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    customSubtitle = props.customSubtitle,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(64),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$c, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$c, null, /*#__PURE__*/React$1.createElement(TextUrl$c, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$c, null, /*#__PURE__*/React$1.createElement(ImageInner$c, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$c, null, /*#__PURE__*/React$1.createElement(TextFirst$c, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$c, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$c, null, customSubtitle || url))));
};

var _templateObject$d, _templateObject2$d, _templateObject3$d, _templateObject4$d, _templateObject5$d, _templateObject6$d, _templateObject7$d, _templateObject8$d, _templateObject9$d;
var Wrapper$d = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 420mm;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 83px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$d = styled.div(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$d = styled.div(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.1px;\n    margin-top: 4px;\n  }\n"])));
var ImageBlock$d = styled.div(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$d = styled.div(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$d = styled.div(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 72.5px;\n"])));
var TextFirst$d = styled.div(_templateObject7$d || (_templateObject7$d = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 34px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 6.5px;\n    margin-right: -6.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 85px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -53px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -53px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$d = styled.div(_templateObject8$d || (_templateObject8$d = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 105px;\n  text-align: center;\n  margin: 23px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2.5px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2.5;
});
var TextThird$d = styled.div(_templateObject9$d || (_templateObject9$d = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.4px;\n"])));
var WarholCard2A2L = function WarholCard2A2L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(91),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$d, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$d, null, /*#__PURE__*/React$1.createElement(TextUrl$d, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$d, null, /*#__PURE__*/React$1.createElement(ImageInner$d, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$d, null, /*#__PURE__*/React$1.createElement(TextFirst$d, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$d, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$d, null, customSubtitle || url))));
};

var _templateObject$e, _templateObject2$e, _templateObject3$e, _templateObject4$e, _templateObject5$e, _templateObject6$e, _templateObject7$e, _templateObject8$e, _templateObject9$e;
var Wrapper$e = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 594mm;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 83px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$e = styled.div(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$e = styled.div(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.1px;\n    margin-top: 10px;\n  }\n"])));
var ImageBlock$e = styled.div(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$e = styled.div(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$e = styled.div(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.7%;\n  width: 88%;\n  padding-bottom: 71px;\n"])));
var TextFirst$e = styled.div(_templateObject7$e || (_templateObject7$e = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 34px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 6.5px;\n    margin-right: -6.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 86px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -53px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -53px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$e = styled.div(_templateObject8$e || (_templateObject8$e = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 105px;\n  text-align: center;\n  margin: 23px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2.5px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2.5;
});
var TextThird$e = styled.div(_templateObject9$e || (_templateObject9$e = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 15.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n"])));
var WarholCard2A2 = function WarholCard2A2(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(91.5),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$e, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$e, null, /*#__PURE__*/React$1.createElement(TextUrl$e, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$e, null, /*#__PURE__*/React$1.createElement(ImageInner$e, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$e, null, /*#__PURE__*/React$1.createElement(TextFirst$e, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$e, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$e, null, customSubtitle || url))));
};

var _templateObject$f, _templateObject2$f, _templateObject3$f, _templateObject4$f, _templateObject5$f, _templateObject6$f, _templateObject7$f, _templateObject8$f, _templateObject9$f;
var Wrapper$f = styled.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 594mm;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 118px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$f = styled.div(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$f = styled.div(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.6px;\n    margin-right: 2px;\n  }\n"])));
var ImageBlock$f = styled.div(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$f = styled.div(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$f = styled.div(_templateObject6$f || (_templateObject6$f = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 100px;\n"])));
var TextFirst$f = styled.div(_templateObject7$f || (_templateObject7$f = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 50px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 8.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 123px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -75px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -75px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$f = styled.div(_templateObject8$f || (_templateObject8$f = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 150px;\n  text-align: center;\n  margin: 34px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 4.5px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -4.5;
});
var TextThird$f = styled.div(_templateObject9$f || (_templateObject9$f = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n"])));
var WarholCard2A1L = function WarholCard2A1L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(129),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$f, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$f, null, /*#__PURE__*/React$1.createElement(TextUrl$f, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$f, null, /*#__PURE__*/React$1.createElement(ImageInner$f, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$f, null, /*#__PURE__*/React$1.createElement(TextFirst$f, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$f, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$f, null, customSubtitle || url))));
};

var _templateObject$g, _templateObject2$g, _templateObject3$g, _templateObject4$g, _templateObject5$g, _templateObject6$g, _templateObject7$g, _templateObject8$g, _templateObject9$g;
var Wrapper$g = styled.div(_templateObject$g || (_templateObject$g = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 841mm;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 83px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$g = styled.div(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$g = styled.div(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.6px;\n    margin-top: 10px;\n  }\n"])));
var ImageBlock$g = styled.div(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$g = styled.div(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$g = styled.div(_templateObject6$g || (_templateObject6$g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 88%;\n  padding-bottom: 104px;\n"])));
var TextFirst$g = styled.div(_templateObject7$g || (_templateObject7$g = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 50px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 8.5px;\n    margin-right: -8.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 123px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -75px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -75px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$g = styled.div(_templateObject8$g || (_templateObject8$g = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 150px;\n  text-align: center;\n  margin: 35px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2.5px;\n"])));
var TextThird$g = styled.div(_templateObject9$g || (_templateObject9$g = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n"])));
var WarholCard2A1 = function WarholCard2A1(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(129),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$g, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$g, null, /*#__PURE__*/React$1.createElement(TextUrl$g, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$g, null, /*#__PURE__*/React$1.createElement(ImageInner$g, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$g, null, /*#__PURE__*/React$1.createElement(TextFirst$g, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$g, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$g, null, customSubtitle || url))));
};

var _templateObject$h, _templateObject2$h, _templateObject3$h, _templateObject4$h, _templateObject5$h, _templateObject6$h, _templateObject7$h, _templateObject8$h, _templateObject9$h;
var Wrapper$h = styled.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteralLoose(["\n  width: 1189mm;\n  height: 841mm;\n  transform: scale(\n    calc(", " / 1189),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 163px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$h = styled.div(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$h = styled.div(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteralLoose(["\n  height: 6.91%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 1px;\n  }\n"])));
var ImageBlock$h = styled.div(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$h = styled.div(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$h = styled.div(_templateObject6$h || (_templateObject6$h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 146px;\n"])));
var TextFirst$h = styled.div(_templateObject7$h || (_templateObject7$h = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 70px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 12.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 172px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -100px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -100px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$h = styled.div(_templateObject8$h || (_templateObject8$h = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 210px;\n  text-align: center;\n  margin: 48px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 6.5px;\n"])));
var TextThird$h = styled.div(_templateObject9$h || (_templateObject9$h = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 30.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 1px;\n"])));
var WarholCard2A0L = function WarholCard2A0L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(181),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$h, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$h, null, /*#__PURE__*/React$1.createElement(TextUrl$h, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$h, null, /*#__PURE__*/React$1.createElement(ImageInner$h, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$h, null, /*#__PURE__*/React$1.createElement(TextFirst$h, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$h, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$h, null, customSubtitle || url))));
};

var _templateObject$i, _templateObject2$i, _templateObject3$i, _templateObject4$i, _templateObject5$i, _templateObject6$i, _templateObject7$i, _templateObject8$i, _templateObject9$i;
var Wrapper$i = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 1189mm;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 1189)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 168px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$i = styled.div(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$i = styled.div(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: bold;\n    margin-top: 20px;\n  }\n"])));
var ImageBlock$i = styled.div(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$i = styled.div(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$i = styled.div(_templateObject6$i || (_templateObject6$i = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.7%;\n  width: 88%;\n  padding-bottom: 138px;\n"])));
var TextFirst$i = styled.div(_templateObject7$i || (_templateObject7$i = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 70px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 12.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 172px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -100px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -100px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$i = styled.div(_templateObject8$i || (_templateObject8$i = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 210px;\n  text-align: center;\n  margin: 48px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 6.5px;\n"])));
var TextThird$i = styled.div(_templateObject9$i || (_templateObject9$i = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 30.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.4px;\n"])));
var WarholCard2A0 = function WarholCard2A0(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(180),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$i, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$i, null, /*#__PURE__*/React$1.createElement(TextUrl$i, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$i, null, /*#__PURE__*/React$1.createElement(ImageInner$i, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$i, null, /*#__PURE__*/React$1.createElement(TextFirst$i, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$i, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$i, null, customSubtitle || url))));
};

var debounce = function debounce(func, delay) {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return func.apply(void 0, args);
    }, delay);
  };
};
var TextWithDynamicLetterSpacing = function TextWithDynamicLetterSpacing(_ref) {
  var text = _ref.text,
    defaultLetterSpacing = _ref.defaultLetterSpacing,
    fontSize = _ref.fontSize;
  var textBlockRef = useRef(null);
  var _useState = useState(defaultLetterSpacing),
    letterSpacing = _useState[0],
    setLetterSpacing = _useState[1];
  var _useState2 = useState(fontSize),
    newFontSize = _useState2[0],
    setNewFontSize = _useState2[1];
  var lastLetterSpacing = useRef(defaultLetterSpacing);
  var lastFontSize = useRef(fontSize);
  var updateLetterSpacing = useCallback(function () {
    if (!textBlockRef.current) return;
    var parentWidth = textBlockRef.current.parentElement.clientWidth;
    var elementWidth = textBlockRef.current.clientWidth;
    if (elementWidth === parentWidth) return;
    var newLetterSpacing = lastLetterSpacing.current - (elementWidth + fontSize - parentWidth - defaultLetterSpacing) / text.length;
    if (newLetterSpacing <= 0) {
      var calculatedFontSize = calcFontSize({
        parentWidth: parentWidth,
        elementWidth: elementWidth,
        fontSize: lastFontSize.current,
        fontSizeMax: fontSize,
        fontSizeMin: 10
      });
      if (calculatedFontSize !== lastFontSize.current) {
        lastFontSize.current = calculatedFontSize;
        setNewFontSize(calculatedFontSize);
      }
      return;
    }
    if (newLetterSpacing !== lastLetterSpacing.current) {
      lastLetterSpacing.current = Math.max(0, Math.min(defaultLetterSpacing, newLetterSpacing));
      setLetterSpacing(lastLetterSpacing.current);
    }
  }, [fontSize, defaultLetterSpacing, text.length]);
  useEffect(function () {
    if (!textBlockRef.current) return;
    var debouncedUpdate = debounce(updateLetterSpacing, 50);
    debouncedUpdate();
    var id = requestAnimationFrame(updateLetterSpacing);
    return function () {
      return cancelAnimationFrame(id);
    };
  }, [updateLetterSpacing, text]);
  var isFullText = defaultLetterSpacing > letterSpacing;
  var textStyle = {
    letterSpacing: letterSpacing,
    fontSize: newFontSize,
    textIndent: isFullText ? 0 : letterSpacing,
    whiteSpace: 'nowrap'
  };
  return /*#__PURE__*/React$1.createElement("span", {
    ref: textBlockRef,
    style: textStyle
  }, text);
};

var useContainerWidth = function useContainerWidth(props) {
  var mainTextRef = props.mainTextRef,
    name = props.name,
    useTextSecont = props.useTextSecont,
    flag = props.flag;
  var _useState = useState(0),
    w = _useState[0],
    setW = _useState[1];
  var width = mainTextRef && mainTextRef.current && mainTextRef.current.offsetWidth;
  useEffect(function () {
    if (useTextSecont) {
      return;
    }
    if (mainTextRef.current && name && width) {
      setW(width);
    }
  }, [name, width]);
  useEffect(function () {
    if (!useTextSecont) {
      return;
    }
    var Width = document.getElementById('text-second').offsetWidth;
    if (Width !== null && Width !== undefined && Width !== 0) {
      setW(Width);
    }
  }, [w, name, flag]);
  return {
    w: w
  };
};

var _templateObject$j, _templateObject2$j, _templateObject3$j, _templateObject4$j, _templateObject5$j, _templateObject6$j, _templateObject7$j, _templateObject8$j, _templateObject9$j;
var Wrapper$j = styled.div(_templateObject$j || (_templateObject$j = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 148.1mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 148)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 30px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$j = styled.div(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$j = styled.div(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: 400;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$j = styled.div(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$j = styled.div(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$j = styled.div(_templateObject6$j || (_templateObject6$j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 18.45%;\n  width: 72%;\n  margin-bottom: 28px;\n"])));
var TextFirst$j = styled.div(_templateObject7$j || (_templateObject7$j = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 7px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 1.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 18px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -10px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -10px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$j = styled.div(_templateObject8$j || (_templateObject8$j = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 110%;\n  height: 16px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 16.5px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$j = styled.div(_templateObject9$j || (_templateObject9$j = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 5.5px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard3A5L = function WarholCard3A5L(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    _props$name = props.name,
    name = _props$name === void 0 ? '' : _props$name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$j, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$j, null, /*#__PURE__*/React$1.createElement(TextUrl$j, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$j, null, /*#__PURE__*/React$1.createElement(ImageInner$j, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$j, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$j, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$j, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 11.5,
    fontSize: 13
  })), /*#__PURE__*/React$1.createElement(TextThird$j, null, customSubtitle || url))));
};

var _templateObject$k, _templateObject2$k, _templateObject3$k, _templateObject4$k, _templateObject5$k, _templateObject6$k, _templateObject7$k, _templateObject8$k, _templateObject9$k;
var Wrapper$k = styled.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteralLoose(["\n  width: 148.3mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 148),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 28.5px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$k = styled.div(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$k = styled.div(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteralLoose(["\n  height: 5.85%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 4px;\n    margin: 4px 2px 0 0;\n  }\n"])));
var ImageBlock$k = styled.div(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$k = styled.div(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$k = styled.div(_templateObject6$k || (_templateObject6$k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 90%;\n  padding-bottom: 35px;\n"])));
var TextFirst$k = styled.div(_templateObject7$k || (_templateObject7$k = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 1px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 18px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -10px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -10px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$k = styled.div(_templateObject8$k || (_templateObject8$k = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 110%;\n  height: 32px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 8px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$k = styled.div(_templateObject9$k || (_templateObject9$k = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 5.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.02px;\n"])));
var WarholCard3A5 = function WarholCard3A5(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    _props$name = props.name,
    name = _props$name === void 0 ? '' : _props$name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$k, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$k, null, /*#__PURE__*/React$1.createElement(TextUrl$k, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$k, null, /*#__PURE__*/React$1.createElement(ImageInner$k, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$k, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$k, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$k, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 11.5,
    fontSize: 13
  })), /*#__PURE__*/React$1.createElement(TextThird$k, null, customSubtitle || url))));
};

var _templateObject$l, _templateObject2$l, _templateObject3$l, _templateObject4$l, _templateObject5$l, _templateObject6$l, _templateObject7$l, _templateObject8$l, _templateObject9$l;
var Wrapper$l = styled.div(_templateObject$l || (_templateObject$l = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 40.3px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$l = styled.div(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$l = styled.div(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteralLoose(["\n  height: 6.85%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 5px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$l = styled.div(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$l = styled.div(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$l = styled.div(_templateObject6$l || (_templateObject6$l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 42px;\n"])));
var TextFirst$l = styled.div(_templateObject7$l || (_templateObject7$l = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.1px;\n    text-indent: 2.1px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 25.8px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -16px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -16px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$l = styled.div(_templateObject8$l || (_templateObject8$l = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 32px;\n  text-align: center;\n  margin: 18.3px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$l = styled.div(_templateObject9$l || (_templateObject9$l = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard3A4L = function WarholCard3A4L(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var fullText = name.length > 23;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$l, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$l, null, /*#__PURE__*/React$1.createElement(TextUrl$l, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$l, null, /*#__PURE__*/React$1.createElement(ImageInner$l, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$l, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$l, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$l, {
    ref: mainTextRef,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 16.3,
    fontSize: 19
  })), /*#__PURE__*/React$1.createElement(TextThird$l, null, customSubtitle || url))));
};

var _templateObject$m, _templateObject2$m, _templateObject3$m, _templateObject4$m, _templateObject5$m, _templateObject6$m, _templateObject7$m, _templateObject8$m, _templateObject9$m;
var Wrapper$m = styled.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 40.3px;\n\n  * {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$m = styled.div(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$m = styled.div(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.7px;\n    line-height: 4px;\n    margin: 5px 3px 0 0;\n  }\n"])));
var ImageBlock$m = styled.div(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$m = styled.div(_templateObject5$m || (_templateObject5$m = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$m = styled.div(_templateObject6$m || (_templateObject6$m = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 90%;\n  padding-bottom: 48px;\n"])));
var TextFirst$m = styled.div(_templateObject7$m || (_templateObject7$m = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 9.4px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.2px;\n    margin-right: -2.2px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 25.8px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -18px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -18px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$m = styled.div(_templateObject8$m || (_templateObject8$m = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 32px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 17.8px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$m = styled.div(_templateObject9$m || (_templateObject9$m = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard3A4 = function WarholCard3A4(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    _props$name = props.name,
    name = _props$name === void 0 ? '' : _props$name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$m, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$m, null, /*#__PURE__*/React$1.createElement(TextUrl$m, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$m, null, /*#__PURE__*/React$1.createElement(ImageInner$m, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$m, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$m, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$m, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 16.3,
    fontSize: 19
  })), /*#__PURE__*/React$1.createElement(TextThird$m, null, customSubtitle || url))));
};

var _templateObject$n, _templateObject2$n, _templateObject3$n, _templateObject4$n, _templateObject5$n, _templateObject6$n, _templateObject7$n, _templateObject8$n, _templateObject9$n;
var Wrapper$n = styled.div(_templateObject$n || (_templateObject$n = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 297mm;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 59px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$n = styled.div(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$n = styled.div(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 6.7px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n  }\n"])));
var ImageBlock$n = styled.div(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$n = styled.div(_templateObject5$n || (_templateObject5$n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$n = styled.div(_templateObject6$n || (_templateObject6$n = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 61px;\n"])));
var TextFirst$n = styled.div(_templateObject7$n || (_templateObject7$n = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.6px;\n    margin-right: -2.6px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 37px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -23px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -23px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$n = styled.div(_templateObject8$n || (_templateObject8$n = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 32px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 32px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$n = styled.div(_templateObject9$n || (_templateObject9$n = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.6px;\n"])));
var WarholCard3A3L = function WarholCard3A3L(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    name = props.name,
    customSubtitle = props.customSubtitle,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$n, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$n, null, /*#__PURE__*/React$1.createElement(TextUrl$n, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$n, null, /*#__PURE__*/React$1.createElement(ImageInner$n, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$n, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$n, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$n, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 23.5,
    fontSize: 26
  })), /*#__PURE__*/React$1.createElement(TextThird$n, null, customSubtitle || url))));
};

var _templateObject$o, _templateObject2$o, _templateObject3$o, _templateObject4$o, _templateObject5$o, _templateObject6$o, _templateObject7$o, _templateObject8$o, _templateObject9$o;
var Wrapper$o = styled.div(_templateObject$o || (_templateObject$o = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 420mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 57px;\n\n  * {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$o = styled.div(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$o = styled.div(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 6.7px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 8px;\n  }\n"])));
var ImageBlock$o = styled.div(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$o = styled.div(_templateObject5$o || (_templateObject5$o = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$o = styled.div(_templateObject6$o || (_templateObject6$o = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 90%;\n  padding-bottom: 70px;\n"])));
var TextFirst$o = styled.div(_templateObject7$o || (_templateObject7$o = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.6px;\n    margin-right: -2.6px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 37px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -23px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -23px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$o = styled.div(_templateObject8$o || (_templateObject8$o = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 32px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 32px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$o = styled.div(_templateObject9$o || (_templateObject9$o = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.6px;\n"])));
var WarholCard3A3 = function WarholCard3A3(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    name = props.name,
    customSubtitle = props.customSubtitle,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$o, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$o, null, /*#__PURE__*/React$1.createElement(TextUrl$o, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$o, null, /*#__PURE__*/React$1.createElement(ImageInner$o, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$o, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$o, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$o, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 23.5,
    fontSize: 26
  })), /*#__PURE__*/React$1.createElement(TextThird$o, null, customSubtitle || url))));
};

var _templateObject$p, _templateObject2$p, _templateObject3$p, _templateObject4$p, _templateObject5$p, _templateObject6$p, _templateObject7$p, _templateObject8$p, _templateObject9$p;
var Wrapper$p = styled.div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 420mm;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 83px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$p = styled.div(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$p = styled.div(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.1px;\n  }\n"])));
var ImageBlock$p = styled.div(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$p = styled.div(_templateObject5$p || (_templateObject5$p = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$p = styled.div(_templateObject6$p || (_templateObject6$p = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 81.5px;\n"])));
var TextFirst$p = styled.div(_templateObject7$p || (_templateObject7$p = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 5.5px;\n    margin-right: -5.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 51px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -33px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -33px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$p = styled.div(_templateObject8$p || (_templateObject8$p = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 42px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 47px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$p = styled.div(_templateObject9$p || (_templateObject9$p = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 15.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n"])));
var WarholCard3A2L = function WarholCard3A2L(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    name = props.name,
    customSubtitle = props.customSubtitle,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$p, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$p, null, /*#__PURE__*/React$1.createElement(TextUrl$p, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$p, null, /*#__PURE__*/React$1.createElement(ImageInner$p, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$p, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$p, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$p, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 32.4,
    fontSize: 38
  })), /*#__PURE__*/React$1.createElement(TextThird$p, null, customSubtitle || url))));
};

var _templateObject$q, _templateObject2$q, _templateObject3$q, _templateObject4$q, _templateObject5$q, _templateObject6$q, _templateObject7$q, _templateObject8$q, _templateObject9$q;
var Wrapper$q = styled.div(_templateObject$q || (_templateObject$q = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 594mm;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 83px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$q = styled.div(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$q = styled.div(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.1px;\n  }\n"])));
var ImageBlock$q = styled.div(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$q = styled.div(_templateObject5$q || (_templateObject5$q = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$q = styled.div(_templateObject6$q || (_templateObject6$q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.7%;\n  width: 90%;\n  padding-bottom: 99px;\n"])));
var TextFirst$q = styled.div(_templateObject7$q || (_templateObject7$q = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 5.5px;\n    margin-right: -5.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 51px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -33px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -33px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$q = styled.div(_templateObject8$q || (_templateObject8$q = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 42px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 47px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$q = styled.div(_templateObject9$q || (_templateObject9$q = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 15.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n"])));
var WarholCard3A2 = function WarholCard3A2(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    name = props.name,
    customSubtitle = props.customSubtitle,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$q, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$q, null, /*#__PURE__*/React$1.createElement(TextUrl$q, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$q, null, /*#__PURE__*/React$1.createElement(ImageInner$q, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$q, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$q, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$q, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 32.4,
    fontSize: 38
  })), /*#__PURE__*/React$1.createElement(TextThird$q, null, customSubtitle || url))));
};

var _templateObject$r, _templateObject2$r, _templateObject3$r, _templateObject4$r, _templateObject5$r, _templateObject6$r, _templateObject7$r, _templateObject8$r, _templateObject9$r;
var Wrapper$r = styled.div(_templateObject$r || (_templateObject$r = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 594mm;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 118px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$r = styled.div(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$r = styled.div(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.6px;\n    margin-right: 2px;\n  }\n"])));
var ImageBlock$r = styled.div(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$r = styled.div(_templateObject5$r || (_templateObject5$r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$r = styled.div(_templateObject6$r || (_templateObject6$r = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24%;\n  width: 72%;\n  padding-bottom: 116px;\n"])));
var TextFirst$r = styled.div(_templateObject7$r || (_templateObject7$r = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 6.5px;\n    margin-right: -6.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 74px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -44px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -44px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$r = styled.div(_templateObject8$r || (_templateObject8$r = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 54px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 70px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$r = styled.div(_templateObject9$r || (_templateObject9$r = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.3px;\n"])));
var WarholCard3A1L = function WarholCard3A1L(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$r, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$r, null, /*#__PURE__*/React$1.createElement(TextUrl$r, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$r, null, /*#__PURE__*/React$1.createElement(ImageInner$r, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$r, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$r, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$r, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 46,
    fontSize: 52
  })), /*#__PURE__*/React$1.createElement(TextThird$r, null, customSubtitle || url))));
};

var _templateObject$s, _templateObject2$s, _templateObject3$s, _templateObject4$s, _templateObject5$s, _templateObject6$s, _templateObject7$s, _templateObject8$s, _templateObject9$s;
var Wrapper$s = styled.div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 841mm;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 115px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$s = styled.div(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$s = styled.div(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.6px;\n  }\n"])));
var ImageBlock$s = styled.div(_templateObject4$s || (_templateObject4$s = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$s = styled.div(_templateObject5$s || (_templateObject5$s = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$s = styled.div(_templateObject6$s || (_templateObject6$s = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.65%;\n  width: 90%;\n  padding-bottom: 142px;\n"])));
var TextFirst$s = styled.div(_templateObject7$s || (_templateObject7$s = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 6.5px;\n    margin-right: -6.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 74px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -44px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -44px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$s = styled.div(_templateObject8$s || (_templateObject8$s = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 54px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 70px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$s = styled.div(_templateObject9$s || (_templateObject9$s = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n"])));
var WarholCard3A1 = function WarholCard3A1(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$s, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$s, null, /*#__PURE__*/React$1.createElement(TextUrl$s, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$s, null, /*#__PURE__*/React$1.createElement(ImageInner$s, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$s, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$s, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$s, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 46,
    fontSize: 52
  })), /*#__PURE__*/React$1.createElement(TextThird$s, null, customSubtitle || url))));
};

var _templateObject$t, _templateObject2$t, _templateObject3$t, _templateObject4$t, _templateObject5$t, _templateObject6$t, _templateObject7$t, _templateObject8$t, _templateObject9$t;
var Wrapper$t = styled.div(_templateObject$t || (_templateObject$t = _taggedTemplateLiteralLoose(["\n  width: 1189mm;\n  height: 841mm;\n  transform: scale(\n    calc(", " / 1189),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 163px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$t = styled.div(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$t = styled.div(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteralLoose(["\n  height: 6.91%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 1px;\n  }\n"])));
var ImageBlock$t = styled.div(_templateObject4$t || (_templateObject4$t = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$t = styled.div(_templateObject5$t || (_templateObject5$t = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$t = styled.div(_templateObject6$t || (_templateObject6$t = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24%;\n  width: 72%;\n  padding-bottom: 165px;\n"])));
var TextFirst$t = styled.div(_templateObject7$t || (_templateObject7$t = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 8.5px;\n    margin-right: -8.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 105px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -65px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -65px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$t = styled.div(_templateObject8$t || (_templateObject8$t = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 80px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 98px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$t = styled.div(_templateObject9$t || (_templateObject9$t = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 30.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 1px;\n"])));
var WarholCard3A0L = function WarholCard3A0L(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$t, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$t, null, /*#__PURE__*/React$1.createElement(TextUrl$t, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$t, null, /*#__PURE__*/React$1.createElement(ImageInner$t, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$t, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$t, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$t, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 64.5,
    fontSize: 72
  })), /*#__PURE__*/React$1.createElement(TextThird$t, null, customSubtitle || url))));
};

var _templateObject$u, _templateObject2$u, _templateObject3$u, _templateObject4$u, _templateObject5$u, _templateObject6$u, _templateObject7$u, _templateObject8$u, _templateObject9$u;
var Wrapper$u = styled.div(_templateObject$u || (_templateObject$u = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 1189mm;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 1189)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 168px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$u = styled.div(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$u = styled.div(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: bold;\n    margin-top: 20px;\n  }\n"])));
var ImageBlock$u = styled.div(_templateObject4$u || (_templateObject4$u = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$u = styled.div(_templateObject5$u || (_templateObject5$u = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$u = styled.div(_templateObject6$u || (_templateObject6$u = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.7%;\n  width: 90%;\n  padding-bottom: 200px;\n"])));
var TextFirst$u = styled.div(_templateObject7$u || (_templateObject7$u = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 8.5px;\n    margin-right: -8.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 105px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -65px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -65px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$u = styled.div(_templateObject8$u || (_templateObject8$u = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 80px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 98px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$u = styled.div(_templateObject9$u || (_templateObject9$u = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 30.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.4px;\n"])));
var WarholCard3A0 = function WarholCard3A0(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$u, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$u, null, /*#__PURE__*/React$1.createElement(TextUrl$u, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$u, null, /*#__PURE__*/React$1.createElement(ImageInner$u, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$u, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$u, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$u, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 64.5,
    fontSize: 72
  })), /*#__PURE__*/React$1.createElement(TextThird$u, null, customSubtitle || url))));
};

var HeartIcon = withTheme(function (props) {
  var width = props.width,
    height = props.height,
    viewBox = props.viewBox,
    fill = props.fill,
    stroke = props.stroke,
    strokeWidth = props.strokeWidth;
  return /*#__PURE__*/React$1.createElement("svg", {
    width: width || '55',
    height: height || '55',
    viewBox: viewBox || '0 0 24 24',
    fill: fill || '#ef2a22',
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M11.133 3.80821L11.9999 5.31574L12.8668 3.80825C13.8489 2.10053 15.578 1 17.5188 1C20.4843 1 23 3.59003 23 6.92758C23 8.72076 22.2617 10.3117 21.1141 11.3925L11.9999 18.9296L2.88574 11.3925C1.73821 10.3117 1 8.72079 1 6.92758C1 3.58986 3.51506 1 6.48038 1C8.42125 1 10.1512 2.10067 11.133 3.80821Z",
    stroke: stroke || '#ef2a22',
    strokeWidth: strokeWidth || '2'
  }));
});

var string2Any = function string2Any(stringSrc, from, to) {
  if (stringSrc && stringSrc.includes(from)) {
    var parts = stringSrc.split(from);
    var newString = /*#__PURE__*/React$1.createElement(Fragment$1, null);
    parts.forEach(function (item, idx, srcArr) {
      newString = /*#__PURE__*/React$1.createElement(Fragment$1, null, newString, item, idx < (srcArr && srcArr.length - 1) && to);
    });
    return /*#__PURE__*/React$1.createElement(Fragment$1, null, newString);
  }
  return stringSrc;
};
var heartReplace = function heartReplace(_ref) {
  var str = _ref.str,
    height = _ref.height,
    width = _ref.width,
    nosizes = _ref.nosizes;
  var iconProps = nosizes ? {} : {
    height: height || 45,
    width: width || 45
  };
  return string2Any(str, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, iconProps));
};

var _templateObject$v, _templateObject2$v, _templateObject3$v, _templateObject4$v, _templateObject5$v, _templateObject6$v, _templateObject7$v, _templateObject8$v, _templateObject9$v;
var Wrapper$v = styled.div(_templateObject$v || (_templateObject$v = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 148mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 148)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$v = styled.div(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$v = styled.div(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteralLoose(["\n  width: 92.5%;\n  height: 80.3%;\n  margin-top: 2.3%;\n  margin-left: 3.4%;\n"])));
var ImageInner$v = styled.div(_templateObject4$v || (_templateObject4$v = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$v = styled.div(_templateObject5$v || (_templateObject5$v = _taggedTemplateLiteralLoose(["\n  margin-top: 0%;\n  text-align: center;\n"])));
var TextUrl$v = styled.div(_templateObject6$v || (_templateObject6$v = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  font-size: 4.3px;\n  letter-spacing: 0;\n  margin-top: 2.13%;\n  text-align: center;\n"])));
var TextFirst$v = styled.div(_templateObject7$v || (_templateObject7$v = _taggedTemplateLiteralLoose(["\n  text-align: center;\n\n  span {\n    font-family: Roboto-Regular, Roboto, serif;\n    letter-spacing: 0.16em;\n    font-size: 5.02pt;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    margin-top: 1.85%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 506px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 121px;\n    left: 338px;\n  }\n"])));
var TextSecond$v = styled.div(_templateObject8$v || (_templateObject8$v = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  display: inline-block;\n  font-size: ", "pt;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  margin-top: 0.5%;\n  line-height: 1;\n  letter-spacing: 0.027em;\n  text-align: center;\n"])), function (props) {
  return props.fs;
});
var TextThird$v = styled.div(_templateObject9$v || (_templateObject9$v = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-weight: bold;\n  letter-spacing: 0;\n  font-size: 3pt;\n  margin-top: 0.65%;\n  text-align: center;\n"])));
var WarholCard4A5L = function WarholCard4A5L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useState = useState(13.37),
    fontS = _useState[0],
    setFontS = _useState[1];
  var _useState2 = useState(1),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name,
      useTextSecont: true,
      flag: flag
    }),
    w = _useContainerWidth.w;
  useEffect(function () {
    if (flag === 1 && w > 587) {
      setFlag(2);
    }
  }, [w]);
  useEffect(function () {
    if (flag === 2) {
      setFontS(13.37);
    }
  }, [w, flag]);
  var initName = toUpperCaseString({
    str: name,
    sliceId: 35
  });
  var textName = useMemo(function () {
    return heartReplace({
      str: initName,
      nosizes: true
    });
  }, [initName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$v, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$v, null, /*#__PURE__*/React$1.createElement(TextUrl$v, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$v, null, /*#__PURE__*/React$1.createElement(ImageInner$v, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$v, null, /*#__PURE__*/React$1.createElement(TextFirst$v, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(TextSecond$v, {
    ref: mainTextRef,
    fs: fontS,
    id: "text-second"
  }, textName), /*#__PURE__*/React$1.createElement(TextThird$v, null, museum))));
};

var _templateObject$w, _templateObject2$w, _templateObject3$w, _templateObject4$w, _templateObject5$w, _templateObject6$w, _templateObject7$w, _templateObject8$w, _templateObject9$w;
var Wrapper$w = styled.div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 209.9mm;\n  border: 1px solid white;\n  transform: scale(calc(", " / 297), calc(", " / 210));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  /* padding: 3.03% 4.86%; */\n  padding: 0.0636mm 14.43mm;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$w = styled.div(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$w = styled.div(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 88.82%;\n  // margin-top: 2.3%;\n  // margin-left: 3.4%;\n\n"])));
var ImageInner$w = styled.div(_templateObject4$w || (_templateObject4$w = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: start;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$w = styled.div(_templateObject5$w || (_templateObject5$w = _taggedTemplateLiteralLoose(["\n  margin-top: 0%;\n  text-align: center;\n  height: 7.07%;\n"])));
var TextUrl$w = styled.div(_templateObject6$w || (_templateObject6$w = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  font-size: 4pt;\n  letter-spacing: 0;\n  // margin-top: 2.13%;\n  margin-bottom: 3.03%;\n  text-align: center;\n"])));
var TextFirst$w = styled.div(_templateObject7$w || (_templateObject7$w = _taggedTemplateLiteralLoose(["\n  text-align: center;\n\n  span {\n    font-family: Roboto-Regular, Roboto, serif;\n    letter-spacing: 0.16em;\n    font-size: 7.1pt;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    // margin-top: 1.85%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    // top: 716px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 174px;\n    // left: 475px;\n    bottom: calc(50% + 1px);\n    left: 50%;\n  }\n"])));
var TextSecond$w = styled.div(_templateObject8$w || (_templateObject8$w = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  display: inline-block;\n  font-size: ", "pt;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  margin: 1.01% 0;\n  line-height: 1;\n  letter-spacing: 0.03em;\n  text-align: center;\n"])), function (props) {
  return props.fs;
});
var TextThird$w = styled.div(_templateObject9$w || (_templateObject9$w = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-weight: bold;\n  letter-spacing: 0;\n  font-size: 3.5pt;\n  // margin-top: 1.1%;\n  text-align: center;\n"])));
var WarholCard4A4L = function WarholCard4A4L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(18.92),
    fontS = _useState[0],
    setFontS = _useState[1];
  var _useState2 = useState(1),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useContainerWidth = useContainerWidth({
      name: name,
      useTextSecont: true,
      flag: flag
    }),
    w = _useContainerWidth.w;
  useEffect(function () {
    if (flag === 1 && w > 828) {
      setFlag(2);
    }
  }, [w]);
  useEffect(function () {
    if (flag === 2) {
      setFontS(18.92);
    }
  }, [w, flag]);
  var initName = toUpperCaseString({
    str: name,
    sliceId: 35
  });
  var textName = useMemo(function () {
    return heartReplace({
      str: initName,
      nosizes: true
    });
  }, [initName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$w, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$w, null, /*#__PURE__*/React$1.createElement(TextUrl$w, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$w, null, /*#__PURE__*/React$1.createElement(ImageInner$w, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$w, null, /*#__PURE__*/React$1.createElement(TextFirst$w, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(TextSecond$w, {
    fs: fontS,
    id: "text-second"
  }, textName), /*#__PURE__*/React$1.createElement(TextThird$w, null, museum))));
};

var _templateObject$x, _templateObject2$x, _templateObject3$x, _templateObject4$x, _templateObject5$x, _templateObject6$x, _templateObject7$x, _templateObject8$x, _templateObject9$x;
var Wrapper$x = styled.div(_templateObject$x || (_templateObject$x = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 296mm;\n  border: 1px solid white;\n  transform: scale(calc(", " / 420), calc(", " / 297));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$x = styled.div(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$x = styled.div(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteralLoose(["\n  width: 92.5%;\n  height: 80.3%;\n  margin-top: 2.2%;\n  margin-left: 3.4%;\n\n"])));
var ImageInner$x = styled.div(_templateObject4$x || (_templateObject4$x = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$x = styled.div(_templateObject5$x || (_templateObject5$x = _taggedTemplateLiteralLoose(["\n  margin-top: 0%;\n  text-align: center;\n"])));
var TextUrl$x = styled.div(_templateObject6$x || (_templateObject6$x = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  font-size: 5pt;\n  letter-spacing: 0;\n  margin-top: 2.3%;\n  text-align: center;\n"])));
var TextFirst$x = styled.div(_templateObject7$x || (_templateObject7$x = _taggedTemplateLiteralLoose(["\n  text-align: center;\n\n  span {\n    font-family: Roboto-Regular, Roboto, serif;\n    letter-spacing: 0.16em;\n    font-size: 10.03pt;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    margin-top: 1.9%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 1010px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 242px;\n    left: 674px;\n  }\n"])));
var TextSecond$x = styled.div(_templateObject8$x || (_templateObject8$x = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  display: inline-block;\n  font-size: ", "pt;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  margin-top: 0.8%;\n  line-height: 1;\n  letter-spacing: 0.03em;\n  text-align: center;\n"])), function (props) {
  return props.fs;
});
var TextThird$x = styled.div(_templateObject9$x || (_templateObject9$x = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-weight: bold;\n  letter-spacing: 0;\n  font-size: 4.46pt;\n  margin-top: 0.9%;\n  text-align: center;\n"])));
var WarholCard4A3L = function WarholCard4A3L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(26.75),
    fontS = _useState[0],
    setFontS = _useState[1];
  var _useState2 = useState(1),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useContainerWidth = useContainerWidth({
      name: name,
      useTextSecont: true,
      flag: flag
    }),
    w = _useContainerWidth.w;
  useEffect(function () {
    if (flag === 1 && w > 1158) {
      setFlag(2);
    }
  }, [w]);
  useEffect(function () {
    if (flag === 2) {
      setFontS(26.75);
    }
  }, [w, flag]);
  var initName = toUpperCaseString({
    str: name,
    sliceId: 35
  });
  var textName = useMemo(function () {
    return heartReplace({
      str: initName,
      nosizes: true
    });
  }, [initName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$x, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$x, null, /*#__PURE__*/React$1.createElement(TextUrl$x, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$x, null, /*#__PURE__*/React$1.createElement(ImageInner$x, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$x, null, /*#__PURE__*/React$1.createElement(TextFirst$x, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(TextSecond$x, {
    fs: fontS,
    id: "text-second"
  }, textName), /*#__PURE__*/React$1.createElement(TextThird$x, null, museum))));
};

var _templateObject$y, _templateObject2$y, _templateObject3$y, _templateObject4$y, _templateObject5$y, _templateObject6$y, _templateObject7$y, _templateObject8$y, _templateObject9$y;
var Wrapper$y = styled.div(_templateObject$y || (_templateObject$y = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 419mm;\n  border: 1px solid white;\n  transform: scale(calc(", " / 594), calc(", " / 420));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$y = styled.div(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$y = styled.div(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteralLoose(["\n  width: 92.5%;\n  height: 80.3%;\n  margin-top: 2.2%;\n  margin-left: 3.4%;\n\n"])));
var ImageInner$y = styled.div(_templateObject4$y || (_templateObject4$y = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$y = styled.div(_templateObject5$y || (_templateObject5$y = _taggedTemplateLiteralLoose(["\n  margin-top: 0%;\n  text-align: center;\n"])));
var TextUrl$y = styled.div(_templateObject6$y || (_templateObject6$y = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  font-size: 8pt;\n  letter-spacing: 0;\n  margin-top: 2.3%;\n  text-align: center;\n"])));
var TextFirst$y = styled.div(_templateObject7$y || (_templateObject7$y = _taggedTemplateLiteralLoose(["\n  text-align: center;\n\n  span {\n    font-family: Roboto-Regular, Roboto, serif;\n    letter-spacing: 0.16em;\n    font-size: 14.19pt;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    margin-top: 1.9%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 1430px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 345px;\n    left: 952px;\n  }\n"])));
var TextSecond$y = styled.div(_templateObject8$y || (_templateObject8$y = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  display: inline-block;\n  font-size: ", "pt;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  margin-top: 0.75%;\n  line-height: 1;\n  letter-spacing: 0.03em;\n  text-align: center;\n"])), function (props) {
  return props.fs;
});
var TextThird$y = styled.div(_templateObject9$y || (_templateObject9$y = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-weight: bold;\n  letter-spacing: 0;\n  font-size: 6.31pt;\n  margin-top: 0.9%;\n  text-align: center;\n"])));
var WarholCard4A2L = function WarholCard4A2L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(37.83),
    fontS = _useState[0],
    setFontS = _useState[1];
  var _useState2 = useState(1),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useContainerWidth = useContainerWidth({
      name: name,
      useTextSecont: true,
      flag: flag
    }),
    w = _useContainerWidth.w;
  useEffect(function () {
    if (flag === 1 && w > 2176) {
      setFlag(2);
    }
  }, [w]);
  useEffect(function () {
    if (flag === 2) {
      setFontS(37.83);
    }
  }, [w, flag]);
  var initName = toUpperCaseString({
    str: name,
    sliceId: 35
  });
  var textName = useMemo(function () {
    return heartReplace({
      str: initName,
      nosizes: true
    });
  }, [initName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$y, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$y, null, /*#__PURE__*/React$1.createElement(TextUrl$y, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$y, null, /*#__PURE__*/React$1.createElement(ImageInner$y, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$y, null, /*#__PURE__*/React$1.createElement(TextFirst$y, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(TextSecond$y, {
    fs: fontS,
    id: "text-second"
  }, textName), /*#__PURE__*/React$1.createElement(TextThird$y, null, museum))));
};

var _templateObject$z, _templateObject2$z, _templateObject3$z, _templateObject4$z, _templateObject5$z, _templateObject6$z, _templateObject7$z, _templateObject8$z, _templateObject9$z;
var Wrapper$z = styled.div(_templateObject$z || (_templateObject$z = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 594mm;\n  border: 1px solid white;\n  transform: scale(calc(", " / 841), calc(", " / 594));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$z = styled.div(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$z = styled.div(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteralLoose(["\n  width: 92.5%;\n  height: 80.3%;\n  margin-top: 2.2%;\n  margin-left: 3.4%;\n\n"])));
var ImageInner$z = styled.div(_templateObject4$z || (_templateObject4$z = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$z = styled.div(_templateObject5$z || (_templateObject5$z = _taggedTemplateLiteralLoose(["\n  margin-top: 0%;\n  text-align: center;\n"])));
var TextUrl$z = styled.div(_templateObject6$z || (_templateObject6$z = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  font-size: 10pt;\n  letter-spacing: 0;\n  margin-top: 2.3%;\n  text-align: center;\n"])));
var TextFirst$z = styled.div(_templateObject7$z || (_templateObject7$z = _taggedTemplateLiteralLoose(["\n  text-align: center;\n\n  span {\n    font-family: Roboto-Regular, Roboto, serif;\n    letter-spacing: 0.16em;\n    font-size: 20.06pt;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    margin-top: 1.83%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 2023px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 483px;\n    left: 1348px;\n  }\n"])));
var TextSecond$z = styled.div(_templateObject8$z || (_templateObject8$z = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  display: inline-block;\n  font-size: ", "pt;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  margin-top: 0.75%;\n  line-height: 1;\n  letter-spacing: 0.03em;\n  text-align: center;\n"])), function (props) {
  return props.fs;
});
var TextThird$z = styled.div(_templateObject9$z || (_templateObject9$z = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-weight: bold;\n  letter-spacing: 0;\n  font-size: 8.92pt;\n  margin-top: 0.95%;\n  text-align: center;\n"])));
var WarholCard4A1L = function WarholCard4A1L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(53.5),
    fontS = _useState[0],
    setFontS = _useState[1];
  var _useState2 = useState(1),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useContainerWidth = useContainerWidth({
      name: name,
      useTextSecont: true,
      flag: flag
    }),
    w = _useContainerWidth.w;
  useEffect(function () {
    if (flag === 1 && w > 2176) {
      setFlag(2);
    }
  }, [w]);
  useEffect(function () {
    if (flag === 2) {
      setFontS(53.5);
    }
  }, [w, flag]);
  var initName = toUpperCaseString({
    str: name,
    sliceId: 35
  });
  var textName = useMemo(function () {
    return heartReplace({
      str: initName,
      nosizes: true
    });
  }, [initName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$z, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$z, null, /*#__PURE__*/React$1.createElement(TextUrl$z, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$z, null, /*#__PURE__*/React$1.createElement(ImageInner$z, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$z, null, /*#__PURE__*/React$1.createElement(TextFirst$z, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(TextSecond$z, {
    fs: fontS,
    id: "text-second"
  }, textName), /*#__PURE__*/React$1.createElement(TextThird$z, null, museum))));
};

var _templateObject$A, _templateObject2$A, _templateObject3$A, _templateObject4$A, _templateObject5$A, _templateObject6$A, _templateObject7$A, _templateObject8$A, _templateObject9$A;
var Wrapper$A = styled.div(_templateObject$A || (_templateObject$A = _taggedTemplateLiteralLoose(["\n  width: 1189mm;\n  height: 840.95mm;\n  border: 1px solid white;\n  transform: scale(calc(", " / 1189), calc(", " / 841));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$A = styled.div(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$A = styled.div(_templateObject3$A || (_templateObject3$A = _taggedTemplateLiteralLoose(["\n  width: 92.5%;\n  height: 80.3%;\n  margin-top: 2.2%;\n  margin-left: 3.4%;\n\n"])));
var ImageInner$A = styled.div(_templateObject4$A || (_templateObject4$A = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$A = styled.div(_templateObject5$A || (_templateObject5$A = _taggedTemplateLiteralLoose(["\n  margin-top: 0%;\n  text-align: center;\n"])));
var TextUrl$A = styled.div(_templateObject6$A || (_templateObject6$A = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  font-size: 15pt;\n  letter-spacing: 0;\n  margin-top: 2.3%;\n  text-align: center;\n"])));
var TextFirst$A = styled.div(_templateObject7$A || (_templateObject7$A = _taggedTemplateLiteralLoose(["\n  text-align: center;\n\n  span {\n    font-family: Roboto-Regular, Roboto, serif;\n    letter-spacing: 0.16em;\n    font-size: 28.37pt;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    margin-top: 1.72%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 2862px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 690px;\n    left: 1903px;\n  }\n"])));
var TextSecond$A = styled.div(_templateObject8$A || (_templateObject8$A = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  display: inline-block;\n  font-size: ", "pt;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  margin-top: 0.77%;\n  line-height: 1;\n  letter-spacing: 0.03em;\n  text-align: center;\n"])), function (props) {
  return props.fs;
});
var TextThird$A = styled.div(_templateObject9$A || (_templateObject9$A = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-weight: bold;\n  letter-spacing: 0;\n  font-size: 12.61pt;\n  margin-top: 1%;\n  text-align: center;\n"])));
var WarholCard4A0L = function WarholCard4A0L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(75.66),
    fontS = _useState[0],
    setFontS = _useState[1];
  var _useState2 = useState(1),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useContainerWidth = useContainerWidth({
      name: name,
      useTextSecont: true,
      flag: flag
    }),
    w = _useContainerWidth.w;
  useEffect(function () {
    if (flag === 1 && w > 3365) {
      setFlag(2);
    }
  }, [w]);
  useEffect(function () {
    if (flag === 2) {
      setFontS(75.66);
    }
  }, [w, flag]);
  var initName = toUpperCaseString({
    str: name,
    sliceId: 35
  });
  var textName = useMemo(function () {
    return heartReplace({
      str: initName,
      nosizes: true
    });
  }, [initName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$A, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$A, null, /*#__PURE__*/React$1.createElement(TextUrl$A, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$A, null, /*#__PURE__*/React$1.createElement(ImageInner$A, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$A, null, /*#__PURE__*/React$1.createElement(TextFirst$A, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(TextSecond$A, {
    fs: fontS,
    id: "text-second"
  }, textName), /*#__PURE__*/React$1.createElement(TextThird$A, null, museum))));
};

var _templateObject$B, _templateObject2$B, _templateObject3$B, _templateObject4$B, _templateObject5$B, _templateObject6$B, _templateObject7$B, _templateObject8$B, _templateObject9$B, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
var Wrapper$B = styled.div(_templateObject$B || (_templateObject$B = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 1188mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 1189)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$B = styled.div(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$B = styled.div(_templateObject3$B || (_templateObject3$B = _taggedTemplateLiteralLoose(["\n  width: 76.7%;\n  height: 74.85%;\n  margin-left: 11.6%;\n  text-align: center;\n"])));
var ImageInner$B = styled.div(_templateObject4$B || (_templateObject4$B = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$B = styled.div(_templateObject5$B || (_templateObject5$B = _taggedTemplateLiteralLoose(["\n  margin-left: 11.6%;\n  width: 76.7%;\n  height: 17.5%;\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var TextFirst$B = styled.div(_templateObject6$B || (_templateObject6$B = _taggedTemplateLiteralLoose(["\n  padding-top: 6.7%;\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.217em;\n    font-size: 80px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 3.2%;\n    padding-right: 3.2%;\n    position: relative;\n    z-index: 1;\n    background: white;\n    text-align: center;\n  }\n\n  i {\n    position: absolute;\n    // top: 54.5mm;\n    border-top: 2px solid black;\n    width: 1110px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$B = styled.div(_templateObject7$B || (_templateObject7$B = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 37.1px;\n  line-height: 1.1;\n  letter-spacing: 0.2px;\n  margin-top: 2.21%;\n  padding-left: 0.45%;\n  text-align: center;\n"])));
var TextSecond2 = styled.div(_templateObject8$B || (_templateObject8$B = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$B = styled.div(_templateObject9$B || (_templateObject9$B = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 1.5px;\n  font-size: 53.75px;\n  margin-top: 1.8%;\n  margin-left: 0.5%;\n  text-align: center;\n"])));
var TextFour = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 20px;\n  margin-top: 2.26%;\n  margin-left: 0.45%;\n  text-align: center;\n"])));
var TextUrl$B = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 9.6pt;\n  margin-top: 4.8%;\n  margin-left: 0.45%;\n  text-align: center;\n  padding-bottom: 6.08%;\n"])));
var TextUrl2 = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  height: 7.7%;\n  width: 100%;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 9.6pt;\n  text-align: center;\n"])));
var TextUrl2None = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n  height: 7.7%;\n"])));
var TextGift = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 0.5;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 24pt;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var LuvrikCardA0 = function LuvrikCardA0(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$B, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2, null, country);
    }
  };
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '') {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [country]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$B, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$B, null, isGift && /*#__PURE__*/React$1.createElement(TextUrl2, null, url), !isGift && /*#__PURE__*/React$1.createElement(TextUrl2None, null), /*#__PURE__*/React$1.createElement(ImageBlock$B, null, /*#__PURE__*/React$1.createElement(ImageInner$B, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$B, null, !isGift && /*#__PURE__*/React$1.createElement(TextUrl$B, null, url), isGift && /*#__PURE__*/React$1.createElement(TextGift, null, giftName), /*#__PURE__*/React$1.createElement(TextFour, null, textName), /*#__PURE__*/React$1.createElement(TextThird$B, null, museum), countryBlock(), /*#__PURE__*/React$1.createElement(TextFirst$B, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$C, _templateObject2$C, _templateObject3$C, _templateObject4$C, _templateObject5$C, _templateObject6$C, _templateObject7$C, _templateObject8$C, _templateObject9$C, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15;
var Wrapper$C = styled.div(_templateObject$C || (_templateObject$C = _taggedTemplateLiteralLoose(["\n  width: 1189mm;\n  height: 840.8mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 1189),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$C = styled.div(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$C = styled.div(_templateObject3$C || (_templateObject3$C = _taggedTemplateLiteralLoose(["\n  width: 92.8%;\n  height: 72.5%;\n  margin-left: 3.6%;\n  margin-top: 2%;\n  text-align: center;\n"])));
var ImageInner$C = styled.div(_templateObject4$C || (_templateObject4$C = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$C = styled.div(_templateObject5$C || (_templateObject5$C = _taggedTemplateLiteralLoose(["\n  width: 92.8%;\n  height: 15.7%;\n  margin-left: 3.6%;\n  padding-top: 3.55%;\n"])));
var TextFirst$C = styled.div(_templateObject6$C || (_templateObject6$C = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.189em;\n    font-size: 83px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville';\n    font-style: italic;\n    position: absolute;\n    // top: 722.6mm;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 1095px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$C = styled.div(_templateObject7$C || (_templateObject7$C = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 36.7px;\n  line-height: 1.1;\n  letter-spacing: 0.32px;\n  margin-top: 1.3%;\n  text-align: center;\n"])));
var TextSecond2$1 = styled.div(_templateObject8$C || (_templateObject8$C = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$C = styled.div(_templateObject9$C || (_templateObject9$C = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 1.4px;\n  font-size: 53.7px;\n  margin-top: 1.05%;\n  text-align: center;\n"])));
var TextFour$1 = styled.div(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 20px;\n  margin-top: ", ";\n  text-align: center;\n"])), function (props) {
  return props.marginTop;
});
var TextUrl$C = styled.div(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 13.7px;\n  text-align: center;\n  margin-top: 2.6%;\n  margin-left: 0.05%;\n"])));
var TextUrlNone = styled.div(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteralLoose(["\n  margin-top: 4.75%;\n"])));
var TextUrl2$1 = styled.div(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 13.7px;\n  text-align: center;\n  margin-top: 3.2%;\n  margin-right: 0.1%;\n"])));
var TextUrl2None$1 = styled.div(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextGift$1 = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 1;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 24pt;\n  margin-top: 1.2%;\n  text-align: center;\n"])));
var LuvrikCardA0L = function LuvrikCardA0L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(1),
    classicState = _useState[0],
    setClassicState = _useState[1];
  var _useState2 = useState(false),
    isGift = _useState2[0],
    setIsGift = _useState2[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$C, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$1, null, country);
    }
  };
  useEffect(function () {
    if (country !== null && country !== undefined && country !== '') {
      setClassicState(1);
    } else {
      setClassicState(2);
    }
  }, [country]);
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '' && classicState === 1) {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [giftName]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$C, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$C, null, classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl$C, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrlNone, null), /*#__PURE__*/React$1.createElement(ImageBlock$C, null, /*#__PURE__*/React$1.createElement(ImageInner$C, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$C, null, /*#__PURE__*/React$1.createElement(TextFirst$C, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), countryBlock(), /*#__PURE__*/React$1.createElement(TextThird$C, null, museum), /*#__PURE__*/React$1.createElement(TextFour$1, {
    marginTop: isGift ? '1.2%' : '1.3%'
  }, textName), classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl2None$1, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrl2$1, null, url), isGift && classicState === 1 && /*#__PURE__*/React$1.createElement(TextGift$1, null, giftName))));
};

var _templateObject$D, _templateObject2$D, _templateObject3$D, _templateObject4$D, _templateObject5$D, _templateObject6$D, _templateObject7$D, _templateObject8$D, _templateObject9$D, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13$2, _templateObject14$2;
var Wrapper$D = styled.div(_templateObject$D || (_templateObject$D = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 840mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$D = styled.div(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n  box-sizing: border-box;\n"])));
var ImageBlock$D = styled.div(_templateObject3$D || (_templateObject3$D = _taggedTemplateLiteralLoose(["\n  width: 76.7%;\n  height: 73.5%;\n  margin-left: 11.6%;\n  text-align: center;\n"])));
var ImageInner$D = styled.div(_templateObject4$D || (_templateObject4$D = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$D = styled.div(_templateObject5$D || (_templateObject5$D = _taggedTemplateLiteralLoose(["\n  margin-left: 11.6%;\n  width: 76.7%;\n  height: 18.8%;\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var TextFirst$D = styled.div(_templateObject6$D || (_templateObject6$D = _taggedTemplateLiteralLoose(["\n  padding-top: 6.24%;\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 14px;\n    font-size: 68.5px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 3.5%;\n    padding-right: 3.5%;\n    position: relative;\n    z-index: 1;\n    background: white;\n    text-align: center;\n  }\n\n  i {\n    position: absolute;\n    // top: 38.5mm;\n    border-top: 2px solid black;\n    width: 920px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$D = styled.div(_templateObject7$D || (_templateObject7$D = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 28.8px;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.82px;\n  margin-top: 2.9%;\n  text-align: center;\n"])));
var TextSecond2$2 = styled.div(_templateObject8$D || (_templateObject8$D = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$D = styled.div(_templateObject9$D || (_templateObject9$D = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.87px;\n  font-size: 45.1px;\n  margin-top: 1.9%;\n  text-align: center;\n"])));
var TextFour$2 = styled.div(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 18.8px;\n  margin-top: 2.5%;\n  text-align: center;\n"])));
var TextUrl$D = styled.div(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 9pt;\n  margin-top: 6.55%;\n  text-align: center;\n  padding-bottom: 4.6%;\n"])));
var TextUrl2$2 = styled.div(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  height: 7.7%;\n  width: 100%;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 9pt;\n  text-align: center;\n"])));
var TextUrl2None$2 = styled.div(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteralLoose(["\n  height: 7.7%;\n"])));
var TextGift$2 = styled.div(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 0.5;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 18pt;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var LuvrikCardA1 = function LuvrikCardA1(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$D, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$2, null, country);
    }
  };
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '') {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [country]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$D, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$D, null, isGift && /*#__PURE__*/React$1.createElement(TextUrl2$2, null, url), !isGift && /*#__PURE__*/React$1.createElement(TextUrl2None$2, null), /*#__PURE__*/React$1.createElement(ImageBlock$D, null, /*#__PURE__*/React$1.createElement(ImageInner$D, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$D, null, !isGift && /*#__PURE__*/React$1.createElement(TextUrl$D, null, url), isGift && /*#__PURE__*/React$1.createElement(TextGift$2, null, giftName), /*#__PURE__*/React$1.createElement(TextFour$2, null, textName), /*#__PURE__*/React$1.createElement(TextThird$D, null, museum), countryBlock(), /*#__PURE__*/React$1.createElement(TextFirst$D, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$E, _templateObject2$E, _templateObject3$E, _templateObject4$E, _templateObject5$E, _templateObject6$E, _templateObject7$E, _templateObject8$E, _templateObject9$E, _templateObject10$3, _templateObject11$3, _templateObject12$3, _templateObject13$3, _templateObject14$3, _templateObject15$1;
var Wrapper$E = styled.div(_templateObject$E || (_templateObject$E = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 593.8mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$E = styled.div(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$E = styled.div(_templateObject3$E || (_templateObject3$E = _taggedTemplateLiteralLoose(["\n  width: 92.8%;\n  height: 71%;\n  margin-left: 3.6%;\n  margin-top: 2%;\n  text-align: center;\n"])));
var ImageInner$E = styled.div(_templateObject4$E || (_templateObject4$E = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$E = styled.div(_templateObject5$E || (_templateObject5$E = _taggedTemplateLiteralLoose(["\n  width: 92.8%;\n  height: 16.7%;\n  margin-left: 3.6%;\n  padding-top: 2.5%;\n"])));
var TextFirst$E = styled.div(_templateObject6$E || (_templateObject6$E = _taggedTemplateLiteralLoose(["\n  margin-top: 1%;\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.2em;\n    font-size: 69.5px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville';\n    font-style: italic;\n    position: absolute;\n    // top: 503mm;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 915px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$E = styled.div(_templateObject7$E || (_templateObject7$E = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 30px;\n  line-height: 1.1;\n  letter-spacing: 0.32px;\n  font-weight: normal;\n  margin-top: 1.7%;\n  text-align: center;\n"])));
var TextSecond2$3 = styled.div(_templateObject8$E || (_templateObject8$E = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$E = styled.div(_templateObject9$E || (_templateObject9$E = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 1.6px;\n  font-size: 43.2px;\n  margin-top: 1.07%;\n  margin-left: 0.1%;\n  text-align: center;\n"])));
var TextFour$3 = styled.div(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 18.8px;\n  margin-top: ", ";\n  text-align: center;\n"])), function (props) {
  return props.marginTop;
});
var TextUrl$E = styled.div(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 14px;\n  text-align: center;\n  margin-top: 2.5%;\n  margin-right: 0.1%;\n"])));
var TextUrlNone$1 = styled.div(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteralLoose(["\n  margin-top: 4.72%;\n"])));
var TextUrl2$3 = styled.div(_templateObject13$3 || (_templateObject13$3 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 14px;\n  text-align: center;\n  margin-top: 3.2%;\n  margin-right: 0.1%;\n"])));
var TextUrl2None$3 = styled.div(_templateObject14$3 || (_templateObject14$3 = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextGift$3 = styled.div(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 1;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 18pt;\n  margin-top: 1%;\n  text-align: center;\n"])));
var LuvrikCardA1L = function LuvrikCardA1L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(1),
    classicState = _useState[0],
    setClassicState = _useState[1];
  var _useState2 = useState(false),
    isGift = _useState2[0],
    setIsGift = _useState2[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$E, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$3, null, country);
    }
  };
  useEffect(function () {
    if (country !== null && country !== undefined && country !== '') {
      setClassicState(1);
    } else {
      setClassicState(2);
    }
  }, [country]);
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '' && classicState === 1) {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [giftName]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$E, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$E, null, classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl$E, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrlNone$1, null), /*#__PURE__*/React$1.createElement(ImageBlock$E, null, /*#__PURE__*/React$1.createElement(ImageInner$E, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$E, null, /*#__PURE__*/React$1.createElement(TextFirst$E, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), countryBlock(), /*#__PURE__*/React$1.createElement(TextThird$E, null, museum), /*#__PURE__*/React$1.createElement(TextFour$3, {
    marginTop: isGift ? '1.2%' : '1.5%'
  }, textName), classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl2None$3, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrl2$3, null, url), isGift && classicState === 1 && /*#__PURE__*/React$1.createElement(TextGift$3, null, giftName))));
};

var _templateObject$F, _templateObject2$F, _templateObject3$F, _templateObject4$F, _templateObject5$F, _templateObject6$F, _templateObject7$F, _templateObject8$F, _templateObject9$F, _templateObject10$4, _templateObject11$4, _templateObject12$4, _templateObject13$4, _templateObject14$4;
var Wrapper$F = styled.div(_templateObject$F || (_templateObject$F = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 594mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$F = styled.div(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n  box-sizing: border-box;\n"])));
var ImageBlock$F = styled.div(_templateObject3$F || (_templateObject3$F = _taggedTemplateLiteralLoose(["\n  width: 76.7%;\n  height: 73.5%;\n  margin-left: 11.6%;\n  text-align: center;\n"])));
var ImageInner$F = styled.div(_templateObject4$F || (_templateObject4$F = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$F = styled.div(_templateObject5$F || (_templateObject5$F = _taggedTemplateLiteralLoose(["\n  margin-left: 11.6%;\n  width: 76.7%;\n  height: 18.8%;\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var TextFirst$F = styled.div(_templateObject6$F || (_templateObject6$F = _taggedTemplateLiteralLoose(["\n  padding-top: 6.24%;\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.209em;\n    font-size: 48.1px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 3.2%;\n    padding-right: 3.2%;\n    position: relative;\n    z-index: 1;\n    background: white;\n    text-align: center;\n  }\n\n  i {\n    position: absolute;\n    // top: 27.5mm;\n    border-top: 2px solid black;\n    width: 650px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$F = styled.div(_templateObject7$F || (_templateObject7$F = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 21.8px;\n  line-height: 1.1;\n  letter-spacing: normal;\n  margin-top: 2.8%;\n  text-align: center;\n"])));
var TextSecond2$4 = styled.div(_templateObject8$F || (_templateObject8$F = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$F = styled.div(_templateObject9$F || (_templateObject9$F = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.8px;\n  font-size: 31px;\n  margin-top: 2.11%;\n  text-align: center;\n"])));
var TextFour$4 = styled.div(_templateObject10$4 || (_templateObject10$4 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 13.8px;\n  margin-top: 2.4%;\n  text-align: center;\n"])));
var TextUrl$F = styled.div(_templateObject11$4 || (_templateObject11$4 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 7.2pt;\n  margin-top: 6.5%;\n  text-align: center;\n  padding-bottom: 4.6%;\n"])));
var TextUrl2$4 = styled.div(_templateObject12$4 || (_templateObject12$4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  height: 7.7%;\n  width: 100%;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 7.2pt;\n  text-align: center;\n"])));
var TextUrl2None$4 = styled.div(_templateObject13$4 || (_templateObject13$4 = _taggedTemplateLiteralLoose(["\n  height: 7.7%;\n"])));
var TextGift$4 = styled.div(_templateObject14$4 || (_templateObject14$4 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 0.5;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 13pt;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var LuvrikCardA2 = function LuvrikCardA2(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$F, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$4, null, country);
    }
  };
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '') {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [country]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$F, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$F, null, isGift && /*#__PURE__*/React$1.createElement(TextUrl2$4, null, url), !isGift && /*#__PURE__*/React$1.createElement(TextUrl2None$4, null), /*#__PURE__*/React$1.createElement(ImageBlock$F, null, /*#__PURE__*/React$1.createElement(ImageInner$F, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$F, null, !isGift && /*#__PURE__*/React$1.createElement(TextUrl$F, null, url), isGift && /*#__PURE__*/React$1.createElement(TextGift$4, null, giftName), /*#__PURE__*/React$1.createElement(TextFour$4, null, textName), /*#__PURE__*/React$1.createElement(TextThird$F, null, museum), countryBlock(), /*#__PURE__*/React$1.createElement(TextFirst$F, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$G, _templateObject2$G, _templateObject3$G, _templateObject4$G, _templateObject5$G, _templateObject6$G, _templateObject7$G, _templateObject8$G, _templateObject9$G, _templateObject10$5, _templateObject11$5, _templateObject12$5, _templateObject13$5, _templateObject14$5, _templateObject15$2;
var Wrapper$G = styled.div(_templateObject$G || (_templateObject$G = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 419mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$G = styled.div(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$G = styled.div(_templateObject3$G || (_templateObject3$G = _taggedTemplateLiteralLoose(["\n  width: 92.7%;\n  height: 71%;\n  margin-left: 3.6%;\n  margin-top: 2.2%;\n  text-align: center;\n"])));
var ImageInner$G = styled.div(_templateObject4$G || (_templateObject4$G = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$G = styled.div(_templateObject5$G || (_templateObject5$G = _taggedTemplateLiteralLoose(["\n  width: 92.7%;\n  height: 16.7%;\n  margin-left: 3.8%;\n  padding-top: 3.45%;\n"])));
var TextFirst$G = styled.div(_templateObject6$G || (_templateObject6$G = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.2em;\n    font-size: 49px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville';\n    font-style: italic;\n    position: absolute;\n    // top: 355.5mm;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 650px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$G = styled.div(_templateObject7$G || (_templateObject7$G = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 21px;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.3px;\n  margin-top: 1.7%;\n  margin-right: 0.3%;\n  text-align: center;\n"])));
var TextSecond2$5 = styled.div(_templateObject8$G || (_templateObject8$G = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$G = styled.div(_templateObject9$G || (_templateObject9$G = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.85px;\n  font-size: 31px;\n  margin-top: 1.1%;\n  margin-right: 0.3%;\n  text-align: center;\n"])));
var TextFour$5 = styled.div(_templateObject10$5 || (_templateObject10$5 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 13.7px;\n  margin-top: ", ";\n  margin-right: 0.3%;\n  text-align: center;\n"])), function (props) {
  return props.marginTop;
});
var TextUrl$G = styled.div(_templateObject11$5 || (_templateObject11$5 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 11.8px;\n  text-align: center;\n  margin-top: 2.4%;\n  margin-right: 0.1%;\n"])));
var TextUrlNone$2 = styled.div(_templateObject12$5 || (_templateObject12$5 = _taggedTemplateLiteralLoose(["\n  margin-top: 4.8%;\n"])));
var TextUrl2$5 = styled.div(_templateObject13$5 || (_templateObject13$5 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 11.8px;\n  text-align: center;\n  margin-top: 3.2%;\n  margin-right: 0.1%;\n"])));
var TextUrl2None$5 = styled.div(_templateObject14$5 || (_templateObject14$5 = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextGift$5 = styled.div(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 1;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 13pt;\n  margin-top: 1%;\n  text-align: center;\n"])));
var LuvrikCardA2L = function LuvrikCardA2L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  var _useState2 = useState(1),
    classicState = _useState2[0],
    setClassicState = _useState2[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$G, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$5, null, country);
    }
  };
  useEffect(function () {
    if (country !== null && country !== undefined && country !== '') {
      setClassicState(1);
    } else {
      setClassicState(2);
    }
  }, [country]);
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '' && classicState === 1) {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [giftName]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$G, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$G, null, classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl$G, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrlNone$2, null), /*#__PURE__*/React$1.createElement(ImageBlock$G, null, /*#__PURE__*/React$1.createElement(ImageInner$G, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$G, null, /*#__PURE__*/React$1.createElement(TextFirst$G, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), countryBlock(), /*#__PURE__*/React$1.createElement(TextThird$G, null, museum), /*#__PURE__*/React$1.createElement(TextFour$5, {
    marginTop: isGift ? '1.2%' : '1.5%'
  }, textName), classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl2None$5, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrl2$5, null, url), isGift && classicState === 1 && /*#__PURE__*/React$1.createElement(TextGift$5, null, giftName))));
};

var _templateObject$H, _templateObject2$H, _templateObject3$H, _templateObject4$H, _templateObject5$H, _templateObject6$H, _templateObject7$H, _templateObject8$H, _templateObject9$H, _templateObject10$6, _templateObject11$6, _templateObject12$6, _templateObject13$6, _templateObject14$6;
var Wrapper$H = styled.div(_templateObject$H || (_templateObject$H = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 420mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$H = styled.div(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n  box-sizing: border-box;\n"])));
var ImageBlock$H = styled.div(_templateObject3$H || (_templateObject3$H = _taggedTemplateLiteralLoose(["\n  width: 76.7%;\n  height: 73.5%;\n  margin-left: 11.6%;\n  text-align: center;\n"])));
var ImageInner$H = styled.div(_templateObject4$H || (_templateObject4$H = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$H = styled.div(_templateObject5$H || (_templateObject5$H = _taggedTemplateLiteralLoose(["\n  margin-left: 11.6%;\n  width: 76.7%;\n  height: 18.8%;\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var TextFirst$H = styled.div(_templateObject6$H || (_templateObject6$H = _taggedTemplateLiteralLoose(["\n  padding-top: 6%;\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.213em;\n    font-size: 37.2px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 3.2%;\n    padding-right: 3.2%;\n    position: relative;\n    z-index: 1;\n    background: white;\n    text-align: center;\n  }\n\n  i {\n    position: absolute;\n    // top: 19.5mm;\n    border-top: 1px solid black;\n    // width: 490px;\n    width: 39%;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$H = styled.div(_templateObject7$H || (_templateObject7$H = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 16.2px;\n  line-height: 1.1;\n  letter-spacing: 0.25px;\n  font-weight: normal;\n  margin-top: 2.6%;\n  text-align: center;\n"])));
var TextSecond2$6 = styled.div(_templateObject8$H || (_templateObject8$H = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$H = styled.div(_templateObject9$H || (_templateObject9$H = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.39px;\n  font-size: 23.1px;\n  margin-top: 1.7%;\n  text-align: center;\n"])));
var TextFour$6 = styled.div(_templateObject10$6 || (_templateObject10$6 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 9.7px;\n  margin-top: 2.5%;\n  text-align: center;\n"])));
var TextUrl$H = styled.div(_templateObject11$6 || (_templateObject11$6 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 5pt;\n  margin-top: 6.6%;\n  padding-bottom: 4.7%;\n  text-align: center;\n"])));
var TextUrl2$6 = styled.div(_templateObject12$6 || (_templateObject12$6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  height: 7.7%;\n  width: 100%;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 5pt;\n  text-align: center;\n"])));
var TextUrl2None$6 = styled.div(_templateObject13$6 || (_templateObject13$6 = _taggedTemplateLiteralLoose(["\n  height: 7.7%;\n"])));
var TextGift$6 = styled.div(_templateObject14$6 || (_templateObject14$6 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 0.5;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 9pt;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var LuvrikCardA3 = function LuvrikCardA3(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$H, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$6, null, country);
    }
  };
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '') {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [country]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$H, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$H, null, isGift && /*#__PURE__*/React$1.createElement(TextUrl2$6, null, url), !isGift && /*#__PURE__*/React$1.createElement(TextUrl2None$6, null), /*#__PURE__*/React$1.createElement(ImageBlock$H, null, /*#__PURE__*/React$1.createElement(ImageInner$H, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$H, null, !isGift && /*#__PURE__*/React$1.createElement(TextUrl$H, null, url), isGift && /*#__PURE__*/React$1.createElement(TextGift$6, null, giftName), /*#__PURE__*/React$1.createElement(TextFour$6, null, textName), /*#__PURE__*/React$1.createElement(TextThird$H, null, museum), countryBlock(), /*#__PURE__*/React$1.createElement(TextFirst$H, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$I, _templateObject2$I, _templateObject3$I, _templateObject4$I, _templateObject5$I, _templateObject6$I, _templateObject7$I, _templateObject8$I, _templateObject9$I, _templateObject10$7, _templateObject11$7, _templateObject12$7, _templateObject13$7, _templateObject14$7, _templateObject15$3;
var Wrapper$I = styled.div(_templateObject$I || (_templateObject$I = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 296mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$I = styled.div(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$I = styled.div(_templateObject3$I || (_templateObject3$I = _taggedTemplateLiteralLoose(["\n  width: 92.7%;\n  height: 71.1%;\n  margin-left: 3.6%;\n  margin-top: 2.2%;\n  text-align: center;\n"])));
var ImageInner$I = styled.div(_templateObject4$I || (_templateObject4$I = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$I = styled.div(_templateObject5$I || (_templateObject5$I = _taggedTemplateLiteralLoose(["\n  width: 92.7%;\n  height: 16.7%;\n  margin-left: 3.6%;\n  padding-top: 3.6%;\n"])));
var TextFirst$I = styled.div(_templateObject6$I || (_templateObject6$I = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-top: -0.15%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.227em;\n    font-size: 33.2px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2%;\n    padding-right: 1.7%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville';\n    font-style: italic;\n    position: absolute;\n    // top: 251mm;\n    z-index: 1;\n    border-top: 1px solid black;\n    // width: 456px;\n    width: 26%;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$I = styled.div(_templateObject7$I || (_templateObject7$I = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 16px;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.3px;\n  margin-top: 1.75%;\n  text-align: center;\n"])));
var TextSecond2$7 = styled.div(_templateObject8$I || (_templateObject8$I = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$I = styled.div(_templateObject9$I || (_templateObject9$I = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.23px;\n  font-size: 23.5px;\n  margin-top: 1%;\n  text-align: center;\n"])));
var TextFour$7 = styled.div(_templateObject10$7 || (_templateObject10$7 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 9.6px;\n  margin-top: ", ";\n  text-align: center;\n"])), function (props) {
  return props.marginTop;
});
var TextUrl$I = styled.div(_templateObject11$7 || (_templateObject11$7 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 9.9px;\n  text-align: center;\n  margin-top: 2.35%;\n  margin-right: 0.3%;\n"])));
var TextUrlNone$3 = styled.div(_templateObject12$7 || (_templateObject12$7 = _taggedTemplateLiteralLoose(["\n  margin-top: 4.8%;\n"])));
var TextUrl2$7 = styled.div(_templateObject13$7 || (_templateObject13$7 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 9.9px;\n  text-align: center;\n  margin-top: 3.2%;\n  margin-right: 0.3%;\n"])));
var TextUrl2None$7 = styled.div(_templateObject14$7 || (_templateObject14$7 = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextGift$7 = styled.div(_templateObject15$3 || (_templateObject15$3 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 1;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 9pt;\n  margin-top: 1.1%;\n  text-align: center;\n"])));
var LuvrikCardA3L = function LuvrikCardA3L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(1),
    classicState = _useState[0],
    setClassicState = _useState[1];
  var _useState2 = useState(false),
    isGift = _useState2[0],
    setIsGift = _useState2[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$I, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$7, null, country);
    }
  };
  useEffect(function () {
    if (country !== null && country !== undefined && country !== '') {
      setClassicState(1);
    } else {
      setClassicState(2);
    }
  }, [country]);
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '' && classicState === 1) {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [giftName]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$I, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$I, null, classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl$I, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrlNone$3, null), /*#__PURE__*/React$1.createElement(ImageBlock$I, null, /*#__PURE__*/React$1.createElement(ImageInner$I, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$I, null, /*#__PURE__*/React$1.createElement(TextFirst$I, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), countryBlock(), /*#__PURE__*/React$1.createElement(TextThird$I, null, museum), /*#__PURE__*/React$1.createElement(TextFour$7, {
    marginTop: isGift ? '1.2%' : '1.5%'
  }, textName), classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl2None$7, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrl2$7, null, url), isGift && classicState === 1 && /*#__PURE__*/React$1.createElement(TextGift$7, null, giftName))));
};

var _templateObject$J, _templateObject2$J, _templateObject3$J, _templateObject4$J, _templateObject5$J, _templateObject6$J, _templateObject7$J, _templateObject8$J, _templateObject9$J, _templateObject10$8, _templateObject11$8, _templateObject12$8, _templateObject13$8, _templateObject14$8;
var Wrapper$J = styled.div(_templateObject$J || (_templateObject$J = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$J = styled.div(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  padding: 0 91px;\n"])));
var ImageBlock$J = styled.div(_templateObject3$J || (_templateObject3$J = _taggedTemplateLiteralLoose(["\n  height: 73.1%;\n  text-align: center;\n"])));
var ImageInner$J = styled.div(_templateObject4$J || (_templateObject4$J = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$J = styled.div(_templateObject5$J || (_templateObject5$J = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column-reverse;\n  height: 18.9%;\n"])));
var TextFirst$J = styled.div(_templateObject6$J || (_templateObject6$J = _taggedTemplateLiteralLoose(["\n  width: 60%;\n  margin: 0 auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: 'Baskerville';\n\n  span {\n    font-size: 27px;\n    font-style: italic;\n    letter-spacing: 5.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 35px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: 42px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: 42px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$J = styled.div(_templateObject7$J || (_templateObject7$J = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: calc(10.5px * 1.23);\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.25px;\n  margin-top: 2.5%;\n  text-align: center;\n  display: block;\n  color: #151514;\n"])));
var TextSecond2$8 = styled.div(_templateObject8$J || (_templateObject8$J = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: calc(10.5px * 1.23);\n  line-height: 1.1;\n  font-weight: bold;\n  letter-spacing: 0.25px;\n  margin-top: 2.5%;\n  text-align: center;\n  display: none;\n  color: #151514;\n"])));
var TextThird$J = styled.div(_templateObject9$J || (_templateObject9$J = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.35px;\n  font-size: calc(15.2px * 1.2);\n  margin-top: 1.4%;\n  text-align: center;\n  color: #151514;\n"])));
var TextFour$8 = styled.div(_templateObject10$8 || (_templateObject10$8 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 7.5px;\n  margin-top: 2.5%;\n  text-align: center;\n  color: #151514;\n"])));
var TextUrl$J = styled.div(_templateObject11$8 || (_templateObject11$8 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 5pt;\n  margin-top: 5.2%;\n  padding-bottom: 4.2%;\n  text-align: center;\n  color: #151514;\n"])));
var TextUrl2$8 = styled.div(_templateObject12$8 || (_templateObject12$8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  height: 8%;\n  width: 100%;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 5pt;\n  text-align: center;\n"])));
var TextUrl2None$8 = styled.div(_templateObject13$8 || (_templateObject13$8 = _taggedTemplateLiteralLoose(["\n  height: 8%;\n"])));
var TextGift$8 = styled.div(_templateObject14$8 || (_templateObject14$8 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 0.5;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 8pt;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var LuvrikCardA4 = function LuvrikCardA4(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$J, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$8, null, country);
    }
  };
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '') {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [country]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$J, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$J, null, isGift && /*#__PURE__*/React$1.createElement(TextUrl2$8, null, url), !isGift && /*#__PURE__*/React$1.createElement(TextUrl2None$8, null), /*#__PURE__*/React$1.createElement(ImageBlock$J, null, /*#__PURE__*/React$1.createElement(ImageInner$J, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$J, null, !isGift && /*#__PURE__*/React$1.createElement(TextUrl$J, null, url), isGift && /*#__PURE__*/React$1.createElement(TextGift$8, null, giftName), /*#__PURE__*/React$1.createElement(TextFour$8, null, textName), /*#__PURE__*/React$1.createElement(TextThird$J, null, museum), countryBlock(), /*#__PURE__*/React$1.createElement(TextFirst$J, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })))));
};

var _templateObject$K, _templateObject2$K, _templateObject3$K, _templateObject4$K, _templateObject5$K, _templateObject6$K, _templateObject7$K, _templateObject8$K, _templateObject9$K, _templateObject10$9, _templateObject11$9, _templateObject12$9, _templateObject13$9, _templateObject14$9, _templateObject15$4;
var Wrapper$K = styled.div(_templateObject$K || (_templateObject$K = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 40px;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$K = styled.div(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"])));
var ImageBlock$K = styled.div(_templateObject3$K || (_templateObject3$K = _taggedTemplateLiteralLoose(["\n  height: 70.8%;\n  text-align: center;\n"])));
var ImageInner$K = styled.div(_templateObject4$K || (_templateObject4$K = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$K = styled.div(_templateObject5$K || (_templateObject5$K = _taggedTemplateLiteralLoose(["\n  width: 92%;\n  height: 22.2%;\n  margin: auto;\n  box-sizing: border-box;\n  padding-top: 43px;\n  color: #151514;\n"])));
var TextFirst$K = styled.div(_templateObject6$K || (_templateObject6$K = _taggedTemplateLiteralLoose(["\n  width: 40%;\n  margin: auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: 'Baskerville';\n\n  span {\n    font-size: 27px;\n    font-style: italic;\n    letter-spacing: 5.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 35px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: 64px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: 64px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$K = styled.div(_templateObject7$K || (_templateObject7$K = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-weight: normal;\n  font-size: 12.7px;\n  line-height: 1.1;\n  letter-spacing: 0.35px;\n  margin-top: 1.1%;\n  margin-right: 0.2%;\n  text-align: center;\n  color: #151514;\n"])));
var TextSecond2$9 = styled.div(_templateObject8$K || (_templateObject8$K = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$K = styled.div(_templateObject9$K || (_templateObject9$K = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.7px;\n  font-size: 17.7px;\n  margin-top: 13px;\n  text-align: center;\n  color: #151514;\n"])));
var TextFour$9 = styled.div(_templateObject10$9 || (_templateObject10$9 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 7.6px;\n  margin-top: ", ";\n  margin-right: 0.2%;\n  text-align: center;\n  color: #151514;\n"])), function (props) {
  return props.marginTop;
});
var TextUrl$K = styled.div(_templateObject11$9 || (_templateObject11$9 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 7.5px;\n  text-align: center;\n  height: 7%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #151514;\n"])));
var TextUrlNone$4 = styled.div(_templateObject12$9 || (_templateObject12$9 = _taggedTemplateLiteralLoose(["\n  margin-top: 4.75%;\n"])));
var TextUrl2$9 = styled.div(_templateObject13$9 || (_templateObject13$9 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 7.5px;\n  text-align: center;\n  margin-top: 2.8%;\n  color: #151514;\n"])));
var TextUrl2None$9 = styled.div(_templateObject14$9 || (_templateObject14$9 = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextGift$9 = styled.div(_templateObject15$4 || (_templateObject15$4 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 1;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 7pt;\n  margin-top: 1.1%;\n  text-align: center;\n"])));
var LuvrikCardA4L = function LuvrikCardA4L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(1),
    classicState = _useState[0],
    setClassicState = _useState[1];
  var _useState2 = useState(false),
    isGift = _useState2[0],
    setIsGift = _useState2[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$K, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$9, null, country);
    }
  };
  useEffect(function () {
    if (country !== null && country !== undefined && country !== '') {
      setClassicState(1);
    } else {
      setClassicState(2);
    }
  }, [country]);
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '' && classicState === 1) {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [giftName]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$K, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$K, null, /*#__PURE__*/React$1.createElement(TextUrl$K, null, classicState === 1 && url), /*#__PURE__*/React$1.createElement(ImageBlock$K, null, /*#__PURE__*/React$1.createElement(ImageInner$K, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$K, null, /*#__PURE__*/React$1.createElement(TextFirst$K, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), countryBlock(), /*#__PURE__*/React$1.createElement(TextThird$K, null, museum), /*#__PURE__*/React$1.createElement(TextFour$9, {
    marginTop: isGift ? '1.1%' : '1.6%'
  }, textName), classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl2None$9, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrl2$9, null, url), isGift && classicState === 1 && /*#__PURE__*/React$1.createElement(TextGift$9, null, giftName))));
};

var _templateObject$L, _templateObject2$L, _templateObject3$L, _templateObject4$L, _templateObject5$L, _templateObject6$L, _templateObject7$L, _templateObject8$L, _templateObject9$L, _templateObject10$a, _templateObject11$a, _templateObject12$a, _templateObject13$a, _templateObject14$a;
var Wrapper$L = styled.div(_templateObject$L || (_templateObject$L = _taggedTemplateLiteralLoose(["\n  width: 148mm;\n  height: 209.9mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 148),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$L = styled.div(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n  box-sizing: border-box;\n"])));
var ImageBlock$L = styled.div(_templateObject3$L || (_templateObject3$L = _taggedTemplateLiteralLoose(["\n  width: 76.8%;\n  height: 73.5%;\n  margin-left: 11.6%;\n  text-align: center;\n"])));
var ImageInner$L = styled.div(_templateObject4$L || (_templateObject4$L = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$L = styled.div(_templateObject5$L || (_templateObject5$L = _taggedTemplateLiteralLoose(["\n  margin-left: 11.6%;\n  width: 76.9%;\n  height: 18.8%;\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var TextFirst$L = styled.div(_templateObject6$L || (_templateObject6$L = _taggedTemplateLiteralLoose(["\n  padding-top: 6.1%;\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.18em;\n    font-size: 22.3px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.5%;\n    padding-right: 2.5%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    // top: 10.5mm;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 264px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$L = styled.div(_templateObject7$L || (_templateObject7$L = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  font-size: 10.5px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: normal;\n  margin-top: 2.35%;\n  text-align: center;\n  display: block;\n"])));
var TextSecond2$a = styled.div(_templateObject8$L || (_templateObject8$L = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  font-size: 10.5px;\n  font-weight: 600;\n  line-height: 1.1;\n  letter-spacing: normal;\n  margin-top: 2.35%;\n  text-align: center;\n  display: none;\n"])));
var TextThird$L = styled.div(_templateObject9$L || (_templateObject9$L = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  line-height: 1.1;\n  letter-spacing: 0.17px;\n  font-size: 13.8px;\n  margin-top: 1.1%;\n  text-align: center;\n"])));
var TextFour$a = styled.div(_templateObject10$a || (_templateObject10$a = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 6.9px;\n  margin-top: 2.4%;\n  text-align: center;\n"])));
var TextUrl$L = styled.div(_templateObject11$a || (_templateObject11$a = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 5.7px;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var TextUrl2$a = styled.div(_templateObject12$a || (_templateObject12$a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  height: 7.7%;\n  width: 100%;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 5.7px;\n  text-align: center;\n"])));
var TextUrl2None$a = styled.div(_templateObject13$a || (_templateObject13$a = _taggedTemplateLiteralLoose(["\n  height: 7.7%; ;\n"])));
var TextGift$a = styled.div(_templateObject14$a || (_templateObject14$a = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 0.5;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 8.2px;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var LuvrikCardA5 = function LuvrikCardA5(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$L, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$a, null, country);
    }
  };
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '') {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [country]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$L, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$L, null, isGift && /*#__PURE__*/React$1.createElement(TextUrl2$a, null, url), !isGift && /*#__PURE__*/React$1.createElement(TextUrl2None$a, null), /*#__PURE__*/React$1.createElement(ImageBlock$L, null, /*#__PURE__*/React$1.createElement(ImageInner$L, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$L, null, !isGift && /*#__PURE__*/React$1.createElement(TextUrl$L, null, url), isGift && /*#__PURE__*/React$1.createElement(TextGift$a, null, giftName), /*#__PURE__*/React$1.createElement(TextFour$a, null, textName), /*#__PURE__*/React$1.createElement(TextThird$L, null, museum), countryBlock(), /*#__PURE__*/React$1.createElement(TextFirst$L, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$M, _templateObject2$M, _templateObject3$M, _templateObject4$M, _templateObject5$M, _templateObject6$M, _templateObject7$M, _templateObject8$M, _templateObject9$M, _templateObject10$b, _templateObject11$b, _templateObject12$b, _templateObject13$b, _templateObject14$b, _templateObject15$5;
var Wrapper$M = styled.div(_templateObject$M || (_templateObject$M = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 148mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 148)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$M = styled.div(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n  box-sizing: border-box;\n"])));
var ImageBlock$M = styled.div(_templateObject3$M || (_templateObject3$M = _taggedTemplateLiteralLoose(["\n  width: 93.3%;\n  height: 71.3%;\n  margin-left: 3.4%;\n  margin-top: 2.2%;\n"])));
var ImageInner$M = styled.div(_templateObject4$M || (_templateObject4$M = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$M = styled.div(_templateObject5$M || (_templateObject5$M = _taggedTemplateLiteralLoose(["\n  width: 93.3%;\n  height: 16.9%;\n  margin-left: 3.4%;\n  padding-top: 3.6%;\n"])));
var TextFirst$M = styled.div(_templateObject6$M || (_templateObject6$M = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.235em;\n    font-size: 20.6px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 1.5%;\n    padding-right: 1.5%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 125.7mm;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 266px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$M = styled.div(_templateObject7$M || (_templateObject7$M = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  font-size: 10px;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.2px;\n  padding-top: 1.4%;\n  text-align: center;\n"])));
var TextSecond2$b = styled.div(_templateObject8$M || (_templateObject8$M = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$M = styled.div(_templateObject9$M || (_templateObject9$M = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  line-height: 1.1;\n  letter-spacing: 0.26px;\n  font-size: 13.5px;\n  padding-top: 0.7%;\n  text-align: center;\n"])));
var TextFour$b = styled.div(_templateObject10$b || (_templateObject10$b = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 6.9px;\n  margin-top: ", ";\n  text-align: center;\n"])), function (props) {
  return props.marginTop;
});
var TextUrl$M = styled.div(_templateObject11$b || (_templateObject11$b = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 7.8px;\n  text-align: center;\n  margin-top: 2.1%;\n"])));
var TextUrlNone$5 = styled.div(_templateObject12$b || (_templateObject12$b = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 7.8px;\n  text-align: center;\n  margin-top: 4.7%;\n"])));
var TextUrl2$b = styled.div(_templateObject13$b || (_templateObject13$b = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 7.8px;\n  text-align: center;\n  margin-top: 2.5%;\n"])));
var TextUrl2None$b = styled.div(_templateObject14$b || (_templateObject14$b = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextGift$b = styled.div(_templateObject15$5 || (_templateObject15$5 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 1;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 6pt;\n  margin-top: 0.8%;\n  text-align: center;\n"])));
var LuvrikCardA5L = function LuvrikCardA5L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(1),
    classicState = _useState[0],
    setClassicState = _useState[1];
  var _useState2 = useState(false),
    isGift = _useState2[0],
    setIsGift = _useState2[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$M, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$b, null, country);
    }
  };
  useEffect(function () {
    if (country !== null && country !== undefined && country !== '') {
      setClassicState(1);
    } else {
      setClassicState(2);
    }
  }, [country]);
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '' && classicState === 1) {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [giftName]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$M, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$M, null, classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl$M, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrlNone$5, null), /*#__PURE__*/React$1.createElement(ImageBlock$M, null, /*#__PURE__*/React$1.createElement(ImageInner$M, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$M, null, /*#__PURE__*/React$1.createElement(TextFirst$M, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), countryBlock(), /*#__PURE__*/React$1.createElement(TextThird$M, null, museum), /*#__PURE__*/React$1.createElement(TextFour$b, {
    marginTop: isGift ? '1%' : '1.5%'
  }, textName), classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl2None$b, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrl2$b, null, url), isGift && classicState === 1 && /*#__PURE__*/React$1.createElement(TextGift$b, null, giftName))));
};

var _templateObject$N, _templateObject2$N, _templateObject3$N, _templateObject4$N, _templateObject5$N, _templateObject6$N, _templateObject7$N, _templateObject8$N, _templateObject9$N, _templateObject10$c, _templateObject11$c, _templateObject12$c, _templateObject13$c;
var Wrapper$N = styled.div(_templateObject$N || (_templateObject$N = _taggedTemplateLiteralLoose(["\n  width: 148mm;\n  height: 209.9mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 148),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$N = styled.div(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  border: 1px solid white;\n"])));
var ImageBlock$N = styled.div(_templateObject3$N || (_templateObject3$N = _taggedTemplateLiteralLoose(["\n  width: 76.5%;\n  height: 53.9%;\n  text-align: center;\n"])));
var ImageInner$N = styled.div(_templateObject4$N || (_templateObject4$N = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$N = styled.div(_templateObject5$N || (_templateObject5$N = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 76.5%;\n  height: 38%;\n  //background: blue;\n"])));
var Number = styled.div(_templateObject6$N || (_templateObject6$N = _taggedTemplateLiteralLoose(["\n  padding-top: 3.5%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.18em;\n    font-size: 22.3px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.8%;\n    padding-right: 2.8%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 28px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 265px;\n    left: 80px;\n  }\n"])));
var OrderName = styled.div(_templateObject7$N || (_templateObject7$N = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  font-style: normal;\n  font-size: 17px;\n  font-weight: normal;\n  line-height: 1.1;\n  margin-top: 8.5%;\n  letter-spacing: normal;\n  text-align: center;\n"])));
var Slogan = styled.div(_templateObject8$N || (_templateObject8$N = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 10.7px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: normal;\n  margin-top: 3.5%;\n"])));
var SloganHeader = styled.div(_templateObject9$N || (_templateObject9$N = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-size: 10px;\n  letter-spacing: 0.5px;\n  text-align: center;\n  font-weight: bold;\n  font-style: italic;\n  padding-bottom: 3px;\n"])));
var Description = styled.div(_templateObject10$c || (_templateObject10$c = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 7px;\n  font-weight: bold;\n  line-height: 10px;\n  letter-spacing: 0.02em;\n  margin-top: 10.5%;\n  text-align: justify;\n  text-align-last: center;\n"])));
var Signature = styled.div(_templateObject11$c || (_templateObject11$c = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  color: #c90000;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.17px;\n  font-size: 14.3px;\n  margin-top: 4%;\n  text-align: center;\n"])));
var SymbolSeparator = styled.div(_templateObject12$c || (_templateObject12$c = _taggedTemplateLiteralLoose(["\n  padding-top: 2.5%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Noto', serif;\n    font-size: 12px;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: normal;\n    position: absolute;\n    top: 21px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 65px;\n    left: 180px;\n  }\n"])));
var Url = styled.div(_templateObject13$c || (_templateObject13$c = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 5.7px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 8%;\n"])));
var ClassicCard3A5 = function ClassicCard3A5(props) {
  var image = props.image,
    url = props.url,
    slogan = props.slogan,
    description = props.description,
    signature = props.signature,
    orderName = props.orderName,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$N, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$N, null, /*#__PURE__*/React$1.createElement(Url, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$N, null, /*#__PURE__*/React$1.createElement(ImageInner$N, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$N, null, /*#__PURE__*/React$1.createElement(OrderName, null, orderName), /*#__PURE__*/React$1.createElement(Slogan, null, /*#__PURE__*/React$1.createElement(SloganHeader, null, "\u0414\u0435\u0432\u0438\u0437"), "\xAB", slogan, "\xBB"), /*#__PURE__*/React$1.createElement(Signature, null, signature), /*#__PURE__*/React$1.createElement(SymbolSeparator, null, /*#__PURE__*/React$1.createElement("span", null, "\u203B"), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(Description, null, description), /*#__PURE__*/React$1.createElement(Number, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$O, _templateObject2$O, _templateObject3$O, _templateObject4$O, _templateObject5$O, _templateObject6$O, _templateObject7$O, _templateObject8$O, _templateObject9$O, _templateObject10$d, _templateObject11$d, _templateObject12$d, _templateObject13$d;
var Wrapper$O = styled.div(_templateObject$O || (_templateObject$O = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$O = styled.div(_templateObject2$O || (_templateObject2$O = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  border: 1px solid white;\n"])));
var ImageBlock$O = styled.div(_templateObject3$O || (_templateObject3$O = _taggedTemplateLiteralLoose(["\n  width: 76.5%;\n  height: 53.9%;\n  text-align: center;\n  //background: red;\n"])));
var ImageInner$O = styled.div(_templateObject4$O || (_templateObject4$O = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$O = styled.div(_templateObject5$O || (_templateObject5$O = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 76.5%;\n  height: 38%;\n  //background: blue;\n"])));
var Number$1 = styled.div(_templateObject6$O || (_templateObject6$O = _taggedTemplateLiteralLoose(["\n  padding-top: 5.7%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.2em;\n    font-size: 27px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.8%;\n    padding-right: 2.8%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 53px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 357px;\n    left: 125px;\n  }\n"])));
var OrderName$1 = styled.div(_templateObject7$O || (_templateObject7$O = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  font-style: normal;\n  font-size: 24px;\n  font-weight: normal;\n  line-height: 1.1;\n  margin-top: 8.6%;\n  letter-spacing: normal;\n  text-align: center;\n"])));
var Slogan$1 = styled.div(_templateObject8$O || (_templateObject8$O = _taggedTemplateLiteralLoose(["\n  font-family: 'Noto', serif;\n  font-style: normal;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: normal;\n  margin-top: 3.5%;\n"])));
var SloganHeader$1 = styled.div(_templateObject9$O || (_templateObject9$O = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-size: 11.2px;\n  letter-spacing: 1.7px;\n  text-align: center;\n  font-weight: bold;\n  font-style: italic;\n  padding-bottom: 3px;\n  margin-top: 1%;\n"])));
var Description$1 = styled.div(_templateObject10$d || (_templateObject10$d = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 10.7px;\n  font-weight: normal;\n  line-height: normal;\n  letter-spacing: 0.01em;\n  margin-top: 11.5%;\n  text-align: justify;\n  text-align-last: center;\n"])));
var Signature$1 = styled.div(_templateObject11$d || (_templateObject11$d = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  color: #c90000;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.28px;\n  font-size: 20px;\n  margin-top: 4.2%;\n  text-align: center;\n"])));
var SymbolSeparator$1 = styled.div(_templateObject12$d || (_templateObject12$d = _taggedTemplateLiteralLoose(["\n  padding-top: 2.9%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Noto', serif;\n    font-size: 16px;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: normal;\n    position: absolute;\n    top: 29px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 90px;\n    left: 258px;\n  }\n"])));
var Url$1 = styled.div(_templateObject13$d || (_templateObject13$d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 5.7px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 8%;\n"])));
var ClassicCard3A4 = function ClassicCard3A4(props) {
  var image = props.image,
    url = props.url,
    slogan = props.slogan,
    description = props.description,
    signature = props.signature,
    orderName = props.orderName,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$O, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$O, null, /*#__PURE__*/React$1.createElement(Url$1, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$O, null, /*#__PURE__*/React$1.createElement(ImageInner$O, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$O, null, /*#__PURE__*/React$1.createElement(OrderName$1, null, orderName), /*#__PURE__*/React$1.createElement(Slogan$1, null, /*#__PURE__*/React$1.createElement(SloganHeader$1, null, "\u0414\u0435\u0432\u0438\u0437"), "\xAB", slogan, "\xBB"), /*#__PURE__*/React$1.createElement(Signature$1, null, signature), /*#__PURE__*/React$1.createElement(SymbolSeparator$1, null, /*#__PURE__*/React$1.createElement("span", null, "\u203B"), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(Description$1, null, description), /*#__PURE__*/React$1.createElement(Number$1, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$P, _templateObject2$P, _templateObject3$P, _templateObject4$P, _templateObject5$P, _templateObject6$P, _templateObject7$P, _templateObject8$P, _templateObject9$P, _templateObject10$e, _templateObject11$e, _templateObject12$e, _templateObject13$e;
var Wrapper$P = styled.div(_templateObject$P || (_templateObject$P = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 420mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$P = styled.div(_templateObject2$P || (_templateObject2$P = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  border: 1px solid white;\n"])));
var ImageBlock$P = styled.div(_templateObject3$P || (_templateObject3$P = _taggedTemplateLiteralLoose(["\n  width: 76.5%;\n  height: 53.9%;\n  text-align: center;\n  //background: red;\n"])));
var ImageInner$P = styled.div(_templateObject4$P || (_templateObject4$P = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$P = styled.div(_templateObject5$P || (_templateObject5$P = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 76.5%;\n  height: 38%;\n  //background: blue;\n"])));
var Number$2 = styled.div(_templateObject6$P || (_templateObject6$P = _taggedTemplateLiteralLoose(["\n  padding-top: 5.7%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.2em;\n    font-size: 34.6px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.8%;\n    padding-right: 2.8%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 71px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 460px;\n    left: 200px;\n  }\n"])));
var OrderName$2 = styled.div(_templateObject7$P || (_templateObject7$P = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  font-style: normal;\n  font-size: 35px;\n  font-weight: normal;\n  line-height: 1.1;\n  margin-top: 8.6%;\n  letter-spacing: normal;\n  text-align: center;\n"])));
var Slogan$2 = styled.div(_templateObject8$P || (_templateObject8$P = _taggedTemplateLiteralLoose(["\n  font-family: 'Noto', serif;\n  font-style: normal;\n  font-size: 17px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: 1.6px;\n  margin-top: 3.5%;\n"])));
var SloganHeader$2 = styled.div(_templateObject9$P || (_templateObject9$P = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-size: 14.5px;\n  letter-spacing: 3px;\n  text-align: center;\n  font-weight: bold;\n  font-style: italic;\n  padding-bottom: 9px;\n  margin-top: 1.5%;\n"])));
var Description$2 = styled.div(_templateObject10$e || (_templateObject10$e = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: normal;\n  letter-spacing: 0.02em;\n  margin-top: 11.5%;\n  text-align: justify;\n  text-align-last: center;\n"])));
var Signature$2 = styled.div(_templateObject11$e || (_templateObject11$e = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  color: #c90000;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.28px;\n  font-size: 28.8px;\n  margin-top: 4.2%;\n  text-align: center;\n"])));
var SymbolSeparator$2 = styled.div(_templateObject12$e || (_templateObject12$e = _taggedTemplateLiteralLoose(["\n  padding-top: 2.9%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Noto', serif;\n    font-size: 21px;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: normal;\n    position: absolute;\n    top: 41px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 125px;\n    left: 367px;\n  }\n"])));
var Url$2 = styled.div(_templateObject13$e || (_templateObject13$e = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 7px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 8%;\n"])));
var ClassicCard3A3 = function ClassicCard3A3(props) {
  var image = props.image,
    url = props.url,
    slogan = props.slogan,
    description = props.description,
    signature = props.signature,
    orderName = props.orderName,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$P, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$P, null, /*#__PURE__*/React$1.createElement(Url$2, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$P, null, /*#__PURE__*/React$1.createElement(ImageInner$P, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$P, null, /*#__PURE__*/React$1.createElement(OrderName$2, null, orderName), /*#__PURE__*/React$1.createElement(Slogan$2, null, /*#__PURE__*/React$1.createElement(SloganHeader$2, null, "\u0414\u0435\u0432\u0438\u0437"), "\xAB", slogan, "\xBB"), /*#__PURE__*/React$1.createElement(Signature$2, null, signature), /*#__PURE__*/React$1.createElement(SymbolSeparator$2, null, /*#__PURE__*/React$1.createElement("span", null, "\u203B"), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(Description$2, null, description), /*#__PURE__*/React$1.createElement(Number$2, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$Q, _templateObject2$Q, _templateObject3$Q, _templateObject4$Q, _templateObject5$Q, _templateObject6$Q, _templateObject7$Q, _templateObject8$Q, _templateObject9$Q, _templateObject10$f, _templateObject11$f, _templateObject12$f, _templateObject13$f;
var Wrapper$Q = styled.div(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 594mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$Q = styled.div(_templateObject2$Q || (_templateObject2$Q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  border: 1px solid white;\n"])));
var ImageBlock$Q = styled.div(_templateObject3$Q || (_templateObject3$Q = _taggedTemplateLiteralLoose(["\n  width: 76.5%;\n  height: 53.9%;\n  text-align: center;\n  //background: red;\n"])));
var ImageInner$Q = styled.div(_templateObject4$Q || (_templateObject4$Q = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$Q = styled.div(_templateObject5$Q || (_templateObject5$Q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 76.5%;\n  height: 38%;\n  //background: blue;\n"])));
var Number$3 = styled.div(_templateObject6$Q || (_templateObject6$Q = _taggedTemplateLiteralLoose(["\n  padding-top: 5.5%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.2em;\n    font-size: 49.5px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.8%;\n    padding-right: 2.8%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 98px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 648px;\n    left: 285px;\n  }\n"])));
var OrderName$3 = styled.div(_templateObject7$Q || (_templateObject7$Q = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  font-style: normal;\n  font-size: 47px;\n  font-weight: normal;\n  line-height: 1.1;\n  margin-top: 8.6%;\n  letter-spacing: normal;\n  text-align: center;\n"])));
var Slogan$3 = styled.div(_templateObject8$Q || (_templateObject8$Q = _taggedTemplateLiteralLoose(["\n  font-family: 'Noto', serif;\n  font-style: normal;\n  font-size: 24.5px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: 1.6px;\n  margin-top: 3.5%;\n"])));
var SloganHeader$3 = styled.div(_templateObject9$Q || (_templateObject9$Q = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-size: 22px;\n  letter-spacing: 3px;\n  text-align: center;\n  font-weight: bold;\n  font-style: italic;\n  padding-bottom: 9px;\n  margin-top: 1.5%;\n"])));
var Description$3 = styled.div(_templateObject10$f || (_templateObject10$f = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 17.8px;\n  font-weight: normal;\n  line-height: normal;\n  letter-spacing: 0.02em;\n  margin-top: 12%;\n  text-align: justify;\n  text-align-last: center;\n"])));
var Signature$3 = styled.div(_templateObject11$f || (_templateObject11$f = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  color: #c90000;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 42px;\n  margin-top: 4.2%;\n  text-align: center;\n"])));
var SymbolSeparator$3 = styled.div(_templateObject12$f || (_templateObject12$f = _taggedTemplateLiteralLoose(["\n  padding-top: 3.3%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Noto', serif;\n    font-size: 27px;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: normal;\n    position: absolute;\n    top: 60px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 173px;\n    left: 520px;\n  }\n"])));
var Url$3 = styled.div(_templateObject13$f || (_templateObject13$f = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 10px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 8%;\n"])));
var ClassicCard3A2 = function ClassicCard3A2(props) {
  var image = props.image,
    url = props.url,
    slogan = props.slogan,
    description = props.description,
    signature = props.signature,
    orderName = props.orderName,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$Q, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$Q, null, /*#__PURE__*/React$1.createElement(Url$3, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$Q, null, /*#__PURE__*/React$1.createElement(ImageInner$Q, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$Q, null, /*#__PURE__*/React$1.createElement(OrderName$3, null, orderName), /*#__PURE__*/React$1.createElement(Slogan$3, null, /*#__PURE__*/React$1.createElement(SloganHeader$3, null, "\u0414\u0435\u0432\u0438\u0437"), "\xAB", slogan, "\xBB"), /*#__PURE__*/React$1.createElement(Signature$3, null, signature), /*#__PURE__*/React$1.createElement(SymbolSeparator$3, null, /*#__PURE__*/React$1.createElement("span", null, "\u203B"), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(Description$3, null, description), /*#__PURE__*/React$1.createElement(Number$3, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$R, _templateObject2$R, _templateObject3$R, _templateObject4$R, _templateObject5$R, _templateObject6$R, _templateObject7$R, _templateObject8$R, _templateObject9$R, _templateObject10$g, _templateObject11$g, _templateObject12$g, _templateObject13$g;
var Wrapper$R = styled.div(_templateObject$R || (_templateObject$R = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 840mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$R = styled.div(_templateObject2$R || (_templateObject2$R = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  border: 1px solid white;\n"])));
var ImageBlock$R = styled.div(_templateObject3$R || (_templateObject3$R = _taggedTemplateLiteralLoose(["\n  width: 76.5%;\n  height: 53.9%;\n  text-align: center;\n  //background: red;\n"])));
var ImageInner$R = styled.div(_templateObject4$R || (_templateObject4$R = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$R = styled.div(_templateObject5$R || (_templateObject5$R = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 76.5%;\n  height: 38%;\n  //background: blue;\n"])));
var Number$4 = styled.div(_templateObject6$R || (_templateObject6$R = _taggedTemplateLiteralLoose(["\n  padding-top: 5.5%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.2em;\n    font-size: 70px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.8%;\n    padding-right: 2.8%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 139px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 918px;\n    left: 400px;\n  }\n"])));
var OrderName$4 = styled.div(_templateObject7$R || (_templateObject7$R = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  font-style: normal;\n  font-size: 54px;\n  font-weight: normal;\n  line-height: 1.1;\n  margin-top: 9.3%;\n  letter-spacing: normal;\n  text-align: center;\n"])));
var Slogan$4 = styled.div(_templateObject8$R || (_templateObject8$R = _taggedTemplateLiteralLoose(["\n  font-family: 'Noto', serif;\n  font-style: normal;\n  font-size: 29px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: 1.6px;\n  margin-top: 3.6%;\n"])));
var SloganHeader$4 = styled.div(_templateObject9$R || (_templateObject9$R = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-size: 32px;\n  letter-spacing: 3px;\n  text-align: center;\n  font-weight: bold;\n  font-style: italic;\n  padding-bottom: 18px;\n  margin-top: 1.5%;\n"])));
var Description$4 = styled.div(_templateObject10$g || (_templateObject10$g = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 22px;\n  font-weight: normal;\n  line-height: normal;\n  letter-spacing: 0.02em;\n  margin-top: 14.2%;\n  text-align: justify;\n  text-align-last: center;\n"])));
var Signature$4 = styled.div(_templateObject11$g || (_templateObject11$g = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  color: #c90000;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 56px;\n  margin-top: 4.2%;\n  text-align: center;\n"])));
var SymbolSeparator$4 = styled.div(_templateObject12$g || (_templateObject12$g = _taggedTemplateLiteralLoose(["\n  padding-top: 3.5%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Noto', serif;\n    font-size: 40px;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: normal;\n    position: absolute;\n    top: 89px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 250px;\n    left: 733px;\n  }\n"])));
var Url$4 = styled.div(_templateObject13$g || (_templateObject13$g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 14px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 8%;\n"])));
var ClassicCard3A1 = function ClassicCard3A1(props) {
  var image = props.image,
    url = props.url,
    slogan = props.slogan,
    description = props.description,
    signature = props.signature,
    orderName = props.orderName,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$R, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$R, null, /*#__PURE__*/React$1.createElement(Url$4, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$R, null, /*#__PURE__*/React$1.createElement(ImageInner$R, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$R, null, /*#__PURE__*/React$1.createElement(OrderName$4, null, orderName), /*#__PURE__*/React$1.createElement(Slogan$4, null, /*#__PURE__*/React$1.createElement(SloganHeader$4, null, "\u0414\u0435\u0432\u0438\u0437"), "\xAB", slogan, "\xBB"), /*#__PURE__*/React$1.createElement(Signature$4, null, signature), /*#__PURE__*/React$1.createElement(SymbolSeparator$4, null, /*#__PURE__*/React$1.createElement("span", null, "\u203B"), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(Description$4, null, description), /*#__PURE__*/React$1.createElement(Number$4, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$S, _templateObject2$S, _templateObject3$S, _templateObject4$S, _templateObject5$S, _templateObject6$S, _templateObject7$S, _templateObject8$S, _templateObject9$S, _templateObject10$h, _templateObject11$h, _templateObject12$h, _templateObject13$h;
var Wrapper$S = styled.div(_templateObject$S || (_templateObject$S = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 1188mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 1189)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$S = styled.div(_templateObject2$S || (_templateObject2$S = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  border: 1px solid white;\n"])));
var ImageBlock$S = styled.div(_templateObject3$S || (_templateObject3$S = _taggedTemplateLiteralLoose(["\n  width: 76.5%;\n  height: 53.9%;\n  text-align: center;\n  //background: red;\n"])));
var ImageInner$S = styled.div(_templateObject4$S || (_templateObject4$S = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$S = styled.div(_templateObject5$S || (_templateObject5$S = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 76.5%;\n  height: 38%;\n  //background: blue;\n"])));
var Number$5 = styled.div(_templateObject6$S || (_templateObject6$S = _taggedTemplateLiteralLoose(["\n  padding-top: 5.9%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.2em;\n    font-size: 80px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.9%;\n    padding-right: 2.9%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 195px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 1100px;\n    left: 670px;\n  }\n"])));
var OrderName$5 = styled.div(_templateObject7$S || (_templateObject7$S = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  font-style: normal;\n  font-size: 64px;\n  font-weight: normal;\n  line-height: 1.1;\n  margin-top: 8.78%;\n  letter-spacing: normal;\n  text-align: center;\n"])));
var Slogan$5 = styled.div(_templateObject8$S || (_templateObject8$S = _taggedTemplateLiteralLoose(["\n  font-family: 'Noto', serif;\n  font-style: normal;\n  font-size: 35px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: 1.6px;\n  margin-top: 5.2%;\n"])));
var SloganHeader$5 = styled.div(_templateObject9$S || (_templateObject9$S = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-size: 36px;\n  letter-spacing: 3px;\n  text-align: center;\n  font-weight: bold;\n  font-style: italic;\n  padding-bottom: 38px;\n  margin-top: 1.5%;\n"])));
var Description$5 = styled.div(_templateObject10$h || (_templateObject10$h = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 24.5px;\n  font-weight: normal;\n  line-height: normal;\n  width: calc(100% - 180px);\n  letter-spacing: 0.01em;\n  margin-top: 15%;\n  text-align: justify;\n  text-align-last: center;\n"])));
var Signature$5 = styled.div(_templateObject11$h || (_templateObject11$h = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  color: #c90000;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 63px;\n  margin-top: 4.8%;\n  text-align: center;\n"])));
var SymbolSeparator$5 = styled.div(_templateObject12$h || (_templateObject12$h = _taggedTemplateLiteralLoose(["\n  padding-top: 3.8%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Noto', serif;\n    font-size: 49px;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: normal;\n    position: absolute;\n    top: 126px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 295px;\n    left: 1070px;\n  }\n"])));
var Url$5 = styled.div(_templateObject13$h || (_templateObject13$h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 13.5px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 8%;\n"])));
var ClassicCard3A0 = function ClassicCard3A0(props) {
  var image = props.image,
    url = props.url,
    slogan = props.slogan,
    description = props.description,
    signature = props.signature,
    orderName = props.orderName,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$S, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$S, null, /*#__PURE__*/React$1.createElement(Url$5, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$S, null, /*#__PURE__*/React$1.createElement(ImageInner$S, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$S, null, /*#__PURE__*/React$1.createElement(OrderName$5, null, orderName), /*#__PURE__*/React$1.createElement(Slogan$5, null, /*#__PURE__*/React$1.createElement(SloganHeader$5, null, "\u0414\u0435\u0432\u0438\u0437"), "\xAB", slogan, "\xBB"), /*#__PURE__*/React$1.createElement(Signature$5, null, signature), /*#__PURE__*/React$1.createElement(SymbolSeparator$5, null, /*#__PURE__*/React$1.createElement("span", null, "\u203B"), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(Description$5, null, description), /*#__PURE__*/React$1.createElement(Number$5, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$T, _templateObject2$T, _templateObject3$T;
var TextMainBlock = styled.div(_templateObject$T || (_templateObject$T = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var TextHeadBlock = styled.div(_templateObject2$T || (_templateObject2$T = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 15.5px;\n    padding-bottom: 3px;\n    padding-top: 3.5px;\n    line-height: 1;\n    letter-spacing: 3px;\n"])));
var TextBodyBlock = styled.div(_templateObject3$T || (_templateObject3$T = _taggedTemplateLiteralLoose(["\n    font-family: 'Oranienbaum';\n    font-weight: 400;\n    font-size: 10.3px;\n    margin: 10px;\n    word-wrap: break-word;\n"])));
function TextBlock$T(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(TextMainBlock, null, /*#__PURE__*/React$1.createElement(TextHeadBlock, null, name), /*#__PURE__*/React$1.createElement(TextBodyBlock, null, body));
}

var _templateObject$U, _templateObject2$U, _templateObject3$U;
var CurMainBlock = styled.div(_templateObject$U || (_templateObject$U = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n    box-sizing: border-box;\n"])));
var CurBodyBlock = styled.div(_templateObject2$U || (_templateObject2$U = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n    font-family: 'Baskerville';\n    font-style: italic;\n    letter-spacing: 3px;\n    font-size: 18px;\n    height: 54px;\n    width: 100%;\n    word-wrap: break-word;\n    text-align: center;\n\n"])));
var CurHeaderBlock = styled.div(_templateObject3$U || (_templateObject3$U = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 15.5px;\n    padding-bottom: 3px;\n    padding-top: 3.5px;\n    line-height: 1;\n    letter-spacing: 3px;\n"])));
function TextBlock$U(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(CurMainBlock, null, /*#__PURE__*/React$1.createElement(CurHeaderBlock, null, name), /*#__PURE__*/React$1.createElement(CurBodyBlock, null, body));
}

var _templateObject$V, _templateObject2$V, _templateObject3$V, _templateObject4$T, _templateObject5$T, _templateObject6$T, _templateObject7$T;
var GerbMainFrame = styled.div(_templateObject$V || (_templateObject$V = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  max-height: 100%;\n"])));
var GerbImageBlock = styled.div(_templateObject2$V || (_templateObject2$V = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 136px;\n  height: 136px;\n  //width: 238px;\n  justify-content: center;\n  margin-top: 8%;\n  margin-bottom: 8%;\n  margin-right: auto;\n  margin-left: auto;\n\n  img {\n    //width: 136px;\n    //height: 100%;\n    width: 100%;\n  }\n"])));
var GerbTextBlock = styled.div(_templateObject3$V || (_templateObject3$V = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-family: 'Corki-Tuscan';\n  font-weight: 400;\n  font-size: 15.5px;\n  padding-left: 5%;\n  padding-right: 5%;\n  line-height: 1.1;\n  word-wrap: break-word;\n"])));
var GerbCountryBlock = styled.div(_templateObject4$T || (_templateObject4$T = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-family: 'Lehmann';\n  width: 238px;\n  height: 103px;\n  font-weight: 500;\n  font-size: 34px;\n  padding-bottom: 2.6%;\n  padding-top: 0.5%;\n  padding-left: 10%;\n  padding-right: 10%;\n  margin: auto;\n  line-height: 1;\n  letter-spacing: 1px;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var GerbTextSep = styled.div(_templateObject5$T || (_templateObject5$T = _taggedTemplateLiteralLoose(["\n  padding-bottom: 1%;\n"])));
var Sep = styled.div(_templateObject6$T || (_templateObject6$T = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  margin-left: 40%;\n  margin-right: 40%;\n"])));
var GerbTextNoSep = styled.div(_templateObject7$T || (_templateObject7$T = _taggedTemplateLiteralLoose(["\n  margin-top: 1%;\n"])));
function GerbBlock(props) {
  var gerbimage = props.gerbimage,
    headername = props.headername,
    countryname = props.countryname,
    capitalname = props.capitalname;
  return /*#__PURE__*/React$1.createElement(GerbMainFrame, null, /*#__PURE__*/React$1.createElement(GerbImageBlock, {
    className: "gerb_block_imageA3"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: gerbimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(GerbTextBlock, null, headername), /*#__PURE__*/React$1.createElement(GerbCountryBlock, null, countryname), /*#__PURE__*/React$1.createElement(GerbTextBlock, null, /*#__PURE__*/React$1.createElement(GerbTextSep, null, "\u0421\u0442\u043E\u043B\u0438\u0446\u0430: ", capitalname)));
}

var _templateObject$W, _templateObject2$W, _templateObject3$W, _templateObject4$U;
var AnimalMainBlock = styled.div(_templateObject$W || (_templateObject$W = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"])));
var AnimalHeaderBlock = styled.div(_templateObject2$W || (_templateObject2$W = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 15.5px;\n    padding-bottom: 3px;\n    padding-top: 3.5px;\n    line-height: 1;\n    letter-spacing: 3px;\n"])));
var AnimalBodyBlock = styled.div(_templateObject3$W || (_templateObject3$W = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 238px;\n  height: 88px;\n  box-sizing: border-box;\n"])));
var AnimalImageBlock = styled.div(_templateObject4$U || (_templateObject4$U = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n    font-family: 'Noto', serif;\n    font-size: 6px;\n    font-weight: 600;\n    width: 38px;\n    height: 45px;\n    box-sizing: border-box;\n\n    img{\n      display: flex;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      size: auto;\n    }\n"])));
function AnimalBlock(props) {
  var name = props.name,
    animals = props.animals,
    endpoint = props.endpoint;
  return /*#__PURE__*/React$1.createElement(AnimalMainBlock, null, /*#__PURE__*/React$1.createElement(AnimalHeaderBlock, null, name), /*#__PURE__*/React$1.createElement(AnimalBodyBlock, null, !!(animals && animals.length) && animals.map(function (item) {
    return /*#__PURE__*/React$1.createElement(AnimalImageBlock, null, /*#__PURE__*/React$1.createElement("img", {
      src: "" + ((endpoint ? endpoint + '/' : '') + item.attachments[0].files[0].url),
      alt: ""
    }), item.attachments[0].texts);
  })));
}

var _templateObject$X, _templateObject2$X, _templateObject3$X;
var QrMainBlock = styled.div(_templateObject$X || (_templateObject$X = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-height: 100%;\n"])));
var QrImageBlock = styled.div(_templateObject2$X || (_templateObject2$X = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img{\n      width: 77%;\n    }\n"])));
var QrTextBlock = styled.div(_templateObject3$X || (_templateObject3$X = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-family: 'Roboto';\n    font-size: 0.67rem;\n    margin-bottom: 5%;\n    justify-content: center;\n"])));
function QrBlock(props) {
  var qrimg = props.qrimg,
    qrurl = props.qrurl;
  return /*#__PURE__*/React$1.createElement(QrMainBlock, null, /*#__PURE__*/React$1.createElement(QrImageBlock, null, /*#__PURE__*/React$1.createElement("img", {
    src: qrimg
  })), /*#__PURE__*/React$1.createElement(QrTextBlock, null, qrurl));
}

var _templateObject$Y, _templateObject2$Y, _templateObject3$Y;
var NumMainBlock = styled.div(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n"])));
var NumberTextBlock = styled.div(_templateObject2$Y || (_templateObject2$Y = _taggedTemplateLiteralLoose(["\n    margin-left: 17%;\n    margin-right: 17%;\n    margin-bottom: 6%;\n    margin-top: 6.5%;\n    text-align: center;\n    \n    span{\n      font-family: 'Baskerville';\n      font-style: italic;\n      font-size: 36px;\n      line-height: 25px;\n      letter-spacing: 10px;\n      z-index: 1;\n      background: white;\n      text-align: center;\n      position: relative;\n      padding-left: 5%;\n      padding-right: 3%;\n    }\n    \n    i{\n      position: absolute;\n      width: 440px;\n      left: 110px;\n      top: 88px;\n      border-top: 1px solid black;\n    }\n    \n"])));
var NumberTextGiftBlock = styled.div(_templateObject3$Y || (_templateObject3$Y = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-size: 14.6px;\n    font-family: 'Oranienbaum';\n    font-weight: 400;\n    border-top: 1px solid black;\n    justify-content: center;\n    padding-top: 1.3%;\n    padding-bottom: 1.2%;\n"])));
function NumberBlock(props) {
  var name = props.name,
    giftname = props.giftname;
  return /*#__PURE__*/React$1.createElement(NumMainBlock, null, /*#__PURE__*/React$1.createElement(NumberTextBlock, null, /*#__PURE__*/React$1.createElement("i", null), /*#__PURE__*/React$1.createElement("span", null, name)), /*#__PURE__*/React$1.createElement(NumberTextGiftBlock, null, giftname));
}

var _templateObject$Z, _templateObject2$Z, _templateObject3$Z, _templateObject4$V;
var MapRelBlock = styled.div(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var MapImageBlock = styled.div(_templateObject2$Z || (_templateObject2$Z = _taggedTemplateLiteralLoose([" \n  img{\n    width: 100%;\n    max-height: 537px;\n  }\n"])));
var MapSvgBlock = styled.div(_templateObject3$Z || (_templateObject3$Z = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-height: 100%;\n    z-index: 9;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n"])));
var MapSvgImage = styled.div(_templateObject4$V || (_templateObject4$V = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n"])));
function MapBlock(props) {
  var mapimage = props.mapimage,
    mapsvg = props.mapsvg;
  return /*#__PURE__*/React$1.createElement(MapRelBlock, null, /*#__PURE__*/React$1.createElement(MapImageBlock, null, /*#__PURE__*/React$1.createElement("img", {
    src: mapimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(MapSvgBlock, null, /*#__PURE__*/React$1.createElement(MapSvgImage, {
    className: "map_svg_imageA3",
    dangerouslySetInnerHTML: {
      __html: mapsvg
    }
  })));
}

var getAnimals = function getAnimals(_ref) {
  var services = _ref.services;
  var animalsItems = services && services.length && services.filter(function (item) {
    return item.type === 'animals';
  });
  var animals = animalsItems && animalsItems.length && animalsItems[0].containers;
  return animals;
};

var _templateObject$_, _templateObject2$_, _templateObject3$_, _templateObject4$W, _templateObject5$U, _templateObject6$U, _templateObject7$U, _templateObject8$T, _templateObject9$T, _templateObject10$i, _templateObject11$i, _templateObject12$i, _templateObject13$i, _templateObject14$c;
var Wrapper$T = styled.div(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteralLoose(["\n    height: 297mm;\n    width: 210mm;\n    transform: scale(calc(", "/210), calc(", "/297));\n    transform-origin: left top;\n    user-select: none;\n  box-sizing: border-box;\n    "])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var PMMainBlock = styled.div(_templateObject2$_ || (_templateObject2$_ = _taggedTemplateLiteralLoose(["\n    padding: 33px;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n"])));
var PMSecondBlock = styled.div(_templateObject3$_ || (_templateObject3$_ = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    padding: 2px;\n    background: white;\n    max-height: 100%;\n    max-width: 100%;\n    border: 2px solid black;\n  box-sizing: border-box;\n"])));
var PMFlexColumn = styled.div(_templateObject4$W || (_templateObject4$W = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n  box-sizing: border-box;\n"])));
var PMFlexRow = styled.div(_templateObject5$U || (_templateObject5$U = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n  box-sizing: border-box;\n"])));
var PMNumberBlock = styled.div(_templateObject6$U || (_templateObject6$U = _taggedTemplateLiteralLoose(["\n    width: 587px;\n    height: 135px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMQrBlock = styled.div(_templateObject7$U || (_templateObject7$U = _taggedTemplateLiteralLoose(["\n    width: 135px;\n    height: 135px;\n    border: 1px solid black;\n    display: flex;\n    box-sizing: border-box;\n"])));
var PMMapBlock = styled.div(_templateObject8$T || (_templateObject8$T = _taggedTemplateLiteralLoose(["\n    width: 720px;\n    height: 539px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMGerbBlock = styled.div(_templateObject9$T || (_templateObject9$T = _taggedTemplateLiteralLoose(["\n    width: 240px;\n    height: 374px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMClimatBlock = styled.div(_templateObject10$i || (_templateObject10$i = _taggedTemplateLiteralLoose(["\n    width: 240px;\n    height: 192px;\n    word-wrap: break-word;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMGeogrBlock = styled.div(_templateObject11$i || (_templateObject11$i = _taggedTemplateLiteralLoose(["\n    width: 240px;\n    height: 182px;\n    word-wrap: break-word;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMEconomBlock = styled.div(_templateObject12$i || (_templateObject12$i = _taggedTemplateLiteralLoose(["\n    width: 240px;\n    height: 182px;\n    word-wrap: break-word;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMAnimalBlock = styled.div(_templateObject13$i || (_templateObject13$i = _taggedTemplateLiteralLoose(["\n    width: 240px;\n    height: 113px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMCurBlock = styled.div(_templateObject14$c || (_templateObject14$c = _taggedTemplateLiteralLoose(["\n    width: 240px;\n    height: 79px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var MapCardA4 = function MapCardA4(props) {
  var num = props.num,
    gift = props.gift,
    qrimage = props.qrimage,
    qrtext = props.qrtext,
    mapimage = props.mapimage,
    mapsvg = props.mapsvg,
    gerbimage = props.gerbimage,
    country = props.country,
    countryname = props.countryname,
    capital = props.capital,
    countrysize = props.countrysize,
    climat = props.climat,
    geographic = props.geographic,
    currency = props.currency,
    economical = props.economical,
    dw = props.dw,
    dh = props.dh,
    animal0 = props.animal0,
    animal1 = props.animal1,
    animal2 = props.animal2,
    animal3 = props.animal3,
    animal4 = props.animal4,
    animal5 = props.animal5,
    externalStyles = props.externalStyles;
  var _ref = externalStyles || {},
    wrapStl = _ref.wrapStl,
    blockStl = _ref.blockStl,
    secondBlockStl = _ref.secondBlockStl,
    flexColumnStl = _ref.flexColumnStl,
    flexRowStl = _ref.flexRowStl,
    numberBlockStl = _ref.numberBlockStl,
    numberStl = _ref.numberStl,
    qrBlockStl = _ref.qrBlockStl,
    qrStl = _ref.qrStl,
    mapBlockStl = _ref.mapBlockStl,
    mapStl = _ref.mapStl,
    gerbBlockStl = _ref.gerbBlockStl,
    gerbStl = _ref.gerbStl,
    climatBlockStl = _ref.climatBlockStl,
    climatStl = _ref.climatStl,
    geogrBlockStl = _ref.geogrBlockStl,
    geogrStl = _ref.geogrStl,
    animalBlockStl = _ref.animalBlockStl,
    animalStl = _ref.animalStl,
    curBlockStl = _ref.curBlockStl,
    curStl = _ref.curStl,
    economBlockStl = _ref.economBlockStl,
    economStl = _ref.economStl;
  var services = props.services,
    endpoint = props.endpoint;
  var animals = getAnimals({
    services: services
  });
  return /*#__PURE__*/React$1.createElement(Wrapper$T, {
    dw: dw,
    dh: dh,
    className: wrapStl
  }, /*#__PURE__*/React$1.createElement(PMMainBlock, {
    className: blockStl
  }, /*#__PURE__*/React$1.createElement(PMSecondBlock, {
    className: secondBlockStl
  }, /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMFlexRow, {
    className: flexRowStl
  }, /*#__PURE__*/React$1.createElement(PMNumberBlock, {
    className: numberBlockStl
  }, /*#__PURE__*/React$1.createElement(NumberBlock, {
    name: num,
    giftname: gift,
    className: numberStl
  })), /*#__PURE__*/React$1.createElement(PMQrBlock, {
    className: qrBlockStl
  }, /*#__PURE__*/React$1.createElement(QrBlock, {
    qrimg: qrimage,
    qrurl: qrtext,
    className: qrStl
  })))), /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMMapBlock, {
    className: mapBlockStl
  }, /*#__PURE__*/React$1.createElement(MapBlock, {
    mapimage: mapimage,
    mapsvg: mapsvg,
    className: mapStl
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMFlexRow, {
    className: flexRowStl
  }, /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMGerbBlock, {
    className: gerbBlockStl
  }, /*#__PURE__*/React$1.createElement(GerbBlock, {
    gerbimage: gerbimage,
    headername: country,
    countryname: countryname,
    capitalname: capital,
    countrysize: countrysize,
    className: gerbStl
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMClimatBlock, {
    className: climatBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$T, {
    name: "Климат",
    body: climat,
    className: climatStl
  })), /*#__PURE__*/React$1.createElement(PMGeogrBlock, {
    className: geogrBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$T, {
    name: "Географическое положение",
    body: geographic,
    className: geogrStl
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMAnimalBlock, {
    className: animalBlockStl
  }, /*#__PURE__*/React$1.createElement(AnimalBlock, {
    className: animalStl,
    name: "Животный мир",
    image0: animal0,
    image1: animal1,
    image2: animal2,
    image3: animal3,
    image4: animal4,
    image5: animal5,
    animals: animals,
    endpoint: endpoint
  })), /*#__PURE__*/React$1.createElement(PMCurBlock, {
    className: curBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$U, {
    name: "Используемая валюта",
    body: currency,
    className: curStl
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMEconomBlock, {
    className: economBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$T, {
    name: "Экономический прогноз",
    body: economical,
    className: economStl
  })))))))));
};

var _templateObject$$, _templateObject2$$, _templateObject3$$;
var TextMainBlock$1 = styled.div(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  max-height: 100%;\n"])));
var TextHeadBlock$1 = styled.div(_templateObject2$$ || (_templateObject2$$ = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  text-align: center;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 25px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  line-height: 1;\n  letter-spacing: 3px;\n"])));
var TextBodyBlock$1 = styled.div(_templateObject3$$ || (_templateObject3$$ = _taggedTemplateLiteralLoose(["\n  font-family: 'Oranienbaum';\n  font-weight: 400;\n  margin: 5%;\n  font-size: 15px;\n  word-wrap: break-word;\n"])));
function TextBlock$V(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(TextMainBlock$1, null, /*#__PURE__*/React$1.createElement(TextHeadBlock$1, null, name), /*#__PURE__*/React$1.createElement(TextBodyBlock$1, null, body));
}

var _templateObject$10, _templateObject2$10, _templateObject3$10;
var CurMainBlock$1 = styled.div(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  max-height: 100%;\n"])));
var CurBodyBlock$1 = styled.div(_templateObject2$10 || (_templateObject2$10 = _taggedTemplateLiteralLoose(["\n  overflow: auto;\n  position: relative;\n  font-family: 'Baskerville';\n  font-style: italic;\n  letter-spacing: 4.2px;\n  font-size: 26px;\n  word-wrap: break-word;\n  text-align: center;\n  margin-top: 5.5%;\n"])));
var CurHeaderBlock$1 = styled.div(_templateObject3$10 || (_templateObject3$10 = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  text-align: center;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 25px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  line-height: 1;\n  letter-spacing: 3px;\n"])));
function CurBlock(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(CurMainBlock$1, null, /*#__PURE__*/React$1.createElement(CurHeaderBlock$1, null, name), /*#__PURE__*/React$1.createElement(CurBodyBlock$1, null, body));
}

var _templateObject$11, _templateObject2$11, _templateObject3$11, _templateObject4$X, _templateObject5$V, _templateObject6$V, _templateObject7$V;
var GerbMainFrame$1 = styled.div(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"])));
var GerbImageBlock$1 = styled.div(_templateObject2$11 || (_templateObject2$11 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 340px;\n  justify-content: center;\n  margin-top: 8%;\n  margin-bottom: 10%;\n\n  img {\n    max-width: 57%;\n    max-height: 100%;\n  }\n"])));
var GerbTextBlock$1 = styled.div(_templateObject3$11 || (_templateObject3$11 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-family: 'Corki-Tuscan';\n  font-weight: 400;\n  font-size: 20.7px;\n  padding-left: 5%;\n  padding-right: 5%;\n  line-height: 1.2;\n  letter-spacing: 1px;\n  word-wrap: break-word;\n"])));
var GerbCountryBlock$1 = styled.div(_templateObject4$X || (_templateObject4$X = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 340px;\n  height: 148px;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 50px;\n  padding-left: 10%;\n  padding-right: 10%;\n  line-height: 1;\n  letter-spacing: 1px;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var GerbTextSep$1 = styled.div(_templateObject5$V || (_templateObject5$V = _taggedTemplateLiteralLoose(["\n  padding-bottom: 1%;\n"])));
var Sep$1 = styled.div(_templateObject6$V || (_templateObject6$V = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  margin-left: 40%;\n  margin-right: 40%;\n"])));
var GerbTextNoSep$1 = styled.div(_templateObject7$V || (_templateObject7$V = _taggedTemplateLiteralLoose(["\n  margin-top: 1%;\n  margin-bottom: 7%;\n"])));
function GerbBlock$1(props) {
  var _countrysize$match;
  var gerbimage = props.gerbimage,
    headername = props.headername,
    countryname = props.countryname,
    capitalname = props.capitalname,
    countrysize = props.countrysize;
  var withCountrySize = countrysize === null || countrysize === void 0 ? void 0 : (_countrysize$match = countrysize.match(/\d/g)) === null || _countrysize$match === void 0 ? void 0 : _countrysize$match.length;
  return /*#__PURE__*/React$1.createElement(GerbMainFrame$1, null, /*#__PURE__*/React$1.createElement(GerbImageBlock$1, {
    className: "gerb_block_imageA3"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: gerbimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(GerbTextBlock$1, null, headername), /*#__PURE__*/React$1.createElement(GerbCountryBlock$1, null, countryname), /*#__PURE__*/React$1.createElement(GerbTextBlock$1, null, /*#__PURE__*/React$1.createElement(GerbTextSep$1, null, "\u0421\u0442\u043E\u043B\u0438\u0446\u0430: ", capitalname), Boolean(withCountrySize) && /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Sep$1, null), /*#__PURE__*/React$1.createElement(GerbTextNoSep$1, null, "\u0422\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F: ", countrysize))));
}

var _templateObject$12, _templateObject2$12, _templateObject3$12;
var AnimalMainBlock$1 = styled.div(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  max-height: 100%;\n"])));
var AnimalHeaderBlock$1 = styled.div(_templateObject2$12 || (_templateObject2$12 = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  text-align: center;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 25px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  line-height: 1;\n  letter-spacing: 3px;\n"])));
var AnimalBodyBlock$1 = styled.div(_templateObject3$12 || (_templateObject3$12 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 1%;\n  padding-left: 1%;\n  padding-right: 1%;\n  padding-bottom: 1%;\n  width: 340px;\n  height: 126px;\n  box-sizing: border-box;\n\n  img {\n    max-height: 70px;\n    width: 330px;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
function AnimalBlock$1(props) {
  var name = props.name,
    image = props.image;
  return /*#__PURE__*/React$1.createElement(AnimalMainBlock$1, null, /*#__PURE__*/React$1.createElement(AnimalHeaderBlock$1, null, name), /*#__PURE__*/React$1.createElement(AnimalBodyBlock$1, null, /*#__PURE__*/React$1.createElement("img", {
    src: image
  })));
}

var _templateObject$13, _templateObject2$13, _templateObject3$13;
var QrMainBlock$1 = styled.div(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"])));
var QrImageBlock$1 = styled.div(_templateObject2$13 || (_templateObject2$13 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  margin-left: 13%;\n  margin-top: 7%;\n  max-height: 100%;\n\n  img {\n    width: 75%;\n    max-height: 100%;\n  }\n"])));
var QrTextBlock$1 = styled.div(_templateObject3$13 || (_templateObject3$13 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto';\n  font-size: calc(0.67rem * 1.6);\n  margin-bottom: 5%;\n  justify-content: center;\n"])));
function QrBlock$1(props) {
  var qrimg = props.qrimg,
    qrurl = props.qrurl;
  return /*#__PURE__*/React$1.createElement(QrMainBlock$1, null, /*#__PURE__*/React$1.createElement(QrImageBlock$1, null, /*#__PURE__*/React$1.createElement("img", {
    src: qrimg
  })), /*#__PURE__*/React$1.createElement(QrTextBlock$1, null, qrurl));
}

var _templateObject$14, _templateObject2$14, _templateObject3$14;
var NumMainBlock$1 = styled.div(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var NumberTextBlock$1 = styled.div(_templateObject2$14 || (_templateObject2$14 = _taggedTemplateLiteralLoose(["\n  margin-left: 18%;\n  margin-right: 16.5%;\n  margin-bottom: 6%;\n  margin-top: 7%;\n  text-align: center;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: 56px;\n    line-height: 25px;\n    letter-spacing: 12px;\n    text-align: center;\n    z-index: 1;\n    position: relative;\n    background: white;\n    padding-left: 5%;\n    padding-right: 3%;\n  }\n\n  i {\n    position: absolute;\n    width: 620px;\n    left: 160px;\n    top: 120px;\n    border-top: 1px solid black;\n  }\n"])));
var NumberText = styled.div(_templateObject3$14 || (_templateObject3$14 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: 56px;\n    line-height: 25px;\n    letter-spacing: 10px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 60px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: 150px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: 150px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
function NumberBlock$1(props) {
  var name = props.name;
  return /*#__PURE__*/React$1.createElement(NumMainBlock$1, null, /*#__PURE__*/React$1.createElement(NumberText, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, name), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })));
}

var _templateObject$15, _templateObject2$15, _templateObject3$15, _templateObject4$Y;
var MapRelBlock$1 = styled.div(_templateObject$15 || (_templateObject$15 = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var MapImageBlock$1 = styled.div(_templateObject2$15 || (_templateObject2$15 = _taggedTemplateLiteralLoose(["\n  img {\n    width: 100%;\n    max-height: 763px;\n  }\n"])));
var MapSvgBlock$1 = styled.div(_templateObject3$15 || (_templateObject3$15 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  z-index: 9;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n"])));
var MapSvgImage$1 = styled.div(_templateObject4$Y || (_templateObject4$Y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"])));
function MapBlock$1(props) {
  var mapimage = props.mapimage,
    mapsvg = props.mapsvg;
  return /*#__PURE__*/React$1.createElement(MapRelBlock$1, null, /*#__PURE__*/React$1.createElement(MapImageBlock$1, null, /*#__PURE__*/React$1.createElement("img", {
    src: mapimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(MapSvgBlock$1, null, /*#__PURE__*/React$1.createElement(MapSvgImage$1, {
    className: "map_svg_imageA3",
    dangerouslySetInnerHTML: {
      __html: mapsvg
    }
  })));
}

var _templateObject$16, _templateObject2$16, _templateObject3$16, _templateObject4$Z, _templateObject5$W, _templateObject6$W, _templateObject7$W, _templateObject8$U, _templateObject9$U, _templateObject10$j, _templateObject11$j, _templateObject12$j, _templateObject13$j, _templateObject14$d;
var Wrapper$U = styled.div(_templateObject$16 || (_templateObject$16 = _taggedTemplateLiteralLoose(["\n  height: 420mm;\n  width: 297mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var PMMainBlock$1 = styled.div(_templateObject2$16 || (_templateObject2$16 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  padding: 45px;\n  box-sizing: border-box;\n"])));
var PMSecondBlock$1 = styled.div(_templateObject3$16 || (_templateObject3$16 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n  background: white;\n  max-height: 100%;\n  max-width: 100%;\n  border: 2px solid black;\n  box-sizing: border-box;\n"])));
var PMFlexColumn$1 = styled.div(_templateObject4$Z || (_templateObject4$Z = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n"])));
var PMFlexRow$1 = styled.div(_templateObject5$W || (_templateObject5$W = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  box-sizing: border-box;\n"])));
var PMNumberBlock$1 = styled.div(_templateObject6$W || (_templateObject6$W = _taggedTemplateLiteralLoose(["\n  width: 835px;\n  height: 190px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMQrBlock$1 = styled.div(_templateObject7$W || (_templateObject7$W = _taggedTemplateLiteralLoose(["\n  width: 190px;\n  height: 190px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMMapBlock$1 = styled.div(_templateObject8$U || (_templateObject8$U = _taggedTemplateLiteralLoose(["\n  width: 1025px;\n  height: 765px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMGerbBlock$1 = styled.div(_templateObject9$U || (_templateObject9$U = _taggedTemplateLiteralLoose(["\n  width: 342px;\n  height: 534px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMClimatBlock$1 = styled.div(_templateObject10$j || (_templateObject10$j = _taggedTemplateLiteralLoose(["\n  width: 341px;\n  height: 274px;\n  word-wrap: break-word;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMGeogrBlock$1 = styled.div(_templateObject11$j || (_templateObject11$j = _taggedTemplateLiteralLoose(["\n  width: 341px;\n  height: 260px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMEconomBlock$1 = styled.div(_templateObject12$j || (_templateObject12$j = _taggedTemplateLiteralLoose(["\n  width: 342px;\n  height: 260px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMAnimalBlock$1 = styled.div(_templateObject13$j || (_templateObject13$j = _taggedTemplateLiteralLoose(["\n  width: 342px;\n  height: 160px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMCurBlock$1 = styled.div(_templateObject14$d || (_templateObject14$d = _taggedTemplateLiteralLoose(["\n  width: 342px;\n  height: 114px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var MapCardA3 = function MapCardA3(props) {
  var num = props.num,
    gift = props.gift,
    qrimage = props.qrimage,
    qrtext = props.qrtext,
    mapimage = props.mapimage,
    mapsvg = props.mapsvg,
    gerbimage = props.gerbimage,
    country = props.country,
    countryname = props.countryname,
    capital = props.capital,
    countrysize = props.countrysize,
    climat = props.climat,
    geographic = props.geographic,
    animal = props.animal,
    currency = props.currency,
    economical = props.economical,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$U, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(PMMainBlock$1, null, /*#__PURE__*/React$1.createElement(PMSecondBlock$1, null, /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMFlexRow$1, null, /*#__PURE__*/React$1.createElement(PMNumberBlock$1, null, /*#__PURE__*/React$1.createElement(NumberBlock$1, {
    name: num,
    giftname: gift
  })), /*#__PURE__*/React$1.createElement(PMQrBlock$1, null, /*#__PURE__*/React$1.createElement(QrBlock$1, {
    qrimg: qrimage,
    qrurl: qrtext
  })))), /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMMapBlock$1, null, /*#__PURE__*/React$1.createElement(MapBlock$1, {
    mapimage: mapimage,
    mapsvg: mapsvg
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMFlexRow$1, null, /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMGerbBlock$1, null, /*#__PURE__*/React$1.createElement(GerbBlock$1, {
    gerbimage: gerbimage,
    headername: country,
    countryname: countryname,
    capitalname: capital,
    countrysize: countrysize
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMClimatBlock$1, null, /*#__PURE__*/React$1.createElement(TextBlock$V, {
    name: "\u041A\u043B\u0438\u043C\u0430\u0442",
    body: climat
  })), /*#__PURE__*/React$1.createElement(PMGeogrBlock$1, null, /*#__PURE__*/React$1.createElement(TextBlock$V, {
    name: "\u0413\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
    body: geographic
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMAnimalBlock$1, null, /*#__PURE__*/React$1.createElement(AnimalBlock$1, {
    name: "\u0416\u0438\u0432\u043E\u0442\u043D\u044B\u0439 \u043C\u0438\u0440",
    image: animal
  })), /*#__PURE__*/React$1.createElement(PMCurBlock$1, null, /*#__PURE__*/React$1.createElement(CurBlock, {
    name: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u0430\u044F \u0432\u0430\u043B\u044E\u0442\u0430",
    body: currency
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMEconomBlock$1, null, /*#__PURE__*/React$1.createElement(TextBlock$V, {
    name: "\u042D\u043A\u043E\u043D\u043E\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043F\u0440\u043E\u0433\u043D\u043E\u0437",
    body: economical
  })))))))));
};

var _templateObject$17, _templateObject2$17, _templateObject3$17;
var TextMainBlock$2 = styled.div(_templateObject$17 || (_templateObject$17 = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var TextHeadBlock$2 = styled.div(_templateObject2$17 || (_templateObject2$17 = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 18px;\n    padding-bottom: 3px;\n    padding-top: 2px;\n    line-height: 1;\n    letter-spacing: 2px;\n"])));
var TextBodyBlock$2 = styled.div(_templateObject3$17 || (_templateObject3$17 = _taggedTemplateLiteralLoose(["\n    font-family: 'Oranienbaum';\n    line-height: 12px;\n    font-weight: 400;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    margin-left: 11px;\n    margin-right: 10px;\n    font-size: 10.2px;\n    word-wrap: break-word;\n"])));
function TextBlock$W(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(TextMainBlock$2, null, /*#__PURE__*/React$1.createElement(TextHeadBlock$2, null, name), /*#__PURE__*/React$1.createElement(TextBodyBlock$2, null, body));
}

var _templateObject$18, _templateObject2$18, _templateObject3$18;
var CurMainBlock$2 = styled.div(_templateObject$18 || (_templateObject$18 = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var CurBodyBlock$2 = styled.div(_templateObject2$18 || (_templateObject2$18 = _taggedTemplateLiteralLoose(["\n    overflow: auto;\n    position: relative;\n    font-family: 'Baskerville';\n    font-style: italic;\n    letter-spacing: 3.55px;\n    font-size: 17px;\n    word-wrap: break-word;\n    text-align: center;\n    margin-top: 1%;\n    margin-bottom: 0;\n"])));
var CurHeaderBlock$2 = styled.div(_templateObject3$18 || (_templateObject3$18 = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 18px;\n    padding-bottom: 3px;\n    padding-top: 2px;\n    line-height: 1;\n    letter-spacing: 2px;\n"])));
function TextBlock$X(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(CurMainBlock$2, null, /*#__PURE__*/React$1.createElement(CurHeaderBlock$2, null, name), /*#__PURE__*/React$1.createElement(CurBodyBlock$2, null, body));
}

var _templateObject$19, _templateObject2$19, _templateObject3$19, _templateObject4$_, _templateObject5$X, _templateObject6$X, _templateObject7$X;
var GerbMainFrame$2 = styled.div(_templateObject$19 || (_templateObject$19 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n"])));
var GerbImageBlock$2 = styled.div(_templateObject2$19 || (_templateObject2$19 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 136px;\n  height: 136px;\n  justify-content: center;\n  max-height: 60%;\n  margin-top: 5.5%;\n  margin-bottom: 5%;\n  margin-right: auto;\n  margin-left: auto;\n\n  img {\n    width: 100%;\n  }\n"])));
var GerbTextBlock$2 = styled.div(_templateObject3$19 || (_templateObject3$19 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-family: 'Corki-Tuscan';\n  font-weight: 500;\n  font-size: 15.1px;\n  padding-left: 7%;\n  padding-right: 7%;\n  line-height: 1.1;\n  word-wrap: break-word;\n"])));
var GerbCountryBlock$2 = styled.div(_templateObject4$_ || (_templateObject4$_ = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 238px;\n  min-height: 103px;\n  max-height: 270px;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 35px;\n  padding: 0 10%;\n  line-height: 1;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var GerbTextSep$2 = styled.div(_templateObject5$X || (_templateObject5$X = _taggedTemplateLiteralLoose(["\n  padding-bottom: 1%;\n"])));
var Sep$2 = styled.div(_templateObject6$X || (_templateObject6$X = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  margin-left: 40%;\n  margin-right: 40%;\n"])));
var GerbTextNoSep$2 = styled.div(_templateObject7$X || (_templateObject7$X = _taggedTemplateLiteralLoose(["\n  margin-top: 1%;\n  margin-bottom: 7%;\n"])));
function GerbBlock$2(props) {
  var gerbimage = props.gerbimage,
    headername = props.headername,
    countryname = props.countryname,
    capitalname = props.capitalname;
  return /*#__PURE__*/React$1.createElement(GerbMainFrame$2, null, /*#__PURE__*/React$1.createElement(GerbImageBlock$2, {
    className: "gerb_block_imageA3"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: gerbimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(GerbTextBlock$2, null, headername), /*#__PURE__*/React$1.createElement(GerbCountryBlock$2, null, countryname), /*#__PURE__*/React$1.createElement(GerbTextBlock$2, null, /*#__PURE__*/React$1.createElement(GerbTextSep$2, null, "\u0421\u0442\u043E\u043B\u0438\u0446\u0430: ", capitalname)));
}

var _templateObject$1a, _templateObject2$1a, _templateObject3$1a, _templateObject4$$;
var AnimalMainBlock$2 = styled.div(_templateObject$1a || (_templateObject$1a = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var AnimalHeaderBlock$2 = styled.div(_templateObject2$1a || (_templateObject2$1a = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 18px;\n    padding-bottom: 3px;\n    padding-top: 2px;\n    line-height: 1;\n    letter-spacing: 2px;\n"])));
var AnimalBodyBlock$2 = styled.div(_templateObject3$1a || (_templateObject3$1a = _taggedTemplateLiteralLoose(["\n    margin: auto;\n    padding-top: 2px;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n    img{\n      max-height: 70px;\n      width: 260px;\n      object-fit: cover;\n      size: auto;\n    }\n"])));
var AnimalImageBlock$1 = styled.div(_templateObject4$$ || (_templateObject4$$ = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n    font-family: 'Noto', serif;\n    font-size: 6px;\n    font-weight: 600;\n    width: 38px;\n    height: 45px;\n    box-sizing: border-box;\n\n    img{\n      display: flex;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      size: auto;\n    }\n"])));
function AnimalBlock$2(props) {
  var name = props.name,
    animals = props.animals,
    endpoint = props.endpoint;
  return /*#__PURE__*/React$1.createElement(AnimalMainBlock$2, null, /*#__PURE__*/React$1.createElement(AnimalHeaderBlock$2, null, name), /*#__PURE__*/React$1.createElement(AnimalBodyBlock$2, null, !!(animals && animals.length) && animals.map(function (item) {
    return /*#__PURE__*/React$1.createElement(AnimalImageBlock$1, null, /*#__PURE__*/React$1.createElement("img", {
      src: endpoint + "/" + item.attachments[0].files[0].url
    }), item.attachments[0].texts);
  })));
}

var _templateObject$1b, _templateObject2$1b, _templateObject3$1b;
var QrMainBlock$2 = styled.div(_templateObject$1b || (_templateObject$1b = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n"])));
var QrImageBlock$2 = styled.div(_templateObject2$1b || (_templateObject2$1b = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 100%;\n    margin-left: 17px;\n    margin-right: 17px;\n    margin-top: 12px;\n    max-height: 100%;\n    \n    img{\n      width: 100px;\n      height: 100px;\n    }\n"])));
var QrTextBlock$2 = styled.div(_templateObject3$1b || (_templateObject3$1b = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-family: 'Roboto';\n    font-size: 0.67rem;\n    justify-content: center;\n"])));
function QrBlock$2(props) {
  var qrimg = props.qrimg,
    qrurl = props.qrurl;
  return /*#__PURE__*/React$1.createElement(QrMainBlock$2, null, /*#__PURE__*/React$1.createElement(QrImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: qrimg
  })), /*#__PURE__*/React$1.createElement(QrTextBlock$2, null, qrurl));
}

var _templateObject$1c, _templateObject2$1c, _templateObject3$1c;
var NumMainBlock$2 = styled.div(_templateObject$1c || (_templateObject$1c = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n"])));
var NumberTextBlock$2 = styled.div(_templateObject2$1c || (_templateObject2$1c = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 385px;\n    height: 30px;\n    padding-left: 15%;\n    padding-right: 16%;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n\n    span{\n      display: flex;\n      align-items: center;\n      font-family: 'Baskerville';\n      font-style: italic;\n      font-size: 24px;\n      height: 26px;\n      letter-spacing: 5px;\n      position: relative;\n      text-align: center;\n      padding-left: 5%;\n      padding-right: 5%;\n      z-index: 1;\n\n      background: white;\n      box-sizing: border-box;\n    }\n\n    i{\n      position: absolute;\n      width: 280px;\n      left: 625px;\n      top: 745px;\n      border-top: 1px solid black;\n    }\n"])));
var NumberTextGiftBlock$1 = styled.div(_templateObject3$1c || (_templateObject3$1c = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-family: 'Oranienbaum';\n    font-weight: 400;\n    font-size: 13.4px;\n    border-bottom: 1px solid black;\n    justify-content: center;\n    padding-top: 3.8%;\n    padding-bottom: 3.8%;\n"])));
function NumberBlock$2(props) {
  var name = props.name,
    giftname = props.giftname;
  return /*#__PURE__*/React$1.createElement(NumMainBlock$2, null, /*#__PURE__*/React$1.createElement(NumberTextGiftBlock$1, null, giftname), /*#__PURE__*/React$1.createElement(NumberTextBlock$2, null, /*#__PURE__*/React$1.createElement("span", null, name), /*#__PURE__*/React$1.createElement("i", null)));
}

var _templateObject$1d, _templateObject2$1d, _templateObject3$1d, _templateObject4$10;
var MapRelBlock$2 = styled.div(_templateObject$1d || (_templateObject$1d = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var MapImageBlock$2 = styled.div(_templateObject2$1d || (_templateObject2$1d = _taggedTemplateLiteralLoose([" \n  img{\n    width: 100%;\n    max-height: 595px;\n  }\n"])));
var MapSvgBlock$2 = styled.div(_templateObject3$1d || (_templateObject3$1d = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-height: 100%;\n    z-index: 9;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n"])));
var MapSvgImage$2 = styled.div(_templateObject4$10 || (_templateObject4$10 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n"])));
function MapBlock$2(props) {
  var mapimage = props.mapimage,
    mapsvg = props.mapsvg;
  return /*#__PURE__*/React$1.createElement(MapRelBlock$2, null, /*#__PURE__*/React$1.createElement(MapImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: mapimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(MapSvgBlock$2, null, /*#__PURE__*/React$1.createElement(MapSvgImage$2, {
    dangerouslySetInnerHTML: {
      __html: mapsvg
    }
  })));
}

var _templateObject$1e, _templateObject2$1e, _templateObject3$1e, _templateObject4$11, _templateObject5$Y, _templateObject6$Y, _templateObject7$Y, _templateObject8$V, _templateObject9$V, _templateObject10$k, _templateObject11$k, _templateObject12$k, _templateObject13$k, _templateObject14$e;
var Wrapper$V = styled.div(_templateObject$1e || (_templateObject$1e = _taggedTemplateLiteralLoose(["\n    height: 210mm;\n    width: 297mm;\n    transform: scale(calc(", "/297), calc(", "/210));\n    transform-origin: left top;\n    user-select: none;\n    box-sizing: border-box;\n    "])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var PMMainBlock$2 = styled.div(_templateObject2$1e || (_templateObject2$1e = _taggedTemplateLiteralLoose(["\n    padding-left: 28px;\n    padding-right: 26px;\n    padding-top: 29px;\n    padding-bottom: 33px;\n\n    //box-sizing: border-box;\n"])));
var PMSecondBlock$2 = styled.div(_templateObject3$1e || (_templateObject3$1e = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    padding: 2px;\n    background: white;\n    height: 100%;\n    width: 100%;\n    border: 2px solid black;\n    box-sizing: border-box;\n"])));
var PMFlexColumn$2 = styled.div(_templateObject4$11 || (_templateObject4$11 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n"])));
var PMFlexRow$2 = styled.div(_templateObject5$Y || (_templateObject5$Y = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n"])));
var PMNumberBlock$2 = styled.div(_templateObject6$Y || (_templateObject6$Y = _taggedTemplateLiteralLoose(["\n    height: 80px;\n    width: 387px;\n    border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMQrBlock$2 = styled.div(_templateObject7$Y || (_templateObject7$Y = _taggedTemplateLiteralLoose(["\n    height: 135px;\n    width: 135px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMMapBlock$2 = styled.div(_templateObject8$V || (_templateObject8$V = _taggedTemplateLiteralLoose(["\n    width: 794px;\n    height: 595px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMGerbBlock$2 = styled.div(_templateObject9$V || (_templateObject9$V = _taggedTemplateLiteralLoose(["\n    height: 367px;\n    width: 267px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMClimatBlock$2 = styled.div(_templateObject10$k || (_templateObject10$k = _taggedTemplateLiteralLoose(["\n    height: 127px;\n    width: 267px;\n    word-wrap: break-word;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMGeogrBlock$2 = styled.div(_templateObject11$k || (_templateObject11$k = _taggedTemplateLiteralLoose(["\n    height: 135px;\n    width: 267px;\n    border: 1px solid black;\n    word-wrap: break-word;\n    box-sizing: border-box;\n"])));
var PMEconomBlock$2 = styled.div(_templateObject12$k || (_templateObject12$k = _taggedTemplateLiteralLoose(["\n    height: 135px;\n    width: 272px;\n    border: 1px solid black;\n    word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var PMAnimalBlock$2 = styled.div(_templateObject13$k || (_templateObject13$k = _taggedTemplateLiteralLoose(["\n    height: 101px;\n    width: 267px;\n    border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMCurBlock$2 = styled.div(_templateObject14$e || (_templateObject14$e = _taggedTemplateLiteralLoose(["\n    height: 55px;\n    width: 387px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var MapCardA4L = function MapCardA4L(props) {
  var num = props.num,
    gift = props.gift,
    qrimage = props.qrimage,
    qrtext = props.qrtext,
    mapimage = props.mapimage,
    mapsvg = props.mapsvg,
    gerbimage = props.gerbimage,
    country = props.country,
    countryname = props.countryname,
    capital = props.capital,
    countrysize = props.countrysize,
    climat = props.climat,
    geographic = props.geographic,
    animal = props.animal,
    currency = props.currency,
    economical = props.economical,
    dw = props.dw,
    dh = props.dh,
    externalStyles = props.externalStyles;
  var _ref = externalStyles || {},
    wrapStl = _ref.wrapStl,
    blockStl = _ref.blockStl,
    secondBlockStl = _ref.secondBlockStl,
    flexColumnStl = _ref.flexColumnStl,
    flexRowStl = _ref.flexRowStl,
    numberBlockStl = _ref.numberBlockStl,
    numberStl = _ref.numberStl,
    qrBlockStl = _ref.qrBlockStl,
    qrStl = _ref.qrStl,
    mapBlockStl = _ref.mapBlockStl,
    mapStl = _ref.mapStl,
    gerbBlockStl = _ref.gerbBlockStl,
    gerbStl = _ref.gerbStl,
    climatBlockStl = _ref.climatBlockStl,
    climatStl = _ref.climatStl,
    geogrBlockStl = _ref.geogrBlockStl,
    geogrStl = _ref.geogrStl,
    animalBlockStl = _ref.animalBlockStl,
    animalStl = _ref.animalStl,
    curBlockStl = _ref.curBlockStl,
    curStl = _ref.curStl,
    economBlockStl = _ref.economBlockStl,
    economStl = _ref.economStl;
  var services = props.services,
    endpoint = props.endpoint;
  var animals = getAnimals({
    services: services
  });
  return /*#__PURE__*/React$1.createElement(Wrapper$V, {
    dw: dw,
    dh: dh,
    className: wrapStl
  }, /*#__PURE__*/React$1.createElement(PMMainBlock$2, {
    className: blockStl
  }, /*#__PURE__*/React$1.createElement(PMSecondBlock$2, {
    className: secondBlockStl
  }, /*#__PURE__*/React$1.createElement(PMFlexRow$2, {
    className: flexRowStl
  }, /*#__PURE__*/React$1.createElement(PMFlexColumn$2, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMGerbBlock$2, {
    className: gerbBlockStl
  }, /*#__PURE__*/React$1.createElement(GerbBlock$2, {
    gerbimage: gerbimage,
    headername: country,
    countryname: countryname,
    capitalname: capital,
    countrysize: countrysize,
    className: gerbStl
  })), /*#__PURE__*/React$1.createElement(PMClimatBlock$2, {
    className: climatBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$W, {
    name: "Климат",
    body: climat,
    className: climatStl
  })), /*#__PURE__*/React$1.createElement(PMAnimalBlock$2, {
    className: animalBlockStl
  }, /*#__PURE__*/React$1.createElement(AnimalBlock$2, {
    name: "Животный мир",
    image: animal,
    className: animalStl,
    endpoint: endpoint,
    animals: animals
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$2, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMMapBlock$2, {
    className: mapBlockStl
  }, /*#__PURE__*/React$1.createElement(MapBlock$2, {
    mapimage: mapimage,
    mapsvg: mapsvg,
    className: mapStl
  })))), /*#__PURE__*/React$1.createElement(PMFlexRow$2, {
    className: flexRowStl
  }, /*#__PURE__*/React$1.createElement(PMGeogrBlock$2, {
    className: geogrBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$W, {
    name: "Географическое положение",
    body: geographic,
    className: geogrStl
  })), /*#__PURE__*/React$1.createElement(PMEconomBlock$2, {
    className: economBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$W, {
    name: "Экономичсекий прогноз",
    body: economical,
    className: economStl
  })), /*#__PURE__*/React$1.createElement(PMFlexColumn$2, null, /*#__PURE__*/React$1.createElement(PMCurBlock$2, {
    className: curBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$X, {
    name: "Используемая валюта",
    body: currency,
    className: curStl
  })), /*#__PURE__*/React$1.createElement(PMNumberBlock$2, {
    className: numberBlockStl
  }, /*#__PURE__*/React$1.createElement(NumberBlock$2, {
    name: num,
    giftname: gift,
    className: numberStl
  }))), /*#__PURE__*/React$1.createElement(PMQrBlock$2, {
    className: qrBlockStl
  }, /*#__PURE__*/React$1.createElement(QrBlock$2, {
    qrimg: qrimage,
    qrurl: qrtext,
    className: qrStl
  }))))));
};

var _templateObject$1f, _templateObject2$1f, _templateObject3$1f;
var TextMainBlock$3 = styled.div(_templateObject$1f || (_templateObject$1f = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  max-width: 100%;\n  max-height: 100%;\n"])));
var TextHeadBlock$3 = styled.div(_templateObject2$1f || (_templateObject2$1f = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  text-align: center;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 25px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  line-height: 1;\n  letter-spacing: 3px;\n"])));
var TextBodyBlock$3 = styled.div(_templateObject3$1f || (_templateObject3$1f = _taggedTemplateLiteralLoose(["\n  font-family: 'Noto';\n  font-weight: 400;\n  margin-top: 13px;\n  margin-bottom: 14px;\n  margin-left: 13px;\n  margin-right: 10px;\n  font-size: 12px;\n  word-wrap: break-word;\n"])));
function TextBlock$Y(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(TextMainBlock$3, null, /*#__PURE__*/React$1.createElement(TextHeadBlock$3, null, name), /*#__PURE__*/React$1.createElement(TextBodyBlock$3, null, body));
}

var _templateObject$1g, _templateObject2$1g, _templateObject3$1g;
var CurMainBlock$3 = styled.div(_templateObject$1g || (_templateObject$1g = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var CurBodyBlock$3 = styled.div(_templateObject2$1g || (_templateObject2$1g = _taggedTemplateLiteralLoose(["\n    overflow: auto;\n    position: relative;\n    font-family: 'Baskerville';\n    font-style: italic;\n    letter-spacing: 6px;\n    font-size: 22.3px;\n    word-wrap: break-word;\n    text-align: center;\n    margin-top: 1.5%;\n"])));
var CurHeaderBlock$3 = styled.div(_templateObject3$1g || (_templateObject3$1g = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 25px;\n    padding-bottom: 4px;\n    padding-top: 4px;\n    line-height: 1;\n    letter-spacing: 3px;\n"])));
function TextBlock$Z(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(CurMainBlock$3, null, /*#__PURE__*/React$1.createElement(CurHeaderBlock$3, null, name), /*#__PURE__*/React$1.createElement(CurBodyBlock$3, null, body));
}

var _templateObject$1h, _templateObject2$1h, _templateObject3$1h, _templateObject4$12, _templateObject5$Z;
var GerbMainFrame$3 = styled.div(_templateObject$1h || (_templateObject$1h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  max-height: 100%;\n"])));
var GerbImageBlock$3 = styled.div(_templateObject2$1h || (_templateObject2$1h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  width: 374px;\n  max-height: 60%;\n  margin-top: 5.5%;\n  margin-bottom: 4%;\n\n  img {\n    width: 57%;\n    max-height: 100%;\n  }\n"])));
var GerbTextBlock$3 = styled.div(_templateObject3$1h || (_templateObject3$1h = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-family: 'Corki-Tuscan';\n  font-weight: 400;\n  font-size: 22px;\n  padding-left: 10%;\n  padding-right: 10%;\n  line-height: 1;\n  word-wrap: break-word;\n"])));
var GerbCountryBlock$3 = styled.div(_templateObject4$12 || (_templateObject4$12 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 374px;\n  height: 190px;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 50px;\n  padding-bottom: 2.6%;\n  padding-top: 0.5%;\n  padding-left: 5%;\n  padding-right: 5%;\n  margin: auto;\n  line-height: 1;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var GerbTextSep$3 = styled.div(_templateObject5$Z || (_templateObject5$Z = _taggedTemplateLiteralLoose(["\n  padding-bottom: 1%;\n"])));
function GerbBlock$3(props) {
  var gerbimage = props.gerbimage,
    headername = props.headername,
    countryname = props.countryname,
    capitalname = props.capitalname;
  return /*#__PURE__*/React$1.createElement(GerbMainFrame$3, null, /*#__PURE__*/React$1.createElement(GerbImageBlock$3, {
    className: "gerb_block_imageA3"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: gerbimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(GerbTextBlock$3, null, headername), /*#__PURE__*/React$1.createElement(GerbCountryBlock$3, null, countryname), /*#__PURE__*/React$1.createElement(GerbTextBlock$3, null, /*#__PURE__*/React$1.createElement(GerbTextSep$3, null, "\u0421\u0442\u043E\u043B\u0438\u0446\u0430: ", capitalname)));
}

var _templateObject$1i, _templateObject2$1i, _templateObject3$1i;
var AnimalMainBlock$3 = styled.div(_templateObject$1i || (_templateObject$1i = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var AnimalHeaderBlock$3 = styled.div(_templateObject2$1i || (_templateObject2$1i = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 25px;\n    padding-bottom: 4px;\n    padding-top: 4px;\n    line-height: 1;\n    letter-spacing: 2px;\n"])));
var AnimalBodyBlock$3 = styled.div(_templateObject3$1i || (_templateObject3$1i = _taggedTemplateLiteralLoose(["\n    margin: auto;\n    padding-top: 2px;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n    img{\n      max-height: 100px;\n      width: 369px;\n      object-fit: cover;\n      size: auto;\n    }\n"])));
function AnimalBlock$3(props) {
  var name = props.name,
    image = props.image;
  return /*#__PURE__*/React$1.createElement(AnimalMainBlock$3, null, /*#__PURE__*/React$1.createElement(AnimalHeaderBlock$3, null, name), /*#__PURE__*/React$1.createElement(AnimalBodyBlock$3, null, /*#__PURE__*/React$1.createElement("img", {
    src: image
  })));
}

var _templateObject$1j, _templateObject2$1j, _templateObject3$1j;
var QrMainBlock$3 = styled.div(_templateObject$1j || (_templateObject$1j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"])));
var QrImageBlock$3 = styled.div(_templateObject2$1j || (_templateObject2$1j = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  padding-left: 12%;\n  padding-top: 8%;\n  max-height: 100%;\n\n  img {\n    width: 140px;\n    height: 140px;\n  }\n"])));
var QrTextBlock$3 = styled.div(_templateObject3$1j || (_templateObject3$1j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto';\n  font-size: calc(0.67rem * 1.5);\n  justify-content: center;\n"])));
function QrBlock$3(props) {
  var qrimg = props.qrimg,
    qrurl = props.qrurl;
  return /*#__PURE__*/React$1.createElement(QrMainBlock$3, null, /*#__PURE__*/React$1.createElement(QrImageBlock$3, null, /*#__PURE__*/React$1.createElement("img", {
    src: qrimg
  })), /*#__PURE__*/React$1.createElement(QrTextBlock$3, null, qrurl));
}

var _templateObject$1k, _templateObject2$1k, _templateObject3$1k;
var NumMainBlock$3 = styled.div(_templateObject$1k || (_templateObject$1k = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var NumberTextGiftBlock$2 = styled.div(_templateObject2$1k || (_templateObject2$1k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1 1 60%;\n  font-family: 'Oranienbaum';\n  font-weight: 400;\n  font-size: 20px;\n  border-bottom: 1px solid black;\n  justify-content: center;\n  align-items: center;\n"])));
var NumberText$1 = styled.div(_templateObject3$1k || (_templateObject3$1k = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex: 1 1 40%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: 32px;\n    line-height: 25px;\n    letter-spacing: 7.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 35px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: 86px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: 86px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
function NumberBlock$3(props) {
  var name = props.name,
    giftname = props.giftname;
  return /*#__PURE__*/React$1.createElement(NumMainBlock$3, null, /*#__PURE__*/React$1.createElement(NumberTextGiftBlock$2, null, giftname), /*#__PURE__*/React$1.createElement(NumberText$1, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, name), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })));
}

var _templateObject$1l, _templateObject2$1l, _templateObject3$1l, _templateObject4$13;
var MapRelBlock$3 = styled.div(_templateObject$1l || (_templateObject$1l = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var MapImageBlock$3 = styled.div(_templateObject2$1l || (_templateObject2$1l = _taggedTemplateLiteralLoose(["\n  img{\n    width: 1111px;\n    height: 834px;\n  }\n"])));
var MapSvgBlock$3 = styled.div(_templateObject3$1l || (_templateObject3$1l = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-height: 100%;\n    z-index: 9;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n"])));
var MapSvgImage$3 = styled.div(_templateObject4$13 || (_templateObject4$13 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n"])));
function MapBlock$3(props) {
  var mapimage = props.mapimage,
    mapsvg = props.mapsvg;
  return /*#__PURE__*/React$1.createElement(MapRelBlock$3, null, /*#__PURE__*/React$1.createElement(MapImageBlock$3, null, /*#__PURE__*/React$1.createElement("img", {
    src: mapimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(MapSvgBlock$3, null, /*#__PURE__*/React$1.createElement(MapSvgImage$3, {
    dangerouslySetInnerHTML: {
      __html: mapsvg
    }
  })));
}

var _templateObject$1m, _templateObject2$1m, _templateObject3$1m, _templateObject4$14, _templateObject5$_, _templateObject6$Z, _templateObject7$Z, _templateObject8$W, _templateObject9$W, _templateObject10$l, _templateObject11$l, _templateObject12$l, _templateObject13$l, _templateObject14$f;
var Wrapper$W = styled.div(_templateObject$1m || (_templateObject$1m = _taggedTemplateLiteralLoose(["\n  height: 297mm;\n  width: 420mm;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var PMMainBlock$3 = styled.div(_templateObject2$1m || (_templateObject2$1m = _taggedTemplateLiteralLoose(["\n  padding: 45px;\n  height: 297mm;\n  width: 420mm;\n  box-sizing: border-box;\n"])));
var PMSecondBlock$3 = styled.div(_templateObject3$1m || (_templateObject3$1m = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n  background: white;\n  height: 100%;\n  width: 100%;\n  border: 3px solid black;\n  box-sizing: border-box;\n"])));
var PMFlexColumn$3 = styled.div(_templateObject4$14 || (_templateObject4$14 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n"])));
var PMFlexRow$3 = styled.div(_templateObject5$_ || (_templateObject5$_ = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"])));
var PMNumberBlock$3 = styled.div(_templateObject6$Z || (_templateObject6$Z = _taggedTemplateLiteralLoose(["\n  height: 109px;\n  width: 544px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMQrBlock$3 = styled.div(_templateObject7$Z || (_templateObject7$Z = _taggedTemplateLiteralLoose(["\n  height: 187px;\n  width: 187px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMMapBlock$3 = styled.div(_templateObject8$W || (_templateObject8$W = _taggedTemplateLiteralLoose(["\n  width: 1113px;\n  height: 836px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMGerbBlock$3 = styled.div(_templateObject9$W || (_templateObject9$W = _taggedTemplateLiteralLoose(["\n  height: 518px;\n  width: 374px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMClimatBlock$3 = styled.div(_templateObject10$l || (_templateObject10$l = _taggedTemplateLiteralLoose(["\n  height: 178px;\n  width: 374px;\n  word-wrap: break-word;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMGeogrBlock$3 = styled.div(_templateObject11$l || (_templateObject11$l = _taggedTemplateLiteralLoose(["\n  height: 187px;\n  width: 374px;\n  border: 1px solid black;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var PMEconomBlock$3 = styled.div(_templateObject12$l || (_templateObject12$l = _taggedTemplateLiteralLoose(["\n  height: 187px;\n  width: 382px;\n  border: 1px solid black;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var PMAnimalBlock$3 = styled.div(_templateObject13$l || (_templateObject13$l = _taggedTemplateLiteralLoose(["\n  height: 140px;\n  width: 374px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMCurBlock$3 = styled.div(_templateObject14$f || (_templateObject14$f = _taggedTemplateLiteralLoose(["\n  height: 78px;\n  width: 544px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var MapCardA3L = function MapCardA3L(props) {
  var num = props.num,
    gift = props.gift,
    qrimage = props.qrimage,
    qrtext = props.qrtext,
    mapimage = props.mapimage,
    mapsvg = props.mapsvg,
    gerbimage = props.gerbimage,
    country = props.country,
    countryname = props.countryname,
    capital = props.capital,
    countrysize = props.countrysize,
    climat = props.climat,
    geographic = props.geographic,
    animal = props.animal,
    currency = props.currency,
    economical = props.economical,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$W, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(PMMainBlock$3, null, /*#__PURE__*/React$1.createElement(PMSecondBlock$3, null, /*#__PURE__*/React$1.createElement(PMFlexRow$3, null, /*#__PURE__*/React$1.createElement(PMFlexColumn$3, null, /*#__PURE__*/React$1.createElement(PMGerbBlock$3, null, /*#__PURE__*/React$1.createElement(GerbBlock$3, {
    gerbimage: gerbimage,
    headername: country,
    countryname: countryname,
    capitalname: capital,
    countrysize: countrysize
  })), /*#__PURE__*/React$1.createElement(PMClimatBlock$3, null, /*#__PURE__*/React$1.createElement(TextBlock$Y, {
    name: "\u041A\u043B\u0438\u043C\u0430\u0442",
    body: climat
  })), /*#__PURE__*/React$1.createElement(PMAnimalBlock$3, null, /*#__PURE__*/React$1.createElement(AnimalBlock$3, {
    name: "\u0416\u0438\u0432\u043E\u0442\u043D\u044B\u0439 \u043C\u0438\u0440",
    image: animal
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$3, null, /*#__PURE__*/React$1.createElement(PMMapBlock$3, null, /*#__PURE__*/React$1.createElement(MapBlock$3, {
    mapimage: mapimage,
    mapsvg: mapsvg
  })))), /*#__PURE__*/React$1.createElement(PMFlexRow$3, null, /*#__PURE__*/React$1.createElement(PMGeogrBlock$3, null, /*#__PURE__*/React$1.createElement(TextBlock$Y, {
    name: "\u0413\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
    body: geographic
  })), /*#__PURE__*/React$1.createElement(PMEconomBlock$3, null, /*#__PURE__*/React$1.createElement(TextBlock$Y, {
    name: "\u042D\u043A\u043E\u043D\u043E\u043C\u0438\u0447\u0441\u0435\u043A\u0438\u0439 \u043F\u0440\u043E\u0433\u043D\u043E\u0437",
    body: economical
  })), /*#__PURE__*/React$1.createElement(PMFlexColumn$3, null, /*#__PURE__*/React$1.createElement(PMCurBlock$3, null, /*#__PURE__*/React$1.createElement(TextBlock$Z, {
    name: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u0430\u044F \u0432\u0430\u043B\u044E\u0442\u0430",
    body: currency
  })), /*#__PURE__*/React$1.createElement(PMNumberBlock$3, null, /*#__PURE__*/React$1.createElement(NumberBlock$3, {
    name: num,
    giftname: gift
  }))), /*#__PURE__*/React$1.createElement(PMQrBlock$3, null, /*#__PURE__*/React$1.createElement(QrBlock$3, {
    qrimg: qrimage,
    qrurl: qrtext
  }))))));
};

var _templateObject$1n, _templateObject2$1n, _templateObject3$1n;
var TextMainBlock$4 = styled.div(_templateObject$1n || (_templateObject$1n = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var TextHeadBlock$4 = styled.div(_templateObject2$1n || (_templateObject2$1n = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 25px;\n    padding-bottom: 5px;\n    padding-top: 6px;\n    line-height: 1;\n    letter-spacing: 3.5px;\n"])));
var TextBodyBlock$4 = styled.div(_templateObject3$1n || (_templateObject3$1n = _taggedTemplateLiteralLoose(["\n    font-family: 'Noto';\n    font-weight: 400;\n    margin-top: 10px;\n    margin-bottom: 14px;\n    margin-left: 14px;\n    margin-right: 10px;\n    font-size: calc(9.2px * 1.50);\n    word-wrap: break-word;\n"])));
function TextBlock$_(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(TextMainBlock$4, null, /*#__PURE__*/React$1.createElement(TextHeadBlock$4, null, name), /*#__PURE__*/React$1.createElement(TextBodyBlock$4, null, body));
}

var _templateObject$1o, _templateObject2$1o, _templateObject3$1o;
var CurMainBlock$4 = styled.div(_templateObject$1o || (_templateObject$1o = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var CurBodyBlock$4 = styled.div(_templateObject2$1o || (_templateObject2$1o = _taggedTemplateLiteralLoose(["\n    overflow: auto;\n    position: relative;\n    font-family: 'Baskerville';\n    font-style: italic;\n    letter-spacing: 5.8px;\n    font-size: 22.3px;\n    word-wrap: break-word;\n    text-align: center;\n    margin-top: 0.35%;\n    font-weight: normal;\n"])));
var CurHeaderBlock$4 = styled.div(_templateObject3$1o || (_templateObject3$1o = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 25px;\n    padding-bottom: 5px;\n    padding-top: 6px;\n    line-height: 1;\n    letter-spacing: 3.5px;\n"])));
function TextBlock$$(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(CurMainBlock$4, null, /*#__PURE__*/React$1.createElement(CurHeaderBlock$4, null, name), /*#__PURE__*/React$1.createElement(CurBodyBlock$4, null, body));
}

var _templateObject$1p, _templateObject2$1p, _templateObject3$1p, _templateObject4$15, _templateObject5$$, _templateObject6$_, _templateObject7$_, _templateObject8$X;
var GerbMainFrame$4 = styled.div(_templateObject$1p || (_templateObject$1p = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    max-width: 100%;\n    max-height: 100%;\n"])));
var GerbImageBlock$4 = styled.div(_templateObject2$1p || (_templateObject2$1p = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 75%;\n    max-height: 60%;\n    margin-top: 32.3%;\n    margin-right: 3%;\n    margin-bottom: 13.1%;\n\n    img{\n      width: 100%;\n      max-height: 100%;\n    }\n"])));
var GerbTextBlock$4 = styled.div(_templateObject3$1p || (_templateObject3$1p = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    font-family: 'Corki-Tuscan';\n    font-weight: normal;\n    letter-spacing: 0.8px;\n    font-size: 22.5px;\n    padding-left: 10%;\n    padding-right: 10%;\n    margin-right: 0.5%;\n    line-height: 1.2;\n    word-wrap: break-word;\n"])));
var GerbTextBlockBottom = styled.div(_templateObject4$15 || (_templateObject4$15 = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    font-family: 'Corki-Tuscan';\n    font-weight: normal;\n    letter-spacing: 1px;\n    font-size: 23.7px;\n    padding-left: 8%;\n    padding-right: 8%;\n    line-height: 1.2;\n    margin-left: 1.5%;\n    word-wrap: break-word;\n"])));
var GerbCountryBlock$4 = styled.div(_templateObject5$$ || (_templateObject5$$ = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 320px;\n    height: 172px;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 54px;\n    letter-spacing: 1.5px;\n    padding-bottom: 2.6%;\n    padding-top: 0.5%;\n    padding-left: 1%;\n    padding-right: 1%;\n    line-height: 1.1;\n    word-wrap: break-word;\n"])));
var GerbTextSep$4 = styled.div(_templateObject6$_ || (_templateObject6$_ = _taggedTemplateLiteralLoose(["\n  padding-bottom: 1%;\n"])));
var Sep$3 = styled.div(_templateObject7$_ || (_templateObject7$_ = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    margin-left: 40%;\n    margin-right: 40%;\n"])));
var GerbTextNoSep$3 = styled.div(_templateObject8$X || (_templateObject8$X = _taggedTemplateLiteralLoose(["\n    margin-top: 1%;\n    margin-bottom: 7%;\n"])));
function GerbBlock$4(props) {
  var gerbimage = props.gerbimage,
    headername = props.headername,
    countryname = props.countryname,
    capitalname = props.capitalname;
  return /*#__PURE__*/React$1.createElement(GerbMainFrame$4, null, /*#__PURE__*/React$1.createElement(GerbImageBlock$4, {
    className: "gerb_block_imageA3"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: gerbimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(GerbTextBlock$4, null, headername), /*#__PURE__*/React$1.createElement(GerbCountryBlock$4, null, countryname), /*#__PURE__*/React$1.createElement(GerbTextBlockBottom, null, /*#__PURE__*/React$1.createElement(GerbTextSep$4, null, "\u0421\u0442\u043E\u043B\u0438\u0446\u0430: ", capitalname)));
}

var _templateObject$1q, _templateObject2$1q, _templateObject3$1q, _templateObject4$16;
var AnimalMainBlock$4 = styled.div(_templateObject$1q || (_templateObject$1q = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var AnimalHeaderBlock$4 = styled.div(_templateObject2$1q || (_templateObject2$1q = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 25px;\n    padding-bottom: 5px;\n    padding-top: 6px;\n    line-height: 1;\n    letter-spacing: 3.5px;\n"])));
var AnimalBodyBlock$4 = styled.div(_templateObject3$1q || (_templateObject3$1q = _taggedTemplateLiteralLoose(["\n    display: flex;\n    margin: auto;\n    width: 100%;\n    height: 133px;\n    justify-content: center;\n    align-items: center;\n"])));
var AnimalImageBlock$2 = styled.div(_templateObject4$16 || (_templateObject4$16 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n    font-family: 'Noto', serif;\n    font-size: 9px;\n    font-weight: 600;\n    width: 70px;\n    height: 80px;\n\n    img{\n      display: flex;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      size: auto;\n    }\n\n"])));
function AnimalBlock$4(props) {
  var name = props.name,
    image0 = props.image0,
    image1 = props.image1,
    image2 = props.image2,
    image3 = props.image3,
    image4 = props.image4,
    image5 = props.image5;
  return /*#__PURE__*/React$1.createElement(AnimalMainBlock$4, null, /*#__PURE__*/React$1.createElement(AnimalHeaderBlock$4, null, name), /*#__PURE__*/React$1.createElement(AnimalBodyBlock$4, null, /*#__PURE__*/React$1.createElement(AnimalImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image0
  }), "\u0420\u044B\u0431\u0430"), /*#__PURE__*/React$1.createElement(AnimalImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image1
  }), "\u041A\u0440\u043E\u043B\u0438\u043A"), /*#__PURE__*/React$1.createElement(AnimalImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image2
  }), "\u0421\u0442\u0440\u0430\u0443\u0441"), /*#__PURE__*/React$1.createElement(AnimalImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image3
  }), "\u042F\u0449\u0435\u0440\u0438\u0446\u0430"), /*#__PURE__*/React$1.createElement(AnimalImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image4
  }), "\u0410\u043A\u0443\u043B\u0430"), /*#__PURE__*/React$1.createElement(AnimalImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image5
  }), "\u0422\u044E\u043B\u0435\u043D\u044C")));
}

var _templateObject$1r, _templateObject2$1r, _templateObject3$1r;
var QrMainBlock$4 = styled.div(_templateObject$1r || (_templateObject$1r = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n"])));
var QrImageBlock$4 = styled.div(_templateObject2$1r || (_templateObject2$1r = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 100%;\n    margin-left: 12%;\n    margin-top: 10%;\n    max-height: 100%;\n    \n    img{\n      width: 138px;\n      height: 138px;\n    }\n"])));
var QrTextBlock$4 = styled.div(_templateObject3$1r || (_templateObject3$1r = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-family: 'Roboto';\n    font-size: calc(0.67rem * 1.50);\n    justify-content: center;\n"])));
function QrBlock$4(props) {
  var qrimg = props.qrimg,
    qrurl = props.qrurl;
  return /*#__PURE__*/React$1.createElement(QrMainBlock$4, null, /*#__PURE__*/React$1.createElement(QrImageBlock$4, null, /*#__PURE__*/React$1.createElement("img", {
    src: qrimg
  })), /*#__PURE__*/React$1.createElement(QrTextBlock$4, null, qrurl));
}

var _templateObject$1s, _templateObject2$1s, _templateObject3$1s;
var NumMainBlock$4 = styled.div(_templateObject$1s || (_templateObject$1s = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n"])));
var NumberTextBlock$3 = styled.div(_templateObject2$1s || (_templateObject2$1s = _taggedTemplateLiteralLoose(["\n  margin-left: 16%;\n  margin-right: 17%;\n  margin-bottom: 0%;\n  margin-top: 0.3%;\n  text-align: center;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: 32.5px;\n    letter-spacing: 7.5px;\n    position: relative;\n    text-align: center;\n    z-index: 1;\n    background: #ffffff;\n    padding-left: 6%;\n    padding-right: 6%;\n\n  }\n\n  i {\n    position: absolute;\n    width: 435px;\n    left: 1384px;\n    top: 1469px;\n    border-top: 1px solid black;\n  }\n"])));
var NumberTextGiftBlock$3 = styled.div(_templateObject3$1s || (_templateObject3$1s = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-family: 'Oranienbaum';\n    font-size: 20px;\n    font-weight: normal;\n    border-bottom: 1px solid black;\n    justify-content: center;\n    padding-top: 2.1%;\n    padding-bottom: 2.1%;\n"])));
function NumberBlock$4(props) {
  var name = props.name,
    giftname = props.giftname;
  return /*#__PURE__*/React$1.createElement(NumMainBlock$4, null, /*#__PURE__*/React$1.createElement(NumberTextGiftBlock$3, null, giftname), /*#__PURE__*/React$1.createElement(NumberTextBlock$3, null, /*#__PURE__*/React$1.createElement("span", null, name), /*#__PURE__*/React$1.createElement("i", null)));
}

var _templateObject$1t, _templateObject2$1t, _templateObject3$1t, _templateObject4$17;
var MapRelBlock$4 = styled.div(_templateObject$1t || (_templateObject$1t = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var MapImageBlock$4 = styled.div(_templateObject2$1t || (_templateObject2$1t = _taggedTemplateLiteralLoose(["\n  img{\n    width: 1662px;\n    height: 1244px;\n    box-sizing: border-box;\n  }\n"])));
var MapSvgBlock$4 = styled.div(_templateObject3$1t || (_templateObject3$1t = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-height: 100%;\n    z-index: 9;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n"])));
var MapSvgImage$4 = styled.div(_templateObject4$17 || (_templateObject4$17 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n"])));
function MapBlock$4(props) {
  var mapimage = props.mapimage,
    mapsvg = props.mapsvg;
  return /*#__PURE__*/React$1.createElement(MapRelBlock$4, null, /*#__PURE__*/React$1.createElement(MapImageBlock$4, null, /*#__PURE__*/React$1.createElement("img", {
    src: mapimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(MapSvgBlock$4, null, /*#__PURE__*/React$1.createElement(MapSvgImage$4, {
    dangerouslySetInnerHTML: {
      __html: mapsvg
    }
  })));
}

var _templateObject$1u, _templateObject2$1u, _templateObject3$1u, _templateObject4$18, _templateObject5$10, _templateObject6$$, _templateObject7$$, _templateObject8$Y, _templateObject9$X, _templateObject10$m, _templateObject11$m, _templateObject12$m, _templateObject13$m, _templateObject14$g;
var Wrapper$X = styled.div(_templateObject$1u || (_templateObject$1u = _taggedTemplateLiteralLoose(["\n  height: 420mm;\n  width: 594mm;\n  transform: scale(calc(", " / 594), calc(", " / 420));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  border: 1px solid black;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var PMMainBlock$4 = styled.div(_templateObject2$1u || (_templateObject2$1u = _taggedTemplateLiteralLoose(["\n  padding-top: 62px;\n  padding-left: 60px;\n  padding-right: 82px;\n  padding-bottom: 80px;\n  height: 419.7mm;\n  width: 594mm;\n  box-sizing: border-box;\n"])));
var PMSecondBlock$4 = styled.div(_templateObject3$1u || (_templateObject3$1u = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding: 4px;\n  background: white;\n  height: 100%;\n  width: 100%;\n  border: 3px solid black;\n  box-sizing: border-box;\n\n"])));
var PMFlexColumn$4 = styled.div(_templateObject4$18 || (_templateObject4$18 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n"])));
var PMFlexRow$4 = styled.div(_templateObject5$10 || (_templateObject5$10 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  box-sizing: border-box;\n"])));
var PMNumberBlock$4 = styled.div(_templateObject6$$ || (_templateObject6$$ = _taggedTemplateLiteralLoose(["\n  height: 110px;\n  width: 742px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMQrBlock$4 = styled.div(_templateObject7$$ || (_templateObject7$$ = _taggedTemplateLiteralLoose(["\n  height: 184px;\n  width: 185px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMMapBlock$4 = styled.div(_templateObject8$Y || (_templateObject8$Y = _taggedTemplateLiteralLoose(["\n  width: 1664px;\n  height: 1246px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMGerbBlock$4 = styled.div(_templateObject9$X || (_templateObject9$X = _taggedTemplateLiteralLoose(["\n  height: 876px;\n  width: 424px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMClimatBlock$4 = styled.div(_templateObject10$m || (_templateObject10$m = _taggedTemplateLiteralLoose(["\n  height: 185px;\n  width: 424px;\n  word-wrap: break-word;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMGeogrBlock$4 = styled.div(_templateObject11$m || (_templateObject11$m = _taggedTemplateLiteralLoose(["\n  height: 184px;\n  width: 424px;\n  border: 1px solid black;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var PMEconomBlock$4 = styled.div(_templateObject12$m || (_templateObject12$m = _taggedTemplateLiteralLoose(["\n  height: 184px;\n  width: 737px;\n  border: 1px solid black;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var PMAnimalBlock$4 = styled.div(_templateObject13$m || (_templateObject13$m = _taggedTemplateLiteralLoose(["\n  height: 185px;\n  width: 424px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMCurBlock$4 = styled.div(_templateObject14$g || (_templateObject14$g = _taggedTemplateLiteralLoose(["\n  height: 74px;\n  width: 742px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var MapCardA2L = function MapCardA2L(props) {
  var num = props.num,
    gift = props.gift,
    qrimage = props.qrimage,
    qrtext = props.qrtext,
    mapimage = props.mapimage,
    mapsvg = props.mapsvg,
    gerbimage = props.gerbimage,
    country = props.country,
    countryname = props.countryname,
    capital = props.capital,
    countrysize = props.countrysize,
    climat = props.climat,
    geographic = props.geographic,
    animal0 = props.animal0,
    animal1 = props.animal1,
    animal2 = props.animal2,
    animal3 = props.animal3,
    animal4 = props.animal4,
    animal5 = props.animal5,
    currency = props.currency,
    economical = props.economical,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$X, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(PMMainBlock$4, null, /*#__PURE__*/React$1.createElement(PMSecondBlock$4, null, /*#__PURE__*/React$1.createElement(PMFlexRow$4, null, /*#__PURE__*/React$1.createElement(PMFlexColumn$4, null, /*#__PURE__*/React$1.createElement(PMGerbBlock$4, null, /*#__PURE__*/React$1.createElement(GerbBlock$4, {
    gerbimage: gerbimage,
    headername: country,
    countryname: countryname,
    capitalname: capital,
    countrysize: countrysize
  })), /*#__PURE__*/React$1.createElement(PMClimatBlock$4, null, /*#__PURE__*/React$1.createElement(TextBlock$_, {
    name: "Климат",
    body: climat
  })), /*#__PURE__*/React$1.createElement(PMAnimalBlock$4, null, /*#__PURE__*/React$1.createElement(AnimalBlock$4, {
    name: "Животный мир",
    image0: animal0,
    image1: animal1,
    image2: animal2,
    image3: animal3,
    image4: animal4,
    image5: animal5
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$4, null, /*#__PURE__*/React$1.createElement(PMMapBlock$4, null, /*#__PURE__*/React$1.createElement(MapBlock$4, {
    mapimage: mapimage,
    mapsvg: mapsvg
  })))), /*#__PURE__*/React$1.createElement(PMFlexRow$4, null, /*#__PURE__*/React$1.createElement(PMGeogrBlock$4, null, /*#__PURE__*/React$1.createElement(TextBlock$_, {
    name: "Географическое положение",
    body: geographic
  })), /*#__PURE__*/React$1.createElement(PMEconomBlock$4, null, /*#__PURE__*/React$1.createElement(TextBlock$_, {
    name: "Экономичсекий прогноз",
    body: economical
  })), /*#__PURE__*/React$1.createElement(PMFlexColumn$4, null, /*#__PURE__*/React$1.createElement(PMCurBlock$4, null, /*#__PURE__*/React$1.createElement(TextBlock$$, {
    name: "Используемая валюта",
    body: currency
  })), /*#__PURE__*/React$1.createElement(PMNumberBlock$4, null, /*#__PURE__*/React$1.createElement(NumberBlock$4, {
    name: num,
    giftname: gift
  }))), /*#__PURE__*/React$1.createElement(PMQrBlock$4, null, /*#__PURE__*/React$1.createElement(QrBlock$4, {
    qrimg: qrimage,
    qrurl: qrtext
  }))))));
};

var _templateObject$1v, _templateObject2$1v, _templateObject3$1v, _templateObject4$19, _templateObject5$11, _templateObject6$10, _templateObject7$10, _templateObject8$Z;
var InfoFlexBox = styled.div(_templateObject$1v || (_templateObject$1v = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n"])));
var Wrapper$Y = styled.div(_templateObject2$1v || (_templateObject2$1v = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  min-width: 297mm;\n  max-width: 297mm;\n  height: 420mm;\n  min-height: 420mm;\n  max-height: 420mm;\n  border: 1px solid white;\n  transform: scale(calc(", " / 297), calc(", " / 420));\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$T = styled.div(_templateObject3$1v || (_templateObject3$1v = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  //border: 1px solid white;\n  box-sizing: border-box;\n"])));
var ImageBlock$T = styled.div(_templateObject4$19 || (_templateObject4$19 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  max-width: 100%;\n  height: 1393px;\n  box-sizing: border-box;\n  margin-left: 72px;\n  margin-right: 74px;\n\n  img {\n    height: 100%;\n    width: 100%;\n    // object-fit: cover;\n  }\n"])));
var InfoBlock = styled.div(_templateObject5$11 || (_templateObject5$11 = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  margin-left: 72px;\n  margin-right: 74px;\n  box-sizing: border-box;\n  margin-top: 6px;\n"])));
var Url$6 = styled.div(_templateObject6$10 || (_templateObject6$10 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-size: 12.8pt;\n  font-style: normal;\n  max-width: 100%;\n  margin-left: 2px;\n"])));
var Coordinates = styled.div(_templateObject7$10 || (_templateObject7$10 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-size: 12.8pt;\n  font-style: normal;\n  max-width: 100%;\n"])));
var Number$6 = styled.div(_templateObject8$Z || (_templateObject8$Z = _taggedTemplateLiteralLoose(["\n  display: flex;\n  height: 84px;\n  align-items: center;\n  justify-content: center;\n  font-family: Roboto-Regular, Roboto, serif;\n  font-size: 16pt;\n  font-style: normal;\n"])));
var GeograffeeCardA3 = function GeograffeeCardA3(props) {
  return /*#__PURE__*/React$1.createElement(Wrapper$Y, {
    dw: props.dw,
    dh: props.dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$T, null, /*#__PURE__*/React$1.createElement(Number$6, null, "№ Ae " + props.number), /*#__PURE__*/React$1.createElement(ImageBlock$T, null, /*#__PURE__*/React$1.createElement("img", {
    src: props.image,
    alt: "",
    draggable: false
  })), /*#__PURE__*/React$1.createElement(InfoBlock, null, /*#__PURE__*/React$1.createElement(InfoFlexBox, null, /*#__PURE__*/React$1.createElement(Url$6, null, props.url), /*#__PURE__*/React$1.createElement(Coordinates, null, props.coordinates)))));
};

var removeEmojis = function removeEmojis(s) {
  return s.replace(emojiRegex(), '');
};

var isPlainObject = function isPlainObject(value) {
  if (value === null || typeof value !== 'object') return false;
  var proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
};
var _deepRemoveEmojis = function deepRemoveEmojis(input, seen) {
  if (seen === void 0) {
    seen = new WeakSet();
  }
  if (input === null || input === undefined) return input;
  var type = typeof input;
  if (type === 'number' || type === 'boolean' || type === 'bigint' || type === 'symbol' || type === 'function') {
    return input;
  }
  if (type === 'string') {
    return removeEmojis(input);
  }
  if (React$1.isValidElement(input)) {
    return input;
  }
  if (typeof input === 'object') {
    if (seen.has(input)) return input;
    seen.add(input);
    if (input instanceof Date || input instanceof RegExp || input instanceof Map || input instanceof Set) {
      return input;
    }
    if (Array.isArray(input)) {
      return input.map(function (item) {
        return _deepRemoveEmojis(item, seen);
      });
    }
    if (isPlainObject(input)) {
      var result = {};
      for (var key in input) {
        if (!Object.prototype.hasOwnProperty.call(input, key)) continue;
        var value = input[key];
        result[key] = _deepRemoveEmojis(value, seen);
      }
      return result;
    }
    return input;
  }
  return input;
};

var components = {
  WarholCardA5L: WarholCardA5L,
  WarholCardA5: WarholCardA5,
  WarholCardA4L: WarholCardA4L,
  WarholCardA4: WarholCardA4,
  WarholCardA3L: WarholCardA3L,
  WarholCardA3: WarholCardA3,
  WarholCardA2L: WarholCardA2L,
  WarholCardA2: WarholCardA2,
  WarholCardA1L: WarholCardA1L,
  WarholCardA1: WarholCardA1,
  WarholCardA0L: WarholCardA0L,
  WarholCardA0: WarholCardA0
};
var WarholStyleCard = function WarholStyleCard(props) {
  var _templateDataComputed, _templateDataComputed2;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components[templateType], {
    url: templateDataComputed && templateDataComputed.link || 'gallllery.com',
    image: image,
    number: cardNumber.replace('№ ', '№'),
    museum: templateDataComputed && templateDataComputed.description || '',
    name: templateDataComputed && templateDataComputed.title && templateDataComputed.title.toString() || '',
    dw: dw,
    dh: dh,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed = templateDataComputed.subTitle) === null || _templateDataComputed === void 0 ? void 0 : _templateDataComputed.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed2 = templateDataComputed.description) === null || _templateDataComputed2 === void 0 ? void 0 : _templateDataComputed2.toString())
  });
};

var _templateObject$1w, _templateObject2$1w, _templateObject3$1w, _templateObject4$1a, _templateObject5$12, _templateObject6$11, _templateObject7$11, _templateObject8$_, _templateObject9$Y;
var Wrapper$Z = styled.div(_templateObject$1w || (_templateObject$1w = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(calc(", " / ", "), calc(", " / ", "));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (p) {
  return p.width;
}, function (p) {
  return p.height;
}, function (p) {
  return p.dw;
}, function (p) {
  return p.width;
}, function (p) {
  return p.dh;
}, function (p) {
  return p.height;
}, function (p) {
  return p.paddingX;
});
var MainBlock$U = styled.div(_templateObject2$1w || (_templateObject2$1w = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$N = styled.div(_templateObject3$1w || (_templateObject3$1w = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: ", "px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: ", "px;\n    margin-top: ", "px;\n  }\n"])), function (p) {
  return p.urlHeight;
}, function (p) {
  return p.urlFontSize;
}, function (p) {
  return p.urlLetterSpacing;
}, function (p) {
  return p.urlMarginTop;
});
var ImageBlock$U = styled.div(_templateObject4$1a || (_templateObject4$1a = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$T = styled.div(_templateObject5$12 || (_templateObject5$12 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$10 = styled.div(_templateObject6$11 || (_templateObject6$11 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: ", "%;\n  width: ", "%;\n  padding-bottom: ", "px;\n"])), function (p) {
  return p.textBlockHeight;
}, function (p) {
  return p.textBlockWidth;
}, function (p) {
  return p.textBlockPaddingBottom;
});
var TextFirst$N = styled.div(_templateObject7$11 || (_templateObject7$11 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n  \n  span {\n    text-transform: ", ";\n    font-size: ", "px;\n    font-style: normal;\n    font-weight: ", ";\n    letter-spacing: ", "px;\n    margin-right: ", "px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: ", "px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (_ref) {
  var isNumberCard = _ref.isNumberCard;
  return isNumberCard && 'uppercase';
}, function (p) {
  return p.firstTextSize;
}, function (_ref2) {
  var isNumberCard = _ref2.isNumberCard;
  return isNumberCard && 700;
}, function (p) {
  return p.firstLetterSpacing;
}, function (p) {
  return -p.firstLetterSpacing;
}, function (_ref3) {
  var isNumberCard = _ref3.isNumberCard;
  return isNumberCard ? '2' : '1';
}, function (p) {
  return p.dashWidth;
}, function (p) {
  return p.dashOffset;
}, function (p) {
  return p.dashOffset;
});
var TextSecond$N = styled.div(_templateObject8$_ || (_templateObject8$_ = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: ", "px;\n  text-align: center;\n  margin: ", ";\n  color: #151514;\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: ", ";\n  letter-spacing: ", "px;\n  margin-right: ", "px;\n  text-transform: ", ";\n"])), function (p) {
  return p.secondTextHeight;
}, function (p) {
  return p.secondTextMargins;
}, function (_ref4) {
  var isNumberCard = _ref4.isNumberCard;
  return !isNumberCard && 700;
}, function (p) {
  return p.secondLetterSpacing;
}, function (p) {
  return p.fullText ? 0 : -p.secondLetterSpacing;
}, function (_ref5) {
  var isNumberCard = _ref5.isNumberCard;
  return !isNumberCard && 'uppercase';
});
var TextThird$N = styled.div(_templateObject9$Y || (_templateObject9$Y = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: ", "px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n"])), function (p) {
  return p.thirdFontSize;
});
var WarholStyle2Template = function WarholStyle2Template(_ref6) {
  var image = _ref6.image,
    url = _ref6.url,
    customSubtitle = _ref6.customSubtitle,
    name = _ref6.name,
    number = _ref6.number,
    dw = _ref6.dw,
    dh = _ref6.dh,
    width = _ref6.width,
    height = _ref6.height,
    paddingX = _ref6.paddingX,
    fontS = _ref6.fontS,
    urlHeight = _ref6.urlHeight,
    urlFontSize = _ref6.urlFontSize,
    urlLetterSpacing = _ref6.urlLetterSpacing,
    urlMarginTop = _ref6.urlMarginTop,
    textBlockHeight = _ref6.textBlockHeight,
    textBlockWidth = _ref6.textBlockWidth,
    textBlockPaddingBottom = _ref6.textBlockPaddingBottom,
    firstTextSize = _ref6.firstTextSize,
    firstLetterSpacing = _ref6.firstLetterSpacing,
    dashWidth = _ref6.dashWidth,
    dashOffset = _ref6.dashOffset,
    secondTextHeight = _ref6.secondTextHeight,
    secondTextMargins = _ref6.secondTextMargins,
    secondLetterSpacing = _ref6.secondLetterSpacing,
    thirdFontSize = _ref6.thirdFontSize,
    isNumberCard = _ref6.isNumberCard;
  var _useState = useState(fontS),
    fontSize = _useState[0];
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$Z, {
    dw: dw,
    dh: dh,
    width: width,
    height: height,
    paddingX: paddingX
  }, /*#__PURE__*/React$1.createElement(MainBlock$U, null, /*#__PURE__*/React$1.createElement(TextUrl$N, {
    urlHeight: urlHeight,
    urlFontSize: urlFontSize,
    urlLetterSpacing: urlLetterSpacing,
    urlMarginTop: urlMarginTop
  }, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$U, null, /*#__PURE__*/React$1.createElement(ImageInner$T, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$10, {
    textBlockHeight: textBlockHeight,
    textBlockWidth: textBlockWidth,
    textBlockPaddingBottom: textBlockPaddingBottom
  }, /*#__PURE__*/React$1.createElement(TextFirst$N, {
    isNumberCard: isNumberCard,
    firstTextSize: firstTextSize,
    firstLetterSpacing: firstLetterSpacing,
    dashWidth: dashWidth,
    dashOffset: dashOffset
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$N, {
    isNumberCard: isNumberCard,
    fullText: fullText,
    secondTextHeight: secondTextHeight,
    secondTextMargins: secondTextMargins,
    secondLetterSpacing: secondLetterSpacing
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: name,
    fontSizeMax: fontSize
  })), /*#__PURE__*/React$1.createElement(TextThird$N, {
    thirdFontSize: thirdFontSize
  }, customSubtitle || url))));
};

var WarholCard2A4Product = function WarholCard2A4Product(props) {
  return /*#__PURE__*/React$1.createElement(WarholStyle2Template, _extends({}, props, {
    width: 210,
    height: 297,
    paddingX: 40.4,
    fontS: 17.5,
    urlHeight: 5.905,
    urlFontSize: 4,
    urlLetterSpacing: 0.7,
    urlMarginTop: 5,
    textBlockHeight: 17.6,
    textBlockWidth: 87.9,
    textBlockPaddingBottom: 36.5,
    firstTextSize: 37,
    firstLetterSpacing: 6,
    dashWidth: 37,
    dashOffset: -26,
    secondTextMargins: '15.7px 0 20.7px',
    secondLetterSpacing: 0.5,
    thirdFontSize: 6,
    isNumberCard: true
  }));
};

var WarholCard2A0Plus = function WarholCard2A0Plus(props) {
  return /*#__PURE__*/React$1.createElement(WarholStyle2Template, _extends({}, props, {
    width: 1000,
    height: 1414,
    paddingX: 195,
    fontS: 220,
    urlHeight: 5.9,
    urlFontSize: 24,
    urlMarginTop: 20,
    textBlockHeight: 17.6,
    textBlockWidth: 89,
    textBlockPaddingBottom: 167,
    firstTextSize: 84,
    firstLetterSpacing: 14.5,
    dashWidth: 200,
    dashOffset: -120,
    secondTextMargins: '53px 0 70px',
    secondLetterSpacing: 4,
    thirdFontSize: 36.5
  }));
};

var components$1 = {
  WarholCard2A5L: WarholCard2A5L,
  WarholCard2A5: WarholCard2A5,
  WarholCard2A4L: WarholCard2A4L,
  WarholCard2A4: WarholCard2A4,
  WarholCard2A4Product: WarholCard2A4Product,
  WarholCard2A3L: WarholCard2A3L,
  WarholCard2A3: WarholCard2A3,
  WarholCard2A2L: WarholCard2A2L,
  WarholCard2A2: WarholCard2A2,
  WarholCard2A1L: WarholCard2A1L,
  WarholCard2A1: WarholCard2A1,
  WarholCard2A0L: WarholCard2A0L,
  WarholCard2A0: WarholCard2A0,
  WarholCard2A0Plus: WarholCard2A0Plus
};
var COMPONENT_NAME = 'WarholCard2';
var WITH_QR = 'WithQr';
var WarholStyle2Card = function WarholStyle2Card(props) {
  var _templateDataComputed, _templateDataComputed2;
  var data = props.data,
    image = props.image,
    _props$templateType = props.templateType,
    templateType = _props$templateType === void 0 ? '' : _props$templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = (data === null || data === void 0 ? void 0 : data.templateData) || {};
  var template = templateType !== null && templateType !== void 0 && templateType.includes(WITH_QR) ? COMPONENT_NAME + templateType.slice(COMPONENT_NAME.length + WITH_QR.length, templateType.length) : templateType;
  return React$1.createElement(components$1[template], {
    url: templateDataComputed && templateDataComputed.link || 'gallllery.com',
    image: image,
    number: cardNumber.replace('№ ', '№'),
    museum: templateDataComputed && templateDataComputed.description || '',
    name: templateDataComputed && templateDataComputed.title && templateDataComputed.title.toString() || '',
    dw: dw,
    dh: dh,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed = templateDataComputed.subTitle) === null || _templateDataComputed === void 0 ? void 0 : _templateDataComputed.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed2 = templateDataComputed.description) === null || _templateDataComputed2 === void 0 ? void 0 : _templateDataComputed2.toString())
  });
};

var _templateObject$1x, _templateObject2$1x, _templateObject3$1x, _templateObject4$1b, _templateObject5$13, _templateObject6$12, _templateObject7$12, _templateObject8$$, _templateObject9$Z;
var Wrapper$_ = styled.div(_templateObject$1x || (_templateObject$1x = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(calc(", " / ", "), calc(", " / ", "));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (p) {
  return p.width;
}, function (p) {
  return p.height;
}, function (p) {
  return p.dw;
}, function (p) {
  return p.width;
}, function (p) {
  return p.dh;
}, function (p) {
  return p.height;
}, function (p) {
  return p.paddingX;
});
var MainBlock$V = styled.div(_templateObject2$1x || (_templateObject2$1x = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$O = styled.div(_templateObject3$1x || (_templateObject3$1x = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: ", "px;\n    font-style: normal;\n    font-weight: bold;\n    margin-top: ", "px;\n  }\n"])), function (p) {
  return p.urlHeight;
}, function (p) {
  return p.urlFontSize;
}, function (p) {
  return p.urlMarginTop;
});
var ImageBlock$V = styled.div(_templateObject4$1b || (_templateObject4$1b = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$U = styled.div(_templateObject5$13 || (_templateObject5$13 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$11 = styled.div(_templateObject6$12 || (_templateObject6$12 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: ", "%;\n  width: ", "%;\n  padding-bottom: ", "px;\n"])), function (p) {
  return p.textBlockHeight;
}, function (p) {
  return p.textBlockWidth;
}, function (p) {
  return p.textBlockPaddingBottom;
});
var TextFirst$O = styled.div(_templateObject7$12 || (_templateObject7$12 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: ", "px;\n    font-style: normal;\n    font-weight: ", ";\n    letter-spacing: ", "px;\n    margin-right: ", "px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: ", "px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (p) {
  return p.firstFontSize;
}, function (p) {
  return p.firstFontWeight;
}, function (p) {
  return p.firstLetterSpacing;
}, function (p) {
  return -p.firstLetterSpacing;
}, function (p) {
  return p.dashBorderWidth;
}, function (p) {
  return p.dashWidth;
}, function (p) {
  return -p.dashOffset;
}, function (p) {
  return -p.dashOffset;
});
var TextSecond$O = styled.div(_templateObject8$$ || (_templateObject8$$ = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  width: 100%;\n  height: ", "px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: ", ";\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: ", ";\n  overflow: hidden;\n"])), function (p) {
  return p.secondTextHeight;
}, function (p) {
  return p.secondTextMargins;
}, function (p) {
  return p.secondFontWeight;
});
var TextThird$O = styled.div(_templateObject9$Z || (_templateObject9$Z = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: ", "px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: ", "px;\n"])), function (p) {
  return p.thirdFontSize;
}, function (p) {
  return p.thirdLetterSpacing;
});
var WarholStyle3Template = function WarholStyle3Template(_ref) {
  var _number$trim;
  var image = _ref.image,
    url = _ref.url,
    customSubtitle = _ref.customSubtitle,
    name = _ref.name,
    number = _ref.number,
    dw = _ref.dw,
    dh = _ref.dh,
    width = _ref.width,
    height = _ref.height,
    paddingX = _ref.paddingX,
    urlHeight = _ref.urlHeight,
    urlFontSize = _ref.urlFontSize,
    urlMarginTop = _ref.urlMarginTop,
    textBlockHeight = _ref.textBlockHeight,
    textBlockWidth = _ref.textBlockWidth,
    textBlockPaddingBottom = _ref.textBlockPaddingBottom,
    firstFontSize = _ref.firstFontSize,
    firstFontWeight = _ref.firstFontWeight,
    firstLetterSpacing = _ref.firstLetterSpacing,
    dashWidth = _ref.dashWidth,
    dashOffset = _ref.dashOffset,
    dashBorderWidth = _ref.dashBorderWidth,
    secondTextHeight = _ref.secondTextHeight,
    secondTextMargins = _ref.secondTextMargins,
    secondFontWeight = _ref.secondFontWeight,
    mainFontSize = _ref.mainFontSize,
    defaultLetterSpacing = _ref.defaultLetterSpacing,
    thirdFontSize = _ref.thirdFontSize,
    thirdLetterSpacing = _ref.thirdLetterSpacing;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$_, {
    dw: dw,
    dh: dh,
    width: width,
    height: height,
    paddingX: paddingX
  }, /*#__PURE__*/React$1.createElement(MainBlock$V, null, /*#__PURE__*/React$1.createElement(TextUrl$O, {
    urlHeight: urlHeight,
    urlFontSize: urlFontSize,
    urlMarginTop: urlMarginTop
  }, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$V, null, /*#__PURE__*/React$1.createElement(ImageInner$U, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$11, {
    textBlockHeight: textBlockHeight,
    textBlockWidth: textBlockWidth,
    textBlockPaddingBottom: textBlockPaddingBottom
  }, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$O, {
    firstFontSize: firstFontSize,
    firstFontWeight: firstFontWeight,
    firstLetterSpacing: firstLetterSpacing,
    dashWidth: dashWidth,
    dashOffset: dashOffset,
    dashBorderWidth: dashBorderWidth
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$O, {
    ref: mainTextRef,
    secondTextHeight: secondTextHeight,
    secondTextMargins: secondTextMargins,
    secondFontWeight: secondFontWeight
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: defaultLetterSpacing,
    fontSize: mainFontSize
  })), /*#__PURE__*/React$1.createElement(TextThird$O, {
    thirdFontSize: thirdFontSize,
    thirdLetterSpacing: thirdLetterSpacing
  }, customSubtitle || url))));
};

var WarholCard3A0Plus = function WarholCard3A0Plus(props) {
  return /*#__PURE__*/React$1.createElement(WarholStyle3Template, _extends({}, props, {
    width: 1000,
    height: 1414,
    paddingX: 197,
    urlHeight: 5.9,
    urlFontSize: 24,
    urlMarginTop: 20,
    textBlockHeight: 17.7,
    textBlockWidth: 90,
    textBlockPaddingBottom: 237,
    firstFontSize: 49,
    firstFontWeight: 400,
    firstLetterSpacing: 9.5,
    dashWidth: 121,
    dashOffset: 70,
    dashBorderWidth: 1,
    secondTextMargins: '108px 0 114px',
    secondFontWeight: 700,
    mainFontSize: 91,
    defaultLetterSpacing: 77.5,
    thirdFontSize: 37.5,
    thirdLetterSpacing: 0.4
  }));
};

var components$2 = {
  WarholCard3A5L: WarholCard3A5L,
  WarholCard3A5: WarholCard3A5,
  WarholCard3A4L: WarholCard3A4L,
  WarholCard3A4: WarholCard3A4,
  WarholCard3A3L: WarholCard3A3L,
  WarholCard3A3: WarholCard3A3,
  WarholCard3A2L: WarholCard3A2L,
  WarholCard3A2: WarholCard3A2,
  WarholCard3A1L: WarholCard3A1L,
  WarholCard3A1: WarholCard3A1,
  WarholCard3A0L: WarholCard3A0L,
  WarholCard3A0: WarholCard3A0,
  WarholCard3A0Plus: WarholCard3A0Plus
};
var WarholStyle3Card = function WarholStyle3Card(props) {
  var _templateDataComputed, _templateDataComputed2;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = (data === null || data === void 0 ? void 0 : data.templateData) || {};
  return React$1.createElement(components$2[templateType], {
    url: templateDataComputed && templateDataComputed.link || 'gallllery.com',
    image: image,
    number: cardNumber,
    museum: templateDataComputed && templateDataComputed.description || '',
    name: templateDataComputed && templateDataComputed.title && templateDataComputed.title.toString() || '',
    dw: dw,
    dh: dh,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed = templateDataComputed.subTitle) === null || _templateDataComputed === void 0 ? void 0 : _templateDataComputed.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed2 = templateDataComputed.description) === null || _templateDataComputed2 === void 0 ? void 0 : _templateDataComputed2.toString())
  });
};

var components$3 = {
  WarholCard4A5L: WarholCard4A5L,
  WarholCard4A4L: WarholCard4A4L,
  WarholCard4A3L: WarholCard4A3L,
  WarholCard4A2L: WarholCard4A2L,
  WarholCard4A1L: WarholCard4A1L,
  WarholCard4A0L: WarholCard4A0L
};
var WarholStyle4Card = function WarholStyle4Card(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = data.templateData;
  if (!components$3[templateType]) {
    return 'Такого шаблона нет';
  }
  return React$1.createElement(components$3[templateType], {
    url: templateDataComputed && templateDataComputed.link || 'gallllery.com',
    image: image,
    number: cardNumber,
    museum: templateDataComputed && templateDataComputed.description || '',
    name: templateDataComputed && templateDataComputed.title && templateDataComputed.title.length && templateDataComputed.title.toString() || '',
    dw: dw,
    dh: dh
  });
};

var _templateObject$1y, _templateObject2$1y, _templateObject3$1y, _templateObject4$1c;
var Wrapper$$ = styled.div(_templateObject$1y || (_templateObject$1y = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  transform: scale(calc(", " / 210), calc(", " / 297));\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var VoteCollectionWrapper = styled.div(_templateObject2$1y || (_templateObject2$1y = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    flex-flow: column;\n    position: relative;\n    background-color: #fff;\n    padding: 20.85mm;\n    justify-content: space-between;\n    box-sizing: border-box;\n"])));
var CoverContainer = styled.div(_templateObject3$1y || (_templateObject3$1y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: calc(100% - ", "px);\n  position: relative;\n  display: flex;\n  align-items: ", ";\n\n  img {\n  width: ", ";\n  height: ", ";\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  }\n"])), function (_ref) {
  var titleHeight = _ref.titleHeight;
  return titleHeight;
}, function (_ref2) {
  var orientation = _ref2.orientation,
    isSquare = _ref2.isSquare;
  return orientation && !isSquare ? "center" : 'flex-start';
}, function (_ref3) {
  var orientation = _ref3.orientation;
  return orientation ? "100%" : 'auto';
}, function (_ref4) {
  var orientation = _ref4.orientation;
  return orientation ? "auto" : 'auto';
});
var Title = styled.div(_templateObject4$1c || (_templateObject4$1c = _taggedTemplateLiteralLoose(["\n    font-family: 'Roboto', serif;\n    font-size: 11.91mm;\n    line-height: 11.91mm;\n    color: #151514;\n    font-weight: 700;\n    white-space: pre-wrap;\n    text-align: left;\n    word-wrap: break-word;\n    margin-top: 6mm;\n"])));
var debounceFunc = function debounceFunc(callback, delay) {
  var timer;
  return function () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      return callback();
    }, delay);
  };
};
var VotingCoverCardMain = function VotingCoverCardMain(props) {
  var dw = props.dw,
    dh = props.dh,
    collectionName = props.collectionName,
    image = props.image,
    baseUrl = props.baseUrl;
  var titleRef = useRef(null);
  var _useState = useState(0),
    titleHeight = _useState[0],
    setTitleHeight = _useState[1];
  var orientation = useMemo(function () {
    return image && (image.orientaion || image.Orientaion);
  }, [image]);
  var ratio = useMemo(function () {
    return image && (image.ratio || image.Ratio);
  }, [image]);
  var isSquare = useMemo(function () {
    if (!image) return false;
    if (image && image.width && image.height) return image.width === image.height;
    return image && image.Width === image.Height;
  }, [image]);
  var imageUrl = useMemo(function () {
    if (image && image.url) return baseUrl + "/" + image.url;
    return image && image.Url ? baseUrl + "/" + image.Url : '';
  }, [image, baseUrl]);
  var resizeHandler = function resizeHandler() {
    if (!titleRef.current || !(collectionName && collectionName.length)) return;
    setTitleHeight(titleRef && titleRef.current && titleRef.current.offsetHeight);
  };
  var debouncedResizeHandler = debounceFunc(resizeHandler, 500);
  useEffect(function () {
    resizeHandler();
    window.addEventListener("resize", debouncedResizeHandler);
    return function () {
      window.removeEventListener("resize", debouncedResizeHandler);
    };
  }, [collectionName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$$, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(VoteCollectionWrapper, {
    orientation: orientation
  }, /*#__PURE__*/React$1.createElement(CoverContainer, {
    titleHeight: titleHeight,
    orientation: orientation,
    ratio: ratio,
    isSquare: isSquare
  }, /*#__PURE__*/React$1.createElement("img", {
    src: imageUrl,
    alt: ""
  })), collectionName && collectionName.length > 0 && /*#__PURE__*/React$1.createElement(Title, {
    ref: titleRef
  }, collectionName)));
};

var components$4 = {
  VotingCoverCardMain: VotingCoverCardMain
};
var VotingCoverCard = function VotingCoverCard(props) {
  var data = props.data,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$4[templateType], {
    dw: dw,
    dh: dh,
    collectionName: data && data.length && data.collectionName || '',
    baseUrl: data && data.baseUrl || '',
    image: data && data.image || undefined
  });
};

var components$5 = {
  ClassicCard3A0: ClassicCard3A0,
  ClassicCard3A1: ClassicCard3A1,
  ClassicCard3A2: ClassicCard3A2,
  ClassicCard3A3: ClassicCard3A3,
  ClassicCard3A4: ClassicCard3A4,
  ClassicCard3A5: ClassicCard3A5
};
var ClassicStyle3Card = function ClassicStyle3Card(props) {
  var templateType = props.templateType;
  if (!components$5[templateType]) {
    return 'Такого шаблона нет, ';
  }
  return 'Шаблон в разработке.';
};

var components$6 = {
  LuvrikCardA5L: LuvrikCardA5L,
  LuvrikCardA5: LuvrikCardA5,
  LuvrikCardA4L: LuvrikCardA4L,
  LuvrikCardA4: LuvrikCardA4,
  LuvrikCardA3L: LuvrikCardA3L,
  LuvrikCardA3: LuvrikCardA3,
  LuvrikCardA2L: LuvrikCardA2L,
  LuvrikCardA2: LuvrikCardA2,
  LuvrikCardA1L: LuvrikCardA1L,
  LuvrikCardA1: LuvrikCardA1,
  LuvrikCardA0L: LuvrikCardA0L,
  LuvrikCardA0: LuvrikCardA0,
  ClassicA5L: LuvrikCardA5L,
  ClassicA5: LuvrikCardA5,
  ClassicA4L: LuvrikCardA4L,
  ClassicA4: LuvrikCardA4,
  ClassicA3L: LuvrikCardA3L,
  ClassicA3: LuvrikCardA3,
  ClassicA2L: LuvrikCardA2L,
  ClassicA2: LuvrikCardA2,
  ClassicA1L: LuvrikCardA1L,
  ClassicA1: LuvrikCardA1,
  ClassicA0L: LuvrikCardA0L,
  ClassicA0: LuvrikCardA0
};
var LuvrikStyleCard = function LuvrikStyleCard(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    appName = props.appName,
    dw = props.dw,
    dh = props.dh;
  var card_number = (appName === 'gallllery' ? '' : '№Ae ') + data.number;
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components$6[templateType], {
    url: templateDataComputed && templateDataComputed.link || 'ze.land',
    image: image,
    country: templateDataComputed && templateDataComputed.subTitle,
    number: card_number,
    museum: templateDataComputed && templateDataComputed.title,
    name: templateDataComputed && templateDataComputed.description,
    dw: dw,
    dh: dh
  });
};

var _templateObject$1z, _templateObject2$1z, _templateObject3$1z, _templateObject4$1d, _templateObject5$14, _templateObject6$13;
var Wrapper$10 = styled.div(_templateObject$1z || (_templateObject$1z = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  // border: 1px solid white;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$W = styled.div(_templateObject2$1z || (_templateObject2$1z = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  // border: 1px solid white;\n  padding: 5%;\n  display: flex;\n  flex-direction: column;\n"])));
var ImageBlock$W = styled.div(_templateObject3$1z || (_templateObject3$1z = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"])));
var ImageInner$V = styled.div(_templateObject4$1d || (_templateObject4$1d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  /* align-items: ", "; */\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])), function (props) {
  return props.align ? 'start' : 'center';
});
var TextBlock$12 = styled.div(_templateObject5$14 || (_templateObject5$14 = _taggedTemplateLiteralLoose(["\n  // margin-top: 5%;\n  //background-color: aqua;\n  height: 13%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var TextSecond$P = styled.div(_templateObject6$13 || (_templateObject6$13 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  font-size: ", "px;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  line-height: 87px;\n  letter-spacing: 0.036em;\n  text-align: center;\n  //background-color: red;\n"])), function (props) {
  return props.fs;
});
var ProductCard = function ProductCard(props) {
  var image = props.image,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(false),
    setIsVerticalImage = _useState[1];
  useEffect(function () {
    if (image) {
      var img = new Image();
      img.onload = function () {
        if (this.width < this.height) {
          setIsVerticalImage(true);
        } else {
          setIsVerticalImage(false);
        }
      };
      img.src = image;
    }
  }, [image]);
  return /*#__PURE__*/React$1.createElement(Wrapper$10, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$W, null, /*#__PURE__*/React$1.createElement(ImageBlock$W, null, /*#__PURE__*/React$1.createElement(ImageInner$V, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  })))));
};

var mainSize = {
  horizontal: {
    small: {
      width: 300,
      height: 394,
      scale: 0.238,
      padding: '45mm 15mm 60mm'
    },
    large: {
      width: 260,
      height: 366,
      scale: 1,
      padding: '30mm 10mm 0'
    }
  },
  vertical: {
    small: {
      width: 300,
      height: 381,
      scale: 0.238,
      padding: '45mm 15mm 60mm'
    },
    large: {
      width: 280,
      height: 686,
      scale: 1,
      padding: '15mm 60mm 0'
    }
  }
};

var _templateObject$1A, _templateObject2$1A;
var TitlePlaceholder = styled.div(_templateObject$1A || (_templateObject$1A = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  &.title_vertical {\n    width: ", ";\n    height: ", ";\n    @media ", " {\n      width: ", ";\n      height: ", ";\n    }\n    @media ", " {\n      width: ", ";\n      height: ", ";\n    }\n  }\n\n  &.title_horizontal {\n    width: ", ";\n    height: ", ";\n    @media ", " {\n      width: ", ";\n      height: ", ";\n    }\n    @media ", " {\n      width: ", ";\n      height: ", ";\n    }\n  }\n\n  &.title_free {\n    width: ", ";\n    height: ", ";\n    @media ", " {\n      width: ", ";\n      height: ", ";\n    }\n    @media ", " {\n      width: ", ";\n      height: ", ";\n    }\n  }\n"])), Colors.galBlack21, function (_ref) {
  var isScaled = _ref.isScaled;
  return isScaled ? '420px' : '100px';
}, function (_ref2) {
  var isScaled = _ref2.isScaled;
  return isScaled ? '51px' : '12px';
}, MEDIA.LAPTOP, function (_ref3) {
  var isScaled = _ref3.isScaled;
  return isScaled ? '534px' : '96px';
}, function (_ref4) {
  var isScaled = _ref4.isScaled;
  return isScaled ? '51px' : '9px';
}, MEDIA.TABLET, function (_ref5) {
  var isScaled = _ref5.isScaled;
  return isScaled ? '485px' : '71px';
}, function (_ref6) {
  var isScaled = _ref6.isScaled;
  return isScaled ? '55px' : '8px';
}, function (_ref7) {
  var isScaled = _ref7.isScaled;
  return isScaled ? '215px' : '51px';
}, function (_ref8) {
  var isScaled = _ref8.isScaled;
  return isScaled ? '26px' : '6px';
}, MEDIA.LAPTOP, function (_ref9) {
  var isScaled = _ref9.isScaled;
  return isScaled ? '429px' : '77px';
}, function (_ref10) {
  var isScaled = _ref10.isScaled;
  return isScaled ? '28px' : '5px';
}, MEDIA.TABLET, function (_ref11) {
  var isScaled = _ref11.isScaled;
  return isScaled ? '322px' : '47px';
}, function (_ref12) {
  var isScaled = _ref12.isScaled;
  return isScaled ? '28px' : '4px';
}, function (_ref13) {
  var isScaled = _ref13.isScaled;
  return isScaled ? '224px' : '38px';
}, function (_ref14) {
  var isScaled = _ref14.isScaled;
  return isScaled ? '24px' : '4px';
}, MEDIA.LAPTOP, function (_ref15) {
  var isScaled = _ref15.isScaled;
  return isScaled ? '234px' : '30px';
}, function (_ref16) {
  var isScaled = _ref16.isScaled;
  return isScaled ? '32px' : '4px';
}, MEDIA.TABLET, function (_ref17) {
  var isScaled = _ref17.isScaled;
  return isScaled ? '239px' : '25px';
}, function (_ref18) {
  var isScaled = _ref18.isScaled;
  return isScaled ? '29px' : '3px';
});
var YearPlaceholder = styled.div(_templateObject2$1A || (_templateObject2$1A = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n\n  &.year_vertical {\n    width: ", ";\n    height: ", ";\n    margin-bottom: 9px;\n    margin-left: auto;\n    @media ", " {\n      width: ", ";\n      height: ", ";\n      margin-bottom: 7px;\n    }\n    @media ", " {\n      width: ", ";\n      height: ", ";\n      margin-bottom: 6px;\n    }\n  }\n  &.year_horizontal {\n    width: ", ";\n    height: ", ";\n    margin-bottom: 3px;\n    margin-left: auto;\n    @media ", " {\n      width: ", ";\n      height: ", ";\n      margin-bottom: 2px;\n    }\n    @media ", " {\n      width: ", ";\n      height: ", ";\n      margin-bottom: 1px;\n    }\n  }\n  &.year_free {\n    width: ", ";\n    height: ", ";\n    margin: 0 auto;\n    margin-bottom: 14px;\n    @media ", " {\n      width: ", ";\n      height: ", ";\n      margin-bottom: 11px;\n    }\n    @media ", " {\n      width: ", ";\n      height: ", ";\n      margin-bottom: 9px;\n    }\n  }\n"])), Colors.galBlack21, function (_ref19) {
  var isScaled = _ref19.isScaled;
  return isScaled ? '152px' : '36px';
}, function (_ref20) {
  var isScaled = _ref20.isScaled;
  return isScaled ? '51px' : '12px';
}, MEDIA.LAPTOP, function (_ref21) {
  var isScaled = _ref21.isScaled;
  return isScaled ? '134px' : '24px';
}, function (_ref22) {
  var isScaled = _ref22.isScaled;
  return isScaled ? '51px' : '9px';
}, MEDIA.TABLET, function (_ref23) {
  var isScaled = _ref23.isScaled;
  return isScaled ? '137px' : '20px';
}, function (_ref24) {
  var isScaled = _ref24.isScaled;
  return isScaled ? '48px' : '7px';
}, function (_ref25) {
  var isScaled = _ref25.isScaled;
  return isScaled ? '80px' : '19px';
}, function (_ref26) {
  var isScaled = _ref26.isScaled;
  return isScaled ? '26px' : '6px';
}, MEDIA.LAPTOP, function (_ref27) {
  var isScaled = _ref27.isScaled;
  return isScaled ? '134px' : '24px';
}, function (_ref28) {
  var isScaled = _ref28.isScaled;
  return isScaled ? '28px' : '5px';
}, MEDIA.TABLET, function (_ref29) {
  var isScaled = _ref29.isScaled;
  return isScaled ? '117px' : '17px';
}, function (_ref30) {
  var isScaled = _ref30.isScaled;
  return isScaled ? '28px' : '4px';
}, function (_ref31) {
  var isScaled = _ref31.isScaled;
  return isScaled ? '218px' : '37px';
}, function (_ref32) {
  var isScaled = _ref32.isScaled;
  return isScaled ? '30px' : '5px';
}, MEDIA.LAPTOP, function (_ref33) {
  var isScaled = _ref33.isScaled;
  return isScaled ? '234px' : '30px';
}, function (_ref34) {
  var isScaled = _ref34.isScaled;
  return isScaled ? '32px' : '4px';
}, MEDIA.TABLET, function (_ref35) {
  var isScaled = _ref35.isScaled;
  return isScaled ? '229px' : '24px';
}, function (_ref36) {
  var isScaled = _ref36.isScaled;
  return isScaled ? '39px' : '4px';
});

var _templateObject$1B, _templateObject2$1B, _templateObject3$1A, _templateObject4$1e, _templateObject5$15, _templateObject6$14, _templateObject7$13, _templateObject8$10, _templateObject9$_, _templateObject10$n, _templateObject11$n, _templateObject12$n, _templateObject13$n, _templateObject14$h;
var TemplateTopYear = styled.div(_templateObject$1B || (_templateObject$1B = _taggedTemplateLiteralLoose(["\n  font-family: HSE Sans;\n  color: #b22125;\n  font-size: 48pt;\n  display: flex;\n  align-items: start;\n  justify-content: flex-end;\n  line-height: 100%;\n  letter-spacing: 0;\n  margin-bottom: 9px;\n"])));
var TemplateBottomTitle = styled.div(_templateObject2$1B || (_templateObject2$1B = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  column-gap: 2mm;\n  white-space: nowrap;\n  margin-top: ", ";\n\n  span {\n    color: #002d6e;\n    font-size: ", "pt;\n    line-height: ", "pt;\n    text-transform: uppercase;\n    font-family: HSE Sans;\n    &:nth-of-type(2n) {\n      font-weight: 400;\n      letter-spacing: 0.025em;\n    }\n    &:nth-of-type(2n + 1) {\n      font-weight: 700;\n    }\n  }\n"])), function (_ref) {
  var isHorizontal = _ref.isHorizontal;
  return isHorizontal ? 0 : '0mm -1mm';
}, function (p) {
  return p.largeText ? 47.3 : 50.3;
}, function (p) {
  return p.largeText ? 47.3 : 50.3;
});
var TemplateBottomLine = styled.div(_templateObject3$1A || (_templateObject3$1A = _taggedTemplateLiteralLoose(["\n  // margin-top: 2%;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n"])), function (_ref2) {
  var isPrinting = _ref2.isPrinting;
  return isPrinting && css(_templateObject4$1e || (_templateObject4$1e = _taggedTemplateLiteralLoose(["\n      margin-top: 8.2mm;\n    "])));
});
var Title$1 = styled.div(_templateObject5$15 || (_templateObject5$15 = _taggedTemplateLiteralLoose(["\n  font-size: 36px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n"])));
var MainContainer = styled.div(_templateObject6$14 || (_templateObject6$14 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  &.placeholder_container_vertical {\n    padding: 51px 12px 73px;\n    @media ", " {\n      padding: 39px 9px 54px;\n    }\n    @media ", " {\n      padding: 31px 8px 43px;\n    }\n  }\n\n  &.placeholder_container_horizontal {\n    padding: 18px 9px 9px;\n    @media ", " {\n      padding: 14px 7px 8px;\n    }\n    @media ", " {\n      padding: 11px 6px 7px;\n    }\n  }\n\n  &.placeholder_container_free {\n    padding: 21px 27px 25px;\n    @media ", " {\n      padding: 15px 21px 20px;\n    }\n    @media ", " {\n      padding: 12px 16px 16px;\n    }\n  }\n"])), MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.LAPTOP, MEDIA.TABLET);
var ImagePlaceholderContainer = styled.div(_templateObject7$13 || (_templateObject7$13 = _taggedTemplateLiteralLoose(["\n  display: grid;\n  justify-content: center;\n  gap: 4px;\n  flex-grow: 1;\n  @media ", " {\n    gap: 3px;\n  }\n  @media ", " {\n    gap: 2px;\n  }\n\n  &.image_placeholder_vertical {\n    grid-template-columns: repeat(3, auto);\n    grid-template-rows: repeat(4, auto);\n    margin-bottom: 10px;\n    @media ", " {\n      margin-bottom: 8px;\n    }\n    @media ", " {\n      margin-bottom: 6px;\n    }\n    @media ", " {\n      grid-template-columns: repeat(3, 1fr);\n      grid-template-rows: repeat(4, 1fr);\n    }\n  }\n\n  &.image_placeholder_horizontal {\n    grid-template-columns: repeat(4, auto);\n    grid-template-rows: repeat(3, auto);\n    margin-bottom: 5px;\n    @media ", " {\n      margin-bottom: 3px;\n    }\n    @media ", " {\n      margin-bottom: 3px;\n    }\n    @media ", " {\n      grid-template-columns: repeat(4, 1fr);\n      grid-template-rows: repeat(3, 1fr);\n    }\n  }\n\n  &.image_placeholder_free {\n    grid-template-columns: repeat(3, auto);\n    grid-template-rows: repeat(4, auto);\n    margin-bottom: 23px;\n    @media ", " {\n      margin-bottom: 16px;\n    }\n    @media ", " {\n      margin-bottom: 12px;\n    }\n    @media ", " {\n      grid-template-columns: repeat(3, 1fr);\n      grid-template-rows: repeat(4, 1fr);\n    }\n  }\n"])), MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE);
var PreviewItemContainer = styled.div(_templateObject8$10 || (_templateObject8$10 = _taggedTemplateLiteralLoose(["\n  background: transparent;\n\n  &.preview_item_vertical {\n    width: 79px;\n    height: 98px;\n    @media ", " {\n      width: 60px;\n      height: 74px;\n    }\n    @media ", " {\n      width: 49px;\n      height: 61px;\n    }\n    @media ", " {\n      width: auto;\n      height: auto;\n    }\n  }\n\n  &.preview_item_horizontal {\n    width: 60px;\n    height: 44px;\n    @media ", " {\n      width: 45px;\n      height: 33px;\n    }\n    @media ", " {\n      width: 37px;\n      height: 27px;\n    }\n    @media ", " {\n      width: auto;\n      height: auto;\n    }\n  }\n\n  &.preview_item_free {\n    width: 69px;\n    height: 69px;\n    @media ", " {\n      width: 52px;\n      height: 52px;\n    }\n    @media ", " {\n      width: 43px;\n      height: 43px;\n    }\n    @media ", " {\n      width: auto;\n      height: auto;\n    }\n  }\n"])), MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE);
var PreviewItemBlock = styled.div(_templateObject9$_ || (_templateObject9$_ = _taggedTemplateLiteralLoose(["\n  --border-color: ", ";\n  --cross-color: rgba(0, 0, 0, 0.15);\n\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--border-color);\n  background-color: #fff;\n  box-sizing: border-box;\n\n  background-image: linear-gradient(\n      to top right,\n      transparent calc(50% - 1px),\n      var(--cross-color),\n      transparent calc(50% + 1px)\n    ),\n    linear-gradient(\n      to bottom right,\n      transparent calc(50% - 1px),\n      var(--cross-color),\n      transparent calc(50% + 1px)\n    );\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n"])), Colors.galBlack21);
var TemplateTopYearScaled = styled(TemplateTopYear)(_templateObject10$n || (_templateObject10$n = _taggedTemplateLiteralLoose(["\n  // font-size: ", "pt;\n  &.template_year_vertical {\n    font-size: 16.5px;\n    margin-bottom: 9px;\n    @media ", " {\n      font-size: 12.75px;\n      margin-bottom: 7px;\n    }\n    @media ", " {\n      font-size: 9.75px;\n      margin-bottom: 6px;\n    }\n    @media ", " {\n      font-size: ", "px;\n    }\n  }\n  &.template_year_horizontal {\n    font-size: 8.5px;\n    margin-bottom: 3px;\n    @media ", " {\n      font-size: 7px;\n      margin-bottom: 2px;\n    }\n    @media ", " {\n      font-size: 5.5px;\n      margin-bottom: 1px;\n    }\n    @media ", " {\n      font-size: ", "px;\n    }\n  }\n  &.template_year_free {\n    justify-content: center;\n    letter-spacing: 4px;\n    font-size: 7px;\n    margin-bottom: 12px;\n    @media ", " {\n      font-size: 6px;\n      margin-bottom: 10px;\n      letter-spacing: 3px;\n    }\n    @media ", " {\n      font-size: 5px;\n      margin-bottom: 8px;\n    }\n    @media ", " {\n      font-size: ", "px;\n    }\n  }\n"])), function (_ref3) {
  var scaleSize = _ref3.scaleSize;
  return 48 * scaleSize;
}, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, function (_ref4) {
  var scaleSize = _ref4.scaleSize;
  return 48 * scaleSize;
}, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, function (_ref5) {
  var scaleSize = _ref5.scaleSize;
  return 48 * scaleSize;
}, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, function (_ref6) {
  var scaleSize = _ref6.scaleSize;
  return 41 * scaleSize;
});
var TemplateBottomTitleScaled = styled(TemplateBottomTitle)(_templateObject11$n || (_templateObject11$n = _taggedTemplateLiteralLoose(["\n  // span {\n  //   font-size: ", ";\n  //   line-height: ", ";\n  // }\n  &.template_title_vertical {\n    span {\n      font-size: 16.5px;\n      line-height: 100%;\n      @media ", " {\n        font-size: 12.5px;\n      }\n      @media ", " {\n        font-size: 11.25px;\n      }\n      ", "\n    }\n  }\n  &.template_title_horizontal {\n    span {\n      font-size: 8.5px;\n      line-height: 100%;\n      @media ", " {\n        font-size: 7px;\n      }\n      @media ", " {\n        font-size: 5.5px;\n      }\n      ", "\n    }\n  }\n"])), function (_ref7) {
  var scaleSize = _ref7.scaleSize;
  return 50.3 * scaleSize + "pt";
}, function (_ref8) {
  var scaleSize = _ref8.scaleSize;
  return 50.3 * scaleSize + "pt";
}, MEDIA.LAPTOP, MEDIA.TABLET, function (p) {
  return css(_templateObject12$n || (_templateObject12$n = _taggedTemplateLiteralLoose(["\n          @media ", " {\n            font-size: ", "px;\n            line-height: ", "px;\n          }\n        "])), MEDIA.MOBILE, (p.largeText ? 47.3 : 50.3) * p.scaleSize, (p.largeText ? 47.3 : 50.3) * p.scaleSize);
}, MEDIA.LAPTOP, MEDIA.TABLET, function (p) {
  return css(_templateObject13$n || (_templateObject13$n = _taggedTemplateLiteralLoose(["\n          @media ", " {\n            font-size: ", "px;\n            line-height: ", "px;\n          }\n        "])), MEDIA.MOBILE, (p.largeText ? 47.3 : 50.3) * p.scaleSize, (p.largeText ? 47.3 : 50.3) * p.scaleSize);
});
var TitleScaled = styled(Title$1)(_templateObject14$h || (_templateObject14$h = _taggedTemplateLiteralLoose(["\n  &.template_title_free {\n    font-size: 6px;\n    line-height: 100%;\n    @media ", " {\n      font-size: 6px;\n    }\n    @media ", " {\n      font-size: 4px;\n    }\n    @media ", " {\n      font-size: ", ";\n    }\n  }\n"])), MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, function (_ref9) {
  var scaleSize = _ref9.scaleSize;
  return 32 * scaleSize + "px";
});
var extractSecondCalcValue = function extractSecondCalcValue(scaleSize) {
  if (typeof scaleSize !== 'string') return scaleSize;
  try {
    var second = scaleSize.split(',')[1];
    if (!second) return NaN;
    var match = second.match(/calc\s*\(([^)]+)\)/i);
    if (!match) return NaN;
    var expression = match[1];
    var _expression$split$map = expression.split('/').map(function (v) {
        return parseFloat(v);
      }),
      num = _expression$split$map[0],
      denom = _expression$split$map[1];
    if (isNaN(num) || isNaN(denom) || denom === 0) return NaN;
    return num / denom;
  } catch (_unused) {
    return NaN;
  }
};
var CalendarImagePlaceholder = function CalendarImagePlaceholder(_ref10) {
  var _ref10$orientation = _ref10.orientation,
    orientation = _ref10$orientation === void 0 ? 'free' : _ref10$orientation,
    title = _ref10.title,
    year = _ref10.year,
    isHorizontal = _ref10.isHorizontal,
    bottomTitleArr = _ref10.bottomTitleArr,
    isPrinting = _ref10.isPrinting,
    scaleSize = _ref10.scaleSize;
  var items = Array.from({
    length: 12
  });
  var scale = extractSecondCalcValue(scaleSize);
  return /*#__PURE__*/React$1.createElement(MainContainer, {
    className: "placeholder_container_" + orientation
  }, year ? /*#__PURE__*/React$1.createElement(TemplateTopYearScaled, {
    scaleSize: scale,
    className: "template_year_" + orientation
  }, year) : /*#__PURE__*/React$1.createElement(YearPlaceholder, {
    className: "year_" + orientation,
    isScaled: false
  }), /*#__PURE__*/React$1.createElement(ImagePlaceholderContainer, {
    className: "image_placeholder_" + orientation
  }, items.map(function (_, index) {
    return /*#__PURE__*/React$1.createElement(PreviewItemContainer, {
      key: index,
      className: "preview_item_" + orientation
    }, /*#__PURE__*/React$1.createElement(PreviewItemBlock, null));
  })), bottomTitleArr ? /*#__PURE__*/React$1.createElement(TemplateBottomLine, {
    isPrinting: isPrinting,
    isHorizontal: isHorizontal
  }, /*#__PURE__*/React$1.createElement(TemplateBottomTitleScaled, {
    largeText: title && title.length > 20,
    isHorizontal: isHorizontal,
    scaleSize: scaleSize,
    className: "template_title_" + orientation
  }, !!(bottomTitleArr && bottomTitleArr.length) && bottomTitleArr.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index + " " + item,
      dangerouslySetInnerHTML: {
        __html: "" + item
      }
    });
  }))) : title ? /*#__PURE__*/React$1.createElement(TitleScaled, {
    className: "template_title_" + orientation,
    scaleSize: scale
  }, title) : /*#__PURE__*/React$1.createElement(TitlePlaceholder, {
    className: "title_" + orientation,
    isScaled: false
  }));
};

var _templateObject$1C, _templateObject2$1C, _templateObject3$1B, _templateObject4$1f, _templateObject5$16, _templateObject6$15, _templateObject7$14, _templateObject8$11, _templateObject9$$, _templateObject10$o, _templateObject11$o, _templateObject12$o, _templateObject13$o, _templateObject14$i, _templateObject15$6, _templateObject16, _templateObject17;
var TimelineCoverMain = styled.div(_templateObject$1C || (_templateObject$1C = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  width: ", "mm;\n  height: ", "mm;\n  padding: ", ";\n  max-height: 388mm;\n\n  @media print {\n    ", "\n  }\n\n  ", "\n\n  ", "\n"])), function (p) {
  return p.mainWidth;
}, function (p) {
  return p.mainHeight;
}, function (p) {
  return p.padding;
}, function (_ref) {
  var isPrinting = _ref.isPrinting;
  return !isPrinting ? 'page-break-after: always;' : '';
}, function (_ref2) {
  var isPrinting = _ref2.isPrinting,
    scaleSize = _ref2.scaleSize;
  return !isPrinting && css(_templateObject2$1C || (_templateObject2$1C = _taggedTemplateLiteralLoose(["\n      transform: scale(", ");\n      transform-origin: left top;\n    "])), scaleSize);
}, function (_ref3) {
  var isPrinting = _ref3.isPrinting,
    isHorizontal = _ref3.isHorizontal;
  return isPrinting && css(_templateObject3$1B || (_templateObject3$1B = _taggedTemplateLiteralLoose(["\n      max-height: none;\n      overflow: hidden;\n      padding: ", ";\n      height: ", "mm;\n      width: ", "mm;\n    "])), isHorizontal ? '25.5mm 20mm 0' : '55mm 10mm 0mm', isHorizontal ? '420' : '640.147', isHorizontal ? '594' : '300');
});
var TemplateTopLine = styled.div(_templateObject4$1f || (_templateObject4$1f = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 3%;\n  align-items: flex-end;\n\n  ", "\n"])), function (_ref4) {
  var isPrinting = _ref4.isPrinting,
    isHorizontal = _ref4.isHorizontal;
  return isPrinting && css(_templateObject5$16 || (_templateObject5$16 = _taggedTemplateLiteralLoose(["\n      margin-bottom: ", "mm;\n    "])), isHorizontal ? 5.8 : 8.5);
});
var CalendarPictures = styled.div(_templateObject6$15 || (_templateObject6$15 = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: repeat(\n    ", ",\n    1fr\n  );\n  grid-template-rows: repeat(\n    ", ",\n    1fr\n  );\n\n  @media (max-width: 734px) {\n    width: 100%;\n  }\n"])), function (_ref5) {
  var isHorizontal = _ref5.isHorizontal;
  return isHorizontal ? 4 : 3;
}, function (_ref6) {
  var isHorizontal = _ref6.isHorizontal;
  return isHorizontal ? 3 : 4;
});
var TimelinePicWrapper = styled.div(_templateObject7$14 || (_templateObject7$14 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: ", ";\n\n  @media (max-width: 734px) {\n    height: 100%;\n    height: ", ";\n  }\n\n  ", "\n"])), function (p) {
  return p.isHorizontal ? '49mm' : '120mm';
}, function (p) {
  return p.isHorizontal ? '49mm' : '120mm';
}, function (_ref7) {
  var isPrinting = _ref7.isPrinting,
    isHorizontal = _ref7.isHorizontal;
  return isPrinting && css(_templateObject8$11 || (_templateObject8$11 = _taggedTemplateLiteralLoose(["\n      height: ", ";\n    "])), isHorizontal ? '102.5mm' : '112.1mm');
});
var TimelinePic = styled.img(_templateObject9$$ || (_templateObject9$$ = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  background-color: #ffffff !important;\n\n  ", "\n"])), function (_ref8) {
  var isPrinting = _ref8.isPrinting,
    isHorizontal = _ref8.isHorizontal;
  return isPrinting && css(_templateObject10$o || (_templateObject10$o = _taggedTemplateLiteralLoose(["\n      height: ", ";\n    "])), isHorizontal ? '102.5mm' : '112.1mm');
});
var TemplateBottomLine$1 = styled.div(_templateObject11$o || (_templateObject11$o = _taggedTemplateLiteralLoose(["\n  margin-top: 2%;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n"])), function (_ref9) {
  var isPrinting = _ref9.isPrinting;
  return isPrinting && css(_templateObject12$o || (_templateObject12$o = _taggedTemplateLiteralLoose(["\n      margin-top: 8.2mm;\n    "])));
});
var TemplateBottomTitle$1 = styled.div(_templateObject13$o || (_templateObject13$o = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  column-gap: 2mm;\n  white-space: nowrap;\n  margin-top: ", ";\n\n  span {\n    color: #002d6e;\n    font-size: ", "pt;\n    line-height: ", "pt;\n    text-transform: uppercase;\n    font-family: HSE Sans;\n    &:nth-of-type(2n) {\n      font-weight: 400;\n      letter-spacing: 0.025em;\n    }\n    &:nth-of-type(2n + 1) {\n      font-weight: 700;\n    }\n  }\n"])), function (_ref10) {
  var isHorizontal = _ref10.isHorizontal;
  return isHorizontal ? 0 : '0mm -1mm';
}, function (p) {
  return p.largeText ? 47.3 : 50.3;
}, function (p) {
  return p.largeText ? 47.3 : 50.3;
});
var TemplateBottomSubtitle = styled.div(_templateObject14$i || (_templateObject14$i = _taggedTemplateLiteralLoose(["\n  display: flex;\n  color: #002d6e;\n  font-family: HSE Sans;\n  //white-space: nowrap;\n  width: 100%;\n  font-size: 30pt;\n  word-wrap: break-word;\n  word-break: break-all;\n"])));
var TemplateTopLogo = styled.div(_templateObject15$6 || (_templateObject15$6 = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n  display: flex;\n  flex-direction: column;\n  width: min-content;\n  font-size: 24pt;\n  line-height: 100%;\n  max-height: 48pt;\n  height: 48pt;\n  width: fit-content;\n  color: #002d6e;\n  span {\n    font-family: HSE Sans;\n    &:nth-of-type(2n) {\n      font-weight: 400;\n    }\n    &:nth-of-type(2n + 1) {\n      font-weight: 700;\n    }\n  }\n  img {\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n  }\n"])));
var TemplateTopYear$1 = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteralLoose(["\n  font-family: HSE Sans;\n  color: #b22125;\n  font-size: 48pt;\n  display: flex;\n  align-items: start;\n  line-height: 100%;\n  letter-spacing: -0.01em;\n"])));
var TemplateTopTitle = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n  font-weight: 600;\n  font-family: 'Inter';\n  font-size: 19pt;\n  width: 210px;\n  line-height: 105%;\n"])));
var TimelineCardMasterTemplate = function TimelineCardMasterTemplate(props) {
  var images = props.images,
    year = props.year,
    title = props.title,
    defaultTitle = props.defaultTitle,
    orientation = props.orientation,
    size = props.size,
    scaleSize = props.scaleSize,
    logo = props.logo,
    isPrinting = props.isPrinting,
    isNeedImagePlaceholder = props.isNeedImagePlaceholder;
  var isHorizontal = orientation === 'horizontal';
  var usedBottomTitle = title || defaultTitle;
  var bottomTitleArr = usedBottomTitle && usedBottomTitle.trim().split(' ');
  if (isNeedImagePlaceholder) {
    return /*#__PURE__*/React$1.createElement(CalendarImagePlaceholder, {
      orientation: orientation,
      title: usedBottomTitle,
      year: year,
      isHorizontal: isHorizontal,
      bottomTitleArr: bottomTitleArr,
      isPrinting: isPrinting,
      scaleSize: scaleSize
    });
  }
  return /*#__PURE__*/React$1.createElement(TimelineCoverMain, {
    scaleSize: scaleSize || mainSize[orientation][size].scale,
    mainWidth: mainSize[orientation][size].width,
    mainHeight: mainSize[orientation][size].height,
    padding: mainSize[orientation][size].padding,
    isPrinting: isPrinting,
    isHorizontal: isHorizontal
  }, /*#__PURE__*/React$1.createElement(TemplateTopLine, {
    isPrinting: isPrinting,
    isHorizontal: isHorizontal
  }, /*#__PURE__*/React$1.createElement(TemplateTopLogo, null, logo && /*#__PURE__*/React$1.createElement("img", {
    src: logo,
    alt: "logo"
  })), /*#__PURE__*/React$1.createElement(TemplateTopTitle, null), year ? /*#__PURE__*/React$1.createElement(TemplateTopYear$1, null, year) : /*#__PURE__*/React$1.createElement(YearPlaceholder, {
    className: "year_" + orientation,
    isScaled: true
  })), /*#__PURE__*/React$1.createElement(CalendarPictures, {
    isHorizontal: isHorizontal
  }, !!(images && images.length) && images.map(function (image, index) {
    return /*#__PURE__*/React$1.createElement(TimelinePicWrapper, {
      key: index + " " + image,
      type: orientation,
      isHorizontal: isHorizontal,
      isPrinting: isPrinting
    }, /*#__PURE__*/React$1.createElement(TimelinePic, {
      isPrinting: isPrinting,
      isHorizontal: isHorizontal,
      src: image
    }));
  })), /*#__PURE__*/React$1.createElement(TemplateBottomLine$1, {
    isPrinting: isPrinting,
    isHorizontal: isHorizontal
  }, usedBottomTitle ? /*#__PURE__*/React$1.createElement(TemplateBottomTitle$1, {
    largeText: usedBottomTitle && usedBottomTitle.length > 20,
    isHorizontal: isHorizontal
  }, !!(bottomTitleArr && bottomTitleArr.length) && bottomTitleArr.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index + " " + item,
      dangerouslySetInnerHTML: {
        __html: "" + item
      }
    });
  })) : /*#__PURE__*/React$1.createElement(TitlePlaceholder, {
    className: "title_" + orientation,
    isScaled: true
  })));
};

var TimelineCardS = function TimelineCardS(props) {
  return /*#__PURE__*/React$1.createElement(TimelineCardMasterTemplate, _extends({}, props, {
    orientation: 'vertical',
    size: 'small'
  }));
};

var TimelineCardSL = function TimelineCardSL(props) {
  return /*#__PURE__*/React$1.createElement(TimelineCardMasterTemplate, _extends({}, props, {
    orientation: 'horizontal',
    size: 'small'
  }));
};

var components$7 = {
  TimelineCardS: TimelineCardS,
  TimelineCardSL: TimelineCardSL
};
var TimelineStyleCard = function TimelineStyleCard(props) {
  var year = props.year,
    images = props.images,
    title = props.title,
    defaultTitle = props.defaultTitle,
    titleArray = props.titleArray,
    templateType = props.templateType,
    scaleSize = props.scaleSize,
    ownerName = props.ownerName,
    collectionName = props.collectionName,
    logo = props.logo,
    isNeedImagePlaceholder = props.isNeedImagePlaceholder;
  return React$1.createElement(components$7[templateType], {
    year: year,
    images: images,
    title: title && title.length && title.substring(0, 53),
    defaultTitle: defaultTitle,
    titleArray: titleArray,
    scaleSize: scaleSize,
    ownerName: ownerName || '',
    collectionName: collectionName || '',
    logo: logo,
    isNeedImagePlaceholder: isNeedImagePlaceholder
  });
};

var _templateObject$1D, _templateObject2$1D, _templateObject3$1C, _templateObject4$1g;
var Wrapper$11 = styled.div(_templateObject$1D || (_templateObject$1D = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  transform: scale(calc(", " / 210), calc(", " / 297));\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var AccountWrapper = styled.div(_templateObject2$1D || (_templateObject2$1D = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    flex-flow: column;\n    position: relative;\n    background-color: #fff;\n    padding: 7.42mm;\n    justify-content: space-between;\n    box-sizing: border-box;\n"])));
var CoverContainer$1 = styled.div(_templateObject3$1C || (_templateObject3$1C = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: calc(100% - 20.13vw);\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  img {\n    width: 100%;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var Title$2 = styled.div(_templateObject4$1g || (_templateObject4$1g = _taggedTemplateLiteralLoose(["\n    font-family: Roboto;\n    font-size: 13.28mm;\n    line-height: 13.28mm;\n    color: #151514;\n    font-weight: 700;\n    white-space: pre-wrap;\n    text-align: center;\n    word-wrap: break-word;\n    text-transform: uppercase;\n    margin-top: 6.85mm;\n"])));
var AccountCardMain = function AccountCardMain(props) {
  var dw = props.dw,
    dh = props.dh,
    serviceName = props.serviceName,
    image = props.image,
    baseUrl = props.baseUrl;
  var orientation = useMemo(function () {
    return image && (image.orientaion || image.Orientaion);
  }, [image]);
  var ratio = useMemo(function () {
    return image && (image.ratio || image.Ratio);
  }, [image]);
  var isSquare = useMemo(function () {
    if (!image) return false;
    if (image.width && image.height) return image.width === image.height;
    return image.Width === image.Height;
  }, [image]);
  var imageUrl = useMemo(function () {
    if (image && image.url) return baseUrl + "/" + image.url;
    return image && image.Url ? baseUrl + "/" + image.Url : '';
  }, [image, baseUrl]);
  return /*#__PURE__*/React$1.createElement(Wrapper$11, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(AccountWrapper, null, /*#__PURE__*/React$1.createElement(CoverContainer$1, {
    orientation: orientation,
    ratio: ratio,
    isSquare: isSquare
  }, /*#__PURE__*/React$1.createElement("img", {
    src: imageUrl,
    alt: ""
  })), serviceName && serviceName.length && /*#__PURE__*/React$1.createElement(Title$2, null, serviceName)));
};

var components$8 = {
  AccountCardMain: AccountCardMain
};
var AccountCard = function AccountCard(props) {
  var data = props.data,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$8[templateType], {
    dw: dw,
    dh: dh,
    serviceName: data && data.serviceName || '',
    baseUrl: data && data.baseUrl || '',
    image: data && data.image || undefined
  });
};

var useResizedImageEnhanced = function useResizedImageEnhanced(files, useRatio) {
  var filesSafe = useMemo(function () {
    return files ? [].concat(files) : [];
  }, [files]);
  var containerRef = useRef(null);
  var _useState = useState(),
    container = _useState[0],
    setContainer = _useState[1];
  var containerWidth = container && container.offsetWidth;
  var containerHeight = container && container.offsetHeight;
  var pixelRatio = window.devicePixelRatio <= 2 ? window.devicePixelRatio : 2;
  var targetWidth = (containerWidth || 0) * pixelRatio;
  var targetHeight = useRatio ? pixelRatio * (containerWidth || 0) / (files ? files[0].ratio : 0) : (containerHeight || 0) * pixelRatio;
  var image = useMemo(function () {
    if (!containerWidth) {
      return null;
    }
    var _filesSafe$reduce = filesSafe.reduce(function (result, item) {
        var width = item.width,
          height = item.height;
        var area = width * height;
        var smallestArea = result.smallestArea;
        if (width >= targetWidth && height >= targetHeight && (!smallestArea || area < smallestArea)) {
          return {
            resized: item,
            smallestArea: area
          };
        }
        return result;
      }, {
        smallestArea: 0,
        resized: null
      }),
      resized = _filesSafe$reduce.resized;
    var _filesSafe$reduce2 = filesSafe.reduce(function (result, item) {
        var width = item.width,
          height = item.height;
        var area = width * height;
        var largestArea = result.largestArea;
        if (!largestArea || area > largestArea) {
          return {
            largest: item,
            largestArea: area
          };
        }
        return result;
      }, {
        largestArea: 0,
        largest: null
      }),
      largest = _filesSafe$reduce2.largest;
    return resized || largest;
  }, [targetWidth, filesSafe]);
  useEffect(function () {
    if (containerRef.current) {
      setContainer(containerRef.current);
    }
  }, []);
  return [image, containerRef];
};

var WEEKS = [{
  title: {
    ru: 'Пн',
    en: 'Mo'
  },
  isWeekend: false
}, {
  title: {
    ru: 'Вт',
    en: 'Tu'
  },
  isWeekend: false
}, {
  title: {
    ru: 'Ср',
    en: 'We'
  },
  isWeekend: false
}, {
  title: {
    ru: 'Чт',
    en: 'Th'
  },
  isWeekend: false
}, {
  title: {
    ru: 'Пт',
    en: 'Fr'
  },
  isWeekend: false
}, {
  title: {
    ru: 'Сб',
    en: 'Sa'
  },
  isWeekend: true
}, {
  title: {
    ru: 'Вс',
    en: 'Su'
  },
  isWeekend: true
}];
var LINES = 5;
var DAYS_IN_WEEK = 7;
var HOLIDAYS = ['1-1', '2-1', '3-1', '4-1', '5-1', '6-1', '7-1', '8-1', '23-2', '8-3', '1-5', '9-5', '12-6', '4-11'];
var MONTHS_FULL_NAMES = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
var langVariant = {
  ru: 'ru-RU',
  en: 'en-US'
};
var getRussianDay = function getRussianDay(day) {
  if (day === 0) return 6;
  return day - 1;
};
var getDaysInMonth = function getDaysInMonth(year, month) {
  var newDate = new Date(year, month, 1);
  newDate.setMonth(newDate.getMonth() + 1);
  newDate.setDate(newDate.getDate() - 1);
  return newDate.getDate();
};
var isEventDay = function isEventDay(year, month, day, events) {
  if (!(events && events.length)) return false;
  var realMonth = month + 1;
  var date = year + '-' + (realMonth < 10 ? '0' + realMonth : realMonth) + '-' + (day < 10 ? '0' + day : day);
  return events.findIndex(function (_ref) {
    var fullDate = _ref.fullDate;
    return fullDate === date;
  }) !== -1;
};
var isDayInRange = function isDayInRange(year, month, day, startDate, endDate) {
  var realMonth = month + 1;
  var dateString = year + '-' + (realMonth < 10 ? '0' + realMonth : realMonth) + '-' + (day < 10 ? '0' + day : day);
  var date = new Date(dateString);
  return date >= startDate && date <= endDate;
};
var isWeekendDay = function isWeekendDay(weekDay, month, day, withSaturday) {
  if (withSaturday === void 0) {
    withSaturday = true;
  }
  if ((weekDay % 7 === 5 && withSaturday || weekDay % 7 === 6) && weekDay !== 0) return true;
  return HOLIDAYS.includes(day + '-' + (month + 1));
};
var getDateViewerData = function getDateViewerData(currentMonth, events, isHorizontal, startDateString, calendarType, withSaturday) {
  var data = [];
  var startDate = new Date(startDateString);
  var endDate = new Date(startDate);
  endDate.setFullYear(endDate.getFullYear() + 1);
  if (calendarType === 0) {
    endDate.setDate(endDate.getDate() - 1);
  }
  var currentMonthNumber = currentMonth.getMonth();
  var currentDayNumber = currentMonth.getDay();
  var currentFullYearNumber = currentMonth.getFullYear();
  if (!isHorizontal) for (var i = 0; i < getRussianDay(currentDayNumber); i++) data.push([]);
  for (var _i = 0; _i < getDaysInMonth(currentFullYearNumber, currentMonthNumber); _i++) {
    var day = _i + 1;
    if (data.length >= LINES * DAYS_IN_WEEK && !isHorizontal) {
      var extraDayIndex = _i + getRussianDay(currentDayNumber) - DAYS_IN_WEEK;
      data[extraDayIndex].push({
        title: day,
        isEvent: isEventDay(currentFullYearNumber, currentMonthNumber, day, events),
        isInRange: isDayInRange(currentFullYearNumber, currentMonthNumber, day, startDate, endDate),
        isWeekend: isWeekendDay(extraDayIndex, currentMonthNumber, day, withSaturday)
      });
      continue;
    }
    data.push([{
      title: day,
      isEvent: isEventDay(currentFullYearNumber, currentMonthNumber, day, events),
      isInRange: isDayInRange(currentFullYearNumber, currentMonthNumber, day, startDate, endDate),
      isWeekend: isWeekendDay(isHorizontal ? data.length + getRussianDay(currentDayNumber) : data.length, currentMonthNumber, day, withSaturday)
    }]);
  }
  if (!isHorizontal) for (var _i2 = data.length; _i2 < LINES * DAYS_IN_WEEK; _i2++) data.push([]);
  return data;
};
var getFirstMonthDay = function getFirstMonthDay(currentMonth) {
  var currentDayNumber = currentMonth.getDay();
  return getRussianDay(currentDayNumber);
};
var getDateViewerTitle = function getDateViewerTitle(currentMonth, format) {
  if (format === void 0) {
    format = 'en';
  }
  return currentMonth.toLocaleString(langVariant[format], {
    month: 'long'
  });
};
var getEventString = function getEventString(event) {
  var date = new Date(event.fullDate);
  var month = date.getMonth();
  var day = date.getDate();
  return day + " " + MONTHS_FULL_NAMES[month] + " \u2014 " + event.description;
};
var useMonthEvents = function useMonthEvents(_ref2) {
  var date = _ref2.date,
    events = _ref2.events,
    startDateString = _ref2.startDate,
    calendarType = _ref2.calendarType;
  var monthEvents = useMemo(function () {
    var _events$filter;
    var cardMonth = date.getMonth();
    var cardYear = date.getFullYear();
    var startDate = new Date(startDateString);
    var endDate = new Date(startDate);
    endDate.setFullYear(endDate.getFullYear() + 1);
    if (calendarType === 0) {
      endDate.setDate(endDate.getDate() - 1);
    }
    return (events === null || events === void 0 ? void 0 : (_events$filter = events.filter(function (event) {
      var eventDate = new Date(event.fullDate);
      var eventYear = eventDate.getFullYear();
      var eventMonth = eventDate.getMonth();
      return eventYear === cardYear && eventMonth === cardMonth && eventDate >= startDate && eventDate <= endDate;
    })) === null || _events$filter === void 0 ? void 0 : _events$filter.sort(function (ev1, ev2) {
      return (ev1 === null || ev1 === void 0 ? void 0 : ev1.day) - (ev2 === null || ev2 === void 0 ? void 0 : ev2.day);
    })) || [];
  }, [date, events]);
  return monthEvents;
};

var _templateObject$1E, _templateObject2$1E, _templateObject3$1D;
var DatesContainer = styled.div(_templateObject$1E || (_templateObject$1E = _taggedTemplateLiteralLoose(["\n  height: 29%;\n  display: flex;\n  flex-direction: column;\n"])));
var DatesTable = styled.table(_templateObject2$1E || (_templateObject2$1E = _taggedTemplateLiteralLoose(["\n  border-collapse: collapse;\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n\n  & > thead {\n    height: 33%;\n    font-size: 18px;\n  }\n\n  & > tbody {\n    font-family: Baskerville;\n    font-style: italic;\n    font-size: 44px;\n  }\n"])));
var DayCell = styled.td(_templateObject3$1D || (_templateObject3$1D = _taggedTemplateLiteralLoose(["\n  border-width: ", "px;\n  border-color: ", ";\n  border-style: solid;\n  text-align: center;\n  color: ", ";\n"])), function (_ref) {
  var isEvent = _ref.isEvent,
    isInRange = _ref.isInRange;
  return isEvent && isInRange ? 3 : 1;
}, function (_ref2) {
  var isEvent = _ref2.isEvent,
    isInRange = _ref2.isInRange;
  return isEvent && isInRange ? '#d2232a' : '#252525';
}, function (_ref3) {
  var isEvent = _ref3.isEvent,
    isWeekend = _ref3.isWeekend,
    isInRange = _ref3.isInRange;
  return isInRange ? isWeekend || isEvent ? '#b4282e' : '#000000' : isWeekend || isEvent ? '#e0a9ac' : '#c8c8c8';
});
var CalendarHorizontalTable = function CalendarHorizontalTable(_ref4) {
  var date = _ref4.date,
    events = _ref4.events,
    isHorizontal = _ref4.isHorizontal,
    startDate = _ref4.startDate,
    calendarType = _ref4.calendarType,
    localization = _ref4.localization;
  var firstMonthDay = useMemo(function () {
    return getFirstMonthDay(date);
  }, [date]);
  var calendarMonthData = useMemo(function () {
    return getDateViewerData(date, events, isHorizontal, startDate, calendarType);
  }, [date, events, isHorizontal, startDate, calendarType]);
  return /*#__PURE__*/React$1.createElement(DatesContainer, null, /*#__PURE__*/React$1.createElement(DatesTable, null, /*#__PURE__*/React$1.createElement("thead", null, /*#__PURE__*/React$1.createElement("tr", null, calendarMonthData === null || calendarMonthData === void 0 ? void 0 : calendarMonthData.map(function (items, index) {
    var _items$, _items$2;
    var currentDate = WEEKS[(index + firstMonthDay) % WEEKS.length];
    return /*#__PURE__*/React$1.createElement(DayCell, {
      key: String(currentDate.title[localization]) + index,
      isWeekend: Boolean(items === null || items === void 0 ? void 0 : items.length) && ((_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.isWeekend),
      isInRange: Boolean(items === null || items === void 0 ? void 0 : items.length) && ((_items$2 = items[0]) === null || _items$2 === void 0 ? void 0 : _items$2.isInRange)
    }, currentDate.title[localization]);
  }))), /*#__PURE__*/React$1.createElement("tbody", null, /*#__PURE__*/React$1.createElement("tr", null, calendarMonthData.map(function (items, index) {
    if (items.length) {
      var _items$3, _items$4, _items$5;
      return /*#__PURE__*/React$1.createElement(DayCell, {
        isEvent: Boolean(items === null || items === void 0 ? void 0 : items.length) && ((_items$3 = items[0]) === null || _items$3 === void 0 ? void 0 : _items$3.isEvent),
        isWeekend: Boolean(items === null || items === void 0 ? void 0 : items.length) && ((_items$4 = items[0]) === null || _items$4 === void 0 ? void 0 : _items$4.isWeekend),
        isInRange: Boolean(items === null || items === void 0 ? void 0 : items.length) && ((_items$5 = items[0]) === null || _items$5 === void 0 ? void 0 : _items$5.isInRange),
        key: index + String(items[0].title)
      }, items[0].title);
    }
    return null;
  })))));
};

var _templateObject$1F, _templateObject2$1F, _templateObject3$1E, _templateObject4$1h, _templateObject5$17, _templateObject6$16, _templateObject7$15, _templateObject8$12;
var TitlesBlock = styled.div(_templateObject$1F || (_templateObject$1F = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 37.9%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var LeftSection = styled.div(_templateObject2$1F || (_templateObject2$1F = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 25%;\n"])));
var MiddleSection = styled.div(_templateObject3$1E || (_templateObject3$1E = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 65%;\n  text-wrap: nowrap;\n  white-space: nowrap;\n  overflow: hidden;\n  padding-bottom: 2px !important;\n"])));
var RightSection = styled.div(_templateObject4$1h || (_templateObject4$1h = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n  width: 25%;\n"])));
var MonthTitle = styled.span(_templateObject5$17 || (_templateObject5$17 = _taggedTemplateLiteralLoose(["\n  font-weight: 700;\n  font-size: 84px;\n  text-transform: uppercase;\n  text-wrap: nowrap;\n  white-space: nowrap;\n  font-style: normal;\n"])));
var MonthEvents = styled.div(_templateObject6$16 || (_templateObject6$16 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  font-size: 11px;\n"])));
var MonthTitleInEvents = styled.div(_templateObject7$15 || (_templateObject7$15 = _taggedTemplateLiteralLoose(["\n  font-family: Baskerville;\n  font-style: italic;\n  font-size: 40px;\n  letter-spacing: ", "px;\n  margin-bottom: ", ";\n"])), function (_ref) {
  var withSignAndMonth = _ref.withSignAndMonth;
  return withSignAndMonth ? 4 : 5;
}, function (_ref2) {
  var withSignAndMonth = _ref2.withSignAndMonth;
  return withSignAndMonth && '-10px !important';
});
var DescriptionSubtitle = styled.div(_templateObject8$12 || (_templateObject8$12 = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  word-wrap: break-word;\n  word-break: break-all;\n  overflow: hidden;\n  margin-bottom: ", "px !important;\n  margin-top: 3px !important;\n"])), function (_ref3) {
  var withSignAndMonth = _ref3.withSignAndMonth;
  return withSignAndMonth ? 6 : 0;
});
var CalendarHorizontalTitles = function CalendarHorizontalTitles(_ref4) {
  var events = _ref4.events,
    date = _ref4.date,
    cardTitle = _ref4.cardTitle,
    author = _ref4.author,
    startDate = _ref4.startDate,
    calendarType = _ref4.calendarType,
    localization = _ref4.localization;
  var monthEvents = useMonthEvents({
    date: date,
    events: events,
    startDate: startDate,
    calendarType: calendarType
  });
  var calendarMonthTitle = useMemo(function () {
    var month = getDateViewerTitle(date, localization);
    return month.charAt(0).toUpperCase() + month.slice(1);
  }, [date, localization]);
  var monthTitle = Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length) && cardTitle.slice(0, 20) || calendarMonthTitle || '';
  var isMonthOnTheRight = Boolean(monthEvents === null || monthEvents === void 0 ? void 0 : monthEvents.length) && Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length);
  return /*#__PURE__*/React$1.createElement(TitlesBlock, null, /*#__PURE__*/React$1.createElement(LeftSection, null, monthEvents !== null && monthEvents !== void 0 && monthEvents.length ? /*#__PURE__*/React$1.createElement(MonthEvents, null, monthEvents.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index
    }, getEventString(item));
  })) : Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length) && /*#__PURE__*/React$1.createElement(MonthTitleInEvents, null, calendarMonthTitle)), /*#__PURE__*/React$1.createElement(MiddleSection, null, /*#__PURE__*/React$1.createElement(MonthTitle, null, monthTitle)), /*#__PURE__*/React$1.createElement(RightSection, {
    withSignAndMonth: isMonthOnTheRight && Boolean(author === null || author === void 0 ? void 0 : author.length)
  }, Boolean(author === null || author === void 0 ? void 0 : author.length) && /*#__PURE__*/React$1.createElement(DescriptionSubtitle, {
    withSignAndMonth: isMonthOnTheRight && Boolean(author === null || author === void 0 ? void 0 : author.length)
  }, author), isMonthOnTheRight && /*#__PURE__*/React$1.createElement(MonthTitleInEvents, {
    withSignAndMonth: isMonthOnTheRight && Boolean(author === null || author === void 0 ? void 0 : author.length)
  }, calendarMonthTitle)));
};

var _templateObject$1G, _templateObject2$1G, _templateObject3$1F;
var ImageContainer = styled.div(_templateObject$1G || (_templateObject$1G = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$W = styled.div(_templateObject2$1G || (_templateObject2$1G = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    aspect-ratio: ", ";\n    object-fit: cover;\n    background-color: #ffffff !important;\n  }\n"])), function (_ref) {
  var imgAspectRatio = _ref.imgAspectRatio;
  return imgAspectRatio;
});
var AuthorTitle = styled.div(_templateObject3$1F || (_templateObject3$1F = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: 0px;\n  right: -1.6em;\n  writing-mode: vertical-lr;\n  transform: rotate(180deg);\n  font-family: Inter;\n  font-size: 0.5625em;\n  z-index: 5;\n"])));
var ImageContent = function ImageContent(_ref2) {
  var img = _ref2.img,
    sideAuthor = _ref2.sideAuthor,
    imgAspectRatio = _ref2.imgAspectRatio,
    imageContentStyles = _ref2.imageContentStyles;
  return /*#__PURE__*/React$1.createElement(ImageContainer, {
    style: imageContentStyles
  }, /*#__PURE__*/React$1.createElement(ImageInner$W, {
    imgAspectRatio: imgAspectRatio
  }, /*#__PURE__*/React$1.createElement("img", {
    src: img === null || img === void 0 ? void 0 : img.url,
    alt: "",
    draggable: false
  }), /*#__PURE__*/React$1.createElement(AuthorTitle, null, sideAuthor)));
};

var _templateObject$1H, _templateObject2$1H, _templateObject3$1G, _templateObject4$1i;
var Footer = styled.footer(_templateObject$1H || (_templateObject$1H = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])), function (_ref) {
  var footerHeight = _ref.footerHeight;
  return footerHeight;
});
var Domain = styled.div(_templateObject2$1H || (_templateObject2$1H = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n  font-family: Inter;\n  font-weight: 700;\n  font-size: ", ";\n  margin-top: ", ";\n"])), function (_ref2) {
  var isHorizontal = _ref2.isHorizontal;
  return isHorizontal ? '32px' : '1.6em';
}, function (_ref3) {
  var isHorizontal = _ref3.isHorizontal;
  return !isHorizontal && '5px !important';
});
var MonthBottomRight = styled.div(_templateObject3$1G || (_templateObject3$1G = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  margin-top: ", ";\n\n  & > svg {\n    margin-bottom: 4px;\n  }\n"])), function (_ref4) {
  var isHorizontal = _ref4.isHorizontal;
  return isHorizontal ? '30px' : '43px';
}, function (_ref5) {
  var isHorizontal = _ref5.isHorizontal;
  return !isHorizontal && '5px !important';
});
var MonthCollectionName = styled.div(_templateObject4$1i || (_templateObject4$1i = _taggedTemplateLiteralLoose(["\n  color: #002d6e;\n  text-transform: uppercase;\n  font-family: HSE Sans;\n  font-weight: 700;\n  font-size: ", ";\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n\n  span {\n    color: #002d6e;\n    &:nth-of-type(2n) {\n      font-weight: 400;\n      letter-spacing: 0.05em;\n    }\n    &:nth-of-type(2n + 1) {\n      font-weight: 700;\n      letter-spacing: 0.07em;\n    }\n    &:not(:first-child) {\n      margin-left: -1mm;\n    }\n  }\n"])), function (_ref6) {
  var isHorizontal = _ref6.isHorizontal;
  return isHorizontal ? '32.4px' : '1.6em';
});
var FooterContent = function FooterContent(_ref7) {
  var isHorizontal = _ref7.isHorizontal,
    title = _ref7.title,
    ownerName = _ref7.ownerName,
    bottomLink = _ref7.bottomLink,
    cardId = _ref7.cardId,
    footerHeight = _ref7.footerHeight,
    svgSize = _ref7.svgSize,
    footerStyles = _ref7.footerStyles;
  var usedTitle = title || ownerName;
  var titleArr = usedTitle && usedTitle.trim().split(' ');
  return /*#__PURE__*/React$1.createElement(Footer, {
    footerHeight: footerHeight,
    style: footerStyles
  }, /*#__PURE__*/React$1.createElement(Domain, {
    isHorizontal: isHorizontal
  }, bottomLink || 'gallllery.com'), /*#__PURE__*/React$1.createElement(MonthBottomRight, {
    isHorizontal: isHorizontal
  }, /*#__PURE__*/React$1.createElement(MonthCollectionName, {
    isHorizontal: isHorizontal
  }, !!(titleArr && titleArr.length) && titleArr.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index + "-" + item,
      dangerouslySetInnerHTML: {
        __html: item + "&ThinSpace;"
      }
    });
  })), /*#__PURE__*/React$1.createElement(QRCodeSVG, {
    size: svgSize,
    value: (bottomLink || 'gallllery.com') + "/card/" + cardId
  })));
};

var DPI = 300;
var MM_PER_INCH = 25.4;
var useResizedImageForPrint = function useResizedImageForPrint(files, calendarSizes) {
  var targetWidthPx = Math.round(calendarSizes.width / MM_PER_INCH * DPI);
  var targetHeightPx = Math.round(calendarSizes.height / MM_PER_INCH * DPI);
  var filesSafe = useMemo(function () {
    return files ? [].concat(files) : [];
  }, [files]);
  var image = useMemo(function () {
    var _filesSafe$reduce = filesSafe.reduce(function (result, item) {
        var area = item.width * item.height;
        if ((!result.largestArea || area > result.largestArea) && item.size !== 'original') {
          return {
            largest: item,
            largestArea: area
          };
        }
        return result;
      }, {
        largestArea: 0,
        largest: null
      }),
      largest = _filesSafe$reduce.largest;
    return largest;
  }, [targetWidthPx, targetHeightPx, filesSafe]);
  return image;
};

var _templateObject$1I, _templateObject2$1I;
var calendarSizes = {
  width: 594,
  height: 420
};
var CalendarContainer = styled.div(_templateObject$1I || (_templateObject$1I = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  min-height: ", "mm;\n  min-width: ", "mm;\n  max-height: ", "mm;\n  max-width: ", "mm;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform-origin: top left;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n\n  * {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (_ref) {
  var height = _ref.height;
  return height;
}, function (_ref2) {
  var width = _ref2.width;
  return width;
}, function (_ref3) {
  var height = _ref3.height;
  return height;
}, function (_ref4) {
  var width = _ref4.width;
  return width;
}, function (props) {
  return props.dw;
}, function (_ref5) {
  var width = _ref5.width;
  return width;
}, function (props) {
  return props.dh;
}, function (_ref6) {
  var height = _ref6.height;
  return height;
});
var TextContent = styled.div(_templateObject2$1I || (_templateObject2$1I = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 22%;\n  padding: 0 74px;\n  display: flex;\n  flex-direction: column;\n"])));
var CalendarHorizontal = function CalendarHorizontal(_ref7) {
  var cardId = _ref7.cardId,
    cardTitle = _ref7.cardTitle,
    author = _ref7.author,
    _ref7$images = _ref7.images,
    images = _ref7$images === void 0 ? [] : _ref7$images,
    sideAuthor = _ref7.sideAuthor,
    date = _ref7.date,
    events = _ref7.events,
    bottomLink = _ref7.bottomLink,
    title = _ref7.title,
    ownerName = _ref7.ownerName,
    _ref7$isHorizontal = _ref7.isHorizontal,
    isHorizontal = _ref7$isHorizontal === void 0 ? true : _ref7$isHorizontal,
    containerClass = _ref7.containerClass,
    style = _ref7.style,
    localization = _ref7.localization,
    dw = _ref7.dw,
    dh = _ref7.dh,
    startDate = _ref7.startDate,
    calendarType = _ref7.calendarType,
    isPrinting = _ref7.isPrinting;
  var _useResizedImageEnhan = useResizedImageEnhanced(images),
    img = _useResizedImageEnhan[0],
    containerRef = _useResizedImageEnhan[1];
  var printImage = useResizedImageForPrint(images, calendarSizes);
  return /*#__PURE__*/React$1.createElement(CalendarContainer, {
    ref: containerRef,
    className: containerClass,
    style: style,
    height: calendarSizes.height,
    width: calendarSizes.width,
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(ImageContent, {
    img: isPrinting ? printImage : img,
    sideAuthor: sideAuthor,
    imgAspectRatio: "1.8 / 1",
    imageContentStyles: {
      padding: '74px 74px 0'
    }
  }), /*#__PURE__*/React$1.createElement(TextContent, null, /*#__PURE__*/React$1.createElement(CalendarHorizontalTitles, {
    author: author,
    events: events,
    date: date,
    cardTitle: cardTitle,
    startDate: startDate,
    calendarType: calendarType,
    localization: localization
  }), /*#__PURE__*/React$1.createElement(CalendarHorizontalTable, {
    date: date,
    events: events,
    isHorizontal: isHorizontal,
    startDate: startDate,
    calendarType: calendarType,
    localization: localization
  }), /*#__PURE__*/React$1.createElement(FooterContent, {
    isHorizontal: isHorizontal,
    title: title,
    ownerName: ownerName,
    bottomLink: bottomLink,
    cardId: cardId,
    footerHeight: "33.5%",
    svgSize: 65,
    footerStyles: {
      paddingBottom: '15px'
    }
  })));
};

var _templateObject$1J, _templateObject2$1J, _templateObject3$1H, _templateObject4$1j, _templateObject5$18, _templateObject6$17, _templateObject7$16, _templateObject8$13, _templateObject9$10;
var TitlesContainer = styled.div(_templateObject$1J || (_templateObject$1J = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 26.8%;\n  display: flex;\n  flex-direction: column;\n"])));
var TitleAndDescBlock = styled.div(_templateObject2$1J || (_templateObject2$1J = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 65.2%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
var EventsAndMonthBlock = styled.div(_templateObject3$1H || (_templateObject3$1H = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 34.6%;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  padding: 0 88px 3px !important;\n"])), function (_ref) {
  var withoutEvents = _ref.withoutEvents;
  return withoutEvents ? 'center' : 'space-between';
});
var Title$3 = styled.div(_templateObject4$1j || (_templateObject4$1j = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  white-space: nowrap;\n  width: 100%;\n  flex: 1;\n  padding-top: 20px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n"])));
var DescriptionSubtitle$1 = styled.div(_templateObject5$18 || (_templateObject5$18 = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  line-height: 12px;\n  word-wrap: break-word;\n  word-break: break-all;\n  overflow: hidden;\n  height: 34.5%;\n"])));
var MonthSplitLine = styled.div(_templateObject6$17 || (_templateObject6$17 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"])));
var MonthSplitDot = styled.div(_templateObject7$16 || (_templateObject7$16 = _taggedTemplateLiteralLoose(["\n  width: 1px;\n  height: 1px;\n  background-color: black;\n  border-radius: 50%;\n"])));
var MonthEvents$1 = styled.div(_templateObject8$13 || (_templateObject8$13 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  font-size: 10px;\n"])));
var MonthTitleInEvents$1 = styled.div(_templateObject9$10 || (_templateObject9$10 = _taggedTemplateLiteralLoose(["\n  font-family: Baskerville;\n  font-style: italic;\n  font-size: 36px;\n  letter-spacing: 2px;\n  margin-right: -2px !important;\n"])));
var dots = Array(89).fill(0);
var CalendarVerticalTitles = function CalendarVerticalTitles(_ref2) {
  var cardTitle = _ref2.cardTitle,
    date = _ref2.date,
    author = _ref2.author,
    events = _ref2.events,
    startDate = _ref2.startDate,
    localization = _ref2.localization,
    calendarType = _ref2.calendarType;
  var calendarMonthTitle = useMemo(function () {
    var month = getDateViewerTitle(date, localization);
    return month.charAt(0).toUpperCase() + month.slice(1);
  }, [date, localization]);
  var monthEvents = useMonthEvents({
    date: date,
    events: events,
    startDate: startDate,
    calendarType: calendarType
  });
  var mainTitle = Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length) && cardTitle.slice(0, 20) || calendarMonthTitle || '';
  return /*#__PURE__*/React$1.createElement(TitlesContainer, null, /*#__PURE__*/React$1.createElement(TitleAndDescBlock, null, /*#__PURE__*/React$1.createElement(Title$3, null, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    width: "100%",
    fontSizeMax: 84,
    text: mainTitle
  })), /*#__PURE__*/React$1.createElement(DescriptionSubtitle$1, null, Boolean(author === null || author === void 0 ? void 0 : author.length) && author)), /*#__PURE__*/React$1.createElement(MonthSplitLine, null, dots.map(function (_, i) {
    return /*#__PURE__*/React$1.createElement(MonthSplitDot, {
      key: i
    });
  })), /*#__PURE__*/React$1.createElement(EventsAndMonthBlock, {
    withoutEvents: !(monthEvents !== null && monthEvents !== void 0 && monthEvents.length)
  }, /*#__PURE__*/React$1.createElement(MonthEvents$1, null, monthEvents === null || monthEvents === void 0 ? void 0 : monthEvents.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index
    }, getEventString(item));
  })), Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length) && /*#__PURE__*/React$1.createElement(MonthTitleInEvents$1, null, calendarMonthTitle)));
};

var _templateObject$1K, _templateObject2$1K, _templateObject3$1I, _templateObject4$1k, _templateObject5$19, _templateObject6$18;
var DayCell$1 = styled.td(_templateObject$1K || (_templateObject$1K = _taggedTemplateLiteralLoose(["\n  border-width: ", "px;\n  border-color: ", ";\n  border-style: solid;\n  text-align: center;\n  color: ", ";\n"])), function (_ref) {
  var isEvent = _ref.isEvent,
    isInRange = _ref.isInRange;
  return isEvent && isInRange ? 3 : 1;
}, function (_ref2) {
  var isEvent = _ref2.isEvent,
    isInRange = _ref2.isInRange;
  return isEvent && isInRange ? '#d2232a' : '#252525';
}, function (_ref3) {
  var isEvent = _ref3.isEvent,
    isWeekend = _ref3.isWeekend,
    isInRange = _ref3.isInRange;
  return isInRange ? isWeekend || isEvent ? '#b4282e' : '#000000' : isWeekend || isEvent ? '#e0a9ac' : '#c8c8c8';
});
var DayHeaderCell = styled.th(_templateObject2$1K || (_templateObject2$1K = _taggedTemplateLiteralLoose(["\n  border: 1px solid #252525;\n  text-align: center;\n  color: ", ";\n"])), function (_ref4) {
  var isWeekend = _ref4.isWeekend;
  return isWeekend ? '#b4282e' : '#000000';
});
var DoubleDayCell = styled.td(_templateObject3$1I || (_templateObject3$1I = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  border-top: ", ";\n\n  border-left: ", ";\n\n  border-right: ", ";\n\n  border-bottom: ", ";\n"])), function (_ref5) {
  var isTopEvent = _ref5.isTopEvent;
  return isTopEvent ? "3px solid #b43036" : '1px solid #252525';
}, function (_ref6) {
  var isTopEvent = _ref6.isTopEvent;
  return isTopEvent ? "3px solid #b43036" : '1px solid #252525';
}, function (_ref7) {
  var isBottomEvent = _ref7.isBottomEvent;
  return isBottomEvent ? "3px solid #b43036" : '1px solid #252525';
}, function (_ref8) {
  var isBottomEvent = _ref8.isBottomEvent;
  return isBottomEvent ? " 3px solid #b43036" : ' 1px solid #252525';
});
var DoubleDayContainer = styled.div(_templateObject4$1k || (_templateObject4$1k = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n\n  &::after {\n    content: '';\n    position: absolute;\n    width: ", "%;\n    left: ", "%;\n    height: ", "px;\n    transform: rotate(135deg);\n    bottom: ", "%;\n    background-color: ", ";\n  }\n"])), function (_ref9) {
  var isBottomEvent = _ref9.isBottomEvent,
    isTopEvent = _ref9.isTopEvent;
  return isBottomEvent || isTopEvent ? "144" : "142";
}, function (_ref10) {
  var isBottomEvent = _ref10.isBottomEvent,
    isTopEvent = _ref10.isTopEvent;
  return isBottomEvent || isTopEvent ? "-22" : "-21.1";
}, function (_ref11) {
  var isBottomEvent = _ref11.isBottomEvent,
    isTopEvent = _ref11.isTopEvent;
  return isBottomEvent || isTopEvent ? "3" : "1";
}, function (_ref12) {
  var isBottomEvent = _ref12.isBottomEvent,
    isTopEvent = _ref12.isTopEvent;
  return isBottomEvent || isTopEvent ? "48.4" : "49.5";
}, function (_ref13) {
  var isBottomEvent = _ref13.isBottomEvent,
    isTopEvent = _ref13.isTopEvent;
  return isBottomEvent || isTopEvent ? "#b43036" : "#252525";
});
var TopDay = styled.div(_templateObject5$19 || (_templateObject5$19 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 2%;\n  left: 6%;\n  font-size: 54px;\n  color: ", ";\n"])), function (_ref14) {
  var isEvent = _ref14.isEvent,
    isInRange = _ref14.isInRange;
  return isInRange ? isEvent ? '#b4282e' : '#000000' : isEvent ? '#e0a9ac' : '#c8c8c8';
});
var BottomDay = styled.div(_templateObject6$18 || (_templateObject6$18 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: 2%;\n  right: 6%;\n  font-size: 54px;\n  color: ", ";\n"])), function (_ref15) {
  var isEvent = _ref15.isEvent,
    isInRange = _ref15.isInRange;
  return isInRange ? isEvent ? '#b4282e' : '#000000' : isEvent ? '#e0a9ac' : '#c8c8c8';
});

var Row = function Row(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React$1.createElement("tr", null, data.map(function (items, index) {
    switch (items.length) {
      case 2:
        return /*#__PURE__*/React$1.createElement(DoubleDayCell, {
          isTopEvent: items[0].isEvent,
          isBottomEvent: items[1].isEvent,
          key: index
        }, /*#__PURE__*/React$1.createElement(DoubleDayContainer, {
          isTopEvent: items[0].isEvent,
          isBottomEvent: items[1].isEvent
        }, /*#__PURE__*/React$1.createElement(TopDay, {
          isEvent: items[0].isEvent,
          isInRange: items[0].isInRange
        }, items[0].title), /*#__PURE__*/React$1.createElement(BottomDay, {
          isEvent: items[1].isEvent,
          isInRange: items[1].isInRange
        }, items[1].title)));
      case 1:
        return /*#__PURE__*/React$1.createElement(DayCell$1, {
          isEvent: items && items.length && items[0].isEvent,
          isWeekend: items && items.length && items[0].isWeekend,
          isInRange: items && items.length && items[0].isInRange,
          key: index + String(items[0].title)
        }, items[0].title);
      default:
        return /*#__PURE__*/React$1.createElement(DayCell$1, {
          key: index
        });
    }
  }));
};

var _templateObject$1L, _templateObject2$1L;
var DatesContainer$1 = styled.div(_templateObject$1L || (_templateObject$1L = _taggedTemplateLiteralLoose(["\n  height: 63%;\n  display: flex;\n  flex-direction: column;\n  padding: 0 88px !important;\n"])));
var DatesTable$1 = styled.table(_templateObject2$1L || (_templateObject2$1L = _taggedTemplateLiteralLoose(["\n  border-collapse: collapse;\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n\n  & > thead {\n    height: 8.8%;\n    font-size: 24px;\n  }\n\n  & > tbody {\n    font-family: Baskerville;\n    font-style: italic;\n    font-size: 60px;\n  }\n"])));
var ROWS = Array(5).fill(0);
var CalendarVerticalTable = function CalendarVerticalTable(_ref) {
  var date = _ref.date,
    events = _ref.events,
    isHorizontal = _ref.isHorizontal,
    localization = _ref.localization,
    startDate = _ref.startDate,
    calendarType = _ref.calendarType;
  var calendarMonthData = useMemo(function () {
    return getDateViewerData(date, events, isHorizontal, startDate, calendarType);
  }, [date, events, isHorizontal, startDate, calendarType]);
  return /*#__PURE__*/React$1.createElement(DatesContainer$1, null, /*#__PURE__*/React$1.createElement(DatesTable$1, null, /*#__PURE__*/React$1.createElement("thead", null, /*#__PURE__*/React$1.createElement("tr", null, WEEKS.map(function (_ref2, index) {
    var title = _ref2.title,
      isWeekend = _ref2.isWeekend;
    return /*#__PURE__*/React$1.createElement(DayHeaderCell, {
      key: String(title[localization]) + index,
      isWeekend: isWeekend
    }, title[localization]);
  }))), /*#__PURE__*/React$1.createElement("tbody", null, ROWS.map(function (_, index) {
    return /*#__PURE__*/React$1.createElement(Row, {
      key: index,
      data: calendarMonthData.slice(index * DAYS_IN_WEEK, index * DAYS_IN_WEEK + DAYS_IN_WEEK)
    });
  }))));
};

var _templateObject$1M, _templateObject2$1M;
var calendarSizes$1 = {
  width: 300,
  height: 640
};
var CalendarContainer$1 = styled.div(_templateObject$1M || (_templateObject$1M = _taggedTemplateLiteralLoose(["\n  height: ", "mm;\n  width: ", "mm;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform-origin: top left;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n\n  * {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (_ref) {
  var height = _ref.height;
  return height;
}, function (_ref2) {
  var width = _ref2.width;
  return width;
}, function (props) {
  return props.dw;
}, function (_ref3) {
  var width = _ref3.width;
  return width;
}, function (props) {
  return props.dh;
}, function (_ref4) {
  var height = _ref4.height;
  return height;
});
var TextContent$1 = styled.div(_templateObject2$1M || (_templateObject2$1M = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 45.08%;\n  padding: 0 37px;\n  display: flex;\n  flex-direction: column;\n"])));
var CalendarVertical = function CalendarVertical(_ref5) {
  var cardId = _ref5.cardId,
    cardTitle = _ref5.cardTitle,
    author = _ref5.author,
    _ref5$images = _ref5.images,
    images = _ref5$images === void 0 ? [] : _ref5$images,
    sideAuthor = _ref5.sideAuthor,
    date = _ref5.date,
    events = _ref5.events,
    bottomLink = _ref5.bottomLink,
    title = _ref5.title,
    ownerName = _ref5.ownerName,
    _ref5$isHorizontal = _ref5.isHorizontal,
    isHorizontal = _ref5$isHorizontal === void 0 ? false : _ref5$isHorizontal,
    containerClass = _ref5.containerClass,
    style = _ref5.style,
    dw = _ref5.dw,
    dh = _ref5.dh,
    localization = _ref5.localization,
    startDate = _ref5.startDate,
    calendarType = _ref5.calendarType,
    isPrinting = _ref5.isPrinting;
  var _useResizedImageEnhan = useResizedImageEnhanced(images),
    img = _useResizedImageEnhan[0],
    containerRef = _useResizedImageEnhan[1];
  var printImage = useResizedImageForPrint(images, calendarSizes$1);
  return /*#__PURE__*/React$1.createElement(CalendarContainer$1, {
    ref: containerRef,
    className: containerClass,
    style: style,
    dw: dw,
    dh: dh,
    width: calendarSizes$1.width,
    height: calendarSizes$1.height
  }, /*#__PURE__*/React$1.createElement(ImageContent, {
    img: isPrinting ? printImage : img,
    sideAuthor: sideAuthor,
    imgAspectRatio: "1 / 1.2",
    imageContentStyles: {
      padding: '57px 37px 0'
    }
  }), /*#__PURE__*/React$1.createElement(TextContent$1, null, /*#__PURE__*/React$1.createElement(CalendarVerticalTitles, {
    author: author,
    date: date,
    cardTitle: cardTitle,
    events: events,
    startDate: startDate,
    calendarType: calendarType,
    localization: localization
  }), /*#__PURE__*/React$1.createElement(CalendarVerticalTable, {
    date: date,
    localization: localization,
    isHorizontal: isHorizontal,
    events: events,
    startDate: startDate,
    calendarType: calendarType
  }), /*#__PURE__*/React$1.createElement(FooterContent, {
    isHorizontal: isHorizontal,
    title: title,
    ownerName: ownerName,
    bottomLink: bottomLink,
    cardId: cardId,
    footerHeight: "9.9%",
    svgSize: 50,
    footerStyles: {
      padding: '0 88px'
    }
  })));
};

var _templateObject$1N, _templateObject2$1N;
var ImageContainer$1 = styled.div(_templateObject$1N || (_templateObject$1N = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$X = styled.div(_templateObject2$1N || (_templateObject2$1N = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    aspect-ratio: ", ";\n    object-fit: contain;\n    background-color: #ffffff !important;\n  }\n"])), function (_ref) {
  var imgAspectRatio = _ref.imgAspectRatio;
  return imgAspectRatio;
});
var ImageContent$1 = function ImageContent(_ref2) {
  var img = _ref2.img,
    imgAspectRatio = _ref2.imgAspectRatio,
    imageContentStyles = _ref2.imageContentStyles;
  return /*#__PURE__*/React$1.createElement(ImageContainer$1, {
    style: imageContentStyles
  }, /*#__PURE__*/React$1.createElement(ImageInner$X, {
    imgAspectRatio: imgAspectRatio
  }, /*#__PURE__*/React$1.createElement("img", {
    src: img === null || img === void 0 ? void 0 : img.url,
    alt: "",
    draggable: false
  })));
};

var _templateObject$1O, _templateObject2$1O, _templateObject3$1J, _templateObject4$1l, _templateObject5$1a, _templateObject6$19;
var TitlesContainer$1 = styled.div(_templateObject$1O || (_templateObject$1O = _taggedTemplateLiteralLoose(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"])), function (_ref) {
  var withOnlyMonth = _ref.withOnlyMonth;
  return withOnlyMonth ? 36 : 15;
}, function (_ref2) {
  var withCardTitle = _ref2.withCardTitle,
    withOnlyMonth = _ref2.withOnlyMonth;
  return withOnlyMonth ? 12 : !withCardTitle ? 14.5 : 0.5;
});
var TitleAndDescBlock$1 = styled.div(_templateObject2$1O || (_templateObject2$1O = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 17.7px;\n"])));
var MonthBlock = styled.div(_templateObject3$1J || (_templateObject3$1J = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: ", ";\n"])), function (_ref3) {
  var withoutOnlyAuthor = _ref3.withoutOnlyAuthor;
  return withoutOnlyAuthor ? '30.5px 0 15.5px' : '13px 0 14px';
});
var Title$4 = styled.div(_templateObject4$1l || (_templateObject4$1l = _taggedTemplateLiteralLoose(["\n  font-family: 'Inter-Bold';\n  white-space: nowrap;\n  width: 100%;\n  flex: 1;\n  padding-top: ", "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  text-transform: uppercase;\n"])), function (_ref4) {
  var withCardTitle = _ref4.withCardTitle;
  return withCardTitle ? 19 : 44;
});
var DescriptionSubtitle$2 = styled.div(_templateObject5$1a || (_templateObject5$1a = _taggedTemplateLiteralLoose(["\n  font-family: 'Inter';\n  font-size: 14.5px;\n  word-wrap: break-word;\n  word-break: break-all;\n  overflow: hidden;\n  height: 34.5%;\n"])));
var MonthName = styled.div(_templateObject6$19 || (_templateObject6$19 = _taggedTemplateLiteralLoose(["\n  font-family: Baskerville;\n  font-style: italic;\n  font-size: 30px;\n  letter-spacing: 6px;\n  margin-right: -6px !important;\n"])));
var Titles = function Titles(_ref5) {
  var cardTitle = _ref5.cardTitle,
    date = _ref5.date,
    author = _ref5.author,
    localization = _ref5.localization;
  var calendarMonthTitle = useMemo(function () {
    var month = getDateViewerTitle(date, localization);
    return month.charAt(0).toUpperCase() + month.slice(1);
  }, [date]);
  var mainTitle = Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length) && cardTitle.slice(0, 70) || calendarMonthTitle || '';
  var authorTitle = author !== null && author !== void 0 && author.length ? author.slice(0, 176) : '';
  var withCardTitle = Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length);
  var withOnlyMonth = !withCardTitle && !authorTitle;
  var withoutOnlyAuthor = withCardTitle && !authorTitle;
  return /*#__PURE__*/React$1.createElement(TitlesContainer$1, {
    withOnlyMonth: withOnlyMonth,
    withCardTitle: withCardTitle
  }, /*#__PURE__*/React$1.createElement(TitleAndDescBlock$1, null, /*#__PURE__*/React$1.createElement(Title$4, {
    withCardTitle: withCardTitle
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    width: "100%",
    fontSizeMax: 31,
    text: mainTitle
  })), /*#__PURE__*/React$1.createElement(DescriptionSubtitle$2, null, authorTitle)), /*#__PURE__*/React$1.createElement(MonthBlock, {
    withoutOnlyAuthor: withoutOnlyAuthor
  }, withCardTitle && /*#__PURE__*/React$1.createElement(MonthName, null, calendarMonthTitle)));
};

var updateDaysArray = function updateDaysArray(days) {
  var result = [];
  days.map(function (day) {
    return day !== null && day !== void 0 && day.length ? day : [{
      isEmpty: true
    }];
  }).forEach(function (day, index) {
    if (index === days.length - 1) {
      result.push(day);
    } else {
      result.push(day, [{
        isBorder: true
      }]);
    }
  });
  return result;
};

var _templateObject$1P, _templateObject2$1P, _templateObject3$1K, _templateObject4$1m;
var DoubleDay = styled.div(_templateObject$1P || (_templateObject$1P = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 40px;\n  display: flex;\n  align-items: center;\n"])));
var TopDay$1 = styled.div(_templateObject2$1P || (_templateObject2$1P = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: flex-end;\n  margin-left: ", "px!important;\n  color: ", ";\n  border-bottom: ", ";\n"])), function (_ref) {
  var isFirstElem = _ref.isFirstElem;
  return isFirstElem ? 0 : 10;
}, function (_ref2) {
  var isEvent = _ref2.isEvent;
  return isEvent ? '#b4282e' : '#000000';
}, function (_ref3) {
  var isEvent = _ref3.isEvent;
  return isEvent && '2px solid';
});
var BottomDay$1 = styled.div(_templateObject3$1K || (_templateObject3$1K = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  border-bottom: ", ";\n  padding-left: 8px !important;\n  padding-right: 9px !important;\n  font-size: 26px;\n"])), function (_ref4) {
  var isEvent = _ref4.isEvent;
  return isEvent ? '#b4282e' : '#000000';
}, function (_ref5) {
  var isEvent = _ref5.isEvent;
  return isEvent && '2px solid';
});
var BlockWithLine = styled.div(_templateObject4$1m || (_templateObject4$1m = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 30px;\n  height: 100%;\n\n  &::after {\n    content: '';\n    position: absolute;\n    width: 170%;\n    height: 1px;\n    background-color: black;\n    top: 0;\n    right: 0;\n    transform: rotate(-53deg);\n    transform-origin: top right;\n  }\n"])));
var DoubleDayCell$1 = function DoubleDayCell(_ref6) {
  var day = _ref6.day,
    secondDay = _ref6.secondDay,
    isFirstElem = _ref6.isFirstElem;
  return /*#__PURE__*/React$1.createElement(DoubleDay, {
    isTopEvent: day === null || day === void 0 ? void 0 : day.isEvent,
    isBottomEvent: secondDay === null || secondDay === void 0 ? void 0 : secondDay.isEvent
  }, /*#__PURE__*/React$1.createElement(TopDay$1, {
    isEvent: day === null || day === void 0 ? void 0 : day.isEvent,
    isFirstElem: isFirstElem
  }, (day === null || day === void 0 ? void 0 : day.title) || ''), /*#__PURE__*/React$1.createElement(BlockWithLine, null), /*#__PURE__*/React$1.createElement(BottomDay$1, {
    isEvent: secondDay === null || secondDay === void 0 ? void 0 : secondDay.isEvent,
    isInRange: secondDay === null || secondDay === void 0 ? void 0 : secondDay.isInRange
  }, (secondDay === null || secondDay === void 0 ? void 0 : secondDay.title) || ''), ' ');
};

var _templateObject$1Q, _templateObject2$1Q, _templateObject3$1L, _templateObject4$1n, _templateObject5$1b;
var DayCell$2 = styled.div(_templateObject$1Q || (_templateObject$1Q = _taggedTemplateLiteralLoose(["\n  line-height: 39.2px;\n  font-size: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: ", ";\n  padding: ", "!important;\n\n  padding-left: ", "px!important;\n\n  padding-right: ", "px!important;\n\n  color: ", ";\n"])), function (_ref) {
  var isEvent = _ref.isEvent;
  return isEvent && '2px solid';
}, function (_ref2) {
  var isBorder = _ref2.isBorder;
  return !isBorder && '0 10px';
}, function (_ref3) {
  var isFirstElem = _ref3.isFirstElem,
    dayLeesThanTen = _ref3.dayLeesThanTen;
  return isFirstElem && !dayLeesThanTen && 0;
}, function (_ref4) {
  var isLastElem = _ref4.isLastElem,
    dayLeesThanTen = _ref4.dayLeesThanTen;
  return isLastElem && !dayLeesThanTen && 0;
}, function (_ref5) {
  var isEvent = _ref5.isEvent,
    isWeekend = _ref5.isWeekend;
  return isWeekend || isEvent ? '#b6252c' : '#000000';
});
var BorderTd = styled.div(_templateObject2$1Q || (_templateObject2$1Q = _taggedTemplateLiteralLoose(["\n  border-top: 1px solid;\n  flex: 1;\n  height: 0;\n"])));
var DayTd = styled.td(_templateObject3$1L || (_templateObject3$1L = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: ", ";\n"])), function (_ref6) {
  var isFirstElem = _ref6.isFirstElem,
    isLastElem = _ref6.isLastElem,
    isFirstShortBorder = _ref6.isFirstShortBorder,
    isSecondShortBorder = _ref6.isSecondShortBorder,
    isTwoDoubleDay = _ref6.isTwoDoubleDay;
  if (isFirstElem || isLastElem) {
    return 1.5;
  }
  if (isFirstShortBorder) {
    if (!isTwoDoubleDay) {
      return 1.3;
    }
    return 1.75;
  }
  if (isSecondShortBorder && isTwoDoubleDay) {
    return 1.2;
  }
  return 2;
});
var WeeksContent = styled.tr(_templateObject4$1n || (_templateObject4$1n = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  font-size: 38px;\n  height: 40px;\n"])));
var EmptyDay = styled.div(_templateObject5$1b || (_templateObject5$1b = _taggedTemplateLiteralLoose(["\n  margin-left: ", "px !important;\n  margin-right: ", "px !important;\n  height: 30px;\n  width: 0;\n  border-right: 1px solid;\n"])), function (p) {
  return p.isFirstElem && 20;
}, function (p) {
  return p.isLastElem && 20;
});
var Row$1 = function Row(_ref7) {
  var data = _ref7.data,
    rowIndex = _ref7.rowIndex;
  var adaptedData = updateDaysArray(data);
  return /*#__PURE__*/React$1.createElement(WeeksContent, null, adaptedData.map(function (item, index, arr) {
    var day = item[0],
      secondDay = item[1];
    var arraysWithDoubleDay = arr.filter(function (item) {
      return item.length > 1;
    });
    var isTwoDoubleDay = (arraysWithDoubleDay === null || arraysWithDoubleDay === void 0 ? void 0 : arraysWithDoubleDay.length) === 2;
    var withSecondDay = item.length > 1;
    var isLastElem = index === adaptedData.length - 1;
    var isFirstElem = index === 0;
    var isFirstShortBorder = (arraysWithDoubleDay === null || arraysWithDoubleDay === void 0 ? void 0 : arraysWithDoubleDay.length) && index === 1;
    var isSecondShortBorder = (arraysWithDoubleDay === null || arraysWithDoubleDay === void 0 ? void 0 : arraysWithDoubleDay.length) && index === 3;
    var dayKey = index.toString() + rowIndex;
    var dayLeesThanTen = day !== null && day !== void 0 && day.title ? +day.title < 10 : false;
    return /*#__PURE__*/React$1.createElement(DayTd, {
      key: dayKey,
      isLastElem: isLastElem,
      isFirstElem: isFirstElem,
      isFirstShortBorder: isFirstShortBorder,
      isSecondShortBorder: isSecondShortBorder,
      isTwoDoubleDay: isTwoDoubleDay
    }, !isFirstElem && /*#__PURE__*/React$1.createElement(BorderTd, null), day !== null && day !== void 0 && day.isEmpty ? /*#__PURE__*/React$1.createElement(EmptyDay, {
      isLastElem: isLastElem,
      isFirstElem: isFirstElem
    }) : withSecondDay ? /*#__PURE__*/React$1.createElement(DoubleDayCell$1, {
      day: day,
      secondDay: secondDay,
      isFirstElem: isFirstElem
    }) : /*#__PURE__*/React$1.createElement(DayCell$2, {
      isBorder: day === null || day === void 0 ? void 0 : day.isBorder,
      isWeekend: day === null || day === void 0 ? void 0 : day.isWeekend,
      isEvent: day === null || day === void 0 ? void 0 : day.isEvent,
      isLastElem: isLastElem,
      isFirstElem: isFirstElem,
      dayLeesThanTen: dayLeesThanTen
    }, /*#__PURE__*/React$1.createElement("span", null, (day === null || day === void 0 ? void 0 : day.title) || '')), !isLastElem && /*#__PURE__*/React$1.createElement(BorderTd, null));
  }));
};

var WEEKS$1 = [{
  title: {
    ru: 'Пн',
    en: 'Mо'
  },
  isWeekend: false
}, {
  title: {
    ru: '',
    en: ''
  },
  isWeekend: false
}, {
  title: {
    ru: 'Вт',
    en: 'Tu'
  },
  isWeekend: false
}, {
  title: {
    ru: '',
    en: ''
  },
  isWeekend: false
}, {
  title: {
    ru: 'Ср',
    en: 'We'
  },
  isWeekend: false
}, {
  title: {
    ru: '',
    en: ''
  },
  isWeekend: false
}, {
  title: {
    ru: 'Чт',
    en: 'Th'
  },
  isWeekend: false
}, {
  title: {
    ru: '',
    en: ''
  },
  isWeekend: false
}, {
  title: {
    ru: 'Пт',
    en: 'Fr'
  },
  isWeekend: false
}, {
  title: {
    ru: '',
    en: ''
  },
  isWeekend: false
}, {
  title: {
    ru: 'Сб',
    en: 'Sa'
  },
  isWeekend: false
}, {
  title: {
    ru: '',
    en: ''
  },
  isWeekend: false
}, {
  title: {
    ru: 'Вс',
    en: 'Su'
  },
  isWeekend: true
}];
var ROWS$1 = Array(5).fill(0);
var DAYS_IN_WEEK$1 = 7;

var _templateObject$1R, _templateObject2$1R, _templateObject3$1M, _templateObject4$1o, _templateObject5$1c, _templateObject6$1a;
var DatesContainer$2 = styled.div(_templateObject$1R || (_templateObject$1R = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var DatesTable$2 = styled.table(_templateObject2$1R || (_templateObject2$1R = _taggedTemplateLiteralLoose(["\n  border-collapse: collapse;\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n\n  & > tbody {\n    font-family: Baskerville;\n    font-style: italic;\n  }\n\n  * {\n    padding: 0;\n    margin: 0;\n  }\n"])));
var WeeksContent$1 = styled.tr(_templateObject3$1M || (_templateObject3$1M = _taggedTemplateLiteralLoose(["\n  height: 38px;\n  display: flex;\n  align-items: center;\n"])));
var BorderTh = styled.div(_templateObject4$1o || (_templateObject4$1o = _taggedTemplateLiteralLoose(["\n  border-top: 2.8px solid;\n  flex: 1;\n  height: 0;\n"])));
var WeekDayName = styled.div(_templateObject5$1c || (_templateObject5$1c = _taggedTemplateLiteralLoose(["\n  font-family: 'Inter-Bold';\n  font-size: 11px;\n  line-height: 39px;\n  display: flex;\n  font-weight: bold;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: ", ";\n\n  padding: ", "!important;\n"])), function (_ref) {
  var isEvent = _ref.isEvent,
    isWeekend = _ref.isWeekend;
  return isWeekend || isEvent ? '#b6252c' : '#000000';
}, function (_ref2) {
  var isBorder = _ref2.isBorder;
  return !isBorder && '0 13px';
});
var WeekDayContainer = styled.td(_templateObject6$1a || (_templateObject6$1a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: ", ";\n"])), function (_ref3) {
  var isFirstElem = _ref3.isFirstElem,
    isLastElem = _ref3.isLastElem;
  return isFirstElem || isLastElem ? 1.5 : 2;
});
var CalendarTable = function CalendarTable(_ref4) {
  var date = _ref4.date,
    events = _ref4.events,
    _ref4$isHorizontal = _ref4.isHorizontal,
    isHorizontal = _ref4$isHorizontal === void 0 ? false : _ref4$isHorizontal,
    startDate = _ref4.startDate,
    calendarType = _ref4.calendarType,
    localization = _ref4.localization;
  var calendarMonthData = useMemo(function () {
    return getDateViewerData(date, events, isHorizontal, startDate, calendarType, false);
  }, [date, events, isHorizontal, startDate, calendarType]);
  return /*#__PURE__*/React$1.createElement(DatesContainer$2, null, /*#__PURE__*/React$1.createElement(DatesTable$2, null, /*#__PURE__*/React$1.createElement("thead", null, /*#__PURE__*/React$1.createElement(WeeksContent$1, null, WEEKS$1.map(function (_ref5, index) {
    var _title$localization;
    var title = _ref5.title,
      isWeekend = _ref5.isWeekend;
    var isLastElem = index === WEEKS$1.length - 1;
    var isFirstElem = index === 0;
    return /*#__PURE__*/React$1.createElement(WeekDayContainer, {
      key: title[localization] + index,
      isFirstElem: isFirstElem,
      isLastElem: isLastElem
    }, !isFirstElem && /*#__PURE__*/React$1.createElement(BorderTh, null), /*#__PURE__*/React$1.createElement(WeekDayName, {
      isFirstElem: isFirstElem,
      isLastElem: isLastElem,
      isWeekend: isWeekend,
      isBorder: !title[localization]
    }, (_title$localization = title[localization]) === null || _title$localization === void 0 ? void 0 : _title$localization.toUpperCase()), !isLastElem && /*#__PURE__*/React$1.createElement(BorderTh, null));
  }))), /*#__PURE__*/React$1.createElement("tbody", null, ROWS$1.map(function (_, index) {
    return /*#__PURE__*/React$1.createElement(Row$1, {
      key: index,
      rowIndex: index,
      data: calendarMonthData.slice(index * DAYS_IN_WEEK$1, index * DAYS_IN_WEEK$1 + DAYS_IN_WEEK$1)
    });
  }))));
};

var _templateObject$1S, _templateObject2$1S;
var Footer$1 = styled.footer(_templateObject$1S || (_templateObject$1S = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 30px;\n\n  & > svg {\n    padding-bottom: 4px;\n    padding-left: 4px;\n  }\n"])), function (_ref) {
  var footerHeight = _ref.footerHeight;
  return footerHeight;
});
var MonthCollectionName$1 = styled.div(_templateObject2$1S || (_templateObject2$1S = _taggedTemplateLiteralLoose(["\n  color: #002d6e;\n  text-transform: uppercase;\n  font-family: HSE Sans;\n  font-weight: 700;\n  font-size: 25px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n\n  span {\n    color: #002d6e;\n    &:nth-of-type(2n) {\n      font-weight: 400;\n      letter-spacing: 0.05em;\n    }\n    &:nth-of-type(2n + 1) {\n      font-weight: 700;\n      letter-spacing: 0.07em;\n    }\n    &:not(:first-child) {\n      margin-left: -1mm;\n    }\n  }\n"])));
var FooterContent$1 = function FooterContent(_ref2) {
  var _ref2$isHorizontal = _ref2.isHorizontal,
    isHorizontal = _ref2$isHorizontal === void 0 ? false : _ref2$isHorizontal,
    title = _ref2.title,
    ownerName = _ref2.ownerName,
    bottomLink = _ref2.bottomLink,
    cardId = _ref2.cardId,
    footerHeight = _ref2.footerHeight,
    svgSize = _ref2.svgSize,
    footerStyles = _ref2.footerStyles;
  var usedTitle = title || ownerName;
  var titleArr = usedTitle && usedTitle.trim().split(' ');
  return /*#__PURE__*/React$1.createElement(Footer$1, {
    footerHeight: footerHeight,
    style: footerStyles
  }, /*#__PURE__*/React$1.createElement(MonthCollectionName$1, {
    isHorizontal: isHorizontal
  }, !!(titleArr && titleArr.length) && titleArr.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index + "-" + item,
      dangerouslySetInnerHTML: {
        __html: item + "&ThinSpace;"
      }
    });
  })), /*#__PURE__*/React$1.createElement(QRCodeSVG, {
    size: svgSize,
    value: (bottomLink || 'gallllery.com') + "/card/" + cardId
  }));
};

var _templateObject$1T, _templateObject2$1T, _templateObject3$1N;
var calendarSizes$2 = {
  width: 420,
  height: 594
};
var CalendarContainer$2 = styled.div(_templateObject$1T || (_templateObject$1T = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform-origin: top left;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  padding: 157px 157px 0;\n  transform: scale(", ");\n  background: transparent !important;\n\n  * {\n    box-sizing: border-box;\n  }\n"])), function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var height = _ref2.height;
  return height;
}, function (_ref3) {
  var dw = _ref3.dw;
  return dw;
}, function (_ref4) {
  var width = _ref4.width;
  return width;
}, function (_ref5) {
  var dh = _ref5.dh;
  return dh;
}, function (_ref6) {
  var height = _ref6.height;
  return height;
}, function (p) {
  return p.scaleSize;
});
var TextContent$2 = styled.div(_templateObject2$1T || (_templateObject2$1T = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 26.8%;\n  display: flex;\n  flex-direction: column;\n"])));
var MonthEvents$2 = styled.div(_templateObject3$1N || (_templateObject3$1N = _taggedTemplateLiteralLoose(["\n  font-family: 'Inter';\n  height: ", ";\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 10px;\n  margin-top: 10px;\n"])), function (_ref7) {
  var isEmptyEvents = _ref7.isEmptyEvents;
  return isEmptyEvents && '13px';
});
var CalendarModern = function CalendarModern(_ref8) {
  var cardTitle = _ref8.cardTitle,
    title = _ref8.title,
    author = _ref8.author,
    date = _ref8.date,
    events = _ref8.events,
    _ref8$images = _ref8.images,
    images = _ref8$images === void 0 ? [] : _ref8$images,
    startDate = _ref8.startDate,
    style = _ref8.style,
    calendarType = _ref8.calendarType,
    ownerName = _ref8.ownerName,
    bottomLink = _ref8.bottomLink,
    cardId = _ref8.cardId,
    containerClass = _ref8.containerClass,
    localization = _ref8.localization,
    dw = _ref8.dw,
    dh = _ref8.dh,
    scaleSize = _ref8.scaleSize,
    isPrinting = _ref8.isPrinting;
  var _useResizedImageEnhan = useResizedImageEnhanced(images),
    img = _useResizedImageEnhan[0],
    containerRef = _useResizedImageEnhan[1];
  var printImage = useResizedImageForPrint(images, calendarSizes$2);
  var monthEvents = useMonthEvents({
    date: date,
    events: events,
    startDate: startDate,
    calendarType: calendarType
  });
  return /*#__PURE__*/React$1.createElement(CalendarContainer$2, {
    ref: containerRef,
    style: style,
    className: containerClass,
    dw: dw,
    dh: dh,
    scaleSize: scaleSize,
    width: calendarSizes$2.width,
    height: calendarSizes$2.height
  }, /*#__PURE__*/React$1.createElement(ImageContent$1, {
    img: isPrinting ? printImage : img,
    imgAspectRatio: "1 / 1.2"
  }), /*#__PURE__*/React$1.createElement(TextContent$2, null, /*#__PURE__*/React$1.createElement(Titles, {
    author: author,
    date: new Date(date),
    cardTitle: cardTitle,
    localization: localization
  }), /*#__PURE__*/React$1.createElement(CalendarTable, {
    date: date,
    events: events,
    startDate: startDate,
    calendarType: calendarType,
    localization: localization
  }), /*#__PURE__*/React$1.createElement(MonthEvents$2, {
    isEmptyEvents: !(monthEvents !== null && monthEvents !== void 0 && monthEvents.length)
  }, monthEvents === null || monthEvents === void 0 ? void 0 : monthEvents.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index
    }, getEventString(item));
  })), /*#__PURE__*/React$1.createElement(FooterContent$1, {
    title: title,
    ownerName: ownerName,
    bottomLink: bottomLink,
    cardId: cardId,
    footerHeight: "9.9%",
    svgSize: 53
  })));
};

var Calendar = function Calendar(props) {
  switch (props === null || props === void 0 ? void 0 : props.orientation) {
    case 'horizontal':
      return /*#__PURE__*/React$1.createElement(CalendarHorizontal, props);
    case 'free':
      return /*#__PURE__*/React$1.createElement(CalendarModern, props);
    case 'vertical':
    default:
      return /*#__PURE__*/React$1.createElement(CalendarVertical, props);
  }
};

var TimelineCardLL = function TimelineCardLL(props) {
  return /*#__PURE__*/React$1.createElement(TimelineCardMasterTemplate, _extends({}, props, {
    orientation: 'horizontal',
    size: 'large'
  }));
};

var TimelineCardL = function TimelineCardL(props) {
  return /*#__PURE__*/React$1.createElement(TimelineCardMasterTemplate, _extends({}, props, {
    orientation: 'vertical',
    size: 'large'
  }));
};

var _templateObject$1U, _templateObject2$1U, _templateObject3$1O, _templateObject4$1p, _templateObject5$1d, _templateObject6$1b, _templateObject7$17, _templateObject8$14, _templateObject9$11, _templateObject10$p, _templateObject11$p, _templateObject12$p, _templateObject13$p, _templateObject14$j, _templateObject15$7;
var Container = styled.div(_templateObject$1U || (_templateObject$1U = _taggedTemplateLiteralLoose(["\n  height: 594mm;\n  width: 420mm;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform: scale(", ");\n  transform-origin: top left;\n  padding: 80px 160px;\n\n  * {\n    box-sizing: border-box;\n  }\n"])), function (p) {
  return p.scaleSize;
});
var Header = styled.div(_templateObject2$1U || (_templateObject2$1U = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 7.6%;\n"])));
var YearBlock = styled.div(_templateObject3$1O || (_templateObject3$1O = _taggedTemplateLiteralLoose(["\n  font-family: 'Inter-Bold';\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 70%;\n  color: #da0006;\n  font-size: 41px;\n  letter-spacing: 37px;\n  text-indent: 35px;\n"])));
var CardsBlock = styled.div(_templateObject4$1p || (_templateObject4$1p = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  width: 100%;\n"])));
var ImagesContainer = styled.div(_templateObject5$1d || (_templateObject5$1d = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(4, 1fr);\n"])));
var ImageWrapper = styled.div(_templateObject6$1b || (_templateObject6$1b = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-top: 1px solid black;\n  border-left: 1px solid black;\n\n  &:nth-child(3n) {\n    border-right: 1px solid black;\n  }\n  &:nth-last-child(-n + 3) {\n    border-bottom: 1px solid black;\n  }\n"])));
var ImageInner$Y = styled.div(_templateObject7$17 || (_templateObject7$17 = _taggedTemplateLiteralLoose(["\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  aspect-ratio: 1 / 1.2;\n"])));
var Image$1 = styled.img(_templateObject8$14 || (_templateObject8$14 = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  background-color: #ffffff !important;\n"])));
var Footer$2 = styled.div(_templateObject9$11 || (_templateObject9$11 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 11.3%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n"])));
var FooterContainer = styled.div(_templateObject10$p || (_templateObject10$p = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  height: 50%;\n"])));
var TitleBlock = styled.div(_templateObject11$p || (_templateObject11$p = _taggedTemplateLiteralLoose(["\n  font-family: 'Inter';\n  width: 66.6%;\n  height: 100%;\n"])));
var LogoBlock = styled.div(_templateObject12$p || (_templateObject12$p = _taggedTemplateLiteralLoose(["\n  width: 25%;\n  height: 80%;\n  margin-top: 7px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"])));
var Logo = styled.img(_templateObject13$p || (_templateObject13$p = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n"])));
var Title$5 = styled.div(_templateObject14$j || (_templateObject14$j = _taggedTemplateLiteralLoose(["\n  font-size: 36px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n"])));
var SubTitle = styled.div(_templateObject15$7 || (_templateObject15$7 = _taggedTemplateLiteralLoose(["\n  font-size: 17px;\n  letter-spacing: 0.05px;\n  margin-top: 15px;\n"])));
var CalendarFreePreview = function CalendarFreePreview(_ref) {
  var images = _ref.images,
    year = _ref.year,
    title = _ref.title,
    scaleSize = _ref.scaleSize,
    logo = _ref.logo,
    author = _ref.author,
    styles = _ref.styles,
    imgAspectRatio = _ref.imgAspectRatio,
    isNeedImagePlaceholder = _ref.isNeedImagePlaceholder;
  var withLogo = Boolean(logo);
  var cardTitle = (title === null || title === void 0 ? void 0 : title.toUpperCase()) || '';
  var scale = extractSecondCalcValue(scaleSize);
  if (isNeedImagePlaceholder) {
    return /*#__PURE__*/React$1.createElement(CalendarImagePlaceholder, {
      orientation: "free",
      title: cardTitle,
      year: year,
      isHorizontal: false,
      isPrinting: false,
      scaleSize: scaleSize
    });
  }
  return /*#__PURE__*/React$1.createElement(Container, {
    scaleSize: scale,
    style: styles
  }, /*#__PURE__*/React$1.createElement(Header, null, year ? /*#__PURE__*/React$1.createElement(YearBlock, null, year) : /*#__PURE__*/React$1.createElement(YearPlaceholder, {
    isScaled: true,
    className: "year_free"
  })), isNeedImagePlaceholder ? /*#__PURE__*/React$1.createElement(CalendarImagePlaceholder, null) : /*#__PURE__*/React$1.createElement(CardsBlock, null, /*#__PURE__*/React$1.createElement(ImagesContainer, null, images.map(function (image, index) {
    return /*#__PURE__*/React$1.createElement(ImageWrapper, {
      key: index
    }, /*#__PURE__*/React$1.createElement(ImageInner$Y, null, /*#__PURE__*/React$1.createElement(Image$1, {
      src: image,
      imgAspectRatio: imgAspectRatio
    })));
  }))), /*#__PURE__*/React$1.createElement(Footer$2, null, /*#__PURE__*/React$1.createElement(FooterContainer, null, /*#__PURE__*/React$1.createElement(TitleBlock, null, cardTitle ? /*#__PURE__*/React$1.createElement(Title$5, null, cardTitle) : /*#__PURE__*/React$1.createElement(TitlePlaceholder, {
    className: "title_free",
    isScaled: true
  }), /*#__PURE__*/React$1.createElement(SubTitle, null, author)), /*#__PURE__*/React$1.createElement(LogoBlock, null, withLogo && /*#__PURE__*/React$1.createElement(Logo, {
    src: logo,
    alt: "logo"
  })))));
};

var getImageUrl = function getImageUrl(images) {
  var _images$;
  if (!images) return '';
  var imageOriginal = images.find(function (image) {
    return (image === null || image === void 0 ? void 0 : image.size) === 'original';
  });
  if (imageOriginal) return imageOriginal === null || imageOriginal === void 0 ? void 0 : imageOriginal.url;
  return ((_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.url) || '';
};

var previewCard = {
  horizontal: TimelineCardLL,
  vertical: TimelineCardL,
  free: CalendarFreePreview
};
var CalendarsPrint = function CalendarsPrint(_ref) {
  var _calendarsData$logoFi, _calendarsData$title, _calendarsData$cards;
  var calendarsData = _ref.calendarsData;
  var images = calendarsData && calendarsData.cards && calendarsData.cards.length ? calendarsData.cards.map(function (card) {
    return card && card.imageUrl;
  }) : [];
  var logo = getImageUrl(calendarsData !== null && calendarsData !== void 0 && (_calendarsData$logoFi = calendarsData.logoFiles) !== null && _calendarsData$logoFi !== void 0 && _calendarsData$logoFi.length ? calendarsData.logoFiles : []);
  var year = new Date().getFullYear();
  var getDateFromMonthIndex = function getDateFromMonthIndex(index) {
    var currentYear = calendarsData && calendarsData.year || year;
    var currentMonth = index + (calendarsData && calendarsData.startMonth);
    var nextYear = currentYear + 1;
    return new Date(currentMonth > 11 ? nextYear : currentYear, currentMonth % 12);
  };
  var Preview = calendarsData !== null && calendarsData !== void 0 && calendarsData.orientation ? previewCard[calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.orientation] : TimelineCardL;
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      display: 'grid'
    }
  }, /*#__PURE__*/React$1.createElement(Preview, {
    isPrinting: true,
    year: calendarsData && calendarsData.timelineYear || year,
    images: images && images.length && images.slice(0, 12) || [],
    title: (calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$title = calendarsData.title) === null || _calendarsData$title === void 0 ? void 0 : _calendarsData$title.length) && calendarsData.title.substring(0, 53) || '',
    defaultTitle: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.defaultTitle) || '',
    titleArray: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.titleArray) || [],
    ownerName: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.ownerName) || '',
    localization: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.localization) || 'en',
    collectionName: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.collectionName) || '',
    logo: logo,
    cardTitle: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.cardTitle) || '',
    author: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.author) || ''
  }), calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$cards = calendarsData.cards) === null || _calendarsData$cards === void 0 ? void 0 : _calendarsData$cards.map(function (item, index) {
    var _calendarsData$title2, _calendarsData$title3;
    return /*#__PURE__*/React$1.createElement(Calendar, {
      isPrinting: true,
      key: (item === null || item === void 0 ? void 0 : item.cardId) + "-" + index,
      cardId: item === null || item === void 0 ? void 0 : item.cardId,
      cardTitle: item === null || item === void 0 ? void 0 : item.name,
      title: (calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$title2 = calendarsData.title) === null || _calendarsData$title2 === void 0 ? void 0 : _calendarsData$title2.length) && (calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$title3 = calendarsData.title) === null || _calendarsData$title3 === void 0 ? void 0 : _calendarsData$title3.substring(0, 53)) || '',
      date: getDateFromMonthIndex(index),
      author: item === null || item === void 0 ? void 0 : item.description,
      images: item === null || item === void 0 ? void 0 : item.images,
      localization: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.localization) || 'en',
      orientation: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.orientation) || 'vertical',
      events: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.events) || [],
      calendarCollectionId: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.calendarCollectionId) || '',
      printImgUrl: item === null || item === void 0 ? void 0 : item.imageUrl,
      ownerName: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.ownerName) || '',
      bottomLink: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.bottomLink) || '',
      collectionName: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.collectionName) || '',
      sideAuthor: item === null || item === void 0 ? void 0 : item.sideAuthor,
      startDate: calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.startDate,
      calendarType: calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.calendarType
    });
  }));
};

var _templateObject$1V, _templateObject2$1V, _templateObject3$1P, _templateObject4$1q, _templateObject5$1e, _templateObject6$1c, _templateObject7$18, _templateObject8$15, _templateObject9$12, _templateObject10$q;
var Wrapper$12 = styled.div(_templateObject$1V || (_templateObject$1V = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.pageWidth;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.pageWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.horizontalPadding;
});
var MainBlock$X = styled.div(_templateObject2$1V || (_templateObject2$1V = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$P = styled.div(_templateObject3$1P || (_templateObject3$1P = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.7px;\n    line-height: 4px;\n    margin: 5px 3px 0 0;\n  }\n"])), function (props) {
  return props.urlHeightPercent;
});
var ImageBlock$X = styled.div(_templateObject4$1q || (_templateObject4$1q = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$Z = styled.div(_templateObject5$1e || (_templateObject5$1e = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$13 = styled.div(_templateObject6$1c || (_templateObject6$1c = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: ", "%;\n  width: ", "%;\n  padding-bottom: ", "px;\n"])), function (props) {
  return props.textBlockHeightPercent;
}, function (props) {
  return props.textBlockWidthPercent;
}, function (props) {
  return props.textBlockPaddingBottom;
});
var TextFirst$P = styled.div(_templateObject7$18 || (_templateObject7$18 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  line-height: 0px;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    font-weight: 400;\n  }\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
});
var TextSecond$Q = styled.div(_templateObject8$15 || (_templateObject8$15 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: ", "px;\n  text-align: center;\n  margin: ", "px 0 ", "px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: 'zMr';\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: ", "px;\n"])), function (props) {
  return props.height;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.letterSpacing;
});
var TextThird$P = styled.div(_templateObject9$12 || (_templateObject9$12 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  font-weight: 400;\n  margin-bottom: ", "px;\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.marginBottom;
});
var TextFourth = styled.div(_templateObject10$q || (_templateObject10$q = _taggedTemplateLiteralLoose(["\n  font-size: ", "px;\n  font-weight: 700;\n  line-height: 0px\n"])), function (props) {
  return props.fontSize;
});
var ShipsConstructor = function ShipsConstructor(_ref) {
  var image = _ref.image,
    url = _ref.url,
    name = _ref.name,
    museum = _ref.museum,
    description = _ref.description,
    dw = _ref.dw,
    dh = _ref.dh,
    pageWidth = _ref.pageWidth,
    pageHeight = _ref.pageHeight,
    horizontalPadding = _ref.horizontalPadding,
    urlHeightPercent = _ref.urlHeightPercent,
    textBlockHeightPercent = _ref.textBlockHeightPercent,
    textBlockWidthPercent = _ref.textBlockWidthPercent,
    textBlockPaddingBottom = _ref.textBlockPaddingBottom,
    firstFontSize = _ref.firstFontSize,
    firstLetterSpacing = _ref.firstLetterSpacing,
    secondFontMax = _ref.secondFontMax,
    secondHeight = _ref.secondHeight,
    secondMarginTop = _ref.secondMarginTop,
    secondMarginBottom = _ref.secondMarginBottom,
    secondLetterSpacing = _ref.secondLetterSpacing,
    thirdFontSize = _ref.thirdFontSize,
    thirdLetterSpacing = _ref.thirdLetterSpacing,
    thirdMarginBottom = _ref.thirdMarginBottom,
    fourthFontSize = _ref.fourthFontSize;
  return /*#__PURE__*/React$1.createElement(Wrapper$12, {
    dw: dw,
    dh: dh,
    pageWidth: pageWidth,
    pageHeight: pageHeight,
    horizontalPadding: horizontalPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$X, null, /*#__PURE__*/React$1.createElement(TextUrl$P, {
    urlHeightPercent: urlHeightPercent
  }, /*#__PURE__*/React$1.createElement("span", null)), /*#__PURE__*/React$1.createElement(ImageBlock$X, null, /*#__PURE__*/React$1.createElement(ImageInner$Z, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$13, {
    textBlockHeightPercent: textBlockHeightPercent,
    textBlockWidthPercent: textBlockWidthPercent,
    textBlockPaddingBottom: textBlockPaddingBottom
  }, /*#__PURE__*/React$1.createElement(TextFirst$P, {
    fontSize: firstFontSize,
    letterSpacing: firstLetterSpacing
  }, /*#__PURE__*/React$1.createElement("span", null, museum)), /*#__PURE__*/React$1.createElement(TextSecond$Q, {
    height: secondHeight,
    marginTop: secondMarginTop,
    marginBottom: secondMarginBottom,
    letterSpacing: secondLetterSpacing
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: name,
    fontSizeMax: secondFontMax
  })), /*#__PURE__*/React$1.createElement(TextThird$P, {
    fontSize: thirdFontSize,
    letterSpacing: thirdLetterSpacing,
    marginBottom: thirdMarginBottom
  }, description), /*#__PURE__*/React$1.createElement(TextFourth, {
    fontSize: fourthFontSize
  }, url))));
};

var ShipsCardA4L = function ShipsCardA4L(props) {
  return /*#__PURE__*/React$1.createElement(ShipsConstructor, _extends({}, props, {
    pageWidth: 297,
    pageHeight: 210,
    horizontalPadding: 112,
    urlHeightPercent: 6.8,
    textBlockHeightPercent: 18,
    textBlockWidthPercent: 87.9,
    textBlockPaddingBottom: 25,
    firstFontSize: 11.3,
    firstLetterSpacing: 0.2,
    secondFontMax: 16,
    secondHeight: 20,
    secondMarginTop: 15,
    secondMarginBottom: 11,
    secondLetterSpacing: 0.45,
    thirdFontSize: 6.5,
    thirdLetterSpacing: 0.2,
    thirdMarginBottom: props.isPaymentModal ? 0 : 29,
    fourthFontSize: 4
  }));
};

var ShipsCardA4 = function ShipsCardA4(props) {
  return /*#__PURE__*/React$1.createElement(ShipsConstructor, _extends({}, props, {
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 93,
    urlHeightPercent: 5.905,
    textBlockHeightPercent: 16.7,
    textBlockWidthPercent: 87.9,
    textBlockPaddingBottom: 46,
    firstFontSize: 11.3,
    firstLetterSpacing: 0.2,
    secondFontMax: 16,
    secondHeight: 20,
    secondMarginTop: 15,
    secondMarginBottom: 11,
    secondLetterSpacing: 0.45,
    thirdFontSize: 6.5,
    thirdLetterSpacing: 0.2,
    thirdMarginBottom: 33,
    fourthFontSize: 4
  }));
};

var ShipsCardA5 = function ShipsCardA5(props) {
  return /*#__PURE__*/React$1.createElement(ShipsConstructor, _extends({}, props, {
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 65,
    urlHeightPercent: 5.905,
    textBlockHeightPercent: 16.7,
    textBlockWidthPercent: 87.9,
    textBlockPaddingBottom: 32,
    firstFontSize: 8,
    firstLetterSpacing: 0.15,
    secondFontMax: 11,
    secondHeight: 14,
    secondMarginTop: 11,
    secondMarginBottom: 8,
    secondLetterSpacing: 0.3,
    thirdFontSize: 4.6,
    thirdLetterSpacing: 0.15,
    thirdMarginBottom: 23,
    fourthFontSize: 3
  }));
};

var ShipsCardA5L = function ShipsCardA5L(props) {
  return /*#__PURE__*/React$1.createElement(ShipsConstructor, _extends({}, props, {
    pageWidth: 210,
    pageHeight: 148,
    horizontalPadding: 79,
    urlHeightPercent: 6.8,
    textBlockHeightPercent: 18,
    textBlockWidthPercent: 87.9,
    textBlockPaddingBottom: 18,
    firstFontSize: 8,
    firstLetterSpacing: 0.15,
    secondFontMax: 11,
    secondHeight: 14,
    secondMarginTop: 11,
    secondMarginBottom: 8,
    secondLetterSpacing: 0.3,
    thirdFontSize: 4.6,
    thirdLetterSpacing: 0.15,
    thirdMarginBottom: props.isPaymentModal ? 0 : 20,
    fourthFontSize: 4
  }));
};

var components$9 = {
  ShipsCardA4: ShipsCardA4,
  ShipsCardA4L: ShipsCardA4L,
  ShipsCardA5: ShipsCardA5,
  ShipsCardA5L: ShipsCardA5L
};
var ShipsStyleCard = function ShipsStyleCard(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components$9[templateType], {
    url: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.link) || 'ze.land',
    image: image,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    description: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.description) || '',
    museum: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    name: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.title) || '',
    dw: dw,
    dh: dh,
    isPaymentModal: props.isPaymentModal
  });
};

var components$a = {
  ShipsCardA4: ShipsCardA4,
  ShipsCardA4L: ShipsCardA4L,
  ShipsCardA5: ShipsCardA5,
  ShipsCardA5L: ShipsCardA5L
};
var ShipsStyleCardPrint = function ShipsStyleCardPrint(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$a[templateType], {
    url: (data === null || data === void 0 ? void 0 : data.link) || 'ze.land',
    image: image,
    customSubtitle: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    description: (data === null || data === void 0 ? void 0 : data.description) || '',
    museum: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    name: (data === null || data === void 0 ? void 0 : data.title) || (data === null || data === void 0 ? void 0 : data.name) || '',
    dw: dw,
    dh: dh
  });
};

var _templateObject$1W, _templateObject2$1W, _templateObject3$1Q, _templateObject4$1r, _templateObject5$1f, _templateObject6$1d, _templateObject7$19, _templateObject8$16, _templateObject9$13, _templateObject10$r, _templateObject11$q;
var Wrapper$13 = styled.div(_templateObject$1W || (_templateObject$1W = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.pageWidth;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.pageWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.horizontalPadding;
});
var MainBlock$Y = styled.div(_templateObject2$1W || (_templateObject2$1W = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$Q = styled.div(_templateObject3$1Q || (_templateObject3$1Q = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.7px;\n    line-height: 4px;\n    margin: 5px 3px 0 0;\n  }\n"])), function (props) {
  return props.urlHeightPercent;
});
var ImageBlock$Y = styled.div(_templateObject4$1r || (_templateObject4$1r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$_ = styled.div(_templateObject5$1f || (_templateObject5$1f = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: ", ";\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])), function (props) {
  return props.imageAlignment || 'center';
});
var TextBlock$14 = styled.div(_templateObject6$1d || (_templateObject6$1d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: ", ";\n  height: ", "%;\n  width: ", "%;\n  padding-bottom: ", "px;\n"])), function (_ref) {
  var withDescription = _ref.withDescription,
    withNumber = _ref.withNumber;
  return !withDescription ? withNumber ? 'flex-start' : 'center' : 'flex-end';
}, function (props) {
  return props.textBlockHeightPercent;
}, function (props) {
  return props.textBlockWidthPercent;
}, function (props) {
  return props.textBlockPaddingBottom;
});
var TextFirst$Q = styled.div(_templateObject7$19 || (_templateObject7$19 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  margin-top: ", "px;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-weight: 400;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (props) {
  return props.marginTop;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.dashWidth;
}, function (props) {
  return props.dashOffset;
}, function (props) {
  return props.dashOffset;
});
var MainTextBlock = styled.div(_templateObject8$16 || (_templateObject8$16 = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", ";\n"])), function (_ref2) {
  var withNumber = _ref2.withNumber,
    withDescription = _ref2.withDescription,
    marginBottom = _ref2.marginBottom;
  return !withNumber ? withDescription ? marginBottom + "px" : '15px' : '';
});
var TextSecond$R = styled.div(_templateObject9$13 || (_templateObject9$13 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: ", "px;\n  text-align: center;\n  margin: ", "px 0 ", "px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: 'zMr';\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: ", "px;\n"])), function (props) {
  return props.height;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.letterSpacing;
});
var TextThird$Q = styled.div(_templateObject10$r || (_templateObject10$r = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  text-align: center;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  font-weight: 400;\n  margin-bottom: ", "px;\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.marginBottom;
});
var TextFourth$1 = styled.div(_templateObject11$q || (_templateObject11$q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", "px;\n  font-weight: ", ";\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.fontWeight || 900;
});
var FlowersConstructor = function FlowersConstructor(_ref3) {
  var image = _ref3.image,
    url = _ref3.url,
    name = _ref3.name,
    description = _ref3.description,
    number = _ref3.number,
    withNumber = _ref3.withNumber,
    dw = _ref3.dw,
    dh = _ref3.dh,
    pageWidth = _ref3.pageWidth,
    pageHeight = _ref3.pageHeight,
    horizontalPadding = _ref3.horizontalPadding,
    urlHeightPercent = _ref3.urlHeightPercent,
    textBlockHeightPercent = _ref3.textBlockHeightPercent,
    textBlockWidthPercent = _ref3.textBlockWidthPercent,
    textBlockPaddingBottom = _ref3.textBlockPaddingBottom,
    imageAlignment = _ref3.imageAlignment,
    firstMarginTop = _ref3.firstMarginTop,
    firstFontSize = _ref3.firstFontSize,
    firstLetterSpacing = _ref3.firstLetterSpacing,
    dashWidth = _ref3.dashWidth,
    dashOffset = _ref3.dashOffset,
    mainTextBlockMarginBottom = _ref3.mainTextBlockMarginBottom,
    secondFontMax = _ref3.secondFontMax,
    secondHeight = _ref3.secondHeight,
    secondMarginTop = _ref3.secondMarginTop,
    secondMarginBottom = _ref3.secondMarginBottom,
    secondLetterSpacing = _ref3.secondLetterSpacing,
    thirdFontSize = _ref3.thirdFontSize,
    thirdLetterSpacing = _ref3.thirdLetterSpacing,
    thirdMarginBottom = _ref3.thirdMarginBottom,
    fourthFontSize = _ref3.fourthFontSize,
    fourthFontWeight = _ref3.fourthFontWeight;
  var withDescription = Boolean(description === null || description === void 0 ? void 0 : description.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$13, {
    dw: dw,
    dh: dh,
    pageWidth: pageWidth,
    pageHeight: pageHeight,
    horizontalPadding: horizontalPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$Y, null, /*#__PURE__*/React$1.createElement(TextUrl$Q, {
    urlHeightPercent: urlHeightPercent
  }, /*#__PURE__*/React$1.createElement("span", null)), /*#__PURE__*/React$1.createElement(ImageBlock$Y, null, /*#__PURE__*/React$1.createElement(ImageInner$_, {
    imageAlignment: imageAlignment
  }, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$14, {
    withNumber: withNumber,
    withDescription: withDescription,
    textBlockHeightPercent: textBlockHeightPercent,
    textBlockWidthPercent: textBlockWidthPercent,
    textBlockPaddingBottom: textBlockPaddingBottom
  }, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$Q, {
    marginTop: firstMarginTop,
    fontSize: firstFontSize,
    letterSpacing: firstLetterSpacing,
    dashWidth: dashWidth,
    dashOffset: dashOffset
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(MainTextBlock, {
    withNumber: withNumber,
    withDescription: withDescription,
    marginBottom: mainTextBlockMarginBottom
  }, /*#__PURE__*/React$1.createElement(TextSecond$R, {
    height: secondHeight,
    marginTop: secondMarginTop,
    marginBottom: secondMarginBottom,
    letterSpacing: secondLetterSpacing
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: name,
    fontSizeMax: secondFontMax
  })), withDescription ? /*#__PURE__*/React$1.createElement(TextThird$Q, {
    fontSize: thirdFontSize,
    letterSpacing: thirdLetterSpacing,
    marginBottom: thirdMarginBottom
  }, description) : /*#__PURE__*/React$1.createElement(TextFourth$1, {
    fontSize: fourthFontSize,
    fontWeight: fourthFontWeight
  }, url)), withDescription && /*#__PURE__*/React$1.createElement(TextFourth$1, {
    fontSize: fourthFontSize,
    fontWeight: fourthFontWeight
  }, url))));
};

var FlowersCardA4 = function FlowersCardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowersConstructor, _extends({}, props, {
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 105,
    urlHeightPercent: 5.905,
    textBlockHeightPercent: 17,
    textBlockWidthPercent: 87.9,
    textBlockPaddingBottom: 26,
    imageAlignment: "center",
    firstMarginTop: 17,
    firstFontSize: 27,
    firstLetterSpacing: 5,
    dashWidth: 39,
    dashOffset: -24,
    mainTextBlockMarginBottom: 20,
    secondFontMax: 16,
    secondHeight: 20,
    secondMarginTop: 37,
    secondMarginBottom: 10,
    secondLetterSpacing: 0.45,
    thirdFontSize: 11.4,
    thirdLetterSpacing: 0.2,
    thirdMarginBottom: 33,
    fourthFontSize: 4.5,
    fourthFontWeight: 900
  }));
};

var FlowersCardWithNumberA4 = function FlowersCardWithNumberA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowersCardA4, _extends({}, props, {
    withNumber: true
  }));
};

var FlowersCardA5 = function FlowersCardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowersConstructor, _extends({}, props, {
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 74,
    urlHeightPercent: 5.905,
    textBlockHeightPercent: 17,
    textBlockWidthPercent: 87.9,
    textBlockPaddingBottom: 18,
    imageAlignment: "center",
    firstMarginTop: 12,
    firstFontSize: 19,
    firstLetterSpacing: 3.5,
    dashWidth: 27,
    dashOffset: -17,
    mainTextBlockMarginBottom: 14,
    secondFontMax: 11,
    secondHeight: 14,
    secondMarginTop: 26,
    secondMarginBottom: 7,
    secondLetterSpacing: 0.3,
    thirdFontSize: 8,
    thirdLetterSpacing: 0.15,
    thirdMarginBottom: 23,
    fourthFontSize: 3.2,
    fourthFontWeight: 900
  }));
};

var FlowersCardWithNumberA5 = function FlowersCardWithNumberA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowersCardA5, _extends({}, props, {
    withNumber: true
  }));
};

var components$b = {
  FlowersCardA4: FlowersCardA4,
  FlowersCardWithNumberA4: FlowersCardWithNumberA4,
  FlowersCardA5: FlowersCardA5,
  FlowersCardWithNumberA5: FlowersCardWithNumberA5
};
var FlowersStyleCard = function FlowersStyleCard(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components$b[templateType], {
    url: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.link) || 'ze.land',
    image: image,
    number: cardNumber,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    description: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.description) || '',
    museum: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    name: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.title) || '',
    dw: dw,
    dh: dh
  });
};

var components$c = {
  FlowersCardA4: FlowersCardA4,
  FlowersCardWithNumberA4: FlowersCardWithNumberA4
};
var FlowersStyleCardPrint = function FlowersStyleCardPrint(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$c[templateType], {
    url: (data === null || data === void 0 ? void 0 : data.link) || 'ze.land',
    image: image,
    number: (data === null || data === void 0 ? void 0 : data.number) || '',
    customSubtitle: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    description: (data === null || data === void 0 ? void 0 : data.description) || '',
    museum: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    name: (data === null || data === void 0 ? void 0 : data.name) || '',
    dw: dw,
    dh: dh
  });
};

var _templateObject$1X, _templateObject2$1X, _templateObject3$1R, _templateObject4$1s, _templateObject5$1g, _templateObject6$1e, _templateObject7$1a, _templateObject8$17, _templateObject9$14, _templateObject10$s, _templateObject11$r;
var Wrapper$14 = styled.div(_templateObject$1X || (_templateObject$1X = _taggedTemplateLiteralLoose(["\n  width: 148mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 148),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 28.5px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$Z = styled.div(_templateObject2$1X || (_templateObject2$1X = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$R = styled.div(_templateObject3$1R || (_templateObject3$1R = _taggedTemplateLiteralLoose(["\n  height: 5.7315%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 4px;\n    margin: 4px 2px 0 0;\n  }\n"])));
var ImageBlock$Z = styled.div(_templateObject4$1s || (_templateObject4$1s = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$$ = styled.div(_templateObject5$1g || (_templateObject5$1g = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var ImageInnerContainer = styled.span(_templateObject6$1e || (_templateObject6$1e = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 100%;\n  width: fit-content;\n"])));
var QrBlock$5 = styled.div(_templateObject7$1a || (_templateObject7$1a = _taggedTemplateLiteralLoose(["\n  background-color: #fff;\n  padding: 3px;\n  display: flex;\n  position: absolute;\n  bottom: 11px;\n  left: 11px;\n  z-index: 999;\n"])));
var TextBlock$15 = styled.div(_templateObject8$17 || (_templateObject8$17 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.426%;\n  width: 88%;\n  padding-bottom: 23.4px;\n"])));
var TextFirst$R = styled.div(_templateObject9$14 || (_templateObject9$14 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.3px;\n    margin-right: -2.3px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 43px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -18px;\n      transform: scale(0.7) translate(-100%, 0);\n      transform-origin: 0 0;\n    }\n\n    &.right-dash {\n      right: -18px;\n      transform: scale(0.7) translate(145%, 0);\n      transform-origin: 0 0;\n    }\n  }\n"])));
var TextSecond$S = styled.div(_templateObject10$s || (_templateObject10$s = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  width: 100%;\n  height: 40px;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  margin: 7px 0 9.5px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -1.5;
});
var TextThird$R = styled.div(_templateObject11$r || (_templateObject11$r = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 5.7px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard2WithQrA5 = function WarholCard2WithQrA5(_ref) {
  var image = _ref.image,
    url = _ref.url,
    name = _ref.name,
    number = _ref.number,
    dw = _ref.dw,
    dh = _ref.dh,
    customSubtitle = _ref.customSubtitle,
    _ref$linkForQr = _ref.linkForQr,
    linkForQr = _ref$linkForQr === void 0 ? 'gallllery.com' : _ref$linkForQr;
  var _useState = useState({
      width: 0,
      height: 0
    }),
    imgSize = _useState[0],
    setImgSize = _useState[1];
  var initName = toUpperCaseString({
    str: name
  });
  var handleLoad = function handleLoad(e) {
    var _e$target = e.target,
      naturalHeight = _e$target.naturalHeight,
      naturalWidth = _e$target.naturalWidth;
    setImgSize({
      width: naturalWidth,
      height: naturalHeight
    });
  };
  var isEmptyImg = useMemo(function () {
    return imgSize.height === 0 && imgSize.width === 0;
  }, [imgSize]);
  return /*#__PURE__*/React$1.createElement(Wrapper$14, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$Z, null, /*#__PURE__*/React$1.createElement(TextUrl$R, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$Z, null, /*#__PURE__*/React$1.createElement(ImageInner$$, null, /*#__PURE__*/React$1.createElement(ImageInnerContainer, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "card",
    draggable: false,
    onLoad: handleLoad
  }), !isEmptyImg && /*#__PURE__*/React$1.createElement(QrBlock$5, null, /*#__PURE__*/React$1.createElement(QRCodeSVG, {
    size: 100.2,
    value: linkForQr
  }))))), /*#__PURE__*/React$1.createElement(TextBlock$15, null, /*#__PURE__*/React$1.createElement(TextFirst$R, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$S, {
    id: "text-second"
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: 32
  })), /*#__PURE__*/React$1.createElement(TextThird$R, null, customSubtitle || url))));
};

var components$d = {
  WarholCard2WithQrA5: WarholCard2WithQrA5
};
var getComponent = function getComponent(templateType, templateDataComputed) {
  if (components$d[templateType]) {
    return components$d[templateType];
  } else {
    return components$d.WarholCard2WithQrA5;
  }
};
var WarholStyle2WithQrCard = function WarholStyle2WithQrCard(props) {
  var _templateDataComputed, _templateDataComputed2, _templateDataComputed3, _templateDataComputed4;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = (data === null || data === void 0 ? void 0 : data.templateData) || {};
  var linkForQr = (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed = templateDataComputed.customFields) === null || _templateDataComputed === void 0 ? void 0 : (_templateDataComputed2 = _templateDataComputed.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.name) === 'qrcode';
  })) === null || _templateDataComputed2 === void 0 ? void 0 : _templateDataComputed2.data) || '';
  return React$1.createElement(getComponent(templateType), {
    url: templateDataComputed && templateDataComputed.link || 'gallllery.com',
    image: image,
    number: cardNumber.replace('№ ', '№'),
    museum: templateDataComputed && templateDataComputed.description || '',
    name: templateDataComputed && templateDataComputed.title && templateDataComputed.title.toString() || '',
    dw: dw,
    dh: dh,
    linkForQr: linkForQr,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed3 = templateDataComputed.subTitle) === null || _templateDataComputed3 === void 0 ? void 0 : _templateDataComputed3.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed4 = templateDataComputed.description) === null || _templateDataComputed4 === void 0 ? void 0 : _templateDataComputed4.toString())
  });
};

var components$e = {
  WarholCard2WithQrA5: WarholCard2WithQrA5
};
var WarholStyle2WithQrCardPrint = function WarholStyle2WithQrCardPrint(props) {
  var _data$customfields, _data$subTitle, _data$description;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var linkForQr = (data === null || data === void 0 ? void 0 : (_data$customfields = data.customfields) === null || _data$customfields === void 0 ? void 0 : _data$customfields.qrcode) || '';
  return React$1.createElement(components$e[templateType], {
    url: data && data.link || 'gallllery.com',
    image: image,
    number: data && data.number,
    museum: data && data.description || '',
    name: data && data.title && data.title.toString() || '',
    dw: dw,
    dh: dh,
    linkForQr: linkForQr,
    customSubtitle: (data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : _data$subTitle.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : _data$description.toString())
  });
};

var CalendarsModernPrint = function CalendarsModernPrint(_ref) {
  var _calendarsData$logoFi, _calendarsData$cards;
  var calendarsData = _ref.calendarsData;
  var images = calendarsData && calendarsData.cards && calendarsData.cards.length ? calendarsData.cards.map(function (card) {
    return card && card.imageUrl;
  }) : [];
  var logo = getImageUrl(calendarsData !== null && calendarsData !== void 0 && (_calendarsData$logoFi = calendarsData.logoFiles) !== null && _calendarsData$logoFi !== void 0 && _calendarsData$logoFi.length ? calendarsData.logoFiles : []);
  var year = new Date().getFullYear();
  var getDateFromMonthIndex = function getDateFromMonthIndex(index) {
    var currentYear = calendarsData && calendarsData.year || year;
    var currentMonth = index + (calendarsData && calendarsData.startMonth);
    var nextYear = currentYear + 1;
    return new Date(currentMonth > 11 ? nextYear : currentYear, currentMonth % 12);
  };
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      display: 'grid'
    }
  }, /*#__PURE__*/React$1.createElement(CalendarFreePreview, {
    year: calendarsData && calendarsData.year || year,
    images: images && images.length && images.slice(0, 12) || [],
    author: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.author) || '',
    title: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.title) || '',
    logo: logo
  }), calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$cards = calendarsData.cards) === null || _calendarsData$cards === void 0 ? void 0 : _calendarsData$cards.map(function (item, index) {
    var _calendarsData$title, _calendarsData$title2;
    return /*#__PURE__*/React$1.createElement(CalendarModern, {
      key: (item === null || item === void 0 ? void 0 : item.cardId) + "-" + index,
      cardId: item === null || item === void 0 ? void 0 : item.cardId,
      cardTitle: item === null || item === void 0 ? void 0 : item.name,
      title: (calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$title = calendarsData.title) === null || _calendarsData$title === void 0 ? void 0 : _calendarsData$title.length) && (calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$title2 = calendarsData.title) === null || _calendarsData$title2 === void 0 ? void 0 : _calendarsData$title2.substring(0, 53)) || '',
      date: getDateFromMonthIndex(index),
      author: item === null || item === void 0 ? void 0 : item.description,
      images: item === null || item === void 0 ? void 0 : item.images,
      orientation: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.orientation) || 'vertical',
      events: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.events) || [],
      calendarCollectionId: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.calendarCollectionId) || '',
      printImgUrl: item === null || item === void 0 ? void 0 : item.imageUrl,
      isPrinting: true,
      ownerName: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.ownerName) || '',
      bottomLink: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.bottomLink) || '',
      collectionName: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.collectionName) || '',
      sideAuthor: item === null || item === void 0 ? void 0 : item.sideAuthor,
      startDate: calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.startDate,
      calendarType: calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.calendarType
    });
  }));
};

var _templateObject$1Y, _templateObject2$1Y, _templateObject3$1S, _templateObject4$1t, _templateObject5$1h, _templateObject6$1f, _templateObject7$1b, _templateObject8$18, _templateObject9$15, _templateObject10$t;
var Container$1 = styled.div(_templateObject$1Y || (_templateObject$1Y = _taggedTemplateLiteralLoose(["\n  height: 594mm;\n  width: 420mm;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  transform: scale(", ");\n  transform-origin: top left;\n  padding: 157px 159px;\n\n  * {\n    box-sizing: border-box;\n  }\n"])), function (p) {
  return p.scaleSize;
});
var Header$1 = styled.div(_templateObject2$1Y || (_templateObject2$1Y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 7.6%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: ", ";\n  padding-bottom: 26px;\n  border-bottom: 2.5px solid #000;\n"])), function (p) {
  return p.withLogo ? 'space-between' : 'flex-end';
});
var YearBlock$1 = styled.div(_templateObject3$1S || (_templateObject3$1S = _taggedTemplateLiteralLoose(["\n  color: #b22125;\n  font-size: 50px;\n  font-weight: 600;\n  display: flex;\n  align-items: start;\n  line-height: 100%;\n  letter-spacing: 1px;\n"])));
var Logo$1 = styled.img(_templateObject4$1t || (_templateObject4$1t = _taggedTemplateLiteralLoose(["\n  width: auto;\n  max-height: 100%;\n"])));
var CardsBlock$1 = styled.div(_templateObject5$1h || (_templateObject5$1h = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  width: 100%;\n  padding: 10px 0;\n"])));
var ImagesContainer$1 = styled.div(_templateObject6$1f || (_templateObject6$1f = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(4, 1fr);\n"])));
var Image$2 = styled.img(_templateObject7$1b || (_templateObject7$1b = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  aspect-ratio: ", ";\n  background: #ffffff !important;\n"])), function (_ref) {
  var imgAspectRatio = _ref.imgAspectRatio;
  return imgAspectRatio || '1.1 / 1';
});
var Footer$3 = styled.div(_templateObject8$18 || (_templateObject8$18 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 10.1%;\n  display: flex;\n  flex-direction: column;\n  border-top: 2.5px solid #000;\n  padding-top: 25px;\n  gap: 15px;\n"])));
var Title$6 = styled.div(_templateObject9$15 || (_templateObject9$15 = _taggedTemplateLiteralLoose(["\n  font-size: 42px;\n  font-weight: bold;\n  letter-spacing: 0.4px;\n"])));
var SubTitle$1 = styled.div(_templateObject10$t || (_templateObject10$t = _taggedTemplateLiteralLoose(["\n  font-size: 17px;\n  letter-spacing: 0.05px;\n"])));
var CalendarPreview = function CalendarPreview(_ref2) {
  var images = _ref2.images,
    year = _ref2.year,
    title = _ref2.title,
    scaleSize = _ref2.scaleSize,
    logo = _ref2.logo,
    author = _ref2.author,
    styles = _ref2.styles,
    imgAspectRatio = _ref2.imgAspectRatio;
  var withLogo = Boolean(logo);
  var cardTitle = (title === null || title === void 0 ? void 0 : title.toUpperCase()) || '';
  return /*#__PURE__*/React$1.createElement(Container$1, {
    scaleSize: scaleSize,
    style: styles
  }, /*#__PURE__*/React$1.createElement(Header$1, {
    withLogo: withLogo
  }, withLogo && /*#__PURE__*/React$1.createElement(Logo$1, {
    src: logo,
    alt: "logo"
  }), /*#__PURE__*/React$1.createElement(YearBlock$1, null, year)), /*#__PURE__*/React$1.createElement(CardsBlock$1, null, /*#__PURE__*/React$1.createElement(ImagesContainer$1, null, images.map(function (image, index) {
    return /*#__PURE__*/React$1.createElement(Image$2, {
      key: index,
      src: image,
      imgAspectRatio: imgAspectRatio
    });
  }))), /*#__PURE__*/React$1.createElement(Footer$3, null, /*#__PURE__*/React$1.createElement(Title$6, null, cardTitle), /*#__PURE__*/React$1.createElement(SubTitle$1, null, author)));
};

var _templateObject$1Z, _templateObject2$1Z, _templateObject3$1T, _templateObject4$1u, _templateObject5$1i, _templateObject6$1g, _templateObject7$1c, _templateObject8$19, _templateObject9$16;
var Wrapper$15 = styled.div(_templateObject$1Z || (_templateObject$1Z = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: ", "px;\n  padding-right: 0;\n  display: flex;\n\n  * {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.width;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.height;
}, function (props) {
  return props.padding;
});
var ImageBlock$_ = styled.div(_templateObject2$1Z || (_templateObject2$1Z = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$16 = styled.div(_templateObject3$1T || (_templateObject3$1T = _taggedTemplateLiteralLoose(["\n  width: ", "px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ", "px;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.gap;
});
var Text = styled.div(_templateObject4$1u || (_templateObject4$1u = _taggedTemplateLiteralLoose(["\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  white-space: nowrap;\n"])));
var Museum = styled(Text)(_templateObject5$1i || (_templateObject5$1i = _taggedTemplateLiteralLoose(["\n  font-family: Roboto, serif;\n  font-size: ", "px;\n  font-weight: 600;\n  letter-spacing: ", ";\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  text-transform: uppercase;\n  color: #151514;\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
});
var UrlAndNumContainer = styled.div(_templateObject6$1g || (_templateObject6$1g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ", "px;\n"])), function (props) {
  return props.gap;
});
var UrlAndNumber = styled(Text)(_templateObject7$1c || (_templateObject7$1c = _taggedTemplateLiteralLoose(["\n  font-family: Inter;\n  font-size: ", "px;\n  font-weight: 400;\n  letter-spacing: ", ";\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  color: #909090;\n  margin-top: ", "px;\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.isNumber && props.urlNumberMarginTop;
});
var NumSymbol = styled.div(_templateObject8$19 || (_templateObject8$19 = _taggedTemplateLiteralLoose(["\n  transform: rotate(90deg);\n  display: inline-block;\n"])));
var Divider = styled.div(_templateObject9$16 || (_templateObject9$16 = _taggedTemplateLiteralLoose(["\n  background-color: #909090;\n  width: ", "px;\n  height: ", "px;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var PosterCardConstructor = function PosterCardConstructor(_ref) {
  var image = _ref.image,
    url = _ref.url,
    number = _ref.number,
    dw = _ref.dw,
    dh = _ref.dh,
    museum = _ref.museum,
    museumFontSize = _ref.museumFontSize,
    museumLetterSpacing = _ref.museumLetterSpacing,
    width = _ref.width,
    height = _ref.height,
    containerPadding = _ref.containerPadding,
    textBlockGap = _ref.textBlockGap,
    urlNumGap = _ref.urlNumGap,
    urlNumFontSize = _ref.urlNumFontSize,
    urlNumLetterSpacing = _ref.urlNumLetterSpacing,
    dividerWidth = _ref.dividerWidth,
    dividerHeight = _ref.dividerHeight,
    urlNumberMarginTop = _ref.urlNumberMarginTop;
  var withNumSymbol = number.includes('№');
  var numberText = withNumSymbol ? /*#__PURE__*/React$1.createElement(Fragment$1, null, /*#__PURE__*/React$1.createElement(NumSymbol, null, "\u2116"), "" + number.replace('№', '')) : number;
  return /*#__PURE__*/React$1.createElement(Wrapper$15, {
    dh: dh,
    dw: dw,
    width: width,
    height: height,
    padding: containerPadding
  }, /*#__PURE__*/React$1.createElement(ImageBlock$_, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  })), /*#__PURE__*/React$1.createElement(TextBlock$16, {
    width: containerPadding,
    gap: textBlockGap
  }, /*#__PURE__*/React$1.createElement(Museum, {
    fontSize: museumFontSize,
    letterSpacing: museumLetterSpacing
  }, museum), /*#__PURE__*/React$1.createElement(UrlAndNumContainer, {
    gap: urlNumGap
  }, /*#__PURE__*/React$1.createElement(UrlAndNumber, {
    fontSize: urlNumFontSize,
    letterSpacing: urlNumLetterSpacing
  }, numberText), /*#__PURE__*/React$1.createElement(Divider, {
    width: dividerWidth,
    height: dividerHeight
  }), /*#__PURE__*/React$1.createElement(UrlAndNumber, {
    isNumber: true,
    fontSize: urlNumFontSize,
    letterSpacing: urlNumLetterSpacing,
    urlNumberMarginTop: urlNumberMarginTop
  }, url))));
};

var PosterCardA5 = function PosterCardA5(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 148,
    height: 210,
    containerPadding: 38,
    textBlockGap: 16,
    museumFontSize: 10,
    museumLetterSpacing: "-0.02em",
    urlNumLetterSpacing: "-0.03em",
    urlNumFontSize: 10,
    urlNumGap: 6,
    dividerWidth: 12,
    dividerHeight: 1
  }));
};

var PosterCardA4 = function PosterCardA4(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 210,
    height: 297,
    containerPadding: 47,
    textBlockGap: 22,
    museumFontSize: 15,
    urlNumFontSize: 15,
    museumLetterSpacing: "-0.01em",
    urlNumLetterSpacing: "-0.02em",
    urlNumGap: 7,
    dividerWidth: 18,
    dividerHeight: 1
  }));
};

var PosterCardA3 = function PosterCardA3(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 297,
    height: 420,
    containerPadding: 58,
    textBlockGap: 30,
    museumFontSize: 15,
    urlNumFontSize: 20,
    urlNumLetterSpacing: "-0.03em",
    urlNumGap: 7,
    dividerWidth: 25,
    dividerHeight: 1
  }));
};

var PosterCardA2 = function PosterCardA2(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 420,
    height: 594,
    containerPadding: 81,
    textBlockGap: 43,
    museumFontSize: 30,
    museumLetterSpacing: "0.005em",
    urlNumFontSize: 32,
    urlNumLetterSpacing: "-0.04em",
    urlNumGap: 10,
    dividerWidth: 37,
    dividerHeight: 1
  }));
};

var PosterCardA1 = function PosterCardA1(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 594,
    height: 841,
    containerPadding: 117,
    textBlockGap: 53,
    museumFontSize: 40,
    urlNumFontSize: 42,
    urlNumLetterSpacing: "-0.035em",
    urlNumGap: 12,
    dividerWidth: 50,
    dividerHeight: 1
  }));
};

var PosterCardA0 = function PosterCardA0(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 841,
    height: 1189,
    containerPadding: 138,
    textBlockGap: 59,
    museumFontSize: 45,
    museumLetterSpacing: "0.005em",
    urlNumFontSize: 47,
    urlNumLetterSpacing: "-0.03em",
    urlNumGap: 13,
    dividerWidth: 57,
    dividerHeight: 1
  }));
};

var PosterCardA0Plus = function PosterCardA0Plus(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 1000,
    height: 1414,
    containerPadding: 180,
    textBlockGap: 136,
    museumFontSize: 54,
    urlNumFontSize: 48,
    urlNumLetterSpacing: "-0.03em",
    urlNumGap: 6,
    dividerWidth: 66,
    dividerHeight: 4,
    urlNumberMarginTop: 47
  }));
};

var components$f = {
  PosterCardA0Plus: PosterCardA0Plus,
  PosterCardA0: PosterCardA0,
  PosterCardA1: PosterCardA1,
  PosterCardA2: PosterCardA2,
  PosterCardA3: PosterCardA3,
  PosterCardA4: PosterCardA4,
  PosterCardA5: PosterCardA5
};
var PosterCard = function PosterCard(_ref) {
  var _templateData$subTitl, _templateData$descrip;
  var data = _ref.data,
    image = _ref.image,
    templateType = _ref.templateType,
    dw = _ref.dw,
    dh = _ref.dh,
    customSubtitle = _ref.customSubtitle;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateData = (data === null || data === void 0 ? void 0 : data.templateData) || {};
  return React$1.createElement(components$f[templateType], {
    url: (templateData === null || templateData === void 0 ? void 0 : templateData.link) || 'gallllery.com',
    image: image,
    number: cardNumber,
    museum: (templateData === null || templateData === void 0 ? void 0 : templateData.title) || '',
    dw: dw,
    dh: dh,
    description: (templateData === null || templateData === void 0 ? void 0 : (_templateData$subTitl = templateData.subTitle) === null || _templateData$subTitl === void 0 ? void 0 : _templateData$subTitl.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (templateData === null || templateData === void 0 ? void 0 : (_templateData$descrip = templateData.description) === null || _templateData$descrip === void 0 ? void 0 : _templateData$descrip.toString())
  });
};

var _templateObject$1_, _templateObject2$1_, _templateObject3$1U, _templateObject4$1v, _templateObject5$1j, _templateObject6$1h, _templateObject7$1d, _templateObject8$1a, _templateObject9$17;
var Wrapper$16 = styled.div(_templateObject$1_ || (_templateObject$1_ = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.wrapperWidth;
}, function (props) {
  return props.wrapperHeight;
}, function (props) {
  return props.wrapperPadding;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.wrapperWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.wrapperHeight;
});
var MainBlock$_ = styled.div(_templateObject2$1_ || (_templateObject2$1_ = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$S = styled.div(_templateObject3$1U || (_templateObject3$1U = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: ", "px;\n    font-weight: ", ";\n    letter-spacing: ", "px;\n    line-height: ", "px;\n  }\n"])), function (props) {
  return props.urlHeight;
}, function (props) {
  return props.urlFontSize;
}, function (props) {
  return props.urlFontWeight;
}, function (props) {
  return props.urlLetterSpacing;
}, function (props) {
  return props.urlLineHeight;
});
var ImageBlock$$ = styled.div(_templateObject4$1v || (_templateObject4$1v = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$10 = styled.div(_templateObject5$1j || (_templateObject5$1j = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$17 = styled.div(_templateObject6$1h || (_templateObject6$1h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: ", "%;\n  width: ", "%;\n  padding-top: ", "px;\n  gap: ", "px;\n"])), function (props) {
  return props.textBlockHeight;
}, function (props) {
  return props.textBlockWidth;
}, function (props) {
  return props.textBlockPaddingTop;
}, function (props) {
  return props.textBlockGap;
});
var TextFirst$S = styled.div(_templateObject7$1d || (_templateObject7$1d = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n\n  span {\n    font-family: ", ";\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    /* text-indent: ", "px; */\n    color: #151514;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n    color: #151514;\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (props) {
  return props.firstTextFontFamily;
}, function (props) {
  return props.firstTextFontSize;
}, function (props) {
  return props.firstTextLetterSpacing;
}, function (props) {
  return props.firstTextIndent;
}, function (props) {
  return props.dashWidth;
}, function (props) {
  return props.dashPosition;
}, function (props) {
  return props.dashPosition;
});
var TextSecond$T = styled.div(_templateObject8$1a || (_templateObject8$1a = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: ", "px;\n  text-align: center;\n  color: var(--Gallllery-Black, #151514);\n  font-family: ", ";\n  font-style: italic;\n  font-weight: 500;\n  letter-spacing: ", "px;\n"])), function (props) {
  return props.secondTextHeight;
}, function (props) {
  return props.secondTextFontFamily;
}, function (props) {
  return props.secondTextLetterSpacing;
});
var TextThird$S = styled.div(_templateObject9$17 || (_templateObject9$17 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-size: ", "px;\n  font-weight: 400;\n  margin-bottom: ", "px;\n  font-family: ", ";\n  color: #151514;\n"])), function (props) {
  return props.thirdTextFontSize;
}, function (props) {
  return props.thirdTextMarginBottom;
}, function (props) {
  return props.thirdTextFontFamily;
});
var FamilyMuseumTemplate = function FamilyMuseumTemplate(_ref) {
  var image = _ref.image,
    url = _ref.url,
    name = _ref.name,
    number = _ref.number,
    withNumber = _ref.withNumber,
    customSubtitle = _ref.customSubtitle,
    description = _ref.description,
    dw = _ref.dw,
    dh = _ref.dh,
    wrapperWidth = _ref.wrapperWidth,
    wrapperHeight = _ref.wrapperHeight,
    wrapperPadding = _ref.wrapperPadding,
    urlHeight = _ref.urlHeight,
    urlFontSize = _ref.urlFontSize,
    urlLetterSpacing = _ref.urlLetterSpacing,
    urlFontWeight = _ref.urlFontWeight,
    urlLineHeight = _ref.urlLineHeight,
    textBlockHeight = _ref.textBlockHeight,
    textBlockWidth = _ref.textBlockWidth,
    textBlockPaddingTop = _ref.textBlockPaddingTop,
    textBlockGap = _ref.textBlockGap,
    firstTextFontSize = _ref.firstTextFontSize,
    firstTextFontFamily = _ref.firstTextFontFamily,
    firstTextLetterSpacing = _ref.firstTextLetterSpacing,
    firstTextIndent = _ref.firstTextIndent,
    dashWidth = _ref.dashWidth,
    dashPosition = _ref.dashPosition,
    secondTextFontFamily = _ref.secondTextFontFamily,
    secondTextLetterSpacing = _ref.secondTextLetterSpacing,
    secondTextHeight = _ref.secondTextHeight,
    thirdTextFontFamily = _ref.thirdTextFontFamily,
    thirdTextFontSize = _ref.thirdTextFontSize,
    thirdTextMarginBottom = _ref.thirdTextMarginBottom,
    fontSizeMax = _ref.fontSizeMax;
  var numberText = withNumber ? number : customSubtitle;
  return /*#__PURE__*/React$1.createElement(Wrapper$16, {
    dw: dw,
    dh: dh,
    wrapperWidth: wrapperWidth,
    wrapperHeight: wrapperHeight,
    wrapperPadding: wrapperPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$_, null, /*#__PURE__*/React$1.createElement(TextUrl$S, {
    urlHeight: urlHeight,
    urlFontSize: urlFontSize,
    urlLetterSpacing: urlLetterSpacing,
    urlFontWeight: urlFontWeight,
    urlLineHeight: urlLineHeight
  }, /*#__PURE__*/React$1.createElement("span", null, description && url)), /*#__PURE__*/React$1.createElement(ImageBlock$$, null, /*#__PURE__*/React$1.createElement(ImageInner$10, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$17, {
    textBlockHeight: textBlockHeight,
    textBlockWidth: textBlockWidth,
    textBlockPaddingTop: textBlockPaddingTop,
    textBlockGap: textBlockGap
  }, /*#__PURE__*/React$1.createElement(TextFirst$S, {
    dashWidth: dashWidth,
    dashPosition: dashPosition,
    firstTextFontSize: firstTextFontSize,
    firstTextFontFamily: firstTextFontFamily,
    firstTextLetterSpacing: firstTextLetterSpacing,
    firstTextIndent: firstTextIndent
  }, numberText && /*#__PURE__*/React$1.createElement(Fragment$1, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, numberText), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  }))), /*#__PURE__*/React$1.createElement(TextSecond$T, {
    secondTextFontFamily: secondTextFontFamily,
    secondTextLetterSpacing: secondTextLetterSpacing,
    secondTextHeight: secondTextHeight
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: name,
    fontSizeMax: fontSizeMax
  })), /*#__PURE__*/React$1.createElement(TextThird$S, {
    thirdTextFontFamily: thirdTextFontFamily,
    thirdTextFontSize: thirdTextFontSize,
    thirdTextMarginBottom: thirdTextMarginBottom
  }, description || url))));
};

var FamilyMuseumA0 = function FamilyMuseumA0(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 841,
    wrapperHeight: 1189,
    wrapperPadding: 380,
    urlHeight: 7.8,
    urlFontSize: 13,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 18.8,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 78,
    textBlockGap: 61.5,
    firstTextFontSize: 48,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 9,
    firstTextIndent: 5,
    dashWidth: 54,
    dashPosition: -41,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 60,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 28,
    thirdTextMarginBottom: 13,
    fontSizeMax: 76.5
  }));
};

var FamilyMuseumWithNumberA0 = function FamilyMuseumWithNumberA0(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA0, _extends({}, props, {
    withNumber: true
  }));
};

var _templateObject$1$, _templateObject2$1$, _templateObject3$1V, _templateObject4$1w, _templateObject5$1k, _templateObject6$1i, _templateObject7$1e, _templateObject8$1b, _templateObject9$18;
var Wrapper$17 = styled.div(_templateObject$1$ || (_templateObject$1$ = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.wrapperWidth;
}, function (props) {
  return props.wrapperHeight;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.wrapperWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.wrapperHeight;
}, function (props) {
  return props.wrapperPadding;
});
var MainBlock$$ = styled.div(_templateObject2$1$ || (_templateObject2$1$ = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$T = styled.div(_templateObject3$1V || (_templateObject3$1V = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: ", "px;\n    font-weight: ", ";\n    letter-spacing: ", "px;\n    line-height: ", "px;\n  }\n"])), function (props) {
  return props.urlHeight;
}, function (props) {
  return props.urlFontSize;
}, function (props) {
  return props.urlFontWeight;
}, function (props) {
  return props.urlLetterSpacing;
}, function (props) {
  return props.urlLineHeight;
});
var ImageBlock$10 = styled.div(_templateObject4$1w || (_templateObject4$1w = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$11 = styled.div(_templateObject5$1k || (_templateObject5$1k = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$18 = styled.div(_templateObject6$1i || (_templateObject6$1i = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: ", "%;\n  width: ", "%;\n  padding-top: ", "px;\n  gap: ", "px;\n"])), function (props) {
  return props.textBlockHeight;
}, function (props) {
  return props.textBlockWidth;
}, function (props) {
  return props.textBlockPaddingTop;
}, function (props) {
  return props.textBlockGap;
});
var TextFirst$T = styled.div(_templateObject7$1e || (_templateObject7$1e = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n\n  span {\n    font-family: ", ";\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-indent: ", "px;\n    color: #151514;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n    color: #151514;\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (props) {
  return props.firstTextFontFamily || 'none';
}, function (props) {
  return props.firstTextFontSize;
}, function (props) {
  return props.firstTextLetterSpacing;
}, function (props) {
  return props.firstTextIndent;
}, function (props) {
  return props.dashWidth;
}, function (props) {
  return props.dashPosition;
}, function (props) {
  return props.dashPosition;
});
var TextSecond$U = styled.div(_templateObject8$1b || (_templateObject8$1b = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: ", "px;\n  text-align: center;\n  color: #151514;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: 500;\n  letter-spacing: ", "px;\n"])), function (props) {
  return props.secondTextHeight;
}, function (props) {
  return props.secondTextFontFamily;
}, function (props) {
  return props.secondTextLetterSpacing;
});
var TextThird$T = styled.div(_templateObject9$18 || (_templateObject9$18 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-family: ", ";\n  font-size: ", "px;\n  font-weight: 400;\n  margin-bottom: ", "px;\n  color: #151514;\n"])), function (props) {
  return props.thirdTextFontFamily;
}, function (props) {
  return props.thirdTextFontSize;
}, function (props) {
  return props.thirdTextMarginBottom;
});
var FamilyMuseumTemplateL = function FamilyMuseumTemplateL(_ref) {
  var image = _ref.image,
    url = _ref.url,
    name = _ref.name,
    number = _ref.number,
    withNumber = _ref.withNumber,
    customSubtitle = _ref.customSubtitle,
    description = _ref.description,
    dw = _ref.dw,
    dh = _ref.dh,
    wrapperWidth = _ref.wrapperWidth,
    wrapperHeight = _ref.wrapperHeight,
    wrapperPadding = _ref.wrapperPadding,
    urlHeight = _ref.urlHeight,
    urlFontSize = _ref.urlFontSize,
    urlLetterSpacing = _ref.urlLetterSpacing,
    urlFontWeight = _ref.urlFontWeight,
    urlLineHeight = _ref.urlLineHeight,
    textBlockHeight = _ref.textBlockHeight,
    textBlockWidth = _ref.textBlockWidth,
    textBlockPaddingTop = _ref.textBlockPaddingTop,
    textBlockGap = _ref.textBlockGap,
    firstTextFontSize = _ref.firstTextFontSize,
    firstTextFontFamily = _ref.firstTextFontFamily,
    firstTextLetterSpacing = _ref.firstTextLetterSpacing,
    firstTextIndent = _ref.firstTextIndent,
    dashWidth = _ref.dashWidth,
    dashPosition = _ref.dashPosition,
    secondTextFontFamily = _ref.secondTextFontFamily,
    secondTextLetterSpacing = _ref.secondTextLetterSpacing,
    secondTextHeight = _ref.secondTextHeight,
    thirdTextFontFamily = _ref.thirdTextFontFamily,
    thirdTextFontSize = _ref.thirdTextFontSize,
    thirdTextMarginBottom = _ref.thirdTextMarginBottom,
    fontSizeMax = _ref.fontSizeMax;
  var numberText = withNumber ? number : customSubtitle;
  return /*#__PURE__*/React$1.createElement(Wrapper$17, {
    dw: dw,
    dh: dh,
    wrapperWidth: wrapperWidth,
    wrapperHeight: wrapperHeight,
    wrapperPadding: wrapperPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$$, null, /*#__PURE__*/React$1.createElement(TextUrl$T, {
    urlHeight: urlHeight,
    urlFontSize: urlFontSize,
    urlLetterSpacing: urlLetterSpacing,
    urlFontWeight: urlFontWeight,
    urlLineHeight: urlLineHeight
  }, /*#__PURE__*/React$1.createElement("span", null, description && url)), /*#__PURE__*/React$1.createElement(ImageBlock$10, null, /*#__PURE__*/React$1.createElement(ImageInner$11, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$18, {
    textBlockHeight: textBlockHeight,
    textBlockWidth: textBlockWidth,
    textBlockPaddingTop: textBlockPaddingTop,
    textBlockGap: textBlockGap
  }, /*#__PURE__*/React$1.createElement(TextFirst$T, {
    firstTextFontSize: firstTextFontSize,
    firstTextFontFamily: firstTextFontFamily,
    firstTextLetterSpacing: firstTextLetterSpacing,
    firstTextIndent: firstTextIndent,
    dashWidth: dashWidth,
    dashPosition: dashPosition
  }, numberText && /*#__PURE__*/React$1.createElement(Fragment$1, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, numberText), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  }))), /*#__PURE__*/React$1.createElement(TextSecond$U, {
    secondTextFontFamily: secondTextFontFamily,
    secondTextLetterSpacing: secondTextLetterSpacing,
    secondTextHeight: secondTextHeight
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: name,
    fontSizeMax: fontSizeMax
  })), /*#__PURE__*/React$1.createElement(TextThird$T, {
    thirdTextFontFamily: thirdTextFontFamily,
    thirdTextFontSize: thirdTextFontSize,
    thirdTextMarginBottom: thirdTextMarginBottom
  }, description || url))));
};

var FamilyMuseumA0L = function FamilyMuseumA0L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplateL, _extends({}, props, {
    wrapperWidth: 1189,
    wrapperHeight: 841,
    wrapperPadding: 165,
    urlHeight: 6.8,
    urlFontSize: 13,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 21,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 19,
    textBlockGap: 60,
    firstTextFontSize: 46,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 9.7,
    firstTextIndent: 1,
    dashWidth: 53,
    dashPosition: -40,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 60,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 27.5,
    thirdTextMarginBottom: 0,
    fontSizeMax: 77
  }));
};

var FamilyMuseumWithNumberA0L = function FamilyMuseumWithNumberA0L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA0L, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA1 = function FamilyMuseumA1(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 594,
    wrapperHeight: 841,
    wrapperPadding: 265,
    urlHeight: 7.8,
    urlFontSize: 12,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 18.8,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 25,
    textBlockGap: 45.5,
    firstTextFontSize: 36,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 7,
    firstTextIndent: 5,
    dashWidth: 42,
    dashPosition: -36,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 50,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 22,
    thirdTextMarginBottom: 13,
    fontSizeMax: 58.5
  }));
};

var FamilyMuseumWithNumberA1 = function FamilyMuseumWithNumberA1(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA1, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA1L = function FamilyMuseumA1L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplateL, _extends({}, props, {
    wrapperWidth: 841,
    wrapperHeight: 594,
    wrapperPadding: 120,
    urlHeight: 6.8,
    urlFontSize: 12,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 22.5,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 33,
    textBlockGap: 45,
    firstTextFontSize: 35,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 7.5,
    firstTextIndent: 1,
    dashWidth: 42,
    dashPosition: -31,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 47,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 21.5,
    thirdTextMarginBottom: 4,
    fontSizeMax: 59
  }));
};

var FamilyMuseumWithNumberA1L = function FamilyMuseumWithNumberA1L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA1L, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA2 = function FamilyMuseumA2(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 420,
    wrapperHeight: 594,
    wrapperPadding: 190,
    urlHeight: 7.8,
    urlFontSize: 9,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 18.9,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 34,
    textBlockGap: 30.5,
    firstTextFontSize: 25,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 5.3,
    firstTextIndent: 5,
    dashWidth: 28,
    dashPosition: -24,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 33,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 15.4,
    thirdTextMarginBottom: 13,
    fontSizeMax: 41.5
  }));
};

var FamilyMuseumWithNumberA2 = function FamilyMuseumWithNumberA2(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA2, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA2L = function FamilyMuseumA2L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplateL, _extends({}, props, {
    wrapperWidth: 594,
    wrapperHeight: 420,
    wrapperPadding: 85,
    urlHeight: 6.8,
    urlFontSize: 9,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 22.5,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 33,
    textBlockGap: 33,
    firstTextFontSize: 25,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 5.4,
    firstTextIndent: 1,
    dashWidth: 30,
    dashPosition: -20,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 35,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 15.2,
    thirdTextMarginBottom: 15,
    fontSizeMax: 41
  }));
};

var FamilyMuseumWithNumberA2L = function FamilyMuseumWithNumberA2L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA2L, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA3 = function FamilyMuseumA3(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 297,
    wrapperHeight: 420,
    wrapperPadding: 135,
    urlHeight: 7.8,
    urlFontSize: 6,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 18.9,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 33,
    textBlockGap: 24.5,
    firstTextFontSize: 19,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 2.8,
    firstTextIndent: 5,
    dashWidth: 21,
    dashPosition: -17,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 20,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 11,
    thirdTextMarginBottom: 22,
    fontSizeMax: 29
  }));
};

var FamilyMuseumWithNumberA3 = function FamilyMuseumWithNumberA3(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA3, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA3L = function FamilyMuseumA3L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplateL, _extends({}, props, {
    wrapperWidth: 420,
    wrapperHeight: 297,
    wrapperPadding: 58,
    urlHeight: 6.8,
    urlFontSize: 6,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 22.5,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 33,
    textBlockGap: 21,
    firstTextFontSize: 18,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 3.5,
    firstTextIndent: 1,
    dashWidth: 21,
    dashPosition: -14,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 29,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 10.8,
    thirdTextMarginBottom: 21,
    fontSizeMax: 29
  }));
};

var FamilyMuseumWithNumberA3L = function FamilyMuseumWithNumberA3L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA3L, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA4 = function FamilyMuseumA4(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 210,
    wrapperHeight: 297,
    wrapperPadding: 94,
    urlHeight: 7.8,
    urlFontSize: 5,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 18.9,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 30,
    textBlockGap: 14.5,
    firstTextFontSize: 13,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 2.4,
    firstTextIndent: 5,
    dashWidth: 15,
    dashPosition: -12,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 20,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 7.5,
    thirdTextMarginBottom: 22,
    fontSizeMax: 20
  }));
};

var FamilyMuseumA4L = function FamilyMuseumA4L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplateL, _extends({}, props, {
    wrapperWidth: 297,
    wrapperHeight: 210,
    wrapperPadding: 43,
    urlHeight: 6.8,
    urlFontSize: 5,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 22.5,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 33,
    textBlockGap: 15,
    firstTextFontSize: 13,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 2.4,
    firstTextIndent: 1,
    dashWidth: 15,
    dashPosition: -10,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 18,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 7.6,
    thirdTextMarginBottom: 24,
    fontSizeMax: 20
  }));
};

var FamilyMuseumWithNumberA4 = function FamilyMuseumWithNumberA4(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA4, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumWithNumberA4L = function FamilyMuseumWithNumberA4L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA4L, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA5 = function FamilyMuseumA5(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 148,
    wrapperHeight: 210,
    wrapperPadding: 66,
    urlHeight: 7.8,
    urlFontSize: 5,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 18.9,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 24,
    textBlockGap: 7.5,
    firstTextFontSize: 9,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 2.1,
    firstTextIndent: 6,
    dashWidth: 10.5,
    dashPosition: -8,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 20,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 6,
    thirdTextMarginBottom: 18,
    fontSizeMax: 14.5
  }));
};

var FamilyMuseumWithNumberA5 = function FamilyMuseumWithNumberA5(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA5, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA5L = function FamilyMuseumA5L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplateL, _extends({}, props, {
    wrapperWidth: 210,
    wrapperHeight: 148,
    wrapperPadding: 31,
    urlHeight: 6.8,
    urlFontSize: 5,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 22.5,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 33,
    textBlockGap: 8,
    firstTextFontSize: 10,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 1.5,
    firstTextIndent: 1,
    dashWidth: 11,
    dashPosition: -7,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.25,
    secondTextHeight: 18,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 6.1,
    thirdTextMarginBottom: 24,
    fontSizeMax: 15
  }));
};

var FamilyMuseumWithNumberA5L = function FamilyMuseumWithNumberA5L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA5L, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA0Plus = function FamilyMuseumA0Plus(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 1000,
    wrapperHeight: 1414,
    wrapperPadding: 450,
    urlHeight: 7.9,
    urlFontSize: 24,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 17.6,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 87,
    textBlockGap: 61.5,
    firstTextFontSize: 52,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 10,
    firstTextIndent: 23,
    dashWidth: 60,
    dashPosition: -50,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 1.45,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 30,
    thirdTextMarginBottom: 24,
    fontSizeMax: 82.5
  }));
};

var FamilyMuseumWithNumberA0Plus = function FamilyMuseumWithNumberA0Plus(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA0Plus, _extends({}, props, {
    withNumber: true
  }));
};

var components$g = {
  FamilyMuseumA0Plus: FamilyMuseumA0Plus,
  FamilyMuseumWithNumberA0Plus: FamilyMuseumWithNumberA0Plus,
  FamilyMuseumA0: FamilyMuseumA0,
  FamilyMuseumWithNumberA0: FamilyMuseumWithNumberA0,
  FamilyMuseumA0L: FamilyMuseumA0L,
  FamilyMuseumWithNumberA0L: FamilyMuseumWithNumberA0L,
  FamilyMuseumA1: FamilyMuseumA1,
  FamilyMuseumWithNumberA1: FamilyMuseumWithNumberA1,
  FamilyMuseumA1L: FamilyMuseumA1L,
  FamilyMuseumWithNumberA1L: FamilyMuseumWithNumberA1L,
  FamilyMuseumA2: FamilyMuseumA2,
  FamilyMuseumWithNumberA2: FamilyMuseumWithNumberA2,
  FamilyMuseumA2L: FamilyMuseumA2L,
  FamilyMuseumWithNumberA2L: FamilyMuseumWithNumberA2L,
  FamilyMuseumA3: FamilyMuseumA3,
  FamilyMuseumWithNumberA3: FamilyMuseumWithNumberA3,
  FamilyMuseumA3L: FamilyMuseumA3L,
  FamilyMuseumWithNumberA3L: FamilyMuseumWithNumberA3L,
  FamilyMuseumA4: FamilyMuseumA4,
  FamilyMuseumWithNumberA4: FamilyMuseumWithNumberA4,
  FamilyMuseumA4L: FamilyMuseumA4L,
  FamilyMuseumWithNumberA4L: FamilyMuseumWithNumberA4L,
  FamilyMuseumA5: FamilyMuseumA5,
  FamilyMuseumWithNumberA5: FamilyMuseumWithNumberA5,
  FamilyMuseumA5L: FamilyMuseumA5L,
  FamilyMuseumWithNumberA5L: FamilyMuseumWithNumberA5L
};
var FamilyMuseum = function FamilyMuseum(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components$g[templateType], {
    url: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.link) || 'kiiids.art',
    image: image,
    number: cardNumber,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    description: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.description) || '',
    name: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.title) || '',
    dw: dw,
    dh: dh
  });
};

function formatText(text, options) {
  if (options === void 0) {
    options = {};
  }
  if (!text) return '';
  if (Array.isArray(text)) return text.join(',');
  var _options = options,
    _options$newlineAfter = _options.newlineAfterColon,
    newlineAfterColon = _options$newlineAfter === void 0 ? false : _options$newlineAfter;
  return text.split('.').map(function (sentence) {
    return sentence.trim();
  }).filter(Boolean).map(function (sentence) {
    var parts = sentence.split(':');
    if (parts.length > 1) {
      var separator = newlineAfterColon ? ':\n' : ': ';
      return parts[0] + separator + parts.slice(1).map(function (part) {
        return part.trim().charAt(0).toUpperCase() + part.trim().slice(1);
      }).join(separator);
    }
    return sentence;
  }).map(function (sentence) {
    return sentence + '.';
  }).join('\n');
}

var _templateObject$20, _templateObject2$20, _templateObject3$1W, _templateObject4$1x, _templateObject5$1l, _templateObject6$1j, _templateObject7$1f, _templateObject8$1c, _templateObject9$19, _templateObject10$u;
var Wrapper$18 = styled.div(_templateObject$20 || (_templateObject$20 = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.pageWidth;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.pageWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.horizontalPadding;
});
var MainBlock$10 = styled.div(_templateObject2$20 || (_templateObject2$20 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$U = styled.div(_templateObject3$1W || (_templateObject3$1W = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.7px;\n    line-height: 4px;\n    margin: 5px 3px 0 0;\n  }\n"])), function (props) {
  return props.urlHeightPercent;
});
var ImageBlock$11 = styled.div(_templateObject4$1x || (_templateObject4$1x = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$12 = styled.div(_templateObject5$1l || (_templateObject5$1l = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$19 = styled.div(_templateObject6$1j || (_templateObject6$1j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  height: ", "%;\n  width: 100%;\n  padding-bottom: ", "px;\n  padding-top: ", "px;\n"])), function (props) {
  return props.textBottomHeight;
}, function (props) {
  return props.textBottomPadding;
}, function (props) {
  return props.textTopPadding;
});
var TextFirst$U = styled.div(_templateObject7$1f || (_templateObject7$1f = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  margin-bottom: ", "px;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-weight: 400;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (props) {
  return props.marginBottom;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.dashWidth;
}, function (props) {
  return props.dashOffset;
}, function (props) {
  return props.dashOffset;
});
var TextSecond$V = styled.div(_templateObject8$1c || (_templateObject8$1c = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n  margin-bottom: ", "px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: 'zMr';\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: ", "px;\n"])), function (props) {
  return props.marginBottom;
}, function (props) {
  return props.letterSpacing;
});
var TextThird$U = styled.div(_templateObject9$19 || (_templateObject9$19 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  text-align: center;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  line-height: ", "px;\n  font-weight: 400;\n  flex: 1;\n  white-space: pre-wrap;\n  color: #151514 !important;\n  padding: 0 ", "px;\n  width: 100%;\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.horizontalPadding;
});
var TextFourth$2 = styled.div(_templateObject10$u || (_templateObject10$u = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", "px;\n  color: #151514 !important;\n"])), function (props) {
  return props.fontSize;
});
var FlowerHorConstructor = function FlowerHorConstructor(_ref) {
  var _customFields$find, _customFields$find$da, _customFields$find2, _customFields$find3, _customFields$find4, _customFields$find5;
  var image = _ref.image,
    url = _ref.url,
    name = _ref.name,
    descriptionInit = _ref.description,
    museum = _ref.museum,
    dw = _ref.dw,
    dh = _ref.dh,
    customFields = _ref.customFields,
    flowerType = _ref.flowerType,
    useRegularFields = _ref.useRegularFields,
    pageWidth = _ref.pageWidth,
    pageHeight = _ref.pageHeight,
    horizontalPadding = _ref.horizontalPadding,
    urlHeightPercent = _ref.urlHeightPercent,
    textBottomHeight = _ref.textBottomHeight,
    textBottomPadding = _ref.textBottomPadding,
    textTopPadding = _ref.textTopPadding,
    dashWidth = _ref.dashWidth,
    dashOffset = _ref.dashOffset,
    titleFontSize = _ref.titleFontSize,
    titleMarginBottom = _ref.titleMarginBottom,
    titleLetterSpacing = _ref.titleLetterSpacing,
    secondFontMax = _ref.secondFontMax,
    secondMarginBottom = _ref.secondMarginBottom,
    secondLetterSpacing = _ref.secondLetterSpacing,
    thirdFontSize = _ref.thirdFontSize,
    thirdLetterSpacing = _ref.thirdLetterSpacing,
    thirdLineHeight = _ref.thirdLineHeight,
    thirdMarginBottom = _ref.thirdMarginBottom,
    thirdHorizontalPadding = _ref.thirdHorizontalPadding,
    fourthFontSize = _ref.fourthFontSize,
    newlineAfterColon = _ref.newlineAfterColon;
  var flowerDateSrc = (customFields === null || customFields === void 0 ? void 0 : (_customFields$find = customFields.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.typeField) === 'dateMonth';
  })) === null || _customFields$find === void 0 ? void 0 : (_customFields$find$da = _customFields$find.data) === null || _customFields$find$da === void 0 ? void 0 : _customFields$find$da.toLowerCase()) || '';
  var flowerDate = flowerDateSrc === 'daymonth' ? new Date().toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long'
  }) : flowerDateSrc;
  var flowerName = (customFields === null || customFields === void 0 ? void 0 : (_customFields$find2 = customFields.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.typeField) === 'flower_name';
  })) === null || _customFields$find2 === void 0 ? void 0 : _customFields$find2.data) || '';
  var flowerCharacters = (customFields === null || customFields === void 0 ? void 0 : (_customFields$find3 = customFields.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.typeField) === 'flower_characters';
  })) === null || _customFields$find3 === void 0 ? void 0 : _customFields$find3.data) || '';
  var flowerPrediction = (customFields === null || customFields === void 0 ? void 0 : (_customFields$find4 = customFields.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.typeField) === 'flower_prediction';
  })) === null || _customFields$find4 === void 0 ? void 0 : _customFields$find4.data) || '';
  var flowerCharacterFeatures = (customFields === null || customFields === void 0 ? void 0 : (_customFields$find5 = customFields.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.typeField) === 'character_features';
  })) === null || _customFields$find5 === void 0 ? void 0 : _customFields$find5.data) || '';
  var flowerData = useMemo(function () {
    if (useRegularFields || flowerType === 1) {
      return {
        title: name,
        description: descriptionInit
      };
    }
    if (flowerType === 2) {
      return {
        title: flowerName,
        description: flowerCharacters ? "\u042D\u0442\u043E \u0446\u0432\u0435\u0442\u043E\u043A \u0434\u0430\u0440\u0438\u0442 \u0435\u0433\u043E \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0443 \u0441\u0432\u043E\u0438 \u0441\u0438\u043C\u0432\u043E\u043B\u044B: " + flowerCharacters : ''
      };
    }
    if (flowerType === 3) {
      return {
        title: flowerDate && flowerName ? flowerDate + ". " + flowerName : '',
        description: flowerPrediction ? "\u042D\u0442\u043E\u0442 \u0446\u0432\u0435\u0442\u043E\u043A, \u043F\u043E\u0434\u0430\u0440\u0435\u043D\u043D\u044B\u0439 \u0441\u0435\u0433\u043E\u0434\u043D\u044F, \u043F\u0440\u0438\u043D\u0435\u0441\u0435\u0442 \u0435\u0433\u043E \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0443 " + flowerPrediction : ''
      };
    }
  }, [flowerType, flowerDate, flowerName, flowerCharacters, flowerPrediction, flowerCharacterFeatures, useRegularFields, descriptionInit, name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$18, {
    dw: dw,
    dh: dh,
    pageWidth: pageWidth,
    pageHeight: pageHeight,
    horizontalPadding: horizontalPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$10, null, /*#__PURE__*/React$1.createElement(TextUrl$U, {
    urlHeightPercent: urlHeightPercent
  }, /*#__PURE__*/React$1.createElement("span", null)), /*#__PURE__*/React$1.createElement(ImageBlock$11, null, /*#__PURE__*/React$1.createElement(ImageInner$12, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$19, {
    textTopPadding: textTopPadding,
    textBottomPadding: textBottomPadding,
    textBottomHeight: textBottomHeight
  }, /*#__PURE__*/React$1.createElement(TextFirst$U, {
    fontSize: titleFontSize,
    marginBottom: titleMarginBottom,
    dashWidth: dashWidth,
    dashOffset: dashOffset,
    letterSpacing: titleLetterSpacing
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, museum), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$V, {
    marginBottom: secondMarginBottom,
    letterSpacing: secondLetterSpacing
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: flowerData.title,
    fontSizeMax: secondFontMax
  })), /*#__PURE__*/React$1.createElement(TextThird$U, {
    fontSize: thirdFontSize,
    letterSpacing: thirdLetterSpacing,
    lineHeight: thirdLineHeight,
    marginBottom: thirdMarginBottom,
    horizontalPadding: thirdHorizontalPadding
  }, formatText(flowerData.description, {
    newlineAfterColon: newlineAfterColon
  })), /*#__PURE__*/React$1.createElement(TextFourth$2, {
    fontSize: fourthFontSize
  }, url))));
};

var FlowerHoroscopeSqCardA4 = function FlowerHoroscopeSqCardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 41,
    urlHeightPercent: 5.3,
    textBottomPadding: 39,
    textTopPadding: 54,
    textBottomHeight: 31.3,
    dashWidth: 26,
    dashOffset: -23,
    titleFontSize: 18,
    titleMarginBottom: 32,
    secondFontMax: 24,
    secondMarginBottom: 28,
    secondLetterSpacing: 0.65,
    thirdHorizontalPadding: 40,
    thirdFontSize: 13.2,
    thirdLetterSpacing: 0.3,
    thirdLineHeight: 26,
    thirdMarginBottom: 36,
    fourthFontSize: 6.4
  }));
};

var FlowerHoroscopeCardA4 = function FlowerHoroscopeCardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 95,
    urlHeightPercent: 7.7,
    textBottomPadding: 34,
    textTopPadding: 48,
    textBottomHeight: 26.6,
    dashWidth: 26,
    dashOffset: -23,
    titleFontSize: 18,
    titleMarginBottom: 30,
    secondFontMax: 24,
    secondMarginBottom: 25,
    secondLetterSpacing: 0.65,
    thirdFontSize: 11.5,
    thirdLetterSpacing: 0.2,
    thirdLineHeight: 18.2,
    thirdMarginBottom: 32,
    fourthFontSize: 6.5
  }));
};

var FlowerHoroscopeCardA1 = function FlowerHoroscopeCardA1(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 270,
    urlHeightPercent: 7.9,
    textBottomPadding: 117,
    textTopPadding: 153,
    textBottomHeight: 26.6,
    titleMarginBottom: 78,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 67,
    secondMarginBottom: 69,
    secondLetterSpacing: 0.6,
    thirdFontSize: 30,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 47,
    thirdMarginBottom: 88,
    fourthFontSize: 15.5
  }));
};

var FlowerHoroscopeSqCardA1 = function FlowerHoroscopeSqCardA1(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 120,
    urlHeightPercent: 5.3,
    textBottomPadding: 135,
    textTopPadding: 173,
    textBottomHeight: 31.3,
    titleMarginBottom: 86,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 66,
    secondMarginBottom: 69,
    secondLetterSpacing: 0.65,
    thirdHorizontalPadding: 110,
    thirdFontSize: 35.2,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 70,
    thirdMarginBottom: 96,
    fourthFontSize: 15.4
  }));
};

var FlowerHoroscopeCardA2 = function FlowerHoroscopeCardA2(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 185,
    urlHeightPercent: 7.9,
    textBottomHeight: 26.6,
    textTopPadding: 110,
    textBottomPadding: 79,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 55,
    secondFontMax: 47,
    secondMarginBottom: 45,
    secondLetterSpacing: 0.5,
    thirdFontSize: 21,
    thirdLetterSpacing: 0.6,
    thirdLineHeight: 34,
    thirdMarginBottom: 59,
    fourthFontSize: 11
  }));
};

var FlowerHoroscopeSqCardA2 = function FlowerHoroscopeSqCardA2(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 82,
    urlHeightPercent: 5.3,
    textBottomPadding: 91,
    textTopPadding: 124,
    textBottomHeight: 31.3,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 60,
    secondFontMax: 47,
    secondMarginBottom: 50,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 79,
    thirdFontSize: 26,
    thirdLineHeight: 49,
    thirdMarginBottom: 69,
    fourthFontSize: 11
  }));
};

var FlowerHoroscopeCardA3 = function FlowerHoroscopeCardA3(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 135,
    urlHeightPercent: 7.8,
    textBottomPadding: 57,
    textTopPadding: 79,
    textBottomHeight: 26.6,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 22,
    titleMarginBottom: 42,
    titleLetterSpacing: 0.9,
    secondFontMax: 31,
    secondMarginBottom: 34,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 3,
    thirdLetterSpacing: 0.45,
    thirdFontSize: 14.8,
    thirdLineHeight: 24,
    thirdMarginBottom: 42,
    fourthFontSize: 7
  }));
};

var FlowerHoroscopeSqCardA3 = function FlowerHoroscopeSqCardA3(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 61,
    urlHeightPercent: 5.3,
    textBottomPadding: 66,
    textTopPadding: 88,
    textBottomHeight: 31.3,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 22,
    titleMarginBottom: 46,
    titleLetterSpacing: 0.9,
    secondFontMax: 31,
    secondMarginBottom: 35,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 73,
    thirdLetterSpacing: 0.3,
    thirdFontSize: 17.8,
    thirdLineHeight: 35,
    thirdMarginBottom: 49,
    fourthFontSize: 7
  }));
};

var FlowerHoroscopeCardA5 = function FlowerHoroscopeCardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 67,
    urlHeightPercent: 7.8,
    textBottomPadding: 27,
    textTopPadding: 34,
    textBottomHeight: 26.8,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 21,
    titleLetterSpacing: 0.3,
    secondFontMax: 17,
    secondMarginBottom: 18,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 3,
    thirdFontSize: 8.9,
    thirdLineHeight: 12.8,
    thirdMarginBottom: 20,
    fourthFontSize: 5
  }));
};

var FlowerHoroscopeSqCardA5 = function FlowerHoroscopeSqCardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 30,
    urlHeightPercent: 5.3,
    textBottomPadding: 29,
    textTopPadding: 38,
    textBottomHeight: 31.5,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 23,
    titleLetterSpacing: 0.3,
    secondFontMax: 17,
    secondMarginBottom: 18,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 26,
    thirdFontSize: 9.8,
    thirdLineHeight: 19,
    thirdMarginBottom: 42,
    fourthFontSize: 5
  }));
};

var FlowerHoroscope2SqCardA3 = function FlowerHoroscope2SqCardA3(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 61,
    urlHeightPercent: 5.3,
    textBottomPadding: 71,
    textTopPadding: 102,
    textBottomHeight: 31.3,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 23,
    titleMarginBottom: 51,
    titleLetterSpacing: 0.6,
    secondFontMax: 31,
    secondMarginBottom: 37,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 122,
    thirdLetterSpacing: -0.1,
    thirdFontSize: 18.4,
    thirdLineHeight: 35,
    thirdMarginBottom: 49,
    fourthFontSize: 7,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope2CardA3 = function FlowerHoroscope2CardA3(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 135,
    urlHeightPercent: 7.8,
    textBottomPadding: 65,
    textTopPadding: 79,
    textBottomHeight: 26.6,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 22,
    titleMarginBottom: 43,
    titleLetterSpacing: 0.9,
    secondFontMax: 31,
    secondMarginBottom: 38,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 3,
    thirdLetterSpacing: -0.1,
    thirdFontSize: 16,
    thirdLineHeight: 24,
    thirdMarginBottom: 42,
    fourthFontSize: 7,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3CardA3 = function FlowerHoroscope3CardA3(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 135,
    urlHeightPercent: 7.8,
    textBottomPadding: 65,
    textTopPadding: 79,
    textBottomHeight: 26.6,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 22,
    titleMarginBottom: 43,
    titleLetterSpacing: 0.9,
    secondFontMax: 31,
    secondMarginBottom: 38,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 3,
    thirdLetterSpacing: -0.1,
    thirdFontSize: 16,
    thirdLineHeight: 24,
    thirdMarginBottom: 42,
    fourthFontSize: 7
  }));
};

var FlowerHoroscope3SqCardA3 = function FlowerHoroscope3SqCardA3(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 61,
    urlHeightPercent: 5.3,
    textBottomPadding: 71,
    textTopPadding: 102,
    textBottomHeight: 31.3,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 23,
    titleMarginBottom: 51,
    titleLetterSpacing: 0.6,
    secondFontMax: 31,
    secondMarginBottom: 37,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 122,
    thirdLetterSpacing: -0.1,
    thirdFontSize: 18.4,
    thirdLineHeight: 35,
    thirdMarginBottom: 49,
    fourthFontSize: 7
  }));
};

var FlowerHoroscope2SqCardA4 = function FlowerHoroscope2SqCardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 41,
    urlHeightPercent: 5.3,
    textBottomPadding: 50,
    textTopPadding: 70,
    textBottomHeight: 31.3,
    dashWidth: 25,
    dashOffset: -21,
    titleFontSize: 17,
    titleMarginBottom: 36,
    secondFontMax: 23,
    secondMarginBottom: 25,
    secondLetterSpacing: 0.65,
    thirdHorizontalPadding: 88,
    thirdFontSize: 12.4,
    thirdLetterSpacing: 0.3,
    thirdLineHeight: 26,
    thirdMarginBottom: 36,
    fourthFontSize: 6.4,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3SqCardA4 = function FlowerHoroscope3SqCardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 41,
    urlHeightPercent: 5.3,
    textBottomPadding: 50,
    textTopPadding: 70,
    textBottomHeight: 31.3,
    dashWidth: 25,
    dashOffset: -21,
    titleFontSize: 17,
    titleMarginBottom: 36,
    secondFontMax: 23,
    secondMarginBottom: 25,
    secondLetterSpacing: 0.65,
    thirdHorizontalPadding: 88,
    thirdFontSize: 12.4,
    thirdLetterSpacing: 0.3,
    thirdLineHeight: 26,
    thirdMarginBottom: 36,
    fourthFontSize: 6.4
  }));
};

var FlowerHoroscope2CardA4 = function FlowerHoroscope2CardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 95,
    urlHeightPercent: 7.9,
    textBottomPadding: 46,
    textTopPadding: 54,
    textBottomHeight: 26.6,
    dashWidth: 26,
    dashOffset: -21,
    titleFontSize: 17,
    titleMarginBottom: 29,
    secondFontMax: 23,
    secondMarginBottom: 25,
    secondLetterSpacing: 0.45,
    thirdFontSize: 11,
    thirdLineHeight: 17.2,
    thirdMarginBottom: 32,
    fourthFontSize: 5.5,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3CardA4 = function FlowerHoroscope3CardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 95,
    urlHeightPercent: 7.9,
    textBottomPadding: 46,
    textTopPadding: 54,
    textBottomHeight: 26.6,
    dashWidth: 26,
    dashOffset: -21,
    titleFontSize: 17,
    titleMarginBottom: 29,
    secondFontMax: 23,
    secondMarginBottom: 25,
    secondLetterSpacing: 0.45,
    thirdFontSize: 11,
    thirdLineHeight: 17.2,
    thirdMarginBottom: 32,
    fourthFontSize: 5.5
  }));
};

var FlowerHoroscope2CardA5 = function FlowerHoroscope2CardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 67,
    urlHeightPercent: 7.8,
    textBottomPadding: 35,
    textTopPadding: 38,
    textBottomHeight: 26.8,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 21,
    titleLetterSpacing: 0.3,
    secondFontMax: 16,
    secondMarginBottom: 19,
    secondLetterSpacing: 0.4,
    thirdHorizontalPadding: 3,
    thirdFontSize: 8.4,
    thirdLineHeight: 12,
    thirdMarginBottom: 20,
    fourthFontSize: 5,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope2SqCardA5 = function FlowerHoroscope2SqCardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 30,
    urlHeightPercent: 5.3,
    textBottomPadding: 38,
    textTopPadding: 50,
    textBottomHeight: 31.5,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 25,
    titleLetterSpacing: 0.3,
    secondFontMax: 16,
    secondMarginBottom: 18.5,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 61,
    thirdFontSize: 9.3,
    thirdLineHeight: 18,
    thirdMarginBottom: 42,
    thirdLetterSpacing: -0.1,
    fourthFontSize: 4.5,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3SqCardA5 = function FlowerHoroscope3SqCardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 30,
    urlHeightPercent: 5.3,
    textBottomPadding: 38,
    textTopPadding: 50,
    textBottomHeight: 31.5,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 25,
    titleLetterSpacing: 0.3,
    secondFontMax: 16,
    secondMarginBottom: 18.5,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 61,
    thirdFontSize: 9.3,
    thirdLineHeight: 18,
    thirdMarginBottom: 42,
    thirdLetterSpacing: -0.1,
    fourthFontSize: 4.5
  }));
};

var FlowerHoroscope3CardA5 = function FlowerHoroscope3CardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 67,
    urlHeightPercent: 7.8,
    textBottomPadding: 35,
    textTopPadding: 38,
    textBottomHeight: 26.8,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 21,
    titleLetterSpacing: 0.3,
    secondFontMax: 16,
    secondMarginBottom: 19,
    secondLetterSpacing: 0.4,
    thirdHorizontalPadding: 3,
    thirdFontSize: 8.4,
    thirdLineHeight: 12,
    thirdMarginBottom: 20,
    fourthFontSize: 5
  }));
};

var FlowerHoroscope2SqCardA2 = function FlowerHoroscope2SqCardA2(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 82,
    urlHeightPercent: 5.3,
    textBottomPadding: 100,
    textTopPadding: 144,
    textBottomHeight: 31.3,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 70,
    secondFontMax: 47,
    secondMarginBottom: 50,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 177,
    thirdFontSize: 26,
    thirdLineHeight: 49,
    thirdMarginBottom: 69,
    fourthFontSize: 11,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3SqCardA2 = function FlowerHoroscope3SqCardA2(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 82,
    urlHeightPercent: 5.3,
    textBottomPadding: 100,
    textTopPadding: 144,
    textBottomHeight: 31.3,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 70,
    secondFontMax: 47,
    secondMarginBottom: 50,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 177,
    thirdFontSize: 26,
    thirdLineHeight: 49,
    thirdMarginBottom: 69,
    fourthFontSize: 11
  }));
};

var FlowerHoroscope2CardA2 = function FlowerHoroscope2CardA2(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 185,
    urlHeightPercent: 7.9,
    textBottomHeight: 26.6,
    textTopPadding: 110,
    textBottomPadding: 90,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 55,
    secondFontMax: 47,
    secondMarginBottom: 52,
    secondLetterSpacing: 0.5,
    thirdFontSize: 21,
    thirdLetterSpacing: 0.6,
    thirdLineHeight: 34,
    thirdMarginBottom: 59,
    fourthFontSize: 11,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3CardA2 = function FlowerHoroscope3CardA2(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 185,
    urlHeightPercent: 7.9,
    textBottomHeight: 26.6,
    textTopPadding: 110,
    textBottomPadding: 90,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 55,
    secondFontMax: 47,
    secondMarginBottom: 52,
    secondLetterSpacing: 0.5,
    thirdFontSize: 21,
    thirdLetterSpacing: 0.6,
    thirdLineHeight: 34,
    thirdMarginBottom: 59,
    fourthFontSize: 11
  }));
};

var FlowerHoroscope2SqCardA1 = function FlowerHoroscope2SqCardA1(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 120,
    urlHeightPercent: 5.3,
    textBottomPadding: 144,
    textTopPadding: 199,
    textBottomHeight: 31.3,
    titleMarginBottom: 102,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 66,
    secondMarginBottom: 74,
    secondLetterSpacing: 0.65,
    thirdHorizontalPadding: 245,
    thirdFontSize: 35.2,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 70,
    thirdMarginBottom: 96,
    fourthFontSize: 15.4,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3SqCardA1 = function FlowerHoroscope3SqCardA1(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 120,
    urlHeightPercent: 5.3,
    textBottomPadding: 144,
    textTopPadding: 199,
    textBottomHeight: 31.3,
    titleMarginBottom: 102,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 66,
    secondMarginBottom: 74,
    secondLetterSpacing: 0.65,
    thirdHorizontalPadding: 245,
    thirdFontSize: 35.2,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 70,
    thirdMarginBottom: 96,
    fourthFontSize: 15.4
  }));
};

var FlowerHoroscope2CardA1 = function FlowerHoroscope2CardA1(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 270,
    urlHeightPercent: 7.9,
    textBottomPadding: 133,
    textTopPadding: 153,
    textBottomHeight: 26.6,
    titleMarginBottom: 80,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 67,
    secondMarginBottom: 74,
    secondLetterSpacing: 0.6,
    thirdFontSize: 30,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 47,
    thirdMarginBottom: 88,
    fourthFontSize: 15.5,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3CardA1 = function FlowerHoroscope3CardA1(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 270,
    urlHeightPercent: 7.9,
    textBottomPadding: 133,
    textTopPadding: 153,
    textBottomHeight: 26.6,
    titleMarginBottom: 80,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 67,
    secondMarginBottom: 74,
    secondLetterSpacing: 0.6,
    thirdFontSize: 30,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 47,
    thirdMarginBottom: 88,
    fourthFontSize: 15.5
  }));
};

var components$h = {
  FlowerHoroscopeCardA1: FlowerHoroscopeCardA1,
  FlowerHoroscopeSqCardA1: FlowerHoroscopeSqCardA1,
  FlowerHoroscopeCardA2: FlowerHoroscopeCardA2,
  FlowerHoroscopeSqCardA2: FlowerHoroscopeSqCardA2,
  FlowerHoroscopeCardA3: FlowerHoroscopeCardA3,
  FlowerHoroscopeSqCardA3: FlowerHoroscopeSqCardA3,
  FlowerHoroscopeCardA4: FlowerHoroscopeCardA4,
  FlowerHoroscopeSqCardA4: FlowerHoroscopeSqCardA4,
  FlowerHoroscopeCardA5: FlowerHoroscopeCardA5,
  FlowerHoroscopeSqCardA5: FlowerHoroscopeSqCardA5,
  FlowerHoroscope2CardA1: FlowerHoroscope2CardA1,
  FlowerHoroscope2SqCardA1: FlowerHoroscope2SqCardA1,
  FlowerHoroscope2CardA2: FlowerHoroscope2CardA2,
  FlowerHoroscope2SqCardA2: FlowerHoroscope2SqCardA2,
  FlowerHoroscope2CardA3: FlowerHoroscope2CardA3,
  FlowerHoroscope2SqCardA3: FlowerHoroscope2SqCardA3,
  FlowerHoroscope2CardA4: FlowerHoroscope2CardA4,
  FlowerHoroscope2SqCardA4: FlowerHoroscope2SqCardA4,
  FlowerHoroscope2CardA5: FlowerHoroscope2CardA5,
  FlowerHoroscope2SqCardA5: FlowerHoroscope2SqCardA5,
  FlowerHoroscope3CardA1: FlowerHoroscope3CardA1,
  FlowerHoroscope3SqCardA1: FlowerHoroscope3SqCardA1,
  FlowerHoroscope3CardA2: FlowerHoroscope3CardA2,
  FlowerHoroscope3SqCardA2: FlowerHoroscope3SqCardA2,
  FlowerHoroscope3CardA3: FlowerHoroscope3CardA3,
  FlowerHoroscope3SqCardA3: FlowerHoroscope3SqCardA3,
  FlowerHoroscope3CardA4: FlowerHoroscope3CardA4,
  FlowerHoroscope3SqCardA4: FlowerHoroscope3SqCardA4,
  FlowerHoroscope3CardA5: FlowerHoroscope3CardA5,
  FlowerHoroscope3SqCardA5: FlowerHoroscope3SqCardA5
};
var FlowerHoroscopeCard = function FlowerHoroscopeCard(props) {
  var _ref;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    useRegularFieldsProp = props.useRegularFields,
    dw = props.dw,
    dh = props.dh;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = data.templateData || {};
  var useRegularFieldsResolved = (_ref = useRegularFieldsProp != null ? useRegularFieldsProp : data && data.useRegularFields) != null ? _ref : false;
  return React$1.createElement(components$h[templateType], {
    url: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.link) || 'artz.work',
    image: image,
    number: cardNumber,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    description: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.description) || '',
    museum: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    name: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.title) || '',
    customFields: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.customFields) || [],
    useRegularFields: useRegularFieldsResolved,
    dw: dw,
    dh: dh
  });
};

var _templateObject$21, _templateObject2$21, _templateObject3$1X, _templateObject4$1y, _templateObject5$1m, _templateObject6$1k, _templateObject7$1g, _templateObject8$1d, _templateObject9$1a, _templateObject10$v, _templateObject11$s;
var Wrapper$19 = styled.div(_templateObject$21 || (_templateObject$21 = _taggedTemplateLiteralLoose(["\n  width: 148mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 148),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 57px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    color: #151514;\n    font-family: 'Roboto';\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$11 = styled.div(_templateObject2$21 || (_templateObject2$21 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$V = styled.div(_templateObject3$1X || (_templateObject3$1X = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n  }\n"])));
var SizeBlock = styled.div(_templateObject4$1y || (_templateObject4$1y = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  width: 100%;\n  height: 34.8%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  overflow: hidden;\n  font-size: 207px;\n  letter-spacing: 2px;\n  font-weight: 700;\n  line-height: 200px;\n\n  & > span {\n    font-size: 158px;\n    letter-spacing: 5px;\n  }\n"])));
var MainTextBlock$1 = styled.div(_templateObject5$1m || (_templateObject5$1m = _taggedTemplateLiteralLoose(["\n  height: 48%;\n  width: 100%;\n"])));
var RowWrapper = styled.div(_templateObject6$1k || (_templateObject6$1k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  border-top: 1px solid black;\n  border-bottom: 1px solid black;\n  font-family: 'Roboto';\n  width: 100%;\n  max-width: 450px;\n"])));
var Row$2 = styled.div(_templateObject7$1g || (_templateObject7$1g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  border-top: 1px solid black;\n  height: 54px;\n  align-items: center;\n  justify-content: space-between;\n\n  &:last-child {\n    border-bottom: none;\n  }\n"])));
var TitleCell = styled.div(_templateObject8$1d || (_templateObject8$1d = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n  font-size: 35px;\n  letter-spacing: 3.3px;\n  text-transform: uppercase;\n  flex-shrink: 0;\n  margin-right: 10px;\n  min-width: 120px;\n  max-width: ", ";\n  background: transparent !important;\n"])), function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth ? '100%' : '252px';
});
var EmptyCell = styled(TitleCell)(_templateObject9$1a || (_templateObject9$1a = _taggedTemplateLiteralLoose(["\n  visibility: hidden;\n"])));
var ValueCell = styled.div(_templateObject10$v || (_templateObject10$v = _taggedTemplateLiteralLoose(["\n  font-size: 21.5px;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 2px;\n  white-space: nowrap;\n  text-align: right;\n  background: transparent !important;\n"])));
var SubtitleBlock = styled.div(_templateObject11$s || (_templateObject11$s = _taggedTemplateLiteralLoose(["\n  max-width: calc(100% - 66px - 32px);\n  margin-top: 7px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n\n  div.text {\n    display: flex;\n    width: 100%;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    text-transform: uppercase;\n    letter-spacing: 3.6px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 33px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (_ref2) {
  var isShortDash = _ref2.isShortDash;
  return isShortDash ? 14 : -16;
}, function (_ref3) {
  var isShortDash = _ref3.isShortDash;
  return isShortDash ? 14 : -16;
});
var ServiceCardA5 = function ServiceCardA5(_ref4) {
  var customFields = _ref4.customFields,
    url = _ref4.url,
    name = _ref4.name,
    dw = _ref4.dw,
    dh = _ref4.dh,
    subTitle = _ref4.subTitle;
  var wrapperRef = useRef(null);
  var _useState = useState(0),
    maxValueWidth = _useState[0],
    setMaxValueWidth = _useState[1];
  var _useState2 = useState(19),
    subTitleFontSize = _useState2[0],
    setSubTitleFontSize = _useState2[1];
  var isTwoPlus = name === null || name === void 0 ? void 0 : name.includes('++');
  var twoPlus = '++';
  var correctName = isTwoPlus ? name === null || name === void 0 ? void 0 : name.replace('++', '') : name;
  useEffect(function () {
    if (!wrapperRef.current) return;
    var resize = function resize() {
      var _wrapperRef$current;
      var fullWidth = ((_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.clientWidth) || 0;
      setMaxValueWidth(fullWidth - 120 - 130);
    };
    resize();
    var observer = new ResizeObserver(resize);
    observer.observe(wrapperRef.current);
    return function () {
      return observer.disconnect();
    };
  }, []);
  var splitWordsIntoLines = useCallback(function (wordsString) {
    var words = wordsString.split(' ');
    if (maxValueWidth === 0) return [words.join(', ')];
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    if (!ctx) return [words.join(', ')];
    ctx.font = '600 21.5px Roboto';
    var lines = [];
    var currentLine = '';
    for (var i = 0; i < words.length; i++) {
      var value = words[i];
      var wordsInValue = value.split(' ');
      for (var j = 0; j < wordsInValue.length; j++) {
        var word = wordsInValue[j];
        var testWordToAdd = word;
        var prefix = ' ';
        if (lines.length === 0 && currentLine === '' && i === 0 && j === 0) {
          prefix = '';
        }
        var testLine = currentLine + prefix + testWordToAdd;
        var testWidth = ctx.measureText(testLine).width;
        if (testWidth > maxValueWidth && currentLine !== '') {
          lines.push(currentLine);
          currentLine = word;
        } else if (testWidth > maxValueWidth && currentLine === '') {
          lines.push(word);
          currentLine = '';
        } else {
          if (currentLine !== '' || currentLine === '' && j > 0) {
            currentLine += prefix;
          }
          currentLine += testWordToAdd;
        }
      }
    }
    if (currentLine) {
      lines.push(currentLine);
    }
    return lines.map(function (line) {
      return line.trim().replace(/^,/, '').trim();
    });
  }, [maxValueWidth]);
  return /*#__PURE__*/React$1.createElement(Wrapper$19, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$11, null, /*#__PURE__*/React$1.createElement(TextUrl$V, null, /*#__PURE__*/React$1.createElement("span", null, url)), /*#__PURE__*/React$1.createElement(SizeBlock, null, isTwoPlus ? correctName : name, isTwoPlus && /*#__PURE__*/React$1.createElement("span", null, twoPlus)), /*#__PURE__*/React$1.createElement(MainTextBlock$1, null, /*#__PURE__*/React$1.createElement(RowWrapper, {
    ref: wrapperRef
  }, customFields.map(function (item, index) {
    var typeField = item.typeField,
      name = item.name,
      data = item.data;
    var lines = data.length > 0 ? splitWordsIntoLines(data) : [];
    return lines.map(function (line, i) {
      return typeField === 'delivery_type' ? /*#__PURE__*/React$1.createElement(Row$2, {
        key: index + "-" + i
      }, /*#__PURE__*/React$1.createElement(TitleCell, {
        fullWidth: true
      }, line)) : /*#__PURE__*/React$1.createElement(Row$2, {
        key: index + "-" + i
      }, i === 0 ? /*#__PURE__*/React$1.createElement(TitleCell, null, name) : /*#__PURE__*/React$1.createElement(EmptyCell, null), /*#__PURE__*/React$1.createElement(ValueCell, null, line));
    });
  }))), /*#__PURE__*/React$1.createElement(SubtitleBlock, {
    isShortDash: subTitleFontSize === 12 && (subTitle === null || subTitle === void 0 ? void 0 : subTitle.length) >= 30
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "text"
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    style: {
      textWrap: subTitleFontSize === 12 ? 'wrap' : 'nowrap'
    },
    text: subTitle,
    fontSizeMax: subTitleFontSize === 12 ? 12 : 19,
    fontSizeMin: 12,
    setWidthsAndFontSize: function setWidthsAndFontSize(data) {
      return setSubTitleFontSize(data === null || data === void 0 ? void 0 : data.newFontSize);
    }
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  }))));
};

var components$i = {
  ServiceCardA5: ServiceCardA5
};
var ServiceCard = function ServiceCard(props) {
  var _templateDataComputed;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components$i[templateType], {
    url: templateDataComputed && templateDataComputed.link || 'gallllery.com',
    image: image,
    customFields: templateDataComputed && templateDataComputed.customFields || '',
    name: templateDataComputed && templateDataComputed.title && templateDataComputed.title.toString() || '',
    dw: dw,
    dh: dh,
    subTitle: templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed = templateDataComputed.subTitle) === null || _templateDataComputed === void 0 ? void 0 : _templateDataComputed.toString()
  });
};

var components$j = {
  ServiceCardA5: ServiceCardA5
};
var ServiceCardPrint = function ServiceCardPrint(props) {
  var _data$subTitle;
  var data = props.data,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$j[templateType], {
    url: data && data.link || 'gallllery.com',
    description: data && data.description || '',
    name: data && data.title && data.title.toString() || '',
    dw: dw,
    dh: dh,
    subTitle: data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : _data$subTitle.toString()
  });
};

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var useFullPageLoad = function useFullPageLoad() {
  var _useState = useState(false),
    isFullyLoaded = _useState[0],
    setIsFullyLoaded = _useState[1];
  var _useState2 = useState(false),
    imagesLoaded = _useState2[0],
    setImagesLoaded = _useState2[1];
  var _useState3 = useState(false),
    fontsLoaded = _useState3[0],
    setFontsLoaded = _useState3[1];
  var checkImages = useCallback(function () {
    setTimeout(function () {
      var images = document.querySelectorAll('img');
      if (images.length === 0) {
        setImagesLoaded(true);
        return;
      }
      var loadedCount = 0;
      var totalImages = images.length;
      var handleImageLoad = function handleImageLoad() {
        loadedCount++;
        if (loadedCount === totalImages) {
          setImagesLoaded(true);
        }
      };
      images.forEach(function (img) {
        if (img.complete && img.naturalHeight !== 0) {
          handleImageLoad();
        } else {
          img.addEventListener('load', handleImageLoad);
          img.addEventListener('error', handleImageLoad);
        }
      });
    }, 100);
  }, []);
  useEffect(function () {
    checkImages();
  }, [checkImages]);
  useEffect(function () {
    var checkFonts = function checkFonts() {
      try {
        var _temp2 = function () {
          if ('fonts' in document) {
            var _temp = _catch(function () {
              return Promise.resolve(document.fonts.ready).then(function () {
                setFontsLoaded(true);
              });
            }, function (error) {
              console.warn('Ошибка при загрузке шрифтов:', error);
              setFontsLoaded(true);
            });
            if (_temp && _temp.then) return _temp.then(function () {});
          } else {
            setTimeout(function () {
              return setFontsLoaded(true);
            }, 1000);
          }
        }();
        return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    checkFonts();
  }, []);
  useEffect(function () {
    if (imagesLoaded && fontsLoaded && !isFullyLoaded) {
      setIsFullyLoaded(true);
    }
  }, [imagesLoaded, fontsLoaded, isFullyLoaded]);
  return {
    isFullyLoaded: isFullyLoaded,
    loadingStatus: {
      imagesLoaded: imagesLoaded,
      fontsLoaded: fontsLoaded
    }
  };
};

var _templateObject$22, _templateObject2$22;
var ErrorWrapper = styled.div(_templateObject$22 || (_templateObject$22 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n"])));
var ErrorText = styled.div(_templateObject2$22 || (_templateObject2$22 = _taggedTemplateLiteralLoose(["\n  color: #b6b6b5;\n  text-align: center;\n  font-family: Inter;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n"])));
var ErrorComponent = function ErrorComponent() {
  return /*#__PURE__*/React$1.createElement(ErrorWrapper, null, /*#__PURE__*/React$1.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M12.056 2.1001C13.1228 2.10434 14.0777 2.66198 14.6078 3.59424L22.5033 17.4536C23.0356 18.3872 23.0318 19.4978 22.4926 20.4263C21.9563 21.3496 21.0045 21.8998 19.9418 21.8999H19.932L4.04823 21.8472C2.98227 21.8441 2.02769 21.2874 1.49647 20.3569C0.964287 19.4244 0.968122 18.3146 1.50624 17.3862L9.49256 3.57764C10.0278 2.65218 10.9814 2.10012 12.0443 2.1001H12.056ZM12.0443 3.15088C11.3578 3.1509 10.7415 3.50793 10.3949 4.104L2.40858 17.9126C2.06191 18.5131 2.0603 19.2318 2.4037 19.8345C2.74712 20.4348 3.36277 20.7951 4.05116 20.7974L19.9359 20.8491H19.9418C20.6281 20.849 21.2436 20.4932 21.5892 19.897C21.937 19.2975 21.9404 18.5788 21.5971 17.9761L13.7015 4.11572C13.3581 3.5141 12.7398 3.15308 12.0512 3.15088H12.0443ZM11.9994 16.3208C12.402 16.3208 12.7296 16.6496 12.7299 17.0562C12.7299 17.4618 12.4023 17.7905 11.9994 17.7905C11.5977 17.7903 11.2699 17.4616 11.2699 17.0562C11.2702 16.6498 11.5979 16.321 11.9994 16.3208ZM11.9994 8.71436C12.2873 8.71436 12.5219 8.94984 12.5219 9.23975V14.187C12.5218 14.4778 12.2873 14.7124 11.9994 14.7124C11.7118 14.7122 11.4779 14.4779 11.4779 14.187V9.23975C11.4779 8.94974 11.7119 8.71455 11.9994 8.71436Z",
    fill: "#B6B6B5"
  })), /*#__PURE__*/React$1.createElement(ErrorText, null, "\u043E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F"));
};

function formatText$1(text, options) {
  if (options === void 0) {
    options = {};
  }
  if (!text) return '';
  if (Array.isArray(text)) return text.join(',');
  var _options = options,
    _options$newlineAfter = _options.newlineAfterColon,
    newlineAfterColon = _options$newlineAfter === void 0 ? false : _options$newlineAfter;
  return text.split('.').map(function (sentence) {
    return sentence.trim();
  }).filter(Boolean).map(function (sentence) {
    var parts = sentence.split(':');
    if (parts.length > 1) {
      var separator = newlineAfterColon ? ':\n' : ': ';
      return parts[0] + separator + parts.slice(1).map(function (part) {
        return part.trim().charAt(0).toUpperCase() + part.trim().slice(1);
      }).join(separator);
    }
    return sentence;
  }).map(function (sentence) {
    return sentence + '.';
  }).join('\n');
}

var _templateObject$23, _templateObject2$23, _templateObject3$1Y, _templateObject4$1z, _templateObject5$1n, _templateObject6$1l, _templateObject7$1h, _templateObject8$1e, _templateObject9$1b, _templateObject10$w;
var Wrapper$1a = styled.div(_templateObject$23 || (_templateObject$23 = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.pageWidth;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.pageWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.horizontalPadding;
});
var MainBlock$12 = styled.div(_templateObject2$23 || (_templateObject2$23 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$W = styled.div(_templateObject3$1Y || (_templateObject3$1Y = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.7px;\n    line-height: 4px;\n    margin: 5px 3px 0 0;\n  }\n"])), function (props) {
  return props.urlHeightPercent;
});
var ImageBlock$12 = styled.div(_templateObject4$1z || (_templateObject4$1z = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$13 = styled.div(_templateObject5$1n || (_templateObject5$1n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$1a = styled.div(_templateObject6$1l || (_templateObject6$1l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  height: ", "%;\n  width: 100%;\n  padding-bottom: ", "px;\n  padding-top: ", "px;\n"])), function (props) {
  return props.textBottomHeight;
}, function (props) {
  return props.textBottomPadding;
}, function (props) {
  return props.textTopPadding;
});
var TextFirst$V = styled.div(_templateObject7$1h || (_templateObject7$1h = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  margin-bottom: ", "px;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-weight: 400;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (props) {
  return props.marginBottom;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.dashWidth;
}, function (props) {
  return props.dashOffset;
}, function (props) {
  return props.dashOffset;
});
var TextSecond$W = styled.div(_templateObject8$1e || (_templateObject8$1e = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n  margin-bottom: ", "px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: 'zMr';\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: ", "px;\n"])), function (props) {
  return props.marginBottom;
}, function (props) {
  return props.letterSpacing;
});
var TextThird$V = styled.div(_templateObject9$1b || (_templateObject9$1b = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  text-align: center;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  line-height: ", "px;\n  font-weight: 400;\n  flex: 1;\n  white-space: pre-wrap;\n  color: #151514 !important;\n  padding: 0 ", "px;\n  width: 100%;\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.horizontalPadding;
});
var TextFourth$3 = styled.div(_templateObject10$w || (_templateObject10$w = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", "px;\n  color: #151514 !important;\n"])), function (props) {
  return props.fontSize;
});
var LuvricZodiacConstructor = function LuvricZodiacConstructor(_ref) {
  var image = _ref.image,
    url = _ref.url,
    title = _ref.title,
    description = _ref.description,
    museum = _ref.museum,
    dw = _ref.dw,
    dh = _ref.dh,
    pageWidth = _ref.pageWidth,
    pageHeight = _ref.pageHeight,
    horizontalPadding = _ref.horizontalPadding,
    urlHeightPercent = _ref.urlHeightPercent,
    textBottomHeight = _ref.textBottomHeight,
    textBottomPadding = _ref.textBottomPadding,
    textTopPadding = _ref.textTopPadding,
    dashWidth = _ref.dashWidth,
    dashOffset = _ref.dashOffset,
    titleFontSize = _ref.titleFontSize,
    titleMarginBottom = _ref.titleMarginBottom,
    titleLetterSpacing = _ref.titleLetterSpacing,
    secondFontMax = _ref.secondFontMax,
    secondMarginBottom = _ref.secondMarginBottom,
    secondLetterSpacing = _ref.secondLetterSpacing,
    thirdFontSize = _ref.thirdFontSize,
    thirdLetterSpacing = _ref.thirdLetterSpacing,
    thirdLineHeight = _ref.thirdLineHeight,
    thirdMarginBottom = _ref.thirdMarginBottom,
    thirdHorizontalPadding = _ref.thirdHorizontalPadding,
    fourthFontSize = _ref.fourthFontSize,
    newlineAfterColon = _ref.newlineAfterColon;
  return /*#__PURE__*/React$1.createElement(Wrapper$1a, {
    dw: dw,
    dh: dh,
    pageWidth: pageWidth,
    pageHeight: pageHeight,
    horizontalPadding: horizontalPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$12, null, /*#__PURE__*/React$1.createElement(TextUrl$W, {
    urlHeightPercent: urlHeightPercent
  }, /*#__PURE__*/React$1.createElement("span", null)), /*#__PURE__*/React$1.createElement(ImageBlock$12, null, /*#__PURE__*/React$1.createElement(ImageInner$13, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$1a, {
    textTopPadding: textTopPadding,
    textBottomPadding: textBottomPadding,
    textBottomHeight: textBottomHeight
  }, /*#__PURE__*/React$1.createElement(TextFirst$V, {
    fontSize: titleFontSize,
    marginBottom: titleMarginBottom,
    dashWidth: dashWidth,
    dashOffset: dashOffset,
    letterSpacing: titleLetterSpacing
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, museum), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$W, {
    marginBottom: secondMarginBottom,
    letterSpacing: secondLetterSpacing
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: title,
    fontSizeMax: secondFontMax
  })), /*#__PURE__*/React$1.createElement(TextThird$V, {
    fontSize: thirdFontSize,
    letterSpacing: thirdLetterSpacing,
    lineHeight: thirdLineHeight,
    marginBottom: thirdMarginBottom,
    horizontalPadding: thirdHorizontalPadding
  }, formatText$1(description, {
    newlineAfterColon: newlineAfterColon
  })), /*#__PURE__*/React$1.createElement(TextFourth$3, {
    fontSize: fourthFontSize
  }, url))));
};

var LuvricZodiacA1 = function LuvricZodiacA1(props) {
  return /*#__PURE__*/React$1.createElement(LuvricZodiacConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 270,
    urlHeightPercent: 7.9,
    textBottomPadding: 117,
    textTopPadding: 153,
    textBottomHeight: 26.6,
    titleMarginBottom: 78,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 67,
    secondMarginBottom: 69,
    secondLetterSpacing: 0.6,
    thirdFontSize: 30,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 47,
    thirdMarginBottom: 88,
    fourthFontSize: 15.5
  }));
};

var LuvricZodiacA2 = function LuvricZodiacA2(props) {
  return /*#__PURE__*/React$1.createElement(LuvricZodiacConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 185,
    urlHeightPercent: 7.9,
    textBottomHeight: 26.6,
    textTopPadding: 110,
    textBottomPadding: 79,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 55,
    secondFontMax: 47,
    secondMarginBottom: 45,
    secondLetterSpacing: 0.5,
    thirdFontSize: 21,
    thirdLetterSpacing: 0.6,
    thirdLineHeight: 34,
    thirdMarginBottom: 59,
    fourthFontSize: 11
  }));
};

var LuvricZodiacA3 = function LuvricZodiacA3(props) {
  return /*#__PURE__*/React$1.createElement(LuvricZodiacConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 135,
    urlHeightPercent: 7.8,
    textBottomPadding: 57,
    textTopPadding: 79,
    textBottomHeight: 26.6,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 22,
    titleMarginBottom: 42,
    titleLetterSpacing: 0.9,
    secondFontMax: 31,
    secondMarginBottom: 34,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 3,
    thirdLetterSpacing: 0.45,
    thirdFontSize: 14.8,
    thirdLineHeight: 24,
    thirdMarginBottom: 42,
    fourthFontSize: 7
  }));
};

var LuvricZodiacA4 = function LuvricZodiacA4(props) {
  return /*#__PURE__*/React$1.createElement(LuvricZodiacConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 95,
    urlHeightPercent: 7.7,
    textBottomPadding: 34,
    textTopPadding: 48,
    textBottomHeight: 26.6,
    dashWidth: 26,
    dashOffset: -23,
    titleFontSize: 18,
    titleMarginBottom: 30,
    secondFontMax: 24,
    secondMarginBottom: 25,
    secondLetterSpacing: 0.65,
    thirdFontSize: 11.5,
    thirdLetterSpacing: 0.2,
    thirdLineHeight: 18.2,
    thirdMarginBottom: 32,
    fourthFontSize: 6.5
  }));
};

var LuvricZodiacA5 = function LuvricZodiacA5(props) {
  return /*#__PURE__*/React$1.createElement(LuvricZodiacConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 67,
    urlHeightPercent: 7.8,
    textBottomPadding: 27,
    textTopPadding: 34,
    textBottomHeight: 26.8,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 21,
    titleLetterSpacing: 0.3,
    secondFontMax: 17,
    secondMarginBottom: 18,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 3,
    thirdFontSize: 8.9,
    thirdLineHeight: 12.8,
    thirdMarginBottom: 20,
    fourthFontSize: 5
  }));
};

var components$k = {
  LuvricZodiacA1: LuvricZodiacA1,
  LuvricZodiacA2: LuvricZodiacA2,
  LuvricZodiacA3: LuvricZodiacA3,
  LuvricZodiacA4: LuvricZodiacA4,
  LuvricZodiacA5: LuvricZodiacA5
};
var LuvricZodiac = function LuvricZodiac(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components$k[templateType], {
    url: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.link) || 'artz.work',
    image: image,
    number: cardNumber,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    description: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.description) || '',
    museum: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    title: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.title) || '',
    dw: dw,
    dh: dh
  });
};

var components$l = {
  LuvricZodiacA1: LuvricZodiacA1,
  LuvricZodiacA2: LuvricZodiacA2,
  LuvricZodiacA3: LuvricZodiacA3,
  LuvricZodiacA4: LuvricZodiacA4,
  LuvricZodiacA5: LuvricZodiacA5
};
var LuvricZodiacPrint = function LuvricZodiacPrint(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$l[templateType], {
    url: (data === null || data === void 0 ? void 0 : data.link) || 'artz.work',
    image: image,
    number: (data === null || data === void 0 ? void 0 : data.number) || '',
    customSubtitle: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    description: (data === null || data === void 0 ? void 0 : data.description) || '',
    museum: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    title: (data === null || data === void 0 ? void 0 : data.title) || '',
    dw: dw,
    dh: dh
  });
};

var components$m = {
  WarholStyleCard: WarholStyleCard,
  WarholStyle2Card: WarholStyle2Card,
  WarholStyle3Card: WarholStyle3Card,
  WarholStyle4Card: WarholStyle4Card,
  ClassicStyle3Card: ClassicStyle3Card,
  VotingCoverCard: VotingCoverCard,
  LuvrikStyleCard: LuvrikStyleCard,
  ProductCard: ProductCard,
  TimelineStyleCard: TimelineStyleCard,
  Calendar: Calendar,
  AccountCard: AccountCard,
  ShipsStyleCard: ShipsStyleCard,
  FlowersStyleCard: FlowersStyleCard,
  CalendarModern: CalendarModern,
  CalendarPreview: CalendarPreview,
  CalendarFreePreview: CalendarFreePreview,
  WarholStyle2WithQrCard: WarholStyle2WithQrCard,
  PosterCard: PosterCard,
  FamilyMuseum: FamilyMuseum,
  FlowerHoroscopeCard: FlowerHoroscopeCard,
  ServiceCard: ServiceCard,
  LuvricZodiac: LuvricZodiac
};
var MasterCard = function MasterCard(props) {
  var sanitizedProps = _deepRemoveEmojis(props);
  var _sanitizedProps$templ = sanitizedProps.templateType,
    templateType = _sanitizedProps$templ === void 0 ? '' : _sanitizedProps$templ;
  var _useFullPageLoad = useFullPageLoad(),
    isFullyLoaded = _useFullPageLoad.isFullyLoaded;
  var localTemplateName = templateType.replace('warhol1', 'warhol').replace('warhol', 'WarholCard');
  var templateComponent = components$m.WarholStyleCard;
  if (localTemplateName.startsWith('WarholCardA')) {
    templateComponent = components$m.WarholStyleCard;
  }
  if (localTemplateName.startsWith('WarholA')) {
    templateComponent = components$m.WarholStyleCard;
  }
  if (localTemplateName.startsWith('WarholCard2A')) {
    templateComponent = components$m.WarholStyle2Card;
  }
  if (localTemplateName.startsWith('WarholCard3A')) {
    templateComponent = components$m.WarholStyle3Card;
  }
  if (localTemplateName.startsWith('WarholCard4A')) {
    templateComponent = components$m.WarholStyle4Card;
  }
  if (localTemplateName.startsWith('ClassicCard3A')) {
    templateComponent = components$m.ClassicStyle3Card;
  }
  if (localTemplateName.startsWith('LuvrikCardA')) {
    templateComponent = components$m.LuvrikStyleCard;
  }
  if (localTemplateName.startsWith('ClassicA')) {
    templateComponent = components$m.LuvrikStyleCard;
  }
  if (localTemplateName.startsWith('ClassicCardA')) {
    templateComponent = components$m.LuvrikStyleCard;
  }
  if (localTemplateName.startsWith('ProductCard')) {
    templateComponent = components$m.ProductCard;
  }
  if (localTemplateName.startsWith('TimelineCard')) {
    templateComponent = components$m.TimelineStyleCard;
  }
  if (localTemplateName.startsWith('Calendar')) {
    templateComponent = components$m.Calendar;
  }
  if (localTemplateName.startsWith('CalendarModern')) {
    templateComponent = components$m.CalendarModern;
  }
  if (localTemplateName.startsWith('CalendarPreview')) {
    templateComponent = components$m.CalendarPreview;
  }
  if (localTemplateName.startsWith('CalendarFreePreview')) {
    templateComponent = components$m.CalendarFreePreview;
  }
  if (localTemplateName.startsWith('VotingCoverCard')) {
    templateComponent = components$m.VotingCoverCard;
  }
  if (localTemplateName.startsWith('AccountCard')) {
    templateComponent = components$m.AccountCard;
  }
  if (localTemplateName.startsWith('ShipsCard')) {
    templateComponent = components$m.ShipsStyleCard;
  }
  if (localTemplateName.startsWith('FlowersCard')) {
    templateComponent = components$m.FlowersStyleCard;
  }
  if (localTemplateName.startsWith('WarholCard2WithQr')) {
    templateComponent = components$m.WarholStyle2WithQrCard;
  }
  if (localTemplateName.startsWith('PosterCard')) {
    templateComponent = components$m.PosterCard;
  }
  if (localTemplateName.startsWith('FamilyMuseum')) {
    templateComponent = components$m.FamilyMuseum;
  }
  if (localTemplateName.startsWith('FlowerHoroscope')) {
    templateComponent = components$m.FlowerHoroscopeCard;
  }
  if (localTemplateName.startsWith('ServiceCard')) {
    templateComponent = components$m.ServiceCard;
  }
  if (localTemplateName.startsWith('LuvricZodiac')) {
    templateComponent = components$m.LuvricZodiac;
  }
  return /*#__PURE__*/React$1.createElement(ErrorBoundary, {
    fallback: /*#__PURE__*/React$1.createElement(ErrorComponent, null)
  }, React$1.createElement(templateComponent, _extends({}, sanitizedProps, {
    style: _extends({
      backgroundColor: '#ffffff'
    }, sanitizedProps === null || sanitizedProps === void 0 ? void 0 : sanitizedProps.style),
    templateType: localTemplateName
  })), isFullyLoaded && /*#__PURE__*/React$1.createElement("div", {
    id: "IsFullyLoaded",
    style: {
      width: 0,
      height: 0
    }
  }));
};

var components$n = {
  WarholCardA5L: WarholCardA5L,
  WarholCardA5: WarholCardA5,
  WarholCardA4L: WarholCardA4L,
  WarholCardA4: WarholCardA4,
  WarholCardA3L: WarholCardA3L,
  WarholCardA3: WarholCardA3,
  WarholCardA2L: WarholCardA2L,
  WarholCardA2: WarholCardA2,
  WarholCardA1L: WarholCardA1L,
  WarholCardA1: WarholCardA1,
  WarholCardA0L: WarholCardA0L,
  WarholCardA0: WarholCardA0
};
var WarholStyleCardPrint = function WarholStyleCardPrint(props) {
  var _data$subTitle, _data$description;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  return React$1.createElement(components$n[templateType], {
    url: data && data.link || 'gallllery.com',
    image: image,
    number: data && data.number,
    museum: data && data.description || '',
    name: data && data.title && data.title.toString() || '',
    dw: dw,
    dh: dh,
    customSubtitle: (data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : _data$subTitle.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : _data$description.toString())
  });
};

var components$o = {
  WarholCard2A5L: WarholCard2A5L,
  WarholCard2A5: WarholCard2A5,
  WarholCard2A4L: WarholCard2A4L,
  WarholCard2A4: WarholCard2A4,
  WarholCard2A4Product: WarholCard2A4Product,
  WarholCard2A3L: WarholCard2A3L,
  WarholCard2A3: WarholCard2A3,
  WarholCard2A2L: WarholCard2A2L,
  WarholCard2A2: WarholCard2A2,
  WarholCard2A1L: WarholCard2A1L,
  WarholCard2A1: WarholCard2A1,
  WarholCard2A0L: WarholCard2A0L,
  WarholCard2A0: WarholCard2A0,
  WarholCard2A0Plus: WarholCard2A0Plus
};
var WarholStyle2CardPrint = function WarholStyle2CardPrint(props) {
  var _data$subTitle, _data$description;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  return React$1.createElement(components$o[templateType], {
    url: data && data.link || 'gallllery.com',
    image: image,
    number: data && data.number,
    museum: data && data.description || '',
    name: data && data.title && data.title.toString() || '',
    dw: dw,
    dh: dh,
    customSubtitle: (data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : _data$subTitle.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : _data$description.toString())
  });
};

var components$p = {
  WarholCard3A5L: WarholCard3A5L,
  WarholCard3A5: WarholCard3A5,
  WarholCard3A4L: WarholCard3A4L,
  WarholCard3A4: WarholCard3A4,
  WarholCard3A3L: WarholCard3A3L,
  WarholCard3A3: WarholCard3A3,
  WarholCard3A2L: WarholCard3A2L,
  WarholCard3A2: WarholCard3A2,
  WarholCard3A1L: WarholCard3A1L,
  WarholCard3A1: WarholCard3A1,
  WarholCard3A0L: WarholCard3A0L,
  WarholCard3A0: WarholCard3A0,
  WarholCard3A0Plus: WarholCard3A0Plus
};
var WarholStyle3CardPrint = function WarholStyle3CardPrint(props) {
  var _data$subTitle, _data$description;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  return React$1.createElement(components$p[templateType], {
    url: data && data.link || 'gallllery.com',
    image: image,
    number: data && data.number,
    museum: data && data.description || '',
    name: data && data.title && data.title.length && data.title.toString() || '',
    dw: dw,
    dh: dh,
    customSubtitle: (data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : _data$subTitle.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : _data$description.toString())
  });
};

var components$q = {
  WarholCard4A5L: WarholCard4A5L,
  WarholCard4A4L: WarholCard4A4L,
  WarholCard4A3L: WarholCard4A3L,
  WarholCard4A2L: WarholCard4A2L,
  WarholCard4A1L: WarholCard4A1L,
  WarholCard4A0L: WarholCard4A0L
};
var WarholStyle4CardPrint = function WarholStyle4CardPrint(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  if (!components$q[templateType]) {
    return 'Такого шаблона нет';
  }
  return React$1.createElement(components$q[templateType], {
    url: data && data.link || 'gallllery.com',
    image: image,
    number: data && data.number,
    museum: data && data.description || '',
    name: data && data.title && data.title.lenght && data.title.toString() || '',
    dw: dw,
    dh: dh
  });
};

var components$r = {
  ClassicCard3A0: ClassicCard3A0,
  ClassicCard3A1: ClassicCard3A1,
  ClassicCard3A2: ClassicCard3A2,
  ClassicCard3A3: ClassicCard3A3,
  ClassicCard3A4: ClassicCard3A4,
  ClassicCard3A5: ClassicCard3A5
};
var ClassicStyle3CardPrint = function ClassicStyle3CardPrint(props) {
  var templateType = props.templateType;
  if (!components$r[templateType]) {
    return 'Такого шаблона нет, ';
  }
  return 'Шаблон в разработке.';
};

var components$s = {
  LuvrikCardA5L: LuvrikCardA5L,
  LuvrikCardA5: LuvrikCardA5,
  LuvrikCardA4L: LuvrikCardA4L,
  LuvrikCardA4: LuvrikCardA4,
  LuvrikCardA3L: LuvrikCardA3L,
  LuvrikCardA3: LuvrikCardA3,
  LuvrikCardA2L: LuvrikCardA2L,
  LuvrikCardA2: LuvrikCardA2,
  LuvrikCardA1L: LuvrikCardA1L,
  LuvrikCardA1: LuvrikCardA1,
  LuvrikCardA0L: LuvrikCardA0L,
  LuvrikCardA0: LuvrikCardA0,
  ClassicA5L: LuvrikCardA5L,
  ClassicA5: LuvrikCardA5,
  ClassicA4L: LuvrikCardA4L,
  ClassicA4: LuvrikCardA4,
  ClassicA3L: LuvrikCardA3L,
  ClassicA3: LuvrikCardA3,
  ClassicA2L: LuvrikCardA2L,
  ClassicA2: LuvrikCardA2,
  ClassicA1L: LuvrikCardA1L,
  ClassicA1: LuvrikCardA1,
  ClassicA0L: LuvrikCardA0L,
  ClassicA0: LuvrikCardA0
};
var LuvrikStyleCardPrint = function LuvrikStyleCardPrint(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$s[templateType], {
    url: data && data.link || 'ze.land',
    image: image,
    country: data && data.subTitle,
    number: data && data.number,
    museum: data && data.title,
    name: data && data.description,
    dw: dw,
    dh: dh
  });
};

var components$t = {
  PosterCardA0Plus: PosterCardA0Plus,
  PosterCardA0: PosterCardA0,
  PosterCardA1: PosterCardA1,
  PosterCardA2: PosterCardA2,
  PosterCardA3: PosterCardA3,
  PosterCardA4: PosterCardA4,
  PosterCardA5: PosterCardA5
};
var PosterCardPrint = function PosterCardPrint(_ref) {
  var _data$subTitle, _data$description;
  var data = _ref.data,
    image = _ref.image,
    templateType = _ref.templateType,
    dw = _ref.dw,
    dh = _ref.dh,
    customSubtitle = _ref.customSubtitle;
  return React$1.createElement(components$t[templateType], {
    url: (data === null || data === void 0 ? void 0 : data.link) || 'gallllery.com',
    image: image,
    number: (data === null || data === void 0 ? void 0 : data.number) || '',
    museum: (data === null || data === void 0 ? void 0 : data.title) || '',
    dw: dw,
    dh: dh,
    description: (data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : _data$subTitle.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : _data$description.toString())
  });
};

var components$u = {
  FamilyMuseumA0Plus: FamilyMuseumA0Plus,
  FamilyMuseumWithNumberA0Plus: FamilyMuseumWithNumberA0Plus,
  FamilyMuseumA0: FamilyMuseumA0,
  FamilyMuseumWithNumberA0: FamilyMuseumWithNumberA0,
  FamilyMuseumA0L: FamilyMuseumA0L,
  FamilyMuseumWithNumberA0L: FamilyMuseumWithNumberA0L,
  FamilyMuseumA1: FamilyMuseumA1,
  FamilyMuseumWithNumberA1: FamilyMuseumWithNumberA1,
  FamilyMuseumA1L: FamilyMuseumA1L,
  FamilyMuseumWithNumberA1L: FamilyMuseumWithNumberA1L,
  FamilyMuseumA2: FamilyMuseumA2,
  FamilyMuseumWithNumberA2: FamilyMuseumWithNumberA2,
  FamilyMuseumA2L: FamilyMuseumA2L,
  FamilyMuseumWithNumberA2L: FamilyMuseumWithNumberA2L,
  FamilyMuseumA3: FamilyMuseumA3,
  FamilyMuseumWithNumberA3: FamilyMuseumWithNumberA3,
  FamilyMuseumA3L: FamilyMuseumA3L,
  FamilyMuseumWithNumberA3L: FamilyMuseumWithNumberA3L,
  FamilyMuseumA4: FamilyMuseumA4,
  FamilyMuseumWithNumberA4: FamilyMuseumWithNumberA4,
  FamilyMuseumA4L: FamilyMuseumA4L,
  FamilyMuseumWithNumberA4L: FamilyMuseumWithNumberA4L,
  FamilyMuseumA5: FamilyMuseumA5,
  FamilyMuseumWithNumberA5: FamilyMuseumWithNumberA5,
  FamilyMuseumA5L: FamilyMuseumA5L,
  FamilyMuseumWithNumberA5L: FamilyMuseumWithNumberA5L
};
var FamilyMuseumPrint = function FamilyMuseumPrint(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$u[templateType], {
    url: (data === null || data === void 0 ? void 0 : data.link) || 'kiiids.art',
    image: image,
    number: (data === null || data === void 0 ? void 0 : data.number) || '',
    customSubtitle: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    name: (data === null || data === void 0 ? void 0 : data.title) || '',
    description: (data === null || data === void 0 ? void 0 : data.description) || '',
    dw: dw,
    dh: dh
  });
};

var components$v = {
  FlowerHoroscopeCardA1: FlowerHoroscopeCardA1,
  FlowerHoroscopeSqCardA1: FlowerHoroscopeSqCardA1,
  FlowerHoroscopeCardA2: FlowerHoroscopeCardA2,
  FlowerHoroscopeSqCardA2: FlowerHoroscopeSqCardA2,
  FlowerHoroscopeCardA3: FlowerHoroscopeCardA3,
  FlowerHoroscopeSqCardA3: FlowerHoroscopeSqCardA3,
  FlowerHoroscopeCardA4: FlowerHoroscopeCardA4,
  FlowerHoroscopeSqCardA4: FlowerHoroscopeSqCardA4,
  FlowerHoroscopeCardA5: FlowerHoroscopeCardA5,
  FlowerHoroscopeSqCardA5: FlowerHoroscopeSqCardA5,
  FlowerHoroscope2CardA1: FlowerHoroscope2CardA1,
  FlowerHoroscope2SqCardA1: FlowerHoroscope2SqCardA1,
  FlowerHoroscope2CardA2: FlowerHoroscope2CardA2,
  FlowerHoroscope2SqCardA2: FlowerHoroscope2SqCardA2,
  FlowerHoroscope2CardA3: FlowerHoroscope2CardA3,
  FlowerHoroscope2SqCardA3: FlowerHoroscope2SqCardA3,
  FlowerHoroscope2CardA4: FlowerHoroscope2CardA4,
  FlowerHoroscope2SqCardA4: FlowerHoroscope2SqCardA4,
  FlowerHoroscope2CardA5: FlowerHoroscope2CardA5,
  FlowerHoroscope2SqCardA5: FlowerHoroscope2SqCardA5,
  FlowerHoroscope3CardA1: FlowerHoroscope3CardA1,
  FlowerHoroscope3SqCardA1: FlowerHoroscope3SqCardA1,
  FlowerHoroscope3CardA2: FlowerHoroscope3CardA2,
  FlowerHoroscope3SqCardA2: FlowerHoroscope3SqCardA2,
  FlowerHoroscope3CardA3: FlowerHoroscope3CardA3,
  FlowerHoroscope3SqCardA3: FlowerHoroscope3SqCardA3,
  FlowerHoroscope3CardA4: FlowerHoroscope3CardA4,
  FlowerHoroscope3SqCardA4: FlowerHoroscope3SqCardA4,
  FlowerHoroscope3CardA5: FlowerHoroscope3CardA5,
  FlowerHoroscope3SqCardA5: FlowerHoroscope3SqCardA5
};
var FlowerHoroscopeCardPrint = function FlowerHoroscopeCardPrint(props) {
  var _ref;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    useRegularFieldsProp = props.useRegularFields,
    dw = props.dw,
    dh = props.dh;
  var useRegularFieldsResolved = (_ref = useRegularFieldsProp != null ? useRegularFieldsProp : data && data.useRegularFields) != null ? _ref : false;
  return React$1.createElement(components$v[templateType], {
    url: (data === null || data === void 0 ? void 0 : data.link) || 'artz.work',
    image: image,
    number: (data === null || data === void 0 ? void 0 : data.number) || '',
    customSubtitle: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    description: (data === null || data === void 0 ? void 0 : data.description) || '',
    museum: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    name: (data === null || data === void 0 ? void 0 : data.title) || '',
    useRegularFields: useRegularFieldsResolved,
    dw: dw,
    dh: dh
  });
};

var components$w = {
  WarholStyleCardPrint: WarholStyleCardPrint,
  WarholStyle2CardPrint: WarholStyle2CardPrint,
  WarholStyle3CardPrint: WarholStyle3CardPrint,
  WarholStyle4CardPrint: WarholStyle4CardPrint,
  ClassicStyle3CardPrint: ClassicStyle3CardPrint,
  LuvrikStyleCardPrint: LuvrikStyleCardPrint,
  ShipsStyleCardPrint: ShipsStyleCardPrint,
  FlowersStyleCardPrint: FlowersStyleCardPrint,
  WarholStyle2WithQrCardPrint: WarholStyle2WithQrCardPrint,
  PosterCardPrint: PosterCardPrint,
  FamilyMuseumPrint: FamilyMuseumPrint,
  FlowerHoroscopeCardPrint: FlowerHoroscopeCardPrint,
  ServiceCardPrint: ServiceCardPrint,
  LuvricZodiacPrint: LuvricZodiacPrint
};
var MasterCardPrint = function MasterCardPrint(props) {
  var sanitizedProps = _deepRemoveEmojis(props);
  var _sanitizedProps$templ = sanitizedProps.templateType,
    templateType = _sanitizedProps$templ === void 0 ? '' : _sanitizedProps$templ;
  var _useFullPageLoad = useFullPageLoad(),
    isFullyLoaded = _useFullPageLoad.isFullyLoaded;
  var localTemplateName = templateType.replace('warhol1', 'warhol').replace('warhol', 'WarholCard');
  var templateComponent = components$w.WarholStyleCardPrint;
  if (localTemplateName.startsWith('WarholCardA')) {
    templateComponent = components$w.WarholStyleCardPrint;
  }
  if (localTemplateName.startsWith('WarholA')) {
    templateComponent = components$w.WarholStyleCardPrint;
  }
  if (localTemplateName.startsWith('WarholCard2A')) {
    templateComponent = components$w.WarholStyle2CardPrint;
  }
  if (localTemplateName.startsWith('WarholCard3A')) {
    templateComponent = components$w.WarholStyle3CardPrint;
  }
  if (localTemplateName.startsWith('WarholCard4A')) {
    templateComponent = components$w.WarholStyle4CardPrint;
  }
  if (localTemplateName.startsWith('ClassicCard3A')) {
    templateComponent = components$w.ClassicStyle3CardPrint;
  }
  if (localTemplateName.startsWith('LuvrikCardA')) {
    templateComponent = components$w.LuvrikStyleCardPrint;
  }
  if (localTemplateName.startsWith('ClassicA')) {
    templateComponent = components$w.LuvrikStyleCardPrint;
  }
  if (localTemplateName.startsWith('ClassicCardA')) {
    templateComponent = components$w.LuvrikStyleCardPrint;
  }
  if (localTemplateName.startsWith('ClassicCardA')) {
    templateComponent = components$w.LuvrikStyleCardPrint;
  }
  if (localTemplateName.startsWith('ShipsCard')) {
    templateComponent = components$w.ShipsStyleCardPrint;
  }
  if (localTemplateName.startsWith('FlowersCard')) {
    templateComponent = components$w.FlowersStyleCardPrint;
  }
  if (localTemplateName.startsWith('WarholCard2WithQr')) {
    templateComponent = components$w.WarholStyle2WithQrCardPrint;
  }
  if (localTemplateName.startsWith('PosterCard')) {
    templateComponent = components$w.PosterCardPrint;
  }
  if (localTemplateName.startsWith('FamilyMuseum')) {
    templateComponent = components$w.FamilyMuseumPrint;
  }
  if (localTemplateName.startsWith('FlowerHoroscope')) {
    templateComponent = components$w.FlowerHoroscopeCardPrint;
  }
  if (localTemplateName.startsWith('ServiceCard')) {
    templateComponent = components$w.ServiceCardPrint;
  }
  if (localTemplateName.startsWith('LuvricZodiac')) {
    templateComponent = components$w.LuvricZodiacPrint;
  }
  return /*#__PURE__*/React$1.createElement(Fragment$1, null, React$1.createElement(templateComponent, _extends({}, sanitizedProps, {
    style: _extends({
      backgroundColor: '#ffffff'
    }, sanitizedProps === null || sanitizedProps === void 0 ? void 0 : sanitizedProps.style),
    templateType: localTemplateName
  })), isFullyLoaded && /*#__PURE__*/React$1.createElement("div", {
    id: "IsFullyLoaded",
    style: {
      width: 0,
      height: 0
    }
  }));
};

var ExampleComponent = function ExampleComponent(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement("div", {
    className: 'test'
  }, "Example Component: ", text);
};

var getAnimalsData = function getAnimalsData(_ref) {
  var services = _ref.services,
    endpoint = _ref.endpoint;
  var animalsItems = Boolean(services === null || services === void 0 ? void 0 : services.length) && services.filter(function (item) {
    return item.type === 'animals';
  });
  var animalItems = animalsItems && animalsItems.length && animalsItems[0].containers || [];
  var animals = animalItems.map(function (item) {
    return {
      animalImage: "" + ((endpoint ? endpoint + '/' : '') + item.attachments[0].files[0].url),
      animalName: item.attachments[0].texts
    };
  });
  return animals;
};

var MAX_LENGTH_IN_SMALL_LINE = 22;
var MAX_LENGTH_IN_LINE = 17;

var useGetTextBlockHeight = function useGetTextBlockHeight(text) {
  var ref = useRef(null);
  var _useState = useState(null),
    height = _useState[0],
    setHeight = _useState[1];
  useEffect(function () {
    if (!ref.current) return;
    var updateHeight = function updateHeight() {
      if (ref.current) {
        setHeight(ref.current.scrollHeight - 5);
      }
    };
    var resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(ref.current);
    var mutationObserver = new MutationObserver(updateHeight);
    mutationObserver.observe(ref.current, {
      childList: true,
      subtree: true,
      characterData: true
    });
    return function () {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [text]);
  return {
    height: height,
    ref: ref
  };
};

var useFormattedText = function useFormattedText(text, maxLength) {
  var _useState = useState(''),
    formattedText = _useState[0],
    setFormattedText = _useState[1];
  useEffect(function () {
    if (!text) return;
    var words = text.split(' ');
    var currentLine = '';
    var result = '';
    words.forEach(function (word) {
      if ((currentLine + ' ' + word).trim().length > maxLength) {
        result += currentLine.trim() + '\n';
        currentLine = word;
      } else {
        currentLine += ' ' + word;
      }
    });
    result += currentLine.trim();
    setFormattedText(result);
  }, [text, maxLength]);
  return formattedText;
};

var _templateObject$24, _templateObject2$24, _templateObject3$1Z, _templateObject4$1A, _templateObject5$1o, _templateObject6$1m, _templateObject7$1i, _templateObject8$1f, _templateObject9$1c, _templateObject10$x, _templateObject11$t, _templateObject12$q, _templateObject13$q, _templateObject14$k, _templateObject15$8, _templateObject16$1, _templateObject17$1, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39;
var Card = styled.div(_templateObject$24 || (_templateObject$24 = _taggedTemplateLiteralLoose(["\n  height: 297mm;\n  width: 210mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 34px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var BorderContainer = styled.div(_templateObject2$24 || (_templateObject2$24 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 2px solid #000;\n  padding: 2px;\n"])));
var ContentContainer = styled.div(_templateObject3$1Z || (_templateObject3$1Z = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid #000;\n  display: flex;\n  flex-direction: column;\n"])));
var HeaderBlock = styled.div(_templateObject4$1A || (_templateObject4$1A = _taggedTemplateLiteralLoose(["\n  height: 12.4%;\n  display: flex;\n"])));
var NumberAndGiftBlock = styled.div(_templateObject5$1o || (_templateObject5$1o = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"])));
var NumberBlock$5 = styled.div(_templateObject6$1m || (_templateObject6$1m = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .num-text {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: 37.5px;\n    letter-spacing: 8.3px;\n    text-indent: 5px;\n  }\n\n  .dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 42px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: 102px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: 102px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var GiftBlock = styled.div(_templateObject7$1i || (_templateObject7$1i = _taggedTemplateLiteralLoose(["\n  height: 25%;\n  border-top: 1px solid #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n"])));
var QrBlock$6 = styled.div(_templateObject8$1f || (_templateObject8$1f = _taggedTemplateLiteralLoose(["\n  width: 18.5%;\n  height: 100%;\n  border-left: 1px solid #000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var QrImageContainer = styled.div(_templateObject9$1c || (_templateObject9$1c = _taggedTemplateLiteralLoose(["\n  height: 74%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n"])));
var QrImage = styled.img(_templateObject10$x || (_templateObject10$x = _taggedTemplateLiteralLoose(["\n  width: 58%;\n"])));
var QrTextContainer = styled.div(_templateObject11$t || (_templateObject11$t = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 24%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var QrText = styled.span(_templateObject12$q || (_templateObject12$q = _taggedTemplateLiteralLoose(["\n  font-family: 'noto';\n  font-size: 10.5px;\n  line-height: 12px;\n"])));
var MapBlock$5 = styled.div(_templateObject13$q || (_templateObject13$q = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 51.5%;\n  border-top: 2px solid #000;\n  border-bottom: 2px solid #000;\n"])));
var MapImage = styled.img(_templateObject14$k || (_templateObject14$k = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  object-fit: cover;\n"])));
var MapSvgBlock$5 = styled.div(_templateObject15$8 || (_templateObject15$8 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  z-index: 10;\n  position: absolute;\n  left: 0;\n  top: 0;\n"])));
var MapSvgImage$5 = styled.div(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"])));
var CountryInfoBlock = styled.div(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 36.1%;\n  display: flex;\n"])));
var MainInfo = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 33.3%;\n  height: 100%;\n  padding-top: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-right: 2px solid #000;\n  overflow: hidden;\n"])));
var EmblemBlock = styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteralLoose(["\n  height: 42.3%;\n  width: 100%;\n"])));
var EmblemImage = styled.img(_templateObject20 || (_templateObject20 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n"])));
var MainInfoContent = styled.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 230px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n"])));
var Country = styled.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  font-family: 'Corki-Tuscan';\n  font-size: 15.5px;\n  line-height: 14px;\n  padding: 0 14px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Territory = styled.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  width: 100%;\n  padding: ", ";\n  font-family: 'Lehmann Egyptian';\n  font-weight: bold;\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: 0.45px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n"])), function (_ref) {
  var height = _ref.height;
  return height ? height + "px" : 'auto';
}, function (_ref2) {
  var withSmallText = _ref2.withSmallText;
  return !withSmallText ? "0 14px" : '0 19px';
}, function (_ref3) {
  var withSmallText = _ref3.withSmallText;
  return withSmallText ? '20.3pt' : '26.2pt';
}, function (_ref4) {
  var withSmallText = _ref4.withSmallText;
  return withSmallText ? '28px' : '36px';
});
var LastBlock = styled.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 2px;\n  font-family: 'Corki-Tuscan';\n  font-size: 15.5px;\n  line-height: 14px;\n  letter-spacing: 0.25px;\n"])));
var Capital = styled.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));
var Divider$1 = styled.div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteralLoose(["\n  border-top: 1px solid #000;\n  width: 30px;\n"])));
var AreaSize = styled.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));
var OtherInfo = styled.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"])));
var ClimateAnimalBlock = styled.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 53.4%;\n  border-bottom: 2px solid #000;\n  display: flex;\n"])));
var InfoBlockHeader = styled.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteralLoose(["\n  height: 23.5px;\n  font-family: 'Lehmann Egyptian';\n  font-weight: bold;\n  font-size: 16px;\n  border-bottom: 1px solid #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  letter-spacing: 2.6px;\n  text-indent: -4px;\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n"])));
var InfoBlockText = styled.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  padding: 11px 10px;\n  font-family: 'Noto';\n  font-size: 9px;\n  line-height: 13.2px;\n  overflow: hidden;\n  white-space: pre-line;\n"])));
var InfoLeftBlock = styled.div(_templateObject32 || (_templateObject32 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 50.1%;\n  height: 100%;\n  border-right: 1px solid #000;\n"])));
var AnimalsAndCurrency = styled.div(_templateObject33 || (_templateObject33 = _taggedTemplateLiteralLoose(["\n  width: 49.5%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var AnimalBlock$5 = styled.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  height: 62%;\n  border-bottom: 2px solid #000;\n"])));
var Animals = styled.div(_templateObject35 || (_templateObject35 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Animal = styled.div(_templateObject36 || (_templateObject36 = _taggedTemplateLiteralLoose(["\n  width: 35.7px;\n  height: 35.7px;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"])));
var InfoRightBlock = styled.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"])));
var Currency = styled.div(_templateObject38 || (_templateObject38 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-style: italic;\n  font-family: 'Baskerville';\n  letter-spacing: 3.5px;\n  font-size: 16px;\n  line-height: 19px;\n  text-align: center;\n  padding-bottom: 1px;\n"])));
var GeographicEconomicBlock = styled.div(_templateObject39 || (_templateObject39 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n"])));
var MapCardA4$1 = function MapCardA4(_ref5) {
  var _countrySize$match, _territory$trim, _territory$trim$split;
  var num = _ref5.num,
    qrImage = _ref5.qrImage,
    qrText = _ref5.qrText,
    mapImage = _ref5.mapImage,
    mapSvg = _ref5.mapSvg,
    emblemImage = _ref5.emblemImage,
    country = _ref5.country,
    territory = _ref5.territory,
    capital = _ref5.capital,
    countrySize = _ref5.countrySize,
    climate = _ref5.climate,
    geographic = _ref5.geographic,
    currency = _ref5.currency,
    economical = _ref5.economical,
    dw = _ref5.dw,
    dh = _ref5.dh,
    services = _ref5.services,
    endpoint = _ref5.endpoint,
    externalStyles = _ref5.externalStyles,
    capitalTitle = _ref5.capitalTitle,
    territoryTitle = _ref5.territoryTitle,
    climateTitle = _ref5.climateTitle,
    geographicTitle = _ref5.geographicTitle,
    currencyTitle = _ref5.currencyTitle,
    economicalTitle = _ref5.economicalTitle,
    animalTitle = _ref5.animalTitle;
  var withCountrySize = Boolean(countrySize === null || countrySize === void 0 ? void 0 : (_countrySize$match = countrySize.match(/\d/g)) === null || _countrySize$match === void 0 ? void 0 : _countrySize$match.length);
  var _useGetTextBlockHeigh = useGetTextBlockHeight(territory),
    territoryRef = _useGetTextBlockHeigh.ref,
    territoryHeight = _useGetTextBlockHeigh.height;
  var animals = getAnimalsData({
    services: services,
    endpoint: endpoint
  });
  var withCountry = Boolean(country === null || country === void 0 ? void 0 : country.length);
  var withSmallText = territory === null || territory === void 0 ? void 0 : (_territory$trim = territory.trim()) === null || _territory$trim === void 0 ? void 0 : (_territory$trim$split = _territory$trim.split(' ')) === null || _territory$trim$split === void 0 ? void 0 : _territory$trim$split.some(function (word) {
    return (word === null || word === void 0 ? void 0 : word.length) > MAX_LENGTH_IN_LINE;
  });
  var formattedTerritory = useFormattedText(territory, withSmallText ? MAX_LENGTH_IN_SMALL_LINE : MAX_LENGTH_IN_LINE);
  var isFourLine = !withSmallText && formattedTerritory && formattedTerritory.split('').filter(function (item) {
    return item === '\n';
  }).length >= 3 && withCountry;
  return /*#__PURE__*/React$1.createElement(Card, {
    dh: dh,
    dw: dw,
    style: externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.container
  }, /*#__PURE__*/React$1.createElement(BorderContainer, null, /*#__PURE__*/React$1.createElement(ContentContainer, null, /*#__PURE__*/React$1.createElement(HeaderBlock, null, /*#__PURE__*/React$1.createElement(NumberAndGiftBlock, null, /*#__PURE__*/React$1.createElement(NumberBlock$5, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", {
    className: "num-text"
  }, num), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  }))), /*#__PURE__*/React$1.createElement(QrBlock$6, null, /*#__PURE__*/React$1.createElement(QrImageContainer, null, /*#__PURE__*/React$1.createElement(QrImage, {
    src: qrImage
  })), /*#__PURE__*/React$1.createElement(QrTextContainer, null, /*#__PURE__*/React$1.createElement(QrText, null, qrText)))), /*#__PURE__*/React$1.createElement(MapBlock$5, null, /*#__PURE__*/React$1.createElement(MapImage, {
    src: mapImage,
    alt: "Map"
  }), /*#__PURE__*/React$1.createElement(MapSvgBlock$5, null, /*#__PURE__*/React$1.createElement(MapSvgImage$5, {
    className: "map_svg_imageA3",
    dangerouslySetInnerHTML: {
      __html: mapSvg
    }
  }))), /*#__PURE__*/React$1.createElement(CountryInfoBlock, null, /*#__PURE__*/React$1.createElement(MainInfo, null, /*#__PURE__*/React$1.createElement(EmblemBlock, {
    style: externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.gerbImgContainer
  }, /*#__PURE__*/React$1.createElement(EmblemImage, {
    style: externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.gerbImg,
    src: emblemImage,
    alt: "Emblem"
  })), /*#__PURE__*/React$1.createElement(MainInfoContent, null, withCountry && /*#__PURE__*/React$1.createElement(Country, null, country), /*#__PURE__*/React$1.createElement(Territory, {
    ref: territoryRef,
    withSmallText: isFourLine || withSmallText,
    withCountry: withCountry,
    style: {
      height: territoryHeight ? territoryHeight + "px" : 'auto'
    }
  }, formattedTerritory), /*#__PURE__*/React$1.createElement(LastBlock, null, /*#__PURE__*/React$1.createElement(Capital, null, capitalTitle || 'Столица', ": ", capital), withCountrySize && /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Divider$1, null), /*#__PURE__*/React$1.createElement(AreaSize, null, territoryTitle || 'Территория', ": ", countrySize))))), /*#__PURE__*/React$1.createElement(OtherInfo, null, /*#__PURE__*/React$1.createElement(ClimateAnimalBlock, null, /*#__PURE__*/React$1.createElement(InfoLeftBlock, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader, null, climateTitle || 'Климат'), /*#__PURE__*/React$1.createElement(InfoBlockText, null, climate)), /*#__PURE__*/React$1.createElement(AnimalsAndCurrency, null, /*#__PURE__*/React$1.createElement(AnimalBlock$5, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader, null, animalTitle || 'Животный мир'), /*#__PURE__*/React$1.createElement(Animals, null, Boolean(animals === null || animals === void 0 ? void 0 : animals.length) && animals.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement(Animal, {
      key: index
    }, /*#__PURE__*/React$1.createElement("img", {
      src: item.animalImage,
      alt: ""
    }));
  })), /*#__PURE__*/React$1.createElement(InfoBlockText, {
    style: {
      paddingTop: 0,
      paddingBottom: '5px'
    }
  }, Boolean(animals === null || animals === void 0 ? void 0 : animals.length) && animals.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index
    }, item.animalName, ". ");
  }))), /*#__PURE__*/React$1.createElement(InfoRightBlock, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader, {
    style: {
      height: '25px'
    }
  }, currencyTitle || 'Используемая валюта'), /*#__PURE__*/React$1.createElement(Currency, null, currency)))), /*#__PURE__*/React$1.createElement(GeographicEconomicBlock, null, /*#__PURE__*/React$1.createElement(InfoLeftBlock, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader, null, geographicTitle || 'Географическое положение'), /*#__PURE__*/React$1.createElement(InfoBlockText, null, geographic)), /*#__PURE__*/React$1.createElement(InfoRightBlock, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader, null, economicalTitle || 'Экономический прогноз'), /*#__PURE__*/React$1.createElement(InfoBlockText, null, economical))))))));
};

var MAX_LENGTH_IN_LINE$1 = 17;
var MAX_LENGTH_IN_SMALL_LINE$1 = 22;

var _templateObject$25, _templateObject2$25, _templateObject3$1_, _templateObject4$1B, _templateObject5$1p, _templateObject6$1n, _templateObject7$1j, _templateObject8$1g, _templateObject9$1d, _templateObject10$y, _templateObject11$u, _templateObject12$r, _templateObject13$r, _templateObject14$l, _templateObject15$9, _templateObject16$2, _templateObject17$2, _templateObject18$1, _templateObject19$1, _templateObject20$1, _templateObject21$1, _templateObject22$1, _templateObject23$1, _templateObject24$1, _templateObject25$1, _templateObject26$1, _templateObject27$1, _templateObject28$1, _templateObject29$1, _templateObject30$1, _templateObject31$1, _templateObject32$1, _templateObject33$1, _templateObject34$1, _templateObject35$1, _templateObject36$1, _templateObject37$1, _templateObject38$1, _templateObject39$1, _templateObject40;
var Card$1 = styled.div(_templateObject$25 || (_templateObject$25 = _taggedTemplateLiteralLoose(["\n  height: 210mm;\n  width: 297mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 34.5px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var BorderContainer$1 = styled.div(_templateObject2$25 || (_templateObject2$25 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 2px solid #000;\n  padding: 2px;\n"])));
var ContentContainer$1 = styled.div(_templateObject3$1_ || (_templateObject3$1_ = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid #000;\n  display: flex;\n  flex-direction: column;\n"])));
var NumberAndGiftBlock$1 = styled.div(_templateObject4$1B || (_templateObject4$1B = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var NumberBlock$6 = styled.div(_templateObject5$1p || (_templateObject5$1p = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .num-text {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: 22px;\n    letter-spacing: 6px;\n  }\n\n  .dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 25px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: 62px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: 62px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var GiftBlock$1 = styled.div(_templateObject6$1n || (_templateObject6$1n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 62%;\n  font-family: 'Oranienbaum';\n  font-size: 14px;\n  border-bottom: 1px solid #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n"])));
var QrBlock$7 = styled.div(_templateObject7$1j || (_templateObject7$1j = _taggedTemplateLiteralLoose(["\n  width: 12.6%;\n  height: 100%;\n  border-left: 2px solid #000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var QrImageContainer$1 = styled.div(_templateObject8$1g || (_templateObject8$1g = _taggedTemplateLiteralLoose(["\n  height: 78%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n"])));
var QrImage$1 = styled.img(_templateObject9$1d || (_templateObject9$1d = _taggedTemplateLiteralLoose(["\n  width: 60%;\n"])));
var QrTextContainer$1 = styled.div(_templateObject10$y || (_templateObject10$y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 22%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var QrText$1 = styled.span(_templateObject11$u || (_templateObject11$u = _taggedTemplateLiteralLoose(["\n  font-family: 'noto';\n  font-size: 10.5px;\n  line-height: 12px;\n  letter-spacing: 0.5px;\n"])));
var MapImage$1 = styled.img(_templateObject12$r || (_templateObject12$r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  object-fit: cover;\n"])));
var MapSvgBlock$6 = styled.div(_templateObject13$r || (_templateObject13$r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  z-index: 10;\n  position: absolute;\n  left: 0;\n  top: 0;\n"])));
var MapSvgImage$6 = styled.div(_templateObject14$l || (_templateObject14$l = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"])));
var MainInfo$1 = styled.div(_templateObject15$9 || (_templateObject15$9 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 59.8%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-bottom: 2px solid #000;\n  padding-top: 10px;\n"])));
var MainInfoContent$1 = styled.div(_templateObject16$2 || (_templateObject16$2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 216px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n"])));
var EmblemBlock$1 = styled.div(_templateObject17$2 || (_templateObject17$2 = _taggedTemplateLiteralLoose(["\n  height: 42%;\n  width: 100%;\n"])));
var EmblemImage$1 = styled.img(_templateObject18$1 || (_templateObject18$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n"])));
var Country$1 = styled.div(_templateObject19$1 || (_templateObject19$1 = _taggedTemplateLiteralLoose(["\n  font-family: 'Corki-Tuscan';\n  font-size: 15px;\n  line-height: 14px;\n  padding: 0 20px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Territory$1 = styled.div(_templateObject20$1 || (_templateObject20$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  padding: 0 27px;\n  font-family: 'Lehmann Egyptian';\n  font-weight: bold;\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: 0.4px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n"])), function (_ref) {
  var withSmallText = _ref.withSmallText;
  return withSmallText ? '20.3pt' : '26.2pt';
}, function (_ref2) {
  var withSmallText = _ref2.withSmallText;
  return withSmallText ? '28px' : '36px';
});
var LastBlock$1 = styled.div(_templateObject21$1 || (_templateObject21$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1px;\n  font-family: 'Corki-Tuscan';\n  font-size: 15px;\n  line-height: 14px;\n  letter-spacing: 0.5px;\n"])));
var Capital$1 = styled.div(_templateObject22$1 || (_templateObject22$1 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));
var Divider$2 = styled.div(_templateObject23$1 || (_templateObject23$1 = _taggedTemplateLiteralLoose(["\n  border-top: 1px solid #000;\n  width: 30px;\n"])));
var AreaSize$1 = styled.div(_templateObject24$1 || (_templateObject24$1 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));
var InfoBlockHeader$1 = styled.div(_templateObject25$1 || (_templateObject25$1 = _taggedTemplateLiteralLoose(["\n  height: 23.5px;\n  font-family: 'Lehmann Egyptian';\n  font-weight: bold;\n  font-size: 16px;\n  border-bottom: 1px solid #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  letter-spacing: 2.6px;\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n"])));
var InfoBlockText$1 = styled.div(_templateObject26$1 || (_templateObject26$1 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  padding: 8.5px 8px;\n  font-family: 'Noto';\n  font-size: 8px;\n  letter-spacing: 0.3px;\n  line-height: 12.5px;\n  overflow: hidden;\n  white-space: pre-line;\n"])));
var Animals$1 = styled.div(_templateObject27$1 || (_templateObject27$1 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var AnimalsImages = styled.div(_templateObject28$1 || (_templateObject28$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var AnimalImage = styled.div(_templateObject29$1 || (_templateObject29$1 = _taggedTemplateLiteralLoose(["\n  width: 42px;\n  height: 42px;\n  font-family: 'Noto';\n  font-size: 7px;\n  text-align: center;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"])));
var AnimalNames = styled.div(_templateObject30$1 || (_templateObject30$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: fit-content;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0 8px;\n  font-family: 'Noto';\n  font-size: 8px;\n  letter-spacing: 0.3px;\n  line-height: 12.5px;\n"])));
var Currency$1 = styled.div(_templateObject31$1 || (_templateObject31$1 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-style: italic;\n  font-family: 'Baskerville';\n  letter-spacing: 3.5px;\n  font-size: 16px;\n  text-align: center;\n  overflow: hidden;\n"])));
var TopSection = styled.div(_templateObject32$1 || (_templateObject32$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 81.8%;\n  display: flex;\n  border-bottom: 2px solid #000;\n"])));
var LeftBlock = styled.div(_templateObject33$1 || (_templateObject33$1 = _taggedTemplateLiteralLoose(["\n  width: 25.3%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  border-right: 2px solid #000;\n"])));
var ClimateBlock = styled.div(_templateObject34$1 || (_templateObject34$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 20.5%;\n  display: flex;\n  flex-direction: column;\n  border-bottom: 2px solid #000;\n"])));
var AnimalBlock$6 = styled.div(_templateObject35$1 || (_templateObject35$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n"])));
var BottomSection = styled.div(_templateObject36$1 || (_templateObject36$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 18.2%;\n  display: flex;\n"])));
var InfoBlock$1 = styled.div(_templateObject37$1 || (_templateObject37$1 = _taggedTemplateLiteralLoose(["\n  width: 25.3%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  border-right: 2px solid #000;\n"])));
var CurrencyAndNumberBlock = styled.div(_templateObject38$1 || (_templateObject38$1 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"])));
var CurrencyBlock = styled.div(_templateObject39$1 || (_templateObject39$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 41%;\n  display: flex;\n  flex-direction: column;\n  border-bottom: 2px solid #000;\n"])));
var RightBlock = styled.div(_templateObject40 || (_templateObject40 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 74.7%;\n  height: 100%;\n"])));
var MapCardA4L$1 = function MapCardA4L(_ref3) {
  var _countrySize$match, _climate$slice, _territory$trim, _territory$trim$split;
  var num = _ref3.num,
    qrImage = _ref3.qrImage,
    qrText = _ref3.qrText,
    mapImage = _ref3.mapImage,
    mapSvg = _ref3.mapSvg,
    emblemImage = _ref3.emblemImage,
    country = _ref3.country,
    territory = _ref3.territory,
    capital = _ref3.capital,
    countrySize = _ref3.countrySize,
    climate = _ref3.climate,
    geographic = _ref3.geographic,
    currency = _ref3.currency,
    economical = _ref3.economical,
    dw = _ref3.dw,
    dh = _ref3.dh,
    services = _ref3.services,
    endpoint = _ref3.endpoint,
    externalStyles = _ref3.externalStyles,
    capitalTitle = _ref3.capitalTitle,
    territoryTitle = _ref3.territoryTitle,
    climateTitle = _ref3.climateTitle,
    geographicTitle = _ref3.geographicTitle,
    currencyTitle = _ref3.currencyTitle,
    economicalTitle = _ref3.economicalTitle,
    animalTitle = _ref3.animalTitle;
  var withCountrySize = Boolean(countrySize === null || countrySize === void 0 ? void 0 : (_countrySize$match = countrySize.match(/\d/g)) === null || _countrySize$match === void 0 ? void 0 : _countrySize$match.length);
  var _useGetTextBlockHeigh = useGetTextBlockHeight(territory),
    territoryRef = _useGetTextBlockHeigh.ref,
    territoryHeight = _useGetTextBlockHeigh.height;
  var animals = getAnimalsData({
    services: services,
    endpoint: endpoint
  });
  var shortClimateText = (climate === null || climate === void 0 ? void 0 : (_climate$slice = climate.slice(0, 300)) === null || _climate$slice === void 0 ? void 0 : _climate$slice.replace(/[^.!?]*$/, '')) || '';
  var withCountry = Boolean(country === null || country === void 0 ? void 0 : country.length);
  var withSmallText = territory === null || territory === void 0 ? void 0 : (_territory$trim = territory.trim()) === null || _territory$trim === void 0 ? void 0 : (_territory$trim$split = _territory$trim.split(' ')) === null || _territory$trim$split === void 0 ? void 0 : _territory$trim$split.some(function (word) {
    return (word === null || word === void 0 ? void 0 : word.length) > MAX_LENGTH_IN_LINE$1;
  });
  var formattedTerritory = useFormattedText(territory, withSmallText ? MAX_LENGTH_IN_SMALL_LINE$1 : MAX_LENGTH_IN_LINE$1);
  var isFourLine = !withSmallText && formattedTerritory && formattedTerritory.split('').filter(function (item) {
    return item === '\n';
  }).length >= 3 && withCountry;
  return /*#__PURE__*/React$1.createElement(Card$1, {
    dh: dh,
    dw: dw,
    style: externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.container
  }, /*#__PURE__*/React$1.createElement(BorderContainer$1, null, /*#__PURE__*/React$1.createElement(ContentContainer$1, null, /*#__PURE__*/React$1.createElement(TopSection, null, /*#__PURE__*/React$1.createElement(LeftBlock, null, /*#__PURE__*/React$1.createElement(MainInfo$1, null, /*#__PURE__*/React$1.createElement(EmblemBlock$1, {
    style: externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.gerbImgContainer
  }, /*#__PURE__*/React$1.createElement(EmblemImage$1, {
    style: externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.gerbImg,
    src: emblemImage,
    alt: "Emblem"
  })), /*#__PURE__*/React$1.createElement(MainInfoContent$1, null, withCountry && /*#__PURE__*/React$1.createElement(Country$1, null, country), /*#__PURE__*/React$1.createElement(Territory$1, {
    ref: territoryRef,
    withSmallText: isFourLine || withSmallText,
    withCountry: withCountry,
    style: {
      height: territoryHeight ? territoryHeight + "px" : 'auto'
    }
  }, formattedTerritory), /*#__PURE__*/React$1.createElement(LastBlock$1, {
    withCountrySize: withCountrySize
  }, /*#__PURE__*/React$1.createElement(Capital$1, null, capitalTitle || 'Столица', ": ", capital), withCountrySize && /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Divider$2, null), /*#__PURE__*/React$1.createElement(AreaSize$1, null, territoryTitle || 'Территория', ": ", countrySize))))), /*#__PURE__*/React$1.createElement(ClimateBlock, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader$1, null, climateTitle || 'Климат'), /*#__PURE__*/React$1.createElement(InfoBlockText$1, null, shortClimateText)), /*#__PURE__*/React$1.createElement(AnimalBlock$6, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader$1, null, animalTitle || 'Животный мир'), /*#__PURE__*/React$1.createElement(Animals$1, null, /*#__PURE__*/React$1.createElement(AnimalsImages, null, Boolean(animals === null || animals === void 0 ? void 0 : animals.length) && animals.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement(AnimalImage, {
      key: index
    }, /*#__PURE__*/React$1.createElement("img", {
      src: item === null || item === void 0 ? void 0 : item.animalImage,
      alt: ""
    }));
  })), /*#__PURE__*/React$1.createElement(AnimalNames, null, Boolean(animals === null || animals === void 0 ? void 0 : animals.length) && animals.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index
    }, item.animalName, ".", "\xA0");
  }))))), /*#__PURE__*/React$1.createElement(RightBlock, null, /*#__PURE__*/React$1.createElement(MapImage$1, {
    src: mapImage,
    alt: "Map"
  }), /*#__PURE__*/React$1.createElement(MapSvgBlock$6, null, /*#__PURE__*/React$1.createElement(MapSvgImage$6, {
    className: "map_svg_imageA3",
    dangerouslySetInnerHTML: {
      __html: mapSvg
    }
  })))), /*#__PURE__*/React$1.createElement(BottomSection, null, /*#__PURE__*/React$1.createElement(InfoBlock$1, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader$1, null, geographicTitle || 'Географическое положение'), /*#__PURE__*/React$1.createElement(InfoBlockText$1, null, geographic)), /*#__PURE__*/React$1.createElement(InfoBlock$1, {
    style: {
      width: '25.6%'
    }
  }, /*#__PURE__*/React$1.createElement(InfoBlockHeader$1, null, economicalTitle || 'Экономический прогноз'), /*#__PURE__*/React$1.createElement(InfoBlockText$1, null, economical)), /*#__PURE__*/React$1.createElement(CurrencyAndNumberBlock, null, /*#__PURE__*/React$1.createElement(CurrencyBlock, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader$1, null, currencyTitle || 'Используемая валюта'), /*#__PURE__*/React$1.createElement(Currency$1, null, currency)), /*#__PURE__*/React$1.createElement(NumberAndGiftBlock$1, null, /*#__PURE__*/React$1.createElement(NumberBlock$6, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", {
    className: "num-text"
  }, num), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })))), /*#__PURE__*/React$1.createElement(QrBlock$7, null, /*#__PURE__*/React$1.createElement(QrImageContainer$1, null, /*#__PURE__*/React$1.createElement(QrImage$1, {
    src: qrImage
  })), /*#__PURE__*/React$1.createElement(QrTextContainer$1, null, /*#__PURE__*/React$1.createElement(QrText$1, null, qrText)))))));
};

export { Calendar, CalendarFreePreview, CalendarModern, CalendarPreview, CalendarsModernPrint, CalendarsPrint, ClassicCard3A0, ClassicCard3A1, ClassicCard3A2, ClassicCard3A3, ClassicCard3A4, ClassicCard3A5, ExampleComponent, FlowerHoroscopeCard, FlowerHoroscopeCardPrint, FlowersStyleCard, FlowersStyleCardPrint, GeograffeeCardA3, LuvrikCardA0, LuvrikCardA0L, LuvrikCardA1, LuvrikCardA1L, LuvrikCardA2, LuvrikCardA2L, LuvrikCardA3, LuvrikCardA3L, LuvrikCardA4, LuvrikCardA4L, LuvrikCardA5, LuvrikCardA5L, MapCardA2L, MapCardA3, MapCardA3L, MapCardA4, MapCardA4L, MasterCard, MasterCardPrint, MapCardA4$1 as NewMapCardA4, MapCardA4L$1 as NewMapCardA4L, PosterCard, PosterCardPrint, ServiceCard, ServiceCardPrint, ShipsStyleCard, ShipsStyleCardPrint, TimelineCardMasterTemplate, VotingCoverCardMain, WarholCard2A0, WarholCard2A0L, WarholCard2A1, WarholCard2A1L, WarholCard2A2, WarholCard2A2L, WarholCard2A3, WarholCard2A3L, WarholCard2A4, WarholCard2A4L, WarholCard2A5, WarholCard2A5L, WarholCard3A0, WarholCard3A0L, WarholCard3A1, WarholCard3A1L, WarholCard3A2, WarholCard3A2L, WarholCard3A3, WarholCard3A3L, WarholCard3A4, WarholCard3A4L, WarholCard3A5, WarholCard3A5L, WarholCard4A0L, WarholCard4A1L, WarholCard4A2L, WarholCard4A3L, WarholCard4A4L, WarholCard4A5L, WarholCardA0, WarholCardA0L, WarholCardA1, WarholCardA1L, WarholCardA2, WarholCardA2L, WarholCardA3, WarholCardA3L, WarholCardA4, WarholCardA4L, WarholCardA5, WarholCardA5L, WarholStyle2WithQrCard, WarholStyle2WithQrCardPrint };
//# sourceMappingURL=index.modern.js.map
import React$1, { useState, useRef, useEffect, useCallback, Fragment as Fragment$1, useMemo } from 'react';
import styled, { withTheme, css } from 'styled-components';
import emojiRegex from 'emoji-regex';
import { Colors, MEDIA } from '@brg/ui';
import { QRCodeSVG } from 'qrcode.react';
import { ErrorBoundary } from 'react-error-boundary';

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
function _taggedTemplateLiteralLoose(e, t) {
  return t || (t = e.slice(0)), e.raw = t, e;
}

var toUpperCaseString = function toUpperCaseString(_ref) {
  var str = _ref.str,
    sliceId = _ref.sliceId;
  return sliceId ? (str || '').substr(0, sliceId).toUpperCase() : (str || '').toUpperCase();
};

var calcFontSize = function calcFontSize(_ref) {
  var parentWidth = _ref.parentWidth,
    elementWidth = _ref.elementWidth,
    fontSize = _ref.fontSize,
    fontSizeMax = _ref.fontSizeMax,
    fontSizeMin = _ref.fontSizeMin;
  var k = elementWidth / fontSize;
  var newFontSize = parentWidth / k || 0;
  if (fontSizeMax < newFontSize) {
    return fontSizeMax;
  }
  if (fontSizeMin > newFontSize) {
    return fontSizeMin;
  }
  return newFontSize;
};

var AdaptiveText = function AdaptiveText(_ref) {
  var _elementRef$current;
  var text = _ref.text,
    style = _ref.style,
    _ref$fontSizeMax = _ref.fontSizeMax,
    fontSizeMax = _ref$fontSizeMax === void 0 ? 100 : _ref$fontSizeMax,
    _ref$fontSizeMin = _ref.fontSizeMin,
    fontSizeMin = _ref$fontSizeMin === void 0 ? 14 : _ref$fontSizeMin,
    setWidthsAndFontSize = _ref.setWidthsAndFontSize;
  var _useState = useState(fontSizeMax),
    fontSize = _useState[0],
    setFontSize = _useState[1];
  var elementRef = useRef(null);
  useEffect(function () {
    var onPaint = function onPaint() {
      if (elementRef.current) {
        var elementRect = elementRef.current;
        var parentRect = elementRef.current.parentElement;
        var parentWidth = parentRect.clientWidth;
        var elementWidth = elementRect.clientWidth;
        var newFontSize = calcFontSize({
          parentWidth: parentWidth,
          elementWidth: elementWidth,
          fontSize: fontSize,
          fontSizeMax: fontSizeMax,
          fontSizeMin: fontSizeMin,
          setWidthsAndFontSize: setWidthsAndFontSize
        });
        setFontSize(newFontSize);
        setWidthsAndFontSize === null || setWidthsAndFontSize === void 0 ? void 0 : setWidthsAndFontSize({
          parentWidth: parentWidth,
          elementWidth: elementWidth,
          newFontSize: newFontSize
        });
      }
    };
    var id = requestAnimationFrame(onPaint);
    return function () {
      return cancelAnimationFrame(id);
    };
  }, [text, (_elementRef$current = elementRef.current) === null || _elementRef$current === void 0 ? void 0 : _elementRef$current.clientWidth, setWidthsAndFontSize]);
  if (typeof text !== 'string') {
    console.warn("AdaptiveText: Prop 'text' is required");
    return null;
  }
  return /*#__PURE__*/React$1.createElement("span", {
    style: _extends({
      fontSize: fontSize,
      textWrap: 'nowrap'
    }, style),
    ref: elementRef
  }, text);
};

var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9;
var Wrapper = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 148.1mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 148)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 30px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock = styled.div(_templateObject2 || (_templateObject2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl = styled.div(_templateObject3 || (_templateObject3 = _taggedTemplateLiteralLoose(["\n  height: 6.8%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: 400;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock = styled.div(_templateObject4 || (_templateObject4 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner = styled.div(_templateObject5 || (_templateObject5 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock = styled.div(_templateObject6 || (_templateObject6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 23.8%;\n  width: 72%;\n  padding-bottom: 33px;\n"])));
var TextFirst = styled.div(_templateObject7 || (_templateObject7 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.3px;\n    margin-right: -2.3px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 27px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -18px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -18px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond = styled.div(_templateObject8 || (_templateObject8 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  width: 100%;\n  height: 47px;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  margin: 2px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 1px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -1;
});
var TextThird = styled.div(_templateObject9 || (_templateObject9 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 4.2px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.2px;\n"])));
var WarholCardA5L = function WarholCardA5L(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var _useState = useState(43),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock, null, /*#__PURE__*/React$1.createElement(TextUrl, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock, null, /*#__PURE__*/React$1.createElement(ImageInner, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock, null, /*#__PURE__*/React$1.createElement(TextFirst, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird, null, customSubtitle || url))));
};

var _templateObject$1, _templateObject2$1, _templateObject3$1, _templateObject4$1, _templateObject5$1, _templateObject6$1, _templateObject7$1, _templateObject8$1, _templateObject9$1;
var Wrapper$1 = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.wrapperWidth;
}, function (props) {
  return props.wrapperHeight;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.wrapperWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.wrapperHeight;
}, function (props) {
  return props.wrapperPadding;
});
var MainBlock$1 = styled.div(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$1 = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    font-style: normal;\n    font-weight: ", ";\n    padding-top: ", "px;\n  }\n"])), function (props) {
  return props.urlHeight;
}, function (props) {
  return props.urlFontSize;
}, function (props) {
  return props.urlLetterSpacing;
}, function (props) {
  return props.urlFontWeight;
}, function (props) {
  return props.urlPaddingTop;
});
var ImageBlock$1 = styled.div(_templateObject4$1 || (_templateObject4$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$1 = styled.div(_templateObject5$1 || (_templateObject5$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$1 = styled.div(_templateObject6$1 || (_templateObject6$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 90%;\n  padding-bottom: ", "px;\n"])), function (props) {
  return props.textBlockPaddingBottom;
});
var TextFirst$1 = styled.div(_templateObject7$1 || (_templateObject7$1 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: ", "px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: ", "px;\n    margin-right: -", "px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (props) {
  return props.numberFontSize;
}, function (props) {
  return props.numberLetterSpacing;
}, function (props) {
  return props.numberLetterSpacing;
}, function (props) {
  return props.dashWidth;
}, function (props) {
  return props.dashPosition;
}, function (props) {
  return props.dashPosition;
});
var TextSecond$1 = styled.div(_templateObject8$1 || (_templateObject8$1 = _taggedTemplateLiteralLoose(["\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  width: 100%;\n  height: ", "px;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  margin-bottom: 5px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  margin: ", ";\n  letter-spacing: ", "px;\n  margin-right: ", "px;\n"])), function (props) {
  return props.textSecondHeight;
}, function (props) {
  return props.textSecondMargin;
}, function (props) {
  return props.textSecondLetterSpacing;
}, function (props) {
  return props !== null && props !== void 0 && props.fullText ? 0 : -props.textSecondLetterSpacing;
});
var TextThird$1 = styled.div(_templateObject9$1 || (_templateObject9$1 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: ", "px;\n  font-style: normal;\n  font-weight: 400;\n"])), function (props) {
  return props.textThirdFontSize;
});
var WarholStylePortraitTemplate = function WarholStylePortraitTemplate(_ref) {
  var image = _ref.image,
    url = _ref.url,
    customSubtitle = _ref.customSubtitle,
    name = _ref.name,
    number = _ref.number,
    dw = _ref.dw,
    dh = _ref.dh,
    wrapperWidth = _ref.wrapperWidth,
    wrapperHeight = _ref.wrapperHeight,
    wrapperPadding = _ref.wrapperPadding,
    urlHeight = _ref.urlHeight,
    urlFontSize = _ref.urlFontSize,
    urlLetterSpacing = _ref.urlLetterSpacing,
    urlFontWeight = _ref.urlFontWeight,
    urlPaddingTop = _ref.urlPaddingTop,
    textBlockHeight = _ref.textBlockHeight,
    textBlockPaddingBottom = _ref.textBlockPaddingBottom,
    numberFontSize = _ref.numberFontSize,
    numberLetterSpacing = _ref.numberLetterSpacing,
    dashWidth = _ref.dashWidth,
    dashPosition = _ref.dashPosition,
    textSecondHeight = _ref.textSecondHeight,
    textSecondMargin = _ref.textSecondMargin,
    textSecondLetterSpacing = _ref.textSecondLetterSpacing,
    textThirdFontSize = _ref.textThirdFontSize,
    fontSizeMax = _ref.fontSizeMax;
  var initName = toUpperCaseString({
    str: name
  });
  return /*#__PURE__*/React$1.createElement(Wrapper$1, {
    dw: dw,
    dh: dh,
    wrapperWidth: wrapperWidth,
    wrapperHeight: wrapperHeight,
    wrapperPadding: wrapperPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$1, null, /*#__PURE__*/React$1.createElement(TextUrl$1, {
    urlHeight: urlHeight,
    urlFontSize: urlFontSize,
    urlLetterSpacing: urlLetterSpacing,
    urlFontWeight: urlFontWeight,
    urlPaddingTop: urlPaddingTop
  }, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$1, null, /*#__PURE__*/React$1.createElement(ImageInner$1, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$1, {
    textBlockHeight: textBlockHeight,
    textBlockPaddingBottom: textBlockPaddingBottom
  }, /*#__PURE__*/React$1.createElement(TextFirst$1, {
    numberFontSize: numberFontSize,
    numberLetterSpacing: numberLetterSpacing,
    dashWidth: dashWidth,
    dashPosition: dashPosition
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$1, {
    textSecondHeight: textSecondHeight,
    textSecondLetterSpacing: textSecondLetterSpacing,
    textSecondMargin: textSecondMargin
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontSizeMax,
    style: {
      lineHeight: 'normal'
    }
  })), /*#__PURE__*/React$1.createElement(TextThird$1, {
    textThirdFontSize: textThirdFontSize
  }, customSubtitle || url))));
};

var WarholCardA5 = function WarholCardA5(props) {
  return /*#__PURE__*/React$1.createElement(WarholStylePortraitTemplate, _extends({}, props, {
    wrapperWidth: 148,
    wrapperHeight: 210,
    wrapperPadding: 28,
    urlHeight: 5.8,
    urlFontSize: 5.8,
    urlLetterSpacing: 0.2,
    urlFontWeight: "bold",
    textBlockHeight: 17.6,
    textBlockPaddingBottom: 25,
    numberFontSize: 12,
    numberLetterSpacing: 3,
    dashWidth: 32,
    dashPosition: 22,
    textSecondHeight: 59,
    textSecondLetterSpacing: 2.2,
    textThirdFontSize: 5.5,
    fontSizeMax: 54.5
  }));
};

var _templateObject$2, _templateObject2$2, _templateObject3$2, _templateObject4$2, _templateObject5$2, _templateObject6$2, _templateObject7$2, _templateObject8$2, _templateObject9$2;
var Wrapper$2 = styled.div(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 40.4px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$2 = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$2 = styled.div(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 5px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$2 = styled.div(_templateObject4$2 || (_templateObject4$2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$2 = styled.div(_templateObject5$2 || (_templateObject5$2 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$2 = styled.div(_templateObject6$2 || (_templateObject6$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 23.9%;\n  width: 72%;\n  padding-bottom: 49px;\n"])));
var TextFirst$2 = styled.div(_templateObject7$2 || (_templateObject7$2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 14px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 3.4px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 38px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -25px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -25px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$2 = styled.div(_templateObject8$2 || (_templateObject8$2 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 60px;\n  text-align: center;\n  margin: 4.5px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2;
});
var TextThird$2 = styled.div(_templateObject9$2 || (_templateObject9$2 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 6px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.2px;\n"])));
var WarholCardA4L = function WarholCardA4L(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var _useState = useState(60),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$2, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$2, null, /*#__PURE__*/React$1.createElement(TextUrl$2, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$2, null, /*#__PURE__*/React$1.createElement(ImageInner$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$2, null, /*#__PURE__*/React$1.createElement(TextFirst$2, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$2, {
    fs: fontS,
    id: "text-second",
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$2, null, customSubtitle || url))));
};

var WarholCardA4 = function WarholCardA4(props) {
  return /*#__PURE__*/React$1.createElement(WarholStylePortraitTemplate, _extends({}, props, {
    wrapperWidth: 210,
    wrapperHeight: 297,
    wrapperPadding: 40.4,
    urlHeight: 5.905,
    urlFontSize: 5.4,
    urlLetterSpacing: 0.1,
    urlFontWeight: "400",
    textBlockHeight: 17.6,
    textBlockPaddingBottom: 34,
    numberFontSize: 18,
    numberLetterSpacing: 3.4,
    dashWidth: 46,
    dashPosition: 32,
    textSecondHeight: 80,
    textSecondLetterSpacing: 2,
    textThirdFontSize: 8,
    fontSizeMax: 78.5,
    urlPaddingTop: 5
  }));
};

var _templateObject$3, _templateObject2$3, _templateObject3$3, _templateObject4$3, _templateObject5$3, _templateObject6$3, _templateObject7$3, _templateObject8$3, _templateObject9$3;
var Wrapper$3 = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 297mm;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 59px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$3 = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$3 = styled.div(_templateObject3$3 || (_templateObject3$3 = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$3 = styled.div(_templateObject4$3 || (_templateObject4$3 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$3 = styled.div(_templateObject5$3 || (_templateObject5$3 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$3 = styled.div(_templateObject6$3 || (_templateObject6$3 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 70px;\n"])));
var TextFirst$3 = styled.div(_templateObject7$3 || (_templateObject7$3 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 20px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 4.2px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 53px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -36px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -36px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$3 = styled.div(_templateObject8$3 || (_templateObject8$3 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 85px;\n  text-align: center;\n  margin: 8px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2.2px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2.2;
});
var TextThird$3 = styled.div(_templateObject9$3 || (_templateObject9$3 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 8.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.3px;\n"])));
var WarholCardA3L = function WarholCardA3L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(85),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$3, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$3, null, /*#__PURE__*/React$1.createElement(TextUrl$3, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$3, null, /*#__PURE__*/React$1.createElement(ImageInner$3, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$3, null, /*#__PURE__*/React$1.createElement(TextFirst$3, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$3, {
    fs: fontS,
    id: "text-second",
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$3, null, customSubtitle || url))));
};

var WarholCardA3 = function WarholCardA3(props) {
  return /*#__PURE__*/React$1.createElement(WarholStylePortraitTemplate, _extends({}, props, {
    wrapperWidth: 297,
    wrapperHeight: 420,
    wrapperPadding: 57,
    urlHeight: 5.9,
    urlFontSize: 6.7,
    urlLetterSpacing: 0.3,
    urlFontWeight: "bold",
    textBlockPaddingBottom: 50,
    numberFontSize: 26,
    numberLetterSpacing: 3.6,
    dashWidth: 60,
    dashPosition: 35,
    textSecondHeight: 100,
    textSecondLetterSpacing: 3,
    textThirdFontSize: 10.5,
    fontSizeMax: 110
  }));
};

var _templateObject$4, _templateObject2$4, _templateObject3$4, _templateObject4$4, _templateObject5$4, _templateObject6$4, _templateObject7$4, _templateObject8$4, _templateObject9$4;
var Wrapper$4 = styled.div(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 420mm;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 82px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$4 = styled.div(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$4 = styled.div(_templateObject3$4 || (_templateObject3$4 = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.1px;\n    margin-top: 4px;\n  }\n"])));
var ImageBlock$4 = styled.div(_templateObject4$4 || (_templateObject4$4 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$4 = styled.div(_templateObject5$4 || (_templateObject5$4 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$4 = styled.div(_templateObject6$4 || (_templateObject6$4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24%;\n  width: 72%;\n  padding-bottom: 96.5px;\n"])));
var TextFirst$4 = styled.div(_templateObject7$4 || (_templateObject7$4 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 30px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 5.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 75px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -48px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -48px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$4 = styled.div(_templateObject8$4 || (_templateObject8$4 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 105px;\n  text-align: center;\n  margin: 18px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2.5px;\n"])));
var TextThird$4 = styled.div(_templateObject9$4 || (_templateObject9$4 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 12px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.4px;\n"])));
var WarholCardA2L = function WarholCardA2L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(121),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$4, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$4, null, /*#__PURE__*/React$1.createElement(TextUrl$4, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$4, null, /*#__PURE__*/React$1.createElement(ImageInner$4, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$4, null, /*#__PURE__*/React$1.createElement(TextFirst$4, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$4, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$4, null, customSubtitle || url))));
};

var WarholCardA2 = function WarholCardA2(props) {
  return /*#__PURE__*/React$1.createElement(WarholStylePortraitTemplate, _extends({}, props, {
    wrapperWidth: 420,
    wrapperHeight: 594,
    wrapperPadding: 80,
    urlHeight: 5.9,
    urlFontSize: 12,
    urlLetterSpacing: 0.1,
    urlFontWeight: "bold",
    textBlockPaddingBottom: 71,
    numberFontSize: 35,
    numberLetterSpacing: 7.5,
    dashWidth: 93,
    dashPosition: 60,
    textSecondHeight: 160,
    textSecondLetterSpacing: 4.5,
    textThirdFontSize: 15.5,
    fontSizeMax: 155
  }));
};

var _templateObject$5, _templateObject2$5, _templateObject3$5, _templateObject4$5, _templateObject5$5, _templateObject6$5, _templateObject7$5, _templateObject8$5, _templateObject9$5;
var Wrapper$5 = styled.div(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 594mm;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 118px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$5 = styled.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$5 = styled.div(_templateObject3$5 || (_templateObject3$5 = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.6px;\n    margin-right: 2px;\n  }\n"])));
var ImageBlock$5 = styled.div(_templateObject4$5 || (_templateObject4$5 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$5 = styled.div(_templateObject5$5 || (_templateObject5$5 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$5 = styled.div(_templateObject6$5 || (_templateObject6$5 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24%;\n  width: 72%;\n  padding-bottom: 137px;\n"])));
var TextFirst$5 = styled.div(_templateObject7$5 || (_templateObject7$5 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 8.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 108px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -72px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -72px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$5 = styled.div(_templateObject8$5 || (_templateObject8$5 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 150px;\n  text-align: center;\n  margin: 24px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 4.5px;\n"])));
var TextThird$5 = styled.div(_templateObject9$5 || (_templateObject9$5 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 17px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n"])));
var WarholCardA1L = function WarholCardA1L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(170),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$5, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$5, null, /*#__PURE__*/React$1.createElement(TextUrl$5, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$5, null, /*#__PURE__*/React$1.createElement(ImageInner$5, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$5, null, /*#__PURE__*/React$1.createElement(TextFirst$5, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$5, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$5, null, customSubtitle || url))));
};

var WarholCardA1 = function WarholCardA1(props) {
  return /*#__PURE__*/React$1.createElement(WarholStylePortraitTemplate, _extends({}, props, {
    wrapperWidth: 594,
    wrapperHeight: 841,
    wrapperPadding: 115,
    urlHeight: 5.9,
    urlFontSize: 16,
    urlLetterSpacing: 0.6,
    urlFontWeight: "bold",
    textBlockPaddingBottom: 100,
    numberFontSize: 50,
    numberLetterSpacing: 10.5,
    dashWidth: 132,
    dashPosition: 84,
    textSecondHeight: 200,
    textSecondLetterSpacing: 5.5,
    textThirdFontSize: 22,
    fontSizeMax: 220
  }));
};

var _templateObject$6, _templateObject2$6, _templateObject3$6, _templateObject4$6, _templateObject5$6, _templateObject6$6, _templateObject7$6, _templateObject8$6, _templateObject9$6;
var Wrapper$6 = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteralLoose(["\n  width: 1189mm;\n  height: 841mm;\n  transform: scale(\n    calc(", " / 1189),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 163px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$6 = styled.div(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$6 = styled.div(_templateObject3$6 || (_templateObject3$6 = _taggedTemplateLiteralLoose(["\n  height: 6.91%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 1px;\n  }\n"])));
var ImageBlock$6 = styled.div(_templateObject4$6 || (_templateObject4$6 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$6 = styled.div(_templateObject5$6 || (_templateObject5$6 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$6 = styled.div(_templateObject6$6 || (_templateObject6$6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24%;\n  width: 72%;\n  padding-bottom: 195px;\n"])));
var TextFirst$6 = styled.div(_templateObject7$6 || (_templateObject7$6 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 60px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 10px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 150px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -100px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -100px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$6 = styled.div(_templateObject8$6 || (_templateObject8$6 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 240px;\n  text-align: center;\n  margin: 24px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 6px;\n"])));
var TextThird$6 = styled.div(_templateObject9$6 || (_templateObject9$6 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 24px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.7px;\n"])));
var WarholCardA0L = function WarholCardA0L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(240),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  return /*#__PURE__*/React$1.createElement(Wrapper$6, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$6, null, /*#__PURE__*/React$1.createElement(TextUrl$6, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$6, null, /*#__PURE__*/React$1.createElement(ImageInner$6, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$6, null, /*#__PURE__*/React$1.createElement(TextFirst$6, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$6, {
    fs: fontS
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$6, null, customSubtitle || url))));
};

var WarholCardA0 = function WarholCardA0(props) {
  return /*#__PURE__*/React$1.createElement(WarholStylePortraitTemplate, _extends({}, props, {
    wrapperWidth: 841,
    wrapperHeight: 1189,
    wrapperPadding: 168,
    urlHeight: 5.9,
    urlFontSize: 24,
    urlFontWeight: "bold",
    textBlockPaddingBottom: 138,
    numberFontSize: 70,
    numberLetterSpacing: 15,
    dashWidth: 184,
    dashPosition: 124,
    textSecondHeight: 300,
    textSecondLetterSpacing: 9,
    textThirdFontSize: 30.5,
    fontSizeMax: 310
  }));
};

var _templateObject$7, _templateObject2$7, _templateObject3$7, _templateObject4$7, _templateObject5$7, _templateObject6$7, _templateObject7$7, _templateObject8$7, _templateObject9$7;
var Wrapper$7 = styled.div(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 148.1mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 148)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 30px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$7 = styled.div(_templateObject2$7 || (_templateObject2$7 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$7 = styled.div(_templateObject3$7 || (_templateObject3$7 = _taggedTemplateLiteralLoose(["\n  height: 7%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: 400;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$7 = styled.div(_templateObject4$7 || (_templateObject4$7 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$7 = styled.div(_templateObject5$7 || (_templateObject5$7 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$7 = styled.div(_templateObject6$7 || (_templateObject6$7 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 23.6%;\n  width: 72%;\n  padding-bottom: 23px;\n"])));
var TextFirst$7 = styled.div(_templateObject7$7 || (_templateObject7$7 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.3px;\n    margin-right: -2.3px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 30px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -18px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -18px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$7 = styled.div(_templateObject8$7 || (_templateObject8$7 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  width: 100%;\n  height: 40px;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  margin: 7px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 1px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -1;
});
var TextThird$7 = styled.div(_templateObject9$7 || (_templateObject9$7 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 5.5px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard2A5L = function WarholCard2A5L(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var _useState = useState(32.9),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$7, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$7, null, /*#__PURE__*/React$1.createElement(TextUrl$7, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$7, null, /*#__PURE__*/React$1.createElement(ImageInner$7, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$7, null, /*#__PURE__*/React$1.createElement(TextFirst$7, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$7, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$7, null, customSubtitle || url))));
};

var _templateObject$8, _templateObject2$8, _templateObject3$8, _templateObject4$8, _templateObject5$8, _templateObject6$8, _templateObject7$8, _templateObject8$8, _templateObject9$8;
var Wrapper$8 = styled.div(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteralLoose(["\n  width: 148.1mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 148),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 28.5px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$8 = styled.div(_templateObject2$8 || (_templateObject2$8 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$8 = styled.div(_templateObject3$8 || (_templateObject3$8 = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 4px;\n    margin: 4px 2px 0 0;\n  }\n"])));
var ImageBlock$8 = styled.div(_templateObject4$8 || (_templateObject4$8 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$8 = styled.div(_templateObject5$8 || (_templateObject5$8 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$8 = styled.div(_templateObject6$8 || (_templateObject6$8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 88%;\n  padding-bottom: 26px;\n"])));
var TextFirst$8 = styled.div(_templateObject7$8 || (_templateObject7$8 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.3px;\n    margin-right: -2.3px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 30px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -18px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -18px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$8 = styled.div(_templateObject8$8 || (_templateObject8$8 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  width: 100%;\n  height: 40px;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  margin: 7px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -1.5;
});
var TextThird$8 = styled.div(_templateObject9$8 || (_templateObject9$8 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 5.5px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard2A5 = function WarholCard2A5(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var _useState = useState(32),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  return /*#__PURE__*/React$1.createElement(Wrapper$8, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$8, null, /*#__PURE__*/React$1.createElement(TextUrl$8, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$8, null, /*#__PURE__*/React$1.createElement(ImageInner$8, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$8, null, /*#__PURE__*/React$1.createElement(TextFirst$8, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$8, {
    fs: fontS,
    id: "text-second"
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$8, null, customSubtitle || url))));
};

var _templateObject$9, _templateObject2$9, _templateObject3$9, _templateObject4$9, _templateObject5$9, _templateObject6$9, _templateObject7$9, _templateObject8$9, _templateObject9$9;
var Wrapper$9 = styled.div(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 41px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$9 = styled.div(_templateObject2$9 || (_templateObject2$9 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$9 = styled.div(_templateObject3$9 || (_templateObject3$9 = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 5px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$9 = styled.div(_templateObject4$9 || (_templateObject4$9 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$9 = styled.div(_templateObject5$9 || (_templateObject5$9 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$9 = styled.div(_templateObject6$9 || (_templateObject6$9 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 23.9%;\n  width: 72%;\n  padding-bottom: 34px;\n"])));
var TextFirst$9 = styled.div(_templateObject7$9 || (_templateObject7$9 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 17px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 3.4px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 43px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -25px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -25px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$9 = styled.div(_templateObject8$9 || (_templateObject8$9 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 50px;\n  text-align: center;\n  margin: 14.5px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2;
});
var TextThird$9 = styled.div(_templateObject9$9 || (_templateObject9$9 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard2A4L = function WarholCard2A4L(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var _useState = useState(45),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$9, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$9, null, /*#__PURE__*/React$1.createElement(TextUrl$9, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$9, null, /*#__PURE__*/React$1.createElement(ImageInner$9, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$9, null, /*#__PURE__*/React$1.createElement(TextFirst$9, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$9, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$9, null, customSubtitle || url))));
};

var _templateObject$a, _templateObject2$a, _templateObject3$a, _templateObject4$a, _templateObject5$a, _templateObject6$a, _templateObject7$a, _templateObject8$a, _templateObject9$a;
var Wrapper$a = styled.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 40.4px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$a = styled.div(_templateObject2$a || (_templateObject2$a = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$a = styled.div(_templateObject3$a || (_templateObject3$a = _taggedTemplateLiteralLoose(["\n  height: 5.905%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.7px;\n    line-height: 4px;\n    margin: 5px 3px 0 0;\n  }\n"])));
var ImageBlock$a = styled.div(_templateObject4$a || (_templateObject4$a = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$a = styled.div(_templateObject5$a || (_templateObject5$a = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$a = styled.div(_templateObject6$a || (_templateObject6$a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 87.9%;\n  padding-bottom: 34.5px;\n"])));
var TextFirst$a = styled.div(_templateObject7$a || (_templateObject7$a = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.79px;\n    margin-right: -2.79px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 42px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -25px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -25px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$a = styled.div(_templateObject8$a || (_templateObject8$a = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 50px;\n  text-align: center;\n  margin: 13.7px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2;
});
var TextThird$a = styled.div(_templateObject9$a || (_templateObject9$a = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard2A4 = function WarholCard2A4(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var _useState = useState(45),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$a, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$a, null, /*#__PURE__*/React$1.createElement(TextUrl$a, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$a, null, /*#__PURE__*/React$1.createElement(ImageInner$a, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$a, null, /*#__PURE__*/React$1.createElement(TextFirst$a, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$a, {
    fs: fontS,
    id: "text-second",
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$a, null, customSubtitle || url))));
};

var _templateObject$b, _templateObject2$b, _templateObject3$b, _templateObject4$b, _templateObject5$b, _templateObject6$b, _templateObject7$b, _templateObject8$b, _templateObject9$b;
var Wrapper$b = styled.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 297mm;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 59px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$b = styled.div(_templateObject2$b || (_templateObject2$b = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$b = styled.div(_templateObject3$b || (_templateObject3$b = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 5px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$b = styled.div(_templateObject4$b || (_templateObject4$b = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$b = styled.div(_templateObject5$b || (_templateObject5$b = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$b = styled.div(_templateObject6$b || (_templateObject6$b = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 50px;\n"])));
var TextFirst$b = styled.div(_templateObject7$b || (_templateObject7$b = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 24px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 4.7px;\n    margin-right: -4.7px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 60px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -35px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -35px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$b = styled.div(_templateObject8$b || (_templateObject8$b = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 75px;\n  text-align: center;\n  margin: 20px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 1.8px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -1.8;
});
var TextThird$b = styled.div(_templateObject9$b || (_templateObject9$b = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.4px;\n"])));
var WarholCard2A3L = function WarholCard2A3L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(64.7),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$b, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$b, null, /*#__PURE__*/React$1.createElement(TextUrl$b, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$b, null, /*#__PURE__*/React$1.createElement(ImageInner$b, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$b, null, /*#__PURE__*/React$1.createElement(TextFirst$b, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$b, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$b, null, customSubtitle || url))));
};

var _templateObject$c, _templateObject2$c, _templateObject3$c, _templateObject4$c, _templateObject5$c, _templateObject6$c, _templateObject7$c, _templateObject8$c, _templateObject9$c;
var Wrapper$c = styled.div(_templateObject$c || (_templateObject$c = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 420mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 57px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$c = styled.div(_templateObject2$c || (_templateObject2$c = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$c = styled.div(_templateObject3$c || (_templateObject3$c = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 6.7px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 8px;\n  }\n"])));
var ImageBlock$c = styled.div(_templateObject4$c || (_templateObject4$c = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$c = styled.div(_templateObject5$c || (_templateObject5$c = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$c = styled.div(_templateObject6$c || (_templateObject6$c = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 88%;\n  padding-bottom: 51px;\n"])));
var TextFirst$c = styled.div(_templateObject7$c || (_templateObject7$c = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 26px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 3.6px;\n    margin-right: -3.6px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 60px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -35px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -35px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$c = styled.div(_templateObject8$c || (_templateObject8$c = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 75px;\n  text-align: center;\n  margin: 18px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2;
});
var TextThird$c = styled.div(_templateObject9$c || (_templateObject9$c = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 10.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.3px;\n"])));
var WarholCard2A3 = function WarholCard2A3(props) {
  var image = props.image,
    url = props.url,
    name = props.name,
    customSubtitle = props.customSubtitle,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(64),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$c, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$c, null, /*#__PURE__*/React$1.createElement(TextUrl$c, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$c, null, /*#__PURE__*/React$1.createElement(ImageInner$c, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$c, null, /*#__PURE__*/React$1.createElement(TextFirst$c, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$c, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$c, null, customSubtitle || url))));
};

var _templateObject$d, _templateObject2$d, _templateObject3$d, _templateObject4$d, _templateObject5$d, _templateObject6$d, _templateObject7$d, _templateObject8$d, _templateObject9$d;
var Wrapper$d = styled.div(_templateObject$d || (_templateObject$d = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 420mm;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 83px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$d = styled.div(_templateObject2$d || (_templateObject2$d = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$d = styled.div(_templateObject3$d || (_templateObject3$d = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.1px;\n    margin-top: 4px;\n  }\n"])));
var ImageBlock$d = styled.div(_templateObject4$d || (_templateObject4$d = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$d = styled.div(_templateObject5$d || (_templateObject5$d = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$d = styled.div(_templateObject6$d || (_templateObject6$d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 72.5px;\n"])));
var TextFirst$d = styled.div(_templateObject7$d || (_templateObject7$d = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 34px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 6.5px;\n    margin-right: -6.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 85px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -53px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -53px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$d = styled.div(_templateObject8$d || (_templateObject8$d = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 105px;\n  text-align: center;\n  margin: 23px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2.5px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2.5;
});
var TextThird$d = styled.div(_templateObject9$d || (_templateObject9$d = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 15px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.4px;\n"])));
var WarholCard2A2L = function WarholCard2A2L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(91),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$d, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$d, null, /*#__PURE__*/React$1.createElement(TextUrl$d, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$d, null, /*#__PURE__*/React$1.createElement(ImageInner$d, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$d, null, /*#__PURE__*/React$1.createElement(TextFirst$d, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$d, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$d, null, customSubtitle || url))));
};

var _templateObject$e, _templateObject2$e, _templateObject3$e, _templateObject4$e, _templateObject5$e, _templateObject6$e, _templateObject7$e, _templateObject8$e, _templateObject9$e;
var Wrapper$e = styled.div(_templateObject$e || (_templateObject$e = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 594mm;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 83px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$e = styled.div(_templateObject2$e || (_templateObject2$e = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$e = styled.div(_templateObject3$e || (_templateObject3$e = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.1px;\n    margin-top: 10px;\n  }\n"])));
var ImageBlock$e = styled.div(_templateObject4$e || (_templateObject4$e = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$e = styled.div(_templateObject5$e || (_templateObject5$e = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$e = styled.div(_templateObject6$e || (_templateObject6$e = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.7%;\n  width: 88%;\n  padding-bottom: 71px;\n"])));
var TextFirst$e = styled.div(_templateObject7$e || (_templateObject7$e = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 34px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 6.5px;\n    margin-right: -6.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 86px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -53px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -53px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$e = styled.div(_templateObject8$e || (_templateObject8$e = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 105px;\n  text-align: center;\n  margin: 23px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2.5px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -2.5;
});
var TextThird$e = styled.div(_templateObject9$e || (_templateObject9$e = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 15.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n"])));
var WarholCard2A2 = function WarholCard2A2(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(91.5),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$e, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$e, null, /*#__PURE__*/React$1.createElement(TextUrl$e, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$e, null, /*#__PURE__*/React$1.createElement(ImageInner$e, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$e, null, /*#__PURE__*/React$1.createElement(TextFirst$e, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$e, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$e, null, customSubtitle || url))));
};

var _templateObject$f, _templateObject2$f, _templateObject3$f, _templateObject4$f, _templateObject5$f, _templateObject6$f, _templateObject7$f, _templateObject8$f, _templateObject9$f;
var Wrapper$f = styled.div(_templateObject$f || (_templateObject$f = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 594mm;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 118px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$f = styled.div(_templateObject2$f || (_templateObject2$f = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$f = styled.div(_templateObject3$f || (_templateObject3$f = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.6px;\n    margin-right: 2px;\n  }\n"])));
var ImageBlock$f = styled.div(_templateObject4$f || (_templateObject4$f = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$f = styled.div(_templateObject5$f || (_templateObject5$f = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$f = styled.div(_templateObject6$f || (_templateObject6$f = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 100px;\n"])));
var TextFirst$f = styled.div(_templateObject7$f || (_templateObject7$f = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 50px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 8.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 123px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -75px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -75px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$f = styled.div(_templateObject8$f || (_templateObject8$f = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 150px;\n  text-align: center;\n  margin: 34px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 4.5px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -4.5;
});
var TextThird$f = styled.div(_templateObject9$f || (_templateObject9$f = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.5px;\n"])));
var WarholCard2A1L = function WarholCard2A1L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(129),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$f, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$f, null, /*#__PURE__*/React$1.createElement(TextUrl$f, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$f, null, /*#__PURE__*/React$1.createElement(ImageInner$f, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$f, null, /*#__PURE__*/React$1.createElement(TextFirst$f, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$f, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$f, null, customSubtitle || url))));
};

var _templateObject$g, _templateObject2$g, _templateObject3$g, _templateObject4$g, _templateObject5$g, _templateObject6$g, _templateObject7$g, _templateObject8$g, _templateObject9$g;
var Wrapper$g = styled.div(_templateObject$g || (_templateObject$g = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 841mm;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 83px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$g = styled.div(_templateObject2$g || (_templateObject2$g = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$g = styled.div(_templateObject3$g || (_templateObject3$g = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.6px;\n    margin-top: 10px;\n  }\n"])));
var ImageBlock$g = styled.div(_templateObject4$g || (_templateObject4$g = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$g = styled.div(_templateObject5$g || (_templateObject5$g = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$g = styled.div(_templateObject6$g || (_templateObject6$g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 88%;\n  padding-bottom: 104px;\n"])));
var TextFirst$g = styled.div(_templateObject7$g || (_templateObject7$g = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 50px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 8.5px;\n    margin-right: -8.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 123px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -75px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -75px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$g = styled.div(_templateObject8$g || (_templateObject8$g = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 150px;\n  text-align: center;\n  margin: 35px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 2.5px;\n"])));
var TextThird$g = styled.div(_templateObject9$g || (_templateObject9$g = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n"])));
var WarholCard2A1 = function WarholCard2A1(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(129),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$g, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$g, null, /*#__PURE__*/React$1.createElement(TextUrl$g, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$g, null, /*#__PURE__*/React$1.createElement(ImageInner$g, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$g, null, /*#__PURE__*/React$1.createElement(TextFirst$g, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$g, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$g, null, customSubtitle || url))));
};

var _templateObject$h, _templateObject2$h, _templateObject3$h, _templateObject4$h, _templateObject5$h, _templateObject6$h, _templateObject7$h, _templateObject8$h, _templateObject9$h;
var Wrapper$h = styled.div(_templateObject$h || (_templateObject$h = _taggedTemplateLiteralLoose(["\n  width: 1189mm;\n  height: 841mm;\n  transform: scale(\n    calc(", " / 1189),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 163px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$h = styled.div(_templateObject2$h || (_templateObject2$h = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$h = styled.div(_templateObject3$h || (_templateObject3$h = _taggedTemplateLiteralLoose(["\n  height: 6.91%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 1px;\n  }\n"])));
var ImageBlock$h = styled.div(_templateObject4$h || (_templateObject4$h = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$h = styled.div(_templateObject5$h || (_templateObject5$h = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$h = styled.div(_templateObject6$h || (_templateObject6$h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 146px;\n"])));
var TextFirst$h = styled.div(_templateObject7$h || (_templateObject7$h = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 70px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 12.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 172px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -100px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -100px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$h = styled.div(_templateObject8$h || (_templateObject8$h = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 210px;\n  text-align: center;\n  margin: 48px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 6.5px;\n"])));
var TextThird$h = styled.div(_templateObject9$h || (_templateObject9$h = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 30.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 1px;\n"])));
var WarholCard2A0L = function WarholCard2A0L(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(181),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$h, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$h, null, /*#__PURE__*/React$1.createElement(TextUrl$h, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$h, null, /*#__PURE__*/React$1.createElement(ImageInner$h, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$h, null, /*#__PURE__*/React$1.createElement(TextFirst$h, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$h, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$h, null, customSubtitle || url))));
};

var _templateObject$i, _templateObject2$i, _templateObject3$i, _templateObject4$i, _templateObject5$i, _templateObject6$i, _templateObject7$i, _templateObject8$i, _templateObject9$i;
var Wrapper$i = styled.div(_templateObject$i || (_templateObject$i = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 1189mm;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 1189)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 168px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$i = styled.div(_templateObject2$i || (_templateObject2$i = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$i = styled.div(_templateObject3$i || (_templateObject3$i = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: bold;\n    margin-top: 20px;\n  }\n"])));
var ImageBlock$i = styled.div(_templateObject4$i || (_templateObject4$i = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$i = styled.div(_templateObject5$i || (_templateObject5$i = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$i = styled.div(_templateObject6$i || (_templateObject6$i = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.7%;\n  width: 88%;\n  padding-bottom: 138px;\n"])));
var TextFirst$i = styled.div(_templateObject7$i || (_templateObject7$i = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 70px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 12.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 172px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -100px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -100px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$i = styled.div(_templateObject8$i || (_templateObject8$i = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 210px;\n  text-align: center;\n  margin: 48px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 6.5px;\n"])));
var TextThird$i = styled.div(_templateObject9$i || (_templateObject9$i = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 30.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.4px;\n"])));
var WarholCard2A0 = function WarholCard2A0(props) {
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(180),
    fontS = _useState[0];
  var initName = toUpperCaseString({
    str: name
  });
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$i, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$i, null, /*#__PURE__*/React$1.createElement(TextUrl$i, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$i, null, /*#__PURE__*/React$1.createElement(ImageInner$i, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$i, null, /*#__PURE__*/React$1.createElement(TextFirst$i, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$i, {
    fs: fontS,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: fontS
  })), /*#__PURE__*/React$1.createElement(TextThird$i, null, customSubtitle || url))));
};

var debounce = function debounce(func, delay) {
  var timeout;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      return func.apply(void 0, args);
    }, delay);
  };
};
var TextWithDynamicLetterSpacing = function TextWithDynamicLetterSpacing(_ref) {
  var text = _ref.text,
    defaultLetterSpacing = _ref.defaultLetterSpacing,
    fontSize = _ref.fontSize;
  var textBlockRef = useRef(null);
  var _useState = useState(defaultLetterSpacing),
    letterSpacing = _useState[0],
    setLetterSpacing = _useState[1];
  var _useState2 = useState(fontSize),
    newFontSize = _useState2[0],
    setNewFontSize = _useState2[1];
  var lastLetterSpacing = useRef(defaultLetterSpacing);
  var lastFontSize = useRef(fontSize);
  var updateLetterSpacing = useCallback(function () {
    if (!textBlockRef.current) return;
    var parentWidth = textBlockRef.current.parentElement.clientWidth;
    var elementWidth = textBlockRef.current.clientWidth;
    if (elementWidth === parentWidth) return;
    var newLetterSpacing = lastLetterSpacing.current - (elementWidth + fontSize - parentWidth - defaultLetterSpacing) / text.length;
    if (newLetterSpacing <= 0) {
      var calculatedFontSize = calcFontSize({
        parentWidth: parentWidth,
        elementWidth: elementWidth,
        fontSize: lastFontSize.current,
        fontSizeMax: fontSize,
        fontSizeMin: 10
      });
      if (calculatedFontSize !== lastFontSize.current) {
        lastFontSize.current = calculatedFontSize;
        setNewFontSize(calculatedFontSize);
      }
      return;
    }
    if (newLetterSpacing !== lastLetterSpacing.current) {
      lastLetterSpacing.current = Math.max(0, Math.min(defaultLetterSpacing, newLetterSpacing));
      setLetterSpacing(lastLetterSpacing.current);
    }
  }, [fontSize, defaultLetterSpacing, text.length]);
  useEffect(function () {
    if (!textBlockRef.current) return;
    var debouncedUpdate = debounce(updateLetterSpacing, 50);
    debouncedUpdate();
    var id = requestAnimationFrame(updateLetterSpacing);
    return function () {
      return cancelAnimationFrame(id);
    };
  }, [updateLetterSpacing, text]);
  var isFullText = defaultLetterSpacing > letterSpacing;
  var textStyle = {
    letterSpacing: letterSpacing,
    fontSize: newFontSize,
    textIndent: isFullText ? 0 : letterSpacing,
    whiteSpace: 'nowrap'
  };
  return /*#__PURE__*/React$1.createElement("span", {
    ref: textBlockRef,
    style: textStyle
  }, text);
};

var useContainerWidth = function useContainerWidth(props) {
  var mainTextRef = props.mainTextRef,
    name = props.name,
    useTextSecont = props.useTextSecont,
    flag = props.flag;
  var _useState = useState(0),
    w = _useState[0],
    setW = _useState[1];
  var width = mainTextRef && mainTextRef.current && mainTextRef.current.offsetWidth;
  useEffect(function () {
    if (useTextSecont) {
      return;
    }
    if (mainTextRef.current && name && width) {
      setW(width);
    }
  }, [name, width]);
  useEffect(function () {
    if (!useTextSecont) {
      return;
    }
    var Width = document.getElementById('text-second').offsetWidth;
    if (Width !== null && Width !== undefined && Width !== 0) {
      setW(Width);
    }
  }, [w, name, flag]);
  return {
    w: w
  };
};

var _templateObject$j, _templateObject2$j, _templateObject3$j, _templateObject4$j, _templateObject5$j, _templateObject6$j, _templateObject7$j, _templateObject8$j, _templateObject9$j;
var Wrapper$j = styled.div(_templateObject$j || (_templateObject$j = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 148.1mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 148)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 30px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$j = styled.div(_templateObject2$j || (_templateObject2$j = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$j = styled.div(_templateObject3$j || (_templateObject3$j = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: 400;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$j = styled.div(_templateObject4$j || (_templateObject4$j = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$j = styled.div(_templateObject5$j || (_templateObject5$j = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$j = styled.div(_templateObject6$j || (_templateObject6$j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 18.45%;\n  width: 72%;\n  margin-bottom: 28px;\n"])));
var TextFirst$j = styled.div(_templateObject7$j || (_templateObject7$j = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 7px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 1.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 18px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -10px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -10px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$j = styled.div(_templateObject8$j || (_templateObject8$j = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 110%;\n  height: 16px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 16.5px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$j = styled.div(_templateObject9$j || (_templateObject9$j = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 5.5px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard3A5L = function WarholCard3A5L(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    _props$name = props.name,
    name = _props$name === void 0 ? '' : _props$name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$j, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$j, null, /*#__PURE__*/React$1.createElement(TextUrl$j, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$j, null, /*#__PURE__*/React$1.createElement(ImageInner$j, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$j, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$j, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$j, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 11.5,
    fontSize: 13
  })), /*#__PURE__*/React$1.createElement(TextThird$j, null, customSubtitle || url))));
};

var _templateObject$k, _templateObject2$k, _templateObject3$k, _templateObject4$k, _templateObject5$k, _templateObject6$k, _templateObject7$k, _templateObject8$k, _templateObject9$k;
var Wrapper$k = styled.div(_templateObject$k || (_templateObject$k = _taggedTemplateLiteralLoose(["\n  width: 148.3mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 148),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 28.5px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$k = styled.div(_templateObject2$k || (_templateObject2$k = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$k = styled.div(_templateObject3$k || (_templateObject3$k = _taggedTemplateLiteralLoose(["\n  height: 5.85%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 4px;\n    margin: 4px 2px 0 0;\n  }\n"])));
var ImageBlock$k = styled.div(_templateObject4$k || (_templateObject4$k = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$k = styled.div(_templateObject5$k || (_templateObject5$k = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$k = styled.div(_templateObject6$k || (_templateObject6$k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 90%;\n  padding-bottom: 35px;\n"])));
var TextFirst$k = styled.div(_templateObject7$k || (_templateObject7$k = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 8px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 1px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 18px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -10px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -10px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$k = styled.div(_templateObject8$k || (_templateObject8$k = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 110%;\n  height: 32px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 8px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$k = styled.div(_templateObject9$k || (_templateObject9$k = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 5.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.02px;\n"])));
var WarholCard3A5 = function WarholCard3A5(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    _props$name = props.name,
    name = _props$name === void 0 ? '' : _props$name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$k, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$k, null, /*#__PURE__*/React$1.createElement(TextUrl$k, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$k, null, /*#__PURE__*/React$1.createElement(ImageInner$k, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$k, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$k, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$k, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 11.5,
    fontSize: 13
  })), /*#__PURE__*/React$1.createElement(TextThird$k, null, customSubtitle || url))));
};

var _templateObject$l, _templateObject2$l, _templateObject3$l, _templateObject4$l, _templateObject5$l, _templateObject6$l, _templateObject7$l, _templateObject8$l, _templateObject9$l;
var Wrapper$l = styled.div(_templateObject$l || (_templateObject$l = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 40.3px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$l = styled.div(_templateObject2$l || (_templateObject2$l = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$l = styled.div(_templateObject3$l || (_templateObject3$l = _taggedTemplateLiteralLoose(["\n  height: 6.85%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 5px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 4px;\n  }\n"])));
var ImageBlock$l = styled.div(_templateObject4$l || (_templateObject4$l = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$l = styled.div(_templateObject5$l || (_templateObject5$l = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$l = styled.div(_templateObject6$l || (_templateObject6$l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 42px;\n"])));
var TextFirst$l = styled.div(_templateObject7$l || (_templateObject7$l = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.1px;\n    text-indent: 2.1px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 25.8px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -16px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -16px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$l = styled.div(_templateObject8$l || (_templateObject8$l = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 32px;\n  text-align: center;\n  margin: 18.3px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$l = styled.div(_templateObject9$l || (_templateObject9$l = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard3A4L = function WarholCard3A4L(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var fullText = name.length > 23;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$l, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$l, null, /*#__PURE__*/React$1.createElement(TextUrl$l, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$l, null, /*#__PURE__*/React$1.createElement(ImageInner$l, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$l, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$l, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$l, {
    ref: mainTextRef,
    fullText: fullText
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 16.3,
    fontSize: 19
  })), /*#__PURE__*/React$1.createElement(TextThird$l, null, customSubtitle || url))));
};

var _templateObject$m, _templateObject2$m, _templateObject3$m, _templateObject4$m, _templateObject5$m, _templateObject6$m, _templateObject7$m, _templateObject8$m, _templateObject9$m;
var Wrapper$m = styled.div(_templateObject$m || (_templateObject$m = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 40.3px;\n\n  * {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$m = styled.div(_templateObject2$m || (_templateObject2$m = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$m = styled.div(_templateObject3$m || (_templateObject3$m = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.7px;\n    line-height: 4px;\n    margin: 5px 3px 0 0;\n  }\n"])));
var ImageBlock$m = styled.div(_templateObject4$m || (_templateObject4$m = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$m = styled.div(_templateObject5$m || (_templateObject5$m = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$m = styled.div(_templateObject6$m || (_templateObject6$m = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 90%;\n  padding-bottom: 48px;\n"])));
var TextFirst$m = styled.div(_templateObject7$m || (_templateObject7$m = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 9.4px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.2px;\n    margin-right: -2.2px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 25.8px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -18px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -18px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$m = styled.div(_templateObject8$m || (_templateObject8$m = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 32px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 17.8px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$m = styled.div(_templateObject9$m || (_templateObject9$m = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 8px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard3A4 = function WarholCard3A4(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    _props$name = props.name,
    name = _props$name === void 0 ? '' : _props$name,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$m, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$m, null, /*#__PURE__*/React$1.createElement(TextUrl$m, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$m, null, /*#__PURE__*/React$1.createElement(ImageInner$m, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$m, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$m, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$m, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 16.3,
    fontSize: 19
  })), /*#__PURE__*/React$1.createElement(TextThird$m, null, customSubtitle || url))));
};

var _templateObject$n, _templateObject2$n, _templateObject3$n, _templateObject4$n, _templateObject5$n, _templateObject6$n, _templateObject7$n, _templateObject8$n, _templateObject9$n;
var Wrapper$n = styled.div(_templateObject$n || (_templateObject$n = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 297mm;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 59px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$n = styled.div(_templateObject2$n || (_templateObject2$n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$n = styled.div(_templateObject3$n || (_templateObject3$n = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 6.7px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n  }\n"])));
var ImageBlock$n = styled.div(_templateObject4$n || (_templateObject4$n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$n = styled.div(_templateObject5$n || (_templateObject5$n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$n = styled.div(_templateObject6$n || (_templateObject6$n = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 61px;\n"])));
var TextFirst$n = styled.div(_templateObject7$n || (_templateObject7$n = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.6px;\n    margin-right: -2.6px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 37px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -23px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -23px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$n = styled.div(_templateObject8$n || (_templateObject8$n = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 32px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 32px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$n = styled.div(_templateObject9$n || (_templateObject9$n = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.6px;\n"])));
var WarholCard3A3L = function WarholCard3A3L(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    name = props.name,
    customSubtitle = props.customSubtitle,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$n, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$n, null, /*#__PURE__*/React$1.createElement(TextUrl$n, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$n, null, /*#__PURE__*/React$1.createElement(ImageInner$n, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$n, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$n, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$n, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 23.5,
    fontSize: 26
  })), /*#__PURE__*/React$1.createElement(TextThird$n, null, customSubtitle || url))));
};

var _templateObject$o, _templateObject2$o, _templateObject3$o, _templateObject4$o, _templateObject5$o, _templateObject6$o, _templateObject7$o, _templateObject8$o, _templateObject9$o;
var Wrapper$o = styled.div(_templateObject$o || (_templateObject$o = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 420mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 57px;\n\n  * {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$o = styled.div(_templateObject2$o || (_templateObject2$o = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$o = styled.div(_templateObject3$o || (_templateObject3$o = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 6.7px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.3px;\n    margin-right: 8px;\n  }\n"])));
var ImageBlock$o = styled.div(_templateObject4$o || (_templateObject4$o = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$o = styled.div(_templateObject5$o || (_templateObject5$o = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$o = styled.div(_templateObject6$o || (_templateObject6$o = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.6%;\n  width: 90%;\n  padding-bottom: 70px;\n"])));
var TextFirst$o = styled.div(_templateObject7$o || (_templateObject7$o = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 15px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.6px;\n    margin-right: -2.6px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 37px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -23px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -23px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$o = styled.div(_templateObject8$o || (_templateObject8$o = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 32px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 32px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$o = styled.div(_templateObject9$o || (_templateObject9$o = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 10px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.6px;\n"])));
var WarholCard3A3 = function WarholCard3A3(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    name = props.name,
    customSubtitle = props.customSubtitle,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$o, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$o, null, /*#__PURE__*/React$1.createElement(TextUrl$o, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$o, null, /*#__PURE__*/React$1.createElement(ImageInner$o, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$o, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$o, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$o, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 23.5,
    fontSize: 26
  })), /*#__PURE__*/React$1.createElement(TextThird$o, null, customSubtitle || url))));
};

var _templateObject$p, _templateObject2$p, _templateObject3$p, _templateObject4$p, _templateObject5$p, _templateObject6$p, _templateObject7$p, _templateObject8$p, _templateObject9$p;
var Wrapper$p = styled.div(_templateObject$p || (_templateObject$p = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 420mm;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 83px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$p = styled.div(_templateObject2$p || (_templateObject2$p = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$p = styled.div(_templateObject3$p || (_templateObject3$p = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.1px;\n  }\n"])));
var ImageBlock$p = styled.div(_templateObject4$p || (_templateObject4$p = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$p = styled.div(_templateObject5$p || (_templateObject5$p = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$p = styled.div(_templateObject6$p || (_templateObject6$p = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24.1%;\n  width: 72%;\n  padding-bottom: 81.5px;\n"])));
var TextFirst$p = styled.div(_templateObject7$p || (_templateObject7$p = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 5.5px;\n    margin-right: -5.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 51px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -33px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -33px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$p = styled.div(_templateObject8$p || (_templateObject8$p = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 42px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 47px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$p = styled.div(_templateObject9$p || (_templateObject9$p = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 15.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n"])));
var WarholCard3A2L = function WarholCard3A2L(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    name = props.name,
    customSubtitle = props.customSubtitle,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$p, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$p, null, /*#__PURE__*/React$1.createElement(TextUrl$p, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$p, null, /*#__PURE__*/React$1.createElement(ImageInner$p, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$p, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$p, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$p, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 32.4,
    fontSize: 38
  })), /*#__PURE__*/React$1.createElement(TextThird$p, null, customSubtitle || url))));
};

var _templateObject$q, _templateObject2$q, _templateObject3$q, _templateObject4$q, _templateObject5$q, _templateObject6$q, _templateObject7$q, _templateObject8$q, _templateObject9$q;
var Wrapper$q = styled.div(_templateObject$q || (_templateObject$q = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 594mm;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 83px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$q = styled.div(_templateObject2$q || (_templateObject2$q = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$q = styled.div(_templateObject3$q || (_templateObject3$q = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 12px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.1px;\n  }\n"])));
var ImageBlock$q = styled.div(_templateObject4$q || (_templateObject4$q = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$q = styled.div(_templateObject5$q || (_templateObject5$q = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$q = styled.div(_templateObject6$q || (_templateObject6$q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.7%;\n  width: 90%;\n  padding-bottom: 99px;\n"])));
var TextFirst$q = styled.div(_templateObject7$q || (_templateObject7$q = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 18px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 5.5px;\n    margin-right: -5.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 51px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -33px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -33px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$q = styled.div(_templateObject8$q || (_templateObject8$q = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 42px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 47px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$q = styled.div(_templateObject9$q || (_templateObject9$q = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 15.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n"])));
var WarholCard3A2 = function WarholCard3A2(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    name = props.name,
    customSubtitle = props.customSubtitle,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$q, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$q, null, /*#__PURE__*/React$1.createElement(TextUrl$q, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$q, null, /*#__PURE__*/React$1.createElement(ImageInner$q, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$q, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$q, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$q, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 32.4,
    fontSize: 38
  })), /*#__PURE__*/React$1.createElement(TextThird$q, null, customSubtitle || url))));
};

var _templateObject$r, _templateObject2$r, _templateObject3$r, _templateObject4$r, _templateObject5$r, _templateObject6$r, _templateObject7$r, _templateObject8$r, _templateObject9$r;
var Wrapper$r = styled.div(_templateObject$r || (_templateObject$r = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 594mm;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 118px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$r = styled.div(_templateObject2$r || (_templateObject2$r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$r = styled.div(_templateObject3$r || (_templateObject3$r = _taggedTemplateLiteralLoose(["\n  height: 6.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 0.6px;\n    margin-right: 2px;\n  }\n"])));
var ImageBlock$r = styled.div(_templateObject4$r || (_templateObject4$r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$r = styled.div(_templateObject5$r || (_templateObject5$r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$r = styled.div(_templateObject6$r || (_templateObject6$r = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24%;\n  width: 72%;\n  padding-bottom: 116px;\n"])));
var TextFirst$r = styled.div(_templateObject7$r || (_templateObject7$r = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 6.5px;\n    margin-right: -6.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 74px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -44px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -44px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$r = styled.div(_templateObject8$r || (_templateObject8$r = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 54px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 70px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$r = styled.div(_templateObject9$r || (_templateObject9$r = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.3px;\n"])));
var WarholCard3A1L = function WarholCard3A1L(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$r, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$r, null, /*#__PURE__*/React$1.createElement(TextUrl$r, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$r, null, /*#__PURE__*/React$1.createElement(ImageInner$r, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$r, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$r, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$r, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 46,
    fontSize: 52
  })), /*#__PURE__*/React$1.createElement(TextThird$r, null, customSubtitle || url))));
};

var _templateObject$s, _templateObject2$s, _templateObject3$s, _templateObject4$s, _templateObject5$s, _templateObject6$s, _templateObject7$s, _templateObject8$s, _templateObject9$s;
var Wrapper$s = styled.div(_templateObject$s || (_templateObject$s = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 841mm;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 115px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$s = styled.div(_templateObject2$s || (_templateObject2$s = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$s = styled.div(_templateObject3$s || (_templateObject3$s = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 16px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.6px;\n  }\n"])));
var ImageBlock$s = styled.div(_templateObject4$s || (_templateObject4$s = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$s = styled.div(_templateObject5$s || (_templateObject5$s = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$s = styled.div(_templateObject6$s || (_templateObject6$s = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.65%;\n  width: 90%;\n  padding-bottom: 142px;\n"])));
var TextFirst$s = styled.div(_templateObject7$s || (_templateObject7$s = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 28px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 6.5px;\n    margin-right: -6.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 74px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -44px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -44px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$s = styled.div(_templateObject8$s || (_templateObject8$s = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 54px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 70px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$s = styled.div(_templateObject9$s || (_templateObject9$s = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 22px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n"])));
var WarholCard3A1 = function WarholCard3A1(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$s, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$s, null, /*#__PURE__*/React$1.createElement(TextUrl$s, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$s, null, /*#__PURE__*/React$1.createElement(ImageInner$s, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$s, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$s, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$s, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 46,
    fontSize: 52
  })), /*#__PURE__*/React$1.createElement(TextThird$s, null, customSubtitle || url))));
};

var _templateObject$t, _templateObject2$t, _templateObject3$t, _templateObject4$t, _templateObject5$t, _templateObject6$t, _templateObject7$t, _templateObject8$t, _templateObject9$t;
var Wrapper$t = styled.div(_templateObject$t || (_templateObject$t = _taggedTemplateLiteralLoose(["\n  width: 1189mm;\n  height: 841mm;\n  transform: scale(\n    calc(", " / 1189),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 163px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$t = styled.div(_templateObject2$t || (_templateObject2$t = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$t = styled.div(_templateObject3$t || (_templateObject3$t = _taggedTemplateLiteralLoose(["\n  height: 6.91%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 22px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 1px;\n  }\n"])));
var ImageBlock$t = styled.div(_templateObject4$t || (_templateObject4$t = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$t = styled.div(_templateObject5$t || (_templateObject5$t = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$t = styled.div(_templateObject6$t || (_templateObject6$t = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 24%;\n  width: 72%;\n  padding-bottom: 165px;\n"])));
var TextFirst$t = styled.div(_templateObject7$t || (_templateObject7$t = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 8.5px;\n    margin-right: -8.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 105px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -65px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -65px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$t = styled.div(_templateObject8$t || (_templateObject8$t = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 80px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 98px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$t = styled.div(_templateObject9$t || (_templateObject9$t = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 30.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 1px;\n"])));
var WarholCard3A0L = function WarholCard3A0L(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$t, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$t, null, /*#__PURE__*/React$1.createElement(TextUrl$t, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$t, null, /*#__PURE__*/React$1.createElement(ImageInner$t, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$t, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$t, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$t, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 64.5,
    fontSize: 72
  })), /*#__PURE__*/React$1.createElement(TextThird$t, null, customSubtitle || url))));
};

var _templateObject$u, _templateObject2$u, _templateObject3$u, _templateObject4$u, _templateObject5$u, _templateObject6$u, _templateObject7$u, _templateObject8$u, _templateObject9$u;
var Wrapper$u = styled.div(_templateObject$u || (_templateObject$u = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 1189mm;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 1189)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 168px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$u = styled.div(_templateObject2$u || (_templateObject2$u = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$u = styled.div(_templateObject3$u || (_templateObject3$u = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 24px;\n    font-style: normal;\n    font-weight: bold;\n    margin-top: 20px;\n  }\n"])));
var ImageBlock$u = styled.div(_templateObject4$u || (_templateObject4$u = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$u = styled.div(_templateObject5$u || (_templateObject5$u = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$u = styled.div(_templateObject6$u || (_templateObject6$u = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.7%;\n  width: 90%;\n  padding-bottom: 200px;\n"])));
var TextFirst$u = styled.div(_templateObject7$u || (_templateObject7$u = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 40px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 8.5px;\n    margin-right: -8.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 105px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -65px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: -65px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$u = styled.div(_templateObject8$u || (_templateObject8$u = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  width: 100%;\n  height: 80px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: 98px 0;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  overflow: hidden;\n"])));
var TextThird$u = styled.div(_templateObject9$u || (_templateObject9$u = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 30.5px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.4px;\n"])));
var WarholCard3A0 = function WarholCard3A0(props) {
  var _number$trim;
  var image = props.image,
    url = props.url,
    customSubtitle = props.customSubtitle,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$u, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$u, null, /*#__PURE__*/React$1.createElement(TextUrl$u, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$u, null, /*#__PURE__*/React$1.createElement(ImageInner$u, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$u, null, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$u, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$u, {
    ref: mainTextRef
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: 64.5,
    fontSize: 72
  })), /*#__PURE__*/React$1.createElement(TextThird$u, null, customSubtitle || url))));
};

var HeartIcon = withTheme(function (props) {
  var width = props.width,
    height = props.height,
    viewBox = props.viewBox,
    fill = props.fill,
    stroke = props.stroke,
    strokeWidth = props.strokeWidth;
  return /*#__PURE__*/React$1.createElement("svg", {
    width: width || '55',
    height: height || '55',
    viewBox: viewBox || '0 0 24 24',
    fill: fill || '#ef2a22',
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M11.133 3.80821L11.9999 5.31574L12.8668 3.80825C13.8489 2.10053 15.578 1 17.5188 1C20.4843 1 23 3.59003 23 6.92758C23 8.72076 22.2617 10.3117 21.1141 11.3925L11.9999 18.9296L2.88574 11.3925C1.73821 10.3117 1 8.72079 1 6.92758C1 3.58986 3.51506 1 6.48038 1C8.42125 1 10.1512 2.10067 11.133 3.80821Z",
    stroke: stroke || '#ef2a22',
    strokeWidth: strokeWidth || '2'
  }));
});

var string2Any = function string2Any(stringSrc, from, to) {
  if (stringSrc && stringSrc.includes(from)) {
    var parts = stringSrc.split(from);
    var newString = /*#__PURE__*/React$1.createElement(Fragment$1, null);
    parts.forEach(function (item, idx, srcArr) {
      newString = /*#__PURE__*/React$1.createElement(Fragment$1, null, newString, item, idx < (srcArr && srcArr.length - 1) && to);
    });
    return /*#__PURE__*/React$1.createElement(Fragment$1, null, newString);
  }
  return stringSrc;
};
var heartReplace = function heartReplace(_ref) {
  var str = _ref.str,
    height = _ref.height,
    width = _ref.width,
    nosizes = _ref.nosizes;
  var iconProps = nosizes ? {} : {
    height: height || 45,
    width: width || 45
  };
  return string2Any(str, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, iconProps));
};

var _templateObject$v, _templateObject2$v, _templateObject3$v, _templateObject4$v, _templateObject5$v, _templateObject6$v, _templateObject7$v, _templateObject8$v, _templateObject9$v;
var Wrapper$v = styled.div(_templateObject$v || (_templateObject$v = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 148mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 148)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$v = styled.div(_templateObject2$v || (_templateObject2$v = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$v = styled.div(_templateObject3$v || (_templateObject3$v = _taggedTemplateLiteralLoose(["\n  width: 92.5%;\n  height: 80.3%;\n  margin-top: 2.3%;\n  margin-left: 3.4%;\n"])));
var ImageInner$v = styled.div(_templateObject4$v || (_templateObject4$v = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$v = styled.div(_templateObject5$v || (_templateObject5$v = _taggedTemplateLiteralLoose(["\n  margin-top: 0%;\n  text-align: center;\n"])));
var TextUrl$v = styled.div(_templateObject6$v || (_templateObject6$v = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  font-size: 4.3px;\n  letter-spacing: 0;\n  margin-top: 2.13%;\n  text-align: center;\n"])));
var TextFirst$v = styled.div(_templateObject7$v || (_templateObject7$v = _taggedTemplateLiteralLoose(["\n  text-align: center;\n\n  span {\n    font-family: Roboto-Regular, Roboto, serif;\n    letter-spacing: 0.16em;\n    font-size: 5.02pt;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    margin-top: 1.85%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 506px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 121px;\n    left: 338px;\n  }\n"])));
var TextSecond$v = styled.div(_templateObject8$v || (_templateObject8$v = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  display: inline-block;\n  font-size: ", "pt;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  margin-top: 0.5%;\n  line-height: 1;\n  letter-spacing: 0.027em;\n  text-align: center;\n"])), function (props) {
  return props.fs;
});
var TextThird$v = styled.div(_templateObject9$v || (_templateObject9$v = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-weight: bold;\n  letter-spacing: 0;\n  font-size: 3pt;\n  margin-top: 0.65%;\n  text-align: center;\n"])));
var WarholCard4A5L = function WarholCard4A5L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var mainTextRef = useRef();
  var _useState = useState(13.37),
    fontS = _useState[0],
    setFontS = _useState[1];
  var _useState2 = useState(1),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name,
      useTextSecont: true,
      flag: flag
    }),
    w = _useContainerWidth.w;
  useEffect(function () {
    if (flag === 1 && w > 587) {
      setFlag(2);
    }
  }, [w]);
  useEffect(function () {
    if (flag === 2) {
      setFontS(13.37);
    }
  }, [w, flag]);
  var initName = toUpperCaseString({
    str: name,
    sliceId: 35
  });
  var textName = useMemo(function () {
    return heartReplace({
      str: initName,
      nosizes: true
    });
  }, [initName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$v, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$v, null, /*#__PURE__*/React$1.createElement(TextUrl$v, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$v, null, /*#__PURE__*/React$1.createElement(ImageInner$v, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$v, null, /*#__PURE__*/React$1.createElement(TextFirst$v, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(TextSecond$v, {
    ref: mainTextRef,
    fs: fontS,
    id: "text-second"
  }, textName), /*#__PURE__*/React$1.createElement(TextThird$v, null, museum))));
};

var _templateObject$w, _templateObject2$w, _templateObject3$w, _templateObject4$w, _templateObject5$w, _templateObject6$w, _templateObject7$w, _templateObject8$w, _templateObject9$w;
var Wrapper$w = styled.div(_templateObject$w || (_templateObject$w = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 209.9mm;\n  border: 1px solid white;\n  transform: scale(calc(", " / 297), calc(", " / 210));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  /* padding: 3.03% 4.86%; */\n  padding: 0.0636mm 14.43mm;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$w = styled.div(_templateObject2$w || (_templateObject2$w = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$w = styled.div(_templateObject3$w || (_templateObject3$w = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 88.82%;\n  // margin-top: 2.3%;\n  // margin-left: 3.4%;\n\n"])));
var ImageInner$w = styled.div(_templateObject4$w || (_templateObject4$w = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: start;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$w = styled.div(_templateObject5$w || (_templateObject5$w = _taggedTemplateLiteralLoose(["\n  margin-top: 0%;\n  text-align: center;\n  height: 7.07%;\n"])));
var TextUrl$w = styled.div(_templateObject6$w || (_templateObject6$w = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  font-size: 4pt;\n  letter-spacing: 0;\n  // margin-top: 2.13%;\n  margin-bottom: 3.03%;\n  text-align: center;\n"])));
var TextFirst$w = styled.div(_templateObject7$w || (_templateObject7$w = _taggedTemplateLiteralLoose(["\n  text-align: center;\n\n  span {\n    font-family: Roboto-Regular, Roboto, serif;\n    letter-spacing: 0.16em;\n    font-size: 7.1pt;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    // margin-top: 1.85%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    // top: 716px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 174px;\n    // left: 475px;\n    bottom: calc(50% + 1px);\n    left: 50%;\n  }\n"])));
var TextSecond$w = styled.div(_templateObject8$w || (_templateObject8$w = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  display: inline-block;\n  font-size: ", "pt;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  margin: 1.01% 0;\n  line-height: 1;\n  letter-spacing: 0.03em;\n  text-align: center;\n"])), function (props) {
  return props.fs;
});
var TextThird$w = styled.div(_templateObject9$w || (_templateObject9$w = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-weight: bold;\n  letter-spacing: 0;\n  font-size: 3.5pt;\n  // margin-top: 1.1%;\n  text-align: center;\n"])));
var WarholCard4A4L = function WarholCard4A4L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(18.92),
    fontS = _useState[0],
    setFontS = _useState[1];
  var _useState2 = useState(1),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useContainerWidth = useContainerWidth({
      name: name,
      useTextSecont: true,
      flag: flag
    }),
    w = _useContainerWidth.w;
  useEffect(function () {
    if (flag === 1 && w > 828) {
      setFlag(2);
    }
  }, [w]);
  useEffect(function () {
    if (flag === 2) {
      setFontS(18.92);
    }
  }, [w, flag]);
  var initName = toUpperCaseString({
    str: name,
    sliceId: 35
  });
  var textName = useMemo(function () {
    return heartReplace({
      str: initName,
      nosizes: true
    });
  }, [initName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$w, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$w, null, /*#__PURE__*/React$1.createElement(TextUrl$w, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$w, null, /*#__PURE__*/React$1.createElement(ImageInner$w, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$w, null, /*#__PURE__*/React$1.createElement(TextFirst$w, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(TextSecond$w, {
    fs: fontS,
    id: "text-second"
  }, textName), /*#__PURE__*/React$1.createElement(TextThird$w, null, museum))));
};

var _templateObject$x, _templateObject2$x, _templateObject3$x, _templateObject4$x, _templateObject5$x, _templateObject6$x, _templateObject7$x, _templateObject8$x, _templateObject9$x;
var Wrapper$x = styled.div(_templateObject$x || (_templateObject$x = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 296mm;\n  border: 1px solid white;\n  transform: scale(calc(", " / 420), calc(", " / 297));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$x = styled.div(_templateObject2$x || (_templateObject2$x = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$x = styled.div(_templateObject3$x || (_templateObject3$x = _taggedTemplateLiteralLoose(["\n  width: 92.5%;\n  height: 80.3%;\n  margin-top: 2.2%;\n  margin-left: 3.4%;\n\n"])));
var ImageInner$x = styled.div(_templateObject4$x || (_templateObject4$x = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$x = styled.div(_templateObject5$x || (_templateObject5$x = _taggedTemplateLiteralLoose(["\n  margin-top: 0%;\n  text-align: center;\n"])));
var TextUrl$x = styled.div(_templateObject6$x || (_templateObject6$x = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  font-size: 5pt;\n  letter-spacing: 0;\n  margin-top: 2.3%;\n  text-align: center;\n"])));
var TextFirst$x = styled.div(_templateObject7$x || (_templateObject7$x = _taggedTemplateLiteralLoose(["\n  text-align: center;\n\n  span {\n    font-family: Roboto-Regular, Roboto, serif;\n    letter-spacing: 0.16em;\n    font-size: 10.03pt;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    margin-top: 1.9%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 1010px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 242px;\n    left: 674px;\n  }\n"])));
var TextSecond$x = styled.div(_templateObject8$x || (_templateObject8$x = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  display: inline-block;\n  font-size: ", "pt;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  margin-top: 0.8%;\n  line-height: 1;\n  letter-spacing: 0.03em;\n  text-align: center;\n"])), function (props) {
  return props.fs;
});
var TextThird$x = styled.div(_templateObject9$x || (_templateObject9$x = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-weight: bold;\n  letter-spacing: 0;\n  font-size: 4.46pt;\n  margin-top: 0.9%;\n  text-align: center;\n"])));
var WarholCard4A3L = function WarholCard4A3L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(26.75),
    fontS = _useState[0],
    setFontS = _useState[1];
  var _useState2 = useState(1),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useContainerWidth = useContainerWidth({
      name: name,
      useTextSecont: true,
      flag: flag
    }),
    w = _useContainerWidth.w;
  useEffect(function () {
    if (flag === 1 && w > 1158) {
      setFlag(2);
    }
  }, [w]);
  useEffect(function () {
    if (flag === 2) {
      setFontS(26.75);
    }
  }, [w, flag]);
  var initName = toUpperCaseString({
    str: name,
    sliceId: 35
  });
  var textName = useMemo(function () {
    return heartReplace({
      str: initName,
      nosizes: true
    });
  }, [initName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$x, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$x, null, /*#__PURE__*/React$1.createElement(TextUrl$x, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$x, null, /*#__PURE__*/React$1.createElement(ImageInner$x, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$x, null, /*#__PURE__*/React$1.createElement(TextFirst$x, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(TextSecond$x, {
    fs: fontS,
    id: "text-second"
  }, textName), /*#__PURE__*/React$1.createElement(TextThird$x, null, museum))));
};

var _templateObject$y, _templateObject2$y, _templateObject3$y, _templateObject4$y, _templateObject5$y, _templateObject6$y, _templateObject7$y, _templateObject8$y, _templateObject9$y;
var Wrapper$y = styled.div(_templateObject$y || (_templateObject$y = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 419mm;\n  border: 1px solid white;\n  transform: scale(calc(", " / 594), calc(", " / 420));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$y = styled.div(_templateObject2$y || (_templateObject2$y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$y = styled.div(_templateObject3$y || (_templateObject3$y = _taggedTemplateLiteralLoose(["\n  width: 92.5%;\n  height: 80.3%;\n  margin-top: 2.2%;\n  margin-left: 3.4%;\n\n"])));
var ImageInner$y = styled.div(_templateObject4$y || (_templateObject4$y = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$y = styled.div(_templateObject5$y || (_templateObject5$y = _taggedTemplateLiteralLoose(["\n  margin-top: 0%;\n  text-align: center;\n"])));
var TextUrl$y = styled.div(_templateObject6$y || (_templateObject6$y = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  font-size: 8pt;\n  letter-spacing: 0;\n  margin-top: 2.3%;\n  text-align: center;\n"])));
var TextFirst$y = styled.div(_templateObject7$y || (_templateObject7$y = _taggedTemplateLiteralLoose(["\n  text-align: center;\n\n  span {\n    font-family: Roboto-Regular, Roboto, serif;\n    letter-spacing: 0.16em;\n    font-size: 14.19pt;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    margin-top: 1.9%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 1430px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 345px;\n    left: 952px;\n  }\n"])));
var TextSecond$y = styled.div(_templateObject8$y || (_templateObject8$y = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  display: inline-block;\n  font-size: ", "pt;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  margin-top: 0.75%;\n  line-height: 1;\n  letter-spacing: 0.03em;\n  text-align: center;\n"])), function (props) {
  return props.fs;
});
var TextThird$y = styled.div(_templateObject9$y || (_templateObject9$y = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-weight: bold;\n  letter-spacing: 0;\n  font-size: 6.31pt;\n  margin-top: 0.9%;\n  text-align: center;\n"])));
var WarholCard4A2L = function WarholCard4A2L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(37.83),
    fontS = _useState[0],
    setFontS = _useState[1];
  var _useState2 = useState(1),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useContainerWidth = useContainerWidth({
      name: name,
      useTextSecont: true,
      flag: flag
    }),
    w = _useContainerWidth.w;
  useEffect(function () {
    if (flag === 1 && w > 2176) {
      setFlag(2);
    }
  }, [w]);
  useEffect(function () {
    if (flag === 2) {
      setFontS(37.83);
    }
  }, [w, flag]);
  var initName = toUpperCaseString({
    str: name,
    sliceId: 35
  });
  var textName = useMemo(function () {
    return heartReplace({
      str: initName,
      nosizes: true
    });
  }, [initName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$y, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$y, null, /*#__PURE__*/React$1.createElement(TextUrl$y, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$y, null, /*#__PURE__*/React$1.createElement(ImageInner$y, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$y, null, /*#__PURE__*/React$1.createElement(TextFirst$y, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(TextSecond$y, {
    fs: fontS,
    id: "text-second"
  }, textName), /*#__PURE__*/React$1.createElement(TextThird$y, null, museum))));
};

var _templateObject$z, _templateObject2$z, _templateObject3$z, _templateObject4$z, _templateObject5$z, _templateObject6$z, _templateObject7$z, _templateObject8$z, _templateObject9$z;
var Wrapper$z = styled.div(_templateObject$z || (_templateObject$z = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 594mm;\n  border: 1px solid white;\n  transform: scale(calc(", " / 841), calc(", " / 594));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$z = styled.div(_templateObject2$z || (_templateObject2$z = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$z = styled.div(_templateObject3$z || (_templateObject3$z = _taggedTemplateLiteralLoose(["\n  width: 92.5%;\n  height: 80.3%;\n  margin-top: 2.2%;\n  margin-left: 3.4%;\n\n"])));
var ImageInner$z = styled.div(_templateObject4$z || (_templateObject4$z = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$z = styled.div(_templateObject5$z || (_templateObject5$z = _taggedTemplateLiteralLoose(["\n  margin-top: 0%;\n  text-align: center;\n"])));
var TextUrl$z = styled.div(_templateObject6$z || (_templateObject6$z = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  font-size: 10pt;\n  letter-spacing: 0;\n  margin-top: 2.3%;\n  text-align: center;\n"])));
var TextFirst$z = styled.div(_templateObject7$z || (_templateObject7$z = _taggedTemplateLiteralLoose(["\n  text-align: center;\n\n  span {\n    font-family: Roboto-Regular, Roboto, serif;\n    letter-spacing: 0.16em;\n    font-size: 20.06pt;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    margin-top: 1.83%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 2023px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 483px;\n    left: 1348px;\n  }\n"])));
var TextSecond$z = styled.div(_templateObject8$z || (_templateObject8$z = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  display: inline-block;\n  font-size: ", "pt;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  margin-top: 0.75%;\n  line-height: 1;\n  letter-spacing: 0.03em;\n  text-align: center;\n"])), function (props) {
  return props.fs;
});
var TextThird$z = styled.div(_templateObject9$z || (_templateObject9$z = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-weight: bold;\n  letter-spacing: 0;\n  font-size: 8.92pt;\n  margin-top: 0.95%;\n  text-align: center;\n"])));
var WarholCard4A1L = function WarholCard4A1L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(53.5),
    fontS = _useState[0],
    setFontS = _useState[1];
  var _useState2 = useState(1),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useContainerWidth = useContainerWidth({
      name: name,
      useTextSecont: true,
      flag: flag
    }),
    w = _useContainerWidth.w;
  useEffect(function () {
    if (flag === 1 && w > 2176) {
      setFlag(2);
    }
  }, [w]);
  useEffect(function () {
    if (flag === 2) {
      setFontS(53.5);
    }
  }, [w, flag]);
  var initName = toUpperCaseString({
    str: name,
    sliceId: 35
  });
  var textName = useMemo(function () {
    return heartReplace({
      str: initName,
      nosizes: true
    });
  }, [initName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$z, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$z, null, /*#__PURE__*/React$1.createElement(TextUrl$z, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$z, null, /*#__PURE__*/React$1.createElement(ImageInner$z, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$z, null, /*#__PURE__*/React$1.createElement(TextFirst$z, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(TextSecond$z, {
    fs: fontS,
    id: "text-second"
  }, textName), /*#__PURE__*/React$1.createElement(TextThird$z, null, museum))));
};

var _templateObject$A, _templateObject2$A, _templateObject3$A, _templateObject4$A, _templateObject5$A, _templateObject6$A, _templateObject7$A, _templateObject8$A, _templateObject9$A;
var Wrapper$A = styled.div(_templateObject$A || (_templateObject$A = _taggedTemplateLiteralLoose(["\n  width: 1189mm;\n  height: 840.95mm;\n  border: 1px solid white;\n  transform: scale(calc(", " / 1189), calc(", " / 841));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$A = styled.div(_templateObject2$A || (_templateObject2$A = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$A = styled.div(_templateObject3$A || (_templateObject3$A = _taggedTemplateLiteralLoose(["\n  width: 92.5%;\n  height: 80.3%;\n  margin-top: 2.2%;\n  margin-left: 3.4%;\n\n"])));
var ImageInner$A = styled.div(_templateObject4$A || (_templateObject4$A = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$A = styled.div(_templateObject5$A || (_templateObject5$A = _taggedTemplateLiteralLoose(["\n  margin-top: 0%;\n  text-align: center;\n"])));
var TextUrl$A = styled.div(_templateObject6$A || (_templateObject6$A = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  font-size: 15pt;\n  letter-spacing: 0;\n  margin-top: 2.3%;\n  text-align: center;\n"])));
var TextFirst$A = styled.div(_templateObject7$A || (_templateObject7$A = _taggedTemplateLiteralLoose(["\n  text-align: center;\n\n  span {\n    font-family: Roboto-Regular, Roboto, serif;\n    letter-spacing: 0.16em;\n    font-size: 28.37pt;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    margin-top: 1.72%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 2862px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 690px;\n    left: 1903px;\n  }\n"])));
var TextSecond$A = styled.div(_templateObject8$A || (_templateObject8$A = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  display: inline-block;\n  font-size: ", "pt;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  margin-top: 0.77%;\n  line-height: 1;\n  letter-spacing: 0.03em;\n  text-align: center;\n"])), function (props) {
  return props.fs;
});
var TextThird$A = styled.div(_templateObject9$A || (_templateObject9$A = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-weight: bold;\n  letter-spacing: 0;\n  font-size: 12.61pt;\n  margin-top: 1%;\n  text-align: center;\n"])));
var WarholCard4A0L = function WarholCard4A0L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(75.66),
    fontS = _useState[0],
    setFontS = _useState[1];
  var _useState2 = useState(1),
    flag = _useState2[0],
    setFlag = _useState2[1];
  var _useContainerWidth = useContainerWidth({
      name: name,
      useTextSecont: true,
      flag: flag
    }),
    w = _useContainerWidth.w;
  useEffect(function () {
    if (flag === 1 && w > 3365) {
      setFlag(2);
    }
  }, [w]);
  useEffect(function () {
    if (flag === 2) {
      setFontS(75.66);
    }
  }, [w, flag]);
  var initName = toUpperCaseString({
    str: name,
    sliceId: 35
  });
  var textName = useMemo(function () {
    return heartReplace({
      str: initName,
      nosizes: true
    });
  }, [initName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$A, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$A, null, /*#__PURE__*/React$1.createElement(TextUrl$A, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$A, null, /*#__PURE__*/React$1.createElement(ImageInner$A, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$A, null, /*#__PURE__*/React$1.createElement(TextFirst$A, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(TextSecond$A, {
    fs: fontS,
    id: "text-second"
  }, textName), /*#__PURE__*/React$1.createElement(TextThird$A, null, museum))));
};

var _templateObject$B, _templateObject2$B, _templateObject3$B, _templateObject4$B, _templateObject5$B, _templateObject6$B, _templateObject7$B, _templateObject8$B, _templateObject9$B, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14;
var Wrapper$B = styled.div(_templateObject$B || (_templateObject$B = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 1188mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 1189)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$B = styled.div(_templateObject2$B || (_templateObject2$B = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$B = styled.div(_templateObject3$B || (_templateObject3$B = _taggedTemplateLiteralLoose(["\n  width: 76.7%;\n  height: 74.85%;\n  margin-left: 11.6%;\n  text-align: center;\n"])));
var ImageInner$B = styled.div(_templateObject4$B || (_templateObject4$B = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$B = styled.div(_templateObject5$B || (_templateObject5$B = _taggedTemplateLiteralLoose(["\n  margin-left: 11.6%;\n  width: 76.7%;\n  height: 17.5%;\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var TextFirst$B = styled.div(_templateObject6$B || (_templateObject6$B = _taggedTemplateLiteralLoose(["\n  padding-top: 6.7%;\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.217em;\n    font-size: 80px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 3.2%;\n    padding-right: 3.2%;\n    position: relative;\n    z-index: 1;\n    background: white;\n    text-align: center;\n  }\n\n  i {\n    position: absolute;\n    // top: 54.5mm;\n    border-top: 2px solid black;\n    width: 1110px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$B = styled.div(_templateObject7$B || (_templateObject7$B = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 37.1px;\n  line-height: 1.1;\n  letter-spacing: 0.2px;\n  margin-top: 2.21%;\n  padding-left: 0.45%;\n  text-align: center;\n"])));
var TextSecond2 = styled.div(_templateObject8$B || (_templateObject8$B = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$B = styled.div(_templateObject9$B || (_templateObject9$B = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 1.5px;\n  font-size: 53.75px;\n  margin-top: 1.8%;\n  margin-left: 0.5%;\n  text-align: center;\n"])));
var TextFour = styled.div(_templateObject10 || (_templateObject10 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 20px;\n  margin-top: 2.26%;\n  margin-left: 0.45%;\n  text-align: center;\n"])));
var TextUrl$B = styled.div(_templateObject11 || (_templateObject11 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 9.6pt;\n  margin-top: 4.8%;\n  margin-left: 0.45%;\n  text-align: center;\n  padding-bottom: 6.08%;\n"])));
var TextUrl2 = styled.div(_templateObject12 || (_templateObject12 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  height: 7.7%;\n  width: 100%;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 9.6pt;\n  text-align: center;\n"])));
var TextUrl2None = styled.div(_templateObject13 || (_templateObject13 = _taggedTemplateLiteralLoose(["\n  height: 7.7%;\n"])));
var TextGift = styled.div(_templateObject14 || (_templateObject14 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 0.5;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 24pt;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var LuvrikCardA0 = function LuvrikCardA0(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$B, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2, null, country);
    }
  };
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '') {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [country]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$B, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$B, null, isGift && /*#__PURE__*/React$1.createElement(TextUrl2, null, url), !isGift && /*#__PURE__*/React$1.createElement(TextUrl2None, null), /*#__PURE__*/React$1.createElement(ImageBlock$B, null, /*#__PURE__*/React$1.createElement(ImageInner$B, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$B, null, !isGift && /*#__PURE__*/React$1.createElement(TextUrl$B, null, url), isGift && /*#__PURE__*/React$1.createElement(TextGift, null, giftName), /*#__PURE__*/React$1.createElement(TextFour, null, textName), /*#__PURE__*/React$1.createElement(TextThird$B, null, museum), countryBlock(), /*#__PURE__*/React$1.createElement(TextFirst$B, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$C, _templateObject2$C, _templateObject3$C, _templateObject4$C, _templateObject5$C, _templateObject6$C, _templateObject7$C, _templateObject8$C, _templateObject9$C, _templateObject10$1, _templateObject11$1, _templateObject12$1, _templateObject13$1, _templateObject14$1, _templateObject15;
var Wrapper$C = styled.div(_templateObject$C || (_templateObject$C = _taggedTemplateLiteralLoose(["\n  width: 1189mm;\n  height: 840.8mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 1189),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$C = styled.div(_templateObject2$C || (_templateObject2$C = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$C = styled.div(_templateObject3$C || (_templateObject3$C = _taggedTemplateLiteralLoose(["\n  width: 92.8%;\n  height: 72.5%;\n  margin-left: 3.6%;\n  margin-top: 2%;\n  text-align: center;\n"])));
var ImageInner$C = styled.div(_templateObject4$C || (_templateObject4$C = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$C = styled.div(_templateObject5$C || (_templateObject5$C = _taggedTemplateLiteralLoose(["\n  width: 92.8%;\n  height: 15.7%;\n  margin-left: 3.6%;\n  padding-top: 3.55%;\n"])));
var TextFirst$C = styled.div(_templateObject6$C || (_templateObject6$C = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.189em;\n    font-size: 83px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville';\n    font-style: italic;\n    position: absolute;\n    // top: 722.6mm;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 1095px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$C = styled.div(_templateObject7$C || (_templateObject7$C = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 36.7px;\n  line-height: 1.1;\n  letter-spacing: 0.32px;\n  margin-top: 1.3%;\n  text-align: center;\n"])));
var TextSecond2$1 = styled.div(_templateObject8$C || (_templateObject8$C = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$C = styled.div(_templateObject9$C || (_templateObject9$C = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 1.4px;\n  font-size: 53.7px;\n  margin-top: 1.05%;\n  text-align: center;\n"])));
var TextFour$1 = styled.div(_templateObject10$1 || (_templateObject10$1 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 20px;\n  margin-top: ", ";\n  text-align: center;\n"])), function (props) {
  return props.marginTop;
});
var TextUrl$C = styled.div(_templateObject11$1 || (_templateObject11$1 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 13.7px;\n  text-align: center;\n  margin-top: 2.6%;\n  margin-left: 0.05%;\n"])));
var TextUrlNone = styled.div(_templateObject12$1 || (_templateObject12$1 = _taggedTemplateLiteralLoose(["\n  margin-top: 4.75%;\n"])));
var TextUrl2$1 = styled.div(_templateObject13$1 || (_templateObject13$1 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 13.7px;\n  text-align: center;\n  margin-top: 3.2%;\n  margin-right: 0.1%;\n"])));
var TextUrl2None$1 = styled.div(_templateObject14$1 || (_templateObject14$1 = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextGift$1 = styled.div(_templateObject15 || (_templateObject15 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 1;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 24pt;\n  margin-top: 1.2%;\n  text-align: center;\n"])));
var LuvrikCardA0L = function LuvrikCardA0L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(1),
    classicState = _useState[0],
    setClassicState = _useState[1];
  var _useState2 = useState(false),
    isGift = _useState2[0],
    setIsGift = _useState2[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$C, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$1, null, country);
    }
  };
  useEffect(function () {
    if (country !== null && country !== undefined && country !== '') {
      setClassicState(1);
    } else {
      setClassicState(2);
    }
  }, [country]);
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '' && classicState === 1) {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [giftName]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$C, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$C, null, classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl$C, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrlNone, null), /*#__PURE__*/React$1.createElement(ImageBlock$C, null, /*#__PURE__*/React$1.createElement(ImageInner$C, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$C, null, /*#__PURE__*/React$1.createElement(TextFirst$C, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), countryBlock(), /*#__PURE__*/React$1.createElement(TextThird$C, null, museum), /*#__PURE__*/React$1.createElement(TextFour$1, {
    marginTop: isGift ? '1.2%' : '1.3%'
  }, textName), classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl2None$1, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrl2$1, null, url), isGift && classicState === 1 && /*#__PURE__*/React$1.createElement(TextGift$1, null, giftName))));
};

var _templateObject$D, _templateObject2$D, _templateObject3$D, _templateObject4$D, _templateObject5$D, _templateObject6$D, _templateObject7$D, _templateObject8$D, _templateObject9$D, _templateObject10$2, _templateObject11$2, _templateObject12$2, _templateObject13$2, _templateObject14$2;
var Wrapper$D = styled.div(_templateObject$D || (_templateObject$D = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 840mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$D = styled.div(_templateObject2$D || (_templateObject2$D = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n  box-sizing: border-box;\n"])));
var ImageBlock$D = styled.div(_templateObject3$D || (_templateObject3$D = _taggedTemplateLiteralLoose(["\n  width: 76.7%;\n  height: 73.5%;\n  margin-left: 11.6%;\n  text-align: center;\n"])));
var ImageInner$D = styled.div(_templateObject4$D || (_templateObject4$D = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$D = styled.div(_templateObject5$D || (_templateObject5$D = _taggedTemplateLiteralLoose(["\n  margin-left: 11.6%;\n  width: 76.7%;\n  height: 18.8%;\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var TextFirst$D = styled.div(_templateObject6$D || (_templateObject6$D = _taggedTemplateLiteralLoose(["\n  padding-top: 6.24%;\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 14px;\n    font-size: 68.5px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 3.5%;\n    padding-right: 3.5%;\n    position: relative;\n    z-index: 1;\n    background: white;\n    text-align: center;\n  }\n\n  i {\n    position: absolute;\n    // top: 38.5mm;\n    border-top: 2px solid black;\n    width: 920px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$D = styled.div(_templateObject7$D || (_templateObject7$D = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 28.8px;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.82px;\n  margin-top: 2.9%;\n  text-align: center;\n"])));
var TextSecond2$2 = styled.div(_templateObject8$D || (_templateObject8$D = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$D = styled.div(_templateObject9$D || (_templateObject9$D = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.87px;\n  font-size: 45.1px;\n  margin-top: 1.9%;\n  text-align: center;\n"])));
var TextFour$2 = styled.div(_templateObject10$2 || (_templateObject10$2 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 18.8px;\n  margin-top: 2.5%;\n  text-align: center;\n"])));
var TextUrl$D = styled.div(_templateObject11$2 || (_templateObject11$2 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 9pt;\n  margin-top: 6.55%;\n  text-align: center;\n  padding-bottom: 4.6%;\n"])));
var TextUrl2$2 = styled.div(_templateObject12$2 || (_templateObject12$2 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  height: 7.7%;\n  width: 100%;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 9pt;\n  text-align: center;\n"])));
var TextUrl2None$2 = styled.div(_templateObject13$2 || (_templateObject13$2 = _taggedTemplateLiteralLoose(["\n  height: 7.7%;\n"])));
var TextGift$2 = styled.div(_templateObject14$2 || (_templateObject14$2 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 0.5;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 18pt;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var LuvrikCardA1 = function LuvrikCardA1(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$D, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$2, null, country);
    }
  };
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '') {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [country]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$D, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$D, null, isGift && /*#__PURE__*/React$1.createElement(TextUrl2$2, null, url), !isGift && /*#__PURE__*/React$1.createElement(TextUrl2None$2, null), /*#__PURE__*/React$1.createElement(ImageBlock$D, null, /*#__PURE__*/React$1.createElement(ImageInner$D, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$D, null, !isGift && /*#__PURE__*/React$1.createElement(TextUrl$D, null, url), isGift && /*#__PURE__*/React$1.createElement(TextGift$2, null, giftName), /*#__PURE__*/React$1.createElement(TextFour$2, null, textName), /*#__PURE__*/React$1.createElement(TextThird$D, null, museum), countryBlock(), /*#__PURE__*/React$1.createElement(TextFirst$D, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$E, _templateObject2$E, _templateObject3$E, _templateObject4$E, _templateObject5$E, _templateObject6$E, _templateObject7$E, _templateObject8$E, _templateObject9$E, _templateObject10$3, _templateObject11$3, _templateObject12$3, _templateObject13$3, _templateObject14$3, _templateObject15$1;
var Wrapper$E = styled.div(_templateObject$E || (_templateObject$E = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 593.8mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$E = styled.div(_templateObject2$E || (_templateObject2$E = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$E = styled.div(_templateObject3$E || (_templateObject3$E = _taggedTemplateLiteralLoose(["\n  width: 92.8%;\n  height: 71%;\n  margin-left: 3.6%;\n  margin-top: 2%;\n  text-align: center;\n"])));
var ImageInner$E = styled.div(_templateObject4$E || (_templateObject4$E = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$E = styled.div(_templateObject5$E || (_templateObject5$E = _taggedTemplateLiteralLoose(["\n  width: 92.8%;\n  height: 16.7%;\n  margin-left: 3.6%;\n  padding-top: 2.5%;\n"])));
var TextFirst$E = styled.div(_templateObject6$E || (_templateObject6$E = _taggedTemplateLiteralLoose(["\n  margin-top: 1%;\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.2em;\n    font-size: 69.5px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville';\n    font-style: italic;\n    position: absolute;\n    // top: 503mm;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 915px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$E = styled.div(_templateObject7$E || (_templateObject7$E = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 30px;\n  line-height: 1.1;\n  letter-spacing: 0.32px;\n  font-weight: normal;\n  margin-top: 1.7%;\n  text-align: center;\n"])));
var TextSecond2$3 = styled.div(_templateObject8$E || (_templateObject8$E = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$E = styled.div(_templateObject9$E || (_templateObject9$E = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 1.6px;\n  font-size: 43.2px;\n  margin-top: 1.07%;\n  margin-left: 0.1%;\n  text-align: center;\n"])));
var TextFour$3 = styled.div(_templateObject10$3 || (_templateObject10$3 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 18.8px;\n  margin-top: ", ";\n  text-align: center;\n"])), function (props) {
  return props.marginTop;
});
var TextUrl$E = styled.div(_templateObject11$3 || (_templateObject11$3 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 14px;\n  text-align: center;\n  margin-top: 2.5%;\n  margin-right: 0.1%;\n"])));
var TextUrlNone$1 = styled.div(_templateObject12$3 || (_templateObject12$3 = _taggedTemplateLiteralLoose(["\n  margin-top: 4.72%;\n"])));
var TextUrl2$3 = styled.div(_templateObject13$3 || (_templateObject13$3 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 14px;\n  text-align: center;\n  margin-top: 3.2%;\n  margin-right: 0.1%;\n"])));
var TextUrl2None$3 = styled.div(_templateObject14$3 || (_templateObject14$3 = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextGift$3 = styled.div(_templateObject15$1 || (_templateObject15$1 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 1;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 18pt;\n  margin-top: 1%;\n  text-align: center;\n"])));
var LuvrikCardA1L = function LuvrikCardA1L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(1),
    classicState = _useState[0],
    setClassicState = _useState[1];
  var _useState2 = useState(false),
    isGift = _useState2[0],
    setIsGift = _useState2[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$E, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$3, null, country);
    }
  };
  useEffect(function () {
    if (country !== null && country !== undefined && country !== '') {
      setClassicState(1);
    } else {
      setClassicState(2);
    }
  }, [country]);
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '' && classicState === 1) {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [giftName]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$E, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$E, null, classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl$E, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrlNone$1, null), /*#__PURE__*/React$1.createElement(ImageBlock$E, null, /*#__PURE__*/React$1.createElement(ImageInner$E, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$E, null, /*#__PURE__*/React$1.createElement(TextFirst$E, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), countryBlock(), /*#__PURE__*/React$1.createElement(TextThird$E, null, museum), /*#__PURE__*/React$1.createElement(TextFour$3, {
    marginTop: isGift ? '1.2%' : '1.5%'
  }, textName), classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl2None$3, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrl2$3, null, url), isGift && classicState === 1 && /*#__PURE__*/React$1.createElement(TextGift$3, null, giftName))));
};

var _templateObject$F, _templateObject2$F, _templateObject3$F, _templateObject4$F, _templateObject5$F, _templateObject6$F, _templateObject7$F, _templateObject8$F, _templateObject9$F, _templateObject10$4, _templateObject11$4, _templateObject12$4, _templateObject13$4, _templateObject14$4;
var Wrapper$F = styled.div(_templateObject$F || (_templateObject$F = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 594mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$F = styled.div(_templateObject2$F || (_templateObject2$F = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n  box-sizing: border-box;\n"])));
var ImageBlock$F = styled.div(_templateObject3$F || (_templateObject3$F = _taggedTemplateLiteralLoose(["\n  width: 76.7%;\n  height: 73.5%;\n  margin-left: 11.6%;\n  text-align: center;\n"])));
var ImageInner$F = styled.div(_templateObject4$F || (_templateObject4$F = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$F = styled.div(_templateObject5$F || (_templateObject5$F = _taggedTemplateLiteralLoose(["\n  margin-left: 11.6%;\n  width: 76.7%;\n  height: 18.8%;\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var TextFirst$F = styled.div(_templateObject6$F || (_templateObject6$F = _taggedTemplateLiteralLoose(["\n  padding-top: 6.24%;\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.209em;\n    font-size: 48.1px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 3.2%;\n    padding-right: 3.2%;\n    position: relative;\n    z-index: 1;\n    background: white;\n    text-align: center;\n  }\n\n  i {\n    position: absolute;\n    // top: 27.5mm;\n    border-top: 2px solid black;\n    width: 650px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$F = styled.div(_templateObject7$F || (_templateObject7$F = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 21.8px;\n  line-height: 1.1;\n  letter-spacing: normal;\n  margin-top: 2.8%;\n  text-align: center;\n"])));
var TextSecond2$4 = styled.div(_templateObject8$F || (_templateObject8$F = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$F = styled.div(_templateObject9$F || (_templateObject9$F = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.8px;\n  font-size: 31px;\n  margin-top: 2.11%;\n  text-align: center;\n"])));
var TextFour$4 = styled.div(_templateObject10$4 || (_templateObject10$4 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 13.8px;\n  margin-top: 2.4%;\n  text-align: center;\n"])));
var TextUrl$F = styled.div(_templateObject11$4 || (_templateObject11$4 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 7.2pt;\n  margin-top: 6.5%;\n  text-align: center;\n  padding-bottom: 4.6%;\n"])));
var TextUrl2$4 = styled.div(_templateObject12$4 || (_templateObject12$4 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  height: 7.7%;\n  width: 100%;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 7.2pt;\n  text-align: center;\n"])));
var TextUrl2None$4 = styled.div(_templateObject13$4 || (_templateObject13$4 = _taggedTemplateLiteralLoose(["\n  height: 7.7%;\n"])));
var TextGift$4 = styled.div(_templateObject14$4 || (_templateObject14$4 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 0.5;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 13pt;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var LuvrikCardA2 = function LuvrikCardA2(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$F, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$4, null, country);
    }
  };
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '') {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [country]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$F, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$F, null, isGift && /*#__PURE__*/React$1.createElement(TextUrl2$4, null, url), !isGift && /*#__PURE__*/React$1.createElement(TextUrl2None$4, null), /*#__PURE__*/React$1.createElement(ImageBlock$F, null, /*#__PURE__*/React$1.createElement(ImageInner$F, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$F, null, !isGift && /*#__PURE__*/React$1.createElement(TextUrl$F, null, url), isGift && /*#__PURE__*/React$1.createElement(TextGift$4, null, giftName), /*#__PURE__*/React$1.createElement(TextFour$4, null, textName), /*#__PURE__*/React$1.createElement(TextThird$F, null, museum), countryBlock(), /*#__PURE__*/React$1.createElement(TextFirst$F, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$G, _templateObject2$G, _templateObject3$G, _templateObject4$G, _templateObject5$G, _templateObject6$G, _templateObject7$G, _templateObject8$G, _templateObject9$G, _templateObject10$5, _templateObject11$5, _templateObject12$5, _templateObject13$5, _templateObject14$5, _templateObject15$2;
var Wrapper$G = styled.div(_templateObject$G || (_templateObject$G = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 419mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$G = styled.div(_templateObject2$G || (_templateObject2$G = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$G = styled.div(_templateObject3$G || (_templateObject3$G = _taggedTemplateLiteralLoose(["\n  width: 92.7%;\n  height: 71%;\n  margin-left: 3.6%;\n  margin-top: 2.2%;\n  text-align: center;\n"])));
var ImageInner$G = styled.div(_templateObject4$G || (_templateObject4$G = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$G = styled.div(_templateObject5$G || (_templateObject5$G = _taggedTemplateLiteralLoose(["\n  width: 92.7%;\n  height: 16.7%;\n  margin-left: 3.8%;\n  padding-top: 3.45%;\n"])));
var TextFirst$G = styled.div(_templateObject6$G || (_templateObject6$G = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.2em;\n    font-size: 49px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 1.8%;\n    padding-right: 1.8%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville';\n    font-style: italic;\n    position: absolute;\n    // top: 355.5mm;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 650px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$G = styled.div(_templateObject7$G || (_templateObject7$G = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 21px;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.3px;\n  margin-top: 1.7%;\n  margin-right: 0.3%;\n  text-align: center;\n"])));
var TextSecond2$5 = styled.div(_templateObject8$G || (_templateObject8$G = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$G = styled.div(_templateObject9$G || (_templateObject9$G = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.85px;\n  font-size: 31px;\n  margin-top: 1.1%;\n  margin-right: 0.3%;\n  text-align: center;\n"])));
var TextFour$5 = styled.div(_templateObject10$5 || (_templateObject10$5 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 13.7px;\n  margin-top: ", ";\n  margin-right: 0.3%;\n  text-align: center;\n"])), function (props) {
  return props.marginTop;
});
var TextUrl$G = styled.div(_templateObject11$5 || (_templateObject11$5 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 11.8px;\n  text-align: center;\n  margin-top: 2.4%;\n  margin-right: 0.1%;\n"])));
var TextUrlNone$2 = styled.div(_templateObject12$5 || (_templateObject12$5 = _taggedTemplateLiteralLoose(["\n  margin-top: 4.8%;\n"])));
var TextUrl2$5 = styled.div(_templateObject13$5 || (_templateObject13$5 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 11.8px;\n  text-align: center;\n  margin-top: 3.2%;\n  margin-right: 0.1%;\n"])));
var TextUrl2None$5 = styled.div(_templateObject14$5 || (_templateObject14$5 = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextGift$5 = styled.div(_templateObject15$2 || (_templateObject15$2 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 1;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 13pt;\n  margin-top: 1%;\n  text-align: center;\n"])));
var LuvrikCardA2L = function LuvrikCardA2L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  var _useState2 = useState(1),
    classicState = _useState2[0],
    setClassicState = _useState2[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$G, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$5, null, country);
    }
  };
  useEffect(function () {
    if (country !== null && country !== undefined && country !== '') {
      setClassicState(1);
    } else {
      setClassicState(2);
    }
  }, [country]);
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '' && classicState === 1) {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [giftName]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$G, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$G, null, classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl$G, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrlNone$2, null), /*#__PURE__*/React$1.createElement(ImageBlock$G, null, /*#__PURE__*/React$1.createElement(ImageInner$G, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$G, null, /*#__PURE__*/React$1.createElement(TextFirst$G, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), countryBlock(), /*#__PURE__*/React$1.createElement(TextThird$G, null, museum), /*#__PURE__*/React$1.createElement(TextFour$5, {
    marginTop: isGift ? '1.2%' : '1.5%'
  }, textName), classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl2None$5, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrl2$5, null, url), isGift && classicState === 1 && /*#__PURE__*/React$1.createElement(TextGift$5, null, giftName))));
};

var _templateObject$H, _templateObject2$H, _templateObject3$H, _templateObject4$H, _templateObject5$H, _templateObject6$H, _templateObject7$H, _templateObject8$H, _templateObject9$H, _templateObject10$6, _templateObject11$6, _templateObject12$6, _templateObject13$6, _templateObject14$6;
var Wrapper$H = styled.div(_templateObject$H || (_templateObject$H = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 420mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$H = styled.div(_templateObject2$H || (_templateObject2$H = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n  box-sizing: border-box;\n"])));
var ImageBlock$H = styled.div(_templateObject3$H || (_templateObject3$H = _taggedTemplateLiteralLoose(["\n  width: 76.7%;\n  height: 73.5%;\n  margin-left: 11.6%;\n  text-align: center;\n"])));
var ImageInner$H = styled.div(_templateObject4$H || (_templateObject4$H = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$H = styled.div(_templateObject5$H || (_templateObject5$H = _taggedTemplateLiteralLoose(["\n  margin-left: 11.6%;\n  width: 76.7%;\n  height: 18.8%;\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var TextFirst$H = styled.div(_templateObject6$H || (_templateObject6$H = _taggedTemplateLiteralLoose(["\n  padding-top: 6%;\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.213em;\n    font-size: 37.2px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 3.2%;\n    padding-right: 3.2%;\n    position: relative;\n    z-index: 1;\n    background: white;\n    text-align: center;\n  }\n\n  i {\n    position: absolute;\n    // top: 19.5mm;\n    border-top: 1px solid black;\n    // width: 490px;\n    width: 39%;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$H = styled.div(_templateObject7$H || (_templateObject7$H = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 16.2px;\n  line-height: 1.1;\n  letter-spacing: 0.25px;\n  font-weight: normal;\n  margin-top: 2.6%;\n  text-align: center;\n"])));
var TextSecond2$6 = styled.div(_templateObject8$H || (_templateObject8$H = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$H = styled.div(_templateObject9$H || (_templateObject9$H = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.39px;\n  font-size: 23.1px;\n  margin-top: 1.7%;\n  text-align: center;\n"])));
var TextFour$6 = styled.div(_templateObject10$6 || (_templateObject10$6 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 9.7px;\n  margin-top: 2.5%;\n  text-align: center;\n"])));
var TextUrl$H = styled.div(_templateObject11$6 || (_templateObject11$6 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 5pt;\n  margin-top: 6.6%;\n  padding-bottom: 4.7%;\n  text-align: center;\n"])));
var TextUrl2$6 = styled.div(_templateObject12$6 || (_templateObject12$6 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  height: 7.7%;\n  width: 100%;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 5pt;\n  text-align: center;\n"])));
var TextUrl2None$6 = styled.div(_templateObject13$6 || (_templateObject13$6 = _taggedTemplateLiteralLoose(["\n  height: 7.7%;\n"])));
var TextGift$6 = styled.div(_templateObject14$6 || (_templateObject14$6 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 0.5;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 9pt;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var LuvrikCardA3 = function LuvrikCardA3(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$H, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$6, null, country);
    }
  };
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '') {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [country]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$H, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$H, null, isGift && /*#__PURE__*/React$1.createElement(TextUrl2$6, null, url), !isGift && /*#__PURE__*/React$1.createElement(TextUrl2None$6, null), /*#__PURE__*/React$1.createElement(ImageBlock$H, null, /*#__PURE__*/React$1.createElement(ImageInner$H, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$H, null, !isGift && /*#__PURE__*/React$1.createElement(TextUrl$H, null, url), isGift && /*#__PURE__*/React$1.createElement(TextGift$6, null, giftName), /*#__PURE__*/React$1.createElement(TextFour$6, null, textName), /*#__PURE__*/React$1.createElement(TextThird$H, null, museum), countryBlock(), /*#__PURE__*/React$1.createElement(TextFirst$H, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$I, _templateObject2$I, _templateObject3$I, _templateObject4$I, _templateObject5$I, _templateObject6$I, _templateObject7$I, _templateObject8$I, _templateObject9$I, _templateObject10$7, _templateObject11$7, _templateObject12$7, _templateObject13$7, _templateObject14$7, _templateObject15$3;
var Wrapper$I = styled.div(_templateObject$I || (_templateObject$I = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 296mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$I = styled.div(_templateObject2$I || (_templateObject2$I = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n"])));
var ImageBlock$I = styled.div(_templateObject3$I || (_templateObject3$I = _taggedTemplateLiteralLoose(["\n  width: 92.7%;\n  height: 71.1%;\n  margin-left: 3.6%;\n  margin-top: 2.2%;\n  text-align: center;\n"])));
var ImageInner$I = styled.div(_templateObject4$I || (_templateObject4$I = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$I = styled.div(_templateObject5$I || (_templateObject5$I = _taggedTemplateLiteralLoose(["\n  width: 92.7%;\n  height: 16.7%;\n  margin-left: 3.6%;\n  padding-top: 3.6%;\n"])));
var TextFirst$I = styled.div(_templateObject6$I || (_templateObject6$I = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  margin-top: -0.15%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville';\n    letter-spacing: 0.227em;\n    font-size: 33.2px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2%;\n    padding-right: 1.7%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville';\n    font-style: italic;\n    position: absolute;\n    // top: 251mm;\n    z-index: 1;\n    border-top: 1px solid black;\n    // width: 456px;\n    width: 26%;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$I = styled.div(_templateObject7$I || (_templateObject7$I = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: 16px;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.3px;\n  margin-top: 1.75%;\n  text-align: center;\n"])));
var TextSecond2$7 = styled.div(_templateObject8$I || (_templateObject8$I = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$I = styled.div(_templateObject9$I || (_templateObject9$I = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.23px;\n  font-size: 23.5px;\n  margin-top: 1%;\n  text-align: center;\n"])));
var TextFour$7 = styled.div(_templateObject10$7 || (_templateObject10$7 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 9.6px;\n  margin-top: ", ";\n  text-align: center;\n"])), function (props) {
  return props.marginTop;
});
var TextUrl$I = styled.div(_templateObject11$7 || (_templateObject11$7 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 9.9px;\n  text-align: center;\n  margin-top: 2.35%;\n  margin-right: 0.3%;\n"])));
var TextUrlNone$3 = styled.div(_templateObject12$7 || (_templateObject12$7 = _taggedTemplateLiteralLoose(["\n  margin-top: 4.8%;\n"])));
var TextUrl2$7 = styled.div(_templateObject13$7 || (_templateObject13$7 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 9.9px;\n  text-align: center;\n  margin-top: 3.2%;\n  margin-right: 0.3%;\n"])));
var TextUrl2None$7 = styled.div(_templateObject14$7 || (_templateObject14$7 = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextGift$7 = styled.div(_templateObject15$3 || (_templateObject15$3 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 1;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 9pt;\n  margin-top: 1.1%;\n  text-align: center;\n"])));
var LuvrikCardA3L = function LuvrikCardA3L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(1),
    classicState = _useState[0],
    setClassicState = _useState[1];
  var _useState2 = useState(false),
    isGift = _useState2[0],
    setIsGift = _useState2[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$I, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$7, null, country);
    }
  };
  useEffect(function () {
    if (country !== null && country !== undefined && country !== '') {
      setClassicState(1);
    } else {
      setClassicState(2);
    }
  }, [country]);
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '' && classicState === 1) {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [giftName]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$I, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$I, null, classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl$I, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrlNone$3, null), /*#__PURE__*/React$1.createElement(ImageBlock$I, null, /*#__PURE__*/React$1.createElement(ImageInner$I, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$I, null, /*#__PURE__*/React$1.createElement(TextFirst$I, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), countryBlock(), /*#__PURE__*/React$1.createElement(TextThird$I, null, museum), /*#__PURE__*/React$1.createElement(TextFour$7, {
    marginTop: isGift ? '1.2%' : '1.5%'
  }, textName), classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl2None$7, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrl2$7, null, url), isGift && classicState === 1 && /*#__PURE__*/React$1.createElement(TextGift$7, null, giftName))));
};

var _templateObject$J, _templateObject2$J, _templateObject3$J, _templateObject4$J, _templateObject5$J, _templateObject6$J, _templateObject7$J, _templateObject8$J, _templateObject9$J, _templateObject10$8, _templateObject11$8, _templateObject12$8, _templateObject13$8, _templateObject14$8;
var Wrapper$J = styled.div(_templateObject$J || (_templateObject$J = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$J = styled.div(_templateObject2$J || (_templateObject2$J = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  padding: 0 91px;\n"])));
var ImageBlock$J = styled.div(_templateObject3$J || (_templateObject3$J = _taggedTemplateLiteralLoose(["\n  height: 73.1%;\n  text-align: center;\n"])));
var ImageInner$J = styled.div(_templateObject4$J || (_templateObject4$J = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$J = styled.div(_templateObject5$J || (_templateObject5$J = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column-reverse;\n  height: 18.9%;\n"])));
var TextFirst$J = styled.div(_templateObject6$J || (_templateObject6$J = _taggedTemplateLiteralLoose(["\n  width: 60%;\n  margin: 0 auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: 'Baskerville';\n\n  span {\n    font-size: 27px;\n    font-style: italic;\n    letter-spacing: 5.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 35px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: 42px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: 42px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$J = styled.div(_templateObject7$J || (_templateObject7$J = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: calc(10.5px * 1.23);\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.25px;\n  margin-top: 2.5%;\n  text-align: center;\n  display: block;\n  color: #151514;\n"])));
var TextSecond2$8 = styled.div(_templateObject8$J || (_templateObject8$J = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-size: calc(10.5px * 1.23);\n  line-height: 1.1;\n  font-weight: bold;\n  letter-spacing: 0.25px;\n  margin-top: 2.5%;\n  text-align: center;\n  display: none;\n  color: #151514;\n"])));
var TextThird$J = styled.div(_templateObject9$J || (_templateObject9$J = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.35px;\n  font-size: calc(15.2px * 1.2);\n  margin-top: 1.4%;\n  text-align: center;\n  color: #151514;\n"])));
var TextFour$8 = styled.div(_templateObject10$8 || (_templateObject10$8 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 7.5px;\n  margin-top: 2.5%;\n  text-align: center;\n  color: #151514;\n"])));
var TextUrl$J = styled.div(_templateObject11$8 || (_templateObject11$8 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 5pt;\n  margin-top: 5.2%;\n  padding-bottom: 4.2%;\n  text-align: center;\n  color: #151514;\n"])));
var TextUrl2$8 = styled.div(_templateObject12$8 || (_templateObject12$8 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  height: 8%;\n  width: 100%;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 5pt;\n  text-align: center;\n"])));
var TextUrl2None$8 = styled.div(_templateObject13$8 || (_templateObject13$8 = _taggedTemplateLiteralLoose(["\n  height: 8%;\n"])));
var TextGift$8 = styled.div(_templateObject14$8 || (_templateObject14$8 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 0.5;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 8pt;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var LuvrikCardA4 = function LuvrikCardA4(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$J, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$8, null, country);
    }
  };
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '') {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [country]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$J, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$J, null, isGift && /*#__PURE__*/React$1.createElement(TextUrl2$8, null, url), !isGift && /*#__PURE__*/React$1.createElement(TextUrl2None$8, null), /*#__PURE__*/React$1.createElement(ImageBlock$J, null, /*#__PURE__*/React$1.createElement(ImageInner$J, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$J, null, !isGift && /*#__PURE__*/React$1.createElement(TextUrl$J, null, url), isGift && /*#__PURE__*/React$1.createElement(TextGift$8, null, giftName), /*#__PURE__*/React$1.createElement(TextFour$8, null, textName), /*#__PURE__*/React$1.createElement(TextThird$J, null, museum), countryBlock(), /*#__PURE__*/React$1.createElement(TextFirst$J, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })))));
};

var _templateObject$K, _templateObject2$K, _templateObject3$K, _templateObject4$K, _templateObject5$K, _templateObject6$K, _templateObject7$K, _templateObject8$K, _templateObject9$K, _templateObject10$9, _templateObject11$9, _templateObject12$9, _templateObject13$9, _templateObject14$9, _templateObject15$4;
var Wrapper$K = styled.div(_templateObject$K || (_templateObject$K = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 40px;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$K = styled.div(_templateObject2$K || (_templateObject2$K = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"])));
var ImageBlock$K = styled.div(_templateObject3$K || (_templateObject3$K = _taggedTemplateLiteralLoose(["\n  height: 70.8%;\n  text-align: center;\n"])));
var ImageInner$K = styled.div(_templateObject4$K || (_templateObject4$K = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$K = styled.div(_templateObject5$K || (_templateObject5$K = _taggedTemplateLiteralLoose(["\n  width: 92%;\n  height: 22.2%;\n  margin: auto;\n  box-sizing: border-box;\n  padding-top: 43px;\n  color: #151514;\n"])));
var TextFirst$K = styled.div(_templateObject6$K || (_templateObject6$K = _taggedTemplateLiteralLoose(["\n  width: 40%;\n  margin: auto;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: 'Baskerville';\n\n  span {\n    font-size: 27px;\n    font-style: italic;\n    letter-spacing: 5.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 35px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: 64px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: 64px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var TextSecond$K = styled.div(_templateObject7$K || (_templateObject7$K = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  font-weight: normal;\n  font-size: 12.7px;\n  line-height: 1.1;\n  letter-spacing: 0.35px;\n  margin-top: 1.1%;\n  margin-right: 0.2%;\n  text-align: center;\n  color: #151514;\n"])));
var TextSecond2$9 = styled.div(_templateObject8$K || (_templateObject8$K = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$K = styled.div(_templateObject9$K || (_templateObject9$K = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr';\n  line-height: 1.1;\n  letter-spacing: 0.7px;\n  font-size: 17.7px;\n  margin-top: 13px;\n  text-align: center;\n  color: #151514;\n"])));
var TextFour$9 = styled.div(_templateObject10$9 || (_templateObject10$9 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 7.6px;\n  margin-top: ", ";\n  margin-right: 0.2%;\n  text-align: center;\n  color: #151514;\n"])), function (props) {
  return props.marginTop;
});
var TextUrl$K = styled.div(_templateObject11$9 || (_templateObject11$9 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 7.5px;\n  text-align: center;\n  height: 7%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  color: #151514;\n"])));
var TextUrlNone$4 = styled.div(_templateObject12$9 || (_templateObject12$9 = _taggedTemplateLiteralLoose(["\n  margin-top: 4.75%;\n"])));
var TextUrl2$9 = styled.div(_templateObject13$9 || (_templateObject13$9 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 7.5px;\n  text-align: center;\n  margin-top: 2.8%;\n  color: #151514;\n"])));
var TextUrl2None$9 = styled.div(_templateObject14$9 || (_templateObject14$9 = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextGift$9 = styled.div(_templateObject15$4 || (_templateObject15$4 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 1;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 7pt;\n  margin-top: 1.1%;\n  text-align: center;\n"])));
var LuvrikCardA4L = function LuvrikCardA4L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(1),
    classicState = _useState[0],
    setClassicState = _useState[1];
  var _useState2 = useState(false),
    isGift = _useState2[0],
    setIsGift = _useState2[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$K, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$9, null, country);
    }
  };
  useEffect(function () {
    if (country !== null && country !== undefined && country !== '') {
      setClassicState(1);
    } else {
      setClassicState(2);
    }
  }, [country]);
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '' && classicState === 1) {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [giftName]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$K, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$K, null, /*#__PURE__*/React$1.createElement(TextUrl$K, null, classicState === 1 && url), /*#__PURE__*/React$1.createElement(ImageBlock$K, null, /*#__PURE__*/React$1.createElement(ImageInner$K, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$K, null, /*#__PURE__*/React$1.createElement(TextFirst$K, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), countryBlock(), /*#__PURE__*/React$1.createElement(TextThird$K, null, museum), /*#__PURE__*/React$1.createElement(TextFour$9, {
    marginTop: isGift ? '1.1%' : '1.6%'
  }, textName), classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl2None$9, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrl2$9, null, url), isGift && classicState === 1 && /*#__PURE__*/React$1.createElement(TextGift$9, null, giftName))));
};

var _templateObject$L, _templateObject2$L, _templateObject3$L, _templateObject4$L, _templateObject5$L, _templateObject6$L, _templateObject7$L, _templateObject8$L, _templateObject9$L, _templateObject10$a, _templateObject11$a, _templateObject12$a, _templateObject13$a, _templateObject14$a;
var Wrapper$L = styled.div(_templateObject$L || (_templateObject$L = _taggedTemplateLiteralLoose(["\n  width: 148mm;\n  height: 209.9mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 148),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$L = styled.div(_templateObject2$L || (_templateObject2$L = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n  box-sizing: border-box;\n"])));
var ImageBlock$L = styled.div(_templateObject3$L || (_templateObject3$L = _taggedTemplateLiteralLoose(["\n  width: 76.8%;\n  height: 73.5%;\n  margin-left: 11.6%;\n  text-align: center;\n"])));
var ImageInner$L = styled.div(_templateObject4$L || (_templateObject4$L = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$L = styled.div(_templateObject5$L || (_templateObject5$L = _taggedTemplateLiteralLoose(["\n  margin-left: 11.6%;\n  width: 76.9%;\n  height: 18.8%;\n  display: flex;\n  flex-direction: column-reverse;\n"])));
var TextFirst$L = styled.div(_templateObject6$L || (_templateObject6$L = _taggedTemplateLiteralLoose(["\n  padding-top: 6.1%;\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.18em;\n    font-size: 22.3px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.5%;\n    padding-right: 2.5%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    // top: 10.5mm;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 264px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$L = styled.div(_templateObject7$L || (_templateObject7$L = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  font-size: 10.5px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: normal;\n  margin-top: 2.35%;\n  text-align: center;\n  display: block;\n"])));
var TextSecond2$a = styled.div(_templateObject8$L || (_templateObject8$L = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  font-size: 10.5px;\n  font-weight: 600;\n  line-height: 1.1;\n  letter-spacing: normal;\n  margin-top: 2.35%;\n  text-align: center;\n  display: none;\n"])));
var TextThird$L = styled.div(_templateObject9$L || (_templateObject9$L = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  line-height: 1.1;\n  letter-spacing: 0.17px;\n  font-size: 13.8px;\n  margin-top: 1.1%;\n  text-align: center;\n"])));
var TextFour$a = styled.div(_templateObject10$a || (_templateObject10$a = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 6.9px;\n  margin-top: 2.4%;\n  text-align: center;\n"])));
var TextUrl$L = styled.div(_templateObject11$a || (_templateObject11$a = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 5.7px;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var TextUrl2$a = styled.div(_templateObject12$a || (_templateObject12$a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  height: 7.7%;\n  width: 100%;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 5.7px;\n  text-align: center;\n"])));
var TextUrl2None$a = styled.div(_templateObject13$a || (_templateObject13$a = _taggedTemplateLiteralLoose(["\n  height: 7.7%; ;\n"])));
var TextGift$a = styled.div(_templateObject14$a || (_templateObject14$a = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 0.5;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 8.2px;\n  margin-top: 5%;\n  text-align: center;\n  padding-bottom: 4.7%;\n"])));
var LuvrikCardA5 = function LuvrikCardA5(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(false),
    isGift = _useState[0],
    setIsGift = _useState[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$L, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$a, null, country);
    }
  };
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '') {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [country]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$L, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$L, null, isGift && /*#__PURE__*/React$1.createElement(TextUrl2$a, null, url), !isGift && /*#__PURE__*/React$1.createElement(TextUrl2None$a, null), /*#__PURE__*/React$1.createElement(ImageBlock$L, null, /*#__PURE__*/React$1.createElement(ImageInner$L, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$L, null, !isGift && /*#__PURE__*/React$1.createElement(TextUrl$L, null, url), isGift && /*#__PURE__*/React$1.createElement(TextGift$a, null, giftName), /*#__PURE__*/React$1.createElement(TextFour$a, null, textName), /*#__PURE__*/React$1.createElement(TextThird$L, null, museum), countryBlock(), /*#__PURE__*/React$1.createElement(TextFirst$L, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$M, _templateObject2$M, _templateObject3$M, _templateObject4$M, _templateObject5$M, _templateObject6$M, _templateObject7$M, _templateObject8$M, _templateObject9$M, _templateObject10$b, _templateObject11$b, _templateObject12$b, _templateObject13$b, _templateObject14$b, _templateObject15$5;
var Wrapper$M = styled.div(_templateObject$M || (_templateObject$M = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 148mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 148)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$M = styled.div(_templateObject2$M || (_templateObject2$M = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid white;\n  box-sizing: border-box;\n"])));
var ImageBlock$M = styled.div(_templateObject3$M || (_templateObject3$M = _taggedTemplateLiteralLoose(["\n  width: 93.3%;\n  height: 71.3%;\n  margin-left: 3.4%;\n  margin-top: 2.2%;\n"])));
var ImageInner$M = styled.div(_templateObject4$M || (_templateObject4$M = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    height: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n    size: auto;\n  }\n"])));
var TextBlock$M = styled.div(_templateObject5$M || (_templateObject5$M = _taggedTemplateLiteralLoose(["\n  width: 93.3%;\n  height: 16.9%;\n  margin-left: 3.4%;\n  padding-top: 3.6%;\n"])));
var TextFirst$M = styled.div(_templateObject6$M || (_templateObject6$M = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.235em;\n    font-size: 20.6px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 1.5%;\n    padding-right: 1.5%;\n    position: relative;\n    z-index: 2;\n    background: white;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 125.7mm;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 266px;\n    bottom: 50%;\n    left: 50%;\n    transform: translate(-50%, 0);\n  }\n"])));
var TextSecond$M = styled.div(_templateObject7$M || (_templateObject7$M = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  font-size: 10px;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.2px;\n  padding-top: 1.4%;\n  text-align: center;\n"])));
var TextSecond2$b = styled.div(_templateObject8$M || (_templateObject8$M = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextThird$M = styled.div(_templateObject9$M || (_templateObject9$M = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  line-height: 1.1;\n  letter-spacing: 0.26px;\n  font-size: 13.5px;\n  padding-top: 0.7%;\n  text-align: center;\n"])));
var TextFour$b = styled.div(_templateObject10$b || (_templateObject10$b = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 6.9px;\n  margin-top: ", ";\n  text-align: center;\n"])), function (props) {
  return props.marginTop;
});
var TextUrl$M = styled.div(_templateObject11$b || (_templateObject11$b = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 7.8px;\n  text-align: center;\n  margin-top: 2.1%;\n"])));
var TextUrlNone$5 = styled.div(_templateObject12$b || (_templateObject12$b = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 7.8px;\n  text-align: center;\n  margin-top: 4.7%;\n"])));
var TextUrl2$b = styled.div(_templateObject13$b || (_templateObject13$b = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: normal;\n  letter-spacing: 0;\n  font-size: 7.8px;\n  text-align: center;\n  margin-top: 2.5%;\n"])));
var TextUrl2None$b = styled.div(_templateObject14$b || (_templateObject14$b = _taggedTemplateLiteralLoose(["\n  display: none;\n"])));
var TextGift$b = styled.div(_templateObject15$5 || (_templateObject15$5 = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-style: italic;\n  line-height: 1;\n  font-weight: normal;\n  color: #c90000;\n  letter-spacing: normal;\n  font-size: 6pt;\n  margin-top: 0.8%;\n  text-align: center;\n"])));
var LuvrikCardA5L = function LuvrikCardA5L(props) {
  var image = props.image,
    url = props.url,
    museum = props.museum,
    name = props.name,
    country = props.country,
    number = props.number,
    dw = props.dw,
    dh = props.dh,
    giftName = props.giftName;
  var _useState = useState(1),
    classicState = _useState[0],
    setClassicState = _useState[1];
  var _useState2 = useState(false),
    isGift = _useState2[0],
    setIsGift = _useState2[1];
  var countryBlock = function countryBlock() {
    if (country !== null && country !== undefined && country !== '') {
      return /*#__PURE__*/React$1.createElement(TextSecond$M, null, country);
    } else {
      return /*#__PURE__*/React$1.createElement(TextSecond2$b, null, country);
    }
  };
  useEffect(function () {
    if (country !== null && country !== undefined && country !== '') {
      setClassicState(1);
    } else {
      setClassicState(2);
    }
  }, [country]);
  useEffect(function () {
    if (giftName !== null && giftName !== undefined && giftName !== '' && classicState === 1) {
      setIsGift(true);
    } else {
      setIsGift(false);
    }
  }, [giftName]);
  var textName = useMemo(function () {
    return string2Any(name, '❤️', /*#__PURE__*/React$1.createElement(HeartIcon, null));
  }, [name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$M, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$M, null, classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl$M, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrlNone$5, null), /*#__PURE__*/React$1.createElement(ImageBlock$M, null, /*#__PURE__*/React$1.createElement(ImageInner$M, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$M, null, /*#__PURE__*/React$1.createElement(TextFirst$M, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)), countryBlock(), /*#__PURE__*/React$1.createElement(TextThird$M, null, museum), /*#__PURE__*/React$1.createElement(TextFour$b, {
    marginTop: isGift ? '1%' : '1.5%'
  }, textName), classicState === 1 && /*#__PURE__*/React$1.createElement(TextUrl2None$b, null, url), classicState === 2 && /*#__PURE__*/React$1.createElement(TextUrl2$b, null, url), isGift && classicState === 1 && /*#__PURE__*/React$1.createElement(TextGift$b, null, giftName))));
};

var _templateObject$N, _templateObject2$N, _templateObject3$N, _templateObject4$N, _templateObject5$N, _templateObject6$N, _templateObject7$N, _templateObject8$N, _templateObject9$N, _templateObject10$c, _templateObject11$c, _templateObject12$c, _templateObject13$c;
var Wrapper$N = styled.div(_templateObject$N || (_templateObject$N = _taggedTemplateLiteralLoose(["\n  width: 148mm;\n  height: 209.9mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 148),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$N = styled.div(_templateObject2$N || (_templateObject2$N = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  border: 1px solid white;\n"])));
var ImageBlock$N = styled.div(_templateObject3$N || (_templateObject3$N = _taggedTemplateLiteralLoose(["\n  width: 76.5%;\n  height: 53.9%;\n  text-align: center;\n"])));
var ImageInner$N = styled.div(_templateObject4$N || (_templateObject4$N = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$N = styled.div(_templateObject5$N || (_templateObject5$N = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 76.5%;\n  height: 38%;\n  //background: blue;\n"])));
var Number = styled.div(_templateObject6$N || (_templateObject6$N = _taggedTemplateLiteralLoose(["\n  padding-top: 3.5%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.18em;\n    font-size: 22.3px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.8%;\n    padding-right: 2.8%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 28px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 265px;\n    left: 80px;\n  }\n"])));
var OrderName = styled.div(_templateObject7$N || (_templateObject7$N = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  font-style: normal;\n  font-size: 17px;\n  font-weight: normal;\n  line-height: 1.1;\n  margin-top: 8.5%;\n  letter-spacing: normal;\n  text-align: center;\n"])));
var Slogan = styled.div(_templateObject8$N || (_templateObject8$N = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 10.7px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: normal;\n  margin-top: 3.5%;\n"])));
var SloganHeader = styled.div(_templateObject9$N || (_templateObject9$N = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-size: 10px;\n  letter-spacing: 0.5px;\n  text-align: center;\n  font-weight: bold;\n  font-style: italic;\n  padding-bottom: 3px;\n"])));
var Description = styled.div(_templateObject10$c || (_templateObject10$c = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 7px;\n  font-weight: bold;\n  line-height: 10px;\n  letter-spacing: 0.02em;\n  margin-top: 10.5%;\n  text-align: justify;\n  text-align-last: center;\n"])));
var Signature = styled.div(_templateObject11$c || (_templateObject11$c = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  color: #c90000;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.17px;\n  font-size: 14.3px;\n  margin-top: 4%;\n  text-align: center;\n"])));
var SymbolSeparator = styled.div(_templateObject12$c || (_templateObject12$c = _taggedTemplateLiteralLoose(["\n  padding-top: 2.5%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Noto', serif;\n    font-size: 12px;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: normal;\n    position: absolute;\n    top: 21px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 65px;\n    left: 180px;\n  }\n"])));
var Url = styled.div(_templateObject13$c || (_templateObject13$c = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 5.7px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 8%;\n"])));
var ClassicCard3A5 = function ClassicCard3A5(props) {
  var image = props.image,
    url = props.url,
    slogan = props.slogan,
    description = props.description,
    signature = props.signature,
    orderName = props.orderName,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$N, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$N, null, /*#__PURE__*/React$1.createElement(Url, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$N, null, /*#__PURE__*/React$1.createElement(ImageInner$N, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$N, null, /*#__PURE__*/React$1.createElement(OrderName, null, orderName), /*#__PURE__*/React$1.createElement(Slogan, null, /*#__PURE__*/React$1.createElement(SloganHeader, null, "\u0414\u0435\u0432\u0438\u0437"), "\xAB", slogan, "\xBB"), /*#__PURE__*/React$1.createElement(Signature, null, signature), /*#__PURE__*/React$1.createElement(SymbolSeparator, null, /*#__PURE__*/React$1.createElement("span", null, "\u203B"), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(Description, null, description), /*#__PURE__*/React$1.createElement(Number, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$O, _templateObject2$O, _templateObject3$O, _templateObject4$O, _templateObject5$O, _templateObject6$O, _templateObject7$O, _templateObject8$O, _templateObject9$O, _templateObject10$d, _templateObject11$d, _templateObject12$d, _templateObject13$d;
var Wrapper$O = styled.div(_templateObject$O || (_templateObject$O = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$O = styled.div(_templateObject2$O || (_templateObject2$O = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  border: 1px solid white;\n"])));
var ImageBlock$O = styled.div(_templateObject3$O || (_templateObject3$O = _taggedTemplateLiteralLoose(["\n  width: 76.5%;\n  height: 53.9%;\n  text-align: center;\n  //background: red;\n"])));
var ImageInner$O = styled.div(_templateObject4$O || (_templateObject4$O = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$O = styled.div(_templateObject5$O || (_templateObject5$O = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 76.5%;\n  height: 38%;\n  //background: blue;\n"])));
var Number$1 = styled.div(_templateObject6$O || (_templateObject6$O = _taggedTemplateLiteralLoose(["\n  padding-top: 5.7%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.2em;\n    font-size: 27px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.8%;\n    padding-right: 2.8%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 53px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 357px;\n    left: 125px;\n  }\n"])));
var OrderName$1 = styled.div(_templateObject7$O || (_templateObject7$O = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  font-style: normal;\n  font-size: 24px;\n  font-weight: normal;\n  line-height: 1.1;\n  margin-top: 8.6%;\n  letter-spacing: normal;\n  text-align: center;\n"])));
var Slogan$1 = styled.div(_templateObject8$O || (_templateObject8$O = _taggedTemplateLiteralLoose(["\n  font-family: 'Noto', serif;\n  font-style: normal;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: normal;\n  margin-top: 3.5%;\n"])));
var SloganHeader$1 = styled.div(_templateObject9$O || (_templateObject9$O = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-size: 11.2px;\n  letter-spacing: 1.7px;\n  text-align: center;\n  font-weight: bold;\n  font-style: italic;\n  padding-bottom: 3px;\n  margin-top: 1%;\n"])));
var Description$1 = styled.div(_templateObject10$d || (_templateObject10$d = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 10.7px;\n  font-weight: normal;\n  line-height: normal;\n  letter-spacing: 0.01em;\n  margin-top: 11.5%;\n  text-align: justify;\n  text-align-last: center;\n"])));
var Signature$1 = styled.div(_templateObject11$d || (_templateObject11$d = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  color: #c90000;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.28px;\n  font-size: 20px;\n  margin-top: 4.2%;\n  text-align: center;\n"])));
var SymbolSeparator$1 = styled.div(_templateObject12$d || (_templateObject12$d = _taggedTemplateLiteralLoose(["\n  padding-top: 2.9%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Noto', serif;\n    font-size: 16px;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: normal;\n    position: absolute;\n    top: 29px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 90px;\n    left: 258px;\n  }\n"])));
var Url$1 = styled.div(_templateObject13$d || (_templateObject13$d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 5.7px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 8%;\n"])));
var ClassicCard3A4 = function ClassicCard3A4(props) {
  var image = props.image,
    url = props.url,
    slogan = props.slogan,
    description = props.description,
    signature = props.signature,
    orderName = props.orderName,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$O, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$O, null, /*#__PURE__*/React$1.createElement(Url$1, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$O, null, /*#__PURE__*/React$1.createElement(ImageInner$O, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$O, null, /*#__PURE__*/React$1.createElement(OrderName$1, null, orderName), /*#__PURE__*/React$1.createElement(Slogan$1, null, /*#__PURE__*/React$1.createElement(SloganHeader$1, null, "\u0414\u0435\u0432\u0438\u0437"), "\xAB", slogan, "\xBB"), /*#__PURE__*/React$1.createElement(Signature$1, null, signature), /*#__PURE__*/React$1.createElement(SymbolSeparator$1, null, /*#__PURE__*/React$1.createElement("span", null, "\u203B"), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(Description$1, null, description), /*#__PURE__*/React$1.createElement(Number$1, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$P, _templateObject2$P, _templateObject3$P, _templateObject4$P, _templateObject5$P, _templateObject6$P, _templateObject7$P, _templateObject8$P, _templateObject9$P, _templateObject10$e, _templateObject11$e, _templateObject12$e, _templateObject13$e;
var Wrapper$P = styled.div(_templateObject$P || (_templateObject$P = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  height: 420mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$P = styled.div(_templateObject2$P || (_templateObject2$P = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  border: 1px solid white;\n"])));
var ImageBlock$P = styled.div(_templateObject3$P || (_templateObject3$P = _taggedTemplateLiteralLoose(["\n  width: 76.5%;\n  height: 53.9%;\n  text-align: center;\n  //background: red;\n"])));
var ImageInner$P = styled.div(_templateObject4$P || (_templateObject4$P = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$P = styled.div(_templateObject5$P || (_templateObject5$P = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 76.5%;\n  height: 38%;\n  //background: blue;\n"])));
var Number$2 = styled.div(_templateObject6$P || (_templateObject6$P = _taggedTemplateLiteralLoose(["\n  padding-top: 5.7%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.2em;\n    font-size: 34.6px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.8%;\n    padding-right: 2.8%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 71px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 460px;\n    left: 200px;\n  }\n"])));
var OrderName$2 = styled.div(_templateObject7$P || (_templateObject7$P = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  font-style: normal;\n  font-size: 35px;\n  font-weight: normal;\n  line-height: 1.1;\n  margin-top: 8.6%;\n  letter-spacing: normal;\n  text-align: center;\n"])));
var Slogan$2 = styled.div(_templateObject8$P || (_templateObject8$P = _taggedTemplateLiteralLoose(["\n  font-family: 'Noto', serif;\n  font-style: normal;\n  font-size: 17px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: 1.6px;\n  margin-top: 3.5%;\n"])));
var SloganHeader$2 = styled.div(_templateObject9$P || (_templateObject9$P = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-size: 14.5px;\n  letter-spacing: 3px;\n  text-align: center;\n  font-weight: bold;\n  font-style: italic;\n  padding-bottom: 9px;\n  margin-top: 1.5%;\n"])));
var Description$2 = styled.div(_templateObject10$e || (_templateObject10$e = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 14px;\n  font-weight: normal;\n  line-height: normal;\n  letter-spacing: 0.02em;\n  margin-top: 11.5%;\n  text-align: justify;\n  text-align-last: center;\n"])));
var Signature$2 = styled.div(_templateObject11$e || (_templateObject11$e = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  color: #c90000;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: 0.28px;\n  font-size: 28.8px;\n  margin-top: 4.2%;\n  text-align: center;\n"])));
var SymbolSeparator$2 = styled.div(_templateObject12$e || (_templateObject12$e = _taggedTemplateLiteralLoose(["\n  padding-top: 2.9%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Noto', serif;\n    font-size: 21px;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: normal;\n    position: absolute;\n    top: 41px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 125px;\n    left: 367px;\n  }\n"])));
var Url$2 = styled.div(_templateObject13$e || (_templateObject13$e = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 7px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 8%;\n"])));
var ClassicCard3A3 = function ClassicCard3A3(props) {
  var image = props.image,
    url = props.url,
    slogan = props.slogan,
    description = props.description,
    signature = props.signature,
    orderName = props.orderName,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$P, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$P, null, /*#__PURE__*/React$1.createElement(Url$2, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$P, null, /*#__PURE__*/React$1.createElement(ImageInner$P, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$P, null, /*#__PURE__*/React$1.createElement(OrderName$2, null, orderName), /*#__PURE__*/React$1.createElement(Slogan$2, null, /*#__PURE__*/React$1.createElement(SloganHeader$2, null, "\u0414\u0435\u0432\u0438\u0437"), "\xAB", slogan, "\xBB"), /*#__PURE__*/React$1.createElement(Signature$2, null, signature), /*#__PURE__*/React$1.createElement(SymbolSeparator$2, null, /*#__PURE__*/React$1.createElement("span", null, "\u203B"), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(Description$2, null, description), /*#__PURE__*/React$1.createElement(Number$2, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$Q, _templateObject2$Q, _templateObject3$Q, _templateObject4$Q, _templateObject5$Q, _templateObject6$Q, _templateObject7$Q, _templateObject8$Q, _templateObject9$Q, _templateObject10$f, _templateObject11$f, _templateObject12$f, _templateObject13$f;
var Wrapper$Q = styled.div(_templateObject$Q || (_templateObject$Q = _taggedTemplateLiteralLoose(["\n  width: 420mm;\n  height: 594mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 594)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$Q = styled.div(_templateObject2$Q || (_templateObject2$Q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  border: 1px solid white;\n"])));
var ImageBlock$Q = styled.div(_templateObject3$Q || (_templateObject3$Q = _taggedTemplateLiteralLoose(["\n  width: 76.5%;\n  height: 53.9%;\n  text-align: center;\n  //background: red;\n"])));
var ImageInner$Q = styled.div(_templateObject4$Q || (_templateObject4$Q = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$Q = styled.div(_templateObject5$Q || (_templateObject5$Q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 76.5%;\n  height: 38%;\n  //background: blue;\n"])));
var Number$3 = styled.div(_templateObject6$Q || (_templateObject6$Q = _taggedTemplateLiteralLoose(["\n  padding-top: 5.5%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.2em;\n    font-size: 49.5px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.8%;\n    padding-right: 2.8%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 98px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 648px;\n    left: 285px;\n  }\n"])));
var OrderName$3 = styled.div(_templateObject7$Q || (_templateObject7$Q = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  font-style: normal;\n  font-size: 47px;\n  font-weight: normal;\n  line-height: 1.1;\n  margin-top: 8.6%;\n  letter-spacing: normal;\n  text-align: center;\n"])));
var Slogan$3 = styled.div(_templateObject8$Q || (_templateObject8$Q = _taggedTemplateLiteralLoose(["\n  font-family: 'Noto', serif;\n  font-style: normal;\n  font-size: 24.5px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: 1.6px;\n  margin-top: 3.5%;\n"])));
var SloganHeader$3 = styled.div(_templateObject9$Q || (_templateObject9$Q = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-size: 22px;\n  letter-spacing: 3px;\n  text-align: center;\n  font-weight: bold;\n  font-style: italic;\n  padding-bottom: 9px;\n  margin-top: 1.5%;\n"])));
var Description$3 = styled.div(_templateObject10$f || (_templateObject10$f = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 17.8px;\n  font-weight: normal;\n  line-height: normal;\n  letter-spacing: 0.02em;\n  margin-top: 12%;\n  text-align: justify;\n  text-align-last: center;\n"])));
var Signature$3 = styled.div(_templateObject11$f || (_templateObject11$f = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  color: #c90000;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 42px;\n  margin-top: 4.2%;\n  text-align: center;\n"])));
var SymbolSeparator$3 = styled.div(_templateObject12$f || (_templateObject12$f = _taggedTemplateLiteralLoose(["\n  padding-top: 3.3%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Noto', serif;\n    font-size: 27px;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: normal;\n    position: absolute;\n    top: 60px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 173px;\n    left: 520px;\n  }\n"])));
var Url$3 = styled.div(_templateObject13$f || (_templateObject13$f = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 10px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 8%;\n"])));
var ClassicCard3A2 = function ClassicCard3A2(props) {
  var image = props.image,
    url = props.url,
    slogan = props.slogan,
    description = props.description,
    signature = props.signature,
    orderName = props.orderName,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$Q, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$Q, null, /*#__PURE__*/React$1.createElement(Url$3, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$Q, null, /*#__PURE__*/React$1.createElement(ImageInner$Q, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$Q, null, /*#__PURE__*/React$1.createElement(OrderName$3, null, orderName), /*#__PURE__*/React$1.createElement(Slogan$3, null, /*#__PURE__*/React$1.createElement(SloganHeader$3, null, "\u0414\u0435\u0432\u0438\u0437"), "\xAB", slogan, "\xBB"), /*#__PURE__*/React$1.createElement(Signature$3, null, signature), /*#__PURE__*/React$1.createElement(SymbolSeparator$3, null, /*#__PURE__*/React$1.createElement("span", null, "\u203B"), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(Description$3, null, description), /*#__PURE__*/React$1.createElement(Number$3, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$R, _templateObject2$R, _templateObject3$R, _templateObject4$R, _templateObject5$R, _templateObject6$R, _templateObject7$R, _templateObject8$R, _templateObject9$R, _templateObject10$g, _templateObject11$g, _templateObject12$g, _templateObject13$g;
var Wrapper$R = styled.div(_templateObject$R || (_templateObject$R = _taggedTemplateLiteralLoose(["\n  width: 594mm;\n  height: 840mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 594),\n    calc(", " / 841)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$R = styled.div(_templateObject2$R || (_templateObject2$R = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  border: 1px solid white;\n"])));
var ImageBlock$R = styled.div(_templateObject3$R || (_templateObject3$R = _taggedTemplateLiteralLoose(["\n  width: 76.5%;\n  height: 53.9%;\n  text-align: center;\n  //background: red;\n"])));
var ImageInner$R = styled.div(_templateObject4$R || (_templateObject4$R = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$R = styled.div(_templateObject5$R || (_templateObject5$R = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 76.5%;\n  height: 38%;\n  //background: blue;\n"])));
var Number$4 = styled.div(_templateObject6$R || (_templateObject6$R = _taggedTemplateLiteralLoose(["\n  padding-top: 5.5%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.2em;\n    font-size: 70px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.8%;\n    padding-right: 2.8%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 139px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 918px;\n    left: 400px;\n  }\n"])));
var OrderName$4 = styled.div(_templateObject7$R || (_templateObject7$R = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  font-style: normal;\n  font-size: 54px;\n  font-weight: normal;\n  line-height: 1.1;\n  margin-top: 9.3%;\n  letter-spacing: normal;\n  text-align: center;\n"])));
var Slogan$4 = styled.div(_templateObject8$R || (_templateObject8$R = _taggedTemplateLiteralLoose(["\n  font-family: 'Noto', serif;\n  font-style: normal;\n  font-size: 29px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: 1.6px;\n  margin-top: 3.6%;\n"])));
var SloganHeader$4 = styled.div(_templateObject9$R || (_templateObject9$R = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-size: 32px;\n  letter-spacing: 3px;\n  text-align: center;\n  font-weight: bold;\n  font-style: italic;\n  padding-bottom: 18px;\n  margin-top: 1.5%;\n"])));
var Description$4 = styled.div(_templateObject10$g || (_templateObject10$g = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 22px;\n  font-weight: normal;\n  line-height: normal;\n  letter-spacing: 0.02em;\n  margin-top: 14.2%;\n  text-align: justify;\n  text-align-last: center;\n"])));
var Signature$4 = styled.div(_templateObject11$g || (_templateObject11$g = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  color: #c90000;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 56px;\n  margin-top: 4.2%;\n  text-align: center;\n"])));
var SymbolSeparator$4 = styled.div(_templateObject12$g || (_templateObject12$g = _taggedTemplateLiteralLoose(["\n  padding-top: 3.5%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Noto', serif;\n    font-size: 40px;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: normal;\n    position: absolute;\n    top: 89px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 250px;\n    left: 733px;\n  }\n"])));
var Url$4 = styled.div(_templateObject13$g || (_templateObject13$g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 14px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 8%;\n"])));
var ClassicCard3A1 = function ClassicCard3A1(props) {
  var image = props.image,
    url = props.url,
    slogan = props.slogan,
    description = props.description,
    signature = props.signature,
    orderName = props.orderName,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$R, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$R, null, /*#__PURE__*/React$1.createElement(Url$4, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$R, null, /*#__PURE__*/React$1.createElement(ImageInner$R, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$R, null, /*#__PURE__*/React$1.createElement(OrderName$4, null, orderName), /*#__PURE__*/React$1.createElement(Slogan$4, null, /*#__PURE__*/React$1.createElement(SloganHeader$4, null, "\u0414\u0435\u0432\u0438\u0437"), "\xAB", slogan, "\xBB"), /*#__PURE__*/React$1.createElement(Signature$4, null, signature), /*#__PURE__*/React$1.createElement(SymbolSeparator$4, null, /*#__PURE__*/React$1.createElement("span", null, "\u203B"), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(Description$4, null, description), /*#__PURE__*/React$1.createElement(Number$4, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$S, _templateObject2$S, _templateObject3$S, _templateObject4$S, _templateObject5$S, _templateObject6$S, _templateObject7$S, _templateObject8$S, _templateObject9$S, _templateObject10$h, _templateObject11$h, _templateObject12$h, _templateObject13$h;
var Wrapper$S = styled.div(_templateObject$S || (_templateObject$S = _taggedTemplateLiteralLoose(["\n  width: 841mm;\n  height: 1188mm;\n  border: 1px solid white;\n  transform: scale(\n    calc(", " / 841),\n    calc(", " / 1189)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$S = styled.div(_templateObject2$S || (_templateObject2$S = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  align-items: center;\n  border: 1px solid white;\n"])));
var ImageBlock$S = styled.div(_templateObject3$S || (_templateObject3$S = _taggedTemplateLiteralLoose(["\n  width: 76.5%;\n  height: 53.9%;\n  text-align: center;\n  //background: red;\n"])));
var ImageInner$S = styled.div(_templateObject4$S || (_templateObject4$S = _taggedTemplateLiteralLoose(["\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
var TextBlock$S = styled.div(_templateObject5$S || (_templateObject5$S = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  width: 76.5%;\n  height: 38%;\n  //background: blue;\n"])));
var Number$5 = styled.div(_templateObject6$S || (_templateObject6$S = _taggedTemplateLiteralLoose(["\n  padding-top: 5.9%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Baskerville', serif;\n    letter-spacing: 0.2em;\n    font-size: 80px;\n    font-style: italic;\n    display: inline-block;\n    padding-left: 2.9%;\n    padding-right: 2.9%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: italic;\n    position: absolute;\n    top: 195px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 1100px;\n    left: 670px;\n  }\n"])));
var OrderName$5 = styled.div(_templateObject7$S || (_templateObject7$S = _taggedTemplateLiteralLoose(["\n  font-family: 'zMr', serif;\n  font-style: normal;\n  font-size: 64px;\n  font-weight: normal;\n  line-height: 1.1;\n  margin-top: 8.78%;\n  letter-spacing: normal;\n  text-align: center;\n"])));
var Slogan$5 = styled.div(_templateObject8$S || (_templateObject8$S = _taggedTemplateLiteralLoose(["\n  font-family: 'Noto', serif;\n  font-style: normal;\n  font-size: 35px;\n  font-weight: normal;\n  line-height: 1.1;\n  letter-spacing: 1.6px;\n  margin-top: 5.2%;\n"])));
var SloganHeader$5 = styled.div(_templateObject9$S || (_templateObject9$S = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  font-size: 36px;\n  letter-spacing: 3px;\n  text-align: center;\n  font-weight: bold;\n  font-style: italic;\n  padding-bottom: 38px;\n  margin-top: 1.5%;\n"])));
var Description$5 = styled.div(_templateObject10$h || (_templateObject10$h = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto', serif;\n  font-style: normal;\n  font-size: 24.5px;\n  font-weight: normal;\n  line-height: normal;\n  width: calc(100% - 180px);\n  letter-spacing: 0.01em;\n  margin-top: 15%;\n  text-align: justify;\n  text-align-last: center;\n"])));
var Signature$5 = styled.div(_templateObject11$h || (_templateObject11$h = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville', serif;\n  color: #c90000;\n  line-height: 1.1;\n  font-weight: normal;\n  letter-spacing: normal;\n  font-size: 63px;\n  margin-top: 4.8%;\n  text-align: center;\n"])));
var SymbolSeparator$5 = styled.div(_templateObject12$h || (_templateObject12$h = _taggedTemplateLiteralLoose(["\n  padding-top: 3.8%;\n  text-align: center;\n  width: 100%;\n  position: relative;\n\n  span {\n    font-family: 'Noto', serif;\n    font-size: 49px;\n    font-style: normal;\n    display: inline-block;\n    padding-left: 1.6%;\n    padding-right: 1.6%;\n    position: relative;\n    background: white;\n    z-index: 2;\n  }\n\n  i {\n    font-family: 'Baskerville', serif;\n    font-style: normal;\n    position: absolute;\n    top: 126px;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 295px;\n    left: 1070px;\n  }\n"])));
var Url$5 = styled.div(_templateObject13$h || (_templateObject13$h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto', serif;\n  line-height: 0.5;\n  font-weight: bold;\n  letter-spacing: normal;\n  font-size: 13.5px;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 8%;\n"])));
var ClassicCard3A0 = function ClassicCard3A0(props) {
  var image = props.image,
    url = props.url,
    slogan = props.slogan,
    description = props.description,
    signature = props.signature,
    orderName = props.orderName,
    number = props.number,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$S, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$S, null, /*#__PURE__*/React$1.createElement(Url$5, null, url), /*#__PURE__*/React$1.createElement(ImageBlock$S, null, /*#__PURE__*/React$1.createElement(ImageInner$S, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$S, null, /*#__PURE__*/React$1.createElement(OrderName$5, null, orderName), /*#__PURE__*/React$1.createElement(Slogan$5, null, /*#__PURE__*/React$1.createElement(SloganHeader$5, null, "\u0414\u0435\u0432\u0438\u0437"), "\xAB", slogan, "\xBB"), /*#__PURE__*/React$1.createElement(Signature$5, null, signature), /*#__PURE__*/React$1.createElement(SymbolSeparator$5, null, /*#__PURE__*/React$1.createElement("span", null, "\u203B"), /*#__PURE__*/React$1.createElement("i", null)), /*#__PURE__*/React$1.createElement(Description$5, null, description), /*#__PURE__*/React$1.createElement(Number$5, null, /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("i", null)))));
};

var _templateObject$T, _templateObject2$T, _templateObject3$T;
var TextMainBlock = styled.div(_templateObject$T || (_templateObject$T = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var TextHeadBlock = styled.div(_templateObject2$T || (_templateObject2$T = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 15.5px;\n    padding-bottom: 3px;\n    padding-top: 3.5px;\n    line-height: 1;\n    letter-spacing: 3px;\n"])));
var TextBodyBlock = styled.div(_templateObject3$T || (_templateObject3$T = _taggedTemplateLiteralLoose(["\n    font-family: 'Oranienbaum';\n    font-weight: 400;\n    font-size: 10.3px;\n    margin: 10px;\n    word-wrap: break-word;\n"])));
function TextBlock$T(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(TextMainBlock, null, /*#__PURE__*/React$1.createElement(TextHeadBlock, null, name), /*#__PURE__*/React$1.createElement(TextBodyBlock, null, body));
}

var _templateObject$U, _templateObject2$U, _templateObject3$U;
var CurMainBlock = styled.div(_templateObject$U || (_templateObject$U = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n    box-sizing: border-box;\n"])));
var CurBodyBlock = styled.div(_templateObject2$U || (_templateObject2$U = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n    position: relative;\n    font-family: 'Baskerville';\n    font-style: italic;\n    letter-spacing: 3px;\n    font-size: 18px;\n    height: 54px;\n    width: 100%;\n    word-wrap: break-word;\n    text-align: center;\n\n"])));
var CurHeaderBlock = styled.div(_templateObject3$U || (_templateObject3$U = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 15.5px;\n    padding-bottom: 3px;\n    padding-top: 3.5px;\n    line-height: 1;\n    letter-spacing: 3px;\n"])));
function TextBlock$U(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(CurMainBlock, null, /*#__PURE__*/React$1.createElement(CurHeaderBlock, null, name), /*#__PURE__*/React$1.createElement(CurBodyBlock, null, body));
}

var _templateObject$V, _templateObject2$V, _templateObject3$V, _templateObject4$T, _templateObject5$T, _templateObject6$T, _templateObject7$T;
var GerbMainFrame = styled.div(_templateObject$V || (_templateObject$V = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  max-height: 100%;\n"])));
var GerbImageBlock = styled.div(_templateObject2$V || (_templateObject2$V = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 136px;\n  height: 136px;\n  //width: 238px;\n  justify-content: center;\n  margin-top: 8%;\n  margin-bottom: 8%;\n  margin-right: auto;\n  margin-left: auto;\n\n  img {\n    //width: 136px;\n    //height: 100%;\n    width: 100%;\n  }\n"])));
var GerbTextBlock = styled.div(_templateObject3$V || (_templateObject3$V = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-family: 'Corki-Tuscan';\n  font-weight: 400;\n  font-size: 15.5px;\n  padding-left: 5%;\n  padding-right: 5%;\n  line-height: 1.1;\n  word-wrap: break-word;\n"])));
var GerbCountryBlock = styled.div(_templateObject4$T || (_templateObject4$T = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-family: 'Lehmann';\n  width: 238px;\n  height: 103px;\n  font-weight: 500;\n  font-size: 34px;\n  padding-bottom: 2.6%;\n  padding-top: 0.5%;\n  padding-left: 10%;\n  padding-right: 10%;\n  margin: auto;\n  line-height: 1;\n  letter-spacing: 1px;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var GerbTextSep = styled.div(_templateObject5$T || (_templateObject5$T = _taggedTemplateLiteralLoose(["\n  padding-bottom: 1%;\n"])));
var Sep = styled.div(_templateObject6$T || (_templateObject6$T = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  margin-left: 40%;\n  margin-right: 40%;\n"])));
var GerbTextNoSep = styled.div(_templateObject7$T || (_templateObject7$T = _taggedTemplateLiteralLoose(["\n  margin-top: 1%;\n"])));
function GerbBlock(props) {
  var gerbimage = props.gerbimage,
    headername = props.headername,
    countryname = props.countryname,
    capitalname = props.capitalname;
  return /*#__PURE__*/React$1.createElement(GerbMainFrame, null, /*#__PURE__*/React$1.createElement(GerbImageBlock, {
    className: "gerb_block_imageA3"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: gerbimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(GerbTextBlock, null, headername), /*#__PURE__*/React$1.createElement(GerbCountryBlock, null, countryname), /*#__PURE__*/React$1.createElement(GerbTextBlock, null, /*#__PURE__*/React$1.createElement(GerbTextSep, null, "\u0421\u0442\u043E\u043B\u0438\u0446\u0430: ", capitalname)));
}

var _templateObject$W, _templateObject2$W, _templateObject3$W, _templateObject4$U;
var AnimalMainBlock = styled.div(_templateObject$W || (_templateObject$W = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"])));
var AnimalHeaderBlock = styled.div(_templateObject2$W || (_templateObject2$W = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 15.5px;\n    padding-bottom: 3px;\n    padding-top: 3.5px;\n    line-height: 1;\n    letter-spacing: 3px;\n"])));
var AnimalBodyBlock = styled.div(_templateObject3$W || (_templateObject3$W = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 238px;\n  height: 88px;\n  box-sizing: border-box;\n"])));
var AnimalImageBlock = styled.div(_templateObject4$U || (_templateObject4$U = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n    font-family: 'Noto', serif;\n    font-size: 6px;\n    font-weight: 600;\n    width: 38px;\n    height: 45px;\n    box-sizing: border-box;\n\n    img{\n      display: flex;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      size: auto;\n    }\n"])));
function AnimalBlock(props) {
  var name = props.name,
    animals = props.animals,
    endpoint = props.endpoint;
  return /*#__PURE__*/React$1.createElement(AnimalMainBlock, null, /*#__PURE__*/React$1.createElement(AnimalHeaderBlock, null, name), /*#__PURE__*/React$1.createElement(AnimalBodyBlock, null, !!(animals && animals.length) && animals.map(function (item) {
    return /*#__PURE__*/React$1.createElement(AnimalImageBlock, null, /*#__PURE__*/React$1.createElement("img", {
      src: "" + ((endpoint ? endpoint + '/' : '') + item.attachments[0].files[0].url),
      alt: ""
    }), item.attachments[0].texts);
  })));
}

var _templateObject$X, _templateObject2$X, _templateObject3$X;
var QrMainBlock = styled.div(_templateObject$X || (_templateObject$X = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    max-height: 100%;\n"])));
var QrImageBlock = styled.div(_templateObject2$X || (_templateObject2$X = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n\n    img{\n      width: 77%;\n    }\n"])));
var QrTextBlock = styled.div(_templateObject3$X || (_templateObject3$X = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-family: 'Roboto';\n    font-size: 0.67rem;\n    margin-bottom: 5%;\n    justify-content: center;\n"])));
function QrBlock(props) {
  var qrimg = props.qrimg,
    qrurl = props.qrurl;
  return /*#__PURE__*/React$1.createElement(QrMainBlock, null, /*#__PURE__*/React$1.createElement(QrImageBlock, null, /*#__PURE__*/React$1.createElement("img", {
    src: qrimg
  })), /*#__PURE__*/React$1.createElement(QrTextBlock, null, qrurl));
}

var _templateObject$Y, _templateObject2$Y, _templateObject3$Y;
var NumMainBlock = styled.div(_templateObject$Y || (_templateObject$Y = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n"])));
var NumberTextBlock = styled.div(_templateObject2$Y || (_templateObject2$Y = _taggedTemplateLiteralLoose(["\n    margin-left: 17%;\n    margin-right: 17%;\n    margin-bottom: 6%;\n    margin-top: 6.5%;\n    text-align: center;\n    \n    span{\n      font-family: 'Baskerville';\n      font-style: italic;\n      font-size: 36px;\n      line-height: 25px;\n      letter-spacing: 10px;\n      z-index: 1;\n      background: white;\n      text-align: center;\n      position: relative;\n      padding-left: 5%;\n      padding-right: 3%;\n    }\n    \n    i{\n      position: absolute;\n      width: 440px;\n      left: 110px;\n      top: 88px;\n      border-top: 1px solid black;\n    }\n    \n"])));
var NumberTextGiftBlock = styled.div(_templateObject3$Y || (_templateObject3$Y = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-size: 14.6px;\n    font-family: 'Oranienbaum';\n    font-weight: 400;\n    border-top: 1px solid black;\n    justify-content: center;\n    padding-top: 1.3%;\n    padding-bottom: 1.2%;\n"])));
function NumberBlock(props) {
  var name = props.name,
    giftname = props.giftname;
  return /*#__PURE__*/React$1.createElement(NumMainBlock, null, /*#__PURE__*/React$1.createElement(NumberTextBlock, null, /*#__PURE__*/React$1.createElement("i", null), /*#__PURE__*/React$1.createElement("span", null, name)), /*#__PURE__*/React$1.createElement(NumberTextGiftBlock, null, giftname));
}

var _templateObject$Z, _templateObject2$Z, _templateObject3$Z, _templateObject4$V;
var MapRelBlock = styled.div(_templateObject$Z || (_templateObject$Z = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var MapImageBlock = styled.div(_templateObject2$Z || (_templateObject2$Z = _taggedTemplateLiteralLoose([" \n  img{\n    width: 100%;\n    max-height: 537px;\n  }\n"])));
var MapSvgBlock = styled.div(_templateObject3$Z || (_templateObject3$Z = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-height: 100%;\n    z-index: 9;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n"])));
var MapSvgImage = styled.div(_templateObject4$V || (_templateObject4$V = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n"])));
function MapBlock(props) {
  var mapimage = props.mapimage,
    mapsvg = props.mapsvg;
  return /*#__PURE__*/React$1.createElement(MapRelBlock, null, /*#__PURE__*/React$1.createElement(MapImageBlock, null, /*#__PURE__*/React$1.createElement("img", {
    src: mapimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(MapSvgBlock, null, /*#__PURE__*/React$1.createElement(MapSvgImage, {
    className: "map_svg_imageA3",
    dangerouslySetInnerHTML: {
      __html: mapsvg
    }
  })));
}

var getAnimals = function getAnimals(_ref) {
  var services = _ref.services;
  var animalsItems = services && services.length && services.filter(function (item) {
    return item.type === 'animals';
  });
  var animals = animalsItems && animalsItems.length && animalsItems[0].containers;
  return animals;
};

var _templateObject$_, _templateObject2$_, _templateObject3$_, _templateObject4$W, _templateObject5$U, _templateObject6$U, _templateObject7$U, _templateObject8$T, _templateObject9$T, _templateObject10$i, _templateObject11$i, _templateObject12$i, _templateObject13$i, _templateObject14$c;
var Wrapper$T = styled.div(_templateObject$_ || (_templateObject$_ = _taggedTemplateLiteralLoose(["\n    height: 297mm;\n    width: 210mm;\n    transform: scale(calc(", "/210), calc(", "/297));\n    transform-origin: left top;\n    user-select: none;\n  box-sizing: border-box;\n    "])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var PMMainBlock = styled.div(_templateObject2$_ || (_templateObject2$_ = _taggedTemplateLiteralLoose(["\n    padding: 33px;\n    height: 100%;\n    width: 100%;\n    box-sizing: border-box;\n"])));
var PMSecondBlock = styled.div(_templateObject3$_ || (_templateObject3$_ = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    padding: 2px;\n    background: white;\n    max-height: 100%;\n    max-width: 100%;\n    border: 2px solid black;\n  box-sizing: border-box;\n"])));
var PMFlexColumn = styled.div(_templateObject4$W || (_templateObject4$W = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n  box-sizing: border-box;\n"])));
var PMFlexRow = styled.div(_templateObject5$U || (_templateObject5$U = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n  box-sizing: border-box;\n"])));
var PMNumberBlock = styled.div(_templateObject6$U || (_templateObject6$U = _taggedTemplateLiteralLoose(["\n    width: 587px;\n    height: 135px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMQrBlock = styled.div(_templateObject7$U || (_templateObject7$U = _taggedTemplateLiteralLoose(["\n    width: 135px;\n    height: 135px;\n    border: 1px solid black;\n    display: flex;\n    box-sizing: border-box;\n"])));
var PMMapBlock = styled.div(_templateObject8$T || (_templateObject8$T = _taggedTemplateLiteralLoose(["\n    width: 720px;\n    height: 539px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMGerbBlock = styled.div(_templateObject9$T || (_templateObject9$T = _taggedTemplateLiteralLoose(["\n    width: 240px;\n    height: 374px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMClimatBlock = styled.div(_templateObject10$i || (_templateObject10$i = _taggedTemplateLiteralLoose(["\n    width: 240px;\n    height: 192px;\n    word-wrap: break-word;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMGeogrBlock = styled.div(_templateObject11$i || (_templateObject11$i = _taggedTemplateLiteralLoose(["\n    width: 240px;\n    height: 182px;\n    word-wrap: break-word;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMEconomBlock = styled.div(_templateObject12$i || (_templateObject12$i = _taggedTemplateLiteralLoose(["\n    width: 240px;\n    height: 182px;\n    word-wrap: break-word;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMAnimalBlock = styled.div(_templateObject13$i || (_templateObject13$i = _taggedTemplateLiteralLoose(["\n    width: 240px;\n    height: 113px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMCurBlock = styled.div(_templateObject14$c || (_templateObject14$c = _taggedTemplateLiteralLoose(["\n    width: 240px;\n    height: 79px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var MapCardA4 = function MapCardA4(props) {
  var num = props.num,
    gift = props.gift,
    qrimage = props.qrimage,
    qrtext = props.qrtext,
    mapimage = props.mapimage,
    mapsvg = props.mapsvg,
    gerbimage = props.gerbimage,
    country = props.country,
    countryname = props.countryname,
    capital = props.capital,
    countrysize = props.countrysize,
    climat = props.climat,
    geographic = props.geographic,
    currency = props.currency,
    economical = props.economical,
    dw = props.dw,
    dh = props.dh,
    animal0 = props.animal0,
    animal1 = props.animal1,
    animal2 = props.animal2,
    animal3 = props.animal3,
    animal4 = props.animal4,
    animal5 = props.animal5,
    externalStyles = props.externalStyles;
  var _ref = externalStyles || {},
    wrapStl = _ref.wrapStl,
    blockStl = _ref.blockStl,
    secondBlockStl = _ref.secondBlockStl,
    flexColumnStl = _ref.flexColumnStl,
    flexRowStl = _ref.flexRowStl,
    numberBlockStl = _ref.numberBlockStl,
    numberStl = _ref.numberStl,
    qrBlockStl = _ref.qrBlockStl,
    qrStl = _ref.qrStl,
    mapBlockStl = _ref.mapBlockStl,
    mapStl = _ref.mapStl,
    gerbBlockStl = _ref.gerbBlockStl,
    gerbStl = _ref.gerbStl,
    climatBlockStl = _ref.climatBlockStl,
    climatStl = _ref.climatStl,
    geogrBlockStl = _ref.geogrBlockStl,
    geogrStl = _ref.geogrStl,
    animalBlockStl = _ref.animalBlockStl,
    animalStl = _ref.animalStl,
    curBlockStl = _ref.curBlockStl,
    curStl = _ref.curStl,
    economBlockStl = _ref.economBlockStl,
    economStl = _ref.economStl;
  var services = props.services,
    endpoint = props.endpoint;
  var animals = getAnimals({
    services: services
  });
  return /*#__PURE__*/React$1.createElement(Wrapper$T, {
    dw: dw,
    dh: dh,
    className: wrapStl
  }, /*#__PURE__*/React$1.createElement(PMMainBlock, {
    className: blockStl
  }, /*#__PURE__*/React$1.createElement(PMSecondBlock, {
    className: secondBlockStl
  }, /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMFlexRow, {
    className: flexRowStl
  }, /*#__PURE__*/React$1.createElement(PMNumberBlock, {
    className: numberBlockStl
  }, /*#__PURE__*/React$1.createElement(NumberBlock, {
    name: num,
    giftname: gift,
    className: numberStl
  })), /*#__PURE__*/React$1.createElement(PMQrBlock, {
    className: qrBlockStl
  }, /*#__PURE__*/React$1.createElement(QrBlock, {
    qrimg: qrimage,
    qrurl: qrtext,
    className: qrStl
  })))), /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMMapBlock, {
    className: mapBlockStl
  }, /*#__PURE__*/React$1.createElement(MapBlock, {
    mapimage: mapimage,
    mapsvg: mapsvg,
    className: mapStl
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMFlexRow, {
    className: flexRowStl
  }, /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMGerbBlock, {
    className: gerbBlockStl
  }, /*#__PURE__*/React$1.createElement(GerbBlock, {
    gerbimage: gerbimage,
    headername: country,
    countryname: countryname,
    capitalname: capital,
    countrysize: countrysize,
    className: gerbStl
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMClimatBlock, {
    className: climatBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$T, {
    name: "Климат",
    body: climat,
    className: climatStl
  })), /*#__PURE__*/React$1.createElement(PMGeogrBlock, {
    className: geogrBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$T, {
    name: "Географическое положение",
    body: geographic,
    className: geogrStl
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMAnimalBlock, {
    className: animalBlockStl
  }, /*#__PURE__*/React$1.createElement(AnimalBlock, {
    className: animalStl,
    name: "Животный мир",
    image0: animal0,
    image1: animal1,
    image2: animal2,
    image3: animal3,
    image4: animal4,
    image5: animal5,
    animals: animals,
    endpoint: endpoint
  })), /*#__PURE__*/React$1.createElement(PMCurBlock, {
    className: curBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$U, {
    name: "Используемая валюта",
    body: currency,
    className: curStl
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMEconomBlock, {
    className: economBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$T, {
    name: "Экономический прогноз",
    body: economical,
    className: economStl
  })))))))));
};

var _templateObject$$, _templateObject2$$, _templateObject3$$;
var TextMainBlock$1 = styled.div(_templateObject$$ || (_templateObject$$ = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  max-height: 100%;\n"])));
var TextHeadBlock$1 = styled.div(_templateObject2$$ || (_templateObject2$$ = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  text-align: center;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 25px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  line-height: 1;\n  letter-spacing: 3px;\n"])));
var TextBodyBlock$1 = styled.div(_templateObject3$$ || (_templateObject3$$ = _taggedTemplateLiteralLoose(["\n  font-family: 'Oranienbaum';\n  font-weight: 400;\n  margin: 5%;\n  font-size: 15px;\n  word-wrap: break-word;\n"])));
function TextBlock$V(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(TextMainBlock$1, null, /*#__PURE__*/React$1.createElement(TextHeadBlock$1, null, name), /*#__PURE__*/React$1.createElement(TextBodyBlock$1, null, body));
}

var _templateObject$10, _templateObject2$10, _templateObject3$10;
var CurMainBlock$1 = styled.div(_templateObject$10 || (_templateObject$10 = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  max-height: 100%;\n"])));
var CurBodyBlock$1 = styled.div(_templateObject2$10 || (_templateObject2$10 = _taggedTemplateLiteralLoose(["\n  overflow: auto;\n  position: relative;\n  font-family: 'Baskerville';\n  font-style: italic;\n  letter-spacing: 4.2px;\n  font-size: 26px;\n  word-wrap: break-word;\n  text-align: center;\n  margin-top: 5.5%;\n"])));
var CurHeaderBlock$1 = styled.div(_templateObject3$10 || (_templateObject3$10 = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  text-align: center;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 25px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  line-height: 1;\n  letter-spacing: 3px;\n"])));
function CurBlock(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(CurMainBlock$1, null, /*#__PURE__*/React$1.createElement(CurHeaderBlock$1, null, name), /*#__PURE__*/React$1.createElement(CurBodyBlock$1, null, body));
}

var _templateObject$11, _templateObject2$11, _templateObject3$11, _templateObject4$X, _templateObject5$V, _templateObject6$V, _templateObject7$V;
var GerbMainFrame$1 = styled.div(_templateObject$11 || (_templateObject$11 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  height: 100%;\n"])));
var GerbImageBlock$1 = styled.div(_templateObject2$11 || (_templateObject2$11 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 340px;\n  justify-content: center;\n  margin-top: 8%;\n  margin-bottom: 10%;\n\n  img {\n    max-width: 57%;\n    max-height: 100%;\n  }\n"])));
var GerbTextBlock$1 = styled.div(_templateObject3$11 || (_templateObject3$11 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-family: 'Corki-Tuscan';\n  font-weight: 400;\n  font-size: 20.7px;\n  padding-left: 5%;\n  padding-right: 5%;\n  line-height: 1.2;\n  letter-spacing: 1px;\n  word-wrap: break-word;\n"])));
var GerbCountryBlock$1 = styled.div(_templateObject4$X || (_templateObject4$X = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 340px;\n  height: 148px;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 50px;\n  padding-left: 10%;\n  padding-right: 10%;\n  line-height: 1;\n  letter-spacing: 1px;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var GerbTextSep$1 = styled.div(_templateObject5$V || (_templateObject5$V = _taggedTemplateLiteralLoose(["\n  padding-bottom: 1%;\n"])));
var Sep$1 = styled.div(_templateObject6$V || (_templateObject6$V = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  margin-left: 40%;\n  margin-right: 40%;\n"])));
var GerbTextNoSep$1 = styled.div(_templateObject7$V || (_templateObject7$V = _taggedTemplateLiteralLoose(["\n  margin-top: 1%;\n  margin-bottom: 7%;\n"])));
function GerbBlock$1(props) {
  var _countrysize$match;
  var gerbimage = props.gerbimage,
    headername = props.headername,
    countryname = props.countryname,
    capitalname = props.capitalname,
    countrysize = props.countrysize;
  var withCountrySize = countrysize === null || countrysize === void 0 ? void 0 : (_countrysize$match = countrysize.match(/\d/g)) === null || _countrysize$match === void 0 ? void 0 : _countrysize$match.length;
  return /*#__PURE__*/React$1.createElement(GerbMainFrame$1, null, /*#__PURE__*/React$1.createElement(GerbImageBlock$1, {
    className: "gerb_block_imageA3"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: gerbimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(GerbTextBlock$1, null, headername), /*#__PURE__*/React$1.createElement(GerbCountryBlock$1, null, countryname), /*#__PURE__*/React$1.createElement(GerbTextBlock$1, null, /*#__PURE__*/React$1.createElement(GerbTextSep$1, null, "\u0421\u0442\u043E\u043B\u0438\u0446\u0430: ", capitalname), Boolean(withCountrySize) && /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Sep$1, null), /*#__PURE__*/React$1.createElement(GerbTextNoSep$1, null, "\u0422\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F: ", countrysize))));
}

var _templateObject$12, _templateObject2$12, _templateObject3$12;
var AnimalMainBlock$1 = styled.div(_templateObject$12 || (_templateObject$12 = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  max-height: 100%;\n"])));
var AnimalHeaderBlock$1 = styled.div(_templateObject2$12 || (_templateObject2$12 = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  text-align: center;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 25px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  line-height: 1;\n  letter-spacing: 3px;\n"])));
var AnimalBodyBlock$1 = styled.div(_templateObject3$12 || (_templateObject3$12 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  padding-top: 1%;\n  padding-left: 1%;\n  padding-right: 1%;\n  padding-bottom: 1%;\n  width: 340px;\n  height: 126px;\n  box-sizing: border-box;\n\n  img {\n    max-height: 70px;\n    width: 330px;\n    object-fit: cover;\n    size: auto;\n  }\n"])));
function AnimalBlock$1(props) {
  var name = props.name,
    image = props.image;
  return /*#__PURE__*/React$1.createElement(AnimalMainBlock$1, null, /*#__PURE__*/React$1.createElement(AnimalHeaderBlock$1, null, name), /*#__PURE__*/React$1.createElement(AnimalBodyBlock$1, null, /*#__PURE__*/React$1.createElement("img", {
    src: image
  })));
}

var _templateObject$13, _templateObject2$13, _templateObject3$13;
var QrMainBlock$1 = styled.div(_templateObject$13 || (_templateObject$13 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"])));
var QrImageBlock$1 = styled.div(_templateObject2$13 || (_templateObject2$13 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  margin-left: 13%;\n  margin-top: 7%;\n  max-height: 100%;\n\n  img {\n    width: 75%;\n    max-height: 100%;\n  }\n"])));
var QrTextBlock$1 = styled.div(_templateObject3$13 || (_templateObject3$13 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto';\n  font-size: calc(0.67rem * 1.6);\n  margin-bottom: 5%;\n  justify-content: center;\n"])));
function QrBlock$1(props) {
  var qrimg = props.qrimg,
    qrurl = props.qrurl;
  return /*#__PURE__*/React$1.createElement(QrMainBlock$1, null, /*#__PURE__*/React$1.createElement(QrImageBlock$1, null, /*#__PURE__*/React$1.createElement("img", {
    src: qrimg
  })), /*#__PURE__*/React$1.createElement(QrTextBlock$1, null, qrurl));
}

var _templateObject$14, _templateObject2$14, _templateObject3$14;
var NumMainBlock$1 = styled.div(_templateObject$14 || (_templateObject$14 = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var NumberTextBlock$1 = styled.div(_templateObject2$14 || (_templateObject2$14 = _taggedTemplateLiteralLoose(["\n  margin-left: 18%;\n  margin-right: 16.5%;\n  margin-bottom: 6%;\n  margin-top: 7%;\n  text-align: center;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: 56px;\n    line-height: 25px;\n    letter-spacing: 12px;\n    text-align: center;\n    z-index: 1;\n    position: relative;\n    background: white;\n    padding-left: 5%;\n    padding-right: 3%;\n  }\n\n  i {\n    position: absolute;\n    width: 620px;\n    left: 160px;\n    top: 120px;\n    border-top: 1px solid black;\n  }\n"])));
var NumberText = styled.div(_templateObject3$14 || (_templateObject3$14 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: 56px;\n    line-height: 25px;\n    letter-spacing: 10px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 60px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: 150px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: 150px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
function NumberBlock$1(props) {
  var name = props.name;
  return /*#__PURE__*/React$1.createElement(NumMainBlock$1, null, /*#__PURE__*/React$1.createElement(NumberText, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, name), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })));
}

var _templateObject$15, _templateObject2$15, _templateObject3$15, _templateObject4$Y;
var MapRelBlock$1 = styled.div(_templateObject$15 || (_templateObject$15 = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var MapImageBlock$1 = styled.div(_templateObject2$15 || (_templateObject2$15 = _taggedTemplateLiteralLoose(["\n  img {\n    width: 100%;\n    max-height: 763px;\n  }\n"])));
var MapSvgBlock$1 = styled.div(_templateObject3$15 || (_templateObject3$15 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  z-index: 9;\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  right: 0;\n  top: 0;\n"])));
var MapSvgImage$1 = styled.div(_templateObject4$Y || (_templateObject4$Y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"])));
function MapBlock$1(props) {
  var mapimage = props.mapimage,
    mapsvg = props.mapsvg;
  return /*#__PURE__*/React$1.createElement(MapRelBlock$1, null, /*#__PURE__*/React$1.createElement(MapImageBlock$1, null, /*#__PURE__*/React$1.createElement("img", {
    src: mapimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(MapSvgBlock$1, null, /*#__PURE__*/React$1.createElement(MapSvgImage$1, {
    className: "map_svg_imageA3",
    dangerouslySetInnerHTML: {
      __html: mapsvg
    }
  })));
}

var _templateObject$16, _templateObject2$16, _templateObject3$16, _templateObject4$Z, _templateObject5$W, _templateObject6$W, _templateObject7$W, _templateObject8$U, _templateObject9$U, _templateObject10$j, _templateObject11$j, _templateObject12$j, _templateObject13$j, _templateObject14$d;
var Wrapper$U = styled.div(_templateObject$16 || (_templateObject$16 = _taggedTemplateLiteralLoose(["\n  height: 420mm;\n  width: 297mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 420)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var PMMainBlock$1 = styled.div(_templateObject2$16 || (_templateObject2$16 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  padding: 45px;\n  box-sizing: border-box;\n"])));
var PMSecondBlock$1 = styled.div(_templateObject3$16 || (_templateObject3$16 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n  background: white;\n  max-height: 100%;\n  max-width: 100%;\n  border: 2px solid black;\n  box-sizing: border-box;\n"])));
var PMFlexColumn$1 = styled.div(_templateObject4$Z || (_templateObject4$Z = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n"])));
var PMFlexRow$1 = styled.div(_templateObject5$W || (_templateObject5$W = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  box-sizing: border-box;\n"])));
var PMNumberBlock$1 = styled.div(_templateObject6$W || (_templateObject6$W = _taggedTemplateLiteralLoose(["\n  width: 835px;\n  height: 190px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMQrBlock$1 = styled.div(_templateObject7$W || (_templateObject7$W = _taggedTemplateLiteralLoose(["\n  width: 190px;\n  height: 190px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMMapBlock$1 = styled.div(_templateObject8$U || (_templateObject8$U = _taggedTemplateLiteralLoose(["\n  width: 1025px;\n  height: 765px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMGerbBlock$1 = styled.div(_templateObject9$U || (_templateObject9$U = _taggedTemplateLiteralLoose(["\n  width: 342px;\n  height: 534px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMClimatBlock$1 = styled.div(_templateObject10$j || (_templateObject10$j = _taggedTemplateLiteralLoose(["\n  width: 341px;\n  height: 274px;\n  word-wrap: break-word;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMGeogrBlock$1 = styled.div(_templateObject11$j || (_templateObject11$j = _taggedTemplateLiteralLoose(["\n  width: 341px;\n  height: 260px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMEconomBlock$1 = styled.div(_templateObject12$j || (_templateObject12$j = _taggedTemplateLiteralLoose(["\n  width: 342px;\n  height: 260px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMAnimalBlock$1 = styled.div(_templateObject13$j || (_templateObject13$j = _taggedTemplateLiteralLoose(["\n  width: 342px;\n  height: 160px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMCurBlock$1 = styled.div(_templateObject14$d || (_templateObject14$d = _taggedTemplateLiteralLoose(["\n  width: 342px;\n  height: 114px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var MapCardA3 = function MapCardA3(props) {
  var num = props.num,
    gift = props.gift,
    qrimage = props.qrimage,
    qrtext = props.qrtext,
    mapimage = props.mapimage,
    mapsvg = props.mapsvg,
    gerbimage = props.gerbimage,
    country = props.country,
    countryname = props.countryname,
    capital = props.capital,
    countrysize = props.countrysize,
    climat = props.climat,
    geographic = props.geographic,
    animal = props.animal,
    currency = props.currency,
    economical = props.economical,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$U, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(PMMainBlock$1, null, /*#__PURE__*/React$1.createElement(PMSecondBlock$1, null, /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMFlexRow$1, null, /*#__PURE__*/React$1.createElement(PMNumberBlock$1, null, /*#__PURE__*/React$1.createElement(NumberBlock$1, {
    name: num,
    giftname: gift
  })), /*#__PURE__*/React$1.createElement(PMQrBlock$1, null, /*#__PURE__*/React$1.createElement(QrBlock$1, {
    qrimg: qrimage,
    qrurl: qrtext
  })))), /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMMapBlock$1, null, /*#__PURE__*/React$1.createElement(MapBlock$1, {
    mapimage: mapimage,
    mapsvg: mapsvg
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMFlexRow$1, null, /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMGerbBlock$1, null, /*#__PURE__*/React$1.createElement(GerbBlock$1, {
    gerbimage: gerbimage,
    headername: country,
    countryname: countryname,
    capitalname: capital,
    countrysize: countrysize
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMClimatBlock$1, null, /*#__PURE__*/React$1.createElement(TextBlock$V, {
    name: "\u041A\u043B\u0438\u043C\u0430\u0442",
    body: climat
  })), /*#__PURE__*/React$1.createElement(PMGeogrBlock$1, null, /*#__PURE__*/React$1.createElement(TextBlock$V, {
    name: "\u0413\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
    body: geographic
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMAnimalBlock$1, null, /*#__PURE__*/React$1.createElement(AnimalBlock$1, {
    name: "\u0416\u0438\u0432\u043E\u0442\u043D\u044B\u0439 \u043C\u0438\u0440",
    image: animal
  })), /*#__PURE__*/React$1.createElement(PMCurBlock$1, null, /*#__PURE__*/React$1.createElement(CurBlock, {
    name: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u0430\u044F \u0432\u0430\u043B\u044E\u0442\u0430",
    body: currency
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$1, null, /*#__PURE__*/React$1.createElement(PMEconomBlock$1, null, /*#__PURE__*/React$1.createElement(TextBlock$V, {
    name: "\u042D\u043A\u043E\u043D\u043E\u043C\u0438\u0447\u0435\u0441\u043A\u0438\u0439 \u043F\u0440\u043E\u0433\u043D\u043E\u0437",
    body: economical
  })))))))));
};

var _templateObject$17, _templateObject2$17, _templateObject3$17;
var TextMainBlock$2 = styled.div(_templateObject$17 || (_templateObject$17 = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var TextHeadBlock$2 = styled.div(_templateObject2$17 || (_templateObject2$17 = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 18px;\n    padding-bottom: 3px;\n    padding-top: 2px;\n    line-height: 1;\n    letter-spacing: 2px;\n"])));
var TextBodyBlock$2 = styled.div(_templateObject3$17 || (_templateObject3$17 = _taggedTemplateLiteralLoose(["\n    font-family: 'Oranienbaum';\n    line-height: 12px;\n    font-weight: 400;\n    margin-top: 8px;\n    margin-bottom: 8px;\n    margin-left: 11px;\n    margin-right: 10px;\n    font-size: 10.2px;\n    word-wrap: break-word;\n"])));
function TextBlock$W(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(TextMainBlock$2, null, /*#__PURE__*/React$1.createElement(TextHeadBlock$2, null, name), /*#__PURE__*/React$1.createElement(TextBodyBlock$2, null, body));
}

var _templateObject$18, _templateObject2$18, _templateObject3$18;
var CurMainBlock$2 = styled.div(_templateObject$18 || (_templateObject$18 = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var CurBodyBlock$2 = styled.div(_templateObject2$18 || (_templateObject2$18 = _taggedTemplateLiteralLoose(["\n    overflow: auto;\n    position: relative;\n    font-family: 'Baskerville';\n    font-style: italic;\n    letter-spacing: 3.55px;\n    font-size: 17px;\n    word-wrap: break-word;\n    text-align: center;\n    margin-top: 1%;\n    margin-bottom: 0;\n"])));
var CurHeaderBlock$2 = styled.div(_templateObject3$18 || (_templateObject3$18 = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 18px;\n    padding-bottom: 3px;\n    padding-top: 2px;\n    line-height: 1;\n    letter-spacing: 2px;\n"])));
function TextBlock$X(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(CurMainBlock$2, null, /*#__PURE__*/React$1.createElement(CurHeaderBlock$2, null, name), /*#__PURE__*/React$1.createElement(CurBodyBlock$2, null, body));
}

var _templateObject$19, _templateObject2$19, _templateObject3$19, _templateObject4$_, _templateObject5$X, _templateObject6$X, _templateObject7$X;
var GerbMainFrame$2 = styled.div(_templateObject$19 || (_templateObject$19 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  height: 100%;\n"])));
var GerbImageBlock$2 = styled.div(_templateObject2$19 || (_templateObject2$19 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 136px;\n  height: 136px;\n  justify-content: center;\n  max-height: 60%;\n  margin-top: 5.5%;\n  margin-bottom: 5%;\n  margin-right: auto;\n  margin-left: auto;\n\n  img {\n    width: 100%;\n  }\n"])));
var GerbTextBlock$2 = styled.div(_templateObject3$19 || (_templateObject3$19 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-family: 'Corki-Tuscan';\n  font-weight: 500;\n  font-size: 15.1px;\n  padding-left: 7%;\n  padding-right: 7%;\n  line-height: 1.1;\n  word-wrap: break-word;\n"])));
var GerbCountryBlock$2 = styled.div(_templateObject4$_ || (_templateObject4$_ = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 238px;\n  min-height: 103px;\n  max-height: 270px;\n  justify-content: center;\n  align-items: center;\n  text-align: center;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 35px;\n  padding: 0 10%;\n  line-height: 1;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var GerbTextSep$2 = styled.div(_templateObject5$X || (_templateObject5$X = _taggedTemplateLiteralLoose(["\n  padding-bottom: 1%;\n"])));
var Sep$2 = styled.div(_templateObject6$X || (_templateObject6$X = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  margin-left: 40%;\n  margin-right: 40%;\n"])));
var GerbTextNoSep$2 = styled.div(_templateObject7$X || (_templateObject7$X = _taggedTemplateLiteralLoose(["\n  margin-top: 1%;\n  margin-bottom: 7%;\n"])));
function GerbBlock$2(props) {
  var gerbimage = props.gerbimage,
    headername = props.headername,
    countryname = props.countryname,
    capitalname = props.capitalname;
  return /*#__PURE__*/React$1.createElement(GerbMainFrame$2, null, /*#__PURE__*/React$1.createElement(GerbImageBlock$2, {
    className: "gerb_block_imageA3"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: gerbimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(GerbTextBlock$2, null, headername), /*#__PURE__*/React$1.createElement(GerbCountryBlock$2, null, countryname), /*#__PURE__*/React$1.createElement(GerbTextBlock$2, null, /*#__PURE__*/React$1.createElement(GerbTextSep$2, null, "\u0421\u0442\u043E\u043B\u0438\u0446\u0430: ", capitalname)));
}

var _templateObject$1a, _templateObject2$1a, _templateObject3$1a, _templateObject4$$;
var AnimalMainBlock$2 = styled.div(_templateObject$1a || (_templateObject$1a = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var AnimalHeaderBlock$2 = styled.div(_templateObject2$1a || (_templateObject2$1a = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 18px;\n    padding-bottom: 3px;\n    padding-top: 2px;\n    line-height: 1;\n    letter-spacing: 2px;\n"])));
var AnimalBodyBlock$2 = styled.div(_templateObject3$1a || (_templateObject3$1a = _taggedTemplateLiteralLoose(["\n    margin: auto;\n    padding-top: 2px;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n    img{\n      max-height: 70px;\n      width: 260px;\n      object-fit: cover;\n      size: auto;\n    }\n"])));
var AnimalImageBlock$1 = styled.div(_templateObject4$$ || (_templateObject4$$ = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n    font-family: 'Noto', serif;\n    font-size: 6px;\n    font-weight: 600;\n    width: 38px;\n    height: 45px;\n    box-sizing: border-box;\n\n    img{\n      display: flex;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      size: auto;\n    }\n"])));
function AnimalBlock$2(props) {
  var name = props.name,
    animals = props.animals,
    endpoint = props.endpoint;
  return /*#__PURE__*/React$1.createElement(AnimalMainBlock$2, null, /*#__PURE__*/React$1.createElement(AnimalHeaderBlock$2, null, name), /*#__PURE__*/React$1.createElement(AnimalBodyBlock$2, null, !!(animals && animals.length) && animals.map(function (item) {
    return /*#__PURE__*/React$1.createElement(AnimalImageBlock$1, null, /*#__PURE__*/React$1.createElement("img", {
      src: endpoint + "/" + item.attachments[0].files[0].url
    }), item.attachments[0].texts);
  })));
}

var _templateObject$1b, _templateObject2$1b, _templateObject3$1b;
var QrMainBlock$2 = styled.div(_templateObject$1b || (_templateObject$1b = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n"])));
var QrImageBlock$2 = styled.div(_templateObject2$1b || (_templateObject2$1b = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 100%;\n    margin-left: 17px;\n    margin-right: 17px;\n    margin-top: 12px;\n    max-height: 100%;\n    \n    img{\n      width: 100px;\n      height: 100px;\n    }\n"])));
var QrTextBlock$2 = styled.div(_templateObject3$1b || (_templateObject3$1b = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-family: 'Roboto';\n    font-size: 0.67rem;\n    justify-content: center;\n"])));
function QrBlock$2(props) {
  var qrimg = props.qrimg,
    qrurl = props.qrurl;
  return /*#__PURE__*/React$1.createElement(QrMainBlock$2, null, /*#__PURE__*/React$1.createElement(QrImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: qrimg
  })), /*#__PURE__*/React$1.createElement(QrTextBlock$2, null, qrurl));
}

var _templateObject$1c, _templateObject2$1c, _templateObject3$1c;
var NumMainBlock$2 = styled.div(_templateObject$1c || (_templateObject$1c = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n\n"])));
var NumberTextBlock$2 = styled.div(_templateObject2$1c || (_templateObject2$1c = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 385px;\n    height: 30px;\n    padding-left: 15%;\n    padding-right: 16%;\n    justify-content: center;\n    align-items: center;\n    box-sizing: border-box;\n\n    span{\n      display: flex;\n      align-items: center;\n      font-family: 'Baskerville';\n      font-style: italic;\n      font-size: 24px;\n      height: 26px;\n      letter-spacing: 5px;\n      position: relative;\n      text-align: center;\n      padding-left: 5%;\n      padding-right: 5%;\n      z-index: 1;\n\n      background: white;\n      box-sizing: border-box;\n    }\n\n    i{\n      position: absolute;\n      width: 280px;\n      left: 625px;\n      top: 745px;\n      border-top: 1px solid black;\n    }\n"])));
var NumberTextGiftBlock$1 = styled.div(_templateObject3$1c || (_templateObject3$1c = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-family: 'Oranienbaum';\n    font-weight: 400;\n    font-size: 13.4px;\n    border-bottom: 1px solid black;\n    justify-content: center;\n    padding-top: 3.8%;\n    padding-bottom: 3.8%;\n"])));
function NumberBlock$2(props) {
  var name = props.name,
    giftname = props.giftname;
  return /*#__PURE__*/React$1.createElement(NumMainBlock$2, null, /*#__PURE__*/React$1.createElement(NumberTextGiftBlock$1, null, giftname), /*#__PURE__*/React$1.createElement(NumberTextBlock$2, null, /*#__PURE__*/React$1.createElement("span", null, name), /*#__PURE__*/React$1.createElement("i", null)));
}

var _templateObject$1d, _templateObject2$1d, _templateObject3$1d, _templateObject4$10;
var MapRelBlock$2 = styled.div(_templateObject$1d || (_templateObject$1d = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var MapImageBlock$2 = styled.div(_templateObject2$1d || (_templateObject2$1d = _taggedTemplateLiteralLoose([" \n  img{\n    width: 100%;\n    max-height: 595px;\n  }\n"])));
var MapSvgBlock$2 = styled.div(_templateObject3$1d || (_templateObject3$1d = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-height: 100%;\n    z-index: 9;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n"])));
var MapSvgImage$2 = styled.div(_templateObject4$10 || (_templateObject4$10 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n"])));
function MapBlock$2(props) {
  var mapimage = props.mapimage,
    mapsvg = props.mapsvg;
  return /*#__PURE__*/React$1.createElement(MapRelBlock$2, null, /*#__PURE__*/React$1.createElement(MapImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: mapimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(MapSvgBlock$2, null, /*#__PURE__*/React$1.createElement(MapSvgImage$2, {
    dangerouslySetInnerHTML: {
      __html: mapsvg
    }
  })));
}

var _templateObject$1e, _templateObject2$1e, _templateObject3$1e, _templateObject4$11, _templateObject5$Y, _templateObject6$Y, _templateObject7$Y, _templateObject8$V, _templateObject9$V, _templateObject10$k, _templateObject11$k, _templateObject12$k, _templateObject13$k, _templateObject14$e;
var Wrapper$V = styled.div(_templateObject$1e || (_templateObject$1e = _taggedTemplateLiteralLoose(["\n    height: 210mm;\n    width: 297mm;\n    transform: scale(calc(", "/297), calc(", "/210));\n    transform-origin: left top;\n    user-select: none;\n    box-sizing: border-box;\n    "])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var PMMainBlock$2 = styled.div(_templateObject2$1e || (_templateObject2$1e = _taggedTemplateLiteralLoose(["\n    padding-left: 28px;\n    padding-right: 26px;\n    padding-top: 29px;\n    padding-bottom: 33px;\n\n    //box-sizing: border-box;\n"])));
var PMSecondBlock$2 = styled.div(_templateObject3$1e || (_templateObject3$1e = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    padding: 2px;\n    background: white;\n    height: 100%;\n    width: 100%;\n    border: 2px solid black;\n    box-sizing: border-box;\n"])));
var PMFlexColumn$2 = styled.div(_templateObject4$11 || (_templateObject4$11 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n"])));
var PMFlexRow$2 = styled.div(_templateObject5$Y || (_templateObject5$Y = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: row;\n"])));
var PMNumberBlock$2 = styled.div(_templateObject6$Y || (_templateObject6$Y = _taggedTemplateLiteralLoose(["\n    height: 80px;\n    width: 387px;\n    border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMQrBlock$2 = styled.div(_templateObject7$Y || (_templateObject7$Y = _taggedTemplateLiteralLoose(["\n    height: 135px;\n    width: 135px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMMapBlock$2 = styled.div(_templateObject8$V || (_templateObject8$V = _taggedTemplateLiteralLoose(["\n    width: 794px;\n    height: 595px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMGerbBlock$2 = styled.div(_templateObject9$V || (_templateObject9$V = _taggedTemplateLiteralLoose(["\n    height: 367px;\n    width: 267px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMClimatBlock$2 = styled.div(_templateObject10$k || (_templateObject10$k = _taggedTemplateLiteralLoose(["\n    height: 127px;\n    width: 267px;\n    word-wrap: break-word;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var PMGeogrBlock$2 = styled.div(_templateObject11$k || (_templateObject11$k = _taggedTemplateLiteralLoose(["\n    height: 135px;\n    width: 267px;\n    border: 1px solid black;\n    word-wrap: break-word;\n    box-sizing: border-box;\n"])));
var PMEconomBlock$2 = styled.div(_templateObject12$k || (_templateObject12$k = _taggedTemplateLiteralLoose(["\n    height: 135px;\n    width: 272px;\n    border: 1px solid black;\n    word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var PMAnimalBlock$2 = styled.div(_templateObject13$k || (_templateObject13$k = _taggedTemplateLiteralLoose(["\n    height: 101px;\n    width: 267px;\n    border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMCurBlock$2 = styled.div(_templateObject14$e || (_templateObject14$e = _taggedTemplateLiteralLoose(["\n    height: 55px;\n    width: 387px;\n    border: 1px solid black;\n    box-sizing: border-box;\n"])));
var MapCardA4L = function MapCardA4L(props) {
  var num = props.num,
    gift = props.gift,
    qrimage = props.qrimage,
    qrtext = props.qrtext,
    mapimage = props.mapimage,
    mapsvg = props.mapsvg,
    gerbimage = props.gerbimage,
    country = props.country,
    countryname = props.countryname,
    capital = props.capital,
    countrysize = props.countrysize,
    climat = props.climat,
    geographic = props.geographic,
    animal = props.animal,
    currency = props.currency,
    economical = props.economical,
    dw = props.dw,
    dh = props.dh,
    externalStyles = props.externalStyles;
  var _ref = externalStyles || {},
    wrapStl = _ref.wrapStl,
    blockStl = _ref.blockStl,
    secondBlockStl = _ref.secondBlockStl,
    flexColumnStl = _ref.flexColumnStl,
    flexRowStl = _ref.flexRowStl,
    numberBlockStl = _ref.numberBlockStl,
    numberStl = _ref.numberStl,
    qrBlockStl = _ref.qrBlockStl,
    qrStl = _ref.qrStl,
    mapBlockStl = _ref.mapBlockStl,
    mapStl = _ref.mapStl,
    gerbBlockStl = _ref.gerbBlockStl,
    gerbStl = _ref.gerbStl,
    climatBlockStl = _ref.climatBlockStl,
    climatStl = _ref.climatStl,
    geogrBlockStl = _ref.geogrBlockStl,
    geogrStl = _ref.geogrStl,
    animalBlockStl = _ref.animalBlockStl,
    animalStl = _ref.animalStl,
    curBlockStl = _ref.curBlockStl,
    curStl = _ref.curStl,
    economBlockStl = _ref.economBlockStl,
    economStl = _ref.economStl;
  var services = props.services,
    endpoint = props.endpoint;
  var animals = getAnimals({
    services: services
  });
  return /*#__PURE__*/React$1.createElement(Wrapper$V, {
    dw: dw,
    dh: dh,
    className: wrapStl
  }, /*#__PURE__*/React$1.createElement(PMMainBlock$2, {
    className: blockStl
  }, /*#__PURE__*/React$1.createElement(PMSecondBlock$2, {
    className: secondBlockStl
  }, /*#__PURE__*/React$1.createElement(PMFlexRow$2, {
    className: flexRowStl
  }, /*#__PURE__*/React$1.createElement(PMFlexColumn$2, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMGerbBlock$2, {
    className: gerbBlockStl
  }, /*#__PURE__*/React$1.createElement(GerbBlock$2, {
    gerbimage: gerbimage,
    headername: country,
    countryname: countryname,
    capitalname: capital,
    countrysize: countrysize,
    className: gerbStl
  })), /*#__PURE__*/React$1.createElement(PMClimatBlock$2, {
    className: climatBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$W, {
    name: "Климат",
    body: climat,
    className: climatStl
  })), /*#__PURE__*/React$1.createElement(PMAnimalBlock$2, {
    className: animalBlockStl
  }, /*#__PURE__*/React$1.createElement(AnimalBlock$2, {
    name: "Животный мир",
    image: animal,
    className: animalStl,
    endpoint: endpoint,
    animals: animals
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$2, {
    className: flexColumnStl
  }, /*#__PURE__*/React$1.createElement(PMMapBlock$2, {
    className: mapBlockStl
  }, /*#__PURE__*/React$1.createElement(MapBlock$2, {
    mapimage: mapimage,
    mapsvg: mapsvg,
    className: mapStl
  })))), /*#__PURE__*/React$1.createElement(PMFlexRow$2, {
    className: flexRowStl
  }, /*#__PURE__*/React$1.createElement(PMGeogrBlock$2, {
    className: geogrBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$W, {
    name: "Географическое положение",
    body: geographic,
    className: geogrStl
  })), /*#__PURE__*/React$1.createElement(PMEconomBlock$2, {
    className: economBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$W, {
    name: "Экономичсекий прогноз",
    body: economical,
    className: economStl
  })), /*#__PURE__*/React$1.createElement(PMFlexColumn$2, null, /*#__PURE__*/React$1.createElement(PMCurBlock$2, {
    className: curBlockStl
  }, /*#__PURE__*/React$1.createElement(TextBlock$X, {
    name: "Используемая валюта",
    body: currency,
    className: curStl
  })), /*#__PURE__*/React$1.createElement(PMNumberBlock$2, {
    className: numberBlockStl
  }, /*#__PURE__*/React$1.createElement(NumberBlock$2, {
    name: num,
    giftname: gift,
    className: numberStl
  }))), /*#__PURE__*/React$1.createElement(PMQrBlock$2, {
    className: qrBlockStl
  }, /*#__PURE__*/React$1.createElement(QrBlock$2, {
    qrimg: qrimage,
    qrurl: qrtext,
    className: qrStl
  }))))));
};

var _templateObject$1f, _templateObject2$1f, _templateObject3$1f;
var TextMainBlock$3 = styled.div(_templateObject$1f || (_templateObject$1f = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  max-width: 100%;\n  max-height: 100%;\n"])));
var TextHeadBlock$3 = styled.div(_templateObject2$1f || (_templateObject2$1f = _taggedTemplateLiteralLoose(["\n  border-bottom: 1px solid black;\n  text-align: center;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 25px;\n  padding-bottom: 4px;\n  padding-top: 4px;\n  line-height: 1;\n  letter-spacing: 3px;\n"])));
var TextBodyBlock$3 = styled.div(_templateObject3$1f || (_templateObject3$1f = _taggedTemplateLiteralLoose(["\n  font-family: 'Noto';\n  font-weight: 400;\n  margin-top: 13px;\n  margin-bottom: 14px;\n  margin-left: 13px;\n  margin-right: 10px;\n  font-size: 12px;\n  word-wrap: break-word;\n"])));
function TextBlock$Y(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(TextMainBlock$3, null, /*#__PURE__*/React$1.createElement(TextHeadBlock$3, null, name), /*#__PURE__*/React$1.createElement(TextBodyBlock$3, null, body));
}

var _templateObject$1g, _templateObject2$1g, _templateObject3$1g;
var CurMainBlock$3 = styled.div(_templateObject$1g || (_templateObject$1g = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var CurBodyBlock$3 = styled.div(_templateObject2$1g || (_templateObject2$1g = _taggedTemplateLiteralLoose(["\n    overflow: auto;\n    position: relative;\n    font-family: 'Baskerville';\n    font-style: italic;\n    letter-spacing: 6px;\n    font-size: 22.3px;\n    word-wrap: break-word;\n    text-align: center;\n    margin-top: 1.5%;\n"])));
var CurHeaderBlock$3 = styled.div(_templateObject3$1g || (_templateObject3$1g = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 25px;\n    padding-bottom: 4px;\n    padding-top: 4px;\n    line-height: 1;\n    letter-spacing: 3px;\n"])));
function TextBlock$Z(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(CurMainBlock$3, null, /*#__PURE__*/React$1.createElement(CurHeaderBlock$3, null, name), /*#__PURE__*/React$1.createElement(CurBodyBlock$3, null, body));
}

var _templateObject$1h, _templateObject2$1h, _templateObject3$1h, _templateObject4$12, _templateObject5$Z;
var GerbMainFrame$3 = styled.div(_templateObject$1h || (_templateObject$1h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  max-width: 100%;\n  max-height: 100%;\n"])));
var GerbImageBlock$3 = styled.div(_templateObject2$1h || (_templateObject2$1h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: center;\n  width: 374px;\n  max-height: 60%;\n  margin-top: 5.5%;\n  margin-bottom: 4%;\n\n  img {\n    width: 57%;\n    max-height: 100%;\n  }\n"])));
var GerbTextBlock$3 = styled.div(_templateObject3$1h || (_templateObject3$1h = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-family: 'Corki-Tuscan';\n  font-weight: 400;\n  font-size: 22px;\n  padding-left: 10%;\n  padding-right: 10%;\n  line-height: 1;\n  word-wrap: break-word;\n"])));
var GerbCountryBlock$3 = styled.div(_templateObject4$12 || (_templateObject4$12 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  width: 374px;\n  height: 190px;\n  font-family: 'Lehmann';\n  font-weight: 500;\n  font-size: 50px;\n  padding-bottom: 2.6%;\n  padding-top: 0.5%;\n  padding-left: 5%;\n  padding-right: 5%;\n  margin: auto;\n  line-height: 1;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var GerbTextSep$3 = styled.div(_templateObject5$Z || (_templateObject5$Z = _taggedTemplateLiteralLoose(["\n  padding-bottom: 1%;\n"])));
function GerbBlock$3(props) {
  var gerbimage = props.gerbimage,
    headername = props.headername,
    countryname = props.countryname,
    capitalname = props.capitalname;
  return /*#__PURE__*/React$1.createElement(GerbMainFrame$3, null, /*#__PURE__*/React$1.createElement(GerbImageBlock$3, {
    className: "gerb_block_imageA3"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: gerbimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(GerbTextBlock$3, null, headername), /*#__PURE__*/React$1.createElement(GerbCountryBlock$3, null, countryname), /*#__PURE__*/React$1.createElement(GerbTextBlock$3, null, /*#__PURE__*/React$1.createElement(GerbTextSep$3, null, "\u0421\u0442\u043E\u043B\u0438\u0446\u0430: ", capitalname)));
}

var _templateObject$1i, _templateObject2$1i, _templateObject3$1i;
var AnimalMainBlock$3 = styled.div(_templateObject$1i || (_templateObject$1i = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var AnimalHeaderBlock$3 = styled.div(_templateObject2$1i || (_templateObject2$1i = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 25px;\n    padding-bottom: 4px;\n    padding-top: 4px;\n    line-height: 1;\n    letter-spacing: 2px;\n"])));
var AnimalBodyBlock$3 = styled.div(_templateObject3$1i || (_templateObject3$1i = _taggedTemplateLiteralLoose(["\n    margin: auto;\n    padding-top: 2px;\n    width: 100%;\n    height: 100%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    \n    img{\n      max-height: 100px;\n      width: 369px;\n      object-fit: cover;\n      size: auto;\n    }\n"])));
function AnimalBlock$3(props) {
  var name = props.name,
    image = props.image;
  return /*#__PURE__*/React$1.createElement(AnimalMainBlock$3, null, /*#__PURE__*/React$1.createElement(AnimalHeaderBlock$3, null, name), /*#__PURE__*/React$1.createElement(AnimalBodyBlock$3, null, /*#__PURE__*/React$1.createElement("img", {
    src: image
  })));
}

var _templateObject$1j, _templateObject2$1j, _templateObject3$1j;
var QrMainBlock$3 = styled.div(_templateObject$1j || (_templateObject$1j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n"])));
var QrImageBlock$3 = styled.div(_templateObject2$1j || (_templateObject2$1j = _taggedTemplateLiteralLoose(["\n  box-sizing: border-box;\n  display: flex;\n  width: 100%;\n  padding-left: 12%;\n  padding-top: 8%;\n  max-height: 100%;\n\n  img {\n    width: 140px;\n    height: 140px;\n  }\n"])));
var QrTextBlock$3 = styled.div(_templateObject3$1j || (_templateObject3$1j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  font-family: 'Roboto';\n  font-size: calc(0.67rem * 1.5);\n  justify-content: center;\n"])));
function QrBlock$3(props) {
  var qrimg = props.qrimg,
    qrurl = props.qrurl;
  return /*#__PURE__*/React$1.createElement(QrMainBlock$3, null, /*#__PURE__*/React$1.createElement(QrImageBlock$3, null, /*#__PURE__*/React$1.createElement("img", {
    src: qrimg
  })), /*#__PURE__*/React$1.createElement(QrTextBlock$3, null, qrurl));
}

var _templateObject$1k, _templateObject2$1k, _templateObject3$1k;
var NumMainBlock$3 = styled.div(_templateObject$1k || (_templateObject$1k = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var NumberTextGiftBlock$2 = styled.div(_templateObject2$1k || (_templateObject2$1k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1 1 60%;\n  font-family: 'Oranienbaum';\n  font-weight: 400;\n  font-size: 20px;\n  border-bottom: 1px solid black;\n  justify-content: center;\n  align-items: center;\n"])));
var NumberText$1 = styled.div(_templateObject3$1k || (_templateObject3$1k = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex: 1 1 40%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: 32px;\n    line-height: 25px;\n    letter-spacing: 7.5px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 35px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: 86px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: 86px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
function NumberBlock$3(props) {
  var name = props.name,
    giftname = props.giftname;
  return /*#__PURE__*/React$1.createElement(NumMainBlock$3, null, /*#__PURE__*/React$1.createElement(NumberTextGiftBlock$2, null, giftname), /*#__PURE__*/React$1.createElement(NumberText$1, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, name), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })));
}

var _templateObject$1l, _templateObject2$1l, _templateObject3$1l, _templateObject4$13;
var MapRelBlock$3 = styled.div(_templateObject$1l || (_templateObject$1l = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var MapImageBlock$3 = styled.div(_templateObject2$1l || (_templateObject2$1l = _taggedTemplateLiteralLoose(["\n  img{\n    width: 1111px;\n    height: 834px;\n  }\n"])));
var MapSvgBlock$3 = styled.div(_templateObject3$1l || (_templateObject3$1l = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-height: 100%;\n    z-index: 9;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n"])));
var MapSvgImage$3 = styled.div(_templateObject4$13 || (_templateObject4$13 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n"])));
function MapBlock$3(props) {
  var mapimage = props.mapimage,
    mapsvg = props.mapsvg;
  return /*#__PURE__*/React$1.createElement(MapRelBlock$3, null, /*#__PURE__*/React$1.createElement(MapImageBlock$3, null, /*#__PURE__*/React$1.createElement("img", {
    src: mapimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(MapSvgBlock$3, null, /*#__PURE__*/React$1.createElement(MapSvgImage$3, {
    dangerouslySetInnerHTML: {
      __html: mapsvg
    }
  })));
}

var _templateObject$1m, _templateObject2$1m, _templateObject3$1m, _templateObject4$14, _templateObject5$_, _templateObject6$Z, _templateObject7$Z, _templateObject8$W, _templateObject9$W, _templateObject10$l, _templateObject11$l, _templateObject12$l, _templateObject13$l, _templateObject14$f;
var Wrapper$W = styled.div(_templateObject$1m || (_templateObject$1m = _taggedTemplateLiteralLoose(["\n  height: 297mm;\n  width: 420mm;\n  transform: scale(\n    calc(", " / 420),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var PMMainBlock$3 = styled.div(_templateObject2$1m || (_templateObject2$1m = _taggedTemplateLiteralLoose(["\n  padding: 45px;\n  height: 297mm;\n  width: 420mm;\n  box-sizing: border-box;\n"])));
var PMSecondBlock$3 = styled.div(_templateObject3$1m || (_templateObject3$1m = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding: 2px;\n  background: white;\n  height: 100%;\n  width: 100%;\n  border: 3px solid black;\n  box-sizing: border-box;\n"])));
var PMFlexColumn$3 = styled.div(_templateObject4$14 || (_templateObject4$14 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n"])));
var PMFlexRow$3 = styled.div(_templateObject5$_ || (_templateObject5$_ = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n"])));
var PMNumberBlock$3 = styled.div(_templateObject6$Z || (_templateObject6$Z = _taggedTemplateLiteralLoose(["\n  height: 109px;\n  width: 544px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMQrBlock$3 = styled.div(_templateObject7$Z || (_templateObject7$Z = _taggedTemplateLiteralLoose(["\n  height: 187px;\n  width: 187px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMMapBlock$3 = styled.div(_templateObject8$W || (_templateObject8$W = _taggedTemplateLiteralLoose(["\n  width: 1113px;\n  height: 836px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMGerbBlock$3 = styled.div(_templateObject9$W || (_templateObject9$W = _taggedTemplateLiteralLoose(["\n  height: 518px;\n  width: 374px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMClimatBlock$3 = styled.div(_templateObject10$l || (_templateObject10$l = _taggedTemplateLiteralLoose(["\n  height: 178px;\n  width: 374px;\n  word-wrap: break-word;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMGeogrBlock$3 = styled.div(_templateObject11$l || (_templateObject11$l = _taggedTemplateLiteralLoose(["\n  height: 187px;\n  width: 374px;\n  border: 1px solid black;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var PMEconomBlock$3 = styled.div(_templateObject12$l || (_templateObject12$l = _taggedTemplateLiteralLoose(["\n  height: 187px;\n  width: 382px;\n  border: 1px solid black;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var PMAnimalBlock$3 = styled.div(_templateObject13$l || (_templateObject13$l = _taggedTemplateLiteralLoose(["\n  height: 140px;\n  width: 374px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMCurBlock$3 = styled.div(_templateObject14$f || (_templateObject14$f = _taggedTemplateLiteralLoose(["\n  height: 78px;\n  width: 544px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var MapCardA3L = function MapCardA3L(props) {
  var num = props.num,
    gift = props.gift,
    qrimage = props.qrimage,
    qrtext = props.qrtext,
    mapimage = props.mapimage,
    mapsvg = props.mapsvg,
    gerbimage = props.gerbimage,
    country = props.country,
    countryname = props.countryname,
    capital = props.capital,
    countrysize = props.countrysize,
    climat = props.climat,
    geographic = props.geographic,
    animal = props.animal,
    currency = props.currency,
    economical = props.economical,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$W, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(PMMainBlock$3, null, /*#__PURE__*/React$1.createElement(PMSecondBlock$3, null, /*#__PURE__*/React$1.createElement(PMFlexRow$3, null, /*#__PURE__*/React$1.createElement(PMFlexColumn$3, null, /*#__PURE__*/React$1.createElement(PMGerbBlock$3, null, /*#__PURE__*/React$1.createElement(GerbBlock$3, {
    gerbimage: gerbimage,
    headername: country,
    countryname: countryname,
    capitalname: capital,
    countrysize: countrysize
  })), /*#__PURE__*/React$1.createElement(PMClimatBlock$3, null, /*#__PURE__*/React$1.createElement(TextBlock$Y, {
    name: "\u041A\u043B\u0438\u043C\u0430\u0442",
    body: climat
  })), /*#__PURE__*/React$1.createElement(PMAnimalBlock$3, null, /*#__PURE__*/React$1.createElement(AnimalBlock$3, {
    name: "\u0416\u0438\u0432\u043E\u0442\u043D\u044B\u0439 \u043C\u0438\u0440",
    image: animal
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$3, null, /*#__PURE__*/React$1.createElement(PMMapBlock$3, null, /*#__PURE__*/React$1.createElement(MapBlock$3, {
    mapimage: mapimage,
    mapsvg: mapsvg
  })))), /*#__PURE__*/React$1.createElement(PMFlexRow$3, null, /*#__PURE__*/React$1.createElement(PMGeogrBlock$3, null, /*#__PURE__*/React$1.createElement(TextBlock$Y, {
    name: "\u0413\u0435\u043E\u0433\u0440\u0430\u0444\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435",
    body: geographic
  })), /*#__PURE__*/React$1.createElement(PMEconomBlock$3, null, /*#__PURE__*/React$1.createElement(TextBlock$Y, {
    name: "\u042D\u043A\u043E\u043D\u043E\u043C\u0438\u0447\u0441\u0435\u043A\u0438\u0439 \u043F\u0440\u043E\u0433\u043D\u043E\u0437",
    body: economical
  })), /*#__PURE__*/React$1.createElement(PMFlexColumn$3, null, /*#__PURE__*/React$1.createElement(PMCurBlock$3, null, /*#__PURE__*/React$1.createElement(TextBlock$Z, {
    name: "\u0418\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u043C\u0430\u044F \u0432\u0430\u043B\u044E\u0442\u0430",
    body: currency
  })), /*#__PURE__*/React$1.createElement(PMNumberBlock$3, null, /*#__PURE__*/React$1.createElement(NumberBlock$3, {
    name: num,
    giftname: gift
  }))), /*#__PURE__*/React$1.createElement(PMQrBlock$3, null, /*#__PURE__*/React$1.createElement(QrBlock$3, {
    qrimg: qrimage,
    qrurl: qrtext
  }))))));
};

var _templateObject$1n, _templateObject2$1n, _templateObject3$1n;
var TextMainBlock$4 = styled.div(_templateObject$1n || (_templateObject$1n = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var TextHeadBlock$4 = styled.div(_templateObject2$1n || (_templateObject2$1n = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 25px;\n    padding-bottom: 5px;\n    padding-top: 6px;\n    line-height: 1;\n    letter-spacing: 3.5px;\n"])));
var TextBodyBlock$4 = styled.div(_templateObject3$1n || (_templateObject3$1n = _taggedTemplateLiteralLoose(["\n    font-family: 'Noto';\n    font-weight: 400;\n    margin-top: 10px;\n    margin-bottom: 14px;\n    margin-left: 14px;\n    margin-right: 10px;\n    font-size: calc(9.2px * 1.50);\n    word-wrap: break-word;\n"])));
function TextBlock$_(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(TextMainBlock$4, null, /*#__PURE__*/React$1.createElement(TextHeadBlock$4, null, name), /*#__PURE__*/React$1.createElement(TextBodyBlock$4, null, body));
}

var _templateObject$1o, _templateObject2$1o, _templateObject3$1o;
var CurMainBlock$4 = styled.div(_templateObject$1o || (_templateObject$1o = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var CurBodyBlock$4 = styled.div(_templateObject2$1o || (_templateObject2$1o = _taggedTemplateLiteralLoose(["\n    overflow: auto;\n    position: relative;\n    font-family: 'Baskerville';\n    font-style: italic;\n    letter-spacing: 5.8px;\n    font-size: 22.3px;\n    word-wrap: break-word;\n    text-align: center;\n    margin-top: 0.35%;\n    font-weight: normal;\n"])));
var CurHeaderBlock$4 = styled.div(_templateObject3$1o || (_templateObject3$1o = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 25px;\n    padding-bottom: 5px;\n    padding-top: 6px;\n    line-height: 1;\n    letter-spacing: 3.5px;\n"])));
function TextBlock$$(props) {
  var name = props.name,
    body = props.body;
  return /*#__PURE__*/React$1.createElement(CurMainBlock$4, null, /*#__PURE__*/React$1.createElement(CurHeaderBlock$4, null, name), /*#__PURE__*/React$1.createElement(CurBodyBlock$4, null, body));
}

var _templateObject$1p, _templateObject2$1p, _templateObject3$1p, _templateObject4$15, _templateObject5$$, _templateObject6$_, _templateObject7$_, _templateObject8$X;
var GerbMainFrame$4 = styled.div(_templateObject$1p || (_templateObject$1p = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    max-width: 100%;\n    max-height: 100%;\n"])));
var GerbImageBlock$4 = styled.div(_templateObject2$1p || (_templateObject2$1p = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 75%;\n    max-height: 60%;\n    margin-top: 32.3%;\n    margin-right: 3%;\n    margin-bottom: 13.1%;\n\n    img{\n      width: 100%;\n      max-height: 100%;\n    }\n"])));
var GerbTextBlock$4 = styled.div(_templateObject3$1p || (_templateObject3$1p = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    font-family: 'Corki-Tuscan';\n    font-weight: normal;\n    letter-spacing: 0.8px;\n    font-size: 22.5px;\n    padding-left: 10%;\n    padding-right: 10%;\n    margin-right: 0.5%;\n    line-height: 1.2;\n    word-wrap: break-word;\n"])));
var GerbTextBlockBottom = styled.div(_templateObject4$15 || (_templateObject4$15 = _taggedTemplateLiteralLoose(["\n    text-align: center;\n    font-family: 'Corki-Tuscan';\n    font-weight: normal;\n    letter-spacing: 1px;\n    font-size: 23.7px;\n    padding-left: 8%;\n    padding-right: 8%;\n    line-height: 1.2;\n    margin-left: 1.5%;\n    word-wrap: break-word;\n"])));
var GerbCountryBlock$4 = styled.div(_templateObject5$$ || (_templateObject5$$ = _taggedTemplateLiteralLoose(["\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    text-align: center;\n    width: 320px;\n    height: 172px;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 54px;\n    letter-spacing: 1.5px;\n    padding-bottom: 2.6%;\n    padding-top: 0.5%;\n    padding-left: 1%;\n    padding-right: 1%;\n    line-height: 1.1;\n    word-wrap: break-word;\n"])));
var GerbTextSep$4 = styled.div(_templateObject6$_ || (_templateObject6$_ = _taggedTemplateLiteralLoose(["\n  padding-bottom: 1%;\n"])));
var Sep$3 = styled.div(_templateObject7$_ || (_templateObject7$_ = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    margin-left: 40%;\n    margin-right: 40%;\n"])));
var GerbTextNoSep$3 = styled.div(_templateObject8$X || (_templateObject8$X = _taggedTemplateLiteralLoose(["\n    margin-top: 1%;\n    margin-bottom: 7%;\n"])));
function GerbBlock$4(props) {
  var gerbimage = props.gerbimage,
    headername = props.headername,
    countryname = props.countryname,
    capitalname = props.capitalname;
  return /*#__PURE__*/React$1.createElement(GerbMainFrame$4, null, /*#__PURE__*/React$1.createElement(GerbImageBlock$4, {
    className: "gerb_block_imageA3"
  }, /*#__PURE__*/React$1.createElement("img", {
    src: gerbimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(GerbTextBlock$4, null, headername), /*#__PURE__*/React$1.createElement(GerbCountryBlock$4, null, countryname), /*#__PURE__*/React$1.createElement(GerbTextBlockBottom, null, /*#__PURE__*/React$1.createElement(GerbTextSep$4, null, "\u0421\u0442\u043E\u043B\u0438\u0446\u0430: ", capitalname)));
}

var _templateObject$1q, _templateObject2$1q, _templateObject3$1q, _templateObject4$16;
var AnimalMainBlock$4 = styled.div(_templateObject$1q || (_templateObject$1q = _taggedTemplateLiteralLoose(["\n    max-width: 100%;\n    max-height: 100%;\n"])));
var AnimalHeaderBlock$4 = styled.div(_templateObject2$1q || (_templateObject2$1q = _taggedTemplateLiteralLoose(["\n    border-bottom: 1px solid black;\n    text-align: center;\n    font-family: 'Lehmann';\n    font-weight: 500;\n    font-size: 25px;\n    padding-bottom: 5px;\n    padding-top: 6px;\n    line-height: 1;\n    letter-spacing: 3.5px;\n"])));
var AnimalBodyBlock$4 = styled.div(_templateObject3$1q || (_templateObject3$1q = _taggedTemplateLiteralLoose(["\n    display: flex;\n    margin: auto;\n    width: 100%;\n    height: 133px;\n    justify-content: center;\n    align-items: center;\n"])));
var AnimalImageBlock$2 = styled.div(_templateObject4$16 || (_templateObject4$16 = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    text-align: center;\n    align-items: center;\n    font-family: 'Noto', serif;\n    font-size: 9px;\n    font-weight: 600;\n    width: 70px;\n    height: 80px;\n\n    img{\n      display: flex;\n      width: 100%;\n      height: 100%;\n      object-fit: cover;\n      size: auto;\n    }\n\n"])));
function AnimalBlock$4(props) {
  var name = props.name,
    image0 = props.image0,
    image1 = props.image1,
    image2 = props.image2,
    image3 = props.image3,
    image4 = props.image4,
    image5 = props.image5;
  return /*#__PURE__*/React$1.createElement(AnimalMainBlock$4, null, /*#__PURE__*/React$1.createElement(AnimalHeaderBlock$4, null, name), /*#__PURE__*/React$1.createElement(AnimalBodyBlock$4, null, /*#__PURE__*/React$1.createElement(AnimalImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image0
  }), "\u0420\u044B\u0431\u0430"), /*#__PURE__*/React$1.createElement(AnimalImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image1
  }), "\u041A\u0440\u043E\u043B\u0438\u043A"), /*#__PURE__*/React$1.createElement(AnimalImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image2
  }), "\u0421\u0442\u0440\u0430\u0443\u0441"), /*#__PURE__*/React$1.createElement(AnimalImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image3
  }), "\u042F\u0449\u0435\u0440\u0438\u0446\u0430"), /*#__PURE__*/React$1.createElement(AnimalImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image4
  }), "\u0410\u043A\u0443\u043B\u0430"), /*#__PURE__*/React$1.createElement(AnimalImageBlock$2, null, /*#__PURE__*/React$1.createElement("img", {
    src: image5
  }), "\u0422\u044E\u043B\u0435\u043D\u044C")));
}

var _templateObject$1r, _templateObject2$1r, _templateObject3$1r;
var QrMainBlock$4 = styled.div(_templateObject$1r || (_templateObject$1r = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n"])));
var QrImageBlock$4 = styled.div(_templateObject2$1r || (_templateObject2$1r = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 100%;\n    margin-left: 12%;\n    margin-top: 10%;\n    max-height: 100%;\n    \n    img{\n      width: 138px;\n      height: 138px;\n    }\n"])));
var QrTextBlock$4 = styled.div(_templateObject3$1r || (_templateObject3$1r = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-family: 'Roboto';\n    font-size: calc(0.67rem * 1.50);\n    justify-content: center;\n"])));
function QrBlock$4(props) {
  var qrimg = props.qrimg,
    qrurl = props.qrurl;
  return /*#__PURE__*/React$1.createElement(QrMainBlock$4, null, /*#__PURE__*/React$1.createElement(QrImageBlock$4, null, /*#__PURE__*/React$1.createElement("img", {
    src: qrimg
  })), /*#__PURE__*/React$1.createElement(QrTextBlock$4, null, qrurl));
}

var _templateObject$1s, _templateObject2$1s, _templateObject3$1s;
var NumMainBlock$4 = styled.div(_templateObject$1s || (_templateObject$1s = _taggedTemplateLiteralLoose(["\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n"])));
var NumberTextBlock$3 = styled.div(_templateObject2$1s || (_templateObject2$1s = _taggedTemplateLiteralLoose(["\n  margin-left: 16%;\n  margin-right: 17%;\n  margin-bottom: 0%;\n  margin-top: 0.3%;\n  text-align: center;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: 32.5px;\n    letter-spacing: 7.5px;\n    position: relative;\n    text-align: center;\n    z-index: 1;\n    background: #ffffff;\n    padding-left: 6%;\n    padding-right: 6%;\n\n  }\n\n  i {\n    position: absolute;\n    width: 435px;\n    left: 1384px;\n    top: 1469px;\n    border-top: 1px solid black;\n  }\n"])));
var NumberTextGiftBlock$3 = styled.div(_templateObject3$1s || (_templateObject3$1s = _taggedTemplateLiteralLoose(["\n    display: flex;\n    font-family: 'Oranienbaum';\n    font-size: 20px;\n    font-weight: normal;\n    border-bottom: 1px solid black;\n    justify-content: center;\n    padding-top: 2.1%;\n    padding-bottom: 2.1%;\n"])));
function NumberBlock$4(props) {
  var name = props.name,
    giftname = props.giftname;
  return /*#__PURE__*/React$1.createElement(NumMainBlock$4, null, /*#__PURE__*/React$1.createElement(NumberTextGiftBlock$3, null, giftname), /*#__PURE__*/React$1.createElement(NumberTextBlock$3, null, /*#__PURE__*/React$1.createElement("span", null, name), /*#__PURE__*/React$1.createElement("i", null)));
}

var _templateObject$1t, _templateObject2$1t, _templateObject3$1t, _templateObject4$17;
var MapRelBlock$4 = styled.div(_templateObject$1t || (_templateObject$1t = _taggedTemplateLiteralLoose(["\n  position: relative;\n"])));
var MapImageBlock$4 = styled.div(_templateObject2$1t || (_templateObject2$1t = _taggedTemplateLiteralLoose(["\n  img{\n    width: 1662px;\n    height: 1244px;\n    box-sizing: border-box;\n  }\n"])));
var MapSvgBlock$4 = styled.div(_templateObject3$1t || (_templateObject3$1t = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    max-height: 100%;\n    z-index: 9;\n    position: absolute;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    top: 0;\n"])));
var MapSvgImage$4 = styled.div(_templateObject4$17 || (_templateObject4$17 = _taggedTemplateLiteralLoose(["\n    width: 100%;\n    height: 100%;\n"])));
function MapBlock$4(props) {
  var mapimage = props.mapimage,
    mapsvg = props.mapsvg;
  return /*#__PURE__*/React$1.createElement(MapRelBlock$4, null, /*#__PURE__*/React$1.createElement(MapImageBlock$4, null, /*#__PURE__*/React$1.createElement("img", {
    src: mapimage,
    alt: ""
  })), /*#__PURE__*/React$1.createElement(MapSvgBlock$4, null, /*#__PURE__*/React$1.createElement(MapSvgImage$4, {
    dangerouslySetInnerHTML: {
      __html: mapsvg
    }
  })));
}

var _templateObject$1u, _templateObject2$1u, _templateObject3$1u, _templateObject4$18, _templateObject5$10, _templateObject6$$, _templateObject7$$, _templateObject8$Y, _templateObject9$X, _templateObject10$m, _templateObject11$m, _templateObject12$m, _templateObject13$m, _templateObject14$g;
var Wrapper$X = styled.div(_templateObject$1u || (_templateObject$1u = _taggedTemplateLiteralLoose(["\n  height: 420mm;\n  width: 594mm;\n  transform: scale(calc(", " / 594), calc(", " / 420));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  border: 1px solid black;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var PMMainBlock$4 = styled.div(_templateObject2$1u || (_templateObject2$1u = _taggedTemplateLiteralLoose(["\n  padding-top: 62px;\n  padding-left: 60px;\n  padding-right: 82px;\n  padding-bottom: 80px;\n  height: 419.7mm;\n  width: 594mm;\n  box-sizing: border-box;\n"])));
var PMSecondBlock$4 = styled.div(_templateObject3$1u || (_templateObject3$1u = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  padding: 4px;\n  background: white;\n  height: 100%;\n  width: 100%;\n  border: 3px solid black;\n  box-sizing: border-box;\n\n"])));
var PMFlexColumn$4 = styled.div(_templateObject4$18 || (_templateObject4$18 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  box-sizing: border-box;\n"])));
var PMFlexRow$4 = styled.div(_templateObject5$10 || (_templateObject5$10 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: row;\n  box-sizing: border-box;\n"])));
var PMNumberBlock$4 = styled.div(_templateObject6$$ || (_templateObject6$$ = _taggedTemplateLiteralLoose(["\n  height: 110px;\n  width: 742px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMQrBlock$4 = styled.div(_templateObject7$$ || (_templateObject7$$ = _taggedTemplateLiteralLoose(["\n  height: 184px;\n  width: 185px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMMapBlock$4 = styled.div(_templateObject8$Y || (_templateObject8$Y = _taggedTemplateLiteralLoose(["\n  width: 1664px;\n  height: 1246px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMGerbBlock$4 = styled.div(_templateObject9$X || (_templateObject9$X = _taggedTemplateLiteralLoose(["\n  height: 876px;\n  width: 424px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMClimatBlock$4 = styled.div(_templateObject10$m || (_templateObject10$m = _taggedTemplateLiteralLoose(["\n  height: 185px;\n  width: 424px;\n  word-wrap: break-word;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMGeogrBlock$4 = styled.div(_templateObject11$m || (_templateObject11$m = _taggedTemplateLiteralLoose(["\n  height: 184px;\n  width: 424px;\n  border: 1px solid black;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var PMEconomBlock$4 = styled.div(_templateObject12$m || (_templateObject12$m = _taggedTemplateLiteralLoose(["\n  height: 184px;\n  width: 737px;\n  border: 1px solid black;\n  word-wrap: break-word;\n  box-sizing: border-box;\n"])));
var PMAnimalBlock$4 = styled.div(_templateObject13$m || (_templateObject13$m = _taggedTemplateLiteralLoose(["\n  height: 185px;\n  width: 424px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var PMCurBlock$4 = styled.div(_templateObject14$g || (_templateObject14$g = _taggedTemplateLiteralLoose(["\n  height: 74px;\n  width: 742px;\n  border: 1px solid black;\n  box-sizing: border-box;\n"])));
var MapCardA2L = function MapCardA2L(props) {
  var num = props.num,
    gift = props.gift,
    qrimage = props.qrimage,
    qrtext = props.qrtext,
    mapimage = props.mapimage,
    mapsvg = props.mapsvg,
    gerbimage = props.gerbimage,
    country = props.country,
    countryname = props.countryname,
    capital = props.capital,
    countrysize = props.countrysize,
    climat = props.climat,
    geographic = props.geographic,
    animal0 = props.animal0,
    animal1 = props.animal1,
    animal2 = props.animal2,
    animal3 = props.animal3,
    animal4 = props.animal4,
    animal5 = props.animal5,
    currency = props.currency,
    economical = props.economical,
    dw = props.dw,
    dh = props.dh;
  return /*#__PURE__*/React$1.createElement(Wrapper$X, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(PMMainBlock$4, null, /*#__PURE__*/React$1.createElement(PMSecondBlock$4, null, /*#__PURE__*/React$1.createElement(PMFlexRow$4, null, /*#__PURE__*/React$1.createElement(PMFlexColumn$4, null, /*#__PURE__*/React$1.createElement(PMGerbBlock$4, null, /*#__PURE__*/React$1.createElement(GerbBlock$4, {
    gerbimage: gerbimage,
    headername: country,
    countryname: countryname,
    capitalname: capital,
    countrysize: countrysize
  })), /*#__PURE__*/React$1.createElement(PMClimatBlock$4, null, /*#__PURE__*/React$1.createElement(TextBlock$_, {
    name: "Климат",
    body: climat
  })), /*#__PURE__*/React$1.createElement(PMAnimalBlock$4, null, /*#__PURE__*/React$1.createElement(AnimalBlock$4, {
    name: "Животный мир",
    image0: animal0,
    image1: animal1,
    image2: animal2,
    image3: animal3,
    image4: animal4,
    image5: animal5
  }))), /*#__PURE__*/React$1.createElement(PMFlexColumn$4, null, /*#__PURE__*/React$1.createElement(PMMapBlock$4, null, /*#__PURE__*/React$1.createElement(MapBlock$4, {
    mapimage: mapimage,
    mapsvg: mapsvg
  })))), /*#__PURE__*/React$1.createElement(PMFlexRow$4, null, /*#__PURE__*/React$1.createElement(PMGeogrBlock$4, null, /*#__PURE__*/React$1.createElement(TextBlock$_, {
    name: "Географическое положение",
    body: geographic
  })), /*#__PURE__*/React$1.createElement(PMEconomBlock$4, null, /*#__PURE__*/React$1.createElement(TextBlock$_, {
    name: "Экономичсекий прогноз",
    body: economical
  })), /*#__PURE__*/React$1.createElement(PMFlexColumn$4, null, /*#__PURE__*/React$1.createElement(PMCurBlock$4, null, /*#__PURE__*/React$1.createElement(TextBlock$$, {
    name: "Используемая валюта",
    body: currency
  })), /*#__PURE__*/React$1.createElement(PMNumberBlock$4, null, /*#__PURE__*/React$1.createElement(NumberBlock$4, {
    name: num,
    giftname: gift
  }))), /*#__PURE__*/React$1.createElement(PMQrBlock$4, null, /*#__PURE__*/React$1.createElement(QrBlock$4, {
    qrimg: qrimage,
    qrurl: qrtext
  }))))));
};

var _templateObject$1v, _templateObject2$1v, _templateObject3$1v, _templateObject4$19, _templateObject5$11, _templateObject6$10, _templateObject7$10, _templateObject8$Z;
var InfoFlexBox = styled.div(_templateObject$1v || (_templateObject$1v = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  justify-content: space-between;\n"])));
var Wrapper$Y = styled.div(_templateObject2$1v || (_templateObject2$1v = _taggedTemplateLiteralLoose(["\n  width: 297mm;\n  min-width: 297mm;\n  max-width: 297mm;\n  height: 420mm;\n  min-height: 420mm;\n  max-height: 420mm;\n  border: 1px solid white;\n  transform: scale(calc(", " / 297), calc(", " / 420));\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$T = styled.div(_templateObject3$1v || (_templateObject3$1v = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  //border: 1px solid white;\n  box-sizing: border-box;\n"])));
var ImageBlock$T = styled.div(_templateObject4$19 || (_templateObject4$19 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  max-width: 100%;\n  height: 1393px;\n  box-sizing: border-box;\n  margin-left: 72px;\n  margin-right: 74px;\n\n  img {\n    height: 100%;\n    width: 100%;\n    // object-fit: cover;\n  }\n"])));
var InfoBlock = styled.div(_templateObject5$11 || (_templateObject5$11 = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  margin-left: 72px;\n  margin-right: 74px;\n  box-sizing: border-box;\n  margin-top: 6px;\n"])));
var Url$6 = styled.div(_templateObject6$10 || (_templateObject6$10 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-size: 12.8pt;\n  font-style: normal;\n  max-width: 100%;\n  margin-left: 2px;\n"])));
var Coordinates = styled.div(_templateObject7$10 || (_templateObject7$10 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  font-size: 12.8pt;\n  font-style: normal;\n  max-width: 100%;\n"])));
var Number$6 = styled.div(_templateObject8$Z || (_templateObject8$Z = _taggedTemplateLiteralLoose(["\n  display: flex;\n  height: 84px;\n  align-items: center;\n  justify-content: center;\n  font-family: Roboto-Regular, Roboto, serif;\n  font-size: 16pt;\n  font-style: normal;\n"])));
var GeograffeeCardA3 = function GeograffeeCardA3(props) {
  return /*#__PURE__*/React$1.createElement(Wrapper$Y, {
    dw: props.dw,
    dh: props.dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$T, null, /*#__PURE__*/React$1.createElement(Number$6, null, "№ Ae " + props.number), /*#__PURE__*/React$1.createElement(ImageBlock$T, null, /*#__PURE__*/React$1.createElement("img", {
    src: props.image,
    alt: "",
    draggable: false
  })), /*#__PURE__*/React$1.createElement(InfoBlock, null, /*#__PURE__*/React$1.createElement(InfoFlexBox, null, /*#__PURE__*/React$1.createElement(Url$6, null, props.url), /*#__PURE__*/React$1.createElement(Coordinates, null, props.coordinates)))));
};

var removeEmojis = function removeEmojis(s) {
  return s.replace(emojiRegex(), '');
};

var isPlainObject = function isPlainObject(value) {
  if (value === null || typeof value !== 'object') return false;
  var proto = Object.getPrototypeOf(value);
  return proto === Object.prototype || proto === null;
};
var _deepRemoveEmojis = function deepRemoveEmojis(input, seen) {
  if (seen === void 0) {
    seen = new WeakSet();
  }
  if (input === null || input === undefined) return input;
  var type = typeof input;
  if (type === 'number' || type === 'boolean' || type === 'bigint' || type === 'symbol' || type === 'function') {
    return input;
  }
  if (type === 'string') {
    return removeEmojis(input);
  }
  if (React$1.isValidElement(input)) {
    return input;
  }
  if (typeof input === 'object') {
    if (seen.has(input)) return input;
    seen.add(input);
    if (input instanceof Date || input instanceof RegExp || input instanceof Map || input instanceof Set) {
      return input;
    }
    if (Array.isArray(input)) {
      return input.map(function (item) {
        return _deepRemoveEmojis(item, seen);
      });
    }
    if (isPlainObject(input)) {
      var result = {};
      for (var key in input) {
        if (!Object.prototype.hasOwnProperty.call(input, key)) continue;
        var value = input[key];
        result[key] = _deepRemoveEmojis(value, seen);
      }
      return result;
    }
    return input;
  }
  return input;
};

var components = {
  WarholCardA5L: WarholCardA5L,
  WarholCardA5: WarholCardA5,
  WarholCardA4L: WarholCardA4L,
  WarholCardA4: WarholCardA4,
  WarholCardA3L: WarholCardA3L,
  WarholCardA3: WarholCardA3,
  WarholCardA2L: WarholCardA2L,
  WarholCardA2: WarholCardA2,
  WarholCardA1L: WarholCardA1L,
  WarholCardA1: WarholCardA1,
  WarholCardA0L: WarholCardA0L,
  WarholCardA0: WarholCardA0
};
var WarholStyleCard = function WarholStyleCard(props) {
  var _templateDataComputed, _templateDataComputed2;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components[templateType], {
    url: templateDataComputed && templateDataComputed.link || 'gallllery.com',
    image: image,
    number: cardNumber.replace('№ ', '№'),
    museum: templateDataComputed && templateDataComputed.description || '',
    name: templateDataComputed && templateDataComputed.title && templateDataComputed.title.toString() || '',
    dw: dw,
    dh: dh,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed = templateDataComputed.subTitle) === null || _templateDataComputed === void 0 ? void 0 : _templateDataComputed.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed2 = templateDataComputed.description) === null || _templateDataComputed2 === void 0 ? void 0 : _templateDataComputed2.toString())
  });
};

var _templateObject$1w, _templateObject2$1w, _templateObject3$1w, _templateObject4$1a, _templateObject5$12, _templateObject6$11, _templateObject7$11, _templateObject8$_, _templateObject9$Y;
var Wrapper$Z = styled.div(_templateObject$1w || (_templateObject$1w = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(calc(", " / ", "), calc(", " / ", "));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (p) {
  return p.width;
}, function (p) {
  return p.height;
}, function (p) {
  return p.dw;
}, function (p) {
  return p.width;
}, function (p) {
  return p.dh;
}, function (p) {
  return p.height;
}, function (p) {
  return p.paddingX;
});
var MainBlock$U = styled.div(_templateObject2$1w || (_templateObject2$1w = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$N = styled.div(_templateObject3$1w || (_templateObject3$1w = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: ", "px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: ", "px;\n    margin-top: ", "px;\n  }\n"])), function (p) {
  return p.urlHeight;
}, function (p) {
  return p.urlFontSize;
}, function (p) {
  return p.urlLetterSpacing;
}, function (p) {
  return p.urlMarginTop;
});
var ImageBlock$U = styled.div(_templateObject4$1a || (_templateObject4$1a = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$T = styled.div(_templateObject5$12 || (_templateObject5$12 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$10 = styled.div(_templateObject6$11 || (_templateObject6$11 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: ", "%;\n  width: ", "%;\n  padding-bottom: ", "px;\n"])), function (p) {
  return p.textBlockHeight;
}, function (p) {
  return p.textBlockWidth;
}, function (p) {
  return p.textBlockPaddingBottom;
});
var TextFirst$N = styled.div(_templateObject7$11 || (_templateObject7$11 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n  \n  span {\n    text-transform: ", ";\n    font-size: ", "px;\n    font-style: normal;\n    font-weight: ", ";\n    letter-spacing: ", "px;\n    margin-right: ", "px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: ", "px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (_ref) {
  var isNumberCard = _ref.isNumberCard;
  return isNumberCard && 'uppercase';
}, function (p) {
  return p.firstTextSize;
}, function (_ref2) {
  var isNumberCard = _ref2.isNumberCard;
  return isNumberCard && 700;
}, function (p) {
  return p.firstLetterSpacing;
}, function (p) {
  return -p.firstLetterSpacing;
}, function (_ref3) {
  var isNumberCard = _ref3.isNumberCard;
  return isNumberCard ? '2' : '1';
}, function (p) {
  return p.dashWidth;
}, function (p) {
  return p.dashOffset;
}, function (p) {
  return p.dashOffset;
});
var TextSecond$N = styled.div(_templateObject8$_ || (_templateObject8$_ = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: ", "px;\n  text-align: center;\n  margin: ", ";\n  color: #151514;\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: ", ";\n  letter-spacing: ", "px;\n  margin-right: ", "px;\n  text-transform: ", ";\n"])), function (p) {
  return p.secondTextHeight;
}, function (p) {
  return p.secondTextMargins;
}, function (_ref4) {
  var isNumberCard = _ref4.isNumberCard;
  return !isNumberCard && 700;
}, function (p) {
  return p.secondLetterSpacing;
}, function (p) {
  return p.fullText ? 0 : -p.secondLetterSpacing;
}, function (_ref5) {
  var isNumberCard = _ref5.isNumberCard;
  return !isNumberCard && 'uppercase';
});
var TextThird$N = styled.div(_templateObject9$Y || (_templateObject9$Y = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: ", "px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: 0.1px;\n"])), function (p) {
  return p.thirdFontSize;
});
var WarholStyle2Template = function WarholStyle2Template(_ref6) {
  var image = _ref6.image,
    url = _ref6.url,
    customSubtitle = _ref6.customSubtitle,
    name = _ref6.name,
    number = _ref6.number,
    dw = _ref6.dw,
    dh = _ref6.dh,
    width = _ref6.width,
    height = _ref6.height,
    paddingX = _ref6.paddingX,
    fontS = _ref6.fontS,
    urlHeight = _ref6.urlHeight,
    urlFontSize = _ref6.urlFontSize,
    urlLetterSpacing = _ref6.urlLetterSpacing,
    urlMarginTop = _ref6.urlMarginTop,
    textBlockHeight = _ref6.textBlockHeight,
    textBlockWidth = _ref6.textBlockWidth,
    textBlockPaddingBottom = _ref6.textBlockPaddingBottom,
    firstTextSize = _ref6.firstTextSize,
    firstLetterSpacing = _ref6.firstLetterSpacing,
    dashWidth = _ref6.dashWidth,
    dashOffset = _ref6.dashOffset,
    secondTextHeight = _ref6.secondTextHeight,
    secondTextMargins = _ref6.secondTextMargins,
    secondLetterSpacing = _ref6.secondLetterSpacing,
    thirdFontSize = _ref6.thirdFontSize,
    isNumberCard = _ref6.isNumberCard;
  var _useState = useState(fontS),
    fontSize = _useState[0];
  var fullText = name.length > 23;
  return /*#__PURE__*/React$1.createElement(Wrapper$Z, {
    dw: dw,
    dh: dh,
    width: width,
    height: height,
    paddingX: paddingX
  }, /*#__PURE__*/React$1.createElement(MainBlock$U, null, /*#__PURE__*/React$1.createElement(TextUrl$N, {
    urlHeight: urlHeight,
    urlFontSize: urlFontSize,
    urlLetterSpacing: urlLetterSpacing,
    urlMarginTop: urlMarginTop
  }, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$U, null, /*#__PURE__*/React$1.createElement(ImageInner$T, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$10, {
    textBlockHeight: textBlockHeight,
    textBlockWidth: textBlockWidth,
    textBlockPaddingBottom: textBlockPaddingBottom
  }, /*#__PURE__*/React$1.createElement(TextFirst$N, {
    isNumberCard: isNumberCard,
    firstTextSize: firstTextSize,
    firstLetterSpacing: firstLetterSpacing,
    dashWidth: dashWidth,
    dashOffset: dashOffset
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$N, {
    isNumberCard: isNumberCard,
    fullText: fullText,
    secondTextHeight: secondTextHeight,
    secondTextMargins: secondTextMargins,
    secondLetterSpacing: secondLetterSpacing
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: name,
    fontSizeMax: fontSize
  })), /*#__PURE__*/React$1.createElement(TextThird$N, {
    thirdFontSize: thirdFontSize
  }, customSubtitle || url))));
};

var WarholCard2A4Product = function WarholCard2A4Product(props) {
  return /*#__PURE__*/React$1.createElement(WarholStyle2Template, _extends({}, props, {
    width: 210,
    height: 297,
    paddingX: 40.4,
    fontS: 17.5,
    urlHeight: 5.905,
    urlFontSize: 4,
    urlLetterSpacing: 0.7,
    urlMarginTop: 5,
    textBlockHeight: 17.6,
    textBlockWidth: 87.9,
    textBlockPaddingBottom: 36.5,
    firstTextSize: 37,
    firstLetterSpacing: 6,
    dashWidth: 37,
    dashOffset: -26,
    secondTextMargins: '15.7px 0 20.7px',
    secondLetterSpacing: 0.5,
    thirdFontSize: 6,
    isNumberCard: true
  }));
};

var WarholCard2A0Plus = function WarholCard2A0Plus(props) {
  return /*#__PURE__*/React$1.createElement(WarholStyle2Template, _extends({}, props, {
    width: 1000,
    height: 1414,
    paddingX: 195,
    fontS: 220,
    urlHeight: 5.9,
    urlFontSize: 24,
    urlMarginTop: 20,
    textBlockHeight: 17.6,
    textBlockWidth: 89,
    textBlockPaddingBottom: 167,
    firstTextSize: 84,
    firstLetterSpacing: 14.5,
    dashWidth: 200,
    dashOffset: -120,
    secondTextMargins: '53px 0 70px',
    secondLetterSpacing: 4,
    thirdFontSize: 36.5
  }));
};

var components$1 = {
  WarholCard2A5L: WarholCard2A5L,
  WarholCard2A5: WarholCard2A5,
  WarholCard2A4L: WarholCard2A4L,
  WarholCard2A4: WarholCard2A4,
  WarholCard2A4Product: WarholCard2A4Product,
  WarholCard2A3L: WarholCard2A3L,
  WarholCard2A3: WarholCard2A3,
  WarholCard2A2L: WarholCard2A2L,
  WarholCard2A2: WarholCard2A2,
  WarholCard2A1L: WarholCard2A1L,
  WarholCard2A1: WarholCard2A1,
  WarholCard2A0L: WarholCard2A0L,
  WarholCard2A0: WarholCard2A0,
  WarholCard2A0Plus: WarholCard2A0Plus
};
var COMPONENT_NAME = 'WarholCard2';
var WITH_QR = 'WithQr';
var WarholStyle2Card = function WarholStyle2Card(props) {
  var _templateDataComputed, _templateDataComputed2;
  var data = props.data,
    image = props.image,
    _props$templateType = props.templateType,
    templateType = _props$templateType === void 0 ? '' : _props$templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = (data === null || data === void 0 ? void 0 : data.templateData) || {};
  var template = templateType !== null && templateType !== void 0 && templateType.includes(WITH_QR) ? COMPONENT_NAME + templateType.slice(COMPONENT_NAME.length + WITH_QR.length, templateType.length) : templateType;
  return React$1.createElement(components$1[template], {
    url: templateDataComputed && templateDataComputed.link || 'gallllery.com',
    image: image,
    number: cardNumber.replace('№ ', '№'),
    museum: templateDataComputed && templateDataComputed.description || '',
    name: templateDataComputed && templateDataComputed.title && templateDataComputed.title.toString() || '',
    dw: dw,
    dh: dh,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed = templateDataComputed.subTitle) === null || _templateDataComputed === void 0 ? void 0 : _templateDataComputed.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed2 = templateDataComputed.description) === null || _templateDataComputed2 === void 0 ? void 0 : _templateDataComputed2.toString())
  });
};

var _templateObject$1x, _templateObject2$1x, _templateObject3$1x, _templateObject4$1b, _templateObject5$13, _templateObject6$12, _templateObject7$12, _templateObject8$$, _templateObject9$Z;
var Wrapper$_ = styled.div(_templateObject$1x || (_templateObject$1x = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(calc(", " / ", "), calc(", " / ", "));\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (p) {
  return p.width;
}, function (p) {
  return p.height;
}, function (p) {
  return p.dw;
}, function (p) {
  return p.width;
}, function (p) {
  return p.dh;
}, function (p) {
  return p.height;
}, function (p) {
  return p.paddingX;
});
var MainBlock$V = styled.div(_templateObject2$1x || (_templateObject2$1x = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$O = styled.div(_templateObject3$1x || (_templateObject3$1x = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: ", "px;\n    font-style: normal;\n    font-weight: bold;\n    margin-top: ", "px;\n  }\n"])), function (p) {
  return p.urlHeight;
}, function (p) {
  return p.urlFontSize;
}, function (p) {
  return p.urlMarginTop;
});
var ImageBlock$V = styled.div(_templateObject4$1b || (_templateObject4$1b = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$U = styled.div(_templateObject5$13 || (_templateObject5$13 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$11 = styled.div(_templateObject6$12 || (_templateObject6$12 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: ", "%;\n  width: ", "%;\n  padding-bottom: ", "px;\n"])), function (p) {
  return p.textBlockHeight;
}, function (p) {
  return p.textBlockWidth;
}, function (p) {
  return p.textBlockPaddingBottom;
});
var TextFirst$O = styled.div(_templateObject7$12 || (_templateObject7$12 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: ", "px;\n    font-style: normal;\n    font-weight: ", ";\n    letter-spacing: ", "px;\n    margin-right: ", "px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: ", "px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (p) {
  return p.firstFontSize;
}, function (p) {
  return p.firstFontWeight;
}, function (p) {
  return p.firstLetterSpacing;
}, function (p) {
  return -p.firstLetterSpacing;
}, function (p) {
  return p.dashBorderWidth;
}, function (p) {
  return p.dashWidth;
}, function (p) {
  return -p.dashOffset;
}, function (p) {
  return -p.dashOffset;
});
var TextSecond$O = styled.div(_templateObject8$$ || (_templateObject8$$ = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  width: 100%;\n  height: ", "px;\n  display: flex;\n  overflow: hidden;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  margin: ", ";\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: ", ";\n  overflow: hidden;\n"])), function (p) {
  return p.secondTextHeight;
}, function (p) {
  return p.secondTextMargins;
}, function (p) {
  return p.secondFontWeight;
});
var TextThird$O = styled.div(_templateObject9$Z || (_templateObject9$Z = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: ", "px;\n  font-style: normal;\n  font-weight: 400;\n  letter-spacing: ", "px;\n"])), function (p) {
  return p.thirdFontSize;
}, function (p) {
  return p.thirdLetterSpacing;
});
var WarholStyle3Template = function WarholStyle3Template(_ref) {
  var _number$trim;
  var image = _ref.image,
    url = _ref.url,
    customSubtitle = _ref.customSubtitle,
    name = _ref.name,
    number = _ref.number,
    dw = _ref.dw,
    dh = _ref.dh,
    width = _ref.width,
    height = _ref.height,
    paddingX = _ref.paddingX,
    urlHeight = _ref.urlHeight,
    urlFontSize = _ref.urlFontSize,
    urlMarginTop = _ref.urlMarginTop,
    textBlockHeight = _ref.textBlockHeight,
    textBlockWidth = _ref.textBlockWidth,
    textBlockPaddingBottom = _ref.textBlockPaddingBottom,
    firstFontSize = _ref.firstFontSize,
    firstFontWeight = _ref.firstFontWeight,
    firstLetterSpacing = _ref.firstLetterSpacing,
    dashWidth = _ref.dashWidth,
    dashOffset = _ref.dashOffset,
    dashBorderWidth = _ref.dashBorderWidth,
    secondTextHeight = _ref.secondTextHeight,
    secondTextMargins = _ref.secondTextMargins,
    secondFontWeight = _ref.secondFontWeight,
    mainFontSize = _ref.mainFontSize,
    defaultLetterSpacing = _ref.defaultLetterSpacing,
    thirdFontSize = _ref.thirdFontSize,
    thirdLetterSpacing = _ref.thirdLetterSpacing;
  var mainTextRef = useRef();
  var _useContainerWidth = useContainerWidth({
      mainTextRef: mainTextRef,
      name: name
    }),
    w = _useContainerWidth.w;
  var mainTitle = toUpperCaseString({
    str: name
  });
  var withNumber = Boolean(number === null || number === void 0 ? void 0 : (_number$trim = number.trim()) === null || _number$trim === void 0 ? void 0 : _number$trim.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$_, {
    dw: dw,
    dh: dh,
    width: width,
    height: height,
    paddingX: paddingX
  }, /*#__PURE__*/React$1.createElement(MainBlock$V, null, /*#__PURE__*/React$1.createElement(TextUrl$O, {
    urlHeight: urlHeight,
    urlFontSize: urlFontSize,
    urlMarginTop: urlMarginTop
  }, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$V, null, /*#__PURE__*/React$1.createElement(ImageInner$U, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$11, {
    textBlockHeight: textBlockHeight,
    textBlockWidth: textBlockWidth,
    textBlockPaddingBottom: textBlockPaddingBottom
  }, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$O, {
    firstFontSize: firstFontSize,
    firstFontWeight: firstFontWeight,
    firstLetterSpacing: firstLetterSpacing,
    dashWidth: dashWidth,
    dashOffset: dashOffset,
    dashBorderWidth: dashBorderWidth
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$O, {
    ref: mainTextRef,
    secondTextHeight: secondTextHeight,
    secondTextMargins: secondTextMargins,
    secondFontWeight: secondFontWeight
  }, /*#__PURE__*/React$1.createElement(TextWithDynamicLetterSpacing, {
    width: w,
    text: mainTitle,
    defaultLetterSpacing: defaultLetterSpacing,
    fontSize: mainFontSize
  })), /*#__PURE__*/React$1.createElement(TextThird$O, {
    thirdFontSize: thirdFontSize,
    thirdLetterSpacing: thirdLetterSpacing
  }, customSubtitle || url))));
};

var WarholCard3A0Plus = function WarholCard3A0Plus(props) {
  return /*#__PURE__*/React$1.createElement(WarholStyle3Template, _extends({}, props, {
    width: 1000,
    height: 1414,
    paddingX: 197,
    urlHeight: 5.9,
    urlFontSize: 24,
    urlMarginTop: 20,
    textBlockHeight: 17.7,
    textBlockWidth: 90,
    textBlockPaddingBottom: 237,
    firstFontSize: 49,
    firstFontWeight: 400,
    firstLetterSpacing: 9.5,
    dashWidth: 121,
    dashOffset: 70,
    dashBorderWidth: 1,
    secondTextMargins: '108px 0 114px',
    secondFontWeight: 700,
    mainFontSize: 91,
    defaultLetterSpacing: 77.5,
    thirdFontSize: 37.5,
    thirdLetterSpacing: 0.4
  }));
};

var components$2 = {
  WarholCard3A5L: WarholCard3A5L,
  WarholCard3A5: WarholCard3A5,
  WarholCard3A4L: WarholCard3A4L,
  WarholCard3A4: WarholCard3A4,
  WarholCard3A3L: WarholCard3A3L,
  WarholCard3A3: WarholCard3A3,
  WarholCard3A2L: WarholCard3A2L,
  WarholCard3A2: WarholCard3A2,
  WarholCard3A1L: WarholCard3A1L,
  WarholCard3A1: WarholCard3A1,
  WarholCard3A0L: WarholCard3A0L,
  WarholCard3A0: WarholCard3A0,
  WarholCard3A0Plus: WarholCard3A0Plus
};
var WarholStyle3Card = function WarholStyle3Card(props) {
  var _templateDataComputed, _templateDataComputed2;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = (data === null || data === void 0 ? void 0 : data.templateData) || {};
  return React$1.createElement(components$2[templateType], {
    url: templateDataComputed && templateDataComputed.link || 'gallllery.com',
    image: image,
    number: cardNumber,
    museum: templateDataComputed && templateDataComputed.description || '',
    name: templateDataComputed && templateDataComputed.title && templateDataComputed.title.toString() || '',
    dw: dw,
    dh: dh,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed = templateDataComputed.subTitle) === null || _templateDataComputed === void 0 ? void 0 : _templateDataComputed.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed2 = templateDataComputed.description) === null || _templateDataComputed2 === void 0 ? void 0 : _templateDataComputed2.toString())
  });
};

var components$3 = {
  WarholCard4A5L: WarholCard4A5L,
  WarholCard4A4L: WarholCard4A4L,
  WarholCard4A3L: WarholCard4A3L,
  WarholCard4A2L: WarholCard4A2L,
  WarholCard4A1L: WarholCard4A1L,
  WarholCard4A0L: WarholCard4A0L
};
var WarholStyle4Card = function WarholStyle4Card(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = data.templateData;
  if (!components$3[templateType]) {
    return 'Такого шаблона нет';
  }
  return React$1.createElement(components$3[templateType], {
    url: templateDataComputed && templateDataComputed.link || 'gallllery.com',
    image: image,
    number: cardNumber,
    museum: templateDataComputed && templateDataComputed.description || '',
    name: templateDataComputed && templateDataComputed.title && templateDataComputed.title.length && templateDataComputed.title.toString() || '',
    dw: dw,
    dh: dh
  });
};

var _templateObject$1y, _templateObject2$1y, _templateObject3$1y, _templateObject4$1c;
var Wrapper$$ = styled.div(_templateObject$1y || (_templateObject$1y = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  transform: scale(calc(", " / 210), calc(", " / 297));\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var VoteCollectionWrapper = styled.div(_templateObject2$1y || (_templateObject2$1y = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    flex-flow: column;\n    position: relative;\n    background-color: #fff;\n    padding: 20.85mm;\n    justify-content: space-between;\n    box-sizing: border-box;\n"])));
var CoverContainer = styled.div(_templateObject3$1y || (_templateObject3$1y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: calc(100% - ", "px);\n  position: relative;\n  display: flex;\n  align-items: ", ";\n\n  img {\n  width: ", ";\n  height: ", ";\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n  }\n"])), function (_ref) {
  var titleHeight = _ref.titleHeight;
  return titleHeight;
}, function (_ref2) {
  var orientation = _ref2.orientation,
    isSquare = _ref2.isSquare;
  return orientation && !isSquare ? "center" : 'flex-start';
}, function (_ref3) {
  var orientation = _ref3.orientation;
  return orientation ? "100%" : 'auto';
}, function (_ref4) {
  var orientation = _ref4.orientation;
  return orientation ? "auto" : 'auto';
});
var Title = styled.div(_templateObject4$1c || (_templateObject4$1c = _taggedTemplateLiteralLoose(["\n    font-family: 'Roboto', serif;\n    font-size: 11.91mm;\n    line-height: 11.91mm;\n    color: #151514;\n    font-weight: 700;\n    white-space: pre-wrap;\n    text-align: left;\n    word-wrap: break-word;\n    margin-top: 6mm;\n"])));
var debounceFunc = function debounceFunc(callback, delay) {
  var timer;
  return function () {
    if (timer) clearTimeout(timer);
    timer = setTimeout(function () {
      return callback();
    }, delay);
  };
};
var VotingCoverCardMain = function VotingCoverCardMain(props) {
  var dw = props.dw,
    dh = props.dh,
    collectionName = props.collectionName,
    image = props.image,
    baseUrl = props.baseUrl;
  var titleRef = useRef(null);
  var _useState = useState(0),
    titleHeight = _useState[0],
    setTitleHeight = _useState[1];
  var orientation = useMemo(function () {
    return image && (image.orientaion || image.Orientaion);
  }, [image]);
  var ratio = useMemo(function () {
    return image && (image.ratio || image.Ratio);
  }, [image]);
  var isSquare = useMemo(function () {
    if (!image) return false;
    if (image && image.width && image.height) return image.width === image.height;
    return image && image.Width === image.Height;
  }, [image]);
  var imageUrl = useMemo(function () {
    if (image && image.url) return baseUrl + "/" + image.url;
    return image && image.Url ? baseUrl + "/" + image.Url : '';
  }, [image, baseUrl]);
  var resizeHandler = function resizeHandler() {
    if (!titleRef.current || !(collectionName && collectionName.length)) return;
    setTitleHeight(titleRef && titleRef.current && titleRef.current.offsetHeight);
  };
  var debouncedResizeHandler = debounceFunc(resizeHandler, 500);
  useEffect(function () {
    resizeHandler();
    window.addEventListener("resize", debouncedResizeHandler);
    return function () {
      window.removeEventListener("resize", debouncedResizeHandler);
    };
  }, [collectionName]);
  return /*#__PURE__*/React$1.createElement(Wrapper$$, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(VoteCollectionWrapper, {
    orientation: orientation
  }, /*#__PURE__*/React$1.createElement(CoverContainer, {
    titleHeight: titleHeight,
    orientation: orientation,
    ratio: ratio,
    isSquare: isSquare
  }, /*#__PURE__*/React$1.createElement("img", {
    src: imageUrl,
    alt: ""
  })), collectionName && collectionName.length > 0 && /*#__PURE__*/React$1.createElement(Title, {
    ref: titleRef
  }, collectionName)));
};

var components$4 = {
  VotingCoverCardMain: VotingCoverCardMain
};
var VotingCoverCard = function VotingCoverCard(props) {
  var data = props.data,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$4[templateType], {
    dw: dw,
    dh: dh,
    collectionName: data && data.length && data.collectionName || '',
    baseUrl: data && data.baseUrl || '',
    image: data && data.image || undefined
  });
};

var components$5 = {
  ClassicCard3A0: ClassicCard3A0,
  ClassicCard3A1: ClassicCard3A1,
  ClassicCard3A2: ClassicCard3A2,
  ClassicCard3A3: ClassicCard3A3,
  ClassicCard3A4: ClassicCard3A4,
  ClassicCard3A5: ClassicCard3A5
};
var ClassicStyle3Card = function ClassicStyle3Card(props) {
  var templateType = props.templateType;
  if (!components$5[templateType]) {
    return 'Такого шаблона нет, ';
  }
  return 'Шаблон в разработке.';
};

var components$6 = {
  LuvrikCardA5L: LuvrikCardA5L,
  LuvrikCardA5: LuvrikCardA5,
  LuvrikCardA4L: LuvrikCardA4L,
  LuvrikCardA4: LuvrikCardA4,
  LuvrikCardA3L: LuvrikCardA3L,
  LuvrikCardA3: LuvrikCardA3,
  LuvrikCardA2L: LuvrikCardA2L,
  LuvrikCardA2: LuvrikCardA2,
  LuvrikCardA1L: LuvrikCardA1L,
  LuvrikCardA1: LuvrikCardA1,
  LuvrikCardA0L: LuvrikCardA0L,
  LuvrikCardA0: LuvrikCardA0,
  ClassicA5L: LuvrikCardA5L,
  ClassicA5: LuvrikCardA5,
  ClassicA4L: LuvrikCardA4L,
  ClassicA4: LuvrikCardA4,
  ClassicA3L: LuvrikCardA3L,
  ClassicA3: LuvrikCardA3,
  ClassicA2L: LuvrikCardA2L,
  ClassicA2: LuvrikCardA2,
  ClassicA1L: LuvrikCardA1L,
  ClassicA1: LuvrikCardA1,
  ClassicA0L: LuvrikCardA0L,
  ClassicA0: LuvrikCardA0
};
var LuvrikStyleCard = function LuvrikStyleCard(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    appName = props.appName,
    dw = props.dw,
    dh = props.dh;
  var card_number = (appName === 'gallllery' ? '' : '№Ae ') + data.number;
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components$6[templateType], {
    url: templateDataComputed && templateDataComputed.link || 'ze.land',
    image: image,
    country: templateDataComputed && templateDataComputed.subTitle,
    number: card_number,
    museum: templateDataComputed && templateDataComputed.title,
    name: templateDataComputed && templateDataComputed.description,
    dw: dw,
    dh: dh
  });
};

var _templateObject$1z, _templateObject2$1z, _templateObject3$1z, _templateObject4$1d, _templateObject5$14, _templateObject6$13;
var Wrapper$10 = styled.div(_templateObject$1z || (_templateObject$1z = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  // border: 1px solid white;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$W = styled.div(_templateObject2$1z || (_templateObject2$1z = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  // border: 1px solid white;\n  padding: 5%;\n  display: flex;\n  flex-direction: column;\n"])));
var ImageBlock$W = styled.div(_templateObject3$1z || (_templateObject3$1z = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"])));
var ImageInner$V = styled.div(_templateObject4$1d || (_templateObject4$1d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  margin: auto;\n  width: 100%;\n  height: 100%;\n  /* align-items: ", "; */\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: cover;\n    size: auto;\n  }\n"])), function (props) {
  return props.align ? 'start' : 'center';
});
var TextBlock$12 = styled.div(_templateObject5$14 || (_templateObject5$14 = _taggedTemplateLiteralLoose(["\n  // margin-top: 5%;\n  //background-color: aqua;\n  height: 13%;\n  text-align: center;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"])));
var TextSecond$P = styled.div(_templateObject6$13 || (_templateObject6$13 = _taggedTemplateLiteralLoose(["\n  display: inline-block;\n  font-size: ", "px;\n  font-family: Roboto-Bold, Roboto, serif;\n  font-weight: 600;\n  line-height: 87px;\n  letter-spacing: 0.036em;\n  text-align: center;\n  //background-color: red;\n"])), function (props) {
  return props.fs;
});
var ProductCard = function ProductCard(props) {
  var image = props.image,
    dw = props.dw,
    dh = props.dh;
  var _useState = useState(false),
    setIsVerticalImage = _useState[1];
  useEffect(function () {
    if (image) {
      var img = new Image();
      img.onload = function () {
        if (this.width < this.height) {
          setIsVerticalImage(true);
        } else {
          setIsVerticalImage(false);
        }
      };
      img.src = image;
    }
  }, [image]);
  return /*#__PURE__*/React$1.createElement(Wrapper$10, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$W, null, /*#__PURE__*/React$1.createElement(ImageBlock$W, null, /*#__PURE__*/React$1.createElement(ImageInner$V, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  })))));
};

var mainSize = {
  horizontal: {
    small: {
      width: 300,
      height: 394,
      scale: 0.238,
      padding: '45mm 15mm 60mm'
    },
    large: {
      width: 260,
      height: 366,
      scale: 1,
      padding: '30mm 10mm 0'
    }
  },
  vertical: {
    small: {
      width: 300,
      height: 381,
      scale: 0.238,
      padding: '45mm 15mm 60mm'
    },
    large: {
      width: 280,
      height: 686,
      scale: 1,
      padding: '15mm 60mm 0'
    }
  }
};

var _templateObject$1A, _templateObject2$1A;
var TitlePlaceholder = styled.div(_templateObject$1A || (_templateObject$1A = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n  &.title_vertical {\n    width: ", ";\n    height: ", ";\n    @media ", " {\n      width: ", ";\n      height: ", ";\n    }\n    @media ", " {\n      width: ", ";\n      height: ", ";\n    }\n  }\n\n  &.title_horizontal {\n    width: ", ";\n    height: ", ";\n    @media ", " {\n      width: ", ";\n      height: ", ";\n    }\n    @media ", " {\n      width: ", ";\n      height: ", ";\n    }\n  }\n\n  &.title_free {\n    width: ", ";\n    height: ", ";\n    @media ", " {\n      width: ", ";\n      height: ", ";\n    }\n    @media ", " {\n      width: ", ";\n      height: ", ";\n    }\n  }\n"])), Colors.galBlack21, function (_ref) {
  var isScaled = _ref.isScaled;
  return isScaled ? '420px' : '100px';
}, function (_ref2) {
  var isScaled = _ref2.isScaled;
  return isScaled ? '51px' : '12px';
}, MEDIA.LAPTOP, function (_ref3) {
  var isScaled = _ref3.isScaled;
  return isScaled ? '534px' : '96px';
}, function (_ref4) {
  var isScaled = _ref4.isScaled;
  return isScaled ? '51px' : '9px';
}, MEDIA.TABLET, function (_ref5) {
  var isScaled = _ref5.isScaled;
  return isScaled ? '485px' : '71px';
}, function (_ref6) {
  var isScaled = _ref6.isScaled;
  return isScaled ? '55px' : '8px';
}, function (_ref7) {
  var isScaled = _ref7.isScaled;
  return isScaled ? '215px' : '51px';
}, function (_ref8) {
  var isScaled = _ref8.isScaled;
  return isScaled ? '26px' : '6px';
}, MEDIA.LAPTOP, function (_ref9) {
  var isScaled = _ref9.isScaled;
  return isScaled ? '429px' : '77px';
}, function (_ref10) {
  var isScaled = _ref10.isScaled;
  return isScaled ? '28px' : '5px';
}, MEDIA.TABLET, function (_ref11) {
  var isScaled = _ref11.isScaled;
  return isScaled ? '322px' : '47px';
}, function (_ref12) {
  var isScaled = _ref12.isScaled;
  return isScaled ? '28px' : '4px';
}, function (_ref13) {
  var isScaled = _ref13.isScaled;
  return isScaled ? '224px' : '38px';
}, function (_ref14) {
  var isScaled = _ref14.isScaled;
  return isScaled ? '24px' : '4px';
}, MEDIA.LAPTOP, function (_ref15) {
  var isScaled = _ref15.isScaled;
  return isScaled ? '234px' : '30px';
}, function (_ref16) {
  var isScaled = _ref16.isScaled;
  return isScaled ? '32px' : '4px';
}, MEDIA.TABLET, function (_ref17) {
  var isScaled = _ref17.isScaled;
  return isScaled ? '239px' : '25px';
}, function (_ref18) {
  var isScaled = _ref18.isScaled;
  return isScaled ? '29px' : '3px';
});
var YearPlaceholder = styled.div(_templateObject2$1A || (_templateObject2$1A = _taggedTemplateLiteralLoose(["\n  background-color: ", ";\n\n  &.year_vertical {\n    width: ", ";\n    height: ", ";\n    margin-bottom: 9px;\n    margin-left: auto;\n    @media ", " {\n      width: ", ";\n      height: ", ";\n      margin-bottom: 7px;\n    }\n    @media ", " {\n      width: ", ";\n      height: ", ";\n      margin-bottom: 6px;\n    }\n  }\n  &.year_horizontal {\n    width: ", ";\n    height: ", ";\n    margin-bottom: 3px;\n    margin-left: auto;\n    @media ", " {\n      width: ", ";\n      height: ", ";\n      margin-bottom: 2px;\n    }\n    @media ", " {\n      width: ", ";\n      height: ", ";\n      margin-bottom: 1px;\n    }\n  }\n  &.year_free {\n    width: ", ";\n    height: ", ";\n    margin: 0 auto;\n    margin-bottom: 14px;\n    @media ", " {\n      width: ", ";\n      height: ", ";\n      margin-bottom: 11px;\n    }\n    @media ", " {\n      width: ", ";\n      height: ", ";\n      margin-bottom: 9px;\n    }\n  }\n"])), Colors.galBlack21, function (_ref19) {
  var isScaled = _ref19.isScaled;
  return isScaled ? '152px' : '36px';
}, function (_ref20) {
  var isScaled = _ref20.isScaled;
  return isScaled ? '51px' : '12px';
}, MEDIA.LAPTOP, function (_ref21) {
  var isScaled = _ref21.isScaled;
  return isScaled ? '134px' : '24px';
}, function (_ref22) {
  var isScaled = _ref22.isScaled;
  return isScaled ? '51px' : '9px';
}, MEDIA.TABLET, function (_ref23) {
  var isScaled = _ref23.isScaled;
  return isScaled ? '137px' : '20px';
}, function (_ref24) {
  var isScaled = _ref24.isScaled;
  return isScaled ? '48px' : '7px';
}, function (_ref25) {
  var isScaled = _ref25.isScaled;
  return isScaled ? '80px' : '19px';
}, function (_ref26) {
  var isScaled = _ref26.isScaled;
  return isScaled ? '26px' : '6px';
}, MEDIA.LAPTOP, function (_ref27) {
  var isScaled = _ref27.isScaled;
  return isScaled ? '134px' : '24px';
}, function (_ref28) {
  var isScaled = _ref28.isScaled;
  return isScaled ? '28px' : '5px';
}, MEDIA.TABLET, function (_ref29) {
  var isScaled = _ref29.isScaled;
  return isScaled ? '117px' : '17px';
}, function (_ref30) {
  var isScaled = _ref30.isScaled;
  return isScaled ? '28px' : '4px';
}, function (_ref31) {
  var isScaled = _ref31.isScaled;
  return isScaled ? '218px' : '37px';
}, function (_ref32) {
  var isScaled = _ref32.isScaled;
  return isScaled ? '30px' : '5px';
}, MEDIA.LAPTOP, function (_ref33) {
  var isScaled = _ref33.isScaled;
  return isScaled ? '234px' : '30px';
}, function (_ref34) {
  var isScaled = _ref34.isScaled;
  return isScaled ? '32px' : '4px';
}, MEDIA.TABLET, function (_ref35) {
  var isScaled = _ref35.isScaled;
  return isScaled ? '229px' : '24px';
}, function (_ref36) {
  var isScaled = _ref36.isScaled;
  return isScaled ? '39px' : '4px';
});

var _templateObject$1B, _templateObject2$1B, _templateObject3$1A, _templateObject4$1e, _templateObject5$15, _templateObject6$14, _templateObject7$13, _templateObject8$10, _templateObject9$_, _templateObject10$n, _templateObject11$n, _templateObject12$n, _templateObject13$n, _templateObject14$h;
var TemplateTopYear = styled.div(_templateObject$1B || (_templateObject$1B = _taggedTemplateLiteralLoose(["\n  font-family: HSE Sans;\n  color: #b22125;\n  font-size: 48pt;\n  display: flex;\n  align-items: start;\n  justify-content: flex-end;\n  line-height: 100%;\n  letter-spacing: 0;\n  margin-bottom: 9px;\n"])));
var TemplateBottomTitle = styled.div(_templateObject2$1B || (_templateObject2$1B = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  column-gap: 2mm;\n  white-space: nowrap;\n  margin-top: ", ";\n\n  span {\n    color: #002d6e;\n    font-size: ", "pt;\n    line-height: ", "pt;\n    text-transform: uppercase;\n    font-family: HSE Sans;\n    &:nth-of-type(2n) {\n      font-weight: 400;\n      letter-spacing: 0.025em;\n    }\n    &:nth-of-type(2n + 1) {\n      font-weight: 700;\n    }\n  }\n"])), function (_ref) {
  var isHorizontal = _ref.isHorizontal;
  return isHorizontal ? 0 : '0mm -1mm';
}, function (p) {
  return p.largeText ? 47.3 : 50.3;
}, function (p) {
  return p.largeText ? 47.3 : 50.3;
});
var TemplateBottomLine = styled.div(_templateObject3$1A || (_templateObject3$1A = _taggedTemplateLiteralLoose(["\n  // margin-top: 2%;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n"])), function (_ref2) {
  var isPrinting = _ref2.isPrinting;
  return isPrinting && css(_templateObject4$1e || (_templateObject4$1e = _taggedTemplateLiteralLoose(["\n      margin-top: 8.2mm;\n    "])));
});
var Title$1 = styled.div(_templateObject5$15 || (_templateObject5$15 = _taggedTemplateLiteralLoose(["\n  font-size: 36px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n"])));
var MainContainer = styled.div(_templateObject6$14 || (_templateObject6$14 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 100%;\n  height: 100%;\n  box-sizing: border-box;\n  overflow: hidden;\n  &.placeholder_container_vertical {\n    padding: 51px 12px 73px;\n    @media ", " {\n      padding: 39px 9px 54px;\n    }\n    @media ", " {\n      padding: 31px 8px 43px;\n    }\n  }\n\n  &.placeholder_container_horizontal {\n    padding: 18px 9px 9px;\n    @media ", " {\n      padding: 14px 7px 8px;\n    }\n    @media ", " {\n      padding: 11px 6px 7px;\n    }\n  }\n\n  &.placeholder_container_free {\n    padding: 21px 27px 25px;\n    @media ", " {\n      padding: 15px 21px 20px;\n    }\n    @media ", " {\n      padding: 12px 16px 16px;\n    }\n  }\n"])), MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.LAPTOP, MEDIA.TABLET);
var ImagePlaceholderContainer = styled.div(_templateObject7$13 || (_templateObject7$13 = _taggedTemplateLiteralLoose(["\n  display: grid;\n  justify-content: center;\n  gap: 4px;\n  flex-grow: 1;\n  @media ", " {\n    gap: 3px;\n  }\n  @media ", " {\n    gap: 2px;\n  }\n\n  &.image_placeholder_vertical {\n    grid-template-columns: repeat(3, auto);\n    grid-template-rows: repeat(4, auto);\n    margin-bottom: 10px;\n    @media ", " {\n      margin-bottom: 8px;\n    }\n    @media ", " {\n      margin-bottom: 6px;\n    }\n    @media ", " {\n      grid-template-columns: repeat(3, 1fr);\n      grid-template-rows: repeat(4, 1fr);\n    }\n  }\n\n  &.image_placeholder_horizontal {\n    grid-template-columns: repeat(4, auto);\n    grid-template-rows: repeat(3, auto);\n    margin-bottom: 5px;\n    @media ", " {\n      margin-bottom: 3px;\n    }\n    @media ", " {\n      margin-bottom: 3px;\n    }\n    @media ", " {\n      grid-template-columns: repeat(4, 1fr);\n      grid-template-rows: repeat(3, 1fr);\n    }\n  }\n\n  &.image_placeholder_free {\n    grid-template-columns: repeat(3, auto);\n    grid-template-rows: repeat(4, auto);\n    margin-bottom: 23px;\n    @media ", " {\n      margin-bottom: 16px;\n    }\n    @media ", " {\n      margin-bottom: 12px;\n    }\n    @media ", " {\n      grid-template-columns: repeat(3, 1fr);\n      grid-template-rows: repeat(4, 1fr);\n    }\n  }\n"])), MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE);
var PreviewItemContainer = styled.div(_templateObject8$10 || (_templateObject8$10 = _taggedTemplateLiteralLoose(["\n  background: transparent;\n\n  &.preview_item_vertical {\n    width: 79px;\n    height: 98px;\n    @media ", " {\n      width: 60px;\n      height: 74px;\n    }\n    @media ", " {\n      width: 49px;\n      height: 61px;\n    }\n    @media ", " {\n      width: auto;\n      height: auto;\n    }\n  }\n\n  &.preview_item_horizontal {\n    width: 60px;\n    height: 44px;\n    @media ", " {\n      width: 45px;\n      height: 33px;\n    }\n    @media ", " {\n      width: 37px;\n      height: 27px;\n    }\n    @media ", " {\n      width: auto;\n      height: auto;\n    }\n  }\n\n  &.preview_item_free {\n    width: 69px;\n    height: 69px;\n    @media ", " {\n      width: 52px;\n      height: 52px;\n    }\n    @media ", " {\n      width: 43px;\n      height: 43px;\n    }\n    @media ", " {\n      width: auto;\n      height: auto;\n    }\n  }\n"])), MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE);
var PreviewItemBlock = styled.div(_templateObject9$_ || (_templateObject9$_ = _taggedTemplateLiteralLoose(["\n  --border-color: ", ";\n  --cross-color: rgba(0, 0, 0, 0.15);\n\n  position: relative;\n  width: 100%;\n  height: 100%;\n  border: 1px solid var(--border-color);\n  background-color: #fff;\n  box-sizing: border-box;\n\n  background-image: linear-gradient(\n      to top right,\n      transparent calc(50% - 1px),\n      var(--cross-color),\n      transparent calc(50% + 1px)\n    ),\n    linear-gradient(\n      to bottom right,\n      transparent calc(50% - 1px),\n      var(--cross-color),\n      transparent calc(50% + 1px)\n    );\n  background-repeat: no-repeat;\n  background-size: 100% 100%;\n"])), Colors.galBlack21);
var TemplateTopYearScaled = styled(TemplateTopYear)(_templateObject10$n || (_templateObject10$n = _taggedTemplateLiteralLoose(["\n  // font-size: ", "pt;\n  &.template_year_vertical {\n    font-size: 16.5px;\n    margin-bottom: 9px;\n    @media ", " {\n      font-size: 12.75px;\n      margin-bottom: 7px;\n    }\n    @media ", " {\n      font-size: 9.75px;\n      margin-bottom: 6px;\n    }\n    @media ", " {\n      font-size: ", "px;\n    }\n  }\n  &.template_year_horizontal {\n    font-size: 8.5px;\n    margin-bottom: 3px;\n    @media ", " {\n      font-size: 7px;\n      margin-bottom: 2px;\n    }\n    @media ", " {\n      font-size: 5.5px;\n      margin-bottom: 1px;\n    }\n    @media ", " {\n      font-size: ", "px;\n    }\n  }\n  &.template_year_free {\n    justify-content: center;\n    letter-spacing: 4px;\n    font-size: 7px;\n    margin-bottom: 12px;\n    @media ", " {\n      font-size: 6px;\n      margin-bottom: 10px;\n      letter-spacing: 3px;\n    }\n    @media ", " {\n      font-size: 5px;\n      margin-bottom: 8px;\n    }\n    @media ", " {\n      font-size: ", "px;\n    }\n  }\n"])), function (_ref3) {
  var scaleSize = _ref3.scaleSize;
  return 48 * scaleSize;
}, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, function (_ref4) {
  var scaleSize = _ref4.scaleSize;
  return 48 * scaleSize;
}, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, function (_ref5) {
  var scaleSize = _ref5.scaleSize;
  return 48 * scaleSize;
}, MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, function (_ref6) {
  var scaleSize = _ref6.scaleSize;
  return 41 * scaleSize;
});
var TemplateBottomTitleScaled = styled(TemplateBottomTitle)(_templateObject11$n || (_templateObject11$n = _taggedTemplateLiteralLoose(["\n  // span {\n  //   font-size: ", ";\n  //   line-height: ", ";\n  // }\n  &.template_title_vertical {\n    span {\n      font-size: 16.5px;\n      line-height: 100%;\n      @media ", " {\n        font-size: 12.5px;\n      }\n      @media ", " {\n        font-size: 11.25px;\n      }\n      ", "\n    }\n  }\n  &.template_title_horizontal {\n    span {\n      font-size: 8.5px;\n      line-height: 100%;\n      @media ", " {\n        font-size: 7px;\n      }\n      @media ", " {\n        font-size: 5.5px;\n      }\n      ", "\n    }\n  }\n"])), function (_ref7) {
  var scaleSize = _ref7.scaleSize;
  return 50.3 * scaleSize + "pt";
}, function (_ref8) {
  var scaleSize = _ref8.scaleSize;
  return 50.3 * scaleSize + "pt";
}, MEDIA.LAPTOP, MEDIA.TABLET, function (p) {
  return css(_templateObject12$n || (_templateObject12$n = _taggedTemplateLiteralLoose(["\n          @media ", " {\n            font-size: ", "px;\n            line-height: ", "px;\n          }\n        "])), MEDIA.MOBILE, (p.largeText ? 47.3 : 50.3) * p.scaleSize, (p.largeText ? 47.3 : 50.3) * p.scaleSize);
}, MEDIA.LAPTOP, MEDIA.TABLET, function (p) {
  return css(_templateObject13$n || (_templateObject13$n = _taggedTemplateLiteralLoose(["\n          @media ", " {\n            font-size: ", "px;\n            line-height: ", "px;\n          }\n        "])), MEDIA.MOBILE, (p.largeText ? 47.3 : 50.3) * p.scaleSize, (p.largeText ? 47.3 : 50.3) * p.scaleSize);
});
var TitleScaled = styled(Title$1)(_templateObject14$h || (_templateObject14$h = _taggedTemplateLiteralLoose(["\n  &.template_title_free {\n    font-size: 6px;\n    line-height: 100%;\n    @media ", " {\n      font-size: 6px;\n    }\n    @media ", " {\n      font-size: 4px;\n    }\n    @media ", " {\n      font-size: ", ";\n    }\n  }\n"])), MEDIA.LAPTOP, MEDIA.TABLET, MEDIA.MOBILE, function (_ref9) {
  var scaleSize = _ref9.scaleSize;
  return 32 * scaleSize + "px";
});
var extractSecondCalcValue = function extractSecondCalcValue(scaleSize) {
  if (typeof scaleSize !== 'string') return scaleSize;
  try {
    var second = scaleSize.split(',')[1];
    if (!second) return NaN;
    var match = second.match(/calc\s*\(([^)]+)\)/i);
    if (!match) return NaN;
    var expression = match[1];
    var _expression$split$map = expression.split('/').map(function (v) {
        return parseFloat(v);
      }),
      num = _expression$split$map[0],
      denom = _expression$split$map[1];
    if (isNaN(num) || isNaN(denom) || denom === 0) return NaN;
    return num / denom;
  } catch (_unused) {
    return NaN;
  }
};
var CalendarImagePlaceholder = function CalendarImagePlaceholder(_ref10) {
  var _ref10$orientation = _ref10.orientation,
    orientation = _ref10$orientation === void 0 ? 'free' : _ref10$orientation,
    title = _ref10.title,
    year = _ref10.year,
    isHorizontal = _ref10.isHorizontal,
    bottomTitleArr = _ref10.bottomTitleArr,
    isPrinting = _ref10.isPrinting,
    scaleSize = _ref10.scaleSize;
  var items = Array.from({
    length: 12
  });
  var scale = extractSecondCalcValue(scaleSize);
  return /*#__PURE__*/React$1.createElement(MainContainer, {
    className: "placeholder_container_" + orientation
  }, year ? /*#__PURE__*/React$1.createElement(TemplateTopYearScaled, {
    scaleSize: scale,
    className: "template_year_" + orientation
  }, year) : /*#__PURE__*/React$1.createElement(YearPlaceholder, {
    className: "year_" + orientation,
    isScaled: false
  }), /*#__PURE__*/React$1.createElement(ImagePlaceholderContainer, {
    className: "image_placeholder_" + orientation
  }, items.map(function (_, index) {
    return /*#__PURE__*/React$1.createElement(PreviewItemContainer, {
      key: index,
      className: "preview_item_" + orientation
    }, /*#__PURE__*/React$1.createElement(PreviewItemBlock, null));
  })), bottomTitleArr ? /*#__PURE__*/React$1.createElement(TemplateBottomLine, {
    isPrinting: isPrinting,
    isHorizontal: isHorizontal
  }, /*#__PURE__*/React$1.createElement(TemplateBottomTitleScaled, {
    largeText: title && title.length > 20,
    isHorizontal: isHorizontal,
    scaleSize: scaleSize,
    className: "template_title_" + orientation
  }, !!(bottomTitleArr && bottomTitleArr.length) && bottomTitleArr.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index + " " + item,
      dangerouslySetInnerHTML: {
        __html: "" + item
      }
    });
  }))) : title ? /*#__PURE__*/React$1.createElement(TitleScaled, {
    className: "template_title_" + orientation,
    scaleSize: scale
  }, title) : /*#__PURE__*/React$1.createElement(TitlePlaceholder, {
    className: "title_" + orientation,
    isScaled: false
  }));
};

var _templateObject$1C, _templateObject2$1C, _templateObject3$1B, _templateObject4$1f, _templateObject5$16, _templateObject6$15, _templateObject7$14, _templateObject8$11, _templateObject9$$, _templateObject10$o, _templateObject11$o, _templateObject12$o, _templateObject13$o, _templateObject14$i, _templateObject15$6, _templateObject16, _templateObject17;
var TimelineCoverMain = styled.div(_templateObject$1C || (_templateObject$1C = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  background: #fff;\n  width: ", "mm;\n  height: ", "mm;\n  padding: ", ";\n  max-height: 388mm;\n\n  @media print {\n    ", "\n  }\n\n  ", "\n\n  ", "\n"])), function (p) {
  return p.mainWidth;
}, function (p) {
  return p.mainHeight;
}, function (p) {
  return p.padding;
}, function (_ref) {
  var isPrinting = _ref.isPrinting;
  return !isPrinting ? 'page-break-after: always;' : '';
}, function (_ref2) {
  var isPrinting = _ref2.isPrinting,
    scaleSize = _ref2.scaleSize;
  return !isPrinting && css(_templateObject2$1C || (_templateObject2$1C = _taggedTemplateLiteralLoose(["\n      transform: scale(", ");\n      transform-origin: left top;\n    "])), scaleSize);
}, function (_ref3) {
  var isPrinting = _ref3.isPrinting,
    isHorizontal = _ref3.isHorizontal;
  return isPrinting && css(_templateObject3$1B || (_templateObject3$1B = _taggedTemplateLiteralLoose(["\n      max-height: none;\n      overflow: hidden;\n      padding: ", ";\n      height: ", "mm;\n      width: ", "mm;\n    "])), isHorizontal ? '25.5mm 20mm 0' : '55mm 10mm 0mm', isHorizontal ? '420' : '640.147', isHorizontal ? '594' : '300');
});
var TemplateTopLine = styled.div(_templateObject4$1f || (_templateObject4$1f = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 3%;\n  align-items: flex-end;\n\n  ", "\n"])), function (_ref4) {
  var isPrinting = _ref4.isPrinting,
    isHorizontal = _ref4.isHorizontal;
  return isPrinting && css(_templateObject5$16 || (_templateObject5$16 = _taggedTemplateLiteralLoose(["\n      margin-bottom: ", "mm;\n    "])), isHorizontal ? 5.8 : 8.5);
});
var CalendarPictures = styled.div(_templateObject6$15 || (_templateObject6$15 = _taggedTemplateLiteralLoose(["\n  display: grid;\n  grid-template-columns: repeat(\n    ", ",\n    1fr\n  );\n  grid-template-rows: repeat(\n    ", ",\n    1fr\n  );\n\n  @media (max-width: 734px) {\n    width: 100%;\n  }\n"])), function (_ref5) {
  var isHorizontal = _ref5.isHorizontal;
  return isHorizontal ? 4 : 3;
}, function (_ref6) {
  var isHorizontal = _ref6.isHorizontal;
  return isHorizontal ? 3 : 4;
});
var TimelinePicWrapper = styled.div(_templateObject7$14 || (_templateObject7$14 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: ", ";\n\n  @media (max-width: 734px) {\n    height: 100%;\n    height: ", ";\n  }\n\n  ", "\n"])), function (p) {
  return p.isHorizontal ? '49mm' : '120mm';
}, function (p) {
  return p.isHorizontal ? '49mm' : '120mm';
}, function (_ref7) {
  var isPrinting = _ref7.isPrinting,
    isHorizontal = _ref7.isHorizontal;
  return isPrinting && css(_templateObject8$11 || (_templateObject8$11 = _taggedTemplateLiteralLoose(["\n      height: ", ";\n    "])), isHorizontal ? '102.5mm' : '112.1mm');
});
var TimelinePic = styled.img(_templateObject9$$ || (_templateObject9$$ = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  background-color: #ffffff !important;\n\n  ", "\n"])), function (_ref8) {
  var isPrinting = _ref8.isPrinting,
    isHorizontal = _ref8.isHorizontal;
  return isPrinting && css(_templateObject10$o || (_templateObject10$o = _taggedTemplateLiteralLoose(["\n      height: ", ";\n    "])), isHorizontal ? '102.5mm' : '112.1mm');
});
var TemplateBottomLine$1 = styled.div(_templateObject11$o || (_templateObject11$o = _taggedTemplateLiteralLoose(["\n  margin-top: 2%;\n  display: flex;\n  flex-direction: column;\n\n  ", "\n"])), function (_ref9) {
  var isPrinting = _ref9.isPrinting;
  return isPrinting && css(_templateObject12$o || (_templateObject12$o = _taggedTemplateLiteralLoose(["\n      margin-top: 8.2mm;\n    "])));
});
var TemplateBottomTitle$1 = styled.div(_templateObject13$o || (_templateObject13$o = _taggedTemplateLiteralLoose(["\n  display: flex;\n  width: 100%;\n  flex-wrap: wrap;\n  column-gap: 2mm;\n  white-space: nowrap;\n  margin-top: ", ";\n\n  span {\n    color: #002d6e;\n    font-size: ", "pt;\n    line-height: ", "pt;\n    text-transform: uppercase;\n    font-family: HSE Sans;\n    &:nth-of-type(2n) {\n      font-weight: 400;\n      letter-spacing: 0.025em;\n    }\n    &:nth-of-type(2n + 1) {\n      font-weight: 700;\n    }\n  }\n"])), function (_ref10) {
  var isHorizontal = _ref10.isHorizontal;
  return isHorizontal ? 0 : '0mm -1mm';
}, function (p) {
  return p.largeText ? 47.3 : 50.3;
}, function (p) {
  return p.largeText ? 47.3 : 50.3;
});
var TemplateBottomSubtitle = styled.div(_templateObject14$i || (_templateObject14$i = _taggedTemplateLiteralLoose(["\n  display: flex;\n  color: #002d6e;\n  font-family: HSE Sans;\n  //white-space: nowrap;\n  width: 100%;\n  font-size: 30pt;\n  word-wrap: break-word;\n  word-break: break-all;\n"])));
var TemplateTopLogo = styled.div(_templateObject15$6 || (_templateObject15$6 = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n  display: flex;\n  flex-direction: column;\n  width: min-content;\n  font-size: 24pt;\n  line-height: 100%;\n  max-height: 48pt;\n  height: 48pt;\n  width: fit-content;\n  color: #002d6e;\n  span {\n    font-family: HSE Sans;\n    &:nth-of-type(2n) {\n      font-weight: 400;\n    }\n    &:nth-of-type(2n + 1) {\n      font-weight: 700;\n    }\n  }\n  img {\n    max-height: 100%;\n    max-width: 100%;\n    object-fit: contain;\n  }\n"])));
var TemplateTopYear$1 = styled.div(_templateObject16 || (_templateObject16 = _taggedTemplateLiteralLoose(["\n  font-family: HSE Sans;\n  color: #b22125;\n  font-size: 48pt;\n  display: flex;\n  align-items: start;\n  line-height: 100%;\n  letter-spacing: -0.01em;\n"])));
var TemplateTopTitle = styled.div(_templateObject17 || (_templateObject17 = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n  font-weight: 600;\n  font-family: 'Inter';\n  font-size: 19pt;\n  width: 210px;\n  line-height: 105%;\n"])));
var TimelineCardMasterTemplate = function TimelineCardMasterTemplate(props) {
  var images = props.images,
    year = props.year,
    title = props.title,
    defaultTitle = props.defaultTitle,
    orientation = props.orientation,
    size = props.size,
    scaleSize = props.scaleSize,
    logo = props.logo,
    isPrinting = props.isPrinting,
    isNeedImagePlaceholder = props.isNeedImagePlaceholder;
  var isHorizontal = orientation === 'horizontal';
  var usedBottomTitle = title || defaultTitle;
  var bottomTitleArr = usedBottomTitle && usedBottomTitle.trim().split(' ');
  if (isNeedImagePlaceholder) {
    return /*#__PURE__*/React$1.createElement(CalendarImagePlaceholder, {
      orientation: orientation,
      title: usedBottomTitle,
      year: year,
      isHorizontal: isHorizontal,
      bottomTitleArr: bottomTitleArr,
      isPrinting: isPrinting,
      scaleSize: scaleSize
    });
  }
  return /*#__PURE__*/React$1.createElement(TimelineCoverMain, {
    scaleSize: scaleSize || mainSize[orientation][size].scale,
    mainWidth: mainSize[orientation][size].width,
    mainHeight: mainSize[orientation][size].height,
    padding: mainSize[orientation][size].padding,
    isPrinting: isPrinting,
    isHorizontal: isHorizontal
  }, /*#__PURE__*/React$1.createElement(TemplateTopLine, {
    isPrinting: isPrinting,
    isHorizontal: isHorizontal
  }, /*#__PURE__*/React$1.createElement(TemplateTopLogo, null, logo && /*#__PURE__*/React$1.createElement("img", {
    src: logo,
    alt: "logo"
  })), /*#__PURE__*/React$1.createElement(TemplateTopTitle, null), year ? /*#__PURE__*/React$1.createElement(TemplateTopYear$1, null, year) : /*#__PURE__*/React$1.createElement(YearPlaceholder, {
    className: "year_" + orientation,
    isScaled: true
  })), /*#__PURE__*/React$1.createElement(CalendarPictures, {
    isHorizontal: isHorizontal
  }, !!(images && images.length) && images.map(function (image, index) {
    return /*#__PURE__*/React$1.createElement(TimelinePicWrapper, {
      key: index + " " + image,
      type: orientation,
      isHorizontal: isHorizontal,
      isPrinting: isPrinting
    }, /*#__PURE__*/React$1.createElement(TimelinePic, {
      isPrinting: isPrinting,
      isHorizontal: isHorizontal,
      src: image
    }));
  })), /*#__PURE__*/React$1.createElement(TemplateBottomLine$1, {
    isPrinting: isPrinting,
    isHorizontal: isHorizontal
  }, usedBottomTitle ? /*#__PURE__*/React$1.createElement(TemplateBottomTitle$1, {
    largeText: usedBottomTitle && usedBottomTitle.length > 20,
    isHorizontal: isHorizontal
  }, !!(bottomTitleArr && bottomTitleArr.length) && bottomTitleArr.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index + " " + item,
      dangerouslySetInnerHTML: {
        __html: "" + item
      }
    });
  })) : /*#__PURE__*/React$1.createElement(TitlePlaceholder, {
    className: "title_" + orientation,
    isScaled: true
  })));
};

var TimelineCardS = function TimelineCardS(props) {
  return /*#__PURE__*/React$1.createElement(TimelineCardMasterTemplate, _extends({}, props, {
    orientation: 'vertical',
    size: 'small'
  }));
};

var TimelineCardSL = function TimelineCardSL(props) {
  return /*#__PURE__*/React$1.createElement(TimelineCardMasterTemplate, _extends({}, props, {
    orientation: 'horizontal',
    size: 'small'
  }));
};

var components$7 = {
  TimelineCardS: TimelineCardS,
  TimelineCardSL: TimelineCardSL
};
var TimelineStyleCard = function TimelineStyleCard(props) {
  var year = props.year,
    images = props.images,
    title = props.title,
    defaultTitle = props.defaultTitle,
    titleArray = props.titleArray,
    templateType = props.templateType,
    scaleSize = props.scaleSize,
    ownerName = props.ownerName,
    collectionName = props.collectionName,
    logo = props.logo,
    isNeedImagePlaceholder = props.isNeedImagePlaceholder;
  return React$1.createElement(components$7[templateType], {
    year: year,
    images: images,
    title: title && title.length && title.substring(0, 53),
    defaultTitle: defaultTitle,
    titleArray: titleArray,
    scaleSize: scaleSize,
    ownerName: ownerName || '',
    collectionName: collectionName || '',
    logo: logo,
    isNeedImagePlaceholder: isNeedImagePlaceholder
  });
};

var _templateObject$1D, _templateObject2$1D, _templateObject3$1C, _templateObject4$1g;
var Wrapper$11 = styled.div(_templateObject$1D || (_templateObject$1D = _taggedTemplateLiteralLoose(["\n  width: 210mm;\n  height: 297mm;\n  transform: scale(calc(", " / 210), calc(", " / 297));\n  transform-origin: left top;\n  user-select: none;\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var AccountWrapper = styled.div(_templateObject2$1D || (_templateObject2$1D = _taggedTemplateLiteralLoose(["\n    display: flex;\n    width: 100%;\n    height: 100%;\n    flex-flow: column;\n    position: relative;\n    background-color: #fff;\n    padding: 7.42mm;\n    justify-content: space-between;\n    box-sizing: border-box;\n"])));
var CoverContainer$1 = styled.div(_templateObject3$1C || (_templateObject3$1C = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: calc(100% - 20.13vw);\n  position: relative;\n  display: flex;\n  align-items: center;\n\n  img {\n    width: 100%;\n    height: auto;\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var Title$2 = styled.div(_templateObject4$1g || (_templateObject4$1g = _taggedTemplateLiteralLoose(["\n    font-family: Roboto;\n    font-size: 13.28mm;\n    line-height: 13.28mm;\n    color: #151514;\n    font-weight: 700;\n    white-space: pre-wrap;\n    text-align: center;\n    word-wrap: break-word;\n    text-transform: uppercase;\n    margin-top: 6.85mm;\n"])));
var AccountCardMain = function AccountCardMain(props) {
  var dw = props.dw,
    dh = props.dh,
    serviceName = props.serviceName,
    image = props.image,
    baseUrl = props.baseUrl;
  var orientation = useMemo(function () {
    return image && (image.orientaion || image.Orientaion);
  }, [image]);
  var ratio = useMemo(function () {
    return image && (image.ratio || image.Ratio);
  }, [image]);
  var isSquare = useMemo(function () {
    if (!image) return false;
    if (image.width && image.height) return image.width === image.height;
    return image.Width === image.Height;
  }, [image]);
  var imageUrl = useMemo(function () {
    if (image && image.url) return baseUrl + "/" + image.url;
    return image && image.Url ? baseUrl + "/" + image.Url : '';
  }, [image, baseUrl]);
  return /*#__PURE__*/React$1.createElement(Wrapper$11, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(AccountWrapper, null, /*#__PURE__*/React$1.createElement(CoverContainer$1, {
    orientation: orientation,
    ratio: ratio,
    isSquare: isSquare
  }, /*#__PURE__*/React$1.createElement("img", {
    src: imageUrl,
    alt: ""
  })), serviceName && serviceName.length && /*#__PURE__*/React$1.createElement(Title$2, null, serviceName)));
};

var components$8 = {
  AccountCardMain: AccountCardMain
};
var AccountCard = function AccountCard(props) {
  var data = props.data,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$8[templateType], {
    dw: dw,
    dh: dh,
    serviceName: data && data.serviceName || '',
    baseUrl: data && data.baseUrl || '',
    image: data && data.image || undefined
  });
};

var useResizedImageEnhanced = function useResizedImageEnhanced(files, useRatio) {
  var filesSafe = useMemo(function () {
    return files ? [].concat(files) : [];
  }, [files]);
  var containerRef = useRef(null);
  var _useState = useState(),
    container = _useState[0],
    setContainer = _useState[1];
  var containerWidth = container && container.offsetWidth;
  var containerHeight = container && container.offsetHeight;
  var pixelRatio = window.devicePixelRatio <= 2 ? window.devicePixelRatio : 2;
  var targetWidth = (containerWidth || 0) * pixelRatio;
  var targetHeight = useRatio ? pixelRatio * (containerWidth || 0) / (files ? files[0].ratio : 0) : (containerHeight || 0) * pixelRatio;
  var image = useMemo(function () {
    if (!containerWidth) {
      return null;
    }
    var _filesSafe$reduce = filesSafe.reduce(function (result, item) {
        var width = item.width,
          height = item.height;
        var area = width * height;
        var smallestArea = result.smallestArea;
        if (width >= targetWidth && height >= targetHeight && (!smallestArea || area < smallestArea)) {
          return {
            resized: item,
            smallestArea: area
          };
        }
        return result;
      }, {
        smallestArea: 0,
        resized: null
      }),
      resized = _filesSafe$reduce.resized;
    var _filesSafe$reduce2 = filesSafe.reduce(function (result, item) {
        var width = item.width,
          height = item.height;
        var area = width * height;
        var largestArea = result.largestArea;
        if (!largestArea || area > largestArea) {
          return {
            largest: item,
            largestArea: area
          };
        }
        return result;
      }, {
        largestArea: 0,
        largest: null
      }),
      largest = _filesSafe$reduce2.largest;
    return resized || largest;
  }, [targetWidth, filesSafe]);
  useEffect(function () {
    if (containerRef.current) {
      setContainer(containerRef.current);
    }
  }, []);
  return [image, containerRef];
};

var WEEKS = [{
  title: {
    ru: 'Пн',
    en: 'Mo'
  },
  isWeekend: false
}, {
  title: {
    ru: 'Вт',
    en: 'Tu'
  },
  isWeekend: false
}, {
  title: {
    ru: 'Ср',
    en: 'We'
  },
  isWeekend: false
}, {
  title: {
    ru: 'Чт',
    en: 'Th'
  },
  isWeekend: false
}, {
  title: {
    ru: 'Пт',
    en: 'Fr'
  },
  isWeekend: false
}, {
  title: {
    ru: 'Сб',
    en: 'Sa'
  },
  isWeekend: true
}, {
  title: {
    ru: 'Вс',
    en: 'Su'
  },
  isWeekend: true
}];
var LINES = 5;
var DAYS_IN_WEEK = 7;
var HOLIDAYS = ['1-1', '2-1', '3-1', '4-1', '5-1', '6-1', '7-1', '8-1', '23-2', '8-3', '1-5', '9-5', '12-6', '4-11'];
var MONTHS_FULL_NAMES = ['января', 'февраля', 'марта', 'апреля', 'мая', 'июня', 'июля', 'августа', 'сентября', 'октября', 'ноября', 'декабря'];
var langVariant = {
  ru: 'ru-RU',
  en: 'en-US'
};
var getRussianDay = function getRussianDay(day) {
  if (day === 0) return 6;
  return day - 1;
};
var getDaysInMonth = function getDaysInMonth(year, month) {
  var newDate = new Date(year, month, 1);
  newDate.setMonth(newDate.getMonth() + 1);
  newDate.setDate(newDate.getDate() - 1);
  return newDate.getDate();
};
var isEventDay = function isEventDay(year, month, day, events) {
  if (!(events && events.length)) return false;
  var realMonth = month + 1;
  var date = year + '-' + (realMonth < 10 ? '0' + realMonth : realMonth) + '-' + (day < 10 ? '0' + day : day);
  return events.findIndex(function (_ref) {
    var fullDate = _ref.fullDate;
    return fullDate === date;
  }) !== -1;
};
var isDayInRange = function isDayInRange(year, month, day, startDate, endDate) {
  var realMonth = month + 1;
  var dateString = year + '-' + (realMonth < 10 ? '0' + realMonth : realMonth) + '-' + (day < 10 ? '0' + day : day);
  var date = new Date(dateString);
  return date >= startDate && date <= endDate;
};
var isWeekendDay = function isWeekendDay(weekDay, month, day, withSaturday) {
  if (withSaturday === void 0) {
    withSaturday = true;
  }
  if ((weekDay % 7 === 5 && withSaturday || weekDay % 7 === 6) && weekDay !== 0) return true;
  return HOLIDAYS.includes(day + '-' + (month + 1));
};
var getDateViewerData = function getDateViewerData(currentMonth, events, isHorizontal, startDateString, calendarType, withSaturday) {
  var data = [];
  var startDate = new Date(startDateString);
  var endDate = new Date(startDate);
  endDate.setFullYear(endDate.getFullYear() + 1);
  if (calendarType === 0) {
    endDate.setDate(endDate.getDate() - 1);
  }
  var currentMonthNumber = currentMonth.getMonth();
  var currentDayNumber = currentMonth.getDay();
  var currentFullYearNumber = currentMonth.getFullYear();
  if (!isHorizontal) for (var i = 0; i < getRussianDay(currentDayNumber); i++) data.push([]);
  for (var _i = 0; _i < getDaysInMonth(currentFullYearNumber, currentMonthNumber); _i++) {
    var day = _i + 1;
    if (data.length >= LINES * DAYS_IN_WEEK && !isHorizontal) {
      var extraDayIndex = _i + getRussianDay(currentDayNumber) - DAYS_IN_WEEK;
      data[extraDayIndex].push({
        title: day,
        isEvent: isEventDay(currentFullYearNumber, currentMonthNumber, day, events),
        isInRange: isDayInRange(currentFullYearNumber, currentMonthNumber, day, startDate, endDate),
        isWeekend: isWeekendDay(extraDayIndex, currentMonthNumber, day, withSaturday)
      });
      continue;
    }
    data.push([{
      title: day,
      isEvent: isEventDay(currentFullYearNumber, currentMonthNumber, day, events),
      isInRange: isDayInRange(currentFullYearNumber, currentMonthNumber, day, startDate, endDate),
      isWeekend: isWeekendDay(isHorizontal ? data.length + getRussianDay(currentDayNumber) : data.length, currentMonthNumber, day, withSaturday)
    }]);
  }
  if (!isHorizontal) for (var _i2 = data.length; _i2 < LINES * DAYS_IN_WEEK; _i2++) data.push([]);
  return data;
};
var getFirstMonthDay = function getFirstMonthDay(currentMonth) {
  var currentDayNumber = currentMonth.getDay();
  return getRussianDay(currentDayNumber);
};
var getDateViewerTitle = function getDateViewerTitle(currentMonth, format) {
  if (format === void 0) {
    format = 'en';
  }
  return currentMonth.toLocaleString(langVariant[format], {
    month: 'long'
  });
};
var getEventString = function getEventString(event) {
  var date = new Date(event.fullDate);
  var month = date.getMonth();
  var day = date.getDate();
  return day + " " + MONTHS_FULL_NAMES[month] + " \u2014 " + event.description;
};
var useMonthEvents = function useMonthEvents(_ref2) {
  var date = _ref2.date,
    events = _ref2.events,
    startDateString = _ref2.startDate,
    calendarType = _ref2.calendarType;
  var monthEvents = useMemo(function () {
    var _events$filter;
    var cardMonth = date.getMonth();
    var cardYear = date.getFullYear();
    var startDate = new Date(startDateString);
    var endDate = new Date(startDate);
    endDate.setFullYear(endDate.getFullYear() + 1);
    if (calendarType === 0) {
      endDate.setDate(endDate.getDate() - 1);
    }
    return (events === null || events === void 0 ? void 0 : (_events$filter = events.filter(function (event) {
      var eventDate = new Date(event.fullDate);
      var eventYear = eventDate.getFullYear();
      var eventMonth = eventDate.getMonth();
      return eventYear === cardYear && eventMonth === cardMonth && eventDate >= startDate && eventDate <= endDate;
    })) === null || _events$filter === void 0 ? void 0 : _events$filter.sort(function (ev1, ev2) {
      return (ev1 === null || ev1 === void 0 ? void 0 : ev1.day) - (ev2 === null || ev2 === void 0 ? void 0 : ev2.day);
    })) || [];
  }, [date, events]);
  return monthEvents;
};

var _templateObject$1E, _templateObject2$1E, _templateObject3$1D;
var DatesContainer = styled.div(_templateObject$1E || (_templateObject$1E = _taggedTemplateLiteralLoose(["\n  height: 29%;\n  display: flex;\n  flex-direction: column;\n"])));
var DatesTable = styled.table(_templateObject2$1E || (_templateObject2$1E = _taggedTemplateLiteralLoose(["\n  border-collapse: collapse;\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n\n  & > thead {\n    height: 33%;\n    font-size: 18px;\n  }\n\n  & > tbody {\n    font-family: Baskerville;\n    font-style: italic;\n    font-size: 44px;\n  }\n"])));
var DayCell = styled.td(_templateObject3$1D || (_templateObject3$1D = _taggedTemplateLiteralLoose(["\n  border-width: ", "px;\n  border-color: ", ";\n  border-style: solid;\n  text-align: center;\n  color: ", ";\n"])), function (_ref) {
  var isEvent = _ref.isEvent,
    isInRange = _ref.isInRange;
  return isEvent && isInRange ? 3 : 1;
}, function (_ref2) {
  var isEvent = _ref2.isEvent,
    isInRange = _ref2.isInRange;
  return isEvent && isInRange ? '#d2232a' : '#252525';
}, function (_ref3) {
  var isEvent = _ref3.isEvent,
    isWeekend = _ref3.isWeekend,
    isInRange = _ref3.isInRange;
  return isInRange ? isWeekend || isEvent ? '#b4282e' : '#000000' : isWeekend || isEvent ? '#e0a9ac' : '#c8c8c8';
});
var CalendarHorizontalTable = function CalendarHorizontalTable(_ref4) {
  var date = _ref4.date,
    events = _ref4.events,
    isHorizontal = _ref4.isHorizontal,
    startDate = _ref4.startDate,
    calendarType = _ref4.calendarType,
    localization = _ref4.localization;
  var firstMonthDay = useMemo(function () {
    return getFirstMonthDay(date);
  }, [date]);
  var calendarMonthData = useMemo(function () {
    return getDateViewerData(date, events, isHorizontal, startDate, calendarType);
  }, [date, events, isHorizontal, startDate, calendarType]);
  return /*#__PURE__*/React$1.createElement(DatesContainer, null, /*#__PURE__*/React$1.createElement(DatesTable, null, /*#__PURE__*/React$1.createElement("thead", null, /*#__PURE__*/React$1.createElement("tr", null, calendarMonthData === null || calendarMonthData === void 0 ? void 0 : calendarMonthData.map(function (items, index) {
    var _items$, _items$2;
    var currentDate = WEEKS[(index + firstMonthDay) % WEEKS.length];
    return /*#__PURE__*/React$1.createElement(DayCell, {
      key: String(currentDate.title[localization]) + index,
      isWeekend: Boolean(items === null || items === void 0 ? void 0 : items.length) && ((_items$ = items[0]) === null || _items$ === void 0 ? void 0 : _items$.isWeekend),
      isInRange: Boolean(items === null || items === void 0 ? void 0 : items.length) && ((_items$2 = items[0]) === null || _items$2 === void 0 ? void 0 : _items$2.isInRange)
    }, currentDate.title[localization]);
  }))), /*#__PURE__*/React$1.createElement("tbody", null, /*#__PURE__*/React$1.createElement("tr", null, calendarMonthData.map(function (items, index) {
    if (items.length) {
      var _items$3, _items$4, _items$5;
      return /*#__PURE__*/React$1.createElement(DayCell, {
        isEvent: Boolean(items === null || items === void 0 ? void 0 : items.length) && ((_items$3 = items[0]) === null || _items$3 === void 0 ? void 0 : _items$3.isEvent),
        isWeekend: Boolean(items === null || items === void 0 ? void 0 : items.length) && ((_items$4 = items[0]) === null || _items$4 === void 0 ? void 0 : _items$4.isWeekend),
        isInRange: Boolean(items === null || items === void 0 ? void 0 : items.length) && ((_items$5 = items[0]) === null || _items$5 === void 0 ? void 0 : _items$5.isInRange),
        key: index + String(items[0].title)
      }, items[0].title);
    }
    return null;
  })))));
};

var _templateObject$1F, _templateObject2$1F, _templateObject3$1E, _templateObject4$1h, _templateObject5$17, _templateObject6$16, _templateObject7$15, _templateObject8$12;
var TitlesBlock = styled.div(_templateObject$1F || (_templateObject$1F = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 37.9%;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])));
var LeftSection = styled.div(_templateObject2$1F || (_templateObject2$1F = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  display: flex;\n  justify-content: flex-start;\n  align-items: center;\n  width: 25%;\n"])));
var MiddleSection = styled.div(_templateObject3$1E || (_templateObject3$1E = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 65%;\n  text-wrap: nowrap;\n  white-space: nowrap;\n  overflow: hidden;\n  padding-bottom: 2px !important;\n"])));
var RightSection = styled.div(_templateObject4$1h || (_templateObject4$1h = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n  width: 25%;\n"])));
var MonthTitle = styled.span(_templateObject5$17 || (_templateObject5$17 = _taggedTemplateLiteralLoose(["\n  font-weight: 700;\n  font-size: 84px;\n  text-transform: uppercase;\n  text-wrap: nowrap;\n  white-space: nowrap;\n  font-style: normal;\n"])));
var MonthEvents = styled.div(_templateObject6$16 || (_templateObject6$16 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  font-size: 11px;\n"])));
var MonthTitleInEvents = styled.div(_templateObject7$15 || (_templateObject7$15 = _taggedTemplateLiteralLoose(["\n  font-family: Baskerville;\n  font-style: italic;\n  font-size: 40px;\n  letter-spacing: ", "px;\n  margin-bottom: ", ";\n"])), function (_ref) {
  var withSignAndMonth = _ref.withSignAndMonth;
  return withSignAndMonth ? 4 : 5;
}, function (_ref2) {
  var withSignAndMonth = _ref2.withSignAndMonth;
  return withSignAndMonth && '-10px !important';
});
var DescriptionSubtitle = styled.div(_templateObject8$12 || (_templateObject8$12 = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  word-wrap: break-word;\n  word-break: break-all;\n  overflow: hidden;\n  margin-bottom: ", "px !important;\n  margin-top: 3px !important;\n"])), function (_ref3) {
  var withSignAndMonth = _ref3.withSignAndMonth;
  return withSignAndMonth ? 6 : 0;
});
var CalendarHorizontalTitles = function CalendarHorizontalTitles(_ref4) {
  var events = _ref4.events,
    date = _ref4.date,
    cardTitle = _ref4.cardTitle,
    author = _ref4.author,
    startDate = _ref4.startDate,
    calendarType = _ref4.calendarType,
    localization = _ref4.localization;
  var monthEvents = useMonthEvents({
    date: date,
    events: events,
    startDate: startDate,
    calendarType: calendarType
  });
  var calendarMonthTitle = useMemo(function () {
    var month = getDateViewerTitle(date, localization);
    return month.charAt(0).toUpperCase() + month.slice(1);
  }, [date, localization]);
  var monthTitle = Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length) && cardTitle.slice(0, 20) || calendarMonthTitle || '';
  var isMonthOnTheRight = Boolean(monthEvents === null || monthEvents === void 0 ? void 0 : monthEvents.length) && Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length);
  return /*#__PURE__*/React$1.createElement(TitlesBlock, null, /*#__PURE__*/React$1.createElement(LeftSection, null, monthEvents !== null && monthEvents !== void 0 && monthEvents.length ? /*#__PURE__*/React$1.createElement(MonthEvents, null, monthEvents.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index
    }, getEventString(item));
  })) : Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length) && /*#__PURE__*/React$1.createElement(MonthTitleInEvents, null, calendarMonthTitle)), /*#__PURE__*/React$1.createElement(MiddleSection, null, /*#__PURE__*/React$1.createElement(MonthTitle, null, monthTitle)), /*#__PURE__*/React$1.createElement(RightSection, {
    withSignAndMonth: isMonthOnTheRight && Boolean(author === null || author === void 0 ? void 0 : author.length)
  }, Boolean(author === null || author === void 0 ? void 0 : author.length) && /*#__PURE__*/React$1.createElement(DescriptionSubtitle, {
    withSignAndMonth: isMonthOnTheRight && Boolean(author === null || author === void 0 ? void 0 : author.length)
  }, author), isMonthOnTheRight && /*#__PURE__*/React$1.createElement(MonthTitleInEvents, {
    withSignAndMonth: isMonthOnTheRight && Boolean(author === null || author === void 0 ? void 0 : author.length)
  }, calendarMonthTitle)));
};

var _templateObject$1G, _templateObject2$1G, _templateObject3$1F;
var ImageContainer = styled.div(_templateObject$1G || (_templateObject$1G = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$W = styled.div(_templateObject2$1G || (_templateObject2$1G = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    aspect-ratio: ", ";\n    object-fit: cover;\n    background-color: #ffffff !important;\n  }\n"])), function (_ref) {
  var imgAspectRatio = _ref.imgAspectRatio;
  return imgAspectRatio;
});
var AuthorTitle = styled.div(_templateObject3$1F || (_templateObject3$1F = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: 0px;\n  right: -1.6em;\n  writing-mode: vertical-lr;\n  transform: rotate(180deg);\n  font-family: Inter;\n  font-size: 0.5625em;\n  z-index: 5;\n"])));
var ImageContent = function ImageContent(_ref2) {
  var img = _ref2.img,
    sideAuthor = _ref2.sideAuthor,
    imgAspectRatio = _ref2.imgAspectRatio,
    imageContentStyles = _ref2.imageContentStyles;
  return /*#__PURE__*/React$1.createElement(ImageContainer, {
    style: imageContentStyles
  }, /*#__PURE__*/React$1.createElement(ImageInner$W, {
    imgAspectRatio: imgAspectRatio
  }, /*#__PURE__*/React$1.createElement("img", {
    src: img === null || img === void 0 ? void 0 : img.url,
    alt: "",
    draggable: false
  }), /*#__PURE__*/React$1.createElement(AuthorTitle, null, sideAuthor)));
};

var _templateObject$1H, _templateObject2$1H, _templateObject3$1G, _templateObject4$1i;
var Footer = styled.footer(_templateObject$1H || (_templateObject$1H = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n"])), function (_ref) {
  var footerHeight = _ref.footerHeight;
  return footerHeight;
});
var Domain = styled.div(_templateObject2$1H || (_templateObject2$1H = _taggedTemplateLiteralLoose(["\n  text-transform: uppercase;\n  font-family: Inter;\n  font-weight: 700;\n  font-size: ", ";\n  margin-top: ", ";\n"])), function (_ref2) {
  var isHorizontal = _ref2.isHorizontal;
  return isHorizontal ? '32px' : '1.6em';
}, function (_ref3) {
  var isHorizontal = _ref3.isHorizontal;
  return !isHorizontal && '5px !important';
});
var MonthBottomRight = styled.div(_templateObject3$1G || (_templateObject3$1G = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  gap: ", ";\n  margin-top: ", ";\n\n  & > svg {\n    margin-bottom: 4px;\n  }\n"])), function (_ref4) {
  var isHorizontal = _ref4.isHorizontal;
  return isHorizontal ? '30px' : '43px';
}, function (_ref5) {
  var isHorizontal = _ref5.isHorizontal;
  return !isHorizontal && '5px !important';
});
var MonthCollectionName = styled.div(_templateObject4$1i || (_templateObject4$1i = _taggedTemplateLiteralLoose(["\n  color: #002d6e;\n  text-transform: uppercase;\n  font-family: HSE Sans;\n  font-weight: 700;\n  font-size: ", ";\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n\n  span {\n    color: #002d6e;\n    &:nth-of-type(2n) {\n      font-weight: 400;\n      letter-spacing: 0.05em;\n    }\n    &:nth-of-type(2n + 1) {\n      font-weight: 700;\n      letter-spacing: 0.07em;\n    }\n    &:not(:first-child) {\n      margin-left: -1mm;\n    }\n  }\n"])), function (_ref6) {
  var isHorizontal = _ref6.isHorizontal;
  return isHorizontal ? '32.4px' : '1.6em';
});
var FooterContent = function FooterContent(_ref7) {
  var isHorizontal = _ref7.isHorizontal,
    title = _ref7.title,
    ownerName = _ref7.ownerName,
    bottomLink = _ref7.bottomLink,
    cardId = _ref7.cardId,
    footerHeight = _ref7.footerHeight,
    svgSize = _ref7.svgSize,
    footerStyles = _ref7.footerStyles;
  var usedTitle = title || ownerName;
  var titleArr = usedTitle && usedTitle.trim().split(' ');
  return /*#__PURE__*/React$1.createElement(Footer, {
    footerHeight: footerHeight,
    style: footerStyles
  }, /*#__PURE__*/React$1.createElement(Domain, {
    isHorizontal: isHorizontal
  }, bottomLink || 'gallllery.com'), /*#__PURE__*/React$1.createElement(MonthBottomRight, {
    isHorizontal: isHorizontal
  }, /*#__PURE__*/React$1.createElement(MonthCollectionName, {
    isHorizontal: isHorizontal
  }, !!(titleArr && titleArr.length) && titleArr.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index + "-" + item,
      dangerouslySetInnerHTML: {
        __html: item + "&ThinSpace;"
      }
    });
  })), /*#__PURE__*/React$1.createElement(QRCodeSVG, {
    size: svgSize,
    value: (bottomLink || 'gallllery.com') + "/card/" + cardId
  })));
};

var DPI = 300;
var MM_PER_INCH = 25.4;
var useResizedImageForPrint = function useResizedImageForPrint(files, calendarSizes) {
  var targetWidthPx = Math.round(calendarSizes.width / MM_PER_INCH * DPI);
  var targetHeightPx = Math.round(calendarSizes.height / MM_PER_INCH * DPI);
  var filesSafe = useMemo(function () {
    return files ? [].concat(files) : [];
  }, [files]);
  var image = useMemo(function () {
    var _filesSafe$reduce = filesSafe.reduce(function (result, item) {
        var area = item.width * item.height;
        if ((!result.largestArea || area > result.largestArea) && item.size !== 'original') {
          return {
            largest: item,
            largestArea: area
          };
        }
        return result;
      }, {
        largestArea: 0,
        largest: null
      }),
      largest = _filesSafe$reduce.largest;
    return largest;
  }, [targetWidthPx, targetHeightPx, filesSafe]);
  return image;
};

var _templateObject$1I, _templateObject2$1I;
var calendarSizes = {
  width: 594,
  height: 420
};
var CalendarContainer = styled.div(_templateObject$1I || (_templateObject$1I = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  min-height: ", "mm;\n  min-width: ", "mm;\n  max-height: ", "mm;\n  max-width: ", "mm;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform-origin: top left;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n\n  * {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (_ref) {
  var height = _ref.height;
  return height;
}, function (_ref2) {
  var width = _ref2.width;
  return width;
}, function (_ref3) {
  var height = _ref3.height;
  return height;
}, function (_ref4) {
  var width = _ref4.width;
  return width;
}, function (props) {
  return props.dw;
}, function (_ref5) {
  var width = _ref5.width;
  return width;
}, function (props) {
  return props.dh;
}, function (_ref6) {
  var height = _ref6.height;
  return height;
});
var TextContent = styled.div(_templateObject2$1I || (_templateObject2$1I = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 22%;\n  padding: 0 74px;\n  display: flex;\n  flex-direction: column;\n"])));
var CalendarHorizontal = function CalendarHorizontal(_ref7) {
  var cardId = _ref7.cardId,
    cardTitle = _ref7.cardTitle,
    author = _ref7.author,
    _ref7$images = _ref7.images,
    images = _ref7$images === void 0 ? [] : _ref7$images,
    sideAuthor = _ref7.sideAuthor,
    date = _ref7.date,
    events = _ref7.events,
    bottomLink = _ref7.bottomLink,
    title = _ref7.title,
    ownerName = _ref7.ownerName,
    _ref7$isHorizontal = _ref7.isHorizontal,
    isHorizontal = _ref7$isHorizontal === void 0 ? true : _ref7$isHorizontal,
    containerClass = _ref7.containerClass,
    style = _ref7.style,
    localization = _ref7.localization,
    dw = _ref7.dw,
    dh = _ref7.dh,
    startDate = _ref7.startDate,
    calendarType = _ref7.calendarType,
    isPrinting = _ref7.isPrinting;
  var _useResizedImageEnhan = useResizedImageEnhanced(images),
    img = _useResizedImageEnhan[0],
    containerRef = _useResizedImageEnhan[1];
  var printImage = useResizedImageForPrint(images, calendarSizes);
  return /*#__PURE__*/React$1.createElement(CalendarContainer, {
    ref: containerRef,
    className: containerClass,
    style: style,
    height: calendarSizes.height,
    width: calendarSizes.width,
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(ImageContent, {
    img: isPrinting ? printImage : img,
    sideAuthor: sideAuthor,
    imgAspectRatio: "1.8 / 1",
    imageContentStyles: {
      padding: '74px 74px 0'
    }
  }), /*#__PURE__*/React$1.createElement(TextContent, null, /*#__PURE__*/React$1.createElement(CalendarHorizontalTitles, {
    author: author,
    events: events,
    date: date,
    cardTitle: cardTitle,
    startDate: startDate,
    calendarType: calendarType,
    localization: localization
  }), /*#__PURE__*/React$1.createElement(CalendarHorizontalTable, {
    date: date,
    events: events,
    isHorizontal: isHorizontal,
    startDate: startDate,
    calendarType: calendarType,
    localization: localization
  }), /*#__PURE__*/React$1.createElement(FooterContent, {
    isHorizontal: isHorizontal,
    title: title,
    ownerName: ownerName,
    bottomLink: bottomLink,
    cardId: cardId,
    footerHeight: "33.5%",
    svgSize: 65,
    footerStyles: {
      paddingBottom: '15px'
    }
  })));
};

var _templateObject$1J, _templateObject2$1J, _templateObject3$1H, _templateObject4$1j, _templateObject5$18, _templateObject6$17, _templateObject7$16, _templateObject8$13, _templateObject9$10;
var TitlesContainer = styled.div(_templateObject$1J || (_templateObject$1J = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 26.8%;\n  display: flex;\n  flex-direction: column;\n"])));
var TitleAndDescBlock = styled.div(_templateObject2$1J || (_templateObject2$1J = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 65.2%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
var EventsAndMonthBlock = styled.div(_templateObject3$1H || (_templateObject3$1H = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 34.6%;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  padding: 0 88px 3px !important;\n"])), function (_ref) {
  var withoutEvents = _ref.withoutEvents;
  return withoutEvents ? 'center' : 'space-between';
});
var Title$3 = styled.div(_templateObject4$1j || (_templateObject4$1j = _taggedTemplateLiteralLoose(["\n  text-wrap: nowrap;\n  white-space: nowrap;\n  width: 100%;\n  flex: 1;\n  padding-top: 20px !important;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 1.5px;\n"])));
var DescriptionSubtitle$1 = styled.div(_templateObject5$18 || (_templateObject5$18 = _taggedTemplateLiteralLoose(["\n  font-size: 14px;\n  line-height: 12px;\n  word-wrap: break-word;\n  word-break: break-all;\n  overflow: hidden;\n  height: 34.5%;\n"])));
var MonthSplitLine = styled.div(_templateObject6$17 || (_templateObject6$17 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n"])));
var MonthSplitDot = styled.div(_templateObject7$16 || (_templateObject7$16 = _taggedTemplateLiteralLoose(["\n  width: 1px;\n  height: 1px;\n  background-color: black;\n  border-radius: 50%;\n"])));
var MonthEvents$1 = styled.div(_templateObject8$13 || (_templateObject8$13 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  font-size: 10px;\n"])));
var MonthTitleInEvents$1 = styled.div(_templateObject9$10 || (_templateObject9$10 = _taggedTemplateLiteralLoose(["\n  font-family: Baskerville;\n  font-style: italic;\n  font-size: 36px;\n  letter-spacing: 2px;\n  margin-right: -2px !important;\n"])));
var dots = Array(89).fill(0);
var CalendarVerticalTitles = function CalendarVerticalTitles(_ref2) {
  var cardTitle = _ref2.cardTitle,
    date = _ref2.date,
    author = _ref2.author,
    events = _ref2.events,
    startDate = _ref2.startDate,
    localization = _ref2.localization,
    calendarType = _ref2.calendarType;
  var calendarMonthTitle = useMemo(function () {
    var month = getDateViewerTitle(date, localization);
    return month.charAt(0).toUpperCase() + month.slice(1);
  }, [date, localization]);
  var monthEvents = useMonthEvents({
    date: date,
    events: events,
    startDate: startDate,
    calendarType: calendarType
  });
  var mainTitle = Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length) && cardTitle.slice(0, 20) || calendarMonthTitle || '';
  return /*#__PURE__*/React$1.createElement(TitlesContainer, null, /*#__PURE__*/React$1.createElement(TitleAndDescBlock, null, /*#__PURE__*/React$1.createElement(Title$3, null, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    width: "100%",
    fontSizeMax: 84,
    text: mainTitle
  })), /*#__PURE__*/React$1.createElement(DescriptionSubtitle$1, null, Boolean(author === null || author === void 0 ? void 0 : author.length) && author)), /*#__PURE__*/React$1.createElement(MonthSplitLine, null, dots.map(function (_, i) {
    return /*#__PURE__*/React$1.createElement(MonthSplitDot, {
      key: i
    });
  })), /*#__PURE__*/React$1.createElement(EventsAndMonthBlock, {
    withoutEvents: !(monthEvents !== null && monthEvents !== void 0 && monthEvents.length)
  }, /*#__PURE__*/React$1.createElement(MonthEvents$1, null, monthEvents === null || monthEvents === void 0 ? void 0 : monthEvents.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index
    }, getEventString(item));
  })), Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length) && /*#__PURE__*/React$1.createElement(MonthTitleInEvents$1, null, calendarMonthTitle)));
};

var _templateObject$1K, _templateObject2$1K, _templateObject3$1I, _templateObject4$1k, _templateObject5$19, _templateObject6$18;
var DayCell$1 = styled.td(_templateObject$1K || (_templateObject$1K = _taggedTemplateLiteralLoose(["\n  border-width: ", "px;\n  border-color: ", ";\n  border-style: solid;\n  text-align: center;\n  color: ", ";\n"])), function (_ref) {
  var isEvent = _ref.isEvent,
    isInRange = _ref.isInRange;
  return isEvent && isInRange ? 3 : 1;
}, function (_ref2) {
  var isEvent = _ref2.isEvent,
    isInRange = _ref2.isInRange;
  return isEvent && isInRange ? '#d2232a' : '#252525';
}, function (_ref3) {
  var isEvent = _ref3.isEvent,
    isWeekend = _ref3.isWeekend,
    isInRange = _ref3.isInRange;
  return isInRange ? isWeekend || isEvent ? '#b4282e' : '#000000' : isWeekend || isEvent ? '#e0a9ac' : '#c8c8c8';
});
var DayHeaderCell = styled.th(_templateObject2$1K || (_templateObject2$1K = _taggedTemplateLiteralLoose(["\n  border: 1px solid #252525;\n  text-align: center;\n  color: ", ";\n"])), function (_ref4) {
  var isWeekend = _ref4.isWeekend;
  return isWeekend ? '#b4282e' : '#000000';
});
var DoubleDayCell = styled.td(_templateObject3$1I || (_templateObject3$1I = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  border-top: ", ";\n\n  border-left: ", ";\n\n  border-right: ", ";\n\n  border-bottom: ", ";\n"])), function (_ref5) {
  var isTopEvent = _ref5.isTopEvent;
  return isTopEvent ? "3px solid #b43036" : '1px solid #252525';
}, function (_ref6) {
  var isTopEvent = _ref6.isTopEvent;
  return isTopEvent ? "3px solid #b43036" : '1px solid #252525';
}, function (_ref7) {
  var isBottomEvent = _ref7.isBottomEvent;
  return isBottomEvent ? "3px solid #b43036" : '1px solid #252525';
}, function (_ref8) {
  var isBottomEvent = _ref8.isBottomEvent;
  return isBottomEvent ? " 3px solid #b43036" : ' 1px solid #252525';
});
var DoubleDayContainer = styled.div(_templateObject4$1k || (_templateObject4$1k = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n\n  &::after {\n    content: '';\n    position: absolute;\n    width: ", "%;\n    left: ", "%;\n    height: ", "px;\n    transform: rotate(135deg);\n    bottom: ", "%;\n    background-color: ", ";\n  }\n"])), function (_ref9) {
  var isBottomEvent = _ref9.isBottomEvent,
    isTopEvent = _ref9.isTopEvent;
  return isBottomEvent || isTopEvent ? "144" : "142";
}, function (_ref10) {
  var isBottomEvent = _ref10.isBottomEvent,
    isTopEvent = _ref10.isTopEvent;
  return isBottomEvent || isTopEvent ? "-22" : "-21.1";
}, function (_ref11) {
  var isBottomEvent = _ref11.isBottomEvent,
    isTopEvent = _ref11.isTopEvent;
  return isBottomEvent || isTopEvent ? "3" : "1";
}, function (_ref12) {
  var isBottomEvent = _ref12.isBottomEvent,
    isTopEvent = _ref12.isTopEvent;
  return isBottomEvent || isTopEvent ? "48.4" : "49.5";
}, function (_ref13) {
  var isBottomEvent = _ref13.isBottomEvent,
    isTopEvent = _ref13.isTopEvent;
  return isBottomEvent || isTopEvent ? "#b43036" : "#252525";
});
var TopDay = styled.div(_templateObject5$19 || (_templateObject5$19 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  top: 2%;\n  left: 6%;\n  font-size: 54px;\n  color: ", ";\n"])), function (_ref14) {
  var isEvent = _ref14.isEvent,
    isInRange = _ref14.isInRange;
  return isInRange ? isEvent ? '#b4282e' : '#000000' : isEvent ? '#e0a9ac' : '#c8c8c8';
});
var BottomDay = styled.div(_templateObject6$18 || (_templateObject6$18 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: 2%;\n  right: 6%;\n  font-size: 54px;\n  color: ", ";\n"])), function (_ref15) {
  var isEvent = _ref15.isEvent,
    isInRange = _ref15.isInRange;
  return isInRange ? isEvent ? '#b4282e' : '#000000' : isEvent ? '#e0a9ac' : '#c8c8c8';
});

var Row = function Row(_ref) {
  var data = _ref.data;
  return /*#__PURE__*/React$1.createElement("tr", null, data.map(function (items, index) {
    switch (items.length) {
      case 2:
        return /*#__PURE__*/React$1.createElement(DoubleDayCell, {
          isTopEvent: items[0].isEvent,
          isBottomEvent: items[1].isEvent,
          key: index
        }, /*#__PURE__*/React$1.createElement(DoubleDayContainer, {
          isTopEvent: items[0].isEvent,
          isBottomEvent: items[1].isEvent
        }, /*#__PURE__*/React$1.createElement(TopDay, {
          isEvent: items[0].isEvent,
          isInRange: items[0].isInRange
        }, items[0].title), /*#__PURE__*/React$1.createElement(BottomDay, {
          isEvent: items[1].isEvent,
          isInRange: items[1].isInRange
        }, items[1].title)));
      case 1:
        return /*#__PURE__*/React$1.createElement(DayCell$1, {
          isEvent: items && items.length && items[0].isEvent,
          isWeekend: items && items.length && items[0].isWeekend,
          isInRange: items && items.length && items[0].isInRange,
          key: index + String(items[0].title)
        }, items[0].title);
      default:
        return /*#__PURE__*/React$1.createElement(DayCell$1, {
          key: index
        });
    }
  }));
};

var _templateObject$1L, _templateObject2$1L;
var DatesContainer$1 = styled.div(_templateObject$1L || (_templateObject$1L = _taggedTemplateLiteralLoose(["\n  height: 63%;\n  display: flex;\n  flex-direction: column;\n  padding: 0 88px !important;\n"])));
var DatesTable$1 = styled.table(_templateObject2$1L || (_templateObject2$1L = _taggedTemplateLiteralLoose(["\n  border-collapse: collapse;\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n\n  & > thead {\n    height: 8.8%;\n    font-size: 24px;\n  }\n\n  & > tbody {\n    font-family: Baskerville;\n    font-style: italic;\n    font-size: 60px;\n  }\n"])));
var ROWS = Array(5).fill(0);
var CalendarVerticalTable = function CalendarVerticalTable(_ref) {
  var date = _ref.date,
    events = _ref.events,
    isHorizontal = _ref.isHorizontal,
    localization = _ref.localization,
    startDate = _ref.startDate,
    calendarType = _ref.calendarType;
  var calendarMonthData = useMemo(function () {
    return getDateViewerData(date, events, isHorizontal, startDate, calendarType);
  }, [date, events, isHorizontal, startDate, calendarType]);
  return /*#__PURE__*/React$1.createElement(DatesContainer$1, null, /*#__PURE__*/React$1.createElement(DatesTable$1, null, /*#__PURE__*/React$1.createElement("thead", null, /*#__PURE__*/React$1.createElement("tr", null, WEEKS.map(function (_ref2, index) {
    var title = _ref2.title,
      isWeekend = _ref2.isWeekend;
    return /*#__PURE__*/React$1.createElement(DayHeaderCell, {
      key: String(title[localization]) + index,
      isWeekend: isWeekend
    }, title[localization]);
  }))), /*#__PURE__*/React$1.createElement("tbody", null, ROWS.map(function (_, index) {
    return /*#__PURE__*/React$1.createElement(Row, {
      key: index,
      data: calendarMonthData.slice(index * DAYS_IN_WEEK, index * DAYS_IN_WEEK + DAYS_IN_WEEK)
    });
  }))));
};

var _templateObject$1M, _templateObject2$1M;
var calendarSizes$1 = {
  width: 300,
  height: 640
};
var CalendarContainer$1 = styled.div(_templateObject$1M || (_templateObject$1M = _taggedTemplateLiteralLoose(["\n  height: ", "mm;\n  width: ", "mm;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform-origin: top left;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n\n  * {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (_ref) {
  var height = _ref.height;
  return height;
}, function (_ref2) {
  var width = _ref2.width;
  return width;
}, function (props) {
  return props.dw;
}, function (_ref3) {
  var width = _ref3.width;
  return width;
}, function (props) {
  return props.dh;
}, function (_ref4) {
  var height = _ref4.height;
  return height;
});
var TextContent$1 = styled.div(_templateObject2$1M || (_templateObject2$1M = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 45.08%;\n  padding: 0 37px;\n  display: flex;\n  flex-direction: column;\n"])));
var CalendarVertical = function CalendarVertical(_ref5) {
  var cardId = _ref5.cardId,
    cardTitle = _ref5.cardTitle,
    author = _ref5.author,
    _ref5$images = _ref5.images,
    images = _ref5$images === void 0 ? [] : _ref5$images,
    sideAuthor = _ref5.sideAuthor,
    date = _ref5.date,
    events = _ref5.events,
    bottomLink = _ref5.bottomLink,
    title = _ref5.title,
    ownerName = _ref5.ownerName,
    _ref5$isHorizontal = _ref5.isHorizontal,
    isHorizontal = _ref5$isHorizontal === void 0 ? false : _ref5$isHorizontal,
    containerClass = _ref5.containerClass,
    style = _ref5.style,
    dw = _ref5.dw,
    dh = _ref5.dh,
    localization = _ref5.localization,
    startDate = _ref5.startDate,
    calendarType = _ref5.calendarType,
    isPrinting = _ref5.isPrinting;
  var _useResizedImageEnhan = useResizedImageEnhanced(images),
    img = _useResizedImageEnhan[0],
    containerRef = _useResizedImageEnhan[1];
  var printImage = useResizedImageForPrint(images, calendarSizes$1);
  return /*#__PURE__*/React$1.createElement(CalendarContainer$1, {
    ref: containerRef,
    className: containerClass,
    style: style,
    dw: dw,
    dh: dh,
    width: calendarSizes$1.width,
    height: calendarSizes$1.height
  }, /*#__PURE__*/React$1.createElement(ImageContent, {
    img: isPrinting ? printImage : img,
    sideAuthor: sideAuthor,
    imgAspectRatio: "1 / 1.2",
    imageContentStyles: {
      padding: '57px 37px 0'
    }
  }), /*#__PURE__*/React$1.createElement(TextContent$1, null, /*#__PURE__*/React$1.createElement(CalendarVerticalTitles, {
    author: author,
    date: date,
    cardTitle: cardTitle,
    events: events,
    startDate: startDate,
    calendarType: calendarType,
    localization: localization
  }), /*#__PURE__*/React$1.createElement(CalendarVerticalTable, {
    date: date,
    localization: localization,
    isHorizontal: isHorizontal,
    events: events,
    startDate: startDate,
    calendarType: calendarType
  }), /*#__PURE__*/React$1.createElement(FooterContent, {
    isHorizontal: isHorizontal,
    title: title,
    ownerName: ownerName,
    bottomLink: bottomLink,
    cardId: cardId,
    footerHeight: "9.9%",
    svgSize: 50,
    footerStyles: {
      padding: '0 88px'
    }
  })));
};

var _templateObject$1N, _templateObject2$1N;
var ImageContainer$1 = styled.div(_templateObject$1N || (_templateObject$1N = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$X = styled.div(_templateObject2$1N || (_templateObject2$1N = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    aspect-ratio: ", ";\n    object-fit: contain;\n    background-color: #ffffff !important;\n  }\n"])), function (_ref) {
  var imgAspectRatio = _ref.imgAspectRatio;
  return imgAspectRatio;
});
var ImageContent$1 = function ImageContent(_ref2) {
  var img = _ref2.img,
    imgAspectRatio = _ref2.imgAspectRatio,
    imageContentStyles = _ref2.imageContentStyles;
  return /*#__PURE__*/React$1.createElement(ImageContainer$1, {
    style: imageContentStyles
  }, /*#__PURE__*/React$1.createElement(ImageInner$X, {
    imgAspectRatio: imgAspectRatio
  }, /*#__PURE__*/React$1.createElement("img", {
    src: img === null || img === void 0 ? void 0 : img.url,
    alt: "",
    draggable: false
  })));
};

var _templateObject$1O, _templateObject2$1O, _templateObject3$1J, _templateObject4$1l, _templateObject5$1a, _templateObject6$19;
var TitlesContainer$1 = styled.div(_templateObject$1O || (_templateObject$1O = _taggedTemplateLiteralLoose(["\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n"])), function (_ref) {
  var withOnlyMonth = _ref.withOnlyMonth;
  return withOnlyMonth ? 36 : 15;
}, function (_ref2) {
  var withCardTitle = _ref2.withCardTitle,
    withOnlyMonth = _ref2.withOnlyMonth;
  return withOnlyMonth ? 12 : !withCardTitle ? 14.5 : 0.5;
});
var TitleAndDescBlock$1 = styled.div(_templateObject2$1O || (_templateObject2$1O = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 17.7px;\n"])));
var MonthBlock = styled.div(_templateObject3$1J || (_templateObject3$1J = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: ", ";\n"])), function (_ref3) {
  var withoutOnlyAuthor = _ref3.withoutOnlyAuthor;
  return withoutOnlyAuthor ? '30.5px 0 15.5px' : '13px 0 14px';
});
var Title$4 = styled.div(_templateObject4$1l || (_templateObject4$1l = _taggedTemplateLiteralLoose(["\n  font-family: 'Inter-Bold';\n  white-space: nowrap;\n  width: 100%;\n  flex: 1;\n  padding-top: ", "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-weight: 700;\n  text-transform: uppercase;\n"])), function (_ref4) {
  var withCardTitle = _ref4.withCardTitle;
  return withCardTitle ? 19 : 44;
});
var DescriptionSubtitle$2 = styled.div(_templateObject5$1a || (_templateObject5$1a = _taggedTemplateLiteralLoose(["\n  font-family: 'Inter';\n  font-size: 14.5px;\n  word-wrap: break-word;\n  word-break: break-all;\n  overflow: hidden;\n  height: 34.5%;\n"])));
var MonthName = styled.div(_templateObject6$19 || (_templateObject6$19 = _taggedTemplateLiteralLoose(["\n  font-family: Baskerville;\n  font-style: italic;\n  font-size: 30px;\n  letter-spacing: 6px;\n  margin-right: -6px !important;\n"])));
var Titles = function Titles(_ref5) {
  var cardTitle = _ref5.cardTitle,
    date = _ref5.date,
    author = _ref5.author,
    localization = _ref5.localization;
  var calendarMonthTitle = useMemo(function () {
    var month = getDateViewerTitle(date, localization);
    return month.charAt(0).toUpperCase() + month.slice(1);
  }, [date]);
  var mainTitle = Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length) && cardTitle.slice(0, 70) || calendarMonthTitle || '';
  var authorTitle = author !== null && author !== void 0 && author.length ? author.slice(0, 176) : '';
  var withCardTitle = Boolean(cardTitle === null || cardTitle === void 0 ? void 0 : cardTitle.length);
  var withOnlyMonth = !withCardTitle && !authorTitle;
  var withoutOnlyAuthor = withCardTitle && !authorTitle;
  return /*#__PURE__*/React$1.createElement(TitlesContainer$1, {
    withOnlyMonth: withOnlyMonth,
    withCardTitle: withCardTitle
  }, /*#__PURE__*/React$1.createElement(TitleAndDescBlock$1, null, /*#__PURE__*/React$1.createElement(Title$4, {
    withCardTitle: withCardTitle
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    width: "100%",
    fontSizeMax: 31,
    text: mainTitle
  })), /*#__PURE__*/React$1.createElement(DescriptionSubtitle$2, null, authorTitle)), /*#__PURE__*/React$1.createElement(MonthBlock, {
    withoutOnlyAuthor: withoutOnlyAuthor
  }, withCardTitle && /*#__PURE__*/React$1.createElement(MonthName, null, calendarMonthTitle)));
};

var updateDaysArray = function updateDaysArray(days) {
  var result = [];
  days.map(function (day) {
    return day !== null && day !== void 0 && day.length ? day : [{
      isEmpty: true
    }];
  }).forEach(function (day, index) {
    if (index === days.length - 1) {
      result.push(day);
    } else {
      result.push(day, [{
        isBorder: true
      }]);
    }
  });
  return result;
};

var _templateObject$1P, _templateObject2$1P, _templateObject3$1K, _templateObject4$1m;
var DoubleDay = styled.div(_templateObject$1P || (_templateObject$1P = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 40px;\n  display: flex;\n  align-items: center;\n"])));
var TopDay$1 = styled.div(_templateObject2$1P || (_templateObject2$1P = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: flex-end;\n  margin-left: ", "px!important;\n  color: ", ";\n  border-bottom: ", ";\n"])), function (_ref) {
  var isFirstElem = _ref.isFirstElem;
  return isFirstElem ? 0 : 10;
}, function (_ref2) {
  var isEvent = _ref2.isEvent;
  return isEvent ? '#b4282e' : '#000000';
}, function (_ref3) {
  var isEvent = _ref3.isEvent;
  return isEvent && '2px solid';
});
var BottomDay$1 = styled.div(_templateObject3$1K || (_templateObject3$1K = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  color: ", ";\n  border-bottom: ", ";\n  padding-left: 8px !important;\n  padding-right: 9px !important;\n  font-size: 26px;\n"])), function (_ref4) {
  var isEvent = _ref4.isEvent;
  return isEvent ? '#b4282e' : '#000000';
}, function (_ref5) {
  var isEvent = _ref5.isEvent;
  return isEvent && '2px solid';
});
var BlockWithLine = styled.div(_templateObject4$1m || (_templateObject4$1m = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 30px;\n  height: 100%;\n\n  &::after {\n    content: '';\n    position: absolute;\n    width: 170%;\n    height: 1px;\n    background-color: black;\n    top: 0;\n    right: 0;\n    transform: rotate(-53deg);\n    transform-origin: top right;\n  }\n"])));
var DoubleDayCell$1 = function DoubleDayCell(_ref6) {
  var day = _ref6.day,
    secondDay = _ref6.secondDay,
    isFirstElem = _ref6.isFirstElem;
  return /*#__PURE__*/React$1.createElement(DoubleDay, {
    isTopEvent: day === null || day === void 0 ? void 0 : day.isEvent,
    isBottomEvent: secondDay === null || secondDay === void 0 ? void 0 : secondDay.isEvent
  }, /*#__PURE__*/React$1.createElement(TopDay$1, {
    isEvent: day === null || day === void 0 ? void 0 : day.isEvent,
    isFirstElem: isFirstElem
  }, (day === null || day === void 0 ? void 0 : day.title) || ''), /*#__PURE__*/React$1.createElement(BlockWithLine, null), /*#__PURE__*/React$1.createElement(BottomDay$1, {
    isEvent: secondDay === null || secondDay === void 0 ? void 0 : secondDay.isEvent,
    isInRange: secondDay === null || secondDay === void 0 ? void 0 : secondDay.isInRange
  }, (secondDay === null || secondDay === void 0 ? void 0 : secondDay.title) || ''), ' ');
};

var _templateObject$1Q, _templateObject2$1Q, _templateObject3$1L, _templateObject4$1n, _templateObject5$1b;
var DayCell$2 = styled.div(_templateObject$1Q || (_templateObject$1Q = _taggedTemplateLiteralLoose(["\n  line-height: 39.2px;\n  font-size: 38px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-bottom: ", ";\n  padding: ", "!important;\n\n  padding-left: ", "px!important;\n\n  padding-right: ", "px!important;\n\n  color: ", ";\n"])), function (_ref) {
  var isEvent = _ref.isEvent;
  return isEvent && '2px solid';
}, function (_ref2) {
  var isBorder = _ref2.isBorder;
  return !isBorder && '0 10px';
}, function (_ref3) {
  var isFirstElem = _ref3.isFirstElem,
    dayLeesThanTen = _ref3.dayLeesThanTen;
  return isFirstElem && !dayLeesThanTen && 0;
}, function (_ref4) {
  var isLastElem = _ref4.isLastElem,
    dayLeesThanTen = _ref4.dayLeesThanTen;
  return isLastElem && !dayLeesThanTen && 0;
}, function (_ref5) {
  var isEvent = _ref5.isEvent,
    isWeekend = _ref5.isWeekend;
  return isWeekend || isEvent ? '#b6252c' : '#000000';
});
var BorderTd = styled.div(_templateObject2$1Q || (_templateObject2$1Q = _taggedTemplateLiteralLoose(["\n  border-top: 1px solid;\n  flex: 1;\n  height: 0;\n"])));
var DayTd = styled.td(_templateObject3$1L || (_templateObject3$1L = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: ", ";\n"])), function (_ref6) {
  var isFirstElem = _ref6.isFirstElem,
    isLastElem = _ref6.isLastElem,
    isFirstShortBorder = _ref6.isFirstShortBorder,
    isSecondShortBorder = _ref6.isSecondShortBorder,
    isTwoDoubleDay = _ref6.isTwoDoubleDay;
  if (isFirstElem || isLastElem) {
    return 1.5;
  }
  if (isFirstShortBorder) {
    if (!isTwoDoubleDay) {
      return 1.3;
    }
    return 1.75;
  }
  if (isSecondShortBorder && isTwoDoubleDay) {
    return 1.2;
  }
  return 2;
});
var WeeksContent = styled.tr(_templateObject4$1n || (_templateObject4$1n = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  font-size: 38px;\n  height: 40px;\n"])));
var EmptyDay = styled.div(_templateObject5$1b || (_templateObject5$1b = _taggedTemplateLiteralLoose(["\n  margin-left: ", "px !important;\n  margin-right: ", "px !important;\n  height: 30px;\n  width: 0;\n  border-right: 1px solid;\n"])), function (p) {
  return p.isFirstElem && 20;
}, function (p) {
  return p.isLastElem && 20;
});
var Row$1 = function Row(_ref7) {
  var data = _ref7.data,
    rowIndex = _ref7.rowIndex;
  var adaptedData = updateDaysArray(data);
  return /*#__PURE__*/React$1.createElement(WeeksContent, null, adaptedData.map(function (item, index, arr) {
    var day = item[0],
      secondDay = item[1];
    var arraysWithDoubleDay = arr.filter(function (item) {
      return item.length > 1;
    });
    var isTwoDoubleDay = (arraysWithDoubleDay === null || arraysWithDoubleDay === void 0 ? void 0 : arraysWithDoubleDay.length) === 2;
    var withSecondDay = item.length > 1;
    var isLastElem = index === adaptedData.length - 1;
    var isFirstElem = index === 0;
    var isFirstShortBorder = (arraysWithDoubleDay === null || arraysWithDoubleDay === void 0 ? void 0 : arraysWithDoubleDay.length) && index === 1;
    var isSecondShortBorder = (arraysWithDoubleDay === null || arraysWithDoubleDay === void 0 ? void 0 : arraysWithDoubleDay.length) && index === 3;
    var dayKey = index.toString() + rowIndex;
    var dayLeesThanTen = day !== null && day !== void 0 && day.title ? +day.title < 10 : false;
    return /*#__PURE__*/React$1.createElement(DayTd, {
      key: dayKey,
      isLastElem: isLastElem,
      isFirstElem: isFirstElem,
      isFirstShortBorder: isFirstShortBorder,
      isSecondShortBorder: isSecondShortBorder,
      isTwoDoubleDay: isTwoDoubleDay
    }, !isFirstElem && /*#__PURE__*/React$1.createElement(BorderTd, null), day !== null && day !== void 0 && day.isEmpty ? /*#__PURE__*/React$1.createElement(EmptyDay, {
      isLastElem: isLastElem,
      isFirstElem: isFirstElem
    }) : withSecondDay ? /*#__PURE__*/React$1.createElement(DoubleDayCell$1, {
      day: day,
      secondDay: secondDay,
      isFirstElem: isFirstElem
    }) : /*#__PURE__*/React$1.createElement(DayCell$2, {
      isBorder: day === null || day === void 0 ? void 0 : day.isBorder,
      isWeekend: day === null || day === void 0 ? void 0 : day.isWeekend,
      isEvent: day === null || day === void 0 ? void 0 : day.isEvent,
      isLastElem: isLastElem,
      isFirstElem: isFirstElem,
      dayLeesThanTen: dayLeesThanTen
    }, /*#__PURE__*/React$1.createElement("span", null, (day === null || day === void 0 ? void 0 : day.title) || '')), !isLastElem && /*#__PURE__*/React$1.createElement(BorderTd, null));
  }));
};

var WEEKS$1 = [{
  title: {
    ru: 'Пн',
    en: 'Mо'
  },
  isWeekend: false
}, {
  title: {
    ru: '',
    en: ''
  },
  isWeekend: false
}, {
  title: {
    ru: 'Вт',
    en: 'Tu'
  },
  isWeekend: false
}, {
  title: {
    ru: '',
    en: ''
  },
  isWeekend: false
}, {
  title: {
    ru: 'Ср',
    en: 'We'
  },
  isWeekend: false
}, {
  title: {
    ru: '',
    en: ''
  },
  isWeekend: false
}, {
  title: {
    ru: 'Чт',
    en: 'Th'
  },
  isWeekend: false
}, {
  title: {
    ru: '',
    en: ''
  },
  isWeekend: false
}, {
  title: {
    ru: 'Пт',
    en: 'Fr'
  },
  isWeekend: false
}, {
  title: {
    ru: '',
    en: ''
  },
  isWeekend: false
}, {
  title: {
    ru: 'Сб',
    en: 'Sa'
  },
  isWeekend: false
}, {
  title: {
    ru: '',
    en: ''
  },
  isWeekend: false
}, {
  title: {
    ru: 'Вс',
    en: 'Su'
  },
  isWeekend: true
}];
var ROWS$1 = Array(5).fill(0);
var DAYS_IN_WEEK$1 = 7;

var _templateObject$1R, _templateObject2$1R, _templateObject3$1M, _templateObject4$1o, _templateObject5$1c, _templateObject6$1a;
var DatesContainer$2 = styled.div(_templateObject$1R || (_templateObject$1R = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n"])));
var DatesTable$2 = styled.table(_templateObject2$1R || (_templateObject2$1R = _taggedTemplateLiteralLoose(["\n  border-collapse: collapse;\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n\n  & > tbody {\n    font-family: Baskerville;\n    font-style: italic;\n  }\n\n  * {\n    padding: 0;\n    margin: 0;\n  }\n"])));
var WeeksContent$1 = styled.tr(_templateObject3$1M || (_templateObject3$1M = _taggedTemplateLiteralLoose(["\n  height: 38px;\n  display: flex;\n  align-items: center;\n"])));
var BorderTh = styled.div(_templateObject4$1o || (_templateObject4$1o = _taggedTemplateLiteralLoose(["\n  border-top: 2.8px solid;\n  flex: 1;\n  height: 0;\n"])));
var WeekDayName = styled.div(_templateObject5$1c || (_templateObject5$1c = _taggedTemplateLiteralLoose(["\n  font-family: 'Inter-Bold';\n  font-size: 11px;\n  line-height: 39px;\n  display: flex;\n  font-weight: bold;\n  align-items: center;\n  justify-content: center;\n  text-align: center;\n  color: ", ";\n\n  padding: ", "!important;\n"])), function (_ref) {
  var isEvent = _ref.isEvent,
    isWeekend = _ref.isWeekend;
  return isWeekend || isEvent ? '#b6252c' : '#000000';
}, function (_ref2) {
  var isBorder = _ref2.isBorder;
  return !isBorder && '0 13px';
});
var WeekDayContainer = styled.td(_templateObject6$1a || (_templateObject6$1a = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex: ", ";\n"])), function (_ref3) {
  var isFirstElem = _ref3.isFirstElem,
    isLastElem = _ref3.isLastElem;
  return isFirstElem || isLastElem ? 1.5 : 2;
});
var CalendarTable = function CalendarTable(_ref4) {
  var date = _ref4.date,
    events = _ref4.events,
    _ref4$isHorizontal = _ref4.isHorizontal,
    isHorizontal = _ref4$isHorizontal === void 0 ? false : _ref4$isHorizontal,
    startDate = _ref4.startDate,
    calendarType = _ref4.calendarType,
    localization = _ref4.localization;
  var calendarMonthData = useMemo(function () {
    return getDateViewerData(date, events, isHorizontal, startDate, calendarType, false);
  }, [date, events, isHorizontal, startDate, calendarType]);
  return /*#__PURE__*/React$1.createElement(DatesContainer$2, null, /*#__PURE__*/React$1.createElement(DatesTable$2, null, /*#__PURE__*/React$1.createElement("thead", null, /*#__PURE__*/React$1.createElement(WeeksContent$1, null, WEEKS$1.map(function (_ref5, index) {
    var _title$localization;
    var title = _ref5.title,
      isWeekend = _ref5.isWeekend;
    var isLastElem = index === WEEKS$1.length - 1;
    var isFirstElem = index === 0;
    return /*#__PURE__*/React$1.createElement(WeekDayContainer, {
      key: title[localization] + index,
      isFirstElem: isFirstElem,
      isLastElem: isLastElem
    }, !isFirstElem && /*#__PURE__*/React$1.createElement(BorderTh, null), /*#__PURE__*/React$1.createElement(WeekDayName, {
      isFirstElem: isFirstElem,
      isLastElem: isLastElem,
      isWeekend: isWeekend,
      isBorder: !title[localization]
    }, (_title$localization = title[localization]) === null || _title$localization === void 0 ? void 0 : _title$localization.toUpperCase()), !isLastElem && /*#__PURE__*/React$1.createElement(BorderTh, null));
  }))), /*#__PURE__*/React$1.createElement("tbody", null, ROWS$1.map(function (_, index) {
    return /*#__PURE__*/React$1.createElement(Row$1, {
      key: index,
      rowIndex: index,
      data: calendarMonthData.slice(index * DAYS_IN_WEEK$1, index * DAYS_IN_WEEK$1 + DAYS_IN_WEEK$1)
    });
  }))));
};

var _templateObject$1S, _templateObject2$1S;
var Footer$1 = styled.footer(_templateObject$1S || (_templateObject$1S = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-top: 30px;\n\n  & > svg {\n    padding-bottom: 4px;\n    padding-left: 4px;\n  }\n"])), function (_ref) {
  var footerHeight = _ref.footerHeight;
  return footerHeight;
});
var MonthCollectionName$1 = styled.div(_templateObject2$1S || (_templateObject2$1S = _taggedTemplateLiteralLoose(["\n  color: #002d6e;\n  text-transform: uppercase;\n  font-family: HSE Sans;\n  font-weight: 700;\n  font-size: 25px;\n  display: flex;\n  align-items: center;\n  flex-wrap: wrap;\n  justify-content: flex-end;\n\n  span {\n    color: #002d6e;\n    &:nth-of-type(2n) {\n      font-weight: 400;\n      letter-spacing: 0.05em;\n    }\n    &:nth-of-type(2n + 1) {\n      font-weight: 700;\n      letter-spacing: 0.07em;\n    }\n    &:not(:first-child) {\n      margin-left: -1mm;\n    }\n  }\n"])));
var FooterContent$1 = function FooterContent(_ref2) {
  var _ref2$isHorizontal = _ref2.isHorizontal,
    isHorizontal = _ref2$isHorizontal === void 0 ? false : _ref2$isHorizontal,
    title = _ref2.title,
    ownerName = _ref2.ownerName,
    bottomLink = _ref2.bottomLink,
    cardId = _ref2.cardId,
    footerHeight = _ref2.footerHeight,
    svgSize = _ref2.svgSize,
    footerStyles = _ref2.footerStyles;
  var usedTitle = title || ownerName;
  var titleArr = usedTitle && usedTitle.trim().split(' ');
  return /*#__PURE__*/React$1.createElement(Footer$1, {
    footerHeight: footerHeight,
    style: footerStyles
  }, /*#__PURE__*/React$1.createElement(MonthCollectionName$1, {
    isHorizontal: isHorizontal
  }, !!(titleArr && titleArr.length) && titleArr.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index + "-" + item,
      dangerouslySetInnerHTML: {
        __html: item + "&ThinSpace;"
      }
    });
  })), /*#__PURE__*/React$1.createElement(QRCodeSVG, {
    size: svgSize,
    value: (bottomLink || 'gallllery.com') + "/card/" + cardId
  }));
};

var _templateObject$1T, _templateObject2$1T, _templateObject3$1N;
var calendarSizes$2 = {
  width: 420,
  height: 594
};
var CalendarContainer$2 = styled.div(_templateObject$1T || (_templateObject$1T = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform-origin: top left;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  padding: 157px 157px 0;\n  transform: scale(", ");\n  background: transparent !important;\n\n  * {\n    box-sizing: border-box;\n  }\n"])), function (_ref) {
  var width = _ref.width;
  return width;
}, function (_ref2) {
  var height = _ref2.height;
  return height;
}, function (_ref3) {
  var dw = _ref3.dw;
  return dw;
}, function (_ref4) {
  var width = _ref4.width;
  return width;
}, function (_ref5) {
  var dh = _ref5.dh;
  return dh;
}, function (_ref6) {
  var height = _ref6.height;
  return height;
}, function (p) {
  return p.scaleSize;
});
var TextContent$2 = styled.div(_templateObject2$1T || (_templateObject2$1T = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 26.8%;\n  display: flex;\n  flex-direction: column;\n"])));
var MonthEvents$2 = styled.div(_templateObject3$1N || (_templateObject3$1N = _taggedTemplateLiteralLoose(["\n  font-family: 'Inter';\n  height: ", ";\n  display: flex;\n  align-items: flex-start;\n  gap: 10px;\n  font-size: 10px;\n  margin-top: 10px;\n"])), function (_ref7) {
  var isEmptyEvents = _ref7.isEmptyEvents;
  return isEmptyEvents && '13px';
});
var CalendarModern = function CalendarModern(_ref8) {
  var cardTitle = _ref8.cardTitle,
    title = _ref8.title,
    author = _ref8.author,
    date = _ref8.date,
    events = _ref8.events,
    _ref8$images = _ref8.images,
    images = _ref8$images === void 0 ? [] : _ref8$images,
    startDate = _ref8.startDate,
    style = _ref8.style,
    calendarType = _ref8.calendarType,
    ownerName = _ref8.ownerName,
    bottomLink = _ref8.bottomLink,
    cardId = _ref8.cardId,
    containerClass = _ref8.containerClass,
    localization = _ref8.localization,
    dw = _ref8.dw,
    dh = _ref8.dh,
    scaleSize = _ref8.scaleSize,
    isPrinting = _ref8.isPrinting;
  var _useResizedImageEnhan = useResizedImageEnhanced(images),
    img = _useResizedImageEnhan[0],
    containerRef = _useResizedImageEnhan[1];
  var printImage = useResizedImageForPrint(images, calendarSizes$2);
  var monthEvents = useMonthEvents({
    date: date,
    events: events,
    startDate: startDate,
    calendarType: calendarType
  });
  return /*#__PURE__*/React$1.createElement(CalendarContainer$2, {
    ref: containerRef,
    style: style,
    className: containerClass,
    dw: dw,
    dh: dh,
    scaleSize: scaleSize,
    width: calendarSizes$2.width,
    height: calendarSizes$2.height
  }, /*#__PURE__*/React$1.createElement(ImageContent$1, {
    img: isPrinting ? printImage : img,
    imgAspectRatio: "1 / 1.2"
  }), /*#__PURE__*/React$1.createElement(TextContent$2, null, /*#__PURE__*/React$1.createElement(Titles, {
    author: author,
    date: new Date(date),
    cardTitle: cardTitle,
    localization: localization
  }), /*#__PURE__*/React$1.createElement(CalendarTable, {
    date: date,
    events: events,
    startDate: startDate,
    calendarType: calendarType,
    localization: localization
  }), /*#__PURE__*/React$1.createElement(MonthEvents$2, {
    isEmptyEvents: !(monthEvents !== null && monthEvents !== void 0 && monthEvents.length)
  }, monthEvents === null || monthEvents === void 0 ? void 0 : monthEvents.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index
    }, getEventString(item));
  })), /*#__PURE__*/React$1.createElement(FooterContent$1, {
    title: title,
    ownerName: ownerName,
    bottomLink: bottomLink,
    cardId: cardId,
    footerHeight: "9.9%",
    svgSize: 53
  })));
};

var Calendar = function Calendar(props) {
  switch (props === null || props === void 0 ? void 0 : props.orientation) {
    case 'horizontal':
      return /*#__PURE__*/React$1.createElement(CalendarHorizontal, props);
    case 'free':
      return /*#__PURE__*/React$1.createElement(CalendarModern, props);
    case 'vertical':
    default:
      return /*#__PURE__*/React$1.createElement(CalendarVertical, props);
  }
};

var TimelineCardLL = function TimelineCardLL(props) {
  return /*#__PURE__*/React$1.createElement(TimelineCardMasterTemplate, _extends({}, props, {
    orientation: 'horizontal',
    size: 'large'
  }));
};

var TimelineCardL = function TimelineCardL(props) {
  return /*#__PURE__*/React$1.createElement(TimelineCardMasterTemplate, _extends({}, props, {
    orientation: 'vertical',
    size: 'large'
  }));
};

var _templateObject$1U, _templateObject2$1U, _templateObject3$1O, _templateObject4$1p, _templateObject5$1d, _templateObject6$1b, _templateObject7$17, _templateObject8$14, _templateObject9$11, _templateObject10$p, _templateObject11$p, _templateObject12$p, _templateObject13$p, _templateObject14$j, _templateObject15$7;
var Container = styled.div(_templateObject$1U || (_templateObject$1U = _taggedTemplateLiteralLoose(["\n  height: 594mm;\n  width: 420mm;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  transform: scale(", ");\n  transform-origin: top left;\n  padding: 80px 160px;\n\n  * {\n    box-sizing: border-box;\n  }\n"])), function (p) {
  return p.scaleSize;
});
var Header = styled.div(_templateObject2$1U || (_templateObject2$1U = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 7.6%;\n"])));
var YearBlock = styled.div(_templateObject3$1O || (_templateObject3$1O = _taggedTemplateLiteralLoose(["\n  font-family: 'Inter-Bold';\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: 70%;\n  color: #da0006;\n  font-size: 41px;\n  letter-spacing: 37px;\n  text-indent: 35px;\n"])));
var CardsBlock = styled.div(_templateObject4$1p || (_templateObject4$1p = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  width: 100%;\n"])));
var ImagesContainer = styled.div(_templateObject5$1d || (_templateObject5$1d = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(4, 1fr);\n"])));
var ImageWrapper = styled.div(_templateObject6$1b || (_templateObject6$1b = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  border-top: 1px solid black;\n  border-left: 1px solid black;\n\n  &:nth-child(3n) {\n    border-right: 1px solid black;\n  }\n  &:nth-last-child(-n + 3) {\n    border-bottom: 1px solid black;\n  }\n"])));
var ImageInner$Y = styled.div(_templateObject7$17 || (_templateObject7$17 = _taggedTemplateLiteralLoose(["\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  aspect-ratio: 1 / 1.2;\n"])));
var Image$1 = styled.img(_templateObject8$14 || (_templateObject8$14 = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: 100%;\n  object-fit: contain;\n  background-color: #ffffff !important;\n"])));
var Footer$2 = styled.div(_templateObject9$11 || (_templateObject9$11 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 11.3%;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n"])));
var FooterContainer = styled.div(_templateObject10$p || (_templateObject10$p = _taggedTemplateLiteralLoose(["\n  display: flex;\n  justify-content: space-between;\n  height: 50%;\n"])));
var TitleBlock = styled.div(_templateObject11$p || (_templateObject11$p = _taggedTemplateLiteralLoose(["\n  font-family: 'Inter';\n  width: 66.6%;\n  height: 100%;\n"])));
var LogoBlock = styled.div(_templateObject12$p || (_templateObject12$p = _taggedTemplateLiteralLoose(["\n  width: 25%;\n  height: 80%;\n  margin-top: 7px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n"])));
var Logo = styled.img(_templateObject13$p || (_templateObject13$p = _taggedTemplateLiteralLoose(["\n  max-width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n"])));
var Title$5 = styled.div(_templateObject14$j || (_templateObject14$j = _taggedTemplateLiteralLoose(["\n  font-size: 36px;\n  font-weight: bold;\n  letter-spacing: 0.5px;\n"])));
var SubTitle = styled.div(_templateObject15$7 || (_templateObject15$7 = _taggedTemplateLiteralLoose(["\n  font-size: 17px;\n  letter-spacing: 0.05px;\n  margin-top: 15px;\n"])));
var CalendarFreePreview = function CalendarFreePreview(_ref) {
  var images = _ref.images,
    year = _ref.year,
    title = _ref.title,
    scaleSize = _ref.scaleSize,
    logo = _ref.logo,
    author = _ref.author,
    styles = _ref.styles,
    imgAspectRatio = _ref.imgAspectRatio,
    isNeedImagePlaceholder = _ref.isNeedImagePlaceholder;
  var withLogo = Boolean(logo);
  var cardTitle = (title === null || title === void 0 ? void 0 : title.toUpperCase()) || '';
  var scale = extractSecondCalcValue(scaleSize);
  if (isNeedImagePlaceholder) {
    return /*#__PURE__*/React$1.createElement(CalendarImagePlaceholder, {
      orientation: "free",
      title: cardTitle,
      year: year,
      isHorizontal: false,
      isPrinting: false,
      scaleSize: scaleSize
    });
  }
  return /*#__PURE__*/React$1.createElement(Container, {
    scaleSize: scale,
    style: styles
  }, /*#__PURE__*/React$1.createElement(Header, null, year ? /*#__PURE__*/React$1.createElement(YearBlock, null, year) : /*#__PURE__*/React$1.createElement(YearPlaceholder, {
    isScaled: true,
    className: "year_free"
  })), isNeedImagePlaceholder ? /*#__PURE__*/React$1.createElement(CalendarImagePlaceholder, null) : /*#__PURE__*/React$1.createElement(CardsBlock, null, /*#__PURE__*/React$1.createElement(ImagesContainer, null, images.map(function (image, index) {
    return /*#__PURE__*/React$1.createElement(ImageWrapper, {
      key: index
    }, /*#__PURE__*/React$1.createElement(ImageInner$Y, null, /*#__PURE__*/React$1.createElement(Image$1, {
      src: image,
      imgAspectRatio: imgAspectRatio
    })));
  }))), /*#__PURE__*/React$1.createElement(Footer$2, null, /*#__PURE__*/React$1.createElement(FooterContainer, null, /*#__PURE__*/React$1.createElement(TitleBlock, null, cardTitle ? /*#__PURE__*/React$1.createElement(Title$5, null, cardTitle) : /*#__PURE__*/React$1.createElement(TitlePlaceholder, {
    className: "title_free",
    isScaled: true
  }), /*#__PURE__*/React$1.createElement(SubTitle, null, author)), /*#__PURE__*/React$1.createElement(LogoBlock, null, withLogo && /*#__PURE__*/React$1.createElement(Logo, {
    src: logo,
    alt: "logo"
  })))));
};

var getImageUrl = function getImageUrl(images) {
  var _images$;
  if (!images) return '';
  var imageOriginal = images.find(function (image) {
    return (image === null || image === void 0 ? void 0 : image.size) === 'original';
  });
  if (imageOriginal) return imageOriginal === null || imageOriginal === void 0 ? void 0 : imageOriginal.url;
  return ((_images$ = images[0]) === null || _images$ === void 0 ? void 0 : _images$.url) || '';
};

var previewCard = {
  horizontal: TimelineCardLL,
  vertical: TimelineCardL,
  free: CalendarFreePreview
};
var CalendarsPrint = function CalendarsPrint(_ref) {
  var _calendarsData$logoFi, _calendarsData$title, _calendarsData$cards;
  var calendarsData = _ref.calendarsData;
  var images = calendarsData && calendarsData.cards && calendarsData.cards.length ? calendarsData.cards.map(function (card) {
    return card && card.imageUrl;
  }) : [];
  var logo = getImageUrl(calendarsData !== null && calendarsData !== void 0 && (_calendarsData$logoFi = calendarsData.logoFiles) !== null && _calendarsData$logoFi !== void 0 && _calendarsData$logoFi.length ? calendarsData.logoFiles : []);
  var year = new Date().getFullYear();
  var getDateFromMonthIndex = function getDateFromMonthIndex(index) {
    var currentYear = calendarsData && calendarsData.year || year;
    var currentMonth = index + (calendarsData && calendarsData.startMonth);
    var nextYear = currentYear + 1;
    return new Date(currentMonth > 11 ? nextYear : currentYear, currentMonth % 12);
  };
  var Preview = calendarsData !== null && calendarsData !== void 0 && calendarsData.orientation ? previewCard[calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.orientation] : TimelineCardL;
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      display: 'grid'
    }
  }, /*#__PURE__*/React$1.createElement(Preview, {
    isPrinting: true,
    year: calendarsData && calendarsData.timelineYear || year,
    images: images && images.length && images.slice(0, 12) || [],
    title: (calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$title = calendarsData.title) === null || _calendarsData$title === void 0 ? void 0 : _calendarsData$title.length) && calendarsData.title.substring(0, 53) || '',
    defaultTitle: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.defaultTitle) || '',
    titleArray: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.titleArray) || [],
    ownerName: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.ownerName) || '',
    localization: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.localization) || 'en',
    collectionName: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.collectionName) || '',
    logo: logo,
    cardTitle: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.cardTitle) || '',
    author: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.author) || ''
  }), calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$cards = calendarsData.cards) === null || _calendarsData$cards === void 0 ? void 0 : _calendarsData$cards.map(function (item, index) {
    var _calendarsData$title2, _calendarsData$title3;
    return /*#__PURE__*/React$1.createElement(Calendar, {
      isPrinting: true,
      key: (item === null || item === void 0 ? void 0 : item.cardId) + "-" + index,
      cardId: item === null || item === void 0 ? void 0 : item.cardId,
      cardTitle: item === null || item === void 0 ? void 0 : item.name,
      title: (calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$title2 = calendarsData.title) === null || _calendarsData$title2 === void 0 ? void 0 : _calendarsData$title2.length) && (calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$title3 = calendarsData.title) === null || _calendarsData$title3 === void 0 ? void 0 : _calendarsData$title3.substring(0, 53)) || '',
      date: getDateFromMonthIndex(index),
      author: item === null || item === void 0 ? void 0 : item.description,
      images: item === null || item === void 0 ? void 0 : item.images,
      localization: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.localization) || 'en',
      orientation: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.orientation) || 'vertical',
      events: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.events) || [],
      calendarCollectionId: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.calendarCollectionId) || '',
      printImgUrl: item === null || item === void 0 ? void 0 : item.imageUrl,
      ownerName: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.ownerName) || '',
      bottomLink: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.bottomLink) || '',
      collectionName: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.collectionName) || '',
      sideAuthor: item === null || item === void 0 ? void 0 : item.sideAuthor,
      startDate: calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.startDate,
      calendarType: calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.calendarType
    });
  }));
};

var _templateObject$1V, _templateObject2$1V, _templateObject3$1P, _templateObject4$1q, _templateObject5$1e, _templateObject6$1c, _templateObject7$18, _templateObject8$15, _templateObject9$12, _templateObject10$q;
var Wrapper$12 = styled.div(_templateObject$1V || (_templateObject$1V = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.pageWidth;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.pageWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.horizontalPadding;
});
var MainBlock$X = styled.div(_templateObject2$1V || (_templateObject2$1V = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$P = styled.div(_templateObject3$1P || (_templateObject3$1P = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.7px;\n    line-height: 4px;\n    margin: 5px 3px 0 0;\n  }\n"])), function (props) {
  return props.urlHeightPercent;
});
var ImageBlock$X = styled.div(_templateObject4$1q || (_templateObject4$1q = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$Z = styled.div(_templateObject5$1e || (_templateObject5$1e = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$13 = styled.div(_templateObject6$1c || (_templateObject6$1c = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: ", "%;\n  width: ", "%;\n  padding-bottom: ", "px;\n"])), function (props) {
  return props.textBlockHeightPercent;
}, function (props) {
  return props.textBlockWidthPercent;
}, function (props) {
  return props.textBlockPaddingBottom;
});
var TextFirst$P = styled.div(_templateObject7$18 || (_templateObject7$18 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  line-height: 0px;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    font-weight: 400;\n  }\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
});
var TextSecond$Q = styled.div(_templateObject8$15 || (_templateObject8$15 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: ", "px;\n  text-align: center;\n  margin: ", "px 0 ", "px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: 'zMr';\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: ", "px;\n"])), function (props) {
  return props.height;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.letterSpacing;
});
var TextThird$P = styled.div(_templateObject9$12 || (_templateObject9$12 = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  font-weight: 400;\n  margin-bottom: ", "px;\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.marginBottom;
});
var TextFourth = styled.div(_templateObject10$q || (_templateObject10$q = _taggedTemplateLiteralLoose(["\n  font-size: ", "px;\n  font-weight: 700;\n  line-height: 0px\n"])), function (props) {
  return props.fontSize;
});
var ShipsConstructor = function ShipsConstructor(_ref) {
  var image = _ref.image,
    url = _ref.url,
    name = _ref.name,
    museum = _ref.museum,
    description = _ref.description,
    dw = _ref.dw,
    dh = _ref.dh,
    pageWidth = _ref.pageWidth,
    pageHeight = _ref.pageHeight,
    horizontalPadding = _ref.horizontalPadding,
    urlHeightPercent = _ref.urlHeightPercent,
    textBlockHeightPercent = _ref.textBlockHeightPercent,
    textBlockWidthPercent = _ref.textBlockWidthPercent,
    textBlockPaddingBottom = _ref.textBlockPaddingBottom,
    firstFontSize = _ref.firstFontSize,
    firstLetterSpacing = _ref.firstLetterSpacing,
    secondFontMax = _ref.secondFontMax,
    secondHeight = _ref.secondHeight,
    secondMarginTop = _ref.secondMarginTop,
    secondMarginBottom = _ref.secondMarginBottom,
    secondLetterSpacing = _ref.secondLetterSpacing,
    thirdFontSize = _ref.thirdFontSize,
    thirdLetterSpacing = _ref.thirdLetterSpacing,
    thirdMarginBottom = _ref.thirdMarginBottom,
    fourthFontSize = _ref.fourthFontSize;
  return /*#__PURE__*/React$1.createElement(Wrapper$12, {
    dw: dw,
    dh: dh,
    pageWidth: pageWidth,
    pageHeight: pageHeight,
    horizontalPadding: horizontalPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$X, null, /*#__PURE__*/React$1.createElement(TextUrl$P, {
    urlHeightPercent: urlHeightPercent
  }, /*#__PURE__*/React$1.createElement("span", null)), /*#__PURE__*/React$1.createElement(ImageBlock$X, null, /*#__PURE__*/React$1.createElement(ImageInner$Z, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$13, {
    textBlockHeightPercent: textBlockHeightPercent,
    textBlockWidthPercent: textBlockWidthPercent,
    textBlockPaddingBottom: textBlockPaddingBottom
  }, /*#__PURE__*/React$1.createElement(TextFirst$P, {
    fontSize: firstFontSize,
    letterSpacing: firstLetterSpacing
  }, /*#__PURE__*/React$1.createElement("span", null, museum)), /*#__PURE__*/React$1.createElement(TextSecond$Q, {
    height: secondHeight,
    marginTop: secondMarginTop,
    marginBottom: secondMarginBottom,
    letterSpacing: secondLetterSpacing
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: name,
    fontSizeMax: secondFontMax
  })), /*#__PURE__*/React$1.createElement(TextThird$P, {
    fontSize: thirdFontSize,
    letterSpacing: thirdLetterSpacing,
    marginBottom: thirdMarginBottom
  }, description), /*#__PURE__*/React$1.createElement(TextFourth, {
    fontSize: fourthFontSize
  }, url))));
};

var ShipsCardA4L = function ShipsCardA4L(props) {
  return /*#__PURE__*/React$1.createElement(ShipsConstructor, _extends({}, props, {
    pageWidth: 297,
    pageHeight: 210,
    horizontalPadding: 112,
    urlHeightPercent: 6.8,
    textBlockHeightPercent: 18,
    textBlockWidthPercent: 87.9,
    textBlockPaddingBottom: 25,
    firstFontSize: 11.3,
    firstLetterSpacing: 0.2,
    secondFontMax: 16,
    secondHeight: 20,
    secondMarginTop: 15,
    secondMarginBottom: 11,
    secondLetterSpacing: 0.45,
    thirdFontSize: 6.5,
    thirdLetterSpacing: 0.2,
    thirdMarginBottom: props.isPaymentModal ? 0 : 29,
    fourthFontSize: 4
  }));
};

var ShipsCardA4 = function ShipsCardA4(props) {
  return /*#__PURE__*/React$1.createElement(ShipsConstructor, _extends({}, props, {
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 93,
    urlHeightPercent: 5.905,
    textBlockHeightPercent: 16.7,
    textBlockWidthPercent: 87.9,
    textBlockPaddingBottom: 46,
    firstFontSize: 11.3,
    firstLetterSpacing: 0.2,
    secondFontMax: 16,
    secondHeight: 20,
    secondMarginTop: 15,
    secondMarginBottom: 11,
    secondLetterSpacing: 0.45,
    thirdFontSize: 6.5,
    thirdLetterSpacing: 0.2,
    thirdMarginBottom: 33,
    fourthFontSize: 4
  }));
};

var ShipsCardA5 = function ShipsCardA5(props) {
  return /*#__PURE__*/React$1.createElement(ShipsConstructor, _extends({}, props, {
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 65,
    urlHeightPercent: 5.905,
    textBlockHeightPercent: 16.7,
    textBlockWidthPercent: 87.9,
    textBlockPaddingBottom: 32,
    firstFontSize: 8,
    firstLetterSpacing: 0.15,
    secondFontMax: 11,
    secondHeight: 14,
    secondMarginTop: 11,
    secondMarginBottom: 8,
    secondLetterSpacing: 0.3,
    thirdFontSize: 4.6,
    thirdLetterSpacing: 0.15,
    thirdMarginBottom: 23,
    fourthFontSize: 3
  }));
};

var ShipsCardA5L = function ShipsCardA5L(props) {
  return /*#__PURE__*/React$1.createElement(ShipsConstructor, _extends({}, props, {
    pageWidth: 210,
    pageHeight: 148,
    horizontalPadding: 79,
    urlHeightPercent: 6.8,
    textBlockHeightPercent: 18,
    textBlockWidthPercent: 87.9,
    textBlockPaddingBottom: 18,
    firstFontSize: 8,
    firstLetterSpacing: 0.15,
    secondFontMax: 11,
    secondHeight: 14,
    secondMarginTop: 11,
    secondMarginBottom: 8,
    secondLetterSpacing: 0.3,
    thirdFontSize: 4.6,
    thirdLetterSpacing: 0.15,
    thirdMarginBottom: props.isPaymentModal ? 0 : 20,
    fourthFontSize: 4
  }));
};

var components$9 = {
  ShipsCardA4: ShipsCardA4,
  ShipsCardA4L: ShipsCardA4L,
  ShipsCardA5: ShipsCardA5,
  ShipsCardA5L: ShipsCardA5L
};
var ShipsStyleCard = function ShipsStyleCard(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components$9[templateType], {
    url: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.link) || 'ze.land',
    image: image,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    description: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.description) || '',
    museum: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    name: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.title) || '',
    dw: dw,
    dh: dh,
    isPaymentModal: props.isPaymentModal
  });
};

var components$a = {
  ShipsCardA4: ShipsCardA4,
  ShipsCardA4L: ShipsCardA4L,
  ShipsCardA5: ShipsCardA5,
  ShipsCardA5L: ShipsCardA5L
};
var ShipsStyleCardPrint = function ShipsStyleCardPrint(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$a[templateType], {
    url: (data === null || data === void 0 ? void 0 : data.link) || 'ze.land',
    image: image,
    customSubtitle: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    description: (data === null || data === void 0 ? void 0 : data.description) || '',
    museum: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    name: (data === null || data === void 0 ? void 0 : data.title) || (data === null || data === void 0 ? void 0 : data.name) || '',
    dw: dw,
    dh: dh
  });
};

var _templateObject$1W, _templateObject2$1W, _templateObject3$1Q, _templateObject4$1r, _templateObject5$1f, _templateObject6$1d, _templateObject7$19, _templateObject8$16, _templateObject9$13, _templateObject10$r, _templateObject11$q;
var Wrapper$13 = styled.div(_templateObject$1W || (_templateObject$1W = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.pageWidth;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.pageWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.horizontalPadding;
});
var MainBlock$Y = styled.div(_templateObject2$1W || (_templateObject2$1W = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$Q = styled.div(_templateObject3$1Q || (_templateObject3$1Q = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.7px;\n    line-height: 4px;\n    margin: 5px 3px 0 0;\n  }\n"])), function (props) {
  return props.urlHeightPercent;
});
var ImageBlock$Y = styled.div(_templateObject4$1r || (_templateObject4$1r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$_ = styled.div(_templateObject5$1f || (_templateObject5$1f = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: ", ";\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])), function (props) {
  return props.imageAlignment || 'center';
});
var TextBlock$14 = styled.div(_templateObject6$1d || (_templateObject6$1d = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: ", ";\n  height: ", "%;\n  width: ", "%;\n  padding-bottom: ", "px;\n"])), function (_ref) {
  var withDescription = _ref.withDescription,
    withNumber = _ref.withNumber;
  return !withDescription ? withNumber ? 'flex-start' : 'center' : 'flex-end';
}, function (props) {
  return props.textBlockHeightPercent;
}, function (props) {
  return props.textBlockWidthPercent;
}, function (props) {
  return props.textBlockPaddingBottom;
});
var TextFirst$Q = styled.div(_templateObject7$19 || (_templateObject7$19 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  margin-top: ", "px;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-weight: 400;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (props) {
  return props.marginTop;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.dashWidth;
}, function (props) {
  return props.dashOffset;
}, function (props) {
  return props.dashOffset;
});
var MainTextBlock = styled.div(_templateObject8$16 || (_templateObject8$16 = _taggedTemplateLiteralLoose(["\n  margin-bottom: ", ";\n"])), function (_ref2) {
  var withNumber = _ref2.withNumber,
    withDescription = _ref2.withDescription,
    marginBottom = _ref2.marginBottom;
  return !withNumber ? withDescription ? marginBottom + "px" : '15px' : '';
});
var TextSecond$R = styled.div(_templateObject9$13 || (_templateObject9$13 = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  text-wrap: nowrap;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: ", "px;\n  text-align: center;\n  margin: ", "px 0 ", "px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: 'zMr';\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: ", "px;\n"])), function (props) {
  return props.height;
}, function (props) {
  return props.marginTop;
}, function (props) {
  return props.marginBottom;
}, function (props) {
  return props.letterSpacing;
});
var TextThird$Q = styled.div(_templateObject10$r || (_templateObject10$r = _taggedTemplateLiteralLoose(["\n  font-family: 'Baskerville';\n  font-style: italic;\n  text-align: center;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  font-weight: 400;\n  margin-bottom: ", "px;\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.marginBottom;
});
var TextFourth$1 = styled.div(_templateObject11$q || (_templateObject11$q = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", "px;\n  font-weight: ", ";\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.fontWeight || 900;
});
var FlowersConstructor = function FlowersConstructor(_ref3) {
  var image = _ref3.image,
    url = _ref3.url,
    name = _ref3.name,
    description = _ref3.description,
    number = _ref3.number,
    withNumber = _ref3.withNumber,
    dw = _ref3.dw,
    dh = _ref3.dh,
    pageWidth = _ref3.pageWidth,
    pageHeight = _ref3.pageHeight,
    horizontalPadding = _ref3.horizontalPadding,
    urlHeightPercent = _ref3.urlHeightPercent,
    textBlockHeightPercent = _ref3.textBlockHeightPercent,
    textBlockWidthPercent = _ref3.textBlockWidthPercent,
    textBlockPaddingBottom = _ref3.textBlockPaddingBottom,
    imageAlignment = _ref3.imageAlignment,
    firstMarginTop = _ref3.firstMarginTop,
    firstFontSize = _ref3.firstFontSize,
    firstLetterSpacing = _ref3.firstLetterSpacing,
    dashWidth = _ref3.dashWidth,
    dashOffset = _ref3.dashOffset,
    mainTextBlockMarginBottom = _ref3.mainTextBlockMarginBottom,
    secondFontMax = _ref3.secondFontMax,
    secondHeight = _ref3.secondHeight,
    secondMarginTop = _ref3.secondMarginTop,
    secondMarginBottom = _ref3.secondMarginBottom,
    secondLetterSpacing = _ref3.secondLetterSpacing,
    thirdFontSize = _ref3.thirdFontSize,
    thirdLetterSpacing = _ref3.thirdLetterSpacing,
    thirdMarginBottom = _ref3.thirdMarginBottom,
    fourthFontSize = _ref3.fourthFontSize,
    fourthFontWeight = _ref3.fourthFontWeight;
  var withDescription = Boolean(description === null || description === void 0 ? void 0 : description.length);
  return /*#__PURE__*/React$1.createElement(Wrapper$13, {
    dw: dw,
    dh: dh,
    pageWidth: pageWidth,
    pageHeight: pageHeight,
    horizontalPadding: horizontalPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$Y, null, /*#__PURE__*/React$1.createElement(TextUrl$Q, {
    urlHeightPercent: urlHeightPercent
  }, /*#__PURE__*/React$1.createElement("span", null)), /*#__PURE__*/React$1.createElement(ImageBlock$Y, null, /*#__PURE__*/React$1.createElement(ImageInner$_, {
    imageAlignment: imageAlignment
  }, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$14, {
    withNumber: withNumber,
    withDescription: withDescription,
    textBlockHeightPercent: textBlockHeightPercent,
    textBlockWidthPercent: textBlockWidthPercent,
    textBlockPaddingBottom: textBlockPaddingBottom
  }, withNumber && /*#__PURE__*/React$1.createElement(TextFirst$Q, {
    marginTop: firstMarginTop,
    fontSize: firstFontSize,
    letterSpacing: firstLetterSpacing,
    dashWidth: dashWidth,
    dashOffset: dashOffset
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(MainTextBlock, {
    withNumber: withNumber,
    withDescription: withDescription,
    marginBottom: mainTextBlockMarginBottom
  }, /*#__PURE__*/React$1.createElement(TextSecond$R, {
    height: secondHeight,
    marginTop: secondMarginTop,
    marginBottom: secondMarginBottom,
    letterSpacing: secondLetterSpacing
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: name,
    fontSizeMax: secondFontMax
  })), withDescription ? /*#__PURE__*/React$1.createElement(TextThird$Q, {
    fontSize: thirdFontSize,
    letterSpacing: thirdLetterSpacing,
    marginBottom: thirdMarginBottom
  }, description) : /*#__PURE__*/React$1.createElement(TextFourth$1, {
    fontSize: fourthFontSize,
    fontWeight: fourthFontWeight
  }, url)), withDescription && /*#__PURE__*/React$1.createElement(TextFourth$1, {
    fontSize: fourthFontSize,
    fontWeight: fourthFontWeight
  }, url))));
};

var FlowersCardA4 = function FlowersCardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowersConstructor, _extends({}, props, {
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 105,
    urlHeightPercent: 5.905,
    textBlockHeightPercent: 17,
    textBlockWidthPercent: 87.9,
    textBlockPaddingBottom: 26,
    imageAlignment: "center",
    firstMarginTop: 17,
    firstFontSize: 27,
    firstLetterSpacing: 5,
    dashWidth: 39,
    dashOffset: -24,
    mainTextBlockMarginBottom: 20,
    secondFontMax: 16,
    secondHeight: 20,
    secondMarginTop: 37,
    secondMarginBottom: 10,
    secondLetterSpacing: 0.45,
    thirdFontSize: 11.4,
    thirdLetterSpacing: 0.2,
    thirdMarginBottom: 33,
    fourthFontSize: 4.5,
    fourthFontWeight: 900
  }));
};

var FlowersCardWithNumberA4 = function FlowersCardWithNumberA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowersCardA4, _extends({}, props, {
    withNumber: true
  }));
};

var FlowersCardA5 = function FlowersCardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowersConstructor, _extends({}, props, {
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 74,
    urlHeightPercent: 5.905,
    textBlockHeightPercent: 17,
    textBlockWidthPercent: 87.9,
    textBlockPaddingBottom: 18,
    imageAlignment: "center",
    firstMarginTop: 12,
    firstFontSize: 19,
    firstLetterSpacing: 3.5,
    dashWidth: 27,
    dashOffset: -17,
    mainTextBlockMarginBottom: 14,
    secondFontMax: 11,
    secondHeight: 14,
    secondMarginTop: 26,
    secondMarginBottom: 7,
    secondLetterSpacing: 0.3,
    thirdFontSize: 8,
    thirdLetterSpacing: 0.15,
    thirdMarginBottom: 23,
    fourthFontSize: 3.2,
    fourthFontWeight: 900
  }));
};

var FlowersCardWithNumberA5 = function FlowersCardWithNumberA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowersCardA5, _extends({}, props, {
    withNumber: true
  }));
};

var components$b = {
  FlowersCardA4: FlowersCardA4,
  FlowersCardWithNumberA4: FlowersCardWithNumberA4,
  FlowersCardA5: FlowersCardA5,
  FlowersCardWithNumberA5: FlowersCardWithNumberA5
};
var FlowersStyleCard = function FlowersStyleCard(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components$b[templateType], {
    url: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.link) || 'ze.land',
    image: image,
    number: cardNumber,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    description: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.description) || '',
    museum: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    name: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.title) || '',
    dw: dw,
    dh: dh
  });
};

var components$c = {
  FlowersCardA4: FlowersCardA4,
  FlowersCardWithNumberA4: FlowersCardWithNumberA4
};
var FlowersStyleCardPrint = function FlowersStyleCardPrint(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$c[templateType], {
    url: (data === null || data === void 0 ? void 0 : data.link) || 'ze.land',
    image: image,
    number: (data === null || data === void 0 ? void 0 : data.number) || '',
    customSubtitle: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    description: (data === null || data === void 0 ? void 0 : data.description) || '',
    museum: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    name: (data === null || data === void 0 ? void 0 : data.name) || '',
    dw: dw,
    dh: dh
  });
};

var _templateObject$1X, _templateObject2$1X, _templateObject3$1R, _templateObject4$1s, _templateObject5$1g, _templateObject6$1e, _templateObject7$1a, _templateObject8$17, _templateObject9$14, _templateObject10$s, _templateObject11$r;
var Wrapper$14 = styled.div(_templateObject$1X || (_templateObject$1X = _taggedTemplateLiteralLoose(["\n  width: 148mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 148),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 28.5px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$Z = styled.div(_templateObject2$1X || (_templateObject2$1X = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$R = styled.div(_templateObject3$1R || (_templateObject3$1R = _taggedTemplateLiteralLoose(["\n  height: 5.7315%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: 400;\n    line-height: 4px;\n    margin: 4px 2px 0 0;\n  }\n"])));
var ImageBlock$Z = styled.div(_templateObject4$1s || (_templateObject4$1s = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$$ = styled.div(_templateObject5$1g || (_templateObject5$1g = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    max-width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var ImageInnerContainer = styled.span(_templateObject6$1e || (_templateObject6$1e = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 100%;\n  width: fit-content;\n"])));
var QrBlock$5 = styled.div(_templateObject7$1a || (_templateObject7$1a = _taggedTemplateLiteralLoose(["\n  background-color: #fff;\n  padding: 3px;\n  display: flex;\n  position: absolute;\n  bottom: 11px;\n  left: 11px;\n  z-index: 999;\n"])));
var TextBlock$15 = styled.div(_templateObject8$17 || (_templateObject8$17 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-end;\n  align-items: center;\n  height: 17.426%;\n  width: 88%;\n  padding-bottom: 23.4px;\n"])));
var TextFirst$R = styled.div(_templateObject9$14 || (_templateObject9$14 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  font-family: Roboto, serif;\n\n  span {\n    font-size: 12px;\n    font-style: normal;\n    font-weight: 400;\n    letter-spacing: 2.3px;\n    margin-right: -2.3px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 43px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: -18px;\n      transform: scale(0.7) translate(-100%, 0);\n      transform-origin: 0 0;\n    }\n\n    &.right-dash {\n      right: -18px;\n      transform: scale(0.7) translate(145%, 0);\n      transform-origin: 0 0;\n    }\n  }\n"])));
var TextSecond$S = styled.div(_templateObject10$s || (_templateObject10$s = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  width: 100%;\n  height: 40px;\n  justify-content: center;\n  text-align: center;\n  align-items: center;\n  margin: 7px 0 9.5px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: Roboto;\n  font-style: normal;\n  font-weight: 700;\n  letter-spacing: 1.5px;\n  margin-right: ", "px;\n"])), function (p) {
  return p !== null && p !== void 0 && p.fullText ? 0 : -1.5;
});
var TextThird$R = styled.div(_templateObject11$r || (_templateObject11$r = _taggedTemplateLiteralLoose(["\n  font-family: Roboto-Regular, Roboto, serif;\n  text-align: center;\n  color: #151514;\n  font-size: 5.7px;\n  font-style: normal;\n  font-weight: 400;\n"])));
var WarholCard2WithQrA5 = function WarholCard2WithQrA5(_ref) {
  var image = _ref.image,
    url = _ref.url,
    name = _ref.name,
    number = _ref.number,
    dw = _ref.dw,
    dh = _ref.dh,
    customSubtitle = _ref.customSubtitle,
    _ref$linkForQr = _ref.linkForQr,
    linkForQr = _ref$linkForQr === void 0 ? 'gallllery.com' : _ref$linkForQr;
  var _useState = useState({
      width: 0,
      height: 0
    }),
    imgSize = _useState[0],
    setImgSize = _useState[1];
  var initName = toUpperCaseString({
    str: name
  });
  var handleLoad = function handleLoad(e) {
    var _e$target = e.target,
      naturalHeight = _e$target.naturalHeight,
      naturalWidth = _e$target.naturalWidth;
    setImgSize({
      width: naturalWidth,
      height: naturalHeight
    });
  };
  var isEmptyImg = useMemo(function () {
    return imgSize.height === 0 && imgSize.width === 0;
  }, [imgSize]);
  return /*#__PURE__*/React$1.createElement(Wrapper$14, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$Z, null, /*#__PURE__*/React$1.createElement(TextUrl$R, null, /*#__PURE__*/React$1.createElement("span", null, customSubtitle && url)), /*#__PURE__*/React$1.createElement(ImageBlock$Z, null, /*#__PURE__*/React$1.createElement(ImageInner$$, null, /*#__PURE__*/React$1.createElement(ImageInnerContainer, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "card",
    draggable: false,
    onLoad: handleLoad
  }), !isEmptyImg && /*#__PURE__*/React$1.createElement(QrBlock$5, null, /*#__PURE__*/React$1.createElement(QRCodeSVG, {
    size: 100.2,
    value: linkForQr
  }))))), /*#__PURE__*/React$1.createElement(TextBlock$15, null, /*#__PURE__*/React$1.createElement(TextFirst$R, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, number), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$S, {
    id: "text-second"
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: initName,
    fontSizeMax: 32
  })), /*#__PURE__*/React$1.createElement(TextThird$R, null, customSubtitle || url))));
};

var components$d = {
  WarholCard2WithQrA5: WarholCard2WithQrA5
};
var getComponent = function getComponent(templateType, templateDataComputed) {
  if (components$d[templateType]) {
    return components$d[templateType];
  } else {
    return components$d.WarholCard2WithQrA5;
  }
};
var WarholStyle2WithQrCard = function WarholStyle2WithQrCard(props) {
  var _templateDataComputed, _templateDataComputed2, _templateDataComputed3, _templateDataComputed4;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = (data === null || data === void 0 ? void 0 : data.templateData) || {};
  var linkForQr = (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed = templateDataComputed.customFields) === null || _templateDataComputed === void 0 ? void 0 : (_templateDataComputed2 = _templateDataComputed.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.name) === 'qrcode';
  })) === null || _templateDataComputed2 === void 0 ? void 0 : _templateDataComputed2.data) || '';
  return React$1.createElement(getComponent(templateType), {
    url: templateDataComputed && templateDataComputed.link || 'gallllery.com',
    image: image,
    number: cardNumber.replace('№ ', '№'),
    museum: templateDataComputed && templateDataComputed.description || '',
    name: templateDataComputed && templateDataComputed.title && templateDataComputed.title.toString() || '',
    dw: dw,
    dh: dh,
    linkForQr: linkForQr,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed3 = templateDataComputed.subTitle) === null || _templateDataComputed3 === void 0 ? void 0 : _templateDataComputed3.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed4 = templateDataComputed.description) === null || _templateDataComputed4 === void 0 ? void 0 : _templateDataComputed4.toString())
  });
};

var components$e = {
  WarholCard2WithQrA5: WarholCard2WithQrA5
};
var WarholStyle2WithQrCardPrint = function WarholStyle2WithQrCardPrint(props) {
  var _data$customfields, _data$subTitle, _data$description;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  var linkForQr = (data === null || data === void 0 ? void 0 : (_data$customfields = data.customfields) === null || _data$customfields === void 0 ? void 0 : _data$customfields.qrcode) || '';
  return React$1.createElement(components$e[templateType], {
    url: data && data.link || 'gallllery.com',
    image: image,
    number: data && data.number,
    museum: data && data.description || '',
    name: data && data.title && data.title.toString() || '',
    dw: dw,
    dh: dh,
    linkForQr: linkForQr,
    customSubtitle: (data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : _data$subTitle.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : _data$description.toString())
  });
};

var CalendarsModernPrint = function CalendarsModernPrint(_ref) {
  var _calendarsData$logoFi, _calendarsData$cards;
  var calendarsData = _ref.calendarsData;
  var images = calendarsData && calendarsData.cards && calendarsData.cards.length ? calendarsData.cards.map(function (card) {
    return card && card.imageUrl;
  }) : [];
  var logo = getImageUrl(calendarsData !== null && calendarsData !== void 0 && (_calendarsData$logoFi = calendarsData.logoFiles) !== null && _calendarsData$logoFi !== void 0 && _calendarsData$logoFi.length ? calendarsData.logoFiles : []);
  var year = new Date().getFullYear();
  var getDateFromMonthIndex = function getDateFromMonthIndex(index) {
    var currentYear = calendarsData && calendarsData.year || year;
    var currentMonth = index + (calendarsData && calendarsData.startMonth);
    var nextYear = currentYear + 1;
    return new Date(currentMonth > 11 ? nextYear : currentYear, currentMonth % 12);
  };
  return /*#__PURE__*/React$1.createElement("div", {
    style: {
      display: 'grid'
    }
  }, /*#__PURE__*/React$1.createElement(CalendarFreePreview, {
    year: calendarsData && calendarsData.year || year,
    images: images && images.length && images.slice(0, 12) || [],
    author: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.author) || '',
    title: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.title) || '',
    logo: logo
  }), calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$cards = calendarsData.cards) === null || _calendarsData$cards === void 0 ? void 0 : _calendarsData$cards.map(function (item, index) {
    var _calendarsData$title, _calendarsData$title2;
    return /*#__PURE__*/React$1.createElement(CalendarModern, {
      key: (item === null || item === void 0 ? void 0 : item.cardId) + "-" + index,
      cardId: item === null || item === void 0 ? void 0 : item.cardId,
      cardTitle: item === null || item === void 0 ? void 0 : item.name,
      title: (calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$title = calendarsData.title) === null || _calendarsData$title === void 0 ? void 0 : _calendarsData$title.length) && (calendarsData === null || calendarsData === void 0 ? void 0 : (_calendarsData$title2 = calendarsData.title) === null || _calendarsData$title2 === void 0 ? void 0 : _calendarsData$title2.substring(0, 53)) || '',
      date: getDateFromMonthIndex(index),
      author: item === null || item === void 0 ? void 0 : item.description,
      images: item === null || item === void 0 ? void 0 : item.images,
      orientation: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.orientation) || 'vertical',
      events: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.events) || [],
      calendarCollectionId: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.calendarCollectionId) || '',
      printImgUrl: item === null || item === void 0 ? void 0 : item.imageUrl,
      isPrinting: true,
      ownerName: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.ownerName) || '',
      bottomLink: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.bottomLink) || '',
      collectionName: (calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.collectionName) || '',
      sideAuthor: item === null || item === void 0 ? void 0 : item.sideAuthor,
      startDate: calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.startDate,
      calendarType: calendarsData === null || calendarsData === void 0 ? void 0 : calendarsData.calendarType
    });
  }));
};

var _templateObject$1Y, _templateObject2$1Y, _templateObject3$1S, _templateObject4$1t, _templateObject5$1h, _templateObject6$1f, _templateObject7$1b, _templateObject8$18, _templateObject9$15, _templateObject10$t;
var Container$1 = styled.div(_templateObject$1Y || (_templateObject$1Y = _taggedTemplateLiteralLoose(["\n  height: 594mm;\n  width: 420mm;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 20px;\n  transform: scale(", ");\n  transform-origin: top left;\n  padding: 157px 159px;\n\n  * {\n    box-sizing: border-box;\n  }\n"])), function (p) {
  return p.scaleSize;
});
var Header$1 = styled.div(_templateObject2$1Y || (_templateObject2$1Y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 7.6%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: ", ";\n  padding-bottom: 26px;\n  border-bottom: 2.5px solid #000;\n"])), function (p) {
  return p.withLogo ? 'space-between' : 'flex-end';
});
var YearBlock$1 = styled.div(_templateObject3$1S || (_templateObject3$1S = _taggedTemplateLiteralLoose(["\n  color: #b22125;\n  font-size: 50px;\n  font-weight: 600;\n  display: flex;\n  align-items: start;\n  line-height: 100%;\n  letter-spacing: 1px;\n"])));
var Logo$1 = styled.img(_templateObject4$1t || (_templateObject4$1t = _taggedTemplateLiteralLoose(["\n  width: auto;\n  max-height: 100%;\n"])));
var CardsBlock$1 = styled.div(_templateObject5$1h || (_templateObject5$1h = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  width: 100%;\n  padding: 10px 0;\n"])));
var ImagesContainer$1 = styled.div(_templateObject6$1f || (_templateObject6$1f = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: grid;\n  grid-template-columns: repeat(3, 1fr);\n  grid-template-rows: repeat(4, 1fr);\n"])));
var Image$2 = styled.img(_templateObject7$1b || (_templateObject7$1b = _taggedTemplateLiteralLoose(["\n  height: 100%;\n  width: 100%;\n  object-fit: cover;\n  aspect-ratio: ", ";\n  background: #ffffff !important;\n"])), function (_ref) {
  var imgAspectRatio = _ref.imgAspectRatio;
  return imgAspectRatio || '1.1 / 1';
});
var Footer$3 = styled.div(_templateObject8$18 || (_templateObject8$18 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 10.1%;\n  display: flex;\n  flex-direction: column;\n  border-top: 2.5px solid #000;\n  padding-top: 25px;\n  gap: 15px;\n"])));
var Title$6 = styled.div(_templateObject9$15 || (_templateObject9$15 = _taggedTemplateLiteralLoose(["\n  font-size: 42px;\n  font-weight: bold;\n  letter-spacing: 0.4px;\n"])));
var SubTitle$1 = styled.div(_templateObject10$t || (_templateObject10$t = _taggedTemplateLiteralLoose(["\n  font-size: 17px;\n  letter-spacing: 0.05px;\n"])));
var CalendarPreview = function CalendarPreview(_ref2) {
  var images = _ref2.images,
    year = _ref2.year,
    title = _ref2.title,
    scaleSize = _ref2.scaleSize,
    logo = _ref2.logo,
    author = _ref2.author,
    styles = _ref2.styles,
    imgAspectRatio = _ref2.imgAspectRatio;
  var withLogo = Boolean(logo);
  var cardTitle = (title === null || title === void 0 ? void 0 : title.toUpperCase()) || '';
  return /*#__PURE__*/React$1.createElement(Container$1, {
    scaleSize: scaleSize,
    style: styles
  }, /*#__PURE__*/React$1.createElement(Header$1, {
    withLogo: withLogo
  }, withLogo && /*#__PURE__*/React$1.createElement(Logo$1, {
    src: logo,
    alt: "logo"
  }), /*#__PURE__*/React$1.createElement(YearBlock$1, null, year)), /*#__PURE__*/React$1.createElement(CardsBlock$1, null, /*#__PURE__*/React$1.createElement(ImagesContainer$1, null, images.map(function (image, index) {
    return /*#__PURE__*/React$1.createElement(Image$2, {
      key: index,
      src: image,
      imgAspectRatio: imgAspectRatio
    });
  }))), /*#__PURE__*/React$1.createElement(Footer$3, null, /*#__PURE__*/React$1.createElement(Title$6, null, cardTitle), /*#__PURE__*/React$1.createElement(SubTitle$1, null, author)));
};

var _templateObject$1Z, _templateObject2$1Z, _templateObject3$1T, _templateObject4$1u, _templateObject5$1i, _templateObject6$1g, _templateObject7$1c, _templateObject8$19, _templateObject9$16;
var Wrapper$15 = styled.div(_templateObject$1Z || (_templateObject$1Z = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: ", "px;\n  padding-right: 0;\n  display: flex;\n\n  * {\n    box-sizing: border-box;\n    padding: 0;\n    margin: 0;\n  }\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.width;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.height;
}, function (props) {
  return props.padding;
});
var ImageBlock$_ = styled.div(_templateObject2$1Z || (_templateObject2$1Z = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$16 = styled.div(_templateObject3$1T || (_templateObject3$1T = _taggedTemplateLiteralLoose(["\n  width: ", "px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ", "px;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.gap;
});
var Text = styled.div(_templateObject4$1u || (_templateObject4$1u = _taggedTemplateLiteralLoose(["\n  writing-mode: vertical-rl;\n  transform: rotate(180deg);\n  white-space: nowrap;\n"])));
var Museum = styled(Text)(_templateObject5$1i || (_templateObject5$1i = _taggedTemplateLiteralLoose(["\n  font-family: Roboto, serif;\n  font-size: ", "px;\n  font-weight: 600;\n  letter-spacing: ", ";\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  text-transform: uppercase;\n  color: #151514;\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
});
var UrlAndNumContainer = styled.div(_templateObject6$1g || (_templateObject6$1g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: ", "px;\n"])), function (props) {
  return props.gap;
});
var UrlAndNumber = styled(Text)(_templateObject7$1c || (_templateObject7$1c = _taggedTemplateLiteralLoose(["\n  font-family: Inter;\n  font-size: ", "px;\n  font-weight: 400;\n  letter-spacing: ", ";\n  text-align: left;\n  text-underline-position: from-font;\n  text-decoration-skip-ink: none;\n  color: #909090;\n  margin-top: ", "px;\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.isNumber && props.urlNumberMarginTop;
});
var NumSymbol = styled.div(_templateObject8$19 || (_templateObject8$19 = _taggedTemplateLiteralLoose(["\n  transform: rotate(90deg);\n  display: inline-block;\n"])));
var Divider = styled.div(_templateObject9$16 || (_templateObject9$16 = _taggedTemplateLiteralLoose(["\n  background-color: #909090;\n  width: ", "px;\n  height: ", "px;\n"])), function (props) {
  return props.width;
}, function (props) {
  return props.height;
});
var PosterCardConstructor = function PosterCardConstructor(_ref) {
  var image = _ref.image,
    url = _ref.url,
    number = _ref.number,
    dw = _ref.dw,
    dh = _ref.dh,
    museum = _ref.museum,
    museumFontSize = _ref.museumFontSize,
    museumLetterSpacing = _ref.museumLetterSpacing,
    width = _ref.width,
    height = _ref.height,
    containerPadding = _ref.containerPadding,
    textBlockGap = _ref.textBlockGap,
    urlNumGap = _ref.urlNumGap,
    urlNumFontSize = _ref.urlNumFontSize,
    urlNumLetterSpacing = _ref.urlNumLetterSpacing,
    dividerWidth = _ref.dividerWidth,
    dividerHeight = _ref.dividerHeight,
    urlNumberMarginTop = _ref.urlNumberMarginTop;
  var withNumSymbol = number.includes('№');
  var numberText = withNumSymbol ? /*#__PURE__*/React$1.createElement(Fragment$1, null, /*#__PURE__*/React$1.createElement(NumSymbol, null, "\u2116"), "" + number.replace('№', '')) : number;
  return /*#__PURE__*/React$1.createElement(Wrapper$15, {
    dh: dh,
    dw: dw,
    width: width,
    height: height,
    padding: containerPadding
  }, /*#__PURE__*/React$1.createElement(ImageBlock$_, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  })), /*#__PURE__*/React$1.createElement(TextBlock$16, {
    width: containerPadding,
    gap: textBlockGap
  }, /*#__PURE__*/React$1.createElement(Museum, {
    fontSize: museumFontSize,
    letterSpacing: museumLetterSpacing
  }, museum), /*#__PURE__*/React$1.createElement(UrlAndNumContainer, {
    gap: urlNumGap
  }, /*#__PURE__*/React$1.createElement(UrlAndNumber, {
    fontSize: urlNumFontSize,
    letterSpacing: urlNumLetterSpacing
  }, numberText), /*#__PURE__*/React$1.createElement(Divider, {
    width: dividerWidth,
    height: dividerHeight
  }), /*#__PURE__*/React$1.createElement(UrlAndNumber, {
    isNumber: true,
    fontSize: urlNumFontSize,
    letterSpacing: urlNumLetterSpacing,
    urlNumberMarginTop: urlNumberMarginTop
  }, url))));
};

var PosterCardA5 = function PosterCardA5(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 148,
    height: 210,
    containerPadding: 38,
    textBlockGap: 16,
    museumFontSize: 10,
    museumLetterSpacing: "-0.02em",
    urlNumLetterSpacing: "-0.03em",
    urlNumFontSize: 10,
    urlNumGap: 6,
    dividerWidth: 12,
    dividerHeight: 1
  }));
};

var PosterCardA4 = function PosterCardA4(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 210,
    height: 297,
    containerPadding: 47,
    textBlockGap: 22,
    museumFontSize: 15,
    urlNumFontSize: 15,
    museumLetterSpacing: "-0.01em",
    urlNumLetterSpacing: "-0.02em",
    urlNumGap: 7,
    dividerWidth: 18,
    dividerHeight: 1
  }));
};

var PosterCardA3 = function PosterCardA3(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 297,
    height: 420,
    containerPadding: 58,
    textBlockGap: 30,
    museumFontSize: 15,
    urlNumFontSize: 20,
    urlNumLetterSpacing: "-0.03em",
    urlNumGap: 7,
    dividerWidth: 25,
    dividerHeight: 1
  }));
};

var PosterCardA2 = function PosterCardA2(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 420,
    height: 594,
    containerPadding: 81,
    textBlockGap: 43,
    museumFontSize: 30,
    museumLetterSpacing: "0.005em",
    urlNumFontSize: 32,
    urlNumLetterSpacing: "-0.04em",
    urlNumGap: 10,
    dividerWidth: 37,
    dividerHeight: 1
  }));
};

var PosterCardA1 = function PosterCardA1(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 594,
    height: 841,
    containerPadding: 117,
    textBlockGap: 53,
    museumFontSize: 40,
    urlNumFontSize: 42,
    urlNumLetterSpacing: "-0.035em",
    urlNumGap: 12,
    dividerWidth: 50,
    dividerHeight: 1
  }));
};

var PosterCardA0 = function PosterCardA0(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 841,
    height: 1189,
    containerPadding: 138,
    textBlockGap: 59,
    museumFontSize: 45,
    museumLetterSpacing: "0.005em",
    urlNumFontSize: 47,
    urlNumLetterSpacing: "-0.03em",
    urlNumGap: 13,
    dividerWidth: 57,
    dividerHeight: 1
  }));
};

var PosterCardA0Plus = function PosterCardA0Plus(props) {
  return /*#__PURE__*/React$1.createElement(PosterCardConstructor, _extends({}, props, {
    width: 1000,
    height: 1414,
    containerPadding: 180,
    textBlockGap: 136,
    museumFontSize: 54,
    urlNumFontSize: 48,
    urlNumLetterSpacing: "-0.03em",
    urlNumGap: 6,
    dividerWidth: 66,
    dividerHeight: 4,
    urlNumberMarginTop: 47
  }));
};

var components$f = {
  PosterCardA0Plus: PosterCardA0Plus,
  PosterCardA0: PosterCardA0,
  PosterCardA1: PosterCardA1,
  PosterCardA2: PosterCardA2,
  PosterCardA3: PosterCardA3,
  PosterCardA4: PosterCardA4,
  PosterCardA5: PosterCardA5
};
var PosterCard = function PosterCard(_ref) {
  var _templateData$subTitl, _templateData$descrip;
  var data = _ref.data,
    image = _ref.image,
    templateType = _ref.templateType,
    dw = _ref.dw,
    dh = _ref.dh,
    customSubtitle = _ref.customSubtitle;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateData = (data === null || data === void 0 ? void 0 : data.templateData) || {};
  return React$1.createElement(components$f[templateType], {
    url: (templateData === null || templateData === void 0 ? void 0 : templateData.link) || 'gallllery.com',
    image: image,
    number: cardNumber,
    museum: (templateData === null || templateData === void 0 ? void 0 : templateData.title) || '',
    dw: dw,
    dh: dh,
    description: (templateData === null || templateData === void 0 ? void 0 : (_templateData$subTitl = templateData.subTitle) === null || _templateData$subTitl === void 0 ? void 0 : _templateData$subTitl.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (templateData === null || templateData === void 0 ? void 0 : (_templateData$descrip = templateData.description) === null || _templateData$descrip === void 0 ? void 0 : _templateData$descrip.toString())
  });
};

var _templateObject$1_, _templateObject2$1_, _templateObject3$1U, _templateObject4$1v, _templateObject5$1j, _templateObject6$1h, _templateObject7$1d, _templateObject8$1a, _templateObject9$17;
var Wrapper$16 = styled.div(_templateObject$1_ || (_templateObject$1_ = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.wrapperWidth;
}, function (props) {
  return props.wrapperHeight;
}, function (props) {
  return props.wrapperPadding;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.wrapperWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.wrapperHeight;
});
var MainBlock$_ = styled.div(_templateObject2$1_ || (_templateObject2$1_ = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$S = styled.div(_templateObject3$1U || (_templateObject3$1U = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: ", "px;\n    font-weight: ", ";\n    letter-spacing: ", "px;\n    line-height: ", "px;\n  }\n"])), function (props) {
  return props.urlHeight;
}, function (props) {
  return props.urlFontSize;
}, function (props) {
  return props.urlFontWeight;
}, function (props) {
  return props.urlLetterSpacing;
}, function (props) {
  return props.urlLineHeight;
});
var ImageBlock$$ = styled.div(_templateObject4$1v || (_templateObject4$1v = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$10 = styled.div(_templateObject5$1j || (_templateObject5$1j = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$17 = styled.div(_templateObject6$1h || (_templateObject6$1h = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  height: ", "%;\n  width: ", "%;\n  padding-top: ", "px;\n  gap: ", "px;\n"])), function (props) {
  return props.textBlockHeight;
}, function (props) {
  return props.textBlockWidth;
}, function (props) {
  return props.textBlockPaddingTop;
}, function (props) {
  return props.textBlockGap;
});
var TextFirst$S = styled.div(_templateObject7$1d || (_templateObject7$1d = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n\n  span {\n    font-family: ", ";\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    /* text-indent: ", "px; */\n    color: #151514;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n    color: #151514;\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (props) {
  return props.firstTextFontFamily;
}, function (props) {
  return props.firstTextFontSize;
}, function (props) {
  return props.firstTextLetterSpacing;
}, function (props) {
  return props.firstTextIndent;
}, function (props) {
  return props.dashWidth;
}, function (props) {
  return props.dashPosition;
}, function (props) {
  return props.dashPosition;
});
var TextSecond$T = styled.div(_templateObject8$1a || (_templateObject8$1a = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: ", "px;\n  text-align: center;\n  color: var(--Gallllery-Black, #151514);\n  font-family: ", ";\n  font-style: italic;\n  font-weight: 500;\n  letter-spacing: ", "px;\n"])), function (props) {
  return props.secondTextHeight;
}, function (props) {
  return props.secondTextFontFamily;
}, function (props) {
  return props.secondTextLetterSpacing;
});
var TextThird$S = styled.div(_templateObject9$17 || (_templateObject9$17 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-size: ", "px;\n  font-weight: 400;\n  margin-bottom: ", "px;\n  font-family: ", ";\n  color: #151514;\n"])), function (props) {
  return props.thirdTextFontSize;
}, function (props) {
  return props.thirdTextMarginBottom;
}, function (props) {
  return props.thirdTextFontFamily;
});
var FamilyMuseumTemplate = function FamilyMuseumTemplate(_ref) {
  var image = _ref.image,
    url = _ref.url,
    name = _ref.name,
    number = _ref.number,
    withNumber = _ref.withNumber,
    customSubtitle = _ref.customSubtitle,
    description = _ref.description,
    dw = _ref.dw,
    dh = _ref.dh,
    wrapperWidth = _ref.wrapperWidth,
    wrapperHeight = _ref.wrapperHeight,
    wrapperPadding = _ref.wrapperPadding,
    urlHeight = _ref.urlHeight,
    urlFontSize = _ref.urlFontSize,
    urlLetterSpacing = _ref.urlLetterSpacing,
    urlFontWeight = _ref.urlFontWeight,
    urlLineHeight = _ref.urlLineHeight,
    textBlockHeight = _ref.textBlockHeight,
    textBlockWidth = _ref.textBlockWidth,
    textBlockPaddingTop = _ref.textBlockPaddingTop,
    textBlockGap = _ref.textBlockGap,
    firstTextFontSize = _ref.firstTextFontSize,
    firstTextFontFamily = _ref.firstTextFontFamily,
    firstTextLetterSpacing = _ref.firstTextLetterSpacing,
    firstTextIndent = _ref.firstTextIndent,
    dashWidth = _ref.dashWidth,
    dashPosition = _ref.dashPosition,
    secondTextFontFamily = _ref.secondTextFontFamily,
    secondTextLetterSpacing = _ref.secondTextLetterSpacing,
    secondTextHeight = _ref.secondTextHeight,
    thirdTextFontFamily = _ref.thirdTextFontFamily,
    thirdTextFontSize = _ref.thirdTextFontSize,
    thirdTextMarginBottom = _ref.thirdTextMarginBottom,
    fontSizeMax = _ref.fontSizeMax;
  var numberText = withNumber ? number : customSubtitle;
  return /*#__PURE__*/React$1.createElement(Wrapper$16, {
    dw: dw,
    dh: dh,
    wrapperWidth: wrapperWidth,
    wrapperHeight: wrapperHeight,
    wrapperPadding: wrapperPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$_, null, /*#__PURE__*/React$1.createElement(TextUrl$S, {
    urlHeight: urlHeight,
    urlFontSize: urlFontSize,
    urlLetterSpacing: urlLetterSpacing,
    urlFontWeight: urlFontWeight,
    urlLineHeight: urlLineHeight
  }, /*#__PURE__*/React$1.createElement("span", null, description && url)), /*#__PURE__*/React$1.createElement(ImageBlock$$, null, /*#__PURE__*/React$1.createElement(ImageInner$10, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$17, {
    textBlockHeight: textBlockHeight,
    textBlockWidth: textBlockWidth,
    textBlockPaddingTop: textBlockPaddingTop,
    textBlockGap: textBlockGap
  }, /*#__PURE__*/React$1.createElement(TextFirst$S, {
    dashWidth: dashWidth,
    dashPosition: dashPosition,
    firstTextFontSize: firstTextFontSize,
    firstTextFontFamily: firstTextFontFamily,
    firstTextLetterSpacing: firstTextLetterSpacing,
    firstTextIndent: firstTextIndent
  }, numberText && /*#__PURE__*/React$1.createElement(Fragment$1, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, numberText), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  }))), /*#__PURE__*/React$1.createElement(TextSecond$T, {
    secondTextFontFamily: secondTextFontFamily,
    secondTextLetterSpacing: secondTextLetterSpacing,
    secondTextHeight: secondTextHeight
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: name,
    fontSizeMax: fontSizeMax
  })), /*#__PURE__*/React$1.createElement(TextThird$S, {
    thirdTextFontFamily: thirdTextFontFamily,
    thirdTextFontSize: thirdTextFontSize,
    thirdTextMarginBottom: thirdTextMarginBottom
  }, description || url))));
};

var FamilyMuseumA0 = function FamilyMuseumA0(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 841,
    wrapperHeight: 1189,
    wrapperPadding: 380,
    urlHeight: 7.8,
    urlFontSize: 13,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 18.8,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 78,
    textBlockGap: 61.5,
    firstTextFontSize: 48,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 9,
    firstTextIndent: 5,
    dashWidth: 54,
    dashPosition: -41,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 60,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 28,
    thirdTextMarginBottom: 13,
    fontSizeMax: 76.5
  }));
};

var FamilyMuseumWithNumberA0 = function FamilyMuseumWithNumberA0(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA0, _extends({}, props, {
    withNumber: true
  }));
};

var _templateObject$1$, _templateObject2$1$, _templateObject3$1V, _templateObject4$1w, _templateObject5$1k, _templateObject6$1i, _templateObject7$1e, _templateObject8$1b, _templateObject9$18;
var Wrapper$17 = styled.div(_templateObject$1$ || (_templateObject$1$ = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.wrapperWidth;
}, function (props) {
  return props.wrapperHeight;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.wrapperWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.wrapperHeight;
}, function (props) {
  return props.wrapperPadding;
});
var MainBlock$$ = styled.div(_templateObject2$1$ || (_templateObject2$1$ = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$T = styled.div(_templateObject3$1V || (_templateObject3$1V = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: ", "px;\n    font-weight: ", ";\n    letter-spacing: ", "px;\n    line-height: ", "px;\n  }\n"])), function (props) {
  return props.urlHeight;
}, function (props) {
  return props.urlFontSize;
}, function (props) {
  return props.urlFontWeight;
}, function (props) {
  return props.urlLetterSpacing;
}, function (props) {
  return props.urlLineHeight;
});
var ImageBlock$10 = styled.div(_templateObject4$1w || (_templateObject4$1w = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$11 = styled.div(_templateObject5$1k || (_templateObject5$1k = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$18 = styled.div(_templateObject6$1i || (_templateObject6$1i = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  height: ", "%;\n  width: ", "%;\n  padding-top: ", "px;\n  gap: ", "px;\n"])), function (props) {
  return props.textBlockHeight;
}, function (props) {
  return props.textBlockWidth;
}, function (props) {
  return props.textBlockPaddingTop;
}, function (props) {
  return props.textBlockGap;
});
var TextFirst$T = styled.div(_templateObject7$1e || (_templateObject7$1e = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n\n  span {\n    font-family: ", ";\n    font-size: ", "px;\n    letter-spacing: ", "px;\n    text-indent: ", "px;\n    color: #151514;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n    color: #151514;\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (props) {
  return props.firstTextFontFamily || 'none';
}, function (props) {
  return props.firstTextFontSize;
}, function (props) {
  return props.firstTextLetterSpacing;
}, function (props) {
  return props.firstTextIndent;
}, function (props) {
  return props.dashWidth;
}, function (props) {
  return props.dashPosition;
}, function (props) {
  return props.dashPosition;
});
var TextSecond$U = styled.div(_templateObject8$1b || (_templateObject8$1b = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: ", "px;\n  text-align: center;\n  color: #151514;\n  font-family: ", ";\n  font-style: italic;\n  font-weight: 500;\n  letter-spacing: ", "px;\n"])), function (props) {
  return props.secondTextHeight;
}, function (props) {
  return props.secondTextFontFamily;
}, function (props) {
  return props.secondTextLetterSpacing;
});
var TextThird$T = styled.div(_templateObject9$18 || (_templateObject9$18 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n  font-family: ", ";\n  font-size: ", "px;\n  font-weight: 400;\n  margin-bottom: ", "px;\n  color: #151514;\n"])), function (props) {
  return props.thirdTextFontFamily;
}, function (props) {
  return props.thirdTextFontSize;
}, function (props) {
  return props.thirdTextMarginBottom;
});
var FamilyMuseumTemplateL = function FamilyMuseumTemplateL(_ref) {
  var image = _ref.image,
    url = _ref.url,
    name = _ref.name,
    number = _ref.number,
    withNumber = _ref.withNumber,
    customSubtitle = _ref.customSubtitle,
    description = _ref.description,
    dw = _ref.dw,
    dh = _ref.dh,
    wrapperWidth = _ref.wrapperWidth,
    wrapperHeight = _ref.wrapperHeight,
    wrapperPadding = _ref.wrapperPadding,
    urlHeight = _ref.urlHeight,
    urlFontSize = _ref.urlFontSize,
    urlLetterSpacing = _ref.urlLetterSpacing,
    urlFontWeight = _ref.urlFontWeight,
    urlLineHeight = _ref.urlLineHeight,
    textBlockHeight = _ref.textBlockHeight,
    textBlockWidth = _ref.textBlockWidth,
    textBlockPaddingTop = _ref.textBlockPaddingTop,
    textBlockGap = _ref.textBlockGap,
    firstTextFontSize = _ref.firstTextFontSize,
    firstTextFontFamily = _ref.firstTextFontFamily,
    firstTextLetterSpacing = _ref.firstTextLetterSpacing,
    firstTextIndent = _ref.firstTextIndent,
    dashWidth = _ref.dashWidth,
    dashPosition = _ref.dashPosition,
    secondTextFontFamily = _ref.secondTextFontFamily,
    secondTextLetterSpacing = _ref.secondTextLetterSpacing,
    secondTextHeight = _ref.secondTextHeight,
    thirdTextFontFamily = _ref.thirdTextFontFamily,
    thirdTextFontSize = _ref.thirdTextFontSize,
    thirdTextMarginBottom = _ref.thirdTextMarginBottom,
    fontSizeMax = _ref.fontSizeMax;
  var numberText = withNumber ? number : customSubtitle;
  return /*#__PURE__*/React$1.createElement(Wrapper$17, {
    dw: dw,
    dh: dh,
    wrapperWidth: wrapperWidth,
    wrapperHeight: wrapperHeight,
    wrapperPadding: wrapperPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$$, null, /*#__PURE__*/React$1.createElement(TextUrl$T, {
    urlHeight: urlHeight,
    urlFontSize: urlFontSize,
    urlLetterSpacing: urlLetterSpacing,
    urlFontWeight: urlFontWeight,
    urlLineHeight: urlLineHeight
  }, /*#__PURE__*/React$1.createElement("span", null, description && url)), /*#__PURE__*/React$1.createElement(ImageBlock$10, null, /*#__PURE__*/React$1.createElement(ImageInner$11, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$18, {
    textBlockHeight: textBlockHeight,
    textBlockWidth: textBlockWidth,
    textBlockPaddingTop: textBlockPaddingTop,
    textBlockGap: textBlockGap
  }, /*#__PURE__*/React$1.createElement(TextFirst$T, {
    firstTextFontSize: firstTextFontSize,
    firstTextFontFamily: firstTextFontFamily,
    firstTextLetterSpacing: firstTextLetterSpacing,
    firstTextIndent: firstTextIndent,
    dashWidth: dashWidth,
    dashPosition: dashPosition
  }, numberText && /*#__PURE__*/React$1.createElement(Fragment$1, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, numberText), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  }))), /*#__PURE__*/React$1.createElement(TextSecond$U, {
    secondTextFontFamily: secondTextFontFamily,
    secondTextLetterSpacing: secondTextLetterSpacing,
    secondTextHeight: secondTextHeight
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: name,
    fontSizeMax: fontSizeMax
  })), /*#__PURE__*/React$1.createElement(TextThird$T, {
    thirdTextFontFamily: thirdTextFontFamily,
    thirdTextFontSize: thirdTextFontSize,
    thirdTextMarginBottom: thirdTextMarginBottom
  }, description || url))));
};

var FamilyMuseumA0L = function FamilyMuseumA0L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplateL, _extends({}, props, {
    wrapperWidth: 1189,
    wrapperHeight: 841,
    wrapperPadding: 165,
    urlHeight: 6.8,
    urlFontSize: 13,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 21,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 19,
    textBlockGap: 60,
    firstTextFontSize: 46,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 9.7,
    firstTextIndent: 1,
    dashWidth: 53,
    dashPosition: -40,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 60,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 27.5,
    thirdTextMarginBottom: 0,
    fontSizeMax: 77
  }));
};

var FamilyMuseumWithNumberA0L = function FamilyMuseumWithNumberA0L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA0L, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA1 = function FamilyMuseumA1(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 594,
    wrapperHeight: 841,
    wrapperPadding: 265,
    urlHeight: 7.8,
    urlFontSize: 12,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 18.8,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 25,
    textBlockGap: 45.5,
    firstTextFontSize: 36,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 7,
    firstTextIndent: 5,
    dashWidth: 42,
    dashPosition: -36,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 50,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 22,
    thirdTextMarginBottom: 13,
    fontSizeMax: 58.5
  }));
};

var FamilyMuseumWithNumberA1 = function FamilyMuseumWithNumberA1(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA1, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA1L = function FamilyMuseumA1L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplateL, _extends({}, props, {
    wrapperWidth: 841,
    wrapperHeight: 594,
    wrapperPadding: 120,
    urlHeight: 6.8,
    urlFontSize: 12,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 22.5,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 33,
    textBlockGap: 45,
    firstTextFontSize: 35,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 7.5,
    firstTextIndent: 1,
    dashWidth: 42,
    dashPosition: -31,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 47,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 21.5,
    thirdTextMarginBottom: 4,
    fontSizeMax: 59
  }));
};

var FamilyMuseumWithNumberA1L = function FamilyMuseumWithNumberA1L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA1L, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA2 = function FamilyMuseumA2(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 420,
    wrapperHeight: 594,
    wrapperPadding: 190,
    urlHeight: 7.8,
    urlFontSize: 9,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 18.9,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 34,
    textBlockGap: 30.5,
    firstTextFontSize: 25,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 5.3,
    firstTextIndent: 5,
    dashWidth: 28,
    dashPosition: -24,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 33,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 15.4,
    thirdTextMarginBottom: 13,
    fontSizeMax: 41.5
  }));
};

var FamilyMuseumWithNumberA2 = function FamilyMuseumWithNumberA2(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA2, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA2L = function FamilyMuseumA2L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplateL, _extends({}, props, {
    wrapperWidth: 594,
    wrapperHeight: 420,
    wrapperPadding: 85,
    urlHeight: 6.8,
    urlFontSize: 9,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 22.5,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 33,
    textBlockGap: 33,
    firstTextFontSize: 25,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 5.4,
    firstTextIndent: 1,
    dashWidth: 30,
    dashPosition: -20,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 35,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 15.2,
    thirdTextMarginBottom: 15,
    fontSizeMax: 41
  }));
};

var FamilyMuseumWithNumberA2L = function FamilyMuseumWithNumberA2L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA2L, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA3 = function FamilyMuseumA3(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 297,
    wrapperHeight: 420,
    wrapperPadding: 135,
    urlHeight: 7.8,
    urlFontSize: 6,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 18.9,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 33,
    textBlockGap: 24.5,
    firstTextFontSize: 19,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 2.8,
    firstTextIndent: 5,
    dashWidth: 21,
    dashPosition: -17,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 20,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 11,
    thirdTextMarginBottom: 22,
    fontSizeMax: 29
  }));
};

var FamilyMuseumWithNumberA3 = function FamilyMuseumWithNumberA3(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA3, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA3L = function FamilyMuseumA3L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplateL, _extends({}, props, {
    wrapperWidth: 420,
    wrapperHeight: 297,
    wrapperPadding: 58,
    urlHeight: 6.8,
    urlFontSize: 6,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 22.5,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 33,
    textBlockGap: 21,
    firstTextFontSize: 18,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 3.5,
    firstTextIndent: 1,
    dashWidth: 21,
    dashPosition: -14,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 29,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 10.8,
    thirdTextMarginBottom: 21,
    fontSizeMax: 29
  }));
};

var FamilyMuseumWithNumberA3L = function FamilyMuseumWithNumberA3L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA3L, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA4 = function FamilyMuseumA4(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 210,
    wrapperHeight: 297,
    wrapperPadding: 94,
    urlHeight: 7.8,
    urlFontSize: 5,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 18.9,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 30,
    textBlockGap: 14.5,
    firstTextFontSize: 13,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 2.4,
    firstTextIndent: 5,
    dashWidth: 15,
    dashPosition: -12,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 20,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 7.5,
    thirdTextMarginBottom: 22,
    fontSizeMax: 20
  }));
};

var FamilyMuseumA4L = function FamilyMuseumA4L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplateL, _extends({}, props, {
    wrapperWidth: 297,
    wrapperHeight: 210,
    wrapperPadding: 43,
    urlHeight: 6.8,
    urlFontSize: 5,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 22.5,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 33,
    textBlockGap: 15,
    firstTextFontSize: 13,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 2.4,
    firstTextIndent: 1,
    dashWidth: 15,
    dashPosition: -10,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 18,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 7.6,
    thirdTextMarginBottom: 24,
    fontSizeMax: 20
  }));
};

var FamilyMuseumWithNumberA4 = function FamilyMuseumWithNumberA4(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA4, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumWithNumberA4L = function FamilyMuseumWithNumberA4L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA4L, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA5 = function FamilyMuseumA5(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 148,
    wrapperHeight: 210,
    wrapperPadding: 66,
    urlHeight: 7.8,
    urlFontSize: 5,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 18.9,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 24,
    textBlockGap: 7.5,
    firstTextFontSize: 9,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 2.1,
    firstTextIndent: 6,
    dashWidth: 10.5,
    dashPosition: -8,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.45,
    secondTextHeight: 20,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 6,
    thirdTextMarginBottom: 18,
    fontSizeMax: 14.5
  }));
};

var FamilyMuseumWithNumberA5 = function FamilyMuseumWithNumberA5(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA5, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA5L = function FamilyMuseumA5L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplateL, _extends({}, props, {
    wrapperWidth: 210,
    wrapperHeight: 148,
    wrapperPadding: 31,
    urlHeight: 6.8,
    urlFontSize: 5,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 22.5,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 33,
    textBlockGap: 8,
    firstTextFontSize: 10,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 1.5,
    firstTextIndent: 1,
    dashWidth: 11,
    dashPosition: -7,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 0.25,
    secondTextHeight: 18,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 6.1,
    thirdTextMarginBottom: 24,
    fontSizeMax: 15
  }));
};

var FamilyMuseumWithNumberA5L = function FamilyMuseumWithNumberA5L(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA5L, _extends({}, props, {
    withNumber: true
  }));
};

var FamilyMuseumA0Plus = function FamilyMuseumA0Plus(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumTemplate, _extends({}, props, {
    wrapperWidth: 1000,
    wrapperHeight: 1414,
    wrapperPadding: 450,
    urlHeight: 7.9,
    urlFontSize: 24,
    urlLetterSpacing: 0.7,
    urlLineHeight: 4,
    textBlockHeight: 17.6,
    textBlockWidth: 87.9,
    textBlockPaddingTop: 87,
    textBlockGap: 61.5,
    firstTextFontSize: 52,
    firstTextFontFamily: "Roboto",
    firstTextLetterSpacing: 10,
    firstTextIndent: 23,
    dashWidth: 60,
    dashPosition: -50,
    secondTextFontFamily: "Baskerville",
    secondTextLetterSpacing: 1.45,
    thirdTextFontFamily: "Roboto",
    thirdTextFontSize: 30,
    thirdTextMarginBottom: 24,
    fontSizeMax: 82.5
  }));
};

var FamilyMuseumWithNumberA0Plus = function FamilyMuseumWithNumberA0Plus(props) {
  return /*#__PURE__*/React$1.createElement(FamilyMuseumA0Plus, _extends({}, props, {
    withNumber: true
  }));
};

var components$g = {
  FamilyMuseumA0Plus: FamilyMuseumA0Plus,
  FamilyMuseumWithNumberA0Plus: FamilyMuseumWithNumberA0Plus,
  FamilyMuseumA0: FamilyMuseumA0,
  FamilyMuseumWithNumberA0: FamilyMuseumWithNumberA0,
  FamilyMuseumA0L: FamilyMuseumA0L,
  FamilyMuseumWithNumberA0L: FamilyMuseumWithNumberA0L,
  FamilyMuseumA1: FamilyMuseumA1,
  FamilyMuseumWithNumberA1: FamilyMuseumWithNumberA1,
  FamilyMuseumA1L: FamilyMuseumA1L,
  FamilyMuseumWithNumberA1L: FamilyMuseumWithNumberA1L,
  FamilyMuseumA2: FamilyMuseumA2,
  FamilyMuseumWithNumberA2: FamilyMuseumWithNumberA2,
  FamilyMuseumA2L: FamilyMuseumA2L,
  FamilyMuseumWithNumberA2L: FamilyMuseumWithNumberA2L,
  FamilyMuseumA3: FamilyMuseumA3,
  FamilyMuseumWithNumberA3: FamilyMuseumWithNumberA3,
  FamilyMuseumA3L: FamilyMuseumA3L,
  FamilyMuseumWithNumberA3L: FamilyMuseumWithNumberA3L,
  FamilyMuseumA4: FamilyMuseumA4,
  FamilyMuseumWithNumberA4: FamilyMuseumWithNumberA4,
  FamilyMuseumA4L: FamilyMuseumA4L,
  FamilyMuseumWithNumberA4L: FamilyMuseumWithNumberA4L,
  FamilyMuseumA5: FamilyMuseumA5,
  FamilyMuseumWithNumberA5: FamilyMuseumWithNumberA5,
  FamilyMuseumA5L: FamilyMuseumA5L,
  FamilyMuseumWithNumberA5L: FamilyMuseumWithNumberA5L
};
var FamilyMuseum = function FamilyMuseum(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components$g[templateType], {
    url: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.link) || 'kiiids.art',
    image: image,
    number: cardNumber,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    description: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.description) || '',
    name: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.title) || '',
    dw: dw,
    dh: dh
  });
};

function formatText(text, options) {
  if (options === void 0) {
    options = {};
  }
  if (!text) return '';
  if (Array.isArray(text)) return text.join(',');
  var _options = options,
    _options$newlineAfter = _options.newlineAfterColon,
    newlineAfterColon = _options$newlineAfter === void 0 ? false : _options$newlineAfter;
  return text.split('.').map(function (sentence) {
    return sentence.trim();
  }).filter(Boolean).map(function (sentence) {
    var parts = sentence.split(':');
    if (parts.length > 1) {
      var separator = newlineAfterColon ? ':\n' : ': ';
      return parts[0] + separator + parts.slice(1).map(function (part) {
        return part.trim().charAt(0).toUpperCase() + part.trim().slice(1);
      }).join(separator);
    }
    return sentence;
  }).map(function (sentence) {
    return sentence + '.';
  }).join('\n');
}

var _templateObject$20, _templateObject2$20, _templateObject3$1W, _templateObject4$1x, _templateObject5$1l, _templateObject6$1j, _templateObject7$1f, _templateObject8$1c, _templateObject9$19, _templateObject10$u;
var Wrapper$18 = styled.div(_templateObject$20 || (_templateObject$20 = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.pageWidth;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.pageWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.horizontalPadding;
});
var MainBlock$10 = styled.div(_templateObject2$20 || (_templateObject2$20 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$U = styled.div(_templateObject3$1W || (_templateObject3$1W = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.7px;\n    line-height: 4px;\n    margin: 5px 3px 0 0;\n  }\n"])), function (props) {
  return props.urlHeightPercent;
});
var ImageBlock$11 = styled.div(_templateObject4$1x || (_templateObject4$1x = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$12 = styled.div(_templateObject5$1l || (_templateObject5$1l = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$19 = styled.div(_templateObject6$1j || (_templateObject6$1j = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  height: ", "%;\n  width: 100%;\n  padding-bottom: ", "px;\n  padding-top: ", "px;\n"])), function (props) {
  return props.textBottomHeight;
}, function (props) {
  return props.textBottomPadding;
}, function (props) {
  return props.textTopPadding;
});
var TextFirst$U = styled.div(_templateObject7$1f || (_templateObject7$1f = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  margin-bottom: ", "px;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-weight: 400;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (props) {
  return props.marginBottom;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.dashWidth;
}, function (props) {
  return props.dashOffset;
}, function (props) {
  return props.dashOffset;
});
var TextSecond$V = styled.div(_templateObject8$1c || (_templateObject8$1c = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n  margin-bottom: ", "px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: 'zMr';\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: ", "px;\n"])), function (props) {
  return props.marginBottom;
}, function (props) {
  return props.letterSpacing;
});
var TextThird$U = styled.div(_templateObject9$19 || (_templateObject9$19 = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  text-align: center;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  line-height: ", "px;\n  font-weight: 400;\n  flex: 1;\n  white-space: pre-wrap;\n  color: #151514 !important;\n  padding: 0 ", "px;\n  width: 100%;\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.horizontalPadding;
});
var TextFourth$2 = styled.div(_templateObject10$u || (_templateObject10$u = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", "px;\n  color: #151514 !important;\n"])), function (props) {
  return props.fontSize;
});
var FlowerHorConstructor = function FlowerHorConstructor(_ref) {
  var _customFields$find, _customFields$find$da, _customFields$find2, _customFields$find3, _customFields$find4, _customFields$find5;
  var image = _ref.image,
    url = _ref.url,
    name = _ref.name,
    descriptionInit = _ref.description,
    museum = _ref.museum,
    dw = _ref.dw,
    dh = _ref.dh,
    customFields = _ref.customFields,
    flowerType = _ref.flowerType,
    useRegularFields = _ref.useRegularFields,
    pageWidth = _ref.pageWidth,
    pageHeight = _ref.pageHeight,
    horizontalPadding = _ref.horizontalPadding,
    urlHeightPercent = _ref.urlHeightPercent,
    textBottomHeight = _ref.textBottomHeight,
    textBottomPadding = _ref.textBottomPadding,
    textTopPadding = _ref.textTopPadding,
    dashWidth = _ref.dashWidth,
    dashOffset = _ref.dashOffset,
    titleFontSize = _ref.titleFontSize,
    titleMarginBottom = _ref.titleMarginBottom,
    titleLetterSpacing = _ref.titleLetterSpacing,
    secondFontMax = _ref.secondFontMax,
    secondMarginBottom = _ref.secondMarginBottom,
    secondLetterSpacing = _ref.secondLetterSpacing,
    thirdFontSize = _ref.thirdFontSize,
    thirdLetterSpacing = _ref.thirdLetterSpacing,
    thirdLineHeight = _ref.thirdLineHeight,
    thirdMarginBottom = _ref.thirdMarginBottom,
    thirdHorizontalPadding = _ref.thirdHorizontalPadding,
    fourthFontSize = _ref.fourthFontSize,
    newlineAfterColon = _ref.newlineAfterColon;
  var flowerDateSrc = (customFields === null || customFields === void 0 ? void 0 : (_customFields$find = customFields.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.typeField) === 'dateMonth';
  })) === null || _customFields$find === void 0 ? void 0 : (_customFields$find$da = _customFields$find.data) === null || _customFields$find$da === void 0 ? void 0 : _customFields$find$da.toLowerCase()) || '';
  var flowerDate = flowerDateSrc === 'daymonth' ? new Date().toLocaleDateString('ru-RU', {
    day: 'numeric',
    month: 'long'
  }) : flowerDateSrc;
  var flowerName = (customFields === null || customFields === void 0 ? void 0 : (_customFields$find2 = customFields.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.typeField) === 'flower_name';
  })) === null || _customFields$find2 === void 0 ? void 0 : _customFields$find2.data) || '';
  var flowerCharacters = (customFields === null || customFields === void 0 ? void 0 : (_customFields$find3 = customFields.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.typeField) === 'flower_characters';
  })) === null || _customFields$find3 === void 0 ? void 0 : _customFields$find3.data) || '';
  var flowerPrediction = (customFields === null || customFields === void 0 ? void 0 : (_customFields$find4 = customFields.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.typeField) === 'flower_prediction';
  })) === null || _customFields$find4 === void 0 ? void 0 : _customFields$find4.data) || '';
  var flowerCharacterFeatures = (customFields === null || customFields === void 0 ? void 0 : (_customFields$find5 = customFields.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.typeField) === 'character_features';
  })) === null || _customFields$find5 === void 0 ? void 0 : _customFields$find5.data) || '';
  var flowerData = useMemo(function () {
    if (useRegularFields || flowerType === 1) {
      return {
        title: name,
        description: descriptionInit
      };
    }
    if (flowerType === 2) {
      return {
        title: flowerName,
        description: flowerCharacters ? "\u042D\u0442\u043E \u0446\u0432\u0435\u0442\u043E\u043A \u0434\u0430\u0440\u0438\u0442 \u0435\u0433\u043E \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0443 \u0441\u0432\u043E\u0438 \u0441\u0438\u043C\u0432\u043E\u043B\u044B: " + flowerCharacters : ''
      };
    }
    if (flowerType === 3) {
      return {
        title: flowerDate && flowerName ? flowerDate + ". " + flowerName : '',
        description: flowerPrediction ? "\u042D\u0442\u043E\u0442 \u0446\u0432\u0435\u0442\u043E\u043A, \u043F\u043E\u0434\u0430\u0440\u0435\u043D\u043D\u044B\u0439 \u0441\u0435\u0433\u043E\u0434\u043D\u044F, \u043F\u0440\u0438\u043D\u0435\u0441\u0435\u0442 \u0435\u0433\u043E \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0443 " + flowerPrediction : ''
      };
    }
  }, [flowerType, flowerDate, flowerName, flowerCharacters, flowerPrediction, flowerCharacterFeatures, useRegularFields, descriptionInit, name]);
  return /*#__PURE__*/React$1.createElement(Wrapper$18, {
    dw: dw,
    dh: dh,
    pageWidth: pageWidth,
    pageHeight: pageHeight,
    horizontalPadding: horizontalPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$10, null, /*#__PURE__*/React$1.createElement(TextUrl$U, {
    urlHeightPercent: urlHeightPercent
  }, /*#__PURE__*/React$1.createElement("span", null)), /*#__PURE__*/React$1.createElement(ImageBlock$11, null, /*#__PURE__*/React$1.createElement(ImageInner$12, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$19, {
    textTopPadding: textTopPadding,
    textBottomPadding: textBottomPadding,
    textBottomHeight: textBottomHeight
  }, /*#__PURE__*/React$1.createElement(TextFirst$U, {
    fontSize: titleFontSize,
    marginBottom: titleMarginBottom,
    dashWidth: dashWidth,
    dashOffset: dashOffset,
    letterSpacing: titleLetterSpacing
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, museum), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$V, {
    marginBottom: secondMarginBottom,
    letterSpacing: secondLetterSpacing
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: flowerData.title,
    fontSizeMax: secondFontMax
  })), /*#__PURE__*/React$1.createElement(TextThird$U, {
    fontSize: thirdFontSize,
    letterSpacing: thirdLetterSpacing,
    lineHeight: thirdLineHeight,
    marginBottom: thirdMarginBottom,
    horizontalPadding: thirdHorizontalPadding
  }, formatText(flowerData.description, {
    newlineAfterColon: newlineAfterColon
  })), /*#__PURE__*/React$1.createElement(TextFourth$2, {
    fontSize: fourthFontSize
  }, url))));
};

var FlowerHoroscopeSqCardA4 = function FlowerHoroscopeSqCardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 41,
    urlHeightPercent: 5.3,
    textBottomPadding: 39,
    textTopPadding: 54,
    textBottomHeight: 31.3,
    dashWidth: 26,
    dashOffset: -23,
    titleFontSize: 18,
    titleMarginBottom: 32,
    secondFontMax: 24,
    secondMarginBottom: 28,
    secondLetterSpacing: 0.65,
    thirdHorizontalPadding: 40,
    thirdFontSize: 13.2,
    thirdLetterSpacing: 0.3,
    thirdLineHeight: 26,
    thirdMarginBottom: 36,
    fourthFontSize: 6.4
  }));
};

var FlowerHoroscopeCardA4 = function FlowerHoroscopeCardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 95,
    urlHeightPercent: 7.7,
    textBottomPadding: 34,
    textTopPadding: 48,
    textBottomHeight: 26.6,
    dashWidth: 26,
    dashOffset: -23,
    titleFontSize: 18,
    titleMarginBottom: 30,
    secondFontMax: 24,
    secondMarginBottom: 25,
    secondLetterSpacing: 0.65,
    thirdFontSize: 11.5,
    thirdLetterSpacing: 0.2,
    thirdLineHeight: 18.2,
    thirdMarginBottom: 32,
    fourthFontSize: 6.5
  }));
};

var FlowerHoroscopeCardA1 = function FlowerHoroscopeCardA1(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 270,
    urlHeightPercent: 7.9,
    textBottomPadding: 117,
    textTopPadding: 153,
    textBottomHeight: 26.6,
    titleMarginBottom: 78,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 67,
    secondMarginBottom: 69,
    secondLetterSpacing: 0.6,
    thirdFontSize: 30,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 47,
    thirdMarginBottom: 88,
    fourthFontSize: 15.5
  }));
};

var FlowerHoroscopeSqCardA1 = function FlowerHoroscopeSqCardA1(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 120,
    urlHeightPercent: 5.3,
    textBottomPadding: 135,
    textTopPadding: 173,
    textBottomHeight: 31.3,
    titleMarginBottom: 86,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 66,
    secondMarginBottom: 69,
    secondLetterSpacing: 0.65,
    thirdHorizontalPadding: 110,
    thirdFontSize: 35.2,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 70,
    thirdMarginBottom: 96,
    fourthFontSize: 15.4
  }));
};

var FlowerHoroscopeCardA2 = function FlowerHoroscopeCardA2(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 185,
    urlHeightPercent: 7.9,
    textBottomHeight: 26.6,
    textTopPadding: 110,
    textBottomPadding: 79,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 55,
    secondFontMax: 47,
    secondMarginBottom: 45,
    secondLetterSpacing: 0.5,
    thirdFontSize: 21,
    thirdLetterSpacing: 0.6,
    thirdLineHeight: 34,
    thirdMarginBottom: 59,
    fourthFontSize: 11
  }));
};

var FlowerHoroscopeSqCardA2 = function FlowerHoroscopeSqCardA2(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 82,
    urlHeightPercent: 5.3,
    textBottomPadding: 91,
    textTopPadding: 124,
    textBottomHeight: 31.3,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 60,
    secondFontMax: 47,
    secondMarginBottom: 50,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 79,
    thirdFontSize: 26,
    thirdLineHeight: 49,
    thirdMarginBottom: 69,
    fourthFontSize: 11
  }));
};

var FlowerHoroscopeCardA3 = function FlowerHoroscopeCardA3(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 135,
    urlHeightPercent: 7.8,
    textBottomPadding: 57,
    textTopPadding: 79,
    textBottomHeight: 26.6,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 22,
    titleMarginBottom: 42,
    titleLetterSpacing: 0.9,
    secondFontMax: 31,
    secondMarginBottom: 34,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 3,
    thirdLetterSpacing: 0.45,
    thirdFontSize: 14.8,
    thirdLineHeight: 24,
    thirdMarginBottom: 42,
    fourthFontSize: 7
  }));
};

var FlowerHoroscopeSqCardA3 = function FlowerHoroscopeSqCardA3(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 61,
    urlHeightPercent: 5.3,
    textBottomPadding: 66,
    textTopPadding: 88,
    textBottomHeight: 31.3,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 22,
    titleMarginBottom: 46,
    titleLetterSpacing: 0.9,
    secondFontMax: 31,
    secondMarginBottom: 35,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 73,
    thirdLetterSpacing: 0.3,
    thirdFontSize: 17.8,
    thirdLineHeight: 35,
    thirdMarginBottom: 49,
    fourthFontSize: 7
  }));
};

var FlowerHoroscopeCardA5 = function FlowerHoroscopeCardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 67,
    urlHeightPercent: 7.8,
    textBottomPadding: 27,
    textTopPadding: 34,
    textBottomHeight: 26.8,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 21,
    titleLetterSpacing: 0.3,
    secondFontMax: 17,
    secondMarginBottom: 18,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 3,
    thirdFontSize: 8.9,
    thirdLineHeight: 12.8,
    thirdMarginBottom: 20,
    fourthFontSize: 5
  }));
};

var FlowerHoroscopeSqCardA5 = function FlowerHoroscopeSqCardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 30,
    urlHeightPercent: 5.3,
    textBottomPadding: 29,
    textTopPadding: 38,
    textBottomHeight: 31.5,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 23,
    titleLetterSpacing: 0.3,
    secondFontMax: 17,
    secondMarginBottom: 18,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 26,
    thirdFontSize: 9.8,
    thirdLineHeight: 19,
    thirdMarginBottom: 42,
    fourthFontSize: 5
  }));
};

var FlowerHoroscope2SqCardA3 = function FlowerHoroscope2SqCardA3(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 61,
    urlHeightPercent: 5.3,
    textBottomPadding: 71,
    textTopPadding: 102,
    textBottomHeight: 31.3,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 23,
    titleMarginBottom: 51,
    titleLetterSpacing: 0.6,
    secondFontMax: 31,
    secondMarginBottom: 37,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 122,
    thirdLetterSpacing: -0.1,
    thirdFontSize: 18.4,
    thirdLineHeight: 35,
    thirdMarginBottom: 49,
    fourthFontSize: 7,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope2CardA3 = function FlowerHoroscope2CardA3(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 135,
    urlHeightPercent: 7.8,
    textBottomPadding: 65,
    textTopPadding: 79,
    textBottomHeight: 26.6,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 22,
    titleMarginBottom: 43,
    titleLetterSpacing: 0.9,
    secondFontMax: 31,
    secondMarginBottom: 38,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 3,
    thirdLetterSpacing: -0.1,
    thirdFontSize: 16,
    thirdLineHeight: 24,
    thirdMarginBottom: 42,
    fourthFontSize: 7,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3CardA3 = function FlowerHoroscope3CardA3(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 135,
    urlHeightPercent: 7.8,
    textBottomPadding: 65,
    textTopPadding: 79,
    textBottomHeight: 26.6,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 22,
    titleMarginBottom: 43,
    titleLetterSpacing: 0.9,
    secondFontMax: 31,
    secondMarginBottom: 38,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 3,
    thirdLetterSpacing: -0.1,
    thirdFontSize: 16,
    thirdLineHeight: 24,
    thirdMarginBottom: 42,
    fourthFontSize: 7
  }));
};

var FlowerHoroscope3SqCardA3 = function FlowerHoroscope3SqCardA3(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 61,
    urlHeightPercent: 5.3,
    textBottomPadding: 71,
    textTopPadding: 102,
    textBottomHeight: 31.3,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 23,
    titleMarginBottom: 51,
    titleLetterSpacing: 0.6,
    secondFontMax: 31,
    secondMarginBottom: 37,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 122,
    thirdLetterSpacing: -0.1,
    thirdFontSize: 18.4,
    thirdLineHeight: 35,
    thirdMarginBottom: 49,
    fourthFontSize: 7
  }));
};

var FlowerHoroscope2SqCardA4 = function FlowerHoroscope2SqCardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 41,
    urlHeightPercent: 5.3,
    textBottomPadding: 50,
    textTopPadding: 70,
    textBottomHeight: 31.3,
    dashWidth: 25,
    dashOffset: -21,
    titleFontSize: 17,
    titleMarginBottom: 36,
    secondFontMax: 23,
    secondMarginBottom: 25,
    secondLetterSpacing: 0.65,
    thirdHorizontalPadding: 88,
    thirdFontSize: 12.4,
    thirdLetterSpacing: 0.3,
    thirdLineHeight: 26,
    thirdMarginBottom: 36,
    fourthFontSize: 6.4,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3SqCardA4 = function FlowerHoroscope3SqCardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 41,
    urlHeightPercent: 5.3,
    textBottomPadding: 50,
    textTopPadding: 70,
    textBottomHeight: 31.3,
    dashWidth: 25,
    dashOffset: -21,
    titleFontSize: 17,
    titleMarginBottom: 36,
    secondFontMax: 23,
    secondMarginBottom: 25,
    secondLetterSpacing: 0.65,
    thirdHorizontalPadding: 88,
    thirdFontSize: 12.4,
    thirdLetterSpacing: 0.3,
    thirdLineHeight: 26,
    thirdMarginBottom: 36,
    fourthFontSize: 6.4
  }));
};

var FlowerHoroscope2CardA4 = function FlowerHoroscope2CardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 95,
    urlHeightPercent: 7.9,
    textBottomPadding: 46,
    textTopPadding: 54,
    textBottomHeight: 26.6,
    dashWidth: 26,
    dashOffset: -21,
    titleFontSize: 17,
    titleMarginBottom: 29,
    secondFontMax: 23,
    secondMarginBottom: 25,
    secondLetterSpacing: 0.45,
    thirdFontSize: 11,
    thirdLineHeight: 17.2,
    thirdMarginBottom: 32,
    fourthFontSize: 5.5,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3CardA4 = function FlowerHoroscope3CardA4(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 95,
    urlHeightPercent: 7.9,
    textBottomPadding: 46,
    textTopPadding: 54,
    textBottomHeight: 26.6,
    dashWidth: 26,
    dashOffset: -21,
    titleFontSize: 17,
    titleMarginBottom: 29,
    secondFontMax: 23,
    secondMarginBottom: 25,
    secondLetterSpacing: 0.45,
    thirdFontSize: 11,
    thirdLineHeight: 17.2,
    thirdMarginBottom: 32,
    fourthFontSize: 5.5
  }));
};

var FlowerHoroscope2CardA5 = function FlowerHoroscope2CardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 67,
    urlHeightPercent: 7.8,
    textBottomPadding: 35,
    textTopPadding: 38,
    textBottomHeight: 26.8,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 21,
    titleLetterSpacing: 0.3,
    secondFontMax: 16,
    secondMarginBottom: 19,
    secondLetterSpacing: 0.4,
    thirdHorizontalPadding: 3,
    thirdFontSize: 8.4,
    thirdLineHeight: 12,
    thirdMarginBottom: 20,
    fourthFontSize: 5,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope2SqCardA5 = function FlowerHoroscope2SqCardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 30,
    urlHeightPercent: 5.3,
    textBottomPadding: 38,
    textTopPadding: 50,
    textBottomHeight: 31.5,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 25,
    titleLetterSpacing: 0.3,
    secondFontMax: 16,
    secondMarginBottom: 18.5,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 61,
    thirdFontSize: 9.3,
    thirdLineHeight: 18,
    thirdMarginBottom: 42,
    thirdLetterSpacing: -0.1,
    fourthFontSize: 4.5,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3SqCardA5 = function FlowerHoroscope3SqCardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 30,
    urlHeightPercent: 5.3,
    textBottomPadding: 38,
    textTopPadding: 50,
    textBottomHeight: 31.5,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 25,
    titleLetterSpacing: 0.3,
    secondFontMax: 16,
    secondMarginBottom: 18.5,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 61,
    thirdFontSize: 9.3,
    thirdLineHeight: 18,
    thirdMarginBottom: 42,
    thirdLetterSpacing: -0.1,
    fourthFontSize: 4.5
  }));
};

var FlowerHoroscope3CardA5 = function FlowerHoroscope3CardA5(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 67,
    urlHeightPercent: 7.8,
    textBottomPadding: 35,
    textTopPadding: 38,
    textBottomHeight: 26.8,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 21,
    titleLetterSpacing: 0.3,
    secondFontMax: 16,
    secondMarginBottom: 19,
    secondLetterSpacing: 0.4,
    thirdHorizontalPadding: 3,
    thirdFontSize: 8.4,
    thirdLineHeight: 12,
    thirdMarginBottom: 20,
    fourthFontSize: 5
  }));
};

var FlowerHoroscope2SqCardA2 = function FlowerHoroscope2SqCardA2(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 82,
    urlHeightPercent: 5.3,
    textBottomPadding: 100,
    textTopPadding: 144,
    textBottomHeight: 31.3,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 70,
    secondFontMax: 47,
    secondMarginBottom: 50,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 177,
    thirdFontSize: 26,
    thirdLineHeight: 49,
    thirdMarginBottom: 69,
    fourthFontSize: 11,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3SqCardA2 = function FlowerHoroscope3SqCardA2(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 82,
    urlHeightPercent: 5.3,
    textBottomPadding: 100,
    textTopPadding: 144,
    textBottomHeight: 31.3,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 70,
    secondFontMax: 47,
    secondMarginBottom: 50,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 177,
    thirdFontSize: 26,
    thirdLineHeight: 49,
    thirdMarginBottom: 69,
    fourthFontSize: 11
  }));
};

var FlowerHoroscope2CardA2 = function FlowerHoroscope2CardA2(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 185,
    urlHeightPercent: 7.9,
    textBottomHeight: 26.6,
    textTopPadding: 110,
    textBottomPadding: 90,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 55,
    secondFontMax: 47,
    secondMarginBottom: 52,
    secondLetterSpacing: 0.5,
    thirdFontSize: 21,
    thirdLetterSpacing: 0.6,
    thirdLineHeight: 34,
    thirdMarginBottom: 59,
    fourthFontSize: 11,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3CardA2 = function FlowerHoroscope3CardA2(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 185,
    urlHeightPercent: 7.9,
    textBottomHeight: 26.6,
    textTopPadding: 110,
    textBottomPadding: 90,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 55,
    secondFontMax: 47,
    secondMarginBottom: 52,
    secondLetterSpacing: 0.5,
    thirdFontSize: 21,
    thirdLetterSpacing: 0.6,
    thirdLineHeight: 34,
    thirdMarginBottom: 59,
    fourthFontSize: 11
  }));
};

var FlowerHoroscope2SqCardA1 = function FlowerHoroscope2SqCardA1(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 120,
    urlHeightPercent: 5.3,
    textBottomPadding: 144,
    textTopPadding: 199,
    textBottomHeight: 31.3,
    titleMarginBottom: 102,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 66,
    secondMarginBottom: 74,
    secondLetterSpacing: 0.65,
    thirdHorizontalPadding: 245,
    thirdFontSize: 35.2,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 70,
    thirdMarginBottom: 96,
    fourthFontSize: 15.4,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3SqCardA1 = function FlowerHoroscope3SqCardA1(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 120,
    urlHeightPercent: 5.3,
    textBottomPadding: 144,
    textTopPadding: 199,
    textBottomHeight: 31.3,
    titleMarginBottom: 102,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 66,
    secondMarginBottom: 74,
    secondLetterSpacing: 0.65,
    thirdHorizontalPadding: 245,
    thirdFontSize: 35.2,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 70,
    thirdMarginBottom: 96,
    fourthFontSize: 15.4
  }));
};

var FlowerHoroscope2CardA1 = function FlowerHoroscope2CardA1(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 2,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 270,
    urlHeightPercent: 7.9,
    textBottomPadding: 133,
    textTopPadding: 153,
    textBottomHeight: 26.6,
    titleMarginBottom: 80,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 67,
    secondMarginBottom: 74,
    secondLetterSpacing: 0.6,
    thirdFontSize: 30,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 47,
    thirdMarginBottom: 88,
    fourthFontSize: 15.5,
    newlineAfterColon: true
  }));
};

var FlowerHoroscope3CardA1 = function FlowerHoroscope3CardA1(props) {
  return /*#__PURE__*/React$1.createElement(FlowerHorConstructor, _extends({}, props, {
    flowerType: 3,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 270,
    urlHeightPercent: 7.9,
    textBottomPadding: 133,
    textTopPadding: 153,
    textBottomHeight: 26.6,
    titleMarginBottom: 80,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 67,
    secondMarginBottom: 74,
    secondLetterSpacing: 0.6,
    thirdFontSize: 30,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 47,
    thirdMarginBottom: 88,
    fourthFontSize: 15.5
  }));
};

var components$h = {
  FlowerHoroscopeCardA1: FlowerHoroscopeCardA1,
  FlowerHoroscopeSqCardA1: FlowerHoroscopeSqCardA1,
  FlowerHoroscopeCardA2: FlowerHoroscopeCardA2,
  FlowerHoroscopeSqCardA2: FlowerHoroscopeSqCardA2,
  FlowerHoroscopeCardA3: FlowerHoroscopeCardA3,
  FlowerHoroscopeSqCardA3: FlowerHoroscopeSqCardA3,
  FlowerHoroscopeCardA4: FlowerHoroscopeCardA4,
  FlowerHoroscopeSqCardA4: FlowerHoroscopeSqCardA4,
  FlowerHoroscopeCardA5: FlowerHoroscopeCardA5,
  FlowerHoroscopeSqCardA5: FlowerHoroscopeSqCardA5,
  FlowerHoroscope2CardA1: FlowerHoroscope2CardA1,
  FlowerHoroscope2SqCardA1: FlowerHoroscope2SqCardA1,
  FlowerHoroscope2CardA2: FlowerHoroscope2CardA2,
  FlowerHoroscope2SqCardA2: FlowerHoroscope2SqCardA2,
  FlowerHoroscope2CardA3: FlowerHoroscope2CardA3,
  FlowerHoroscope2SqCardA3: FlowerHoroscope2SqCardA3,
  FlowerHoroscope2CardA4: FlowerHoroscope2CardA4,
  FlowerHoroscope2SqCardA4: FlowerHoroscope2SqCardA4,
  FlowerHoroscope2CardA5: FlowerHoroscope2CardA5,
  FlowerHoroscope2SqCardA5: FlowerHoroscope2SqCardA5,
  FlowerHoroscope3CardA1: FlowerHoroscope3CardA1,
  FlowerHoroscope3SqCardA1: FlowerHoroscope3SqCardA1,
  FlowerHoroscope3CardA2: FlowerHoroscope3CardA2,
  FlowerHoroscope3SqCardA2: FlowerHoroscope3SqCardA2,
  FlowerHoroscope3CardA3: FlowerHoroscope3CardA3,
  FlowerHoroscope3SqCardA3: FlowerHoroscope3SqCardA3,
  FlowerHoroscope3CardA4: FlowerHoroscope3CardA4,
  FlowerHoroscope3SqCardA4: FlowerHoroscope3SqCardA4,
  FlowerHoroscope3CardA5: FlowerHoroscope3CardA5,
  FlowerHoroscope3SqCardA5: FlowerHoroscope3SqCardA5
};
var FlowerHoroscopeCard = function FlowerHoroscopeCard(props) {
  var _ref;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    useRegularFieldsProp = props.useRegularFields,
    dw = props.dw,
    dh = props.dh;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = data.templateData || {};
  var useRegularFieldsResolved = (_ref = useRegularFieldsProp != null ? useRegularFieldsProp : data && data.useRegularFields) != null ? _ref : false;
  return React$1.createElement(components$h[templateType], {
    url: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.link) || 'artz.work',
    image: image,
    number: cardNumber,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    description: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.description) || '',
    museum: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    name: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.title) || '',
    customFields: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.customFields) || [],
    useRegularFields: useRegularFieldsResolved,
    dw: dw,
    dh: dh
  });
};

var _templateObject$21, _templateObject2$21, _templateObject3$1X, _templateObject4$1y, _templateObject5$1m, _templateObject6$1k, _templateObject7$1g, _templateObject8$1d, _templateObject9$1a, _templateObject10$v, _templateObject11$s;
var Wrapper$19 = styled.div(_templateObject$21 || (_templateObject$21 = _taggedTemplateLiteralLoose(["\n  width: 148mm;\n  height: 210mm;\n  transform: scale(\n    calc(", " / 148),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 57px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n    color: #151514;\n    font-family: 'Roboto';\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var MainBlock$11 = styled.div(_templateObject2$21 || (_templateObject2$21 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$V = styled.div(_templateObject3$1X || (_templateObject3$1X = _taggedTemplateLiteralLoose(["\n  height: 5.9%;\n  width: 100%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 10px;\n    font-style: normal;\n    font-weight: 400;\n  }\n"])));
var SizeBlock = styled.div(_templateObject4$1y || (_templateObject4$1y = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  width: 100%;\n  height: 34.8%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n  overflow: hidden;\n  font-size: 207px;\n  letter-spacing: 2px;\n  font-weight: 700;\n  line-height: 200px;\n\n  & > span {\n    font-size: 158px;\n    letter-spacing: 5px;\n  }\n"])));
var MainTextBlock$1 = styled.div(_templateObject5$1m || (_templateObject5$1m = _taggedTemplateLiteralLoose(["\n  height: 48%;\n  width: 100%;\n"])));
var RowWrapper = styled.div(_templateObject6$1k || (_templateObject6$1k = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  border-top: 1px solid black;\n  border-bottom: 1px solid black;\n  font-family: 'Roboto';\n  width: 100%;\n  max-width: 450px;\n"])));
var Row$2 = styled.div(_templateObject7$1g || (_templateObject7$1g = _taggedTemplateLiteralLoose(["\n  display: flex;\n  border-top: 1px solid black;\n  height: 54px;\n  align-items: center;\n  justify-content: space-between;\n\n  &:last-child {\n    border-bottom: none;\n  }\n"])));
var TitleCell = styled.div(_templateObject8$1d || (_templateObject8$1d = _taggedTemplateLiteralLoose(["\n  font-weight: 600;\n  font-size: 35px;\n  letter-spacing: 3.3px;\n  text-transform: uppercase;\n  flex-shrink: 0;\n  margin-right: 10px;\n  min-width: 120px;\n  max-width: ", ";\n  background: transparent !important;\n"])), function (_ref) {
  var fullWidth = _ref.fullWidth;
  return fullWidth ? '100%' : '252px';
});
var EmptyCell = styled(TitleCell)(_templateObject9$1a || (_templateObject9$1a = _taggedTemplateLiteralLoose(["\n  visibility: hidden;\n"])));
var ValueCell = styled.div(_templateObject10$v || (_templateObject10$v = _taggedTemplateLiteralLoose(["\n  font-size: 21.5px;\n  text-transform: uppercase;\n  font-weight: 600;\n  letter-spacing: 2px;\n  white-space: nowrap;\n  text-align: right;\n  background: transparent !important;\n"])));
var SubtitleBlock = styled.div(_templateObject11$s || (_templateObject11$s = _taggedTemplateLiteralLoose(["\n  max-width: calc(100% - 66px - 32px);\n  margin-top: 7px;\n  position: relative;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex: 1;\n\n  div.text {\n    display: flex;\n    width: 100%;\n    text-align: center;\n    align-items: center;\n    justify-content: center;\n    text-transform: uppercase;\n    letter-spacing: 3.6px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 33px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (_ref2) {
  var isShortDash = _ref2.isShortDash;
  return isShortDash ? 14 : -16;
}, function (_ref3) {
  var isShortDash = _ref3.isShortDash;
  return isShortDash ? 14 : -16;
});
var ServiceCardA5 = function ServiceCardA5(_ref4) {
  var customFields = _ref4.customFields,
    url = _ref4.url,
    name = _ref4.name,
    dw = _ref4.dw,
    dh = _ref4.dh,
    subTitle = _ref4.subTitle;
  var wrapperRef = useRef(null);
  var _useState = useState(0),
    maxValueWidth = _useState[0],
    setMaxValueWidth = _useState[1];
  var _useState2 = useState(19),
    subTitleFontSize = _useState2[0],
    setSubTitleFontSize = _useState2[1];
  var isTwoPlus = name === null || name === void 0 ? void 0 : name.includes('++');
  var twoPlus = '++';
  var correctName = isTwoPlus ? name === null || name === void 0 ? void 0 : name.replace('++', '') : name;
  useEffect(function () {
    if (!wrapperRef.current) return;
    var resize = function resize() {
      var _wrapperRef$current;
      var fullWidth = ((_wrapperRef$current = wrapperRef.current) === null || _wrapperRef$current === void 0 ? void 0 : _wrapperRef$current.clientWidth) || 0;
      setMaxValueWidth(fullWidth - 120 - 130);
    };
    resize();
    var observer = new ResizeObserver(resize);
    observer.observe(wrapperRef.current);
    return function () {
      return observer.disconnect();
    };
  }, []);
  var splitWordsIntoLines = useCallback(function (wordsString) {
    var words = wordsString.split(' ');
    if (maxValueWidth === 0) return [words.join(', ')];
    var canvas = document.createElement('canvas');
    var ctx = canvas.getContext('2d');
    if (!ctx) return [words.join(', ')];
    ctx.font = '600 21.5px Roboto';
    var lines = [];
    var currentLine = '';
    for (var i = 0; i < words.length; i++) {
      var value = words[i];
      var wordsInValue = value.split(' ');
      for (var j = 0; j < wordsInValue.length; j++) {
        var word = wordsInValue[j];
        var testWordToAdd = word;
        var prefix = ' ';
        if (lines.length === 0 && currentLine === '' && i === 0 && j === 0) {
          prefix = '';
        }
        var testLine = currentLine + prefix + testWordToAdd;
        var testWidth = ctx.measureText(testLine).width;
        if (testWidth > maxValueWidth && currentLine !== '') {
          lines.push(currentLine);
          currentLine = word;
        } else if (testWidth > maxValueWidth && currentLine === '') {
          lines.push(word);
          currentLine = '';
        } else {
          if (currentLine !== '' || currentLine === '' && j > 0) {
            currentLine += prefix;
          }
          currentLine += testWordToAdd;
        }
      }
    }
    if (currentLine) {
      lines.push(currentLine);
    }
    return lines.map(function (line) {
      return line.trim().replace(/^,/, '').trim();
    });
  }, [maxValueWidth]);
  return /*#__PURE__*/React$1.createElement(Wrapper$19, {
    dw: dw,
    dh: dh
  }, /*#__PURE__*/React$1.createElement(MainBlock$11, null, /*#__PURE__*/React$1.createElement(TextUrl$V, null, /*#__PURE__*/React$1.createElement("span", null, url)), /*#__PURE__*/React$1.createElement(SizeBlock, null, isTwoPlus ? correctName : name, isTwoPlus && /*#__PURE__*/React$1.createElement("span", null, twoPlus)), /*#__PURE__*/React$1.createElement(MainTextBlock$1, null, /*#__PURE__*/React$1.createElement(RowWrapper, {
    ref: wrapperRef
  }, customFields.map(function (item, index) {
    var typeField = item.typeField,
      name = item.name,
      data = item.data;
    var lines = data.length > 0 ? splitWordsIntoLines(data) : [];
    return lines.map(function (line, i) {
      return typeField === 'delivery_type' ? /*#__PURE__*/React$1.createElement(Row$2, {
        key: index + "-" + i
      }, /*#__PURE__*/React$1.createElement(TitleCell, {
        fullWidth: true
      }, line)) : /*#__PURE__*/React$1.createElement(Row$2, {
        key: index + "-" + i
      }, i === 0 ? /*#__PURE__*/React$1.createElement(TitleCell, null, name) : /*#__PURE__*/React$1.createElement(EmptyCell, null), /*#__PURE__*/React$1.createElement(ValueCell, null, line));
    });
  }))), /*#__PURE__*/React$1.createElement(SubtitleBlock, {
    isShortDash: subTitleFontSize === 12 && (subTitle === null || subTitle === void 0 ? void 0 : subTitle.length) >= 30
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("div", {
    className: "text"
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    style: {
      textWrap: subTitleFontSize === 12 ? 'wrap' : 'nowrap'
    },
    text: subTitle,
    fontSizeMax: subTitleFontSize === 12 ? 12 : 19,
    fontSizeMin: 12,
    setWidthsAndFontSize: function setWidthsAndFontSize(data) {
      return setSubTitleFontSize(data === null || data === void 0 ? void 0 : data.newFontSize);
    }
  })), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  }))));
};

var components$i = {
  ServiceCardA5: ServiceCardA5
};
var ServiceCard = function ServiceCard(props) {
  var _templateDataComputed;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components$i[templateType], {
    url: templateDataComputed && templateDataComputed.link || 'gallllery.com',
    image: image,
    customFields: templateDataComputed && templateDataComputed.customFields || '',
    name: templateDataComputed && templateDataComputed.title && templateDataComputed.title.toString() || '',
    dw: dw,
    dh: dh,
    subTitle: templateDataComputed === null || templateDataComputed === void 0 ? void 0 : (_templateDataComputed = templateDataComputed.subTitle) === null || _templateDataComputed === void 0 ? void 0 : _templateDataComputed.toString()
  });
};

var components$j = {
  ServiceCardA5: ServiceCardA5
};
var ServiceCardPrint = function ServiceCardPrint(props) {
  var _data$subTitle;
  var data = props.data,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$j[templateType], {
    url: data && data.link || 'gallllery.com',
    description: data && data.description || '',
    name: data && data.title && data.title.toString() || '',
    dw: dw,
    dh: dh,
    subTitle: data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : _data$subTitle.toString()
  });
};

// A type of promise-like that resolves synchronously and supports only one observer

const _iteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.iterator || (Symbol.iterator = Symbol("Symbol.iterator"))) : "@@iterator";

const _asyncIteratorSymbol = /*#__PURE__*/ typeof Symbol !== "undefined" ? (Symbol.asyncIterator || (Symbol.asyncIterator = Symbol("Symbol.asyncIterator"))) : "@@asyncIterator";

// Asynchronously call a function and send errors to recovery continuation
function _catch(body, recover) {
	try {
		var result = body();
	} catch(e) {
		return recover(e);
	}
	if (result && result.then) {
		return result.then(void 0, recover);
	}
	return result;
}

var useFullPageLoad = function useFullPageLoad() {
  var _useState = useState(false),
    isFullyLoaded = _useState[0],
    setIsFullyLoaded = _useState[1];
  var _useState2 = useState(false),
    imagesLoaded = _useState2[0],
    setImagesLoaded = _useState2[1];
  var _useState3 = useState(false),
    fontsLoaded = _useState3[0],
    setFontsLoaded = _useState3[1];
  var checkImages = useCallback(function () {
    setTimeout(function () {
      var images = document.querySelectorAll('img');
      if (images.length === 0) {
        setImagesLoaded(true);
        return;
      }
      var loadedCount = 0;
      var totalImages = images.length;
      var handleImageLoad = function handleImageLoad() {
        loadedCount++;
        if (loadedCount === totalImages) {
          setImagesLoaded(true);
        }
      };
      images.forEach(function (img) {
        if (img.complete && img.naturalHeight !== 0) {
          handleImageLoad();
        } else {
          img.addEventListener('load', handleImageLoad);
          img.addEventListener('error', handleImageLoad);
        }
      });
    }, 100);
  }, []);
  useEffect(function () {
    checkImages();
  }, [checkImages]);
  useEffect(function () {
    var checkFonts = function checkFonts() {
      try {
        var _temp2 = function () {
          if ('fonts' in document) {
            var _temp = _catch(function () {
              return Promise.resolve(document.fonts.ready).then(function () {
                setFontsLoaded(true);
              });
            }, function (error) {
              console.warn('Ошибка при загрузке шрифтов:', error);
              setFontsLoaded(true);
            });
            if (_temp && _temp.then) return _temp.then(function () {});
          } else {
            setTimeout(function () {
              return setFontsLoaded(true);
            }, 1000);
          }
        }();
        return Promise.resolve(_temp2 && _temp2.then ? _temp2.then(function () {}) : void 0);
      } catch (e) {
        return Promise.reject(e);
      }
    };
    checkFonts();
  }, []);
  useEffect(function () {
    if (imagesLoaded && fontsLoaded && !isFullyLoaded) {
      setIsFullyLoaded(true);
    }
  }, [imagesLoaded, fontsLoaded, isFullyLoaded]);
  return {
    isFullyLoaded: isFullyLoaded,
    loadingStatus: {
      imagesLoaded: imagesLoaded,
      fontsLoaded: fontsLoaded
    }
  };
};

var _templateObject$22, _templateObject2$22;
var ErrorWrapper = styled.div(_templateObject$22 || (_templateObject$22 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n  gap: 8px;\n"])));
var ErrorText = styled.div(_templateObject2$22 || (_templateObject2$22 = _taggedTemplateLiteralLoose(["\n  color: #b6b6b5;\n  text-align: center;\n  font-family: Inter;\n  font-size: 13px;\n  font-style: normal;\n  font-weight: 600;\n  line-height: 16px;\n"])));
var ErrorComponent = function ErrorComponent() {
  return /*#__PURE__*/React$1.createElement(ErrorWrapper, null, /*#__PURE__*/React$1.createElement("svg", {
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React$1.createElement("path", {
    d: "M12.056 2.1001C13.1228 2.10434 14.0777 2.66198 14.6078 3.59424L22.5033 17.4536C23.0356 18.3872 23.0318 19.4978 22.4926 20.4263C21.9563 21.3496 21.0045 21.8998 19.9418 21.8999H19.932L4.04823 21.8472C2.98227 21.8441 2.02769 21.2874 1.49647 20.3569C0.964287 19.4244 0.968122 18.3146 1.50624 17.3862L9.49256 3.57764C10.0278 2.65218 10.9814 2.10012 12.0443 2.1001H12.056ZM12.0443 3.15088C11.3578 3.1509 10.7415 3.50793 10.3949 4.104L2.40858 17.9126C2.06191 18.5131 2.0603 19.2318 2.4037 19.8345C2.74712 20.4348 3.36277 20.7951 4.05116 20.7974L19.9359 20.8491H19.9418C20.6281 20.849 21.2436 20.4932 21.5892 19.897C21.937 19.2975 21.9404 18.5788 21.5971 17.9761L13.7015 4.11572C13.3581 3.5141 12.7398 3.15308 12.0512 3.15088H12.0443ZM11.9994 16.3208C12.402 16.3208 12.7296 16.6496 12.7299 17.0562C12.7299 17.4618 12.4023 17.7905 11.9994 17.7905C11.5977 17.7903 11.2699 17.4616 11.2699 17.0562C11.2702 16.6498 11.5979 16.321 11.9994 16.3208ZM11.9994 8.71436C12.2873 8.71436 12.5219 8.94984 12.5219 9.23975V14.187C12.5218 14.4778 12.2873 14.7124 11.9994 14.7124C11.7118 14.7122 11.4779 14.4779 11.4779 14.187V9.23975C11.4779 8.94974 11.7119 8.71455 11.9994 8.71436Z",
    fill: "#B6B6B5"
  })), /*#__PURE__*/React$1.createElement(ErrorText, null, "\u043E\u0448\u0438\u0431\u043A\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u043A\u0438 \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F"));
};

function formatText$1(text, options) {
  if (options === void 0) {
    options = {};
  }
  if (!text) return '';
  if (Array.isArray(text)) return text.join(',');
  var _options = options,
    _options$newlineAfter = _options.newlineAfterColon,
    newlineAfterColon = _options$newlineAfter === void 0 ? false : _options$newlineAfter;
  return text.split('.').map(function (sentence) {
    return sentence.trim();
  }).filter(Boolean).map(function (sentence) {
    var parts = sentence.split(':');
    if (parts.length > 1) {
      var separator = newlineAfterColon ? ':\n' : ': ';
      return parts[0] + separator + parts.slice(1).map(function (part) {
        return part.trim().charAt(0).toUpperCase() + part.trim().slice(1);
      }).join(separator);
    }
    return sentence;
  }).map(function (sentence) {
    return sentence + '.';
  }).join('\n');
}

var _templateObject$23, _templateObject2$23, _templateObject3$1Y, _templateObject4$1z, _templateObject5$1n, _templateObject6$1l, _templateObject7$1h, _templateObject8$1e, _templateObject9$1b, _templateObject10$w;
var Wrapper$1a = styled.div(_templateObject$23 || (_templateObject$23 = _taggedTemplateLiteralLoose(["\n  width: ", "mm;\n  height: ", "mm;\n  transform: scale(\n    calc(", " / ", "),\n    calc(", " / ", ")\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 0 ", "px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.pageWidth;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.dw;
}, function (props) {
  return props.pageWidth;
}, function (props) {
  return props.dh;
}, function (props) {
  return props.pageHeight;
}, function (props) {
  return props.horizontalPadding;
});
var MainBlock$12 = styled.div(_templateObject2$23 || (_templateObject2$23 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var TextUrl$W = styled.div(_templateObject3$1Y || (_templateObject3$1Y = _taggedTemplateLiteralLoose(["\n  height: ", "%;\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  & > span {\n    font-family: 'Roboto', serif;\n    color: #151514;\n    font-size: 4px;\n    font-style: normal;\n    font-weight: bold;\n    letter-spacing: 0.7px;\n    line-height: 4px;\n    margin: 5px 3px 0 0;\n  }\n"])), function (props) {
  return props.urlHeightPercent;
});
var ImageBlock$12 = styled.div(_templateObject4$1z || (_templateObject4$1z = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n"])));
var ImageInner$13 = styled.div(_templateObject5$1n || (_templateObject5$1n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n\n  img {\n    width: 100%;\n    max-height: 100%;\n    object-fit: contain;\n  }\n"])));
var TextBlock$1a = styled.div(_templateObject6$1l || (_templateObject6$1l = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-end;\n  height: ", "%;\n  width: 100%;\n  padding-bottom: ", "px;\n  padding-top: ", "px;\n"])), function (props) {
  return props.textBottomHeight;
}, function (props) {
  return props.textBottomPadding;
}, function (props) {
  return props.textTopPadding;
});
var TextFirst$V = styled.div(_templateObject7$1h || (_templateObject7$1h = _taggedTemplateLiteralLoose(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  color: #151514;\n  margin-bottom: ", "px;\n\n  span {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-weight: 400;\n    font-size: ", "px;\n    letter-spacing: ", "px;\n  }\n\n  div.dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: ", "px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: ", "px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: ", "px;\n      transform: translate(100%, 0);\n    }\n  }\n"])), function (props) {
  return props.marginBottom;
}, function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.dashWidth;
}, function (props) {
  return props.dashOffset;
}, function (props) {
  return props.dashOffset;
});
var TextSecond$W = styled.div(_templateObject8$1e || (_templateObject8$1e = _taggedTemplateLiteralLoose(["\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  text-align: center;\n  margin-bottom: ", "px;\n  color: var(--Gallllery-Black, #151514);\n  font-family: 'zMr';\n  font-style: normal;\n  font-weight: 500;\n  letter-spacing: ", "px;\n"])), function (props) {
  return props.marginBottom;
}, function (props) {
  return props.letterSpacing;
});
var TextThird$V = styled.div(_templateObject9$1b || (_templateObject9$1b = _taggedTemplateLiteralLoose(["\n  font-family: 'Roboto';\n  text-align: center;\n  font-size: ", "px;\n  letter-spacing: ", "px;\n  line-height: ", "px;\n  font-weight: 400;\n  flex: 1;\n  white-space: pre-wrap;\n  color: #151514 !important;\n  padding: 0 ", "px;\n  width: 100%;\n"])), function (props) {
  return props.fontSize;
}, function (props) {
  return props.letterSpacing;
}, function (props) {
  return props.lineHeight;
}, function (props) {
  return props.horizontalPadding;
});
var TextFourth$3 = styled.div(_templateObject10$w || (_templateObject10$w = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", "px;\n  color: #151514 !important;\n"])), function (props) {
  return props.fontSize;
});
var LuvricZodiacConstructor = function LuvricZodiacConstructor(_ref) {
  var image = _ref.image,
    url = _ref.url,
    title = _ref.title,
    description = _ref.description,
    museum = _ref.museum,
    dw = _ref.dw,
    dh = _ref.dh,
    pageWidth = _ref.pageWidth,
    pageHeight = _ref.pageHeight,
    horizontalPadding = _ref.horizontalPadding,
    urlHeightPercent = _ref.urlHeightPercent,
    textBottomHeight = _ref.textBottomHeight,
    textBottomPadding = _ref.textBottomPadding,
    textTopPadding = _ref.textTopPadding,
    dashWidth = _ref.dashWidth,
    dashOffset = _ref.dashOffset,
    titleFontSize = _ref.titleFontSize,
    titleMarginBottom = _ref.titleMarginBottom,
    titleLetterSpacing = _ref.titleLetterSpacing,
    secondFontMax = _ref.secondFontMax,
    secondMarginBottom = _ref.secondMarginBottom,
    secondLetterSpacing = _ref.secondLetterSpacing,
    thirdFontSize = _ref.thirdFontSize,
    thirdLetterSpacing = _ref.thirdLetterSpacing,
    thirdLineHeight = _ref.thirdLineHeight,
    thirdMarginBottom = _ref.thirdMarginBottom,
    thirdHorizontalPadding = _ref.thirdHorizontalPadding,
    fourthFontSize = _ref.fourthFontSize,
    newlineAfterColon = _ref.newlineAfterColon;
  return /*#__PURE__*/React$1.createElement(Wrapper$1a, {
    dw: dw,
    dh: dh,
    pageWidth: pageWidth,
    pageHeight: pageHeight,
    horizontalPadding: horizontalPadding
  }, /*#__PURE__*/React$1.createElement(MainBlock$12, null, /*#__PURE__*/React$1.createElement(TextUrl$W, {
    urlHeightPercent: urlHeightPercent
  }, /*#__PURE__*/React$1.createElement("span", null)), /*#__PURE__*/React$1.createElement(ImageBlock$12, null, /*#__PURE__*/React$1.createElement(ImageInner$13, null, /*#__PURE__*/React$1.createElement("img", {
    src: image,
    alt: "",
    draggable: false
  }))), /*#__PURE__*/React$1.createElement(TextBlock$1a, {
    textTopPadding: textTopPadding,
    textBottomPadding: textBottomPadding,
    textBottomHeight: textBottomHeight
  }, /*#__PURE__*/React$1.createElement(TextFirst$V, {
    fontSize: titleFontSize,
    marginBottom: titleMarginBottom,
    dashWidth: dashWidth,
    dashOffset: dashOffset,
    letterSpacing: titleLetterSpacing
  }, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", null, museum), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })), /*#__PURE__*/React$1.createElement(TextSecond$W, {
    marginBottom: secondMarginBottom,
    letterSpacing: secondLetterSpacing
  }, /*#__PURE__*/React$1.createElement(AdaptiveText, {
    text: title,
    fontSizeMax: secondFontMax
  })), /*#__PURE__*/React$1.createElement(TextThird$V, {
    fontSize: thirdFontSize,
    letterSpacing: thirdLetterSpacing,
    lineHeight: thirdLineHeight,
    marginBottom: thirdMarginBottom,
    horizontalPadding: thirdHorizontalPadding
  }, formatText$1(description, {
    newlineAfterColon: newlineAfterColon
  })), /*#__PURE__*/React$1.createElement(TextFourth$3, {
    fontSize: fourthFontSize
  }, url))));
};

var LuvricZodiacA1 = function LuvricZodiacA1(props) {
  return /*#__PURE__*/React$1.createElement(LuvricZodiacConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 594,
    pageHeight: 841,
    horizontalPadding: 270,
    urlHeightPercent: 7.9,
    textBottomPadding: 117,
    textTopPadding: 153,
    textBottomHeight: 26.6,
    titleMarginBottom: 78,
    titleFontSize: 48,
    dashWidth: 71,
    dashOffset: -60,
    secondFontMax: 67,
    secondMarginBottom: 69,
    secondLetterSpacing: 0.6,
    thirdFontSize: 30,
    thirdLetterSpacing: 0.7,
    thirdLineHeight: 47,
    thirdMarginBottom: 88,
    fourthFontSize: 15.5
  }));
};

var LuvricZodiacA2 = function LuvricZodiacA2(props) {
  return /*#__PURE__*/React$1.createElement(LuvricZodiacConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 420,
    pageHeight: 594,
    horizontalPadding: 185,
    urlHeightPercent: 7.9,
    textBottomHeight: 26.6,
    textTopPadding: 110,
    textBottomPadding: 79,
    dashWidth: 50,
    dashOffset: -42,
    titleFontSize: 34,
    titleMarginBottom: 55,
    secondFontMax: 47,
    secondMarginBottom: 45,
    secondLetterSpacing: 0.5,
    thirdFontSize: 21,
    thirdLetterSpacing: 0.6,
    thirdLineHeight: 34,
    thirdMarginBottom: 59,
    fourthFontSize: 11
  }));
};

var LuvricZodiacA3 = function LuvricZodiacA3(props) {
  return /*#__PURE__*/React$1.createElement(LuvricZodiacConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 297,
    pageHeight: 420,
    horizontalPadding: 135,
    urlHeightPercent: 7.8,
    textBottomPadding: 57,
    textTopPadding: 79,
    textBottomHeight: 26.6,
    dashWidth: 36,
    dashOffset: -29,
    titleFontSize: 22,
    titleMarginBottom: 42,
    titleLetterSpacing: 0.9,
    secondFontMax: 31,
    secondMarginBottom: 34,
    secondLetterSpacing: 1.2,
    thirdHorizontalPadding: 3,
    thirdLetterSpacing: 0.45,
    thirdFontSize: 14.8,
    thirdLineHeight: 24,
    thirdMarginBottom: 42,
    fourthFontSize: 7
  }));
};

var LuvricZodiacA4 = function LuvricZodiacA4(props) {
  return /*#__PURE__*/React$1.createElement(LuvricZodiacConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 210,
    pageHeight: 297,
    horizontalPadding: 95,
    urlHeightPercent: 7.7,
    textBottomPadding: 34,
    textTopPadding: 48,
    textBottomHeight: 26.6,
    dashWidth: 26,
    dashOffset: -23,
    titleFontSize: 18,
    titleMarginBottom: 30,
    secondFontMax: 24,
    secondMarginBottom: 25,
    secondLetterSpacing: 0.65,
    thirdFontSize: 11.5,
    thirdLetterSpacing: 0.2,
    thirdLineHeight: 18.2,
    thirdMarginBottom: 32,
    fourthFontSize: 6.5
  }));
};

var LuvricZodiacA5 = function LuvricZodiacA5(props) {
  return /*#__PURE__*/React$1.createElement(LuvricZodiacConstructor, _extends({}, props, {
    flowerType: 1,
    pageWidth: 148,
    pageHeight: 210,
    horizontalPadding: 67,
    urlHeightPercent: 7.8,
    textBottomPadding: 27,
    textTopPadding: 34,
    textBottomHeight: 26.8,
    dashWidth: 19,
    dashOffset: -16,
    titleFontSize: 12,
    titleMarginBottom: 21,
    titleLetterSpacing: 0.3,
    secondFontMax: 17,
    secondMarginBottom: 18,
    secondLetterSpacing: 0.5,
    thirdHorizontalPadding: 3,
    thirdFontSize: 8.9,
    thirdLineHeight: 12.8,
    thirdMarginBottom: 20,
    fourthFontSize: 5
  }));
};

var components$k = {
  LuvricZodiacA1: LuvricZodiacA1,
  LuvricZodiacA2: LuvricZodiacA2,
  LuvricZodiacA3: LuvricZodiacA3,
  LuvricZodiacA4: LuvricZodiacA4,
  LuvricZodiacA5: LuvricZodiacA5
};
var LuvricZodiac = function LuvricZodiac(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  var cardNumber = (data === null || data === void 0 ? void 0 : data.number) || '';
  var templateDataComputed = data.templateData || {};
  return React$1.createElement(components$k[templateType], {
    url: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.link) || 'artz.work',
    image: image,
    number: cardNumber,
    customSubtitle: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    description: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.description) || '',
    museum: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.subTitle) || '',
    title: (templateDataComputed === null || templateDataComputed === void 0 ? void 0 : templateDataComputed.title) || '',
    dw: dw,
    dh: dh
  });
};

var components$l = {
  LuvricZodiacA1: LuvricZodiacA1,
  LuvricZodiacA2: LuvricZodiacA2,
  LuvricZodiacA3: LuvricZodiacA3,
  LuvricZodiacA4: LuvricZodiacA4,
  LuvricZodiacA5: LuvricZodiacA5
};
var LuvricZodiacPrint = function LuvricZodiacPrint(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$l[templateType], {
    url: (data === null || data === void 0 ? void 0 : data.link) || 'artz.work',
    image: image,
    number: (data === null || data === void 0 ? void 0 : data.number) || '',
    customSubtitle: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    description: (data === null || data === void 0 ? void 0 : data.description) || '',
    museum: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    title: (data === null || data === void 0 ? void 0 : data.title) || '',
    dw: dw,
    dh: dh
  });
};

var components$m = {
  WarholStyleCard: WarholStyleCard,
  WarholStyle2Card: WarholStyle2Card,
  WarholStyle3Card: WarholStyle3Card,
  WarholStyle4Card: WarholStyle4Card,
  ClassicStyle3Card: ClassicStyle3Card,
  VotingCoverCard: VotingCoverCard,
  LuvrikStyleCard: LuvrikStyleCard,
  ProductCard: ProductCard,
  TimelineStyleCard: TimelineStyleCard,
  Calendar: Calendar,
  AccountCard: AccountCard,
  ShipsStyleCard: ShipsStyleCard,
  FlowersStyleCard: FlowersStyleCard,
  CalendarModern: CalendarModern,
  CalendarPreview: CalendarPreview,
  CalendarFreePreview: CalendarFreePreview,
  WarholStyle2WithQrCard: WarholStyle2WithQrCard,
  PosterCard: PosterCard,
  FamilyMuseum: FamilyMuseum,
  FlowerHoroscopeCard: FlowerHoroscopeCard,
  ServiceCard: ServiceCard,
  LuvricZodiac: LuvricZodiac
};
var MasterCard = function MasterCard(props) {
  var sanitizedProps = _deepRemoveEmojis(props);
  var _sanitizedProps$templ = sanitizedProps.templateType,
    templateType = _sanitizedProps$templ === void 0 ? '' : _sanitizedProps$templ;
  var _useFullPageLoad = useFullPageLoad(),
    isFullyLoaded = _useFullPageLoad.isFullyLoaded;
  var localTemplateName = templateType.replace('warhol1', 'warhol').replace('warhol', 'WarholCard');
  var templateComponent = components$m.WarholStyleCard;
  if (localTemplateName.startsWith('WarholCardA')) {
    templateComponent = components$m.WarholStyleCard;
  }
  if (localTemplateName.startsWith('WarholA')) {
    templateComponent = components$m.WarholStyleCard;
  }
  if (localTemplateName.startsWith('WarholCard2A')) {
    templateComponent = components$m.WarholStyle2Card;
  }
  if (localTemplateName.startsWith('WarholCard3A')) {
    templateComponent = components$m.WarholStyle3Card;
  }
  if (localTemplateName.startsWith('WarholCard4A')) {
    templateComponent = components$m.WarholStyle4Card;
  }
  if (localTemplateName.startsWith('ClassicCard3A')) {
    templateComponent = components$m.ClassicStyle3Card;
  }
  if (localTemplateName.startsWith('LuvrikCardA')) {
    templateComponent = components$m.LuvrikStyleCard;
  }
  if (localTemplateName.startsWith('ClassicA')) {
    templateComponent = components$m.LuvrikStyleCard;
  }
  if (localTemplateName.startsWith('ClassicCardA')) {
    templateComponent = components$m.LuvrikStyleCard;
  }
  if (localTemplateName.startsWith('ProductCard')) {
    templateComponent = components$m.ProductCard;
  }
  if (localTemplateName.startsWith('TimelineCard')) {
    templateComponent = components$m.TimelineStyleCard;
  }
  if (localTemplateName.startsWith('Calendar')) {
    templateComponent = components$m.Calendar;
  }
  if (localTemplateName.startsWith('CalendarModern')) {
    templateComponent = components$m.CalendarModern;
  }
  if (localTemplateName.startsWith('CalendarPreview')) {
    templateComponent = components$m.CalendarPreview;
  }
  if (localTemplateName.startsWith('CalendarFreePreview')) {
    templateComponent = components$m.CalendarFreePreview;
  }
  if (localTemplateName.startsWith('VotingCoverCard')) {
    templateComponent = components$m.VotingCoverCard;
  }
  if (localTemplateName.startsWith('AccountCard')) {
    templateComponent = components$m.AccountCard;
  }
  if (localTemplateName.startsWith('ShipsCard')) {
    templateComponent = components$m.ShipsStyleCard;
  }
  if (localTemplateName.startsWith('FlowersCard')) {
    templateComponent = components$m.FlowersStyleCard;
  }
  if (localTemplateName.startsWith('WarholCard2WithQr')) {
    templateComponent = components$m.WarholStyle2WithQrCard;
  }
  if (localTemplateName.startsWith('PosterCard')) {
    templateComponent = components$m.PosterCard;
  }
  if (localTemplateName.startsWith('FamilyMuseum')) {
    templateComponent = components$m.FamilyMuseum;
  }
  if (localTemplateName.startsWith('FlowerHoroscope')) {
    templateComponent = components$m.FlowerHoroscopeCard;
  }
  if (localTemplateName.startsWith('ServiceCard')) {
    templateComponent = components$m.ServiceCard;
  }
  if (localTemplateName.startsWith('LuvricZodiac')) {
    templateComponent = components$m.LuvricZodiac;
  }
  return /*#__PURE__*/React$1.createElement(ErrorBoundary, {
    fallback: /*#__PURE__*/React$1.createElement(ErrorComponent, null)
  }, React$1.createElement(templateComponent, _extends({}, sanitizedProps, {
    style: _extends({
      backgroundColor: '#ffffff'
    }, sanitizedProps === null || sanitizedProps === void 0 ? void 0 : sanitizedProps.style),
    templateType: localTemplateName
  })), isFullyLoaded && /*#__PURE__*/React$1.createElement("div", {
    id: "IsFullyLoaded",
    style: {
      width: 0,
      height: 0
    }
  }));
};

var components$n = {
  WarholCardA5L: WarholCardA5L,
  WarholCardA5: WarholCardA5,
  WarholCardA4L: WarholCardA4L,
  WarholCardA4: WarholCardA4,
  WarholCardA3L: WarholCardA3L,
  WarholCardA3: WarholCardA3,
  WarholCardA2L: WarholCardA2L,
  WarholCardA2: WarholCardA2,
  WarholCardA1L: WarholCardA1L,
  WarholCardA1: WarholCardA1,
  WarholCardA0L: WarholCardA0L,
  WarholCardA0: WarholCardA0
};
var WarholStyleCardPrint = function WarholStyleCardPrint(props) {
  var _data$subTitle, _data$description;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  return React$1.createElement(components$n[templateType], {
    url: data && data.link || 'gallllery.com',
    image: image,
    number: data && data.number,
    museum: data && data.description || '',
    name: data && data.title && data.title.toString() || '',
    dw: dw,
    dh: dh,
    customSubtitle: (data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : _data$subTitle.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : _data$description.toString())
  });
};

var components$o = {
  WarholCard2A5L: WarholCard2A5L,
  WarholCard2A5: WarholCard2A5,
  WarholCard2A4L: WarholCard2A4L,
  WarholCard2A4: WarholCard2A4,
  WarholCard2A4Product: WarholCard2A4Product,
  WarholCard2A3L: WarholCard2A3L,
  WarholCard2A3: WarholCard2A3,
  WarholCard2A2L: WarholCard2A2L,
  WarholCard2A2: WarholCard2A2,
  WarholCard2A1L: WarholCard2A1L,
  WarholCard2A1: WarholCard2A1,
  WarholCard2A0L: WarholCard2A0L,
  WarholCard2A0: WarholCard2A0,
  WarholCard2A0Plus: WarholCard2A0Plus
};
var WarholStyle2CardPrint = function WarholStyle2CardPrint(props) {
  var _data$subTitle, _data$description;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  return React$1.createElement(components$o[templateType], {
    url: data && data.link || 'gallllery.com',
    image: image,
    number: data && data.number,
    museum: data && data.description || '',
    name: data && data.title && data.title.toString() || '',
    dw: dw,
    dh: dh,
    customSubtitle: (data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : _data$subTitle.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : _data$description.toString())
  });
};

var components$p = {
  WarholCard3A5L: WarholCard3A5L,
  WarholCard3A5: WarholCard3A5,
  WarholCard3A4L: WarholCard3A4L,
  WarholCard3A4: WarholCard3A4,
  WarholCard3A3L: WarholCard3A3L,
  WarholCard3A3: WarholCard3A3,
  WarholCard3A2L: WarholCard3A2L,
  WarholCard3A2: WarholCard3A2,
  WarholCard3A1L: WarholCard3A1L,
  WarholCard3A1: WarholCard3A1,
  WarholCard3A0L: WarholCard3A0L,
  WarholCard3A0: WarholCard3A0,
  WarholCard3A0Plus: WarholCard3A0Plus
};
var WarholStyle3CardPrint = function WarholStyle3CardPrint(props) {
  var _data$subTitle, _data$description;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh,
    customSubtitle = props.customSubtitle;
  return React$1.createElement(components$p[templateType], {
    url: data && data.link || 'gallllery.com',
    image: image,
    number: data && data.number,
    museum: data && data.description || '',
    name: data && data.title && data.title.length && data.title.toString() || '',
    dw: dw,
    dh: dh,
    customSubtitle: (data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : _data$subTitle.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : _data$description.toString())
  });
};

var components$q = {
  WarholCard4A5L: WarholCard4A5L,
  WarholCard4A4L: WarholCard4A4L,
  WarholCard4A3L: WarholCard4A3L,
  WarholCard4A2L: WarholCard4A2L,
  WarholCard4A1L: WarholCard4A1L,
  WarholCard4A0L: WarholCard4A0L
};
var WarholStyle4CardPrint = function WarholStyle4CardPrint(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  if (!components$q[templateType]) {
    return 'Такого шаблона нет';
  }
  return React$1.createElement(components$q[templateType], {
    url: data && data.link || 'gallllery.com',
    image: image,
    number: data && data.number,
    museum: data && data.description || '',
    name: data && data.title && data.title.lenght && data.title.toString() || '',
    dw: dw,
    dh: dh
  });
};

var components$r = {
  ClassicCard3A0: ClassicCard3A0,
  ClassicCard3A1: ClassicCard3A1,
  ClassicCard3A2: ClassicCard3A2,
  ClassicCard3A3: ClassicCard3A3,
  ClassicCard3A4: ClassicCard3A4,
  ClassicCard3A5: ClassicCard3A5
};
var ClassicStyle3CardPrint = function ClassicStyle3CardPrint(props) {
  var templateType = props.templateType;
  if (!components$r[templateType]) {
    return 'Такого шаблона нет, ';
  }
  return 'Шаблон в разработке.';
};

var components$s = {
  LuvrikCardA5L: LuvrikCardA5L,
  LuvrikCardA5: LuvrikCardA5,
  LuvrikCardA4L: LuvrikCardA4L,
  LuvrikCardA4: LuvrikCardA4,
  LuvrikCardA3L: LuvrikCardA3L,
  LuvrikCardA3: LuvrikCardA3,
  LuvrikCardA2L: LuvrikCardA2L,
  LuvrikCardA2: LuvrikCardA2,
  LuvrikCardA1L: LuvrikCardA1L,
  LuvrikCardA1: LuvrikCardA1,
  LuvrikCardA0L: LuvrikCardA0L,
  LuvrikCardA0: LuvrikCardA0,
  ClassicA5L: LuvrikCardA5L,
  ClassicA5: LuvrikCardA5,
  ClassicA4L: LuvrikCardA4L,
  ClassicA4: LuvrikCardA4,
  ClassicA3L: LuvrikCardA3L,
  ClassicA3: LuvrikCardA3,
  ClassicA2L: LuvrikCardA2L,
  ClassicA2: LuvrikCardA2,
  ClassicA1L: LuvrikCardA1L,
  ClassicA1: LuvrikCardA1,
  ClassicA0L: LuvrikCardA0L,
  ClassicA0: LuvrikCardA0
};
var LuvrikStyleCardPrint = function LuvrikStyleCardPrint(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$s[templateType], {
    url: data && data.link || 'ze.land',
    image: image,
    country: data && data.subTitle,
    number: data && data.number,
    museum: data && data.title,
    name: data && data.description,
    dw: dw,
    dh: dh
  });
};

var components$t = {
  PosterCardA0Plus: PosterCardA0Plus,
  PosterCardA0: PosterCardA0,
  PosterCardA1: PosterCardA1,
  PosterCardA2: PosterCardA2,
  PosterCardA3: PosterCardA3,
  PosterCardA4: PosterCardA4,
  PosterCardA5: PosterCardA5
};
var PosterCardPrint = function PosterCardPrint(_ref) {
  var _data$subTitle, _data$description;
  var data = _ref.data,
    image = _ref.image,
    templateType = _ref.templateType,
    dw = _ref.dw,
    dh = _ref.dh,
    customSubtitle = _ref.customSubtitle;
  return React$1.createElement(components$t[templateType], {
    url: (data === null || data === void 0 ? void 0 : data.link) || 'gallllery.com',
    image: image,
    number: (data === null || data === void 0 ? void 0 : data.number) || '',
    museum: (data === null || data === void 0 ? void 0 : data.title) || '',
    dw: dw,
    dh: dh,
    description: (data === null || data === void 0 ? void 0 : (_data$subTitle = data.subTitle) === null || _data$subTitle === void 0 ? void 0 : _data$subTitle.toString()) || (customSubtitle === null || customSubtitle === void 0 ? void 0 : customSubtitle.toString()) || (data === null || data === void 0 ? void 0 : (_data$description = data.description) === null || _data$description === void 0 ? void 0 : _data$description.toString())
  });
};

var components$u = {
  FamilyMuseumA0Plus: FamilyMuseumA0Plus,
  FamilyMuseumWithNumberA0Plus: FamilyMuseumWithNumberA0Plus,
  FamilyMuseumA0: FamilyMuseumA0,
  FamilyMuseumWithNumberA0: FamilyMuseumWithNumberA0,
  FamilyMuseumA0L: FamilyMuseumA0L,
  FamilyMuseumWithNumberA0L: FamilyMuseumWithNumberA0L,
  FamilyMuseumA1: FamilyMuseumA1,
  FamilyMuseumWithNumberA1: FamilyMuseumWithNumberA1,
  FamilyMuseumA1L: FamilyMuseumA1L,
  FamilyMuseumWithNumberA1L: FamilyMuseumWithNumberA1L,
  FamilyMuseumA2: FamilyMuseumA2,
  FamilyMuseumWithNumberA2: FamilyMuseumWithNumberA2,
  FamilyMuseumA2L: FamilyMuseumA2L,
  FamilyMuseumWithNumberA2L: FamilyMuseumWithNumberA2L,
  FamilyMuseumA3: FamilyMuseumA3,
  FamilyMuseumWithNumberA3: FamilyMuseumWithNumberA3,
  FamilyMuseumA3L: FamilyMuseumA3L,
  FamilyMuseumWithNumberA3L: FamilyMuseumWithNumberA3L,
  FamilyMuseumA4: FamilyMuseumA4,
  FamilyMuseumWithNumberA4: FamilyMuseumWithNumberA4,
  FamilyMuseumA4L: FamilyMuseumA4L,
  FamilyMuseumWithNumberA4L: FamilyMuseumWithNumberA4L,
  FamilyMuseumA5: FamilyMuseumA5,
  FamilyMuseumWithNumberA5: FamilyMuseumWithNumberA5,
  FamilyMuseumA5L: FamilyMuseumA5L,
  FamilyMuseumWithNumberA5L: FamilyMuseumWithNumberA5L
};
var FamilyMuseumPrint = function FamilyMuseumPrint(props) {
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    dw = props.dw,
    dh = props.dh;
  return React$1.createElement(components$u[templateType], {
    url: (data === null || data === void 0 ? void 0 : data.link) || 'kiiids.art',
    image: image,
    number: (data === null || data === void 0 ? void 0 : data.number) || '',
    customSubtitle: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    name: (data === null || data === void 0 ? void 0 : data.title) || '',
    description: (data === null || data === void 0 ? void 0 : data.description) || '',
    dw: dw,
    dh: dh
  });
};

var components$v = {
  FlowerHoroscopeCardA1: FlowerHoroscopeCardA1,
  FlowerHoroscopeSqCardA1: FlowerHoroscopeSqCardA1,
  FlowerHoroscopeCardA2: FlowerHoroscopeCardA2,
  FlowerHoroscopeSqCardA2: FlowerHoroscopeSqCardA2,
  FlowerHoroscopeCardA3: FlowerHoroscopeCardA3,
  FlowerHoroscopeSqCardA3: FlowerHoroscopeSqCardA3,
  FlowerHoroscopeCardA4: FlowerHoroscopeCardA4,
  FlowerHoroscopeSqCardA4: FlowerHoroscopeSqCardA4,
  FlowerHoroscopeCardA5: FlowerHoroscopeCardA5,
  FlowerHoroscopeSqCardA5: FlowerHoroscopeSqCardA5,
  FlowerHoroscope2CardA1: FlowerHoroscope2CardA1,
  FlowerHoroscope2SqCardA1: FlowerHoroscope2SqCardA1,
  FlowerHoroscope2CardA2: FlowerHoroscope2CardA2,
  FlowerHoroscope2SqCardA2: FlowerHoroscope2SqCardA2,
  FlowerHoroscope2CardA3: FlowerHoroscope2CardA3,
  FlowerHoroscope2SqCardA3: FlowerHoroscope2SqCardA3,
  FlowerHoroscope2CardA4: FlowerHoroscope2CardA4,
  FlowerHoroscope2SqCardA4: FlowerHoroscope2SqCardA4,
  FlowerHoroscope2CardA5: FlowerHoroscope2CardA5,
  FlowerHoroscope2SqCardA5: FlowerHoroscope2SqCardA5,
  FlowerHoroscope3CardA1: FlowerHoroscope3CardA1,
  FlowerHoroscope3SqCardA1: FlowerHoroscope3SqCardA1,
  FlowerHoroscope3CardA2: FlowerHoroscope3CardA2,
  FlowerHoroscope3SqCardA2: FlowerHoroscope3SqCardA2,
  FlowerHoroscope3CardA3: FlowerHoroscope3CardA3,
  FlowerHoroscope3SqCardA3: FlowerHoroscope3SqCardA3,
  FlowerHoroscope3CardA4: FlowerHoroscope3CardA4,
  FlowerHoroscope3SqCardA4: FlowerHoroscope3SqCardA4,
  FlowerHoroscope3CardA5: FlowerHoroscope3CardA5,
  FlowerHoroscope3SqCardA5: FlowerHoroscope3SqCardA5
};
var FlowerHoroscopeCardPrint = function FlowerHoroscopeCardPrint(props) {
  var _ref;
  var data = props.data,
    image = props.image,
    templateType = props.templateType,
    useRegularFieldsProp = props.useRegularFields,
    dw = props.dw,
    dh = props.dh;
  var useRegularFieldsResolved = (_ref = useRegularFieldsProp != null ? useRegularFieldsProp : data && data.useRegularFields) != null ? _ref : false;
  return React$1.createElement(components$v[templateType], {
    url: (data === null || data === void 0 ? void 0 : data.link) || 'artz.work',
    image: image,
    number: (data === null || data === void 0 ? void 0 : data.number) || '',
    customSubtitle: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    description: (data === null || data === void 0 ? void 0 : data.description) || '',
    museum: (data === null || data === void 0 ? void 0 : data.subTitle) || '',
    name: (data === null || data === void 0 ? void 0 : data.title) || '',
    useRegularFields: useRegularFieldsResolved,
    dw: dw,
    dh: dh
  });
};

var components$w = {
  WarholStyleCardPrint: WarholStyleCardPrint,
  WarholStyle2CardPrint: WarholStyle2CardPrint,
  WarholStyle3CardPrint: WarholStyle3CardPrint,
  WarholStyle4CardPrint: WarholStyle4CardPrint,
  ClassicStyle3CardPrint: ClassicStyle3CardPrint,
  LuvrikStyleCardPrint: LuvrikStyleCardPrint,
  ShipsStyleCardPrint: ShipsStyleCardPrint,
  FlowersStyleCardPrint: FlowersStyleCardPrint,
  WarholStyle2WithQrCardPrint: WarholStyle2WithQrCardPrint,
  PosterCardPrint: PosterCardPrint,
  FamilyMuseumPrint: FamilyMuseumPrint,
  FlowerHoroscopeCardPrint: FlowerHoroscopeCardPrint,
  ServiceCardPrint: ServiceCardPrint,
  LuvricZodiacPrint: LuvricZodiacPrint
};
var MasterCardPrint = function MasterCardPrint(props) {
  var sanitizedProps = _deepRemoveEmojis(props);
  var _sanitizedProps$templ = sanitizedProps.templateType,
    templateType = _sanitizedProps$templ === void 0 ? '' : _sanitizedProps$templ;
  var _useFullPageLoad = useFullPageLoad(),
    isFullyLoaded = _useFullPageLoad.isFullyLoaded;
  var localTemplateName = templateType.replace('warhol1', 'warhol').replace('warhol', 'WarholCard');
  var templateComponent = components$w.WarholStyleCardPrint;
  if (localTemplateName.startsWith('WarholCardA')) {
    templateComponent = components$w.WarholStyleCardPrint;
  }
  if (localTemplateName.startsWith('WarholA')) {
    templateComponent = components$w.WarholStyleCardPrint;
  }
  if (localTemplateName.startsWith('WarholCard2A')) {
    templateComponent = components$w.WarholStyle2CardPrint;
  }
  if (localTemplateName.startsWith('WarholCard3A')) {
    templateComponent = components$w.WarholStyle3CardPrint;
  }
  if (localTemplateName.startsWith('WarholCard4A')) {
    templateComponent = components$w.WarholStyle4CardPrint;
  }
  if (localTemplateName.startsWith('ClassicCard3A')) {
    templateComponent = components$w.ClassicStyle3CardPrint;
  }
  if (localTemplateName.startsWith('LuvrikCardA')) {
    templateComponent = components$w.LuvrikStyleCardPrint;
  }
  if (localTemplateName.startsWith('ClassicA')) {
    templateComponent = components$w.LuvrikStyleCardPrint;
  }
  if (localTemplateName.startsWith('ClassicCardA')) {
    templateComponent = components$w.LuvrikStyleCardPrint;
  }
  if (localTemplateName.startsWith('ClassicCardA')) {
    templateComponent = components$w.LuvrikStyleCardPrint;
  }
  if (localTemplateName.startsWith('ShipsCard')) {
    templateComponent = components$w.ShipsStyleCardPrint;
  }
  if (localTemplateName.startsWith('FlowersCard')) {
    templateComponent = components$w.FlowersStyleCardPrint;
  }
  if (localTemplateName.startsWith('WarholCard2WithQr')) {
    templateComponent = components$w.WarholStyle2WithQrCardPrint;
  }
  if (localTemplateName.startsWith('PosterCard')) {
    templateComponent = components$w.PosterCardPrint;
  }
  if (localTemplateName.startsWith('FamilyMuseum')) {
    templateComponent = components$w.FamilyMuseumPrint;
  }
  if (localTemplateName.startsWith('FlowerHoroscope')) {
    templateComponent = components$w.FlowerHoroscopeCardPrint;
  }
  if (localTemplateName.startsWith('ServiceCard')) {
    templateComponent = components$w.ServiceCardPrint;
  }
  if (localTemplateName.startsWith('LuvricZodiac')) {
    templateComponent = components$w.LuvricZodiacPrint;
  }
  return /*#__PURE__*/React$1.createElement(Fragment$1, null, React$1.createElement(templateComponent, _extends({}, sanitizedProps, {
    style: _extends({
      backgroundColor: '#ffffff'
    }, sanitizedProps === null || sanitizedProps === void 0 ? void 0 : sanitizedProps.style),
    templateType: localTemplateName
  })), isFullyLoaded && /*#__PURE__*/React$1.createElement("div", {
    id: "IsFullyLoaded",
    style: {
      width: 0,
      height: 0
    }
  }));
};

var ExampleComponent = function ExampleComponent(_ref) {
  var text = _ref.text;
  return /*#__PURE__*/React.createElement("div", {
    className: 'test'
  }, "Example Component: ", text);
};

var getAnimalsData = function getAnimalsData(_ref) {
  var services = _ref.services,
    endpoint = _ref.endpoint;
  var animalsItems = Boolean(services === null || services === void 0 ? void 0 : services.length) && services.filter(function (item) {
    return item.type === 'animals';
  });
  var animalItems = animalsItems && animalsItems.length && animalsItems[0].containers || [];
  var animals = animalItems.map(function (item) {
    return {
      animalImage: "" + ((endpoint ? endpoint + '/' : '') + item.attachments[0].files[0].url),
      animalName: item.attachments[0].texts
    };
  });
  return animals;
};

var MAX_LENGTH_IN_SMALL_LINE = 22;
var MAX_LENGTH_IN_LINE = 17;

var useGetTextBlockHeight = function useGetTextBlockHeight(text) {
  var ref = useRef(null);
  var _useState = useState(null),
    height = _useState[0],
    setHeight = _useState[1];
  useEffect(function () {
    if (!ref.current) return;
    var updateHeight = function updateHeight() {
      if (ref.current) {
        setHeight(ref.current.scrollHeight - 5);
      }
    };
    var resizeObserver = new ResizeObserver(updateHeight);
    resizeObserver.observe(ref.current);
    var mutationObserver = new MutationObserver(updateHeight);
    mutationObserver.observe(ref.current, {
      childList: true,
      subtree: true,
      characterData: true
    });
    return function () {
      resizeObserver.disconnect();
      mutationObserver.disconnect();
    };
  }, [text]);
  return {
    height: height,
    ref: ref
  };
};

var useFormattedText = function useFormattedText(text, maxLength) {
  var _useState = useState(''),
    formattedText = _useState[0],
    setFormattedText = _useState[1];
  useEffect(function () {
    if (!text) return;
    var words = text.split(' ');
    var currentLine = '';
    var result = '';
    words.forEach(function (word) {
      if ((currentLine + ' ' + word).trim().length > maxLength) {
        result += currentLine.trim() + '\n';
        currentLine = word;
      } else {
        currentLine += ' ' + word;
      }
    });
    result += currentLine.trim();
    setFormattedText(result);
  }, [text, maxLength]);
  return formattedText;
};

var _templateObject$24, _templateObject2$24, _templateObject3$1Z, _templateObject4$1A, _templateObject5$1o, _templateObject6$1m, _templateObject7$1i, _templateObject8$1f, _templateObject9$1c, _templateObject10$x, _templateObject11$t, _templateObject12$q, _templateObject13$q, _templateObject14$k, _templateObject15$8, _templateObject16$1, _templateObject17$1, _templateObject18, _templateObject19, _templateObject20, _templateObject21, _templateObject22, _templateObject23, _templateObject24, _templateObject25, _templateObject26, _templateObject27, _templateObject28, _templateObject29, _templateObject30, _templateObject31, _templateObject32, _templateObject33, _templateObject34, _templateObject35, _templateObject36, _templateObject37, _templateObject38, _templateObject39;
var Card = styled.div(_templateObject$24 || (_templateObject$24 = _taggedTemplateLiteralLoose(["\n  height: 297mm;\n  width: 210mm;\n  transform: scale(\n    calc(", " / 210),\n    calc(", " / 297)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 34px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var BorderContainer = styled.div(_templateObject2$24 || (_templateObject2$24 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 2px solid #000;\n  padding: 2px;\n"])));
var ContentContainer = styled.div(_templateObject3$1Z || (_templateObject3$1Z = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid #000;\n  display: flex;\n  flex-direction: column;\n"])));
var HeaderBlock = styled.div(_templateObject4$1A || (_templateObject4$1A = _taggedTemplateLiteralLoose(["\n  height: 12.4%;\n  display: flex;\n"])));
var NumberAndGiftBlock = styled.div(_templateObject5$1o || (_templateObject5$1o = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"])));
var NumberBlock$5 = styled.div(_templateObject6$1m || (_templateObject6$1m = _taggedTemplateLiteralLoose(["\n  position: relative;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .num-text {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: 37.5px;\n    letter-spacing: 8.3px;\n    text-indent: 5px;\n  }\n\n  .dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 42px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: 102px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: 102px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var GiftBlock = styled.div(_templateObject7$1i || (_templateObject7$1i = _taggedTemplateLiteralLoose(["\n  height: 25%;\n  border-top: 1px solid #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n"])));
var QrBlock$6 = styled.div(_templateObject8$1f || (_templateObject8$1f = _taggedTemplateLiteralLoose(["\n  width: 18.5%;\n  height: 100%;\n  border-left: 1px solid #000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var QrImageContainer = styled.div(_templateObject9$1c || (_templateObject9$1c = _taggedTemplateLiteralLoose(["\n  height: 74%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n"])));
var QrImage = styled.img(_templateObject10$x || (_templateObject10$x = _taggedTemplateLiteralLoose(["\n  width: 58%;\n"])));
var QrTextContainer = styled.div(_templateObject11$t || (_templateObject11$t = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 24%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var QrText = styled.span(_templateObject12$q || (_templateObject12$q = _taggedTemplateLiteralLoose(["\n  font-family: 'noto';\n  font-size: 10.5px;\n  line-height: 12px;\n"])));
var MapBlock$5 = styled.div(_templateObject13$q || (_templateObject13$q = _taggedTemplateLiteralLoose(["\n  position: relative;\n  height: 51.5%;\n  border-top: 2px solid #000;\n  border-bottom: 2px solid #000;\n"])));
var MapImage = styled.img(_templateObject14$k || (_templateObject14$k = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  object-fit: cover;\n"])));
var MapSvgBlock$5 = styled.div(_templateObject15$8 || (_templateObject15$8 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  z-index: 10;\n  position: absolute;\n  left: 0;\n  top: 0;\n"])));
var MapSvgImage$5 = styled.div(_templateObject16$1 || (_templateObject16$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"])));
var CountryInfoBlock = styled.div(_templateObject17$1 || (_templateObject17$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 36.1%;\n  display: flex;\n"])));
var MainInfo = styled.div(_templateObject18 || (_templateObject18 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 33.3%;\n  height: 100%;\n  padding-top: 16px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-right: 2px solid #000;\n  overflow: hidden;\n"])));
var EmblemBlock = styled.div(_templateObject19 || (_templateObject19 = _taggedTemplateLiteralLoose(["\n  height: 42.3%;\n  width: 100%;\n"])));
var EmblemImage = styled.img(_templateObject20 || (_templateObject20 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n"])));
var MainInfoContent = styled.div(_templateObject21 || (_templateObject21 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 230px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n"])));
var Country = styled.div(_templateObject22 || (_templateObject22 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  font-family: 'Corki-Tuscan';\n  font-size: 15.5px;\n  line-height: 14px;\n  padding: 0 14px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Territory = styled.div(_templateObject23 || (_templateObject23 = _taggedTemplateLiteralLoose(["\n  height: ", ";\n  width: 100%;\n  padding: ", ";\n  font-family: 'Lehmann Egyptian';\n  font-weight: bold;\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: 0.45px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n"])), function (_ref) {
  var height = _ref.height;
  return height ? height + "px" : 'auto';
}, function (_ref2) {
  var withSmallText = _ref2.withSmallText;
  return !withSmallText ? "0 14px" : '0 19px';
}, function (_ref3) {
  var withSmallText = _ref3.withSmallText;
  return withSmallText ? '20.3pt' : '26.2pt';
}, function (_ref4) {
  var withSmallText = _ref4.withSmallText;
  return withSmallText ? '28px' : '36px';
});
var LastBlock = styled.div(_templateObject24 || (_templateObject24 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 2px;\n  font-family: 'Corki-Tuscan';\n  font-size: 15.5px;\n  line-height: 14px;\n  letter-spacing: 0.25px;\n"])));
var Capital = styled.div(_templateObject25 || (_templateObject25 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));
var Divider$1 = styled.div(_templateObject26 || (_templateObject26 = _taggedTemplateLiteralLoose(["\n  border-top: 1px solid #000;\n  width: 30px;\n"])));
var AreaSize = styled.div(_templateObject27 || (_templateObject27 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));
var OtherInfo = styled.div(_templateObject28 || (_templateObject28 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"])));
var ClimateAnimalBlock = styled.div(_templateObject29 || (_templateObject29 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 53.4%;\n  border-bottom: 2px solid #000;\n  display: flex;\n"])));
var InfoBlockHeader = styled.div(_templateObject30 || (_templateObject30 = _taggedTemplateLiteralLoose(["\n  height: 23.5px;\n  font-family: 'Lehmann Egyptian';\n  font-weight: bold;\n  font-size: 16px;\n  border-bottom: 1px solid #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  letter-spacing: 2.6px;\n  text-indent: -4px;\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n"])));
var InfoBlockText = styled.div(_templateObject31 || (_templateObject31 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  padding: 11px 10px;\n  font-family: 'Noto';\n  font-size: 9px;\n  line-height: 13.2px;\n  overflow: hidden;\n  white-space: pre-line;\n"])));
var InfoLeftBlock = styled.div(_templateObject32 || (_templateObject32 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  width: 50.1%;\n  height: 100%;\n  border-right: 1px solid #000;\n"])));
var AnimalsAndCurrency = styled.div(_templateObject33 || (_templateObject33 = _taggedTemplateLiteralLoose(["\n  width: 49.5%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n"])));
var AnimalBlock$5 = styled.div(_templateObject34 || (_templateObject34 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex-direction: column;\n  height: 62%;\n  border-bottom: 2px solid #000;\n"])));
var Animals = styled.div(_templateObject35 || (_templateObject35 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Animal = styled.div(_templateObject36 || (_templateObject36 = _taggedTemplateLiteralLoose(["\n  width: 35.7px;\n  height: 35.7px;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"])));
var InfoRightBlock = styled.div(_templateObject37 || (_templateObject37 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"])));
var Currency = styled.div(_templateObject38 || (_templateObject38 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-style: italic;\n  font-family: 'Baskerville';\n  letter-spacing: 3.5px;\n  font-size: 16px;\n  line-height: 19px;\n  text-align: center;\n  padding-bottom: 1px;\n"])));
var GeographicEconomicBlock = styled.div(_templateObject39 || (_templateObject39 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  flex: 1;\n  display: flex;\n"])));
var MapCardA4$1 = function MapCardA4(_ref5) {
  var _countrySize$match, _territory$trim, _territory$trim$split;
  var num = _ref5.num,
    qrImage = _ref5.qrImage,
    qrText = _ref5.qrText,
    mapImage = _ref5.mapImage,
    mapSvg = _ref5.mapSvg,
    emblemImage = _ref5.emblemImage,
    country = _ref5.country,
    territory = _ref5.territory,
    capital = _ref5.capital,
    countrySize = _ref5.countrySize,
    climate = _ref5.climate,
    geographic = _ref5.geographic,
    currency = _ref5.currency,
    economical = _ref5.economical,
    dw = _ref5.dw,
    dh = _ref5.dh,
    services = _ref5.services,
    endpoint = _ref5.endpoint,
    externalStyles = _ref5.externalStyles,
    capitalTitle = _ref5.capitalTitle,
    territoryTitle = _ref5.territoryTitle,
    climateTitle = _ref5.climateTitle,
    geographicTitle = _ref5.geographicTitle,
    currencyTitle = _ref5.currencyTitle,
    economicalTitle = _ref5.economicalTitle,
    animalTitle = _ref5.animalTitle;
  var withCountrySize = Boolean(countrySize === null || countrySize === void 0 ? void 0 : (_countrySize$match = countrySize.match(/\d/g)) === null || _countrySize$match === void 0 ? void 0 : _countrySize$match.length);
  var _useGetTextBlockHeigh = useGetTextBlockHeight(territory),
    territoryRef = _useGetTextBlockHeigh.ref,
    territoryHeight = _useGetTextBlockHeigh.height;
  var animals = getAnimalsData({
    services: services,
    endpoint: endpoint
  });
  var withCountry = Boolean(country === null || country === void 0 ? void 0 : country.length);
  var withSmallText = territory === null || territory === void 0 ? void 0 : (_territory$trim = territory.trim()) === null || _territory$trim === void 0 ? void 0 : (_territory$trim$split = _territory$trim.split(' ')) === null || _territory$trim$split === void 0 ? void 0 : _territory$trim$split.some(function (word) {
    return (word === null || word === void 0 ? void 0 : word.length) > MAX_LENGTH_IN_LINE;
  });
  var formattedTerritory = useFormattedText(territory, withSmallText ? MAX_LENGTH_IN_SMALL_LINE : MAX_LENGTH_IN_LINE);
  var isFourLine = !withSmallText && formattedTerritory && formattedTerritory.split('').filter(function (item) {
    return item === '\n';
  }).length >= 3 && withCountry;
  return /*#__PURE__*/React$1.createElement(Card, {
    dh: dh,
    dw: dw,
    style: externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.container
  }, /*#__PURE__*/React$1.createElement(BorderContainer, null, /*#__PURE__*/React$1.createElement(ContentContainer, null, /*#__PURE__*/React$1.createElement(HeaderBlock, null, /*#__PURE__*/React$1.createElement(NumberAndGiftBlock, null, /*#__PURE__*/React$1.createElement(NumberBlock$5, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", {
    className: "num-text"
  }, num), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  }))), /*#__PURE__*/React$1.createElement(QrBlock$6, null, /*#__PURE__*/React$1.createElement(QrImageContainer, null, /*#__PURE__*/React$1.createElement(QrImage, {
    src: qrImage
  })), /*#__PURE__*/React$1.createElement(QrTextContainer, null, /*#__PURE__*/React$1.createElement(QrText, null, qrText)))), /*#__PURE__*/React$1.createElement(MapBlock$5, null, /*#__PURE__*/React$1.createElement(MapImage, {
    src: mapImage,
    alt: "Map"
  }), /*#__PURE__*/React$1.createElement(MapSvgBlock$5, null, /*#__PURE__*/React$1.createElement(MapSvgImage$5, {
    className: "map_svg_imageA3",
    dangerouslySetInnerHTML: {
      __html: mapSvg
    }
  }))), /*#__PURE__*/React$1.createElement(CountryInfoBlock, null, /*#__PURE__*/React$1.createElement(MainInfo, null, /*#__PURE__*/React$1.createElement(EmblemBlock, {
    style: externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.gerbImgContainer
  }, /*#__PURE__*/React$1.createElement(EmblemImage, {
    style: externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.gerbImg,
    src: emblemImage,
    alt: "Emblem"
  })), /*#__PURE__*/React$1.createElement(MainInfoContent, null, withCountry && /*#__PURE__*/React$1.createElement(Country, null, country), /*#__PURE__*/React$1.createElement(Territory, {
    ref: territoryRef,
    withSmallText: isFourLine || withSmallText,
    withCountry: withCountry,
    style: {
      height: territoryHeight ? territoryHeight + "px" : 'auto'
    }
  }, formattedTerritory), /*#__PURE__*/React$1.createElement(LastBlock, null, /*#__PURE__*/React$1.createElement(Capital, null, capitalTitle || 'Столица', ": ", capital), withCountrySize && /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Divider$1, null), /*#__PURE__*/React$1.createElement(AreaSize, null, territoryTitle || 'Территория', ": ", countrySize))))), /*#__PURE__*/React$1.createElement(OtherInfo, null, /*#__PURE__*/React$1.createElement(ClimateAnimalBlock, null, /*#__PURE__*/React$1.createElement(InfoLeftBlock, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader, null, climateTitle || 'Климат'), /*#__PURE__*/React$1.createElement(InfoBlockText, null, climate)), /*#__PURE__*/React$1.createElement(AnimalsAndCurrency, null, /*#__PURE__*/React$1.createElement(AnimalBlock$5, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader, null, animalTitle || 'Животный мир'), /*#__PURE__*/React$1.createElement(Animals, null, Boolean(animals === null || animals === void 0 ? void 0 : animals.length) && animals.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement(Animal, {
      key: index
    }, /*#__PURE__*/React$1.createElement("img", {
      src: item.animalImage,
      alt: ""
    }));
  })), /*#__PURE__*/React$1.createElement(InfoBlockText, {
    style: {
      paddingTop: 0,
      paddingBottom: '5px'
    }
  }, Boolean(animals === null || animals === void 0 ? void 0 : animals.length) && animals.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index
    }, item.animalName, ". ");
  }))), /*#__PURE__*/React$1.createElement(InfoRightBlock, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader, {
    style: {
      height: '25px'
    }
  }, currencyTitle || 'Используемая валюта'), /*#__PURE__*/React$1.createElement(Currency, null, currency)))), /*#__PURE__*/React$1.createElement(GeographicEconomicBlock, null, /*#__PURE__*/React$1.createElement(InfoLeftBlock, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader, null, geographicTitle || 'Географическое положение'), /*#__PURE__*/React$1.createElement(InfoBlockText, null, geographic)), /*#__PURE__*/React$1.createElement(InfoRightBlock, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader, null, economicalTitle || 'Экономический прогноз'), /*#__PURE__*/React$1.createElement(InfoBlockText, null, economical))))))));
};

var MAX_LENGTH_IN_LINE$1 = 17;
var MAX_LENGTH_IN_SMALL_LINE$1 = 22;

var _templateObject$25, _templateObject2$25, _templateObject3$1_, _templateObject4$1B, _templateObject5$1p, _templateObject6$1n, _templateObject7$1j, _templateObject8$1g, _templateObject9$1d, _templateObject10$y, _templateObject11$u, _templateObject12$r, _templateObject13$r, _templateObject14$l, _templateObject15$9, _templateObject16$2, _templateObject17$2, _templateObject18$1, _templateObject19$1, _templateObject20$1, _templateObject21$1, _templateObject22$1, _templateObject23$1, _templateObject24$1, _templateObject25$1, _templateObject26$1, _templateObject27$1, _templateObject28$1, _templateObject29$1, _templateObject30$1, _templateObject31$1, _templateObject32$1, _templateObject33$1, _templateObject34$1, _templateObject35$1, _templateObject36$1, _templateObject37$1, _templateObject38$1, _templateObject39$1, _templateObject40;
var Card$1 = styled.div(_templateObject$25 || (_templateObject$25 = _taggedTemplateLiteralLoose(["\n  height: 210mm;\n  width: 297mm;\n  transform: scale(\n    calc(", " / 297),\n    calc(", " / 210)\n  );\n  transform-origin: left top;\n  user-select: none;\n  box-sizing: border-box;\n  padding: 34.5px;\n\n  * {\n    box-sizing: border-box;\n    margin: 0;\n    padding: 0;\n  }\n"])), function (props) {
  return props.dw;
}, function (props) {
  return props.dh;
});
var BorderContainer$1 = styled.div(_templateObject2$25 || (_templateObject2$25 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 2px solid #000;\n  padding: 2px;\n"])));
var ContentContainer$1 = styled.div(_templateObject3$1_ || (_templateObject3$1_ = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n  border: 1px solid #000;\n  display: flex;\n  flex-direction: column;\n"])));
var NumberAndGiftBlock$1 = styled.div(_templateObject4$1B || (_templateObject4$1B = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var NumberBlock$6 = styled.div(_templateObject5$1p || (_templateObject5$1p = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  flex: 1;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n\n  .num-text {\n    font-family: 'Baskerville';\n    font-style: italic;\n    font-size: 22px;\n    letter-spacing: 6px;\n  }\n\n  .dash {\n    display: flex;\n    position: absolute;\n    z-index: 1;\n    border-top: 1px solid black;\n    width: 25px;\n    top: calc(50% - 0.5px);\n\n    &.left-dash {\n      left: 62px;\n      transform: translate(-100%, 0);\n    }\n\n    &.right-dash {\n      right: 62px;\n      transform: translate(100%, 0);\n    }\n  }\n"])));
var GiftBlock$1 = styled.div(_templateObject6$1n || (_templateObject6$1n = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 62%;\n  font-family: 'Oranienbaum';\n  font-size: 14px;\n  border-bottom: 1px solid #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n"])));
var QrBlock$7 = styled.div(_templateObject7$1j || (_templateObject7$1j = _taggedTemplateLiteralLoose(["\n  width: 12.6%;\n  height: 100%;\n  border-left: 2px solid #000;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n"])));
var QrImageContainer$1 = styled.div(_templateObject8$1g || (_templateObject8$1g = _taggedTemplateLiteralLoose(["\n  height: 78%;\n  display: flex;\n  align-items: flex-end;\n  justify-content: center;\n"])));
var QrImage$1 = styled.img(_templateObject9$1d || (_templateObject9$1d = _taggedTemplateLiteralLoose(["\n  width: 60%;\n"])));
var QrTextContainer$1 = styled.div(_templateObject10$y || (_templateObject10$y = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 22%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var QrText$1 = styled.span(_templateObject11$u || (_templateObject11$u = _taggedTemplateLiteralLoose(["\n  font-family: 'noto';\n  font-size: 10.5px;\n  line-height: 12px;\n  letter-spacing: 0.5px;\n"])));
var MapImage$1 = styled.img(_templateObject12$r || (_templateObject12$r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  object-fit: cover;\n"])));
var MapSvgBlock$6 = styled.div(_templateObject13$r || (_templateObject13$r = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  z-index: 10;\n  position: absolute;\n  left: 0;\n  top: 0;\n"])));
var MapSvgImage$6 = styled.div(_templateObject14$l || (_templateObject14$l = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 100%;\n"])));
var MainInfo$1 = styled.div(_templateObject15$9 || (_templateObject15$9 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  overflow: hidden;\n  width: 100%;\n  height: 59.8%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  border-bottom: 2px solid #000;\n  padding-top: 10px;\n"])));
var MainInfoContent$1 = styled.div(_templateObject16$2 || (_templateObject16$2 = _taggedTemplateLiteralLoose(["\n  position: absolute;\n  bottom: 0;\n  left: 0;\n  height: 216px;\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  justify-content: space-evenly;\n  align-items: center;\n"])));
var EmblemBlock$1 = styled.div(_templateObject17$2 || (_templateObject17$2 = _taggedTemplateLiteralLoose(["\n  height: 42%;\n  width: 100%;\n"])));
var EmblemImage$1 = styled.img(_templateObject18$1 || (_templateObject18$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  max-height: 100%;\n  object-fit: contain;\n"])));
var Country$1 = styled.div(_templateObject19$1 || (_templateObject19$1 = _taggedTemplateLiteralLoose(["\n  font-family: 'Corki-Tuscan';\n  font-size: 15px;\n  line-height: 14px;\n  padding: 0 20px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var Territory$1 = styled.div(_templateObject20$1 || (_templateObject20$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  padding: 0 27px;\n  font-family: 'Lehmann Egyptian';\n  font-weight: bold;\n  font-size: ", ";\n  line-height: ", ";\n  letter-spacing: 0.4px;\n  text-align: center;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  white-space: pre-wrap;\n  overflow-wrap: break-word;\n"])), function (_ref) {
  var withSmallText = _ref.withSmallText;
  return withSmallText ? '20.3pt' : '26.2pt';
}, function (_ref2) {
  var withSmallText = _ref2.withSmallText;
  return withSmallText ? '28px' : '36px';
});
var LastBlock$1 = styled.div(_templateObject21$1 || (_templateObject21$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: flex-start;\n  gap: 1px;\n  font-family: 'Corki-Tuscan';\n  font-size: 15px;\n  line-height: 14px;\n  letter-spacing: 0.5px;\n"])));
var Capital$1 = styled.div(_templateObject22$1 || (_templateObject22$1 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));
var Divider$2 = styled.div(_templateObject23$1 || (_templateObject23$1 = _taggedTemplateLiteralLoose(["\n  border-top: 1px solid #000;\n  width: 30px;\n"])));
var AreaSize$1 = styled.div(_templateObject24$1 || (_templateObject24$1 = _taggedTemplateLiteralLoose(["\n  text-align: center;\n"])));
var InfoBlockHeader$1 = styled.div(_templateObject25$1 || (_templateObject25$1 = _taggedTemplateLiteralLoose(["\n  height: 23.5px;\n  font-family: 'Lehmann Egyptian';\n  font-weight: bold;\n  font-size: 16px;\n  border-bottom: 1px solid #000;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  letter-spacing: 2.6px;\n  overflow: hidden;\n  white-space: nowrap;\n  word-wrap: break-word;\n"])));
var InfoBlockText$1 = styled.div(_templateObject26$1 || (_templateObject26$1 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  padding: 8.5px 8px;\n  font-family: 'Noto';\n  font-size: 8px;\n  letter-spacing: 0.3px;\n  line-height: 12.5px;\n  overflow: hidden;\n  white-space: pre-line;\n"])));
var Animals$1 = styled.div(_templateObject27$1 || (_templateObject27$1 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: center;\n"])));
var AnimalsImages = styled.div(_templateObject28$1 || (_templateObject28$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var AnimalImage = styled.div(_templateObject29$1 || (_templateObject29$1 = _taggedTemplateLiteralLoose(["\n  width: 42px;\n  height: 42px;\n  font-family: 'Noto';\n  font-size: 7px;\n  text-align: center;\n\n  img {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n"])));
var AnimalNames = styled.div(_templateObject30$1 || (_templateObject30$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: fit-content;\n  display: flex;\n  flex-wrap: wrap;\n  padding: 0 8px;\n  font-family: 'Noto';\n  font-size: 8px;\n  letter-spacing: 0.3px;\n  line-height: 12.5px;\n"])));
var Currency$1 = styled.div(_templateObject31$1 || (_templateObject31$1 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-style: italic;\n  font-family: 'Baskerville';\n  letter-spacing: 3.5px;\n  font-size: 16px;\n  text-align: center;\n  overflow: hidden;\n"])));
var TopSection = styled.div(_templateObject32$1 || (_templateObject32$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 81.8%;\n  display: flex;\n  border-bottom: 2px solid #000;\n"])));
var LeftBlock = styled.div(_templateObject33$1 || (_templateObject33$1 = _taggedTemplateLiteralLoose(["\n  width: 25.3%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  border-right: 2px solid #000;\n"])));
var ClimateBlock = styled.div(_templateObject34$1 || (_templateObject34$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 20.5%;\n  display: flex;\n  flex-direction: column;\n  border-bottom: 2px solid #000;\n"])));
var AnimalBlock$6 = styled.div(_templateObject35$1 || (_templateObject35$1 = _taggedTemplateLiteralLoose(["\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n"])));
var BottomSection = styled.div(_templateObject36$1 || (_templateObject36$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 18.2%;\n  display: flex;\n"])));
var InfoBlock$1 = styled.div(_templateObject37$1 || (_templateObject37$1 = _taggedTemplateLiteralLoose(["\n  width: 25.3%;\n  height: 100%;\n  display: flex;\n  flex-direction: column;\n  border-right: 2px solid #000;\n"])));
var CurrencyAndNumberBlock = styled.div(_templateObject38$1 || (_templateObject38$1 = _taggedTemplateLiteralLoose(["\n  flex: 1;\n  display: flex;\n  flex-direction: column;\n"])));
var CurrencyBlock = styled.div(_templateObject39$1 || (_templateObject39$1 = _taggedTemplateLiteralLoose(["\n  width: 100%;\n  height: 41%;\n  display: flex;\n  flex-direction: column;\n  border-bottom: 2px solid #000;\n"])));
var RightBlock = styled.div(_templateObject40 || (_templateObject40 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 74.7%;\n  height: 100%;\n"])));
var MapCardA4L$1 = function MapCardA4L(_ref3) {
  var _countrySize$match, _climate$slice, _territory$trim, _territory$trim$split;
  var num = _ref3.num,
    qrImage = _ref3.qrImage,
    qrText = _ref3.qrText,
    mapImage = _ref3.mapImage,
    mapSvg = _ref3.mapSvg,
    emblemImage = _ref3.emblemImage,
    country = _ref3.country,
    territory = _ref3.territory,
    capital = _ref3.capital,
    countrySize = _ref3.countrySize,
    climate = _ref3.climate,
    geographic = _ref3.geographic,
    currency = _ref3.currency,
    economical = _ref3.economical,
    dw = _ref3.dw,
    dh = _ref3.dh,
    services = _ref3.services,
    endpoint = _ref3.endpoint,
    externalStyles = _ref3.externalStyles,
    capitalTitle = _ref3.capitalTitle,
    territoryTitle = _ref3.territoryTitle,
    climateTitle = _ref3.climateTitle,
    geographicTitle = _ref3.geographicTitle,
    currencyTitle = _ref3.currencyTitle,
    economicalTitle = _ref3.economicalTitle,
    animalTitle = _ref3.animalTitle;
  var withCountrySize = Boolean(countrySize === null || countrySize === void 0 ? void 0 : (_countrySize$match = countrySize.match(/\d/g)) === null || _countrySize$match === void 0 ? void 0 : _countrySize$match.length);
  var _useGetTextBlockHeigh = useGetTextBlockHeight(territory),
    territoryRef = _useGetTextBlockHeigh.ref,
    territoryHeight = _useGetTextBlockHeigh.height;
  var animals = getAnimalsData({
    services: services,
    endpoint: endpoint
  });
  var shortClimateText = (climate === null || climate === void 0 ? void 0 : (_climate$slice = climate.slice(0, 300)) === null || _climate$slice === void 0 ? void 0 : _climate$slice.replace(/[^.!?]*$/, '')) || '';
  var withCountry = Boolean(country === null || country === void 0 ? void 0 : country.length);
  var withSmallText = territory === null || territory === void 0 ? void 0 : (_territory$trim = territory.trim()) === null || _territory$trim === void 0 ? void 0 : (_territory$trim$split = _territory$trim.split(' ')) === null || _territory$trim$split === void 0 ? void 0 : _territory$trim$split.some(function (word) {
    return (word === null || word === void 0 ? void 0 : word.length) > MAX_LENGTH_IN_LINE$1;
  });
  var formattedTerritory = useFormattedText(territory, withSmallText ? MAX_LENGTH_IN_SMALL_LINE$1 : MAX_LENGTH_IN_LINE$1);
  var isFourLine = !withSmallText && formattedTerritory && formattedTerritory.split('').filter(function (item) {
    return item === '\n';
  }).length >= 3 && withCountry;
  return /*#__PURE__*/React$1.createElement(Card$1, {
    dh: dh,
    dw: dw,
    style: externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.container
  }, /*#__PURE__*/React$1.createElement(BorderContainer$1, null, /*#__PURE__*/React$1.createElement(ContentContainer$1, null, /*#__PURE__*/React$1.createElement(TopSection, null, /*#__PURE__*/React$1.createElement(LeftBlock, null, /*#__PURE__*/React$1.createElement(MainInfo$1, null, /*#__PURE__*/React$1.createElement(EmblemBlock$1, {
    style: externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.gerbImgContainer
  }, /*#__PURE__*/React$1.createElement(EmblemImage$1, {
    style: externalStyles === null || externalStyles === void 0 ? void 0 : externalStyles.gerbImg,
    src: emblemImage,
    alt: "Emblem"
  })), /*#__PURE__*/React$1.createElement(MainInfoContent$1, null, withCountry && /*#__PURE__*/React$1.createElement(Country$1, null, country), /*#__PURE__*/React$1.createElement(Territory$1, {
    ref: territoryRef,
    withSmallText: isFourLine || withSmallText,
    withCountry: withCountry,
    style: {
      height: territoryHeight ? territoryHeight + "px" : 'auto'
    }
  }, formattedTerritory), /*#__PURE__*/React$1.createElement(LastBlock$1, {
    withCountrySize: withCountrySize
  }, /*#__PURE__*/React$1.createElement(Capital$1, null, capitalTitle || 'Столица', ": ", capital), withCountrySize && /*#__PURE__*/React$1.createElement(Fragment, null, /*#__PURE__*/React$1.createElement(Divider$2, null), /*#__PURE__*/React$1.createElement(AreaSize$1, null, territoryTitle || 'Территория', ": ", countrySize))))), /*#__PURE__*/React$1.createElement(ClimateBlock, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader$1, null, climateTitle || 'Климат'), /*#__PURE__*/React$1.createElement(InfoBlockText$1, null, shortClimateText)), /*#__PURE__*/React$1.createElement(AnimalBlock$6, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader$1, null, animalTitle || 'Животный мир'), /*#__PURE__*/React$1.createElement(Animals$1, null, /*#__PURE__*/React$1.createElement(AnimalsImages, null, Boolean(animals === null || animals === void 0 ? void 0 : animals.length) && animals.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement(AnimalImage, {
      key: index
    }, /*#__PURE__*/React$1.createElement("img", {
      src: item === null || item === void 0 ? void 0 : item.animalImage,
      alt: ""
    }));
  })), /*#__PURE__*/React$1.createElement(AnimalNames, null, Boolean(animals === null || animals === void 0 ? void 0 : animals.length) && animals.map(function (item, index) {
    return /*#__PURE__*/React$1.createElement("span", {
      key: index
    }, item.animalName, ".", "\xA0");
  }))))), /*#__PURE__*/React$1.createElement(RightBlock, null, /*#__PURE__*/React$1.createElement(MapImage$1, {
    src: mapImage,
    alt: "Map"
  }), /*#__PURE__*/React$1.createElement(MapSvgBlock$6, null, /*#__PURE__*/React$1.createElement(MapSvgImage$6, {
    className: "map_svg_imageA3",
    dangerouslySetInnerHTML: {
      __html: mapSvg
    }
  })))), /*#__PURE__*/React$1.createElement(BottomSection, null, /*#__PURE__*/React$1.createElement(InfoBlock$1, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader$1, null, geographicTitle || 'Географическое положение'), /*#__PURE__*/React$1.createElement(InfoBlockText$1, null, geographic)), /*#__PURE__*/React$1.createElement(InfoBlock$1, {
    style: {
      width: '25.6%'
    }
  }, /*#__PURE__*/React$1.createElement(InfoBlockHeader$1, null, economicalTitle || 'Экономический прогноз'), /*#__PURE__*/React$1.createElement(InfoBlockText$1, null, economical)), /*#__PURE__*/React$1.createElement(CurrencyAndNumberBlock, null, /*#__PURE__*/React$1.createElement(CurrencyBlock, null, /*#__PURE__*/React$1.createElement(InfoBlockHeader$1, null, currencyTitle || 'Используемая валюта'), /*#__PURE__*/React$1.createElement(Currency$1, null, currency)), /*#__PURE__*/React$1.createElement(NumberAndGiftBlock$1, null, /*#__PURE__*/React$1.createElement(NumberBlock$6, null, /*#__PURE__*/React$1.createElement("div", {
    className: "dash left-dash"
  }), /*#__PURE__*/React$1.createElement("span", {
    className: "num-text"
  }, num), /*#__PURE__*/React$1.createElement("div", {
    className: "dash right-dash"
  })))), /*#__PURE__*/React$1.createElement(QrBlock$7, null, /*#__PURE__*/React$1.createElement(QrImageContainer$1, null, /*#__PURE__*/React$1.createElement(QrImage$1, {
    src: qrImage
  })), /*#__PURE__*/React$1.createElement(QrTextContainer$1, null, /*#__PURE__*/React$1.createElement(QrText$1, null, qrText)))))));
};

export { Calendar, CalendarFreePreview, CalendarModern, CalendarPreview, CalendarsModernPrint, CalendarsPrint, ClassicCard3A0, ClassicCard3A1, ClassicCard3A2, ClassicCard3A3, ClassicCard3A4, ClassicCard3A5, ExampleComponent, FlowerHoroscopeCard, FlowerHoroscopeCardPrint, FlowersStyleCard, FlowersStyleCardPrint, GeograffeeCardA3, LuvrikCardA0, LuvrikCardA0L, LuvrikCardA1, LuvrikCardA1L, LuvrikCardA2, LuvrikCardA2L, LuvrikCardA3, LuvrikCardA3L, LuvrikCardA4, LuvrikCardA4L, LuvrikCardA5, LuvrikCardA5L, MapCardA2L, MapCardA3, MapCardA3L, MapCardA4, MapCardA4L, MasterCard, MasterCardPrint, MapCardA4$1 as NewMapCardA4, MapCardA4L$1 as NewMapCardA4L, PosterCard, PosterCardPrint, ServiceCard, ServiceCardPrint, ShipsStyleCard, ShipsStyleCardPrint, TimelineCardMasterTemplate, VotingCoverCardMain, WarholCard2A0, WarholCard2A0L, WarholCard2A1, WarholCard2A1L, WarholCard2A2, WarholCard2A2L, WarholCard2A3, WarholCard2A3L, WarholCard2A4, WarholCard2A4L, WarholCard2A5, WarholCard2A5L, WarholCard3A0, WarholCard3A0L, WarholCard3A1, WarholCard3A1L, WarholCard3A2, WarholCard3A2L, WarholCard3A3, WarholCard3A3L, WarholCard3A4, WarholCard3A4L, WarholCard3A5, WarholCard3A5L, WarholCard4A0L, WarholCard4A1L, WarholCard4A2L, WarholCard4A3L, WarholCard4A4L, WarholCard4A5L, WarholCardA0, WarholCardA0L, WarholCardA1, WarholCardA1L, WarholCardA2, WarholCardA2L, WarholCardA3, WarholCardA3L, WarholCardA4, WarholCardA4L, WarholCardA5, WarholCardA5L, WarholStyle2WithQrCard, WarholStyle2WithQrCardPrint };
//# sourceMappingURL=index.modern.js.map
